{
    "_documentation": "This JSON file is a database of the ethical and unethical practices of different companies. Each item in the \"companies\" object represents a company ethics record. Each of these items has a \"names\" array containing names that can be used for the company, of which the first entry is the most commonly used name. They also have a \"comment\" string which is a comment on the ethics of the company, with sources denoted by numbers in square brackets eg. [1][2]. The URLs for these sources are in the \"sources\" object which is a mapping from the source numbers to URLs. Each company also has tags in the \"tags\" array, which are strings that describe the company. Finally each company has a \"logoUrl\" and \"siteUrl\" which are URLs for the company's logo image and website. There is an \"updatedAt\" timestamp on each item to track when it was last updated. https://boikot.xyz © boikot 2023-2025",
    "companies": {
        "5": {
            "key": "5",
            "names": [
                "5"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 36,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-10-01T22:15:06.779Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/5_(British_TV_channel)",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/d/d2/Channel_5_2025.svg/120px-Channel_5_2025.svg.png",
            "siteUrl": "http://www.channel5.com/"
        },
        "barclays": {
            "names": [
                "Barclays",
                "Barclays Bank",
                "Barclays Bank plc",
                "Barclays plc",
                "Barclays Group",
                "Barclays UK",
                "Barclays International",
                "Barclay's",
                "Barclay Bank",
                "BCLYS",
                "BARC",
                "BCS"
            ],
            "comment": "Barclays is a UK-based bank which is Europe's largest funder of fracking and coal [1], having invested $85 billion into fossil fuels and $24 billion into expansion. Among other controversies, Barclays has been fined £500 million for tax avoidance by the Treasury [2], illegally manipulated the price of gold [3], attempted to manipulate the US energy market [4], and conducted workplace surveillance on its staff [5].",
            "sources": {
                "1": "https://web.archive.org/web/20231210171959/https://www.banktrack.org/article/banking_on_climate_change_fossil_fuel_finance_report_card_2019",
                "2": "https://web.archive.org/web/20231122051820/https://www.bbc.co.uk/news/business-17181213",
                "3": "https://web.archive.org/web/20140525200522/http://www.thelondonnews.net/index.php/sid/222273039/scat/3a8a80d6f705f8cc/ht/FCA-fines-Barclays-26mn-pounds-over-gold-price-manipulation",
                "4": "https://web.archive.org/web/20231031090011/https://www.theguardian.com/business/2013/jul/17/us-energy-regulator-barclays-fine",
                "5": "https://web.archive.org/web/20231202225949/https://www.theguardian.com/business/2020/feb/20/barlays-using-dytopian-big-brother-tactics-to-spy-on-staff-says-tuc"
            },
            "tags": [
                "bank",
                "unsustainable",
                "anticompetitive",
                "tax avoidance",
                "poor working conditions",
                "anticompetitive practices",
                "unsustainable practices",
                "privacy violations",
                "environmental violations",
                "fossil fuels",
                "deception"
            ],
            "score": 20,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/7/7e/Barclays_logo.svg",
            "siteUrl": "https://www.barclays.co.uk/",
            "updatedAt": "2023-12-15T22:09:30.315Z",
            "key": "barclays"
        },
        "hsbc": {
            "names": [
                "HSBC",
                "HSBC Bank",
                "HSBC Holdings",
                "Hongkong and Shanghai Banking Corporation",
                "the Hongkong and Shanghai Banking Corporation",
                "HSBC Group",
                "Hong Kong Bank",
                "HongKongBank",
                "Hong Kong Shanghai Bank",
                "HSBC Holdings plc",
                "HSBA"
            ],
            "comment": "HSBC is a British bank founded in colonial Hong Kong, which has been fined over $2 billion by various governments for providing services to money laundering groups [1][2][3], has assisted Iran and North Korea in circumventing US nuclear-weapons sanctions [4], and has been fined over $600 million for tax avoidance [5]. HSBC has made sustainability pledges such as to end financing of coal power [6][7], but has also invested billions in oil and gas and been accused of greenwashing [8].",
            "sources": {
                "1": "https://web.archive.org/web/20231127195037/https://www.reuters.com/business/hsbc-fined-85-mln-uk-anti-money-laundering-failings-2021-12-17/",
                "2": "https://web.archive.org/web/20231024090948/https://www.theguardian.com/business/2015/jun/04/hsbc-fined-278m-over-money-laundering-claims",
                "3": "https://www.independent.co.uk/news/business/news/terrorists-and-drug-lords-targeted-hsbc-bosses-admit-8483303.html",
                "4": "https://web.archive.org/web/20220331180747/https://www.bbc.co.uk/news/business-20673466",
                "5": "https://web.archive.org/web/20221221080911/https://www.reuters.com/article/us-hsbc-france-swiss-idUKKBN1DE1Z1/",
                "6": "https://web.archive.org/web/20231108184928/https://www.reuters.com/article/hsbc-hldg-climatechange/exclusive-hsbc-targets-net-zero-emissions-by-2050-earmarks-1-trln-green-financing-idINL8N2GZ31Q/",
                "7": "https://web.archive.org/web/20231117144315/https://shareaction.org/news/hsbc-sends-shockwaves-as-it-commits-to-end-coal-financing",
                "8": "https://web.archive.org/web/20231118013509/https://www.thebureauinvestigates.com/stories/2022-10-31/mines-pipelines-and-oil-rigs-what-hsbcs-sustainable-finance-really-pays-for"
            },
            "tags": [
                "bank",
                "corruption",
                "greenwashing",
                "tax avoidance",
                "unsustainable practices",
                "fossil fuels"
            ],
            "score": 35,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/aa/HSBC_logo_%282018%29.svg",
            "siteUrl": "https://www.hsbc.co.uk/",
            "updatedAt": "2023-12-15T22:09:30.315Z",
            "key": "hsbc"
        },
        "samsung": {
            "names": [
                "Samsung",
                "Samsung Group"
            ],
            "comment": "Samsung is a South Korean conglomerate which is the world's largest mobile phone and microchip manufacturer [1][2]. Samsung accounts for over 20% of South Korean exports [3] and has an outsized influence in the nation [4], and has been involved in bribery [5], anti-union activities [6], and price fixing [7].",
            "sources": {
                "1": "https://web.archive.org/web/20120428062632/http://www.isuppli.com/Mobile-and-Wireless-Communications/News/Pages/Samsung-Overtakes-Nokia-for-Cellphone-Lead.aspx",
                "2": "https://web.archive.org/web/20180525234650/https://techcrunch.com/2018/01/30/samsung-intel-worlds-largest-chipmaker/",
                "3": "https://web.archive.org/web/20110503224019/http://business.timesonline.co.uk/tol/business/industry_sectors/technology/article3764352.ece",
                "4": "https://web.archive.org/web/20130921061502/http://articles.washingtonpost.com/2012-12-09/world/35721716_1_samsung-chairman-smartphone-market-samsung-credit-card",
                "5": "https://web.archive.org/web/20170701085942/http://www.nytimes.com/2007/11/06/business/worldbusiness/06iht-samsung.1.8210181.html?pagewanted=all&_r=0",
                "6": "https://web.archive.org/web/20190627140032/http://english.hani.co.kr/arti/english_edition/e_international/899427.html",
                "7": "https://web.archive.org/web/20100707041505/http://europa.eu/rapid/pressReleasesAction.do?reference=IP/10/586"
            },
            "tags": [
                "electronics",
                "corruption",
                "anticompetitive",
                "antiunion",
                "anti-union practices",
                "anticompetitive practices"
            ],
            "score": 45,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/b4/Samsung_wordmark.svg",
            "siteUrl": "https://www.samsung.com",
            "updatedAt": "2023-12-15T22:09:30.315Z",
            "key": "samsung"
        },
        "apple": {
            "names": [
                "Apple",
                "Apple Inc.",
                "Apple Computer Company",
                "Apple Computer Inc.",
                "AAPL"
            ],
            "comment": "Apple is an American technology company credited with innovation in personal computing [1] which has a generally pro-consumer stance on privacy [2][3][4] and a proactive climate policy [5][6][7]. Apple has engaged in anti-competetive practices [8], its factories have seen abusive working conditions [9][10], and its climate claims have been called misleading [11].",
            "sources": {
                "1": "https://www.forbes.com/sites/susanadams/2013/09/27/is-apple-the-worlds-most-innovative-company-still",
                "2": "https://www.wired.com/2015/06/apples-latest-selling-point-little-knows",
                "3": "https://www.gizbot.com/mobile/news/apple-app-tracking-transparency-becomes-facebook-nightmare-only-4-percent-allow-tracking-074217.html",
                "4": "https://money.cnn.com/2016/02/22/technology/apple-privacy-icloud/index.html",
                "5": "https://9to5mac.com/2016/06/09/apple-energy-company",
                "6": "https://web.archive.org/web/20131202223855/http://www.businessweek.com/news/2013-03-21/apple-says-data-centers-now-use-100-percent-renewable-energy",
                "7": "https://www.apple.com/newsroom/2016/06/global-apps-for-earth-campaign-with-wwf-raises-more-than--8m.html",
                "8": "https://ghostarchive.org/archive/20221210/https://www.ft.com/content/e9bb4da1-867a-40ba-abc0-4a63d3421e31",
                "9": "https://www.reuters.com/article/idUSTRE6A41M920101105",
                "10": "https://www.huffpost.com/entry/foxconn-suffers-10th-deat_n_588524",
                "11": "https://www.seattletimes.com/business/report-corporate-climate-pledges-are-weaker-than-they-seem/"
            },
            "tags": [
                "tech",
                "electronics",
                "proprivacy",
                "anticompetitive",
                "greenwashing",
                "poor working conditions",
                "anticompetitive practices",
                "unsafe working conditions",
                "deception"
            ],
            "score": 55,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg",
            "siteUrl": "https://www.apple.com/",
            "updatedAt": "2023-12-15T22:09:30.315Z",
            "key": "apple"
        },
        "tesla": {
            "names": [
                "Tesla",
                "Tesla Inc.",
                "Tesla Automation",
                "Tesla Energy",
                "TSLA"
            ],
            "comment": "Tesla is an American automotive and sustainable energy company which is the world's biggest manufacturer of electric vehicles [1] and is a major installer of solar power systems [2] and battery storage [3]. Tesla has engaged in anti-union practices [4], received claims of workplace sexual harassment [5], committed environmental waste violations [6], and been accused of anticompetitive repair policies in several lawsuits [7], while its head Elon Musk has endorsed far-right political parties [8].",
            "sources": {
                "1": "https://web.archive.org/web/20210904115030/https://cleantechnica.com/2021/08/26/tesla-model-3-has-passed-1-million-sales/",
                "2": "https://web.archive.org/web/20230420155738/https://www.pv-tech.org/tesla-2022-solar-installs-inched-up-to-348mw/",
                "3": "https://web.archive.org/web/20230820094909/https://finance.yahoo.com/news/tesla-battery-backup-systems-manage-142235080.html",
                "4": "https://www.nytimes.com/2023/03/31/business/tesla-union-musk-twitter.html",
                "5": "https://www.forbes.com/sites/alanohnsman/2021/12/14/tesla-hit-by-6-more-sexual-harassment-claims/",
                "6": "https://www.thedrive.com/tech/28413/tesla-in-settlement-proceedings-over-19-air-quality-violations-as-investigation-continues",
                "7": "https://www.theregister.com/2023/03/16/dual_tesla_lawsuits_brings_musk/",
                "8": "https://www.politico.eu/article/elon-musk-endorses-germanys-far-right/"
            },
            "tags": [
                "electric vehicles",
                "cars",
                "tech",
                "ai",
                "cleanenergy",
                "antiunion",
                "anticompetitive",
                "sexual harassment",
                "poor working conditions",
                "unsustainable",
                "anti-union practices",
                "environmental violations",
                "anticompetitive practices"
            ],
            "score": 37,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/bd/Tesla_Motors.svg",
            "siteUrl": "https://tesla.com/",
            "updatedAt": "2023-12-15T22:09:30.315Z",
            "key": "tesla"
        },
        "github": {
            "names": [
                "Github",
                "Github Inc.",
                "Logical Volcano"
            ],
            "comment": "Github is an American software and version control platform owned by Microsoft which offers free services to software developers [1] and students [2][3]. A past Github CEO resigned over claims of workplace harassment [4].",
            "sources": {
                "1": "https://web.archive.org/web/20200414193839/https://github.blog/2020-04-14-github-is-now-free-for-teams/",
                "2": "https://web.archive.org/web/20210322042209/https://techcrunch.com/2014/10/07/github-partners-with-digital-ocean-unreal-engine-and-others-to-give-students-free-access-to-developer-tools/",
                "3": "https://web.archive.org/web/20190123010650/https://github.blog/2016-06-25-github-campus-experts-technology-leadership-at-your-school/",
                "4": "https://web.archive.org/web/20210322042246/https://www.wired.com/2014/04/tom-pw/"
            },
            "tags": [
                "tech",
                "ai",
                "sexual harassment"
            ],
            "score": 35,
            "ownedBy": [
                "microsoft"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/c2/GitHub_Invertocat_Logo.svg",
            "siteUrl": "https://github.com/",
            "updatedAt": "2023-12-15T22:56:44.080Z",
            "key": "github"
        },
        "microsoft": {
            "names": [
                "Microsoft",
                "MicroSoft",
                "Microsoft Corporation",
                "Microsoft Inc.",
                "Azure",
                "Bing",
                "MSFT"
            ],
            "comment": "Microsoft is an American technology company that has received recognition for sustainable practices [1], workplace gender inclusivity [2] and provided cyber security services to Ukraine [3]. Microsoft has avoided billions in tax [4] while replacing journalists with AI [5], abused its monopolistic position [6][7], participated in government surveillance of the public [8][9] and construction of a Microsoft data center destroyed a historic black cemetery [10].",
            "sources": {
                "1": "https://www.epa.gov/greenpower/green-power-leadership-awardees",
                "2": "https://web.archive.org/web/20100703003315/http://www.hrc.org/about_us/7115.htm",
                "3": "https://blogs.microsoft.com/on-the-issues/2022/06/22/defending-ukraine-early-lessons-from-the-cyber-war/",
                "4": "https://www.theguardian.com/world/2021/jun/03/microsoft-irish-subsidiary-paid-zero-corporate-tax-on-220bn-profit-last-year",
                "5": "https://www.seattletimes.com/business/local-business/microsoft-is-cutting-dozens-of-msn-news-production-workers-and-replacing-them-with-artificial-intelligence/",
                "6": "https://www.usdoj.gov/atr/cases/f2600/2613.htm",
                "7": "https://web.archive.org/web/20190831090402/https://www.reuters.com/article/microsoft-eu/eu-fines-microsoft-record-899-million-euros-idUSBRU00634320080227",
                "8": "https://www.webcitation.org/6HEwkERtq?url=http://www.washingtonpost.com/investigations/us-intelligence-mining-data-from-nine-us-internet-companies-in-broad-secret-program/2013/06/06/3a0c0da8-cebf-11e2-8845-d970ccb04497_story.html?hpid=z1",
                "9": "https://web.archive.org/web/20151119014627/http://www.theguardian.com/world/2013/jul/11/microsoft-nsa-collaboration-user-data",
                "10": "https://www.propublica.org/article/how-authorities-erased-historic-black-cemetery-virginia"
            },
            "tags": [
                "tech",
                "ai",
                "video games",
                "electronics",
                "anticompetitive",
                "antiprivacy",
                "tax avoidance",
                "anticompetitive practices",
                "privacy violations",
                "environmental violations",
                "unsustainable practices"
            ],
            "score": 35,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/96/Microsoft_logo_%282012%29.svg",
            "siteUrl": "https://www.microsoft.com/",
            "updatedAt": "2023-12-16T16:14:19.614Z",
            "key": "microsoft"
        },
        "hugging-face": {
            "names": [
                "Hugging Face",
                "Hugging Face Inc."
            ],
            "comment": "HuggingFace is a French-American software and artificial intelligence company which provides free access to machine learning models [1]. HuggingFace has campaigned for legislation to support open-source AI development [2].",
            "sources": {
                "1": "https://www.pcguide.com/ai/faq/hugging-face/",
                "2": "https://venturebeat.com/ai/hugging-face-github-and-more-unite-to-defend-open-source-in-eu-ai-legislation/"
            },
            "tags": [
                "tech",
                "ai",
                ""
            ],
            "score": 70,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/4/45/Hugging_Face_logo.svg",
            "siteUrl": "https://huggingface.co/",
            "updatedAt": "2023-12-17T12:55:21.833Z",
            "key": "hugging-face"
        },
        "youtube": {
            "names": [
                "YouTube",
                "Youtube",
                "You Tube"
            ],
            "comment": "YouTube is an American video streaming platform owned by Google, which is a leading source of free entertainment and educational content online [1][2], and has empowered independent creators to build their audience [3]. Youtube has been fined $170 million for collecting the personal information of minors [4], blocked users' content due to copyright even when fair use applies [5], applied an algorithm that propagates radical content [6][7][8] and showed videos containing violent and disturbing content to children [9].",
            "sources": {
                "1": "https://web.archive.org/web/20230614094637/http://www.forbes.com/advisor/business/social-media-statistics/",
                "2": "https://web.archive.org/web/20121105215846/http://www.forbes.com/sites/michaelnoer/2012/11/02/one-man-one-computer-10-million-students-how-khan-academy-is-reinventing-education/",
                "3": "https://web.archive.org/web/20140106071553/https://www.reuters.com/article/2007/02/26/us-youtube-idUSN2518918320070226",
                "4": "https://web.archive.org/web/20190906200850/https://www.techdirt.com/articles/20190905/17343942934/ftcs-latest-fine-youtube-over-coppa-violations-shows-that-coppa-section-230-are-collision-course.shtml",
                "5": "https://web.archive.org/web/20210422152639/https://www.theverge.com/2019/5/24/18635904/copyright-youtube-creators-dmca-takedown-fair-use-music-cover",
                "6": "https://www.wsj.com/articles/how-youtube-drives-viewers-to-the-internets-darkest-corners-1518020478",
                "7": "https://www.cjr.org/the_media_today/youtube-conspiracy-radicalization.php",
                "8": "https://web.archive.org/web/20190122035903/https://www.nytimes.com/2018/03/10/opinion/sunday/youtube-politics-radical.html",
                "9": "https://news10.com/2017/03/31/report-thousands-of-videos-mimicking-popular-cartoons-on-youtube-kids-contain-inappropriate-content/"
            },
            "tags": [
                "tech",
                "media",
                "antiprivacy",
                "privacy violations",
                "unsafe practices"
            ],
            "score": 20,
            "ownedBy": [
                "google"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/b8/YouTube_Logo_2017.svg",
            "siteUrl": "https://www.youtube.com/",
            "updatedAt": "2023-12-17T15:24:11.664Z",
            "key": "youtube"
        },
        "ford": {
            "names": [
                "Ford",
                "Ford Motor Company",
                "F"
            ],
            "comment": "Ford is an American car company that has committed environmental waste violations [1], sold unsafe vehicles [2][3] and discriminated against minorities in its financing policies [4]. Ford's philanthropic arm contributes millions annually to education and community building [5][6].",
            "sources": {
                "1": "https://www.nytimes.com/2007/07/29/business/yourmoney/29spill.html",
                "2": "https://articles.latimes.com/2013/aug/01/autos/la-fi-hy-autos-nhtsa-ford-with-fine-recall-20130801",
                "3": "https://www.nytimes.com/2014/12/19/business/ford-recall-of-takata-airbags-to-extend-nationwide.html",
                "4": "https://www.nytimes.com/2005/03/01/business/01ford.html",
                "5": "https://web.archive.org/web/20190123223816/https://www.insidephilanthropy.com/grants-for-k-12-education/ford-motor-company-fund-community-services-grants-for-k-12-e.html",
                "6": "https://web.archive.org/web/20190123224600/https://shareholder.ford.com/investors/sustainability/default.aspx"
            },
            "tags": [
                "cars",
                "discrimination",
                "unsustainable",
                "unsafe working conditions",
                "environment violations",
                "unsafe practices",
                "racial discrimination"
            ],
            "score": 45,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/3e/Ford_logo_flat.svg",
            "siteUrl": "https://www.ford.com/",
            "updatedAt": "2023-12-17T19:20:12.403Z",
            "key": "ford"
        },
        "coca-cola": {
            "names": [
                "Coca-Cola",
                "Coca Cola",
                "CocaCola",
                "Coke",
                "The Coca-Cola Company",
                "KO"
            ],
            "comment": "The Coca-Cola Company is an American beverage corporation which has been branded by Forbes as the world's most polluting brand [1], producing 200,000 plastic bottles each minute [2], while depleting water resources in areas that already suffer from drought [3]. The company has made some pledges to reduce its use of plastic [4][5].",
            "sources": {
                "1": "https://www.forbes.com/sites/trevornace/2019/10/29/coca-cola-named-the-worlds-most-polluting-brand-in-plastic-waste-audit/",
                "2": "https://www.indiatimes.com/news/india/pepsico-was-the-biggest-plastic-polluter-in-india-in-2022-coca-cola-globally-584817.html",
                "3": "https://waronwant.org/news-analysis/coca-cola-drinking-world-dry",
                "4": "https://www.bloomberg.com/news/articles/2019-11-19/coca-cola-races-ahead-in-sweden-shifting-to-recycled-plastic?leadSource=uverify%20wall#xj4y7vzkg",
                "5": "https://www.beveragedaily.com/Article/2022/02/15/Coca-Cola-s-25-reusable-packaging-goal-How-will-this-be-achieved"
            },
            "tags": [
                "beverages",
                "plastic",
                "water depletion",
                "unsustainable",
                "unsustainable practices",
                "environmental violations"
            ],
            "score": 10,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/09/The_Coca-Cola_Company_%282020%29.svg",
            "siteUrl": "https://coca-colacompany.com/",
            "updatedAt": "2023-12-17T22:18:51.032Z",
            "key": "coca-cola"
        },
        "appletiser": {
            "names": [
                "Appletiser"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "beverages"
            ],
            "score": 10,
            "ownedBy": [
                "coca-cola"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/8/8b/Appletiser.png",
            "siteUrl": "http://appletiser.com/",
            "updatedAt": "2024-02-24T11:12:32.673Z",
            "key": "appletiser"
        },
        "sprite": {
            "names": [
                "Sprite"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "beverages"
            ],
            "score": 10,
            "ownedBy": [
                "coca-cola"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/ae/Sprite_2022.svg",
            "siteUrl": "https://www.sprite.com/",
            "updatedAt": "2024-02-24T11:12:32.673Z",
            "key": "sprite"
        },
        "smartwater": {
            "names": [
                "smartwater"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "beverages"
            ],
            "score": 10,
            "ownedBy": [
                "coca-cola"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/7/7a/Glaceau_Smartwater.jpg",
            "siteUrl": "http://drinksmartwater.com/",
            "updatedAt": "2024-02-24T11:12:32.673Z",
            "key": "smartwater"
        },
        "powerade": {
            "names": [
                "Powerade"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "beverages"
            ],
            "score": 10,
            "ownedBy": [
                "coca-cola"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/Powerade_logo.png/120px-Powerade_logo.png.png",
            "siteUrl": "http://www.us.powerade.com/",
            "updatedAt": "2024-02-24T11:12:32.673Z",
            "key": "powerade"
        },
        "innocent": {
            "names": [
                "Innocent",
                "Innocent Smoothies",
                "Innocent Drinks"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "beverages"
            ],
            "score": 10,
            "ownedBy": [
                "coca-cola"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/5/53/Innocent_Drinks.png",
            "siteUrl": "https://www.innocentdrinks.co.uk/",
            "updatedAt": "2024-02-24T11:12:32.673Z",
            "key": "innocent"
        },
        "capri-sun": {
            "names": [
                "Capri-Sun"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "beverages"
            ],
            "score": 10,
            "ownedBy": [
                "coca-cola",
                "kraft-heinz"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/7/72/Capri_Sun_EMEA_logo.png",
            "siteUrl": "https://capri-sun.com/group/en/",
            "updatedAt": "2024-02-24T11:12:32.673Z",
            "key": "capri-sun"
        },
        "dasani": {
            "names": [
                "Dasani"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "beverages"
            ],
            "score": 10,
            "ownedBy": [
                "coca-cola"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/87/Dasani_Logo.svg",
            "siteUrl": "https://www.dasani.com/",
            "updatedAt": "2024-02-24T11:12:32.673Z",
            "key": "dasani"
        },
        "fuze": {
            "names": [
                "Fuze"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "beverages"
            ],
            "score": 10,
            "ownedBy": [
                "coca-cola"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/f/f0/Fuze_Beverage_logo.png",
            "siteUrl": "https://www.fuzebev.com/",
            "updatedAt": "2024-02-24T11:12:32.673Z",
            "key": "fuze"
        },
        "minute-maid": {
            "names": [
                "Minute Maid"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "beverages"
            ],
            "score": 10,
            "ownedBy": [
                "coca-cola"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/b3/Minute_Maid_2023.svg",
            "siteUrl": "http://minutemaid.com/",
            "updatedAt": "2024-02-24T11:12:32.673Z",
            "key": "minute-maid"
        },
        "oasis": {
            "names": [
                "Oasis"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "beverages"
            ],
            "score": 10,
            "ownedBy": [
                "coca-cola"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/0/04/Oasis_Drinks_logo.png",
            "siteUrl": "https://www.coca-cola.co.uk/drinks/oasis",
            "updatedAt": "2024-02-24T11:12:32.673Z",
            "key": "oasis"
        },
        "relentless": {
            "names": [
                "Relentless"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "beverages"
            ],
            "score": 10,
            "ownedBy": [
                "coca-cola"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/e/e1/Relentlesscan.png",
            "siteUrl": "http://www.relentlessenergy.com/",
            "updatedAt": "2024-02-24T11:12:32.673Z",
            "key": "relentless"
        },
        "rockstar": {
            "names": [
                "Rockstar",
                "Rockstar North",
                "Rockstar Games UK",
                "Rockstar Games"
            ],
            "comment": "Rockstar, a video game company, faced controversy over its poor working conditions and has acknowledged needing improvement while defending against allegations of deceptive practices in the Hot Coffee scandal investigation [1]. The House of Representatives voted to support a Federal Trade Commission probe into Grand Theft Auto: San Andreas amidst accusations of deceiving the Entertainment Software Ratings Board to avoid an \"Adults-Only\" rating [2].",
            "sources": {
                "1": "https://www.theguardian.com/games/2018/oct/18/rockstar-games-working-conditions-red-dead-redemption-2-rob-nelson",
                "2": "https://www.gamespot.com/articles/house-backs-federal-investigation-of-rockstar-games/1100-6129723/"
            },
            "tags": [
                "video games",
                "poor working conditions",
                "deception"
            ],
            "score": 50,
            "ownedBy": [
                "take-two"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/53/Rockstar_Games_Logo.svg",
            "siteUrl": "https://www.rockstargames.com/",
            "updatedAt": "2024-03-01T22:17:52.078Z",
            "key": "rockstar"
        },
        "pepsico": {
            "names": [
                "PepsiCo",
                "PepsiCo Inc.",
                "Pepsi",
                "PEP"
            ],
            "comment": "PepsiCo is an American food and beverage conglomerate which is one of the biggest plastic polluters worldwide [1], has contributed to water shortages in drought-affected areas [2], and been complicit in illegal rainforest destruction [3]. The company has aimed to reduce its environmental impact, achieving positive water balance in India [4].",
            "sources": {
                "1": "https://www.fastcompany.com/90425011/coca-cola-nestle-and-pepsico-are-the-worlds-biggest-plastic-polluters-again",
                "2": "https://web.archive.org/web/20070602161948/http://www.businessweek.com/globalbiz/content/may2007/gb20070531_868198.htm",
                "3": "https://www.theguardian.com/environment/2017/jul/21/pepsico-unilever-and-nestle-accused-of-complicity-in-illegal-rainforest-destruction",
                "4": "https://web.archive.org/web/20100821142748/http://www.pepsico.com/Download/PepsiCo_2009_Sustainability_Report_Overview.pdf"
            },
            "tags": [
                "beverages",
                "plastic",
                "water depletion",
                "deforestation",
                "unsustainable practices",
                "environmental violations"
            ],
            "score": 20,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/68/Pepsi_2023.svg",
            "siteUrl": "pepsico.com",
            "updatedAt": "2023-12-22T12:14:02.971Z",
            "key": "pepsico"
        },
        "nestle": {
            "names": [
                "Nestlé",
                "Nestlé S.A.",
                "Nestle"
            ],
            "comment": "Nestlé is the world's largest food and beverage company which has been named by Ukraine as an International Sponsor of War [1], sourced cocoa produced by child labour in West Africa [2][3], and questioned whether access to drinking water should be a human right [4]. The company has made some positive efforts like improving agriculture practices and building schools for the children of their farmers [5].",
            "sources": {
                "1": "https://zmina.info/en/news-en/nestle-listed-as-international-war-sponsor-by-ukraines-anti-corruption-agency/",
                "2": "https://web.archive.org/web/20081226141935/http://news.bbc.co.uk/1/hi/world/africa/1272522.stm",
                "3": "https://web.archive.org/web/20090114115945/http://news.bbc.co.uk/2/hi/africa/1311982.stm",
                "4": "https://web.archive.org/web/20170629043128/http://www.thenational.ae/arts-culture/the-human-rights-and-wrongs-of-nestl-and-water-for-all",
                "5": "https://web.archive.org/web/20160103032603/http://www.mnn.com/food/healthy-eating/stories/what-does-the-cocoa-plan-label-on-chocolate-mean"
            },
            "tags": [
                "food",
                "beverages",
                "child labour",
                "russia",
                "connections to russia"
            ],
            "score": 10,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/d8/Nestl%C3%A9.svg",
            "siteUrl": "https://nestle.com/",
            "updatedAt": "2023-12-23T00:34:27.776Z",
            "key": "nestle"
        },
        "polo": {
            "names": [
                "Polo"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "confectionary"
            ],
            "score": 10,
            "ownedBy": [
                "nestle"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/3/33/Polo_Mints_logo.png",
            "siteUrl": "https://www.nestleprofessional.co.uk/our-solutions/impulse-confectionery/our-brands/polo",
            "updatedAt": "2024-03-18T17:06:41.962Z",
            "key": "polo"
        },
        "carnation": {
            "names": [
                "Carnation"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "food"
            ],
            "score": 10,
            "ownedBy": [
                "nestle"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/2/20/Carnationlogo.png",
            "siteUrl": "http://www.nestle.com/",
            "updatedAt": "2024-03-18T17:06:36.629Z",
            "key": "carnation"
        },
        "nesquik": {
            "names": [
                "Nesquik"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "food"
            ],
            "score": 10,
            "ownedBy": [
                "nestle"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f5/Nesquik_logo_2023.svg/120px-Nesquik_logo_2023.svg.png",
            "siteUrl": "https://www.goodnes.com/nesquik/",
            "updatedAt": "2024-03-18T17:06:35.041Z",
            "key": "nesquik"
        },
        "san-pellegrino": {
            "names": [
                "San Pellegrino"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "beverages"
            ],
            "score": 10,
            "ownedBy": [
                "nestle"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/52/Sanpelegrino.svg/120px-Sanpelegrino.svg.png",
            "siteUrl": "http://www.sanpellegrino.com/",
            "updatedAt": "2024-03-18T17:06:37.166Z",
            "key": "san-pellegrino"
        },
        "nescafe": {
            "names": [
                "Nescafe"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "coffee",
                "beverages"
            ],
            "score": 10,
            "ownedBy": [
                "nestle"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Nescafe_logo_2014.png/120px-Nescafe_logo_2014.png.png",
            "siteUrl": "http://nescafe.com/",
            "updatedAt": "2024-03-18T17:06:38.475Z",
            "key": "nescafe"
        },
        "nespresso": {
            "names": [
                "Nespresso"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "coffee",
                "beverages"
            ],
            "score": 10,
            "ownedBy": [
                "nestle"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/4e/Nespresso_logo_%28monogram_%2B_wordmark%29.svg",
            "siteUrl": "https://www.nespresso.com/",
            "updatedAt": "2024-03-18T17:06:34.788Z",
            "key": "nespresso"
        },
        "perrier": {
            "names": [
                "Perrier"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "beverages"
            ],
            "score": 10,
            "ownedBy": [
                "nestle"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/7e/Perrier_logo.svg",
            "siteUrl": "http://perrier.com/",
            "updatedAt": "2024-03-18T17:06:38.213Z",
            "key": "perrier"
        },
        "princes-gate": {
            "names": [
                "Princes Gate"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "beverages"
            ],
            "score": 10,
            "ownedBy": [
                "nestle"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/6/68/Princes_Gate_Spring_Water_logo.png",
            "siteUrl": "https://nestle.com/",
            "updatedAt": "2024-03-18T17:06:35.261Z",
            "key": "princes-gate"
        },
        "curiously-cinnamon": {
            "names": [
                "Curiously Cinnamon"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "food"
            ],
            "score": 10,
            "ownedBy": [
                "nestle"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1d/Cinnamon_toastcrunch_logo.png/120px-Cinnamon_toastcrunch_logo.png.png",
            "siteUrl": "https://www.cinnamontoastcrunch.com/",
            "updatedAt": "2024-03-18T17:06:34.473Z",
            "key": "curiously-cinnamon"
        },
        "cookie-crisp": {
            "names": [
                "Cookie Crisp"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "food"
            ],
            "score": 10,
            "ownedBy": [
                "nestle",
                "general-mills"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/e/eb/Cookiecrisp_brand_logo.png",
            "siteUrl": "https://cereals.generalmills.com/products/cookie-crisp/",
            "updatedAt": "2024-03-18T17:06:36.844Z",
            "key": "cookie-crisp"
        },
        "cheerios": {
            "names": [
                "Cheerios"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "food"
            ],
            "score": 10,
            "ownedBy": [
                "nestle"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/07/Cheerios_brand_logo.svg",
            "siteUrl": "https://www.cheerios.com/",
            "updatedAt": "2024-03-18T17:06:39.319Z",
            "key": "cheerios"
        },
        "golden-nuggets": {
            "names": [
                "Golden Nuggets"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "food"
            ],
            "score": 10,
            "ownedBy": [
                "nestle"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/1/17/Goldennuggets_brand_logo.png",
            "siteUrl": "http://nestle-cereals.com/uk/brands/golden-nuggets",
            "updatedAt": "2024-03-18T17:06:39.014Z",
            "key": "golden-nuggets"
        },
        "shreddies": {
            "names": [
                "Shreddies"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "food"
            ],
            "score": 10,
            "ownedBy": [
                "nestle"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4a/Shreddies_postbrands_logo.png/120px-Shreddies_postbrands_logo.png.png",
            "siteUrl": "https://www.postconsumerbrands.ca/brand/shreddies/products/original-shreddies/",
            "updatedAt": "2024-03-18T17:06:36.179Z",
            "key": "shreddies"
        },
        "aero": {
            "names": [
                "Aero"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "confectionary"
            ],
            "score": 10,
            "ownedBy": [
                "nestle"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/b/b9/Aero_chocolate_logo.png",
            "siteUrl": "https://www.aerochocolate.co.uk/",
            "updatedAt": "2024-03-18T17:06:42.606Z",
            "key": "aero"
        },
        "caramac": {
            "names": [
                "Caramac"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "confectionary"
            ],
            "score": 10,
            "ownedBy": [
                "nestle"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/b/bc/Caramac_brand_logo.png",
            "siteUrl": "https://www.nestle.co.uk/en-gb/brands/chocolate_and_confectionery/chocolate/caramac",
            "updatedAt": "2024-03-18T17:06:37.958Z",
            "key": "caramac"
        },
        "chips-ahoy!": {
            "names": [
                "Chips Ahoy!"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "food"
            ],
            "score": 10,
            "ownedBy": [
                "nestle"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Chips_ahoy_brandlogo.png/120px-Chips_ahoy_brandlogo.png.png",
            "siteUrl": "https://www.snackworks.com/brands/chips-ahoy",
            "updatedAt": "2024-03-18T17:06:36.351Z",
            "key": "chips-ahoy!"
        },
        "milkybar": {
            "names": [
                "Milkybar"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "confectionary"
            ],
            "score": 10,
            "ownedBy": [
                "nestle"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Milkybar_logo.png/120px-Milkybar_logo.png.png",
            "siteUrl": "https://www.milkybar.co.uk/",
            "updatedAt": "2024-03-18T17:06:35.380Z",
            "key": "milkybar"
        },
        "kit-kat": {
            "names": [
                "Kit Kat"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "confectionary"
            ],
            "score": 10,
            "ownedBy": [
                "nestle"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/b/b6/Kit_kat_logo17.png",
            "siteUrl": "https://www.kitkat.com/",
            "updatedAt": "2024-03-18T17:06:40.806Z",
            "key": "kit-kat"
        },
        "munchies": {
            "names": [
                "Munchies"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "confectionary"
            ],
            "score": 10,
            "ownedBy": [
                "nestle"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a6/Munchies_brand_logo.png/120px-Munchies_brand_logo.png.png",
            "siteUrl": "https://www.nestle.co.uk/en-gb/brands/chocolate_and_confectionery/chocolate/munchies",
            "updatedAt": "2024-03-18T17:06:35.689Z",
            "key": "munchies"
        },
        "quality-street": {
            "names": [
                "Quality Street"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "confectionary"
            ],
            "score": 10,
            "ownedBy": [
                "nestle"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c9/Qualitystreet_brand_logo.png/120px-Qualitystreet_brand_logo.png.png",
            "siteUrl": "https://www.qualitystreet.co.uk/",
            "updatedAt": "2024-03-18T17:06:37.764Z",
            "key": "quality-street"
        },
        "rolo": {
            "names": [
                "Rolo"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "confectionary"
            ],
            "score": 10,
            "ownedBy": [
                "nestle"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/db/Rolo_brand_logo.png/120px-Rolo_brand_logo.png.png",
            "siteUrl": "https://www.nestle.co.uk/en-gb/brands/chocolate_and_confectionery/chocolate/rolo",
            "updatedAt": "2024-03-18T17:06:35.523Z",
            "key": "rolo"
        },
        "rowntrees": {
            "names": [
                "Rowntrees"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "confectionary"
            ],
            "score": 10,
            "ownedBy": [
                "nestle"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/a/a8/Rowntree%27s_logo.png",
            "siteUrl": "https://www.rowntrees.co.uk/",
            "updatedAt": "2024-03-18T17:06:37.562Z",
            "key": "rowntrees"
        },
        "smarties": {
            "names": [
                "Smarties"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "confectionary"
            ],
            "score": 10,
            "ownedBy": [
                "nestle"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/5/51/Nestle_smarties_logo.png",
            "siteUrl": "https://www.nestle.com/brands/allbrands/smarties",
            "updatedAt": "2024-03-18T17:06:38.736Z",
            "key": "smarties"
        },
        "sma": {
            "names": [
                "SMA"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "food"
            ],
            "score": 10,
            "ownedBy": [
                "nestle"
            ],
            "logoUrl": "https://www.smababy.co.uk/sites/default/files/site_logo.png",
            "siteUrl": "https://www.smababy.co.uk/",
            "updatedAt": "2024-03-18T17:06:44.373Z",
            "key": "sma"
        },
        "yorkie": {
            "names": [
                "Yorkie"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "confectionary"
            ],
            "score": 10,
            "ownedBy": [
                "nestle"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/a/aa/Yorkie_brand_logo.png",
            "siteUrl": "https://www.nestle.co.uk/en-gb/brands/chocolate_and_confectionery/chocolate/yorkie",
            "updatedAt": "2024-03-18T17:06:44.373Z",
            "key": "yorkie"
        },
        "haagen-dazs": {
            "names": [
                "Häagen-Dazs"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "confectionary",
                "food"
            ],
            "score": 10,
            "ownedBy": [
                "nestle",
                "general-mills"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/H%C3%A4agen-Dazs_Logo.svg/120px-H%C3%A4agen-Dazs_Logo.svg.png",
            "siteUrl": "https://www.icecream.com/us/en/brands/haagen-dazs",
            "updatedAt": "2024-03-18T17:06:39.652Z",
            "key": "haagen-dazs"
        },
        "hot-pockets": {
            "names": [
                "Hot Pockets"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "food"
            ],
            "score": 10,
            "ownedBy": [
                "nestle"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Hot_Pockets_2021_logo.png/120px-Hot_Pockets_2021_logo.png.png",
            "siteUrl": "http://www.hotpockets.com/",
            "updatedAt": "2024-03-18T17:06:37.368Z",
            "key": "hot-pockets"
        },
        "felix": {
            "names": [
                "Felix"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "pets"
            ],
            "score": 10,
            "ownedBy": [
                "nestle"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/d1/Purina_Felix_logo.png",
            "siteUrl": "https://www.purina.co.uk/cat/felix/",
            "updatedAt": "2024-03-18T17:06:40.000Z",
            "key": "felix"
        },
        "purina": {
            "names": [
                "Purina"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "pets"
            ],
            "score": 10,
            "ownedBy": [
                "nestle"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/90/Lg_checker.svg",
            "siteUrl": "http://purina.com/",
            "updatedAt": "2024-03-18T17:06:41.248Z",
            "key": "purina"
        },
        "lily's-kitchen": {
            "names": [
                "Lily's Kitchen"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "food"
            ],
            "score": 10,
            "ownedBy": [
                "nestle"
            ],
            "logoUrl": "https://www.lilyskitchen.co.uk/on/demandware.static/-/Library-Sites-lilsrp-content-global/default/dwb65fdf38/header/logo.svg",
            "siteUrl": "https://www.lilyskitchen.co.uk/",
            "updatedAt": "2024-03-18T17:06:33.810Z",
            "key": "lily's-kitchen"
        },
        "l'oreal": {
            "names": [
                "L'Oréal",
                "L'Oréal S.A.",
                "L'Oreal"
            ],
            "comment": "L'Oréal is a French cosmetics company that sells skin‑lightening creams [1], engages in anti‑competitive price‑fixing [2], and has been accused of false advertising, including airbrushing pictures of models [3][4][5]. The company has also fired a transgender model who spoke against racism [6], employed racist hiring and model selection practices [7], engaged in greenwashing [8], supplied giveaways to the Israeli military [9], and its supply chain is marred by child labour [10][11], human rights violations and environmental damage [12], while its headquarters occupy land taken from Holocaust victims [13] and the company's founder was a known Nazi [14][15].",
            "sources": {
                "1": "https://www.theguardian.com/world/2018/apr/23/skin-lightening-creams-are-dangerous-yet-business-is-booming-can-the-trade-be-stopped",
                "2": "http://www.connexionfrance.com/court-appeal-price-fixing-fine-upheld-consumer-companies-gillette-loreal-procter-gamble-sc-johnson-18567-view-article.html",
                "3": "http://www.news.com.au/entertainment/story/0,23663,21682971-36557,00.html",
                "4": "https://web.archive.org/web/20090405174025/http://www.asa.org.uk/asa/adjudications/Public/TF_ADJ_42910.htm",
                "5": "https://web.archive.org/web/20121025072002/http://edition.cnn.com/2011/WORLD/europe/07/28/airbrushed.advertisements.ban/index.html?&hpt=hp_c2",
                "6": "https://www.nytimes.com/2017/09/02/business/munroe-bergdorf-loreal-transgender.html?mcubz=1&_r=0",
                "7": "https://www.soxfirst.com/50226711/loreal_found_guilty_of_racism.php",
                "8": "https://cosmeticsbusiness.com/l-or-al-p-g-and-l-occitane-accused-of-greenwashing-in-new-findings--201904",
                "9": "http://www.palestinecampaign.org/boycott-garnier-support-israeli-army/",
                "10": "https://www.bbc.com/news/world-middle-east-68172560",
                "11": "https://theindustry.beauty/loreal-defends-its-ethical-practices-after-accusations-of-child-labour-in-supply-chain/",
                "12": "https://www.business-humanrights.org/en/latest-news/united-nations-alleges-the-second-biggest-indonesia-palm-oil-companies-on-its-egregious-human-rights-violations-and-environmental-degradation/",
                "13": "https://www.theguardian.com/world/2004/oct/13/secondworldwar.germany",
                "14": "https://www.forbes.com/2005/03/18/cz_sh_0318oreal_bill05.html",
                "15": "https://web.archive.org/web/20110604000405/http://www.time.com/time/magazine/article/0,9171,157348,00.html"
            },
            "sourceNotes": {
                "1": "sells skin-lightening creams",
                "2": "anti-competitive practices - price fixing",
                "3": "false advertising",
                "4": "false advertising",
                "5": "false advertising - airbrushing models",
                "6": "fired transgender model who made anti-racist statements",
                "7": "racist hiring practices and model selection",
                "8": "greenwashing",
                "9": "giveaways to israeli military",
                "10": "child labour in supply chain",
                "11": "child labour in supply chain",
                "12": "human rights abuses and environmental abuses in supply chain",
                "13": "situated its headquarters on land stolen from holocaust victims",
                "14": "founded by a nazi",
                "15": "founded by a nazi"
            },
            "tags": [
                "consumer goods",
                "antico‑competitive practices",
                "deception",
                "racial discrimination",
                "gender discrimination",
                "child labour",
                "greenwashing",
                "connections to israel",
                "environmental violations"
            ],
            "score": 15,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/9d/L%27Or%C3%A9al_logo.svg",
            "siteUrl": "https://www.loreal.com/",
            "updatedAt": "2024-03-18T17:06:43.352Z",
            "key": "l'oreal"
        },
        "britvic": {
            "names": [
                "Britvic",
                "Britvic plc",
                "BVIC"
            ],
            "comment": "Britvic is a British beverage company. Britvic produces thousands of tonnes of single-use plastic per year [1] but has invested in sustainable energy sources and increased recycling rates [1].",
            "sources": {
                "1": "https://www.britvic.com/media/krpdotmg/britvic-annual-report-and-accounts-2023.pdf"
            },
            "tags": [
                "beverages",
                "plastic",
                "unsustainable practices"
            ],
            "score": 50,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/f/ff/Britvic_logo.png",
            "siteUrl": "https://www.britvic.co.uk/",
            "updatedAt": "2023-12-23T09:41:38.711Z",
            "key": "britvic"
        },
        "fruit-shoot": {
            "names": [
                "Fruit Shoot",
                "Fruitshoot"
            ],
            "comment": "",
            "sources": {
                "1": "https://www.britvic.com/media/krpdotmg/britvic-annual-report-and-accounts-2023.pdf#page=5"
            },
            "tags": [
                "beverages"
            ],
            "score": 50,
            "ownedBy": [
                "britvic"
            ],
            "logoUrl": "https://fruitshoot.com/media/pshnbkx4/master-nav-logo.svg",
            "siteUrl": "https://fruitshoot.com/",
            "updatedAt": "2023-12-23T20:26:43.695Z",
            "key": "fruit-shoot"
        },
        "ballygowan": {
            "names": [
                "Ballygowan"
            ],
            "comment": "",
            "sources": {
                "1": "https://www.britvic.com/media/krpdotmg/britvic-annual-report-and-accounts-2023.pdf#page=5"
            },
            "tags": [
                "beverages"
            ],
            "score": 50,
            "ownedBy": [
                "britvic"
            ],
            "logoUrl": "https://www.ballygowan.ie/media/ttybvmzh/ballygowan_logo_all.svg",
            "siteUrl": "https://www.ballygowan.ie/",
            "updatedAt": "2023-12-23T20:26:43.695Z",
            "key": "ballygowan"
        },
        "j2o": {
            "names": [
                "J2O"
            ],
            "comment": "",
            "sources": {
                "1": "https://www.britvic.com/media/krpdotmg/britvic-annual-report-and-accounts-2023.pdf#page=5"
            },
            "tags": [
                "beverages"
            ],
            "score": 50,
            "ownedBy": [
                "britvic"
            ],
            "logoUrl": "https://www.j2o.co.uk/media/gs3hmorz/j2o_logo_2018.png",
            "siteUrl": "https://www.j2o.co.uk/",
            "updatedAt": "2023-12-23T20:26:43.695Z",
            "key": "j2o"
        },
        "r.-white's": {
            "names": [
                "R. White's",
                "R Whites"
            ],
            "comment": "",
            "sources": {
                "1": "https://www.britvic.com/media/krpdotmg/britvic-annual-report-and-accounts-2023.pdf#page=5"
            },
            "tags": [
                "beverages"
            ],
            "score": 50,
            "ownedBy": [
                "britvic"
            ],
            "logoUrl": "https://www.rwhites.co.uk/media/xn3ehtcu/logo.png",
            "siteUrl": "https://www.rwhites.co.uk/",
            "updatedAt": "2023-12-24T21:19:13.747Z",
            "key": "r.-white's"
        },
        "jimmy's-iced-coffee": {
            "names": [
                "Jimmy's Iced Coffee",
                "Jimmy's",
                "Jimmys Iced Coffee",
                "Jimmys"
            ],
            "comment": "",
            "sources": {
                "1": "https://web.archive.org/web/20231223224400/https://www.britvic.com/our-news/performance/britvic-acquires-jimmy-s-iced-coffee/"
            },
            "tags": [
                "coffee",
                "beverages"
            ],
            "score": 50,
            "ownedBy": [
                "britvic"
            ],
            "logoUrl": "https://www.jimmysicedcoffee.com/cdn/shop/files/logo-large_300x@3x.png?v=1646849230",
            "siteUrl": "https://www.jimmysicedcoffee.com/",
            "updatedAt": "2023-12-23T20:26:43.695Z",
            "key": "jimmy's-iced-coffee"
        },
        "the-london-essence-co": {
            "names": [
                "The London Essence Co",
                "The London Essence Co.",
                "London Essence"
            ],
            "comment": "",
            "sources": {
                "1": "https://web.archive.org/web/20230324214813/https://www.londonessenceco.com/en/privacy-policy/"
            },
            "tags": [
                "beverages"
            ],
            "score": 50,
            "ownedBy": [
                "britvic"
            ],
            "logoUrl": "https://www.londonessenceco.com/media/3mpllmke/londonessence_logo.svg",
            "siteUrl": "https://www.londonessenceco.com/en",
            "updatedAt": "2023-12-23T20:26:43.695Z",
            "key": "the-london-essence-co"
        },
        "teisseire": {
            "names": [
                "Teisseire"
            ],
            "comment": "",
            "sources": {
                "1": "https://www.en.teisseire.com/our-history"
            },
            "tags": [
                "beverages"
            ],
            "score": 50,
            "ownedBy": [
                "britvic"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/4/40/Teisseire_logo.png",
            "siteUrl": "https://teisseire.com/",
            "updatedAt": "2023-12-23T20:26:43.695Z",
            "key": "teisseire"
        },
        "robinsons": {
            "names": [
                "Robinsons",
                "Robinson's"
            ],
            "comment": "",
            "sources": {
                "1": "https://www.britvic.com/media/krpdotmg/britvic-annual-report-and-accounts-2023.pdf#page=5"
            },
            "tags": [
                "beverages"
            ],
            "score": 50,
            "ownedBy": [
                "britvic"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/thumb/9/96/Logo_of_Robinsons.png",
            "siteUrl": "https://www.robinsonssquash.co.uk/",
            "updatedAt": "2023-12-23T20:26:43.695Z",
            "key": "robinsons"
        },
        "aqua-libra": {
            "names": [
                "Aqua Libra",
                "AquaLibra"
            ],
            "comment": "",
            "sources": {
                "1": "https://www.britvic.com/media/krpdotmg/britvic-annual-report-and-accounts-2023.pdf#page=5"
            },
            "tags": [
                "beverages"
            ],
            "score": 50,
            "ownedBy": [
                "britvic"
            ],
            "logoUrl": "https://aqualibradrinks.com/media/ad5fob5y/logo-fan_on_white-back.png",
            "siteUrl": "https://aqualibradrinks.com/",
            "updatedAt": "2023-12-23T21:49:32.761Z",
            "key": "aqua-libra"
        },
        "tango": {
            "names": [
                "Tango"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "beverages"
            ],
            "score": 50,
            "ownedBy": [
                "britvic"
            ],
            "logoUrl": "https://tango.co.uk/media/jkkjey2n/tango_logo.png",
            "siteUrl": "https://tango.co.uk/",
            "updatedAt": "2024-01-01T20:44:53.157Z",
            "key": "tango"
        },
        "diet-coke": {
            "names": [
                "Diet Coke",
                "Coca-Cola Light"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "beverages"
            ],
            "score": 10,
            "ownedBy": [
                "coca-cola"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/3c/Diet_Coke_logo.svg",
            "siteUrl": "",
            "updatedAt": "2024-01-01T20:11:10.557Z",
            "key": "diet-coke"
        },
        "fanta": {
            "names": [
                "Fanta"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "beverages"
            ],
            "score": 10,
            "ownedBy": [
                "coca-cola"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/c2/Fanta_2023.svg",
            "siteUrl": "https://www.fanta.com/",
            "updatedAt": "2024-01-02T18:49:28.296Z",
            "key": "fanta"
        },
        "dr-pepper": {
            "names": [
                "Dr Pepper",
                "Dr. Pepper",
                "Keurig Dr Pepper",
                "KDP"
            ],
            "comment": "Dr Pepper is an American beverage company that produces hundreds of thousands of tonnes of plastic packaging per year [1] and is a major consumer of water [1]. Dr Pepper is distributed by the Coca-Cola company in the UK [2]. ",
            "sources": {
                "1": "https://www.keurigdrpepper.com/wp-content/uploads/2024/03/Keurig-Dr-Pepper-Corporate-Responsibility-Report-2022.pdf",
                "2": "https://www.coca-cola.com/gb/en/brands/dr-pepper"
            },
            "tags": [
                "beverages",
                "water depletion",
                "plastic",
                "unsustainable practices",
                "environmental violations"
            ],
            "score": 30,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/1/19/Dr_Pepper_modern.svg",
            "siteUrl": "https://drpepper.com/en",
            "updatedAt": "2024-01-01T20:19:02.959Z",
            "key": "dr-pepper"
        },
        "snapple": {
            "names": [
                "Snapple"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "beverages"
            ],
            "score": 30,
            "ownedBy": [
                "dr-pepper"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/43/Snapple_logo_%282020%29.svg",
            "siteUrl": "",
            "updatedAt": "2024-01-01T20:41:16.271Z",
            "key": "snapple"
        },
        "hellman's": {
            "names": [
                "Hellman's",
                "Best Foods"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "food"
            ],
            "score": 5,
            "ownedBy": [
                "unilever"
            ],
            "logoUrl": "https://1000logos.net/wp-content/uploads/2020/09/Hellmanns-Logo-2004-1024x585.jpg",
            "siteUrl": "https://www.hellmanns.com/",
            "updatedAt": "2024-01-27T01:40:56.316Z",
            "key": "hellman's"
        },
        "marmite": {
            "names": [
                "Marmite"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "food"
            ],
            "score": 5,
            "ownedBy": [
                "unilever"
            ],
            "logoUrl": "https://i.pinimg.com/originals/aa/05/e1/aa05e1c98241eefd076b4f996ef87482.jpg",
            "siteUrl": "https://www.marmite.co.uk/",
            "updatedAt": "2024-01-27T01:40:56.316Z",
            "key": "marmite"
        },
        "ben-and-jerry's": {
            "names": [
                "Ben & Jerry's",
                "Ben and Jerry's",
                "Ben & Jerrys",
                "Ben and Jerrys"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "confectionary"
            ],
            "score": 5,
            "ownedBy": [
                "unilever"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Ben_%26_Jerry%27s.svg/120px-Ben_%26_Jerry%27s.svg.png",
            "siteUrl": "https://www.benjerry.com/",
            "updatedAt": "2024-01-27T01:40:56.316Z",
            "key": "ben-and-jerry's"
        },
        "wall's": {
            "names": [
                "Wall's"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "confectionary"
            ],
            "score": 5,
            "ownedBy": [
                "unilever"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/23/Wall%27s_Logo.svg",
            "siteUrl": "https://www.wallsicecream.com/",
            "updatedAt": "2024-01-27T01:40:56.316Z",
            "key": "wall's"
        },
        "pot-noodle": {
            "names": [
                "Pot Noodle"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "food"
            ],
            "score": 5,
            "ownedBy": [
                "unilever"
            ],
            "logoUrl": "https://www.potnoodle.com/sk-eu/content/dam/brands/all_brand_positions/global_use/1724553-pot-noodle-logo.png.rendition.380.380.png",
            "siteUrl": "https://www.potnoodle.com/",
            "updatedAt": "2024-01-27T01:40:56.316Z",
            "key": "pot-noodle"
        },
        "cif": {
            "names": [
                "Cif"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "consumer goods"
            ],
            "score": 5,
            "ownedBy": [
                "unilever"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/9/91/Cif_logo.png",
            "siteUrl": "https://www.cifclean.co.uk/",
            "updatedAt": "2024-01-27T01:40:56.316Z",
            "key": "cif"
        },
        "persil": {
            "names": [
                "Persil"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "consumer goods"
            ],
            "score": 5,
            "ownedBy": [
                "unilever"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/07/Persil-Logo.svg",
            "siteUrl": "https://www.persil.com/",
            "updatedAt": "2024-01-27T01:40:56.316Z",
            "key": "persil"
        },
        "surf": {
            "names": [
                "Surf"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "consumer goods"
            ],
            "score": 5,
            "ownedBy": [
                "unilever"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/3/36/Surf-logo.png",
            "siteUrl": "https://www.unilever.co.uk/brands/home-care/surf/",
            "updatedAt": "2024-01-27T01:40:56.316Z",
            "key": "surf"
        },
        "lynx": {
            "names": [
                "LYNX",
                "AXE"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "consumer goods"
            ],
            "score": 5,
            "ownedBy": [
                "unilever"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/0b/Lynx_logo_2021.svg",
            "siteUrl": "https://www.axe.com/",
            "updatedAt": "2024-01-27T01:40:56.316Z",
            "key": "lynx"
        },
        "radox": {
            "names": [
                "Radox"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "consumer goods"
            ],
            "score": 5,
            "ownedBy": [
                "unilever"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/1/1f/Radox_logo.png",
            "siteUrl": "https://radox.co.uk/",
            "updatedAt": "2024-01-27T01:40:56.316Z",
            "key": "radox"
        },
        "dove": {
            "names": [
                "Dove"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "consumer goods"
            ],
            "score": 5,
            "ownedBy": [
                "unilever"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4b/Dove_logo.png/120px-Dove_logo.png.png",
            "siteUrl": "https://dove.com/",
            "updatedAt": "2024-01-27T01:40:56.316Z",
            "key": "dove"
        },
        "toni-and-guy": {
            "names": [
                "Toni & Guy",
                "Toni and Guy"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "consumer goods"
            ],
            "score": 5,
            "ownedBy": [
                "unilever"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/8/83/Toni_and_Guy_logo.png",
            "siteUrl": "Toni & Guy",
            "updatedAt": "2024-01-27T12:29:37.086Z",
            "key": "toni-and-guy"
        },
        "tresemme": {
            "names": [
                "TRESemmé",
                "TRESemme"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "consumer goods"
            ],
            "score": 5,
            "ownedBy": [
                "unilever"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/Tresemme_new_logo.png/120px-Tresemme_new_logo.png.png",
            "siteUrl": "https://www.tresemme.com/",
            "updatedAt": "2024-01-27T12:29:37.086Z",
            "key": "tresemme"
        },
        "glow-and-lovely": {
            "names": [
                "Glow & Lovely",
                "Glow and Lovely",
                "Fair & Lovely",
                "Fair and Lovely"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "consumer goods"
            ],
            "score": 5,
            "ownedBy": [
                "unilever"
            ],
            "logoUrl": "https://www.hul.co.in/content-images/8fedf5de81dce8eb469cda95ef2cc960e6bbc5ce-1080x1080.jpg",
            "siteUrl": "https://www.hul.co.in/brands/beauty-wellbeing/glow-lovely/",
            "updatedAt": "2024-01-27T01:40:56.316Z",
            "key": "glow-and-lovely"
        },
        "calippo": {
            "names": [
                "Calippo"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "confectionary"
            ],
            "score": 5,
            "ownedBy": [
                "unilever"
            ],
            "logoUrl": "https://img4.wikia.nocookie.net/__cb20091229190706/logopedia/images/e/ed/Calippo_logo.png",
            "siteUrl": "",
            "updatedAt": "2024-01-27T01:40:56.316Z",
            "key": "calippo"
        },
        "klondike": {
            "names": [
                "Klondike"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "confectionary"
            ],
            "score": 5,
            "ownedBy": [
                "unilever"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/d5/Klondike_logo.svg",
            "siteUrl": "https://klondikebar.com/",
            "updatedAt": "2024-01-27T01:40:56.316Z",
            "key": "klondike"
        },
        "magnum": {
            "names": [
                "Magnum"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "confectionary"
            ],
            "score": 5,
            "ownedBy": [
                "unilever"
            ],
            "logoUrl": "https://assets.unileversolutions.com/v1/85851330.png?im=AspectCrop=(400,140);Resize=(400,140)",
            "siteUrl": "https://www.magnumicecream.com/",
            "updatedAt": "2024-01-27T01:40:56.316Z",
            "key": "magnum"
        },
        "red-bull": {
            "names": [
                "Red Bull",
                "Red Bull GmbH"
            ],
            "comment": "Red Bull is an Austrian energy drink brand, which can be harmful if consumed in excess [1][2]. Red Bull has created opportunities and platforms for artists and creatives [3][4], and has supported sustainability initiatives despite being a major sponsor of Formula 1 [5].",
            "sources": {
                "1": "https://doi.org/10.7759%2Fcureus.1322",
                "2": "https://www.frontiersin.org/articles/10.3389/fpubh.2014.00134/full",
                "3": "https://www.forbes.com/sites/afdhelaziz/2019/05/01/the-power-of-purpose-how-red-bull-is-giving-social-entrepreneurs-wings/",
                "4": "https://web.archive.org/web/20210920212838/https://www.metrotimes.com/detroit/red-bull-house-of-art/Content?oid=2145533",
                "5": "https://www.redbullracing.com/int-en/tackling-global-sustainability-with-global-standard"
            },
            "tags": [
                "beverages",
                "unsafe practices"
            ],
            "score": 50,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/f/f5/RedBullEnergyDrink.svg",
            "siteUrl": "https://www.redbull.com/int-en/energydrink/red-bull-energy-drink",
            "updatedAt": "2024-01-01T20:44:59.786Z",
            "key": "red-bull"
        },
        "lipton": {
            "names": [
                "Lipton",
                "Lipton Ice Tea",
                "Pepsi Lipton International"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "beverages"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico",
                "unilever"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/thumb/f/fc/LIPTON_PRIMARY_RGB_BMT.png",
            "siteUrl": "https://www.lipton.com/us/en/",
            "updatedAt": "2024-01-02T19:08:02.820Z",
            "key": "lipton"
        },
        "tfl": {
            "names": [
                "TfL",
                "Transport for London"
            ],
            "comment": "Transport for London is London's public transport provider, which offers low-emissions transportation within greater london. TfL illegally accessed EU citizen's personal data to issue fruadulent ULEZ fines [1] and continues to pay hundreds of executives 6-figure salaries while proposing to close bus routes to save money [2].",
            "sources": {
                "1": "https://www.theguardian.com/uk-news/2024/jan/26/eu-citizens-ulez-fines-data-breach-tfl",
                "2": "https://www.standard.co.uk/news/london/tfl-executive-pay-government-bailout-tube-strike-sadiq-khan-b1009359.html"
            },
            "tags": [
                "transport",
                "public transport",
                "unfair pay",
                "deception",
                "privacy violations",
                "data breach"
            ],
            "score": 65,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/3e/TfL_roundel_%28no_text%29.svg",
            "siteUrl": "https://tfl.gov.uk/",
            "updatedAt": "2024-02-10T08:09:59.878Z",
            "key": "tfl"
        },
        "etsy": {
            "names": [
                "Etsy",
                "Etsy, Inc.",
                "ETSY"
            ],
            "comment": "Etsy is an American ecommerce website that has lost its B Corp status [1] and faced backlash from its sellers over fees [2] and witholding of funds [3]. Etsy carbon-offsets deliveries [4] and provides a plaform to small independent businesses [5].",
            "sources": {
                "1": "https://www.ecommercebytes.com/2017/11/30/etsy-gives-b-corp-status-maintain-corporate-structure/",
                "2": "https://www.bbc.co.uk/news/business-63984098",
                "3": "https://www.bbc.co.uk/news/business-66201042",
                "4": "https://www.etsy.com/uk/blog/etsy-launches-carbon-offset-shipping",
                "5": "https://retail-insider.com/retail-insider/2021/05/etsy-provides-small-businesses-with-a-booming-e-commerce-platform-but-who-reaps-the-benefits/"
            },
            "tags": [
                "ecommerce",
                "retail",
                ""
            ],
            "score": 70,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/89/Etsy_logo.svg",
            "siteUrl": "https://www.etsy.com/",
            "updatedAt": "2024-02-08T08:23:34.904Z",
            "key": "etsy"
        },
        "irn-bru": {
            "names": [
                "Irn-Bru",
                "IrnBru",
                "Irn Bru",
                "Iron Brew",
                "IRN-BRU",
                "IRN BRU"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "beverages"
            ],
            "score": 49,
            "ownedBy": [
                "a.g.-barr"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/9/9d/Irn-Bru_logo.png",
            "siteUrl": "https://irn-bru.co.uk/",
            "updatedAt": "2024-01-02T19:17:01.423Z",
            "key": "irn-bru"
        },
        "mcdonald's": {
            "names": [
                "McDonald's",
                "McDonald's Corporation",
                "MCD"
            ],
            "comment": "McDonald's is the world's largest fast food brand, which produces more emissions than Norway [1] and is the leading producer of litter in the UK [2], whose restaurants have hosted sexual abuse [3][4], illegal employment of children [5], and racist discrimination [6]. McDonald's has avoided hundreds of millions in taxes [7], failed to meet its own pledges to reduce animal abuse in its supply chain [8], and offered free meals to the IDF as it commited war crimes in Gaza [9].",
            "sources": {
                "1": "https://www.bloomberg.com/news/articles/2021-12-01/the-carbon-footprint-of-mcdonald-s-menu-very-big",
                "2": "https://ghostarchive.org/archive/20220110/https://www.telegraph.co.uk/news/earth/earthnews/4223106/McDonalds-waste-makes-up-largest-proportion-of-fast-food-litter-on-streets.html",
                "3": "https://www.bbc.co.uk/news/business-65388445",
                "4": "https://news.sky.com/story/mcdonalds-sacks-18-workers-after-sexual-abuse-racism-and-bullying-claims-13008183",
                "5": "https://web.archive.org/web/20070418214623/https://www.abc.net.au/news/newsitems/200704/s1895071.htm",
                "6": "https://www.france24.com/en/20200414-mcdonald-s-apologises-after-china-store-bans-black-people",
                "7": "https://www.reuters.com/article/us-france-mcdonalds-tax-idUSKCN0XG2QS",
                "8": "https://plantbasednews.org/culture/ethics/mcdonalds-animal-welfare-commitments/",
                "9": "https://www.samaa.tv/208732607-mcdonald-s-faces-backlash-for-donating-free-meals-to-israeli-forces-amid-ongoing-conflict#tbl-em-lnp5au1hyagx03rjii"
            },
            "tags": [
                "fast food",
                "unsustainable",
                "sexual harassment",
                "child labour",
                "discrimination",
                "tax avoidance",
                "animal abuse",
                "proisrael",
                "racial discrimination",
                "unsustainable practices",
                "environmental violations",
                "connections to israel",
                "fossil fuels"
            ],
            "score": 5,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/36/McDonald%27s_Golden_Arches.svg",
            "siteUrl": "https://www.mcdonalds.com/us/en-us.html",
            "updatedAt": "2024-04-06T19:32:02.312Z",
            "key": "mcdonald's"
        },
        "pret-a-manger": {
            "names": [
                "Pret a Manger",
                "Pret"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "restaurant",
                "coffee",
                "poor working conditions",
                "unsafe working conditions"
            ],
            "score": 35,
            "ownedBy": [
                "jab-holding-company"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/5/5d/PretLogo.svg",
            "siteUrl": "http://www.pret.co.uk/",
            "updatedAt": "2024-04-13T19:35:21.166Z",
            "key": "pret-a-manger"
        },
        "jde-peet's": {
            "names": [
                "JDE Peet's",
                "JDE Peet's N.V.",
                "Jacobs Douwe Egberts",
                "JDEP"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "coffee",
                "russia"
            ],
            "score": 35,
            "ownedBy": [
                "jab-holding-company"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/21/JDE_Peet%27s_box_logo.svg/120px-JDE_Peet%27s_box_logo.svg.png",
            "siteUrl": "https://www.jdepeets.com/",
            "updatedAt": "2024-04-13T19:35:21.166Z",
            "key": "jde-peet's"
        },
        "tassimo": {
            "names": [
                "Tassimo"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "coffee"
            ],
            "score": 35,
            "ownedBy": [
                "jab-holding-company"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/8d/Tassimo_logo.svg",
            "siteUrl": "https://www.tassimo.com/",
            "updatedAt": "2024-04-13T20:12:12.650Z",
            "key": "tassimo"
        },
        "kenco": {
            "names": [
                "Kenco"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "coffee"
            ],
            "score": 35,
            "ownedBy": [
                "jab-holding-company"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/Kenco_logo.webp/120px-Kenco_logo.webp.png",
            "siteUrl": "https://www.kenco.co.uk/",
            "updatedAt": "2024-04-13T20:12:12.650Z",
            "key": "kenco"
        },
        "subway": {
            "names": [
                "Subway",
                "Subway IP LLC"
            ],
            "comment": "Subway, a fast-food chain, has been found to have underpaid workers at several franchises across Australia, resulting in over $81,000 in unpaid wages for 167 current and former employees [1]. Subway has also been listed as an International Sponsor of War by Ukraine for continuing operations in Russia [2].",
            "sources": {
                "1": "https://web.archive.org/web/20191224111400/https://www.abc.net.au/news/2019-10-01/subway-employees-recover-unpaid-wages/11563342",
                "2": "https://nazk.gov.ua/uk/novyny/fastfud-yakyy-diysno-vbyvae-nazk-vneslo-subway-do-pereliku-mizhnarodnyh-sponsoriv-viyny/"
            },
            "tags": [
                "fast food",
                "poor working conditions",
                "russia",
                "unfair pay",
                "connections to russia"
            ],
            "score": 25,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/5c/Subway_2016_logo.svg",
            "siteUrl": "https://www.subway.com/",
            "updatedAt": "2024-04-06T20:09:26.447Z",
            "key": "subway"
        },
        "nationwide": {
            "names": [
                "Nationwide",
                "Nationwide Building Society"
            ],
            "comment": "Nationwide is a British building society owned by its members [1], who voted to contribute 1% of profits to charity [4]. Nationwide does not invest in fossil fuels [2], although hundreds of its employees have faced redundancy [3].",
            "sources": {
                "1": "https://www.nationwide.co.uk/-/assets/nationwidecouk/documents/current-accounts/resources/p4055-current-account-important-information.pdf?rev=5035ecd6acdb468aa67fe5b7e473bbe5#:~:text=Nationwide%20Building%20Society%20is%20a,member%20of%20Nationwide%20Building%20Society",
                "2": "https://www.nationwide.co.uk/about-us/responsible-business/reducing-environmental-harm/",
                "3": "https://www.bbc.co.uk/news/uk-england-wiltshire-64567941",
                "4": "https://www.nationwide.co.uk/about-us/building-a-better-society/"
            },
            "tags": [
                "bank",
                "building society",
                "none"
            ],
            "score": 80,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/2/2f/Nationwide_Building_Society_logo_2023.svg",
            "siteUrl": "https://www.nationwide.co.uk/",
            "updatedAt": "2024-01-08T15:23:39.205Z",
            "key": "nationwide"
        },
        "natwest": {
            "names": [
                "NatWest",
                "Natwest",
                "National Westminster Bank",
                "NatWest Holdings Limited",
                "NatWest Holdings",
                "NatWest Group",
                "NatWest Group plc"
            ],
            "comment": "NatWest is a British bank that has invested $2.03 billion in six companies that manufacture nuclear weapons [1] and billions more in fossil fuels [2], has been fined for anti-money laundering failures [3], and executives have expressed indifference to the cost of living crisis [4]. NatWest's energy investments comprise 85% sustainable energy [5] and the bank is halting financing for oil and gas ventures in 2026 [6].",
            "sources": {
                "1": "https://www.thenational.scot/news/19257311.revealed-billions-invested-big-business-nuclear-arms/",
                "2": "https://www.theguardian.com/global/2023/feb/09/natwest-to-end-new-business-loans-for-oil-and-gas-extraction",
                "3": "https://www.fca.org.uk/news/press-releases/natwest-fined-264.8million-anti-money-laundering-failures",
                "4": "https://www.dailymail.co.uk/news/article-12930165/NatWest-Howard-Davies-banker-difficult-house-homes-property-ladder.html",
                "5": "https://bank.green/banks/natwest",
                "6": "https://www.theguardian.com/global/2023/feb/09/natwest-to-end-new-business-loans-for-oil-and-gas-extraction"
            },
            "tags": [
                "bank",
                "unsustainable",
                "fossil fuels",
                "unsustainable practices"
            ],
            "score": 35,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/de/Natwest_logo.svg",
            "siteUrl": "https://www.natwest.com/",
            "updatedAt": "2024-01-08T15:23:39.205Z",
            "key": "natwest"
        },
        "netflix": {
            "names": [
                "Netflix",
                "Netflix, Inc.",
                "NFLX"
            ],
            "comment": "Netflix is an American tech and entertainment company. Netflix has been accused of illegally retaining and using consumer data [1].",
            "sources": {
                "1": "https://www.bizjournals.com/sanjose/news/2013/03/25/netflix-settles-9-million-privacy.html"
            },
            "tags": [
                "tech",
                "entertainment",
                "antiprivacy",
                "privacy violations"
            ],
            "score": 50,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/08/Netflix_2015_logo.svg",
            "siteUrl": "https://www.netflix.com/",
            "updatedAt": "2024-01-08T15:23:39.205Z",
            "key": "netflix"
        },
        "meta": {
            "names": [
                "Meta",
                "Facebook",
                "Meta Platforms, Inc.",
                "TheFacebook, Inc.",
                "META"
            ],
            "comment": "Meta is an American tech company that has fought aginst privacy legistion [1][2], shared user data without consent which was used to sway elections [3], designed software to addict children [4][5] and polarise users in idealogical echo chambers [6][7], avoided billions in tax [8][9] and conducted mass suveillance on the public [10].",
            "sources": {
                "1": "https://web.archive.org/web/20190302143109/https://www.theguardian.com/technology/2019/mar/02/facebook-global-lobbying-campaign-against-data-privacy-laws-investment",
                "2": "https://www.politico.eu/article/inside-story-facebook-fight-against-european-regulation",
                "3": "https://web.archive.org/web/20210129123154/https://www.businessinsider.com/cambridge-analytica-whistleblower-christopher-wylie-facebook-data-2019-10",
                "4": "https://web.archive.org/web/20231127192915/https://www.theguardian.com/technology/2023/nov/27/meta-instagram-facebook-kids-addicted-lawsuit",
                "5": "https://web.archive.org/web/20230629034801/https://www.theguardian.com/technology/2021/oct/05/facebook-harms-children-damaging-democracy-claims-whistleblower",
                "6": "https://doi.org/10.1111%2Fnpqu.11519",
                "7": "https://doi.org/10.1111%2Fnpqu.11519",
                "8": "https://www.theguardian.com/technology/2012/dec/23/facebook-tax-profits-outside-us",
                "9": "https://www.bbc.co.uk/news/business-34504474",
                "10": "https://www.theguardian.com/world/2013/jun/06/us-tech-giants-nsa-data"
            },
            "tags": [
                "tech",
                "social media",
                "antiprivacy",
                "tax avoidance",
                "privacy violations",
                "data breach",
                "deception"
            ],
            "score": 10,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/7b/Meta_Platforms_Inc._logo.svg",
            "siteUrl": "https://about.meta.com/",
            "updatedAt": "2024-01-07T20:47:32.197Z",
            "key": "meta"
        },
        "fairy": {
            "names": [
                "Fairy"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "consumer goods"
            ],
            "score": 35,
            "ownedBy": [
                "procter-and-gamble"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/5/59/Fairy_logo.png",
            "siteUrl": "https://www.supersavvyme.co.uk/brands/fairy",
            "updatedAt": "2024-01-31T19:01:06.524Z",
            "key": "fairy"
        },
        "old-spice": {
            "names": [
                "Old Spice"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "consumer goods"
            ],
            "score": 35,
            "ownedBy": [
                "procter-and-gamble"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/9/94/Current_Old_Spice_Logo_2016.svg",
            "siteUrl": "https://oldspice.com/",
            "updatedAt": "2024-01-31T19:01:06.524Z",
            "key": "old-spice"
        },
        "ariel": {
            "names": [
                "Ariel"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "consumer goods"
            ],
            "score": 35,
            "ownedBy": [
                "procter-and-gamble"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/3/37/Ariel_Logo.png",
            "siteUrl": "https://www.ariel.co.uk/",
            "updatedAt": "2024-01-31T19:01:06.524Z",
            "key": "ariel"
        },
        "herbal-essences": {
            "names": [
                "Herbal Essences"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "consumer goods"
            ],
            "score": 35,
            "ownedBy": [
                "procter-and-gamble"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/1/14/Herbal_Essences_Hair_Care.png",
            "siteUrl": "https://herbalessences.com/",
            "updatedAt": "2024-01-31T19:01:06.524Z",
            "key": "herbal-essences"
        },
        "braun": {
            "names": [
                "Braun",
                "Braun GmbH"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "consumer goods"
            ],
            "score": 35,
            "ownedBy": [
                "procter-and-gamble"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/16/Braun_Logo.svg",
            "siteUrl": "https://www.braun.com/",
            "updatedAt": "2024-01-31T19:01:06.524Z",
            "key": "braun"
        },
        "aussie": {
            "names": [
                "Aussie"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "consumer goods"
            ],
            "score": 35,
            "ownedBy": [
                "procter-and-gamble"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/4/48/Aussie_logo.png",
            "siteUrl": "https://www.aussie.com/",
            "updatedAt": "2024-01-31T19:01:06.524Z",
            "key": "aussie"
        },
        "vicks": {
            "names": [
                "Vicks"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "consumer goods"
            ],
            "score": 35,
            "ownedBy": [
                "procter-and-gamble"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/VicksLogo.png/120px-VicksLogo.png.png",
            "siteUrl": "https://vicks.com/",
            "updatedAt": "2024-01-31T19:01:06.524Z",
            "key": "vicks"
        },
        "tide": {
            "names": [
                "Tide"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "consumer goods"
            ],
            "score": 35,
            "ownedBy": [
                "procter-and-gamble"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1e/Tide_Logo_RGB_2014.png/120px-Tide_Logo_RGB_2014.png.png",
            "siteUrl": "https://www.tide.com/",
            "updatedAt": "2024-01-31T19:01:06.524Z",
            "key": "tide"
        },
        "pantene": {
            "names": [
                "Pantene"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "consumer goods"
            ],
            "score": 35,
            "ownedBy": [
                "procter-and-gamble"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/19/Pantene_Header_logo.png",
            "siteUrl": "",
            "updatedAt": "2024-01-31T19:01:06.524Z",
            "key": "pantene"
        },
        "pampers": {
            "names": [
                "Pampers"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "consumer goods"
            ],
            "score": 35,
            "ownedBy": [
                "procter-and-gamble"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/1/17/Pampers_logo.svg",
            "siteUrl": "https://www.pampers.com/",
            "updatedAt": "2024-01-31T19:01:06.524Z",
            "key": "pampers"
        },
        "oral-b": {
            "names": [
                "Oral-B"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "consumer goods"
            ],
            "score": 35,
            "ownedBy": [
                "procter-and-gamble"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Oral-B_logo.svg/120px-Oral-B_logo.svg.png",
            "siteUrl": "https://oralb.com/",
            "updatedAt": "2024-01-31T19:01:06.524Z",
            "key": "oral-b"
        },
        "olay": {
            "names": [
                "Olay"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "consumer goods"
            ],
            "score": 35,
            "ownedBy": [
                "procter-and-gamble"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/57/Olay.png/120px-Olay.png.png",
            "siteUrl": "https://www.olay.com/",
            "updatedAt": "2024-01-31T19:01:06.524Z",
            "key": "olay"
        },
        "head-and-shoulders": {
            "names": [
                "Head & Shoulders",
                "Head and Shoulders"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "consumer goods"
            ],
            "score": 35,
            "ownedBy": [
                "procter-and-gamble"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/74/Head%26shoulders-Logo.svg",
            "siteUrl": "https://www.headandshoulders.com/",
            "updatedAt": "2024-01-31T19:01:06.524Z",
            "key": "head-and-shoulders"
        },
        "gillette": {
            "names": [
                "Gillette",
                "The Gillette Company"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "consumer goods"
            ],
            "score": 35,
            "ownedBy": [
                "procter-and-gamble"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/f/fa/Gillette.svg",
            "siteUrl": "https://gillette.com/",
            "updatedAt": "2024-01-31T19:01:06.524Z",
            "key": "gillette"
        },
        "febreeze": {
            "names": [
                "Febreeze"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "consumer goods"
            ],
            "score": 35,
            "ownedBy": [
                "procter-and-gamble"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/72/Febreze_Logo.svg/120px-Febreze_Logo.svg.png",
            "siteUrl": "https://www.febreze.com/",
            "updatedAt": "2024-01-31T19:01:06.524Z",
            "key": "febreeze"
        },
        "monster-energy": {
            "names": [
                "Monster Energy",
                "Monster Beverage",
                "Monster Beverage Corporation",
                "MNST",
                "Monster"
            ],
            "comment": "Monster Energy is an American energy drinks manufacturer that has been accused of cultivating an abusive and discriminatory work environment, involving allegations of sexual harassment, bullying, and retaliation [1][2]. Their drinks may pose health risks, potentially masking alcohol’s effects and contributing to cardiac and psychiatric issues [3][4][5].",
            "sources": {
                "1": "https://www.huffpost.com/entry/monster-energy-lawsuits_n_5a6280c1e4b002283002ca27",
                "2": "https://www.huffpost.com/entry/monster-energy-brent-hamilton-out_n_5cd9c3a9e4b0615b08178297",
                "3": "https://www.racgp.org.au/download/documents/AFP/2011/March/201103pennay.pdf",
                "4": "https://doi.org/10.1016%2Fj.cjca.2014.12.019",
                "5": "https://doi.org/10.1016%2Fj.lpm.2014.07.029"
            },
            "tags": [
                "beverages",
                "poor working conditions",
                "sexual harassment",
                "gender discrimination"
            ],
            "score": 35,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/e/e2/Monster_Beverage_logo.png",
            "siteUrl": "https://www.monsterenergy.com/en-gb/",
            "updatedAt": "2024-01-03T19:32:45.718Z",
            "key": "monster-energy"
        },
        "lego": {
            "names": [
                "LEGO",
                "The LEGO Group",
                "Lego"
            ],
            "comment": "The LEGO Group is a Danish toy manufacturer which is a major producer of plastic derived from crude oil [1], and has created Shell-branded [2] and gender-stereotypical [3] toys. LEGO has since produced items that promote gender equality [4] and LGBT+ rights [5], while being recognised as a beneficial toy for children's development [6][7].",
            "sources": {
                "1": "https://www.wired.co.uk/article/lego-haunted-by-its-own-plastic",
                "2": "https://www.theguardian.com/commentisfree/2014/aug/08/lego-child-play-big-business-marketing-toys-shell",
                "3": "https://web.archive.org/web/20150925050912/http://www.independent.co.uk/life-style/health-and-families/lego-told-off-by-7yearold-girl-for-promoting-gender-stereotypes-9104571.html",
                "4": "https://web.archive.org/web/20141127130849/http://www.bbc.co.uk/news/magazine-28660069",
                "5": "https://web.archive.org/web/20210722043242/https://www.lego.com/en-au/page/why-i-designed-everyone-is-awesome?icmp=LP-SHCC-Standard-Project_Rainbow_CC_Block_1-PR-MT-QAXDTRW46D",
                "6": "https://www.verywellhealth.com/lego-therapy-for-children-with-autism-4169865",
                "7": "https://www.theguardian.com/commentisfree/2022/apr/20/why-building-playtime-is-crucial-soothing"
            },
            "tags": [
                "toys",
                "plastic",
                "unsustainable",
                "fossil fuels",
                "gender discrimination",
                "unsustainable practices",
                "environmental violations"
            ],
            "score": 60,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/24/LEGO_logo.svg",
            "siteUrl": "https://www.lego.com/",
            "updatedAt": "2024-01-06T14:46:15.790Z",
            "key": "lego"
        },
        "co-op": {
            "names": [
                "Co-op",
                "Co-op Food",
                "The Co-operative Group",
                "Co-operative Wholesale Society"
            ],
            "comment": "Co-op is a British supermarket and consumer co-operative which has championed the introduction of fairtrade [1], pushed for climate justice [2][3][4], innovated in accessible food labelling for disabled people [5], and invested millions of pounds of its profits back into the communities it serves [6]. Co-op boycotted exports from Israei settlements in Palestine since 2012 [7] and has a celebrated stance on avoiding pesticides [8], sustainable sourcing of palm oil [9], and animal welfare [6].",
            "sources": {
                "1": "http://web.archive.org/web/20190708142737/http://www.fairtrade.org.uk/en/buying-fairtrade/tea/cooperative",
                "2": "https://web.archive.org/web/20150622200646/http://www.co-operative.coop/our-ethics/our-plan/protecting-the-environment/clean-energy-revolution/",
                "3": "https://web.archive.org/web/20160303235606/http://www.co-operative.coop/upload/ToxicFuels/docs/businessandngo_openletter_mandatoryghgreporting.pdf",
                "4": "https://web.archive.org/web/20150521053740/http://www.co-operative.coop/upload/ToxicFuels/docs/toxic_fuels_report_web.pdf",
                "5": "http://www.marketingmagazine.co.uk/article/216426/co-op-extend-braille-labelling-food-range",
                "6": "https://web.archive.org/web/20160304060542/https://www.co-operative.coop/Corporate/PDFs/Shopping%20With%20Attitude%20Report.pdf",
                "7": "https://www.theguardian.com/world/2012/apr/29/co-op-israel-west-bank-boycott",
                "8": "http://www.foe.co.uk/resource/press_releases/0702coop",
                "9": "https://web.archive.org/web/20151211105906/http://news.co-operativefood.co.uk/latest-news/the-co-operative-voted-best-for-palm-oil-use.html"
            },
            "tags": [
                "supermarket",
                "retail",
                "propalestine",
                "connections to israel"
            ],
            "score": 85,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/The_Co-Operative_clover_leaf_logo.svg/120px-The_Co-Operative_clover_leaf_logo.svg.png",
            "siteUrl": "https://www.coop.co.uk/",
            "updatedAt": "2024-03-30T16:58:30.024Z",
            "key": "co-op"
        },
        "londis": {
            "names": [
                "Londis"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "supermarket",
                "retail"
            ],
            "score": 30,
            "ownedBy": [
                "tesco"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/c/cc/LondisLogo.svg",
            "siteUrl": "http://www.londis.co.uk/",
            "updatedAt": "2024-03-30T21:00:09.606Z",
            "key": "londis"
        },
        "premier": {
            "names": [
                "Premier"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "supermarket",
                "retail"
            ],
            "score": 30,
            "ownedBy": [
                "tesco"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/6/65/PremierStoresLogo.svg",
            "siteUrl": "http://premier-stores.co.uk/",
            "updatedAt": "2024-03-30T21:00:09.606Z",
            "key": "premier"
        },
        "sainsbury's": {
            "names": [
                "Sainsbury's",
                "J Sainsbury plc",
                "SBRY"
            ],
            "comment": "Sainsbury's has faced criticism for declining to pay contracted workers a living wage and for excessive executive compensation, with its CEO receiving £3.8m while rejecting calls to ensure all workers earn a living wage [1]. Investigations have uncovered allegations of forced labor, excessive overtime, abuse, and poor working conditions in factories producing clothing for Sainsbury's [2], and the company threatened legal action against a small business named Singhsbury's [3].",
            "sources": {
                "1": "https://www.theguardian.com/business/2022/jun/06/sainsburys-boss-pay-triples-to-38m-as-firm-rejects-living-wage-calls",
                "2": "https://www.dailymail.co.uk/news/article-8956691/Exploited-workers-Indian-factories-supplying-Tesco-Sainsburys-M-S-Ralph-Lauren.html",
                "3": "https://web.archive.org/web/20180109064054/https://www.theguardian.com/business/2017/jun/27/corner-shop-becomes-morrisinghs-after-sainsburys-legal-threat"
            },
            "tags": [
                "supermarket",
                "retail",
                "unfair pay",
                "poor working conditions",
                "anticompetitive",
                "forced labour"
            ],
            "score": 40,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/d/d7/Sainsbury%27s_Logo.svg",
            "siteUrl": "http://www.about.sainsburys.co.uk/",
            "updatedAt": "2024-03-30T21:00:09.606Z",
            "key": "sainsbury's"
        },
        "argos": {
            "names": [
                "Argos"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "retail"
            ],
            "score": 40,
            "ownedBy": [
                "sainsbury's"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/56/Argos_logo.svg",
            "siteUrl": "https://www.argos.co.uk/",
            "updatedAt": "2024-03-30T21:00:09.606Z",
            "key": "argos"
        },
        "ikea": {
            "names": [
                "IKEA",
                "Inter IKEA Systems B.V.",
                "Ikea"
            ],
            "comment": "Ikea is a Swedish furniture manufacturer that has sourced timber from illegal logging [1][2], and whose furniture designs have led to the deaths of children [3]. Ikea France was found illegally spying on employees [4], Ikea stores have been built over historic buildings and tombs [5][6], and the founder of Ikea was involved with Nazi groups [7].",
            "sources": {
                "1": "https://www.theguardian.com/environment/2020/jun/23/timber-unsustainable-logging-allegedly-sold-eu-ethical",
                "2": "https://www.independent.co.uk/climate-change/news/ikea-children-furniture-illegal-wood-b1884276.html",
                "3": "https://www.nbcnews.com/business/consumer/ikea-reaches-50-million-wrongful-death-settlement-over-falling-dressers-n698876",
                "4": "https://web.archive.org/web/20210616033812/https://www.theguardian.com/business/2021/jun/15/ikea-fined-1m-by-french-court-for-spying-on-staff",
                "5": "https://web.archive.org/web/20070712175632/http://www.nydailynews.com/boroughs/2006/11/22/2006-11-22_suit_aims_to_make_an_ikea_lot_history.html",
                "6": "https://www.reuters.com/article/us-china-tombs/workers-destroy-ancient-chinese-tombs-media-idUSPEK34443620070703/",
                "7": "https://www.nytimes.com/1994/11/09/business/ikea-founder-tells-of-past.html"
            },
            "tags": [
                "retail",
                "poor working conditions",
                "antiprivacy",
                "deforestation",
                "environmental violations",
                "unsustainable practices",
                "privacy violations",
                "unsafe practices"
            ],
            "score": 15,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/c5/Ikea_logo.svg",
            "siteUrl": "https://about.ikea.com/",
            "updatedAt": "2024-04-01T18:19:21.032Z",
            "key": "ikea"
        },
        "inditex": {
            "names": [
                "Inditex",
                "Industria de Diseño Textil, S.A."
            ],
            "comment": "Inditex is a Spanish clothing company that has used forced Uyghur labour in its suply chain [1], and slave labour in its Brazilian sweatshops [2], and has stolen designs from independent creators [3][4]. ",
            "sources": {
                "1": "https://www.shu.ac.uk/-/media/home/research/helena-kennedy-centre/projects/eu-apparel/eu-tailoring-responsibility-february-24.pdf",
                "2": "https://www.forbes.com/sites/andersonantunes/2011/08/17/zara-accused-of-alleged-slave-labor-in-brazil/",
                "3": "https://www.boredpanda.com/zara-stealing-designs-copying-independent-artists-tuesday-bassen/",
                "4": "https://web.archive.org/web/20200616103810/http://www.flanderstoday.eu/living/zara-home-co-opts-design-flemish-artisan"
            },
            "tags": [
                "clothing",
                "retail",
                "forced labour",
                "anticompetitive",
                "unsustainable",
                "forced uyghur labour"
            ],
            "score": 20,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/35/Inditex_logo_black.svg",
            "siteUrl": "https://www.inditex.com/",
            "updatedAt": "2024-04-01T18:19:21.032Z",
            "key": "inditex"
        },
        "zara": {
            "names": [
                "ZARA",
                "Zara"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "clothing"
            ],
            "score": 20,
            "ownedBy": [
                "inditex"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/f/fd/Zara_Logo.svg",
            "siteUrl": "https://www.zara.com/",
            "updatedAt": "2024-04-01T18:19:21.032Z",
            "key": "zara"
        },
        "bershka": {
            "names": [
                "Bershka"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "clothing",
                "retail"
            ],
            "score": 20,
            "ownedBy": [
                "inditex"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/75/Bershka_logo.svg/120px-Bershka_logo.svg.png",
            "siteUrl": "https://www.bershka.com/",
            "updatedAt": "2024-04-01T18:19:21.032Z",
            "key": "bershka"
        },
        "massimo-dutti": {
            "names": [
                "Massimo Dutti"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "clothing",
                "retail"
            ],
            "score": 20,
            "ownedBy": [
                "inditex"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/74/Massimo_Dutti.png/120px-Massimo_Dutti.png.png",
            "siteUrl": "http://www.massimodutti.com/",
            "updatedAt": "2024-04-01T18:19:21.032Z",
            "key": "massimo-dutti"
        },
        "stradivarius": {
            "names": [
                "Stradivarius"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "clothing",
                "retail"
            ],
            "score": 20,
            "ownedBy": [
                "inditex"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/95/Stradivarius_logo.svg",
            "siteUrl": "http://www.stradivarius.com/",
            "updatedAt": "2024-04-01T18:19:21.032Z",
            "key": "stradivarius"
        },
        "pullandbear": {
            "names": [
                "Pull&Bear",
                "Pull and Bear",
                "Pull & Bear"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "clothing",
                "retail"
            ],
            "score": 20,
            "ownedBy": [
                "inditex"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/72/Pull%26Bear_logo.svg",
            "siteUrl": "http://www.pullandbear.com/",
            "updatedAt": "2024-04-01T18:19:21.032Z",
            "key": "pullandbear"
        },
        "handm": {
            "names": [
                "H&M",
                "H & M Hennes & Mauritz AB",
                "H&M Group"
            ],
            "comment": "H&M is a multinational fast fashion company that has been accused of greenwashing [1] and has faced criticism for its operations in Israel [2]. H&M has made racist tweets [3] and used imagery widely seen as racist [4], and is being investigated for racist practices in Sweden [5].",
            "sources": {
                "1": "https://www.just-style.com/news/hm-under-fire-in-us-over-sustainable-material-claims/",
                "2": "http://www.inminds.co.uk/article.php?id=10310",
                "3": "https://newsone.com/3247456/hm-apologizes-racist-tweets/",
                "4": "https://www.cbsnews.com/news/h-m-the-weeknd-coolest-monkey-in-the-jungle-racist-hoodie/",
                "5": "https://www.reuters.com/article/h-m-discrimination-idUSKBN28J2JF"
            },
            "tags": [
                "clothing",
                "retail",
                "fast fashion",
                "discrimination",
                "greenwashing",
                "unsustainable",
                "connections to israel",
                "racial discrimination"
            ],
            "score": 30,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/53/H%26M-Logo.svg",
            "siteUrl": "https://www.hm.com/",
            "updatedAt": "2024-04-03T19:57:12.627Z",
            "key": "handm"
        },
        "cos": {
            "names": [
                "COS"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "clothing",
                "retail",
                "fast fashion"
            ],
            "score": 30,
            "ownedBy": [
                "handm"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6e/COS_Logo.png/120px-COS_Logo.png.png",
            "siteUrl": "https://www.cos.com/",
            "updatedAt": "2024-04-03T21:14:45.611Z",
            "key": "cos"
        },
        "arket": {
            "names": [
                "Arket"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "clothing",
                "retail",
                "fast fashion"
            ],
            "score": 30,
            "ownedBy": [
                "handm"
            ],
            "logoUrl": "https://image.hm.com/content/dam/hm-external-brands-brandpage-images/inspirational-page/logo/fashion/ARKET.svg",
            "siteUrl": "https://www.arket.com/",
            "updatedAt": "2024-04-03T21:14:45.611Z",
            "key": "arket"
        },
        "mango": {
            "names": [
                "Mango",
                "Punto Fa, S.L."
            ],
            "comment": "Mango, a Spanish fashion brand, has been accused of copying a bag design from a small creator [1], and has been criticized for promoting unhealthy body image by labeling sizes 40-52 as a separate \"Violeta\" line for \"curvy\" women [2]. Mango has refused to join the compensation efforts for victims of the Rana Plaza factory collapse that killed over 1,100 workers in its supply chain [3][4].",
            "sources": {
                "1": "http://www.lexpress.fr/styles/minute-mode/mango-accuse-de-contrefacon-par-velvetine_1002694.html",
                "2": "https://www.abc.es/sociedad/20140117/abci-mango-firmas-retirada-violeta-201401162008.html",
                "3": "https://www.independent.co.uk/life-style/fashion/rana-plaza-factory-disaster-anniversary-what-happened-fashion-a9478126.html",
                "4": "https://web.archive.org/web/20160325222511/http://www.dhakatribune.com/law-amp-rights/2013/oct/24/buyers-make-no-compensation-pledge-yet-rana-plaza-victims"
            },
            "tags": [
                "clothing",
                "retail",
                "fast fashion",
                "poor working conditions",
                "unsafe working conditions"
            ],
            "score": 25,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/1c/Logo_of_Mango_%28new%29.svg",
            "siteUrl": "http://shop.mango.com/",
            "updatedAt": "2024-04-03T20:02:08.965Z",
            "key": "mango"
        },
        "marks-and-spencer": {
            "names": [
                "Marks & Spencer",
                "Marks and Spencer plc",
                "M and S",
                "M&S",
                "MKS"
            ],
            "comment": "Marks & Spencer's supply chain has been criticized for labor abuses like forced overtime, denial of breaks, and underage workers at factories in Cambodia and elsewhere [1], as well as underpaying workers on berry farms supplying its groceries [2]. The company has faced protests over stocking Israeli goods [3] and an Oxfam report found poverty wages, discrimination, and health issues in its food and footwear supply chains despite audits clearing the company [4].",
            "sources": {
                "1": "https://www.theguardian.com/world/2015/mar/12/marks-and-spencer-gap-h-and-m-adidas-cambodian-factories-workers-rights",
                "2": "https://www.grocerygazette.co.uk/2022/01/25/uk-supermarkets-linked-to-underpaid-farm-workers/",
                "3": "https://www.jewishnews.co.uk/sparks-fly-marks-protesters-clash-israel/",
                "4": "https://www.retailgazette.co.uk/blog/2021/01/ms-under-scrutiny-over-supply-chain-worker-concerns/"
            },
            "tags": [
                "supermarket",
                "retail",
                "child labour",
                "discrimination",
                "poor working conditions",
                "forced labour",
                "unfair pay",
                "unsafe working conditions",
                "connections to israel"
            ],
            "score": 40,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/79/M%26S_logo.svg",
            "siteUrl": "https://marksandspencer.com/",
            "updatedAt": "2024-03-30T21:00:09.606Z",
            "key": "marks-and-spencer"
        },
        "iceland": {
            "names": [
                "Iceland",
                "Iceland Foods Limited",
                "Iceland Frozen Foods plc"
            ],
            "comment": "Iceland is a British supermarket that lied about removing palm oil from its products [1], and discriminated against customer groups [2][3]. Iceland has a poor animal welfare record [4] and the worst sustainability rating amongst supermarkets [5].",
            "sources": {
                "1": "https://www.bbc.co.uk/news/uk-46984349",
                "2": "https://www.irishtimes.com/ireland/2022/10/12/iceland-ordered-to-pay-12000-to-group-of-travellers-ejected-from-supermarket/",
                "3": "https://www.bbc.co.uk/news/uk-northern-ireland-21508758",
                "4": "https://www.independent.co.uk/news/uk/home-news/pigs-pork-animal-cruelty-iceland-asda-b1722592.html",
                "5": "https://www.thegrocer.co.uk/sustainability-and-environment/in-graphs-why-iceland-ranked-bottom-for-supermarket-sustainability-by-which/664405.article"
            },
            "tags": [
                "supermarket",
                "retail",
                "discrimination",
                "unsustainable",
                "animal abuse",
                "deception",
                "greenwashing",
                "unsustainable practices"
            ],
            "score": 35,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/f/fe/Iceland_with_the_The_Food_Warehouse_logo.png",
            "siteUrl": "https://iceland.co.uk/",
            "updatedAt": "2024-03-30T20:06:46.980Z",
            "key": "iceland"
        },
        "amazon": {
            "names": [
                "Amazon",
                "Amazon.com, Inc.",
                "AMZN"
            ],
            "comment": "Amazon is an American online retail and tech conglomerate which has funded climate change denial groups [1], issued propaganda to local news stations [2][3], sent thousands of items of unused stock to landfill [4][5], avoided billions in tax [6], violated privacy laws [7][8], discriminated against black and female employees [9][10], mistreated workers [11][12], aggressively opposed unionisation [13][14][15] and engaged in anticompetitive practices [16][17][18].",
            "sources": {
                "1": "https://web.archive.org/web/20190710185008/https://www.nytimes.com/2019/07/10/climate/nyt-climate-newsletter-cei.html",
                "2": "https://web.archive.org/web/20200604102522/https://news.avclub.com/oh-cool-amazon-is-dictating-the-local-news-now-1843705714",
                "3": "https://web.archive.org/web/20200528144830/https://www.vice.com/en_uk/article/4ayvwb/local-news-stations-run-propaganda-segments-scripted-and-produced-by-amazon",
                "4": "https://web.archive.org/web/20210621235131/https://www.itv.com/news/2021-06-21/amazon-destroying-millions-of-items-of-unsold-stock-in-one-of-its-uk-warehouses-every-year-itv-news-investigation-finds",
                "5": "https://web.archive.org/web/20210621204203/https://www.heraldscotland.com/business_hq/19387292.amazon-dunfermline-company-denies-denies-claim-thousands-items-sent-landfill/",
                "6": "https://www.theguardian.com/business/2019/dec/02/new-study-deems-amazon-worst-for-aggressive-tax-avoidance",
                "7": "https://web.archive.org/web/20210808141701/https://www.bloomberg.com/news/articles/2021-07-30/amazon-given-record-888-million-eu-fine-for-data-privacy-breach",
                "8": "https://www.bbc.com/news/technology-65772154",
                "9": "https://web.archive.org/web/20220217123550/https://www.king5.com/article/news/community/facing-race/current-and-former-black-amazon-employees-claim-racial-discrimination/281-8e91902f-c8e0-41c0-8809-e4413a58f859",
                "10": "https://web.archive.org/web/20220221113851/https://www.vox.com/recode/2021/2/26/22297554/amazon-race-black-diversity-inclusion",
                "11": "https://www.businessinsider.com/brutal-conditions-in-amazons-warehouses-2013-8",
                "12": "https://www.thedailybeast.com/amazon-the-shocking-911-calls-from-inside-its-warehouses",
                "13": "https://gizmodo.com/amazons-aggressive-anti-union-tactics-revealed-in-leake-1829305201",
                "14": "https://web.archive.org/web/20201031231943/https://www.theregister.com/2020/04/02/amazon_coronavirus_firing/",
                "15": "https://web.archive.org/web/20201216204639/https://www.businessinsider.com/whole-foods-tracks-unionization-risk-with-heat-map-2020-1?r=US&IR=T",
                "16": "https://web.archive.org/web/20080607093312/http://www.publishingnews.co.uk/pn/pno-news-display.asp?K=e2008040310393759&TAG=&CID=&PGE=&sg9t=cbd2a5be26893c7c10ff5b7ccc309f6f",
                "17": "https://archive.today/20191219195205/https://www.nytimes.com/2019/12/19/technology/amazon-sellers.html",
                "18": "https://www.npr.org/2020/10/06/920882893/how-are-apple-amazon-facebook-google-monopolies-house-report-counts-the-ways"
            },
            "tags": [
                "retail",
                "ecommerce",
                "tech",
                "unsustainable",
                "discrimination",
                "poor working conditions",
                "anticompetitive",
                "antiunion",
                "anticompetitive practices",
                "anti-union practices",
                "racial discrimination",
                "gender discrimination",
                "tax avoidance",
                "privacy violations",
                "unsustainable practices",
                "greenwashing",
                "environmental violations",
                "deception"
            ],
            "score": 5,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg",
            "siteUrl": "https://amazon.com",
            "updatedAt": "2024-01-07T15:59:06.010Z",
            "key": "amazon"
        },
        "fedex": {
            "names": [
                "FedEx",
                "FedEx Corporation",
                "Federal Express Corporation",
                "FDX Corporation",
                "Federal Express",
                "FDX"
            ],
            "comment": "Fedex is an American shipping and logistics company that spends tens of millions of dollars lobbying the federal government [1], benefitted from tax cuts without subsequently increasing investment as promised [2], distributed drugs without prescriptions [3], and pressured employees into working through the pandemic even if they were sick [4]. Fedex has made significant emissions savings through fuel conservation programs [5] but their 2021 annual report still states that they may struggle to reach their climate targets [6].",
            "sources": {
                "1": "https://web.archive.org/web/20210308191338/https://www.opensecrets.org/federal-lobbying/clients/summary?cycle=2018&id=D000000089",
                "2": "https://www.nytimes.com/2019/11/17/business/how-fedex-cut-its-tax-bill-to-0.html",
                "3": "https://web.archive.org/web/20141120015938/http://www.justice.gov/usao/can/news/2014/2014_07_17_fedex.indicted.press.html",
                "4": "https://www.nytimes.com/2020/03/21/business/coronavirus-ups-fedex-xpo-workers.html",
                "5": "https://web.archive.org/web/20221021092857/https://www.uschamberfoundation.org/blog/post/fedex-fuel-sense-every-drop-counts/31620",
                "6": "https://web.archive.org/web/20221018015119/https://investors.fedex.com/financial-information/sec-filings/default.aspx"
            },
            "tags": [
                "ecommerce",
                "poor working conditions",
                "unsafe working conditions",
                "tax avoidance",
                "unsustainable practices",
                "unsafe practices"
            ],
            "score": 45,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/b9/FedEx_Corporation_-_2016_Logo.svg",
            "siteUrl": "https://www.fedex.com/",
            "updatedAt": "2024-02-11T17:53:17.979Z",
            "key": "fedex"
        },
        "salesforce": {
            "names": [
                "Salesforce",
                "Salesforce, Inc.",
                "Salesforce.com, Inc.",
                "Salesforce.com",
                "CRM"
            ],
            "comment": "Salesforce, a tech company facing legal scrutiny for aiding Backpage in sex trafficking [1], has been highlighted for its tax avoidance strategies, with findings revealing it paid minimal federal taxes in 2018 [2]. Additionally, controversy surrounds its contracts with Customs and Border Protection, leading to the rejection of a donation by a legal aid group for immigrants and refugees [3], and allegations of inadequate accommodations for employees with developmental disorders in Japan [4].",
            "sources": {
                "1": "https://www.houstonchronicle.com/news/houston-texas/crime/article/Tech-giant-Salesforce-to-stand-trial-for-creating-16050424.php",
                "2": "https://www.cnbc.com/2019/12/16/these-91-fortune-500-companies-didnt-pay-federal-taxes-in-2018.html",
                "3": "https://www.theguardian.com/us-news/2018/jul/19/salesforce-raices-immigration-customs-border-protection",
                "4": "https://www.bengo4.com/c_5/n_13323"
            },
            "tags": [
                "tech",
                "tax avoidance",
                "poor working conditions"
            ],
            "score": 40,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/f/f9/Salesforce.com_logo.svg",
            "siteUrl": "https://salesforce.com/",
            "updatedAt": "2024-02-11T16:20:10.322Z",
            "key": "salesforce"
        },
        "tesco": {
            "names": [
                "Tesco",
                "Tesco plc",
                "TSCO",
                "Tesco Stores"
            ],
            "comment": "Tesco is a British retailer which appropriated a UNICEF slogan for advertising purposes [1] and engaged in price fixing [2], and its supply chain has included animal cruelty [3][4], slave labour [5], and deforestation of the Amazon [6]. Tesco has provided millions of pounds in educational equipment to schools [7], which is a fraction of the amount it has avoided in tax [8].",
            "sources": {
                "1": "https://web.archive.org/web/20110516024843/http://www.irishtimes.com/newspaper/ireland/2009/0725/1224251305112.html",
                "2": "https://web.archive.org/web/20160923155033/https://www.theguardian.com/business/2011/aug/10/tesco-attacks-oft-price-fixing-fine",
                "3": "https://web.archive.org/web/20221212130122/https://www.independent.co.uk/news/uk/home-news/rspca-farm-pigs-animal-cruelty-b2242436.html",
                "4": "https://web.archive.org/web/20221213163839/https://www.bbc.com/news/uk-england-lincolnshire-48745253",
                "5": "https://web.archive.org/web/20140611032723/http://www.theguardian.com/global-development/2014/jun/10/supermarket-prawns-thailand-produced-slave-labour",
                "6": "https://web.archive.org/web/20210828175312/https://leftfootforward.org/2021/08/greenpeace-activists-protest-tesco-as-meat-supplier-linked-to-amazon-forest-fires/",
                "7": "https://tescostrongerstarts.org.uk/5m-for-schools/",
                "8": "https://www.taxresearch.org.uk/Blog/2008/06/01/tescos-the-zug-deal-is-tax-avoidance/"
            },
            "tags": [
                "retail",
                "supermarket",
                "tax avoidance",
                "anticompetitive",
                "deforestation",
                "animal abuse",
                "forced labour",
                "anticompetitive practices",
                "deception",
                "unsustainable practices",
                "environmental violations"
            ],
            "score": 30,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/b/b0/Tesco_Logo.svg",
            "siteUrl": "https://www.tescoplc.com/",
            "updatedAt": "2024-01-07T10:56:47.816Z",
            "key": "tesco"
        },
        "bmw": {
            "names": [
                "BMW",
                "Bayerische Motoren Werke",
                "Bayerische Flugzeugwerke"
            ],
            "comment": "BMW is a German car maker that lied about its vehicles' emissions [1] and sourced cobalt from environmentally harmful sources [2][3].",
            "sources": {
                "1": "https://www.theguardian.com/environment/2021/jul/08/eu-fines-vw-and-bmw-750m-for-colluding-with-daimler-on-fumes",
                "2": "https://www.business-humanrights.org/en/latest-news/morocco-bmw-confirms-there-are-environmental-problems-at-managems-cobalt-mine/",
                "3": "https://www.heise.de/en/news/E-Autos-BMW-gesteht-Umweltprobleme-in-marokkanischer-Kobalt-Mine-ein-9715035.html"
            },
            "tags": [
                "cars",
                "unsustainable",
                "emissions cheating",
                "deception",
                "unsustainable practices",
                "environmental violations"
            ],
            "score": 36,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/f/f4/BMW_logo_%28gray%29.svg",
            "siteUrl": "https://www.bmw.com/en/index.html",
            "updatedAt": "2024-03-10T18:56:53.382Z",
            "key": "bmw"
        },
        "wetherspoons": {
            "names": [
                "Wetherspoons",
                "J D Wetherspoon",
                "Wetherspoon",
                "J D Wetherspoon plc",
                "Spoons",
                "JDW"
            ],
            "comment": "Wetherspoons is a UK pub chain known for excellent value for money [1].",
            "sources": {
                "1": "http://web.archive.org/web/20240105044821/https://www.thesun.co.uk/fabulous/25250928/wetherspoons-sale-january-food-drinks/"
            },
            "tags": [
                "restaurant",
                "beverages",
                "food",
                ""
            ],
            "score": 70,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/93/Wetherspoon_logo.svg",
            "siteUrl": "https://jdwetherspoon.com/",
            "updatedAt": "2024-04-05T20:00:17.127Z",
            "key": "wetherspoons"
        },
        "rolls-royce": {
            "names": [
                "Rolls-Royce"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "cars"
            ],
            "score": 36,
            "ownedBy": [
                "bmw"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/a2/Rolls_royce_holdings_logo.svg",
            "siteUrl": "https://www.rolls-royce.com/",
            "updatedAt": "2024-03-10T18:56:53.382Z",
            "key": "rolls-royce"
        },
        "mini": {
            "names": [
                "Mini"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "cars"
            ],
            "score": 36,
            "ownedBy": [
                "bmw"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/e/e9/MINI_logo.svg",
            "siteUrl": "http://mini.com/",
            "updatedAt": "2024-03-10T18:56:53.382Z",
            "key": "mini"
        },
        "whole-foods": {
            "names": [
                "Whole Foods",
                "Whole Foods Market",
                "Whole Foods Market, Inc."
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "food",
                "supermarket",
                "antiunion"
            ],
            "score": 5,
            "ownedBy": [
                "amazon"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Whole_Foods_Market_201x_logo.svg/120px-Whole_Foods_Market_201x_logo.svg.png",
            "siteUrl": "https://www.wholefoodsmarket.com/",
            "updatedAt": "2024-03-10T18:56:53.382Z",
            "key": "whole-foods"
        },
        "google": {
            "names": [
                "Google",
                "Google LLC",
                "Alphabet"
            ],
            "comment": "Google is an American tech conglomerate that has conducted mass surveillance on the public [1][2][3], enacted anti-union schemes [4], engaged in monopolistic and anticompetitive practices [5][6][7], and avoided billions in tax [8][9][10].",
            "sources": {
                "1": "https://www.theverge.com/2022/2/5/22918487/fbi-geofence-seattle-blm-protest-police-guild-attack",
                "2": "https://web.archive.org/web/20170320171345/http://www.bbc.com/news/world-us-canada-23123964",
                "3": "https://web.archive.org/web/20060818114650/http://www.guardian.co.uk/world/2013/jun/06/us-tech-giants-nsa-data",
                "4": "https://www.vice.com/en/article/v7d7j9/google-had-secret-project-to-convince-employees-that-unions-suck",
                "5": "https://www.bbc.com/news/technology-40406542",
                "6": "https://www.justice.gov/opa/pr/justice-department-sues-google-monopolizing-digital-advertising-technologies",
                "7": "https://www.opensecrets.org/news/2023/10/google-ramped-up-federal-lobbying-ahead-of-doj-antitrust-showdown/",
                "8": "https://static.financieel-management.nl/documents/16690/EU-Tax-Revenue-Loss-from-Google-and-Facebook.pdf",
                "9": "https://www.theguardian.com/technology/2013/may/16/google-told-by-mp-you-do-do-evil",
                "10": "https://www.independent.co.uk/news/uk/home-news/google-boss-im-very-proud-of-our-tax-avoidance-scheme-8411974.html"
            },
            "tags": [
                "tech",
                "ai",
                "antiprivacy",
                "antiunion",
                "anticompetitive",
                "tax avoidance",
                "anti-union practices",
                "anticompetitive practices",
                "privacy violations"
            ],
            "score": 20,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg",
            "siteUrl": "https://about.google/",
            "updatedAt": "2024-01-07T10:56:47.816Z",
            "key": "google"
        },
        "sony": {
            "names": [
                "Sony",
                "Sony Group Corporation",
                "Sony Corporation",
                "SONY"
            ],
            "comment": "Sony Group Corporation is a Japanese technology conglomerate that has engaged in price fixing [1], conducted surveillance on environmental activists [2], and created invasive DRM software [3]. Sony's runs a recycling program that takes back and recycles any of their products at no cost to the consumer [4].",
            "sources": {
                "1": "https://web.archive.org/web/20221123183738/https://www.reuters.com/article/tech-eu-video-fines-dc-idUKBFA00056020071120",
                "2": "https://web.archive.org/web/20201024125232/https://www.motherjones.com/environment/2000/09/sonys-pr-war-activists/",
                "3": "https://blogs.technet.com/b/markrussinovich/archive/2005/10/31/sony-rootkits-and-digital-rights-management-gone-too-far.aspx",
                "4": "https://www.sony.com/en_us/SCA/social-responsibility/environment.html"
            },
            "tags": [
                "tech",
                "video games",
                "entertainment",
                "electronics",
                "antiprivacy",
                "anticompetitive",
                "anticompetitive practices",
                "privacy violations"
            ],
            "score": 50,
            "ownedBy": [],
            "siteUrl": "https://www.sony.com/",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/ca/Sony_logo.svg",
            "updatedAt": "2024-01-07T10:56:47.816Z",
            "key": "sony"
        },
        "john-lewis": {
            "names": [
                "John Lewis",
                "John Lewis & Partners",
                "John Lewis Partnership plc",
                "JLP"
            ],
            "comment": "John Lewis is a British retailer which violated minimum wage regulations, underpaying around 20,000 workers by approximately £941,356 between 2011 and 2018 [1].",
            "sources": {
                "1": "https://www.reuters.com/world/uk/uk-names-john-lewis-others-breaking-minimum-wage-law-2021-08-04/"
            },
            "tags": [
                "retail",
                "supermarket",
                "poor working conditions",
                "unfair pay"
            ],
            "score": 45,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/a/a4/John_Lewis_%26_Partners_logo.svg",
            "siteUrl": "https://www.johnlewispartnership.co.uk/",
            "updatedAt": "2024-01-06T15:15:10.705Z",
            "key": "john-lewis"
        },
        "dell": {
            "names": [
                "Dell",
                "Dell Inc.",
                "DELL",
                "Dell Computer Corporation",
                "Dell Technologies, Inc.",
                "Dell Technologies"
            ],
            "comment": "Dell offers convenient trade-in and recycling solutions to help protect the environment by reusing precious materials to make new products [1]. Journalists investigating Dell have uncovered evidence of technical flaws and unethical business practices, including the use of low-quality components and deceptive sales tactics [2].",
            "sources": {
                "1": "https://web.archive.org/web/20230425034626/https://www.dell.com/en-us/dt/corporate/social-impact/advancing-sustainability/how-to-recycle.htm#/",
                "2": "https://www.fastcompany.com/1665003/dell-lawsuit-highlights-broken-pcs-dirty-business-dealings"
            },
            "tags": [
                "tech",
                "deception",
                "greenwashing"
            ],
            "score": 65,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/18/Dell_logo_2016.svg",
            "siteUrl": "https://www.dell.com/",
            "updatedAt": "2024-01-17T23:57:50.055Z",
            "key": "dell"
        },
        "bosch": {
            "names": [
                "Bosch",
                "Robert Bosch GmbH",
                "BOSCH"
            ],
            "comment": "Bosch was fined €90 million for its role in the Dieselgate scandal, delivering around 17 million devices with illegal software causing higher nitrogen oxide emissions [1]. The Robert Bosch Stiftung is a charitable foundation associated with the company focusing on health, education, global issues, and interdisciplinary exchange to promote a sustainable future [2].",
            "sources": {
                "1": "https://www.dw.com/en/bosch-pays-90-million-euro-fine-over-diesel-scandal/a-48843405",
                "2": "https://www.bosch-stiftung.de/en/about-robert-bosch-stiftung"
            },
            "tags": [
                "tech",
                "unsustainable",
                "deception",
                "environmental violations",
                "unsafe practices",
                "fossil fuels"
            ],
            "score": 40,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/16/Bosch-logo.svg",
            "siteUrl": "https://www.bosch.com/",
            "updatedAt": "2024-01-17T19:39:48.430Z",
            "key": "bosch"
        },
        "nike": {
            "names": [
                "Nike",
                "Nike, Inc.",
                "NIKE",
                "NKE",
                "Blue Ribbon Sports"
            ],
            "comment": "Nike is an American sportswear company that has benefited from child labour [1] and forced Uyghur labour [2], has avoided tax [3] and failed to take responsibility for hazardous waste dumping in its supply chain [4]. Nike has invested in sustainable materials research [5] and clothing recycling programs [6].",
            "sources": {
                "1": "https://news.bbc.co.uk/1/hi/programmes/panorama/970385.stm",
                "2": "https://fashionunited.com/news/fashion/nike-patagonia-named-in-european-lawsuit-as-being-complicit-in-forced-labour-practices-in-xinjiang-china/2021120644306",
                "3": "https://www.icij.org/investigations/paradise-papers/explore-politicians-paradise-papers/",
                "4": "https://web.archive.org/web/20200401155311/http://p3-raw.greenpeace.org/international/en/campaigns/detox/fashion/detox-catwalk/",
                "5": "https://hypebeast.com/2021/9/newlight-technologies-aircarbon-negative-nike-sustainable-shoes-what-the-tech",
                "6": "https://theecobahn.com/ideas/nike-reuse-a-shoe-digital-upcycling-shift/"
            },
            "tags": [
                "clothing",
                "child labour",
                "tax avoidance",
                "forced labour",
                "forced uyghur labour",
                "environmental violations",
                "unsustainable practices"
            ],
            "score": 40,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/a6/Logo_NIKE.svg",
            "siteUrl": "https://www.nike.com/",
            "updatedAt": "2024-01-29T21:48:22.741Z",
            "key": "nike"
        },
        "leon": {
            "names": [
                "LEON",
                "Leon Restaurants"
            ],
            "comment": "LEON is a British restaurant brand that started an initiative to deliver free meals to the NHS during the COVID-19 pandemic [1] and is a founding member of the Sustainable Restaurant Association [2].",
            "sources": {
                "1": "https://www.theguardian.com/business/2020/mar/27/leon-sets-up-initiative-to-deliver-free-hot-meals-to-nhs-staff-coronavirus",
                "2": "https://www.bbc.co.uk/news/uk-48781564"
            },
            "tags": [
                "restaurant",
                "fast food",
                "food",
                ""
            ],
            "score": 70,
            "ownedBy": [
                "eg-group"
            ],
            "logoUrl": "https://tse2.mm.bing.net/th?id=OIP.R6-CO58eUfG6oc05A_KJiQHaHa&pid=Api",
            "siteUrl": "https://leon.co/",
            "updatedAt": "2024-02-07T20:14:40.093Z",
            "key": "leon"
        },
        "greggs": {
            "names": [
                "Greggs",
                "Greggs Bakeries Limited",
                "Greggs plc",
                "GRG"
            ],
            "comment": "Greggs is a British bakery whose executives received \"excessive\" bonuses of millions of pounds in 2022 [1] while paying some employees below minimum wage [2]. The Greggs foundation is a charitable organisation that gives schoolchildren access to free, nutritional food [3].",
            "sources": {
                "1": "https://www.theguardian.com/business/2022/may/11/greggs-feels-heat-from-investors-over-excessive-pay-for-bosses",
                "2": "https://www.thecaterer.com/news/mitchells-and-butlers-greggs-minimum-wage-list-2024",
                "3": "https://web.archive.org/web/20240118100640/https://www.greggsfoundation.org.uk/news/2023-in-review"
            },
            "tags": [
                "restaurant",
                "food",
                "fast food",
                "unfair pay"
            ],
            "score": 45,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/1/19/Greggs_IMG_6701.jpg",
            "siteUrl": "https://www.greggs.co.uk/",
            "updatedAt": "2024-02-06T20:32:30.554Z",
            "key": "greggs"
        },
        "mitchells-and-butlers": {
            "names": [
                "Mitchells & Butlers",
                "Mitchells & Butlers plc",
                "M&B",
                "MAB"
            ],
            "comment": "Mitchells & Butlers, a British pub operator and FTSE 250 company, has faced criticism for unethical practices including failing to pay £565,094.87 in minimum wage to 16,187 employees [1], and implementing a tip-sharing system that can result in waiting staff earning below minimum wage [2]. Mitchells & Butlers ordered the killing of an ancient oak near one of their pubs [3].",
            "sources": {
                "1": "https://www.thecaterer.com/news/mitchells-and-butlers-greggs-minimum-wage-list-2024",
                "2": "https://www.theguardian.com/business/2023/oct/18/steakhouse-chain-miller-carter-waiting-staff-tips-pay-chefs",
                "3": "https://www.bbc.co.uk/news/articles/cn05y14dy7do"
            },
            "tags": [
                "restaurant",
                "bar",
                "pub",
                "poor working conditions",
                "unfair pay",
                "environmental violations"
            ],
            "score": 45,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/8/80/Mitchells_%26_Butlers_logo.svg",
            "siteUrl": "http://mbplc.com/",
            "updatedAt": "2024-04-07T15:46:15.962Z",
            "key": "mitchells-and-butlers"
        },
        "toby-carvery": {
            "names": [
                "Toby Carvery",
                "Toby",
                "Toby Pub & Carvery"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "restaurant",
                "pub"
            ],
            "score": 45,
            "ownedBy": [
                "mitchells-and-butlers"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f4/Denham%2C_The_Toby_Pub_and_Carvery_-_geograph.org.uk_-_803065.jpg/120px-Denham%2C_The_Toby_Pub_and_Carvery_-_geograph.org.uk_-_803065.jpg.png",
            "siteUrl": "http://www.tobycarvery.co.uk/",
            "updatedAt": "2024-04-07T15:46:15.962Z",
            "key": "toby-carvery"
        },
        "harvester": {
            "names": [
                "Harvester"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "restaurant",
                "pub"
            ],
            "score": 45,
            "ownedBy": [
                "mitchells-and-butlers"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/c/cf/Harvester_%28restaurant%29_logo.svg",
            "siteUrl": "http://www.harvester.co.uk/",
            "updatedAt": "2024-04-07T15:46:15.962Z",
            "key": "harvester"
        },
        "browns": {
            "names": [
                "Browns",
                "Browns Restaurants",
                "Browns Brasserie & Bar"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "restaurant",
                "bar"
            ],
            "score": 45,
            "ownedBy": [
                "mitchells-and-butlers"
            ],
            "logoUrl": "https://www.browns-restaurants.co.uk/content/dam/browns/images/browns-logo.png",
            "siteUrl": "https://www.browns-restaurants.co.uk/",
            "updatedAt": "2024-04-07T15:46:15.962Z",
            "key": "browns"
        },
        "all-bar-one": {
            "names": [
                "All Bar One"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "restaurant",
                "bar"
            ],
            "score": 45,
            "ownedBy": [
                "mitchells-and-butlers"
            ],
            "logoUrl": "https://www.allbarone.co.uk/content/dam/all-bar-one/images/content/theme/2018/abo-test-logo.png",
            "siteUrl": "https://www.allbarone.co.uk/",
            "updatedAt": "2024-04-07T15:46:15.962Z",
            "key": "all-bar-one"
        },
        "miller-and-carter": {
            "names": [
                "Miller & Carter"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "restaurant"
            ],
            "score": 45,
            "ownedBy": [
                "mitchells-and-butlers"
            ],
            "logoUrl": "https://www.millerandcarter.co.uk/content/dam/miller-and-carter/images/theme/sw/elements/mclogo-small.png",
            "siteUrl": "https://www.millerandcarter.co.uk/",
            "updatedAt": "2024-04-07T15:46:15.962Z",
            "key": "miller-and-carter"
        },
        "caffe-nero": {
            "names": [
                "Caffè Nero",
                "Caffe Nero",
                "Cafe Nero",
                "Caffè Nero Group Ltd.",
                "Caffè Nero Ltd"
            ],
            "comment": "Caffè Nero is a UK-based coffeehouse chain that has been accused of avoiding corporation tax through the use of tax-deductible interest payments and a complex corporate structure [1]. The company has also been found to have varying levels of faecal bacteria in its iced drinks, along with other major coffee chains [2].",
            "sources": {
                "1": "https://www.bbc.co.uk/news/business-27291283",
                "2": "https://www.bbc.co.uk/news/business-40426228"
            },
            "tags": [
                "restaurant",
                "coffee",
                "food",
                "beverages",
                "tax avoidance"
            ],
            "score": 46,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/21/Caff%C3%A8_Nero_Logo.svg/120px-Caff%C3%A8_Nero_Logo.svg.png",
            "siteUrl": "https://www.caffenero.com/",
            "updatedAt": "2024-04-09T21:34:43.018Z",
            "key": "caffe-nero"
        },
        "starbucks": {
            "names": [
                "Starbucks",
                "Starbucks Corporation",
                "SBUX"
            ],
            "comment": "Starbucks is an American coffee shop chain that has prolifically avoided tax [1][2], deprived Ethiopian farmers of their rightful pay [3] and enforces discriminatory pay discrepancies on its employees based on race [4]. Starbucks has engaged in anti-union practices [5][6] and has worked closely with the Anti-Defamation League [7].",
            "sources": {
                "1": "https://web.archive.org/web/20160210024015/http://uk.reuters.com/article/us-britain-starbucks-tax-idUKBRE89E0EX20121015",
                "2": "https://web.archive.org/web/20160104212731/http://uk.reuters.com/article/uk-starbucks-tax-europe-idUKBRE8A00DR20121101",
                "3": "https://web.archive.org/web/20191221001509/https://www.oxfamamerica.org/press/starbucks-opposes-ethiopia-coffee-trademark-plan/",
                "4": "https://web.archive.org/web/20220214212231/https://www.nytimes.com/2020/03/01/business/starbucks-discrimination-race.html",
                "5": "https://web.archive.org/web/20220215175957/https://www.theguardian.com/business/2021/nov/23/starbucks-aggressive-anti-union-effort-new-york-stores-organize",
                "6": "https://web.archive.org/web/20220213165713/https://www.washingtonpost.com/nation/2022/02/12/rhodes-scholar-barista-fight-unionize-starbucks/",
                "7": "https://web.archive.org/web/20190110003522/https://www.nytimes.com/2018/04/17/business/starbucks-arrests-racial-bias.html"
            },
            "tags": [
                "restaurant",
                "coffee",
                "food",
                "beverages",
                "tax avoidance",
                "poor working conditions",
                "antiunion",
                "unfair pay",
                "racial discrimination",
                "anti-union practices"
            ],
            "score": 35,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/d3/Starbucks_Corporation_Logo_2011.svg",
            "siteUrl": "https://starbucks.com/",
            "updatedAt": "2024-04-09T21:34:43.018Z",
            "key": "starbucks"
        },
        "zizzi": {
            "names": [
                "Zizzi",
                "Zizzi Restaurants Limited"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "restaurant"
            ],
            "score": null,
            "ownedBy": [
                "towerbrook-capital-partners"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/4/46/Zizzi_logo.svg",
            "siteUrl": "http://zizzi.co.uk/",
            "updatedAt": "2024-04-16T08:27:19.280Z",
            "key": "zizzi"
        },
        "costco": {
            "names": [
                "Costco",
                "Costco Wholesale Corporation",
                "COST"
            ],
            "comment": "Costco is an American wholesaler whose supply chain has included animal cruelty [1][2] and forced monkey labour [3], and which has overworked employees resulting in death [4]. Costco has sourced stock produced by slave labour [5], cut down Canadian forests to make toilet paper [6], and spilled 111 thousand litres of oil in Iceland [7].",
            "sources": {
                "1": "https://web.archive.org/web/20160302200432/http://qz.com/582427/after-months-of-pressure-costco-commits-to-a-cage-free-egg-supply/",
                "2": "https://web.archive.org/web/20170130104252/https://www.washingtonpost.com/news/animalia/wp/2016/10/20/her-head-has-been-torn-off-activists-film-alleges-abuse-at-costco-linked-cage-free-egg-farm/",
                "3": "https://web.archive.org/web/20210417155108/https://www.cnn.com/2020/10/31/business/costco-coconut-milk-monkey-labor-trnd/index.html",
                "4": "https://www.koreatimes.co.kr/www/tech/2024/03/419_359141.html",
                "5": "https://web.archive.org/web/20200728230134/https://www.cbsnews.com/news/shrimp-sold-at-walmart-costco-tied-to-slave-labor/",
                "6": "https://actions.sumofus.org/a/costco-protect-the-boreal-forests-and-use-recycled-pulp-in-your-toilet-paper?source=campaigns",
                "7": "https://www.icelandreview.com/news/costco-fined-isk-20-million-for-gross-negligence-over-oil-spill/"
            },
            "tags": [
                "retail",
                "supermarket",
                "animal abuse",
                "forced labour",
                "unsafe working conditions",
                "deforestation",
                "environmental violations"
            ],
            "score": 7,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/59/Costco_Wholesale_logo_2010-10-26.svg",
            "siteUrl": "https://www.costco.com/",
            "updatedAt": "2024-05-11T22:44:30.064Z",
            "key": "costco"
        },
        "wagamama": {
            "names": [
                "Wagamama"
            ],
            "comment": "Wagamama is a British restaurant chain that has underpaid staff and failed to pay the National Minimum Wage [1], and has been accused of maintaining a policy that discourages sick employees from taking time off [2]. The company has also faced criticism for requiring staff to cover the cost of uniforms, which was considered an infringement on workers' rights [1].",
            "sources": {
                "1": "https://www.bbc.com/news/business-43332875",
                "2": "https://pjhlaw.co.uk/2018/01/05/happened-christmas-part-1-wagamama-sick-leave/"
            },
            "tags": [
                "restaurant",
                "poor working conditions",
                "unfair pay"
            ],
            "score": 40,
            "ownedBy": [
                "apollo-global-management"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/35/Wagamama_logo.svg",
            "siteUrl": "https://www.wagamama.com/",
            "updatedAt": "2024-04-16T15:20:06.727Z",
            "key": "wagamama"
        },
        "yo!-sushi": {
            "names": [
                "YO! Sushi",
                "Yo! Sushi",
                "Yo Sushi"
            ],
            "comment": "YO! Sushi, a British sushi restaurant chain, has been identified as having the worst food safety record among major chains, with eight of its 23 restaurants failing to meet legal hygiene standards [1]. A YO! Sushi location refused to seat a blind woman accompanied by a guide dog [2].",
            "sources": {
                "1": "https://www.thecaterer.com/news/restaurant/yo-sushi-defends-food-safety-procedures-after-independent-attacks-hygiene-record",
                "2": "https://www.mailplus.co.uk/edition/news/society/107928/yo-sushi-restaurant-refuses-to-seat-blind-woman-accompanied-by-guide-dog"
            },
            "tags": [
                "restaurant",
                "food",
                "discrimination",
                "unsafe practices"
            ],
            "score": 39,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/a/a1/YO%21_Sushi_logo.svg",
            "siteUrl": "https://yosushi.com/",
            "updatedAt": "2024-04-15T15:40:27.062Z",
            "key": "yo!-sushi"
        },
        "shake-shack": {
            "names": [
                "Shake Shack",
                "SHAK"
            ],
            "comment": "Shake Shack is an American fast food chain that has agreed to a $6 million class action lawsuit settlement for failing to provide consistent and lawful schedules to New York City employees, violating the city's Fair Workweek Law [1]. The company has also been ordered to pay $20,000 to a former employee for gender discrimination, harassment, and retaliation based on gender identity and expression, and has been accused of denying managers overtime pay [2][3]. Additionally, Shake Shack's connection to a bakery whose owners support a controversial political figure has led to criticism and calls for a boycott of the chain [4].",
            "sources": {
                "1": "https://topclassactions.com/lawsuit-settlements/closed-settlements/shake-shack-employee-schedules-6m-class-action-lawsuit-settlement/",
                "2": "https://www.today.com/food/news/shake-shack-misgendering-discrimination-lawsuit-rcna70790",
                "3": "https://www.dnainfo.com/new-york/20160329/midtown/shake-shack-settles-lawsuit-over-manager-overtime-pay-company-says/",
                "4": "https://www.tastingtable.com/884727/the-shake-shack-potato-roll-controversy-explained/"
            },
            "tags": [
                "fast food",
                "discrimination",
                "poor working conditions",
                "gender discrimination",
                "sexual harassment",
                "unfair pay"
            ],
            "score": 40,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/96/Shake_Shack_logo.svg",
            "siteUrl": "https://www.shakeshack.com/",
            "updatedAt": "2024-04-15T15:40:27.062Z",
            "key": "shake-shack"
        },
        "papa-john's": {
            "names": [
                "Papa John's",
                "Papa John's International, Inc."
            ],
            "comment": "Papa John's is an American pizza chain which has faced allegations of sexual harassment and racism by its founder and former CEO [1][2]. The company has been described as having a toxic atmosphere, with instances of sexism and racist language used by its executives [3].",
            "sources": {
                "1": "https://www.cnbc.com/2018/07/10/papa-johns-founder-john-schnatter-resigns-as-chairman-of-company-boar.html",
                "2": "https://www.forbes.com/sites/forbesdigitalcovers/2018/07/19/the-inside-story-of-papa-johns-toxic-culture/",
                "3": "https://www.forbes.com/sites/forbesdigitalcovers/2018/07/19/the-inside-story-of-papa-johns-toxic-culture/"
            },
            "tags": [
                "fast food",
                "pizza",
                "sexual harassment",
                "discrimination",
                "poor working conditions",
                "racial discrimination",
                "gender discrimination"
            ],
            "score": 40,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/92/Papa_Johns_logo.svg",
            "siteUrl": "http://papajohns.com/",
            "updatedAt": "2024-04-15T15:40:27.062Z",
            "key": "papa-john's"
        },
        "wimpy": {
            "names": [
                "Wimpy"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "fast food",
                "restaurant"
            ],
            "score": 50,
            "ownedBy": [
                "famous-brands"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/1e/Logo_of_Wimpy.svg",
            "siteUrl": "http://www.wimpy.uk.com/",
            "updatedAt": "2024-04-15T15:40:27.062Z",
            "key": "wimpy"
        },
        "tortilla": {
            "names": [
                "Tortilla",
                "Tortilla Mexican Grill PLC",
                "MEX"
            ],
            "comment": "Tortilla is a UK restaurant chain that sources 100% renewable electricity and converts its used cooking oil to biodiesel [1].",
            "sources": {
                "1": "http://web.archive.org/web/20240415153554/https://tortillagroup.co.uk/wp-content/uploads/Release-Tortilla-ESG-impact-report.pdf"
            },
            "tags": [
                "restaurant",
                "food",
                "fast food",
                ""
            ],
            "score": 75,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ee/Tortilla_logo.svg/120px-Tortilla_logo.svg.png",
            "siteUrl": "https://www.tortilla.co.uk/",
            "updatedAt": "2024-04-15T07:16:31.977Z",
            "key": "tortilla"
        },
        "five-guys": {
            "names": [
                "Five Guys",
                "Five Guys Burgers and Fries",
                "Five Guys Enterprises, LLC",
                "5 Guys"
            ],
            "comment": "Five Guys, a American burger chain, has faced allegations of gender-based pay discrimination [1], labor violations including off-the-clock work and denied breaks [2], and discrimination against an employee with HIV [3]. The company has also been subject to sexual harassment lawsuits, with former employees claiming they were subjected to hostile work environments [4].",
            "sources": {
                "1": "https://news.bloomberglaw.com/daily-labor-report/five-guys-loses-round-to-two-women-in-nationwide-pay-bias-suit",
                "2": "https://topclassactions.com/lawsuit-settlements/lawsuit-news/five-guys-burgers-accused-of-california-labor-violations/",
                "3": "http://web.archive.org/web/20181101230628/https://www.ocala.com/news/20181101/fired-ocala-employee-sues-five-guys-for-discrimination",
                "4": "http://web.archive.org/web/20240414210254/https://www.wvgazettemail.com/news/legal_affairs/putnam-five-guys-employees-sue-managers-chain-over-sexual-harassment/article_5366f1b7-3d9b-584a-afc4-9247787ab51c.html"
            },
            "tags": [
                "restaurant",
                "fast food",
                "food",
                "poor working conditions",
                "discrimination",
                "sexual harassment",
                "gender discrimination",
                "unfair pay"
            ],
            "score": 40,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/80/Five_Guys_logo.svg/120px-Five_Guys_logo.svg.png",
            "siteUrl": "http://fiveguys.com/",
            "updatedAt": "2024-04-14T21:05:29.060Z",
            "key": "five-guys"
        },
        "chipotle": {
            "names": [
                "Chipotle",
                "Chipotle Mexican Grill",
                "Chipotle Mexican Grill, Inc.",
                "CMG"
            ],
            "comment": "Chiptole is an American fast food company that has underpaid its employees [1] who often face unacceptable working conditions [2]. Chiptole's poor food standards have made thousands of people sick [3] and the company has failed to report on its sustainability practices [4].",
            "sources": {
                "1": "https://edition.cnn.com/2021/04/29/business/chipotle-nyc-lawsuit-labor-law/index.html",
                "2": "https://www.nytimes.com/2019/09/10/nyregion/chipotle-lawsuit-workers.html",
                "3": "https://www.ft.com/content/8fcc81a3-aed8-47e0-9898-ab34dd6ef73c",
                "4": "https://www.theguardian.com/sustainable-business/2015/oct/23/chipotles-corporate-social-responsibility-mcdonalds-gmo"
            },
            "tags": [
                "restaurant",
                "food",
                "fast food",
                "poor working conditions",
                "unsafe working conditions",
                "unfair pay",
                "unsafe practices"
            ],
            "score": 40,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/3/3b/Chipotle_Mexican_Grill_logo.svg",
            "siteUrl": "http://chipotle.com/",
            "updatedAt": "2024-04-13T08:34:01.493Z",
            "key": "chipotle"
        },
        "adidas": {
            "names": [
                "Adidas",
                "Adidas AG",
                "ADS"
            ],
            "comment": "Adidas is a German sportswear manufacturer that has selected suppliers subjecting employees to sweatshop-like conditions [1] and whose head of HR resigned after inaction against racial discrimination within the company [2].",
            "sources": {
                "1": "https://www.oxfam.org.au/explore/workers-rights/adidas",
                "2": "https://www.reuters.com/article/us-adidas-race/adidas-human-resources-head-steps-down-after-race-row-idUSKBN241332?il=0"
            },
            "tags": [
                "clothing",
                "poor working conditions",
                "discrimination",
                "racial discrimination",
                "forced labour",
                "unsafe working conditions"
            ],
            "score": 42,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/1b/Adidas_2022_logo.svg",
            "siteUrl": "https://www.adidas.com/",
            "updatedAt": "2024-01-29T21:48:22.741Z",
            "key": "adidas"
        },
        "uniqlo": {
            "names": [
                "Uniqlo"
            ],
            "comment": "Uniqlo is a Japanese clothing retailer that has repeatedly exhibited abuse of its workers globally [1][2][3][4], sourced materials stemming from forced labour [5] and produced adverts that trivialised the trauma of victims of sex slavery [6]. Uniqlo initially decided to keep operating in Russia but then reversed its decision [7].",
            "sources": {
                "1": "https://www.waronwant.org/sites/default/files/WoW_uniqlo%20report%202016.pdf",
                "2": "https://web.archive.org/web/20160827181345/http://www.waronwant.org/media/reality-behind-uniqlos-corporate-social-responsibility-promises",
                "3": "https://web.archive.org/web/20160920181433/http://qz.com/324726/your-uniqlo-skinny-jeans-may-have-a-dark-past/",
                "4": "https://web.archive.org/web/20190302234149/https://www.news.com.au/finance/business/retail/everyone-has-some-form-of-ptsd-former-uniqlo-employees-describe-toxic-bullying-culture/news-story/3e355f0f9c64234aa30e95b378735df8",
                "5": "https://web.archive.org/web/20210521104028/https://www.reuters.com/world/china/uniqlo-shirts-blocked-us-border-january-china-forced-labour-concern-2021-05-19/",
                "6": "https://web.archive.org/web/20210614232327/https://ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js",
                "7": "https://www.nytimes.com/2022/03/10/business/uniqlo-fast-retailing-russia.html"
            },
            "tags": [
                "clothing",
                "fast fashion",
                "retail",
                "poor working conditions",
                "forced labour",
                "unsafe working conditions",
                "connections to russia"
            ],
            "score": 25,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/7e/Uniqlo_logo_Japanese.svg",
            "siteUrl": "https://www.uniqlo.com/",
            "updatedAt": "2024-02-18T12:37:05.918Z",
            "key": "uniqlo"
        },
        "twitter": {
            "names": [
                "Twitter",
                "X",
                "Twitter.com",
                "x.com",
                "Twitter, Inc.",
                "X Corp."
            ],
            "comment": "X, formerly known as Twitter, is an American social media platform owned by Elon Musk, under whose ownership hate speech has flourished [1]. Twitter has been pivotal in democratising the spread of information and news [2], and for purposes like organising political actions [3], but its algorithm has been found to be politically biased [4]. ",
            "sources": {
                "1": "https://www.wired.com/story/twitter-really-is-worse-than-ever/",
                "2": "https://web.archive.org/web/20170206120212/http://denman-mills.net/web_documents/jips_mills.etal._2009.07.22_finalsubmission.pdf",
                "3": "https://doi.org/10.13140%2FRG.2.1.4239.9442",
                "4": "https://www.theguardian.com/technology/2021/oct/22/twitter-admits-bias-in-algorithm-for-rightwing-politicians-and-news-outlets"
            },
            "tags": [
                "social media",
                "news",
                "tech",
                "media",
                "racial discrimination"
            ],
            "score": 48,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/ce/X_logo_2023.svg",
            "siteUrl": "https://twitter.com/",
            "updatedAt": "2024-02-18T12:11:46.993Z",
            "key": "twitter"
        },
        "converse": {
            "names": [
                "Converse"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "clothing"
            ],
            "score": 40,
            "ownedBy": [
                "nike"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/30/Converse_logo.svg",
            "siteUrl": "https://converse.com/",
            "updatedAt": "2024-01-29T21:48:22.741Z",
            "key": "converse"
        },
        "jordans": {
            "names": [
                "Jordans",
                "Air Jordan",
                "Jordan Brand"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "clothing"
            ],
            "score": 40,
            "ownedBy": [
                "nike"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/3/37/Jumpman_logo.svg",
            "siteUrl": "https://www.nike.com/jordan",
            "updatedAt": "2024-01-29T21:48:22.741Z",
            "key": "jordans"
        },
        "lg": {
            "names": [
                "LG",
                "LG Corporation",
                "LG Group",
                "Lucky-Goldstar",
                "주식회사 엘지",
                "LGLD"
            ],
            "comment": "LG is a South Korean technology and industrial conglomerate that produces products including electronics, batteries and petrochemicals. In 2020 two fatal accidents at LG Chem facilities resulted in the deaths of thirteen people [1].",
            "sources": {
                "1": "https://techxplore.com/news/2020-05-lg-chairman-apologises-gas-leak.html"
            },
            "tags": [
                "tech",
                "chemicals",
                "electronics",
                "unsafe working conditions"
            ],
            "score": 20,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/8d/LG_logo_%282014%29.svg",
            "siteUrl": "https://lgcorp.com/",
            "updatedAt": "2024-01-21T20:33:02.640Z",
            "key": "lg"
        },
        "accenture": {
            "names": [
                "Accenture",
                "Accenture plc",
                "Accenture Limited",
                "Accenture Services Ltd.",
                "Accenture FZ-LLC",
                "Accenture Solutions S.A.",
                "Accenture Federal Services",
                "ACN"
            ],
            "comment": "Accenture faces criticism for working with Isabel dos Santos, accused of corruption, and is under employee backlash over a $297 million contract with Customs and Border Protection (CBP) that supports inhumane policies [1]. Accenture has been involved in allegations of corruption-linked businesses and faces internal protests similar to those at Amazon, Salesforce, Microsoft, and Google [2].",
            "sources": {
                "1": "https://qz.com/africa/1787289/accenture-took-millions-from-isabel-dos-santos-despite-corruption-claims",
                "2": "https://gizmodo.com/accenture-employees-demand-their-company-break-ties-wit-1830474961"
            },
            "tags": [
                "finance",
                "tech",
                "corruption"
            ],
            "score": 41,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/cd/Accenture.svg",
            "siteUrl": "https://www.accenture.com/",
            "updatedAt": "2024-03-02T19:34:35.315Z",
            "key": "accenture"
        },
        "procter-and-gamble": {
            "names": [
                "Procter & Gamble",
                "P&G",
                "Procter and Gamble",
                "The Procter & Gamble Company",
                "P & G",
                "PG"
            ],
            "comment": "Procter and Gamble is an American consumer goods company that has profited from child labour in palm oil production [1] and has been named by Ukraine as an international sponsor of war [2].\nThe company's advertising has addressed issues including police brutality and has won an Emmy award [3][4].",
            "sources": {
                "1": "https://web.archive.org/web/20180423210624/https://www.amnesty.org/en/documents/asa21/5184/2016/en/",
                "2": "https://sanctions.nazk.gov.ua/en/boycott/14/",
                "3": "https://web.archive.org/web/20190216195636/https://www.cbsnews.com/amp/news/the-talk-ad-procter-and-gamble-commercial-racial-stereotypes-stirs-debate/",
                "4": "https://web.archive.org/web/20180913074041/https://www.shootonline.com/news/pgs-talk%C2%A0wins-primetime-commercial-emmy-award"
            },
            "tags": [
                "consumer goods",
                "child labour",
                "russia"
            ],
            "score": 35,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/85/Procter_%26_Gamble_logo.svg",
            "siteUrl": "https://pg.com/",
            "updatedAt": "2024-01-31T19:00:57.998Z",
            "key": "procter-and-gamble"
        },
        "spotify": {
            "names": [
                "Spotify",
                "Spotify Technology S.A.",
                "SPOT",
                "Spotify Ltd",
                "Spotify USA Inc.",
                "Spotify AB"
            ],
            "comment": "Spotify is a music streaming service that has been accused of unfairly compensating artists [1][2] and whose CEO has donated millions to military artificial intelligence research [3][4]. Although spotify has reduced piracy it has also reduced music sales [5] limiting benefit to artists.",
            "sources": {
                "1": "https://www.digitalmusicnews.com/2021/06/29/spotify-executive-entitled-pay-penny-per-stream/",
                "2": "https://www.huffingtonpost.com/2012/03/28/black-keys-sean-parker-spotify-asshole_n_1384882.html",
                "3": "https://techcrunch.com/2021/11/09/daniel-eks-fund-puts-e100m-into-defence-startup-helsing-ai-to-support-democracies/",
                "4": "https://www.billboard.com/pro/daniel-ek-defense-tech-investment-boycott-spotify-helsing/",
                "5": "https://www.engadget.com/2015-10-28-spotify-piracy-study.html?guccounter=1"
            },
            "tags": [
                "tech",
                "music",
                "unfair pay"
            ],
            "score": 40,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/26/Spotify_logo_with_text.svg",
            "siteUrl": "https://spotify.com/",
            "updatedAt": "2024-01-26T18:00:16.127Z",
            "key": "spotify"
        },
        "unilever": {
            "names": [
                "Unilever",
                "Unilever plc",
                "ULVR",
                "UNA",
                "UL"
            ],
            "comment": "Unilever is a British food and beverage and consumer products conglomerate that has been named by Ukraine as a sponsor of war [1], continued selling Ben & Jerry's in Israeli settlements depite the brand's intent to withdraw [2], hired security that assaulted peaceful protestors [3], aggressively pushed skin lightening products [4], engaged in price fixing [5], opposed legislation against single-use plastic [6], caused deforestation [7] and sourced palm oil from a supplier that used child labour [8].",
            "sources": {
                "1": "https://archive.is/v01oO",
                "2": "https://archive.is/dwpFn",
                "3": "https://web.archive.org/web/20211206070632/https://www.ethicalconsumer.org/food-drink/unilever-still-failing-respect-its-workers-rights",
                "4": "https://web.archive.org/web/20201103064806/https://www.buzzfeednews.com/article/meghara/unilever-sri-lankan-influencers-skin-whiteners",
                "5": "https://web.archive.org/web/20180509100638/http://www.bbc.co.uk/news/business-13064928",
                "6": "https://www.reuters.com/investigates/special-report/global-plastic-unilever/",
                "7": "https://web.archive.org/web/20140508042719/http://www.greenpeace.org.uk/media/press-releases/unilever-admits-toxic-dumping-will-clean-up-but-not-come-clean",
                "8": "https://web.archive.org/web/20180423210624/https://www.amnesty.org/en/documents/asa21/5184/2016/en/"
            },
            "tags": [
                "food",
                "beverages",
                "consumer goods",
                "russia",
                "plastic",
                "deforestation",
                "child labour",
                "anticompetitive",
                "unsustainable",
                "connections to israel",
                "anticompetitive practices",
                "racial discrimination",
                "unsustainable practices",
                "connections to russia"
            ],
            "score": 5,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/e/e4/Unilever.svg",
            "siteUrl": "https://www.unilever.com/",
            "updatedAt": "2024-01-25T07:25:34.031Z",
            "key": "unilever"
        },
        "knorr": {
            "names": [
                "Knorr"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "food"
            ],
            "score": 5,
            "ownedBy": [
                "unilever"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dc/Knorr_Logo_2020.svg/120px-Knorr_Logo_2020.svg.png",
            "siteUrl": "https://www.knorr.com/",
            "updatedAt": "2024-01-25T22:09:42.603Z",
            "key": "knorr"
        },
        "vaseline": {
            "names": [
                "Vaseline"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "consumer goods"
            ],
            "score": 5,
            "ownedBy": [
                "unilever"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6c/Vaseline_new_logo.png",
            "siteUrl": "https://vaseline.com/",
            "updatedAt": "2024-01-25T22:09:42.603Z",
            "key": "vaseline"
        },
        "colman's": {
            "names": [
                "Colman's"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "food"
            ],
            "score": 5,
            "ownedBy": [
                "unilever"
            ],
            "logoUrl": "https://www.colmans.co.uk/sk-eu/content/dam/brands/colmans/united_kingdom/1468566-colmans-logo.png.rendition.466.242.png",
            "siteUrl": "https://www.colmans.co.uk/",
            "updatedAt": "2024-01-27T01:34:37.705Z",
            "key": "colman's"
        },
        "mondelez": {
            "names": [
                "Mondelez",
                "Mondelēz",
                "Mondelez International",
                "Mondelez International, Inc.",
                "Mondelēz International",
                "MDLZ"
            ],
            "comment": "Mondelez International, the maker of Cadbury, Oreo, and other popular snack brands, has been accused of destroying tens of thousands of hectares of orangutan habitat [1] and continuing to employ child labor on cocoa farms in its supply chain despite past pledges to eliminate such practices [2]. Despite promising to source sustainable palm oil, Mondelez has remained linked to suppliers engaged in deforestation and human rights abuses, and the company continued operating in Russia following its invasion of Ukraine, leading Ukraine to declare it an international sponsor of the war [3].",
            "sources": {
                "1": "https://www.independent.co.uk/environment/orangutans-palm-oil-habitat-rainforest-cadbury-mondelez-oreos-indonesia-greenpeace-a8630801.html",
                "2": "https://www.theguardian.com/law/2022/apr/03/cadbury-faces-fresh-accusations-of-child-labour-on-cocoa-farms-in-ghana",
                "3": "https://english.nv.ua/business/ukraine-declares-mondelez-international-makers-of-milka-and-oreo-sponsor-of-war-50327508.html"
            },
            "tags": [
                "food",
                "beverages",
                "unsustainable",
                "deforestation",
                "child labour",
                "russia",
                "connections to russia",
                "unsustainable practices",
                "environmental violations",
                "greenwashing"
            ],
            "score": 20,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/3b/Mondelez_International.svg",
            "siteUrl": "http://mondelezinternational.com/",
            "updatedAt": "2024-03-14T21:59:31.553Z",
            "key": "mondelez"
        },
        "cadbury": {
            "names": [
                "Cadbury"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "confectionary"
            ],
            "score": 20,
            "ownedBy": [
                "mondelez"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/a4/Cadbury_%282020%29.svg",
            "siteUrl": "https://cadbury.co.uk/",
            "updatedAt": "2024-01-27T01:34:37.705Z",
            "key": "cadbury"
        },
        "daim": {
            "names": [
                "Daim"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "confectionary"
            ],
            "score": 20,
            "ownedBy": [
                "mondelez"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/c/cf/Daim-Wrapper-Small.jpg",
            "siteUrl": "https://www.mondelezinternational.com/our-brands/daim/",
            "updatedAt": "2024-01-27T01:34:37.705Z",
            "key": "daim"
        },
        "halls": {
            "names": [
                "Halls"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "confectionary"
            ],
            "score": 20,
            "ownedBy": [
                "mondelez"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/f/f0/HallsCoughDrops.jpg",
            "siteUrl": "http://gethalls.com/",
            "updatedAt": "2024-01-27T01:34:37.705Z",
            "key": "halls"
        },
        "milka": {
            "names": [
                "Milka"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "confectionary"
            ],
            "score": 20,
            "ownedBy": [
                "mondelez"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/09/Milka_purple_logo18.svg",
            "siteUrl": "https://www.milka.com/",
            "updatedAt": "2024-01-27T01:34:37.705Z",
            "key": "milka"
        },
        "oreo": {
            "names": [
                "Oreo"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "confectionary"
            ],
            "score": 20,
            "ownedBy": [
                "mondelez"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/9/97/Oreo_Cookie_logo.png",
            "siteUrl": "https://www.oreo.com/",
            "updatedAt": "2024-01-27T01:34:37.705Z",
            "key": "oreo"
        },
        "philadelphia": {
            "names": [
                "Philadelphia"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "food"
            ],
            "score": 20,
            "ownedBy": [
                "mondelez",
                "kraft-heinz"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Philadelphia_cheese_logo.png/120px-Philadelphia_cheese_logo.png.png",
            "siteUrl": "https://www.mondelezinternational.com/our-brands/philadelphia/",
            "updatedAt": "2024-01-27T01:34:37.705Z",
            "key": "philadelphia"
        },
        "ritz": {
            "names": [
                "Ritz"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "food"
            ],
            "score": 20,
            "ownedBy": [
                "mondelez"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/72/Ritz_crackers_logo.png/120px-Ritz_crackers_logo.png.png",
            "siteUrl": "https://www.ritzcrackers.com/",
            "updatedAt": "2024-01-27T01:34:37.705Z",
            "key": "ritz"
        },
        "sour-patch-kids": {
            "names": [
                "Sour Patch Kids"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "confectionary"
            ],
            "score": 20,
            "ownedBy": [
                "mondelez"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4a/Sour-Patch-Kids.jpg/250px-Sour-Patch-Kids.jpg",
            "siteUrl": "http://sourpatchkids.com/",
            "updatedAt": "2024-01-27T01:34:37.705Z",
            "key": "sour-patch-kids"
        },
        "toblerone": {
            "names": [
                "Toblerone"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "confectionary"
            ],
            "score": 20,
            "ownedBy": [
                "mondelez"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/Toblerone_logo22.png/120px-Toblerone_logo22.png.png",
            "siteUrl": "https://www.toblerone.co.uk/en",
            "updatedAt": "2024-01-27T01:34:37.705Z",
            "key": "toblerone"
        },
        "primark": {
            "names": [
                "Primark",
                "Penneys",
                "Primark Stores Limited"
            ],
            "comment": "Primark, a British fast fashion giant, has been accused of underpaying garment workers in its supply chain, employing undocumented immigrants below minimum wage, and imprisoning workers for participating in protests against Myanmar's military coup [1][2][3]. The company has also faced criticism for promoting sexist messaging on children's clothing and removing ethical branding following investigations into labor violations [2][3].",
            "sources": {
                "1": "https://www.theguardian.com/global-development/2021/mar/13/primark-supplier-accused-of-locking-workers-in-factory-in-myanmar-protests",
                "2": "https://www.theguardian.com/business/2009/jan/11/primark-ethical-business-living",
                "3": "https://www.bbc.co.uk/news/business-60290232"
            },
            "tags": [
                "fast fashion",
                "clothing",
                "retail",
                "poor working conditions",
                "forced labour",
                "anti-union practices",
                "gender discrimination",
                "unfair pay",
                "deception"
            ],
            "score": 10,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/99/Primark_Stores_Logo.svg",
            "siteUrl": "http://primark.com/",
            "updatedAt": "2024-03-16T08:22:52.479Z",
            "key": "primark"
        },
        "tk-maxx": {
            "names": [
                "TK Maxx",
                "TJ Maxx",
                "HomeGoods",
                "HomeSense",
                "TJX",
                "TJX Companies",
                "T.K. Maxx",
                "T.K.maxx"
            ],
            "comment": "TK Maxx, a major retailer, has been found selling real fur from animals like rabbits, foxes and mink that was mislabeled as \"faux fur\", despite claiming to have a no-fur policy [1]. Along with other fashion brands like Boohoo, Amazon and Missguided, TK Maxx has also been called out by UK MPs for failing to take sufficient action on sustainability and ethical labor practices in its supply chain [2].",
            "sources": {
                "1": "https://news.sky.com/story/more-retailers-selling-real-fur-labelled-as-fake-sky-news-investigation-finds-11177979",
                "2": "https://www.bbc.co.uk/news/business-47057870"
            },
            "tags": [
                "clothing",
                "retail",
                "animal abuse",
                "unsustainable",
                "deception",
                "unsustainable practices",
                "greenwashing"
            ],
            "score": 45,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/e/e9/TK_Maxx_Logo.svg",
            "siteUrl": "http://www.tkmaxx.com/",
            "updatedAt": "2024-03-16T08:36:24.708Z",
            "key": "tk-maxx"
        },
        "kraft-heinz": {
            "names": [
                "Kraft Heinz",
                "Kraft",
                "KHC"
            ],
            "comment": "Kraft Heinz, one of the world's largest food companies, paid a $62 million fine for creating over $200 million in fake cost savings to mislead investors, violating securities laws [1]. The company has also been criticized by WWF for lagging behind on sustainable palm oil sourcing, a key driver of deforestation and habitat destruction [2].",
            "sources": {
                "1": "https://www.forbes.com/sites/graisondangor/2021/09/03/kraft-heinz-fined-62-million-for-phony-accounting/",
                "2": "https://www.independent.co.uk/climate-change/news/heinz-palm-oil-worst-companies-b1929351.html"
            },
            "tags": [
                "food",
                "unsustainable",
                "deception",
                "environmental violations",
                "unsustainable practices",
                "deforestation"
            ],
            "score": 40,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/55/KraftHeinz.svg",
            "siteUrl": "https://kraftheinzcompany.com/",
            "updatedAt": "2024-03-16T09:11:26.184Z",
            "key": "kraft-heinz"
        },
        "heinz": {
            "names": [
                "Heinz",
                "HNZ"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "food"
            ],
            "score": 40,
            "ownedBy": [
                "kraft-heinz"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/35/H._J._Heinz_Company_-_Logo.svg",
            "siteUrl": "https://www.heinz.com/",
            "updatedAt": "2024-03-16T09:11:26.184Z",
            "key": "heinz"
        },
        "daddies": {
            "names": [
                "Daddies"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "food"
            ],
            "score": 40,
            "ownedBy": [
                "kraft-heinz"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/Daddies_brand_logo.png/120px-Daddies_brand_logo.png.png",
            "siteUrl": "https://kraftheinzcompany.com/",
            "updatedAt": "2024-03-16T09:11:26.184Z",
            "key": "daddies"
        },
        "grey-poupon": {
            "names": [
                "Grey Poupon"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "food"
            ],
            "score": 40,
            "ownedBy": [
                "kraft-heinz"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/e/ea/Grey_poupon_logo.png",
            "siteUrl": "https://greypouponmustard.co.uk/",
            "updatedAt": "2024-03-16T09:11:26.184Z",
            "key": "grey-poupon"
        },
        "hp-sauce": {
            "names": [
                "HP Sauce"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "food"
            ],
            "score": 40,
            "ownedBy": [
                "kraft-heinz"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/8/87/HPsauce.svg",
            "siteUrl": "https://www.hpsauce.co.uk/",
            "updatedAt": "2024-03-16T09:11:26.184Z",
            "key": "hp-sauce"
        },
        "kool-aid": {
            "names": [
                "Kool-Aid"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "beverages"
            ],
            "score": 40,
            "ownedBy": [
                "kraft-heinz"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c0/Kool_aid_brand_logo.png/120px-Kool_aid_brand_logo.png.png",
            "siteUrl": "https://www.koolaid.com/",
            "updatedAt": "2024-03-16T09:11:26.184Z",
            "key": "kool-aid"
        },
        "jell-o": {
            "names": [
                "Jell-O"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "confectionary"
            ],
            "score": 40,
            "ownedBy": [
                "kraft-heinz"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/91/Jell-O_new_logo_%282023%29.svg",
            "siteUrl": "https://www.kraftheinz.com/jello",
            "updatedAt": "2024-03-16T09:11:26.184Z",
            "key": "jell-o"
        },
        "lea-and-perrins": {
            "names": [
                "Lea & Perrins",
                "Worcestershire Sauce"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "food"
            ],
            "score": 40,
            "ownedBy": [
                "kraft-heinz"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Leaandperrins_logo.png/120px-Leaandperrins_logo.png.png",
            "siteUrl": "https://www.kraftheinz.com/",
            "updatedAt": "2024-03-16T09:11:26.184Z",
            "key": "lea-and-perrins"
        },
        "walmart": {
            "names": [
                "Walmart",
                "Massmart",
                "Flipkart",
                "Walmart Inc.",
                "Wal-Mart",
                "WMT"
            ],
            "comment": "Walmart, the world's largest retailer, has been accused of destroying Native American burial grounds [1], violating labor laws by disciplining protesting workers [2], illegally employing minors and denying breaks [3], and fueling the opioid crisis through irresponsible pharmaceutical practices [4].",
            "sources": {
                "1": "https://web.archive.org/web/20070929045815/http://www.anairtn.org/walmart/index.html",
                "2": "https://web.archive.org/web/20131126221724/http://www.latimes.com/business/money/la-fi-mo-nlrb-walmart-20131119,0,1499317.story#axzz2lfbzVSap",
                "3": "https://web.archive.org/web/20070807045544/http://www.corpwatch.org/article.php?id=9649",
                "4": "https://www.nytimes.com/2022/11/15/health/walmart-opioids-settlement.html"
            },
            "tags": [
                "supermarket",
                "retail",
                "poor working conditions",
                "child labour",
                "unsafe working conditions",
                "anti‑union practices"
            ],
            "score": 20,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/ca/Walmart_logo.svg",
            "siteUrl": "https://www.walmart.com/",
            "updatedAt": "2024-03-29T15:10:50.832Z",
            "key": "walmart"
        },
        "asda": {
            "names": [
                "ASDA"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "supermarket",
                "retail"
            ],
            "score": 20,
            "ownedBy": [
                "walmart"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/9/91/Asda_logo.svg",
            "siteUrl": "https://asda.com/",
            "updatedAt": "2024-03-29T15:10:50.832Z",
            "key": "asda"
        },
        "aldi": {
            "names": [
                "ALDI",
                "Aldi"
            ],
            "comment": "Aldi, a German supermarket chain, has cut emissions substantially through renewable energy and efficiency measures [1], but has been accused of systemic wage theft by requiring employees to work unpaid before shifts [2][3]. The company was sued for misclassifying managers to avoid overtime pay [2], and potentially underpaid over 20,000 workers more than $150 million [3].",
            "sources": {
                "1": "https://web.archive.org/web/20190126101154/https://www.treehugger.com/corporate-responsibility/supermarket-cuts-emissions-53-offsets-rest.html",
                "2": "https://www.syracuse.com/business/2019/02/aldi-pays-98-million-in-syracuse-overtime-lawsuit.html",
                "3": "https://www.afr.com/work-and-careers/workplace/aldi-accused-of-150m-deliberate-wage-theft-20231027-p5efni"
            },
            "tags": [
                "supermarket",
                "retail",
                "poor working conditions",
                "unfair pay"
            ],
            "score": 60,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/ALDI_SUD.png/120px-ALDI_SUD.png.png",
            "siteUrl": "http://aldi.com/",
            "updatedAt": "2024-03-29T16:58:43.366Z",
            "key": "aldi"
        },
        "lidl": {
            "names": [
                "Lidl",
                "LIDL",
                "Kaufland"
            ],
            "comment": "Lidl, a German discount supermarket chain, has been accused of extensively spying on employees, recording personal details like menstrual cycles, relationships and finances [1], as well as shutting down stores where employees unionise [2]. The company has also faced allegations of animal cruelty [3], using unethical killing methods on chickens, operating in inhumane conditions, and deceiving consumers about severing ties with an abusive supplier farm.",
            "sources": {
                "1": "https://www.theguardian.com/world/2008/mar/27/germany.supermarkets",
                "2": "https://www.mashed.com/94133/untold-truth-lidl/",
                "3": "https://www.lidlchickenscandal.com/"
            },
            "tags": [
                "supermarket",
                "retail",
                "antiprivacy",
                "poor working conditions",
                "animal abuse",
                "antiunion",
                "anti-union practices",
                "privacy violations",
                "deception"
            ],
            "score": 30,
            "ownedBy": [
                "schwarz-gruppe"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/91/Lidl-Logo.svg",
            "siteUrl": "https://info.lidl/en/",
            "updatedAt": "2024-03-29T16:58:43.366Z",
            "key": "lidl"
        },
        "morrisons": {
            "names": [
                "Morrisons",
                "Wm Morrison Supermarkets Limited"
            ],
            "comment": "Morrisons is a British supermarket chain that awarded millions in executive bonuses despite pandemic-related profit losses by adjusting performance metrics [1], and has been criticized for animal cruelty in its chicken supply chain despite marketing higher welfare standards [2]. Morrisons was ordered to pay compensation against a mother who suffered workplace discrimination [3].",
            "sources": {
                "1": "https://www.theguardian.com/business/2021/jun/10/morrisons-shareholders-reject-executive-bonuses-amid-falling-profits",
                "2": "https://www.retailgazette.co.uk/blog/2021/06/morrisons-under-fire-for-ignoring-animal-suffering-in-supply-chain/",
                "3": "https://www.bbc.co.uk/news/business-63457797"
            },
            "tags": [
                "supermarket",
                "retail",
                "unfair pay",
                "animal abuse",
                "discrimination",
                "greenwashing",
                "gender discrimination",
                "deception"
            ],
            "score": 38,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/8/82/MorrisonsLogo.svg",
            "siteUrl": "https://morrisons.com/",
            "updatedAt": "2024-03-30T10:14:47.798Z",
            "key": "morrisons"
        },
        "mccoll's": {
            "names": [
                "McColl's"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "supermarket",
                "retail"
            ],
            "score": 38,
            "ownedBy": [
                "morrisons"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/f/f4/McColl%27s_logo.svg",
            "siteUrl": "http://www.morrisons.com/mccolls/",
            "updatedAt": "2024-03-30T16:58:30.024Z",
            "key": "mccoll's"
        },
        "burger-king": {
            "names": [
                "Burger King",
                "Burger King Corporation",
                "BK",
                "BKC"
            ],
            "comment": "Burger King is an American fast food chain that has created sexist adverts [1] and is even less sustainable than McDonalds [2].",
            "sources": {
                "1": "https://www.huffingtonpost.co.uk/entry/burger-king-women-belong-in-the-kitchen_n_6046994dc5b6e6abac8214a3",
                "2": "https://d3.harvard.edu/platform-rctom/submission/burger-kings-sustainability-efforts-barely-trying/"
            },
            "tags": [
                "fast food",
                "restaurant",
                "discrimination",
                "unsustainable",
                "gender discrimination",
                "unsustainable practices"
            ],
            "score": 15,
            "ownedBy": [
                "restaurant-brands-international"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/cc/Burger_King_2020.svg",
            "siteUrl": "http://bk.com/",
            "updatedAt": "2024-04-05T20:00:17.127Z",
            "key": "burger-king"
        },
        "costa-coffee": {
            "names": [
                "Costa Coffee",
                "Costa",
                "Costa Limited"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "coffee",
                "beverages"
            ],
            "score": 10,
            "ownedBy": [
                "coca-cola"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/f/fa/Costa_Coffee_logo.svg",
            "siteUrl": "https://costa.co.uk/",
            "updatedAt": "2024-04-05T20:00:17.127Z",
            "key": "costa-coffee"
        },
        "yum!-brands": {
            "names": [
                "Yum! Brands",
                "Yum Brands",
                "Yum! Brands, Inc.",
                "YUM"
            ],
            "comment": "Yum Brands is an American fast food company which owns KFC, Pizza Hut and Taco Bell. Its supply chains have involved mass animal cruelty [1][3] and is the biggest killer of chickens globally [2], it has fired employees for speaking out after being sexually abused [4] and illegally underpaid staff [5].",
            "sources": {
                "1": "https://www.theguardian.com/environment/2020/jul/30/kfc-admits-a-third-of-its-chickens-suffer-painful-inflammation",
                "2": "https://www.independent.co.uk/climate-change/news/kfc-is-cruel-to-chickens-says-animal-rights-group-5534360.html",
                "3": "https://www.worldanimalprotection.org.au/news/kfc-lagging-behind-competitors-chicken-welfare-fast-food-ranking",
                "4": "https://www.bbc.co.uk/news/uk-wales-67360703",
                "5": "https://news.sky.com/story/tesco-and-pizza-hut-named-and-shamed-over-minimum-wage-breaches-12176216"
            },
            "tags": [
                "fast food",
                "animal abuse",
                "sexual harassment",
                "poor working conditions",
                "unfair pay"
            ],
            "score": 20,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/59/Yum%21_Brands_logo.svg",
            "siteUrl": "https://yum.com/",
            "updatedAt": "2024-04-05T22:08:49.415Z",
            "key": "yum!-brands"
        },
        "pizza-hut": {
            "names": [
                "Pizza Hut"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "fast food",
                "pizza"
            ],
            "score": 20,
            "ownedBy": [
                "yum!-brands"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5d/Pizza_Hut_classic_logo.svg/120px-Pizza_Hut_classic_logo.svg.png",
            "siteUrl": "http://pizzahut.com/",
            "updatedAt": "2024-04-05T20:00:17.127Z",
            "key": "pizza-hut"
        },
        "kfc": {
            "names": [
                "KFC"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "fast food"
            ],
            "score": 20,
            "ownedBy": [
                "yum!-brands"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/5/57/KFC_logo-image.svg",
            "siteUrl": "https://kfc.com/",
            "updatedAt": "2024-04-05T20:00:17.127Z",
            "key": "kfc"
        },
        "taco-bell": {
            "names": [
                "Taco Bell"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "fast food"
            ],
            "score": 20,
            "ownedBy": [
                "yum!-brands"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/b/b3/Taco_Bell_2016.svg",
            "siteUrl": "https://tacobell.com/",
            "updatedAt": "2024-04-05T20:00:17.127Z",
            "key": "taco-bell"
        },
        "krispy-kreme": {
            "names": [
                "Krispy Kreme",
                "Krispy Kreme, Inc.",
                "Krispy Kreme Doughnuts, Inc.",
                "DNUT"
            ],
            "comment": "Krispy Kreme is an American doughnut company whose executives manipulated earnings reports and engaged in misleading practices for personal gain [1]. The company has also failed to comply with environmental regulations, avoiding costs for packaging waste recovery and recycle notes [2].",
            "sources": {
                "1": "https://marketrealist.com/p/krispy-kreme-accounting-scandal/",
                "2": "https://www.packagingnews.co.uk/news/doughnut-giant-fined-for-not-recycling-packaging-18-03-2011"
            },
            "tags": [
                "confectionary",
                "food",
                "deception",
                "environmental violations",
                "unsustainable practices",
                "corruption"
            ],
            "score": 45,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/8b/Logo.KrispyKreme.svg",
            "siteUrl": "http://krispykreme.com/",
            "updatedAt": "2024-04-07T14:42:36.411Z",
            "key": "krispy-kreme"
        },
        "nando's": {
            "names": [
                "Nando's",
                "Nandos"
            ],
            "comment": "Nandos is a South African restaurant chain whose supply chain has contained abhorrent animal cruelty [1][2] and whose advertising campaigns have taken advantage of imprisoned refugees on hunger strike [3].",
            "sources": {
                "1": "https://www.independent.co.uk/news/uk/home-news/lidl-nando-chicken-supplier-taunton-somerset-farm-deformed-birds-die-slowly-animal-rights-a7872226.html",
                "2": "https://www.dailymail.co.uk/news/article-7513231/Nandos-accused-using-chickens-farms-thousands-birds-kept-cramped-conditions.html",
                "3": "http://www.theage.com.au/articles/2002/07/28/1027818485483.html"
            },
            "tags": [
                "restaurant",
                "food",
                "animal abuse",
                "deception"
            ],
            "score": 35,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/c/c5/Nandos_logo.svg",
            "siteUrl": "http://www.nandos.com/",
            "updatedAt": "2024-04-07T15:46:15.962Z",
            "key": "nando's"
        },
        "domino's": {
            "names": [
                "Domino's",
                "Domino's Pizza, Inc.",
                "DPZ"
            ],
            "comment": "Domino's is an American pizza brand that has been accused of exploiting workers [1].",
            "sources": {
                "1": "https://www.smh.com.au/interactive/2017/the-dominos-effect/"
            },
            "tags": [
                "fast food",
                "restaurant",
                "poor working conditions",
                "unfair pay"
            ],
            "score": 45,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/8b/DominosPizza.svg",
            "siteUrl": "https://dominos.com/",
            "updatedAt": "2024-04-07T14:42:36.411Z",
            "key": "domino's"
        },
        "pizzaexpress": {
            "names": [
                "PizzaExpress",
                "Pizza Express",
                "PizzaExpress (Restaurants) Limited",
                "Pizza Marzano"
            ],
            "comment": "PizzaExpress is a British restaurant chain that has taken money from customer tips to supplement wages, reducing the amount going to waiting staff [1][2]. The company also fired staff during the pandemic when enployees were most vulnerable, before rehiring on worse contracts [2].",
            "sources": {
                "1": "https://www.independent.co.uk/news/uk/home-news/revealed-how-the-restaurant-chains-pocket-your-tips-867634.html",
                "2": "https://www.socialistpartyni.org/analysis-news/britain/rights-wages-of-pizza-express-workers-sliced-and-burned/"
            },
            "tags": [
                "restaurant",
                "food",
                "poor working conditions",
                "unfair pay"
            ],
            "score": 46,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Pizzaexpress.jpg/120px-Pizzaexpress.jpg.png",
            "siteUrl": "https://pizzaexpress.com/",
            "updatedAt": "2024-04-07T08:36:54.559Z",
            "key": "pizzaexpress"
        },
        "volkswagen": {
            "names": [
                "Volkswagen",
                "Volkswagen Group",
                "Volkswagen AG",
                "VW",
                "VOW"
            ],
            "comment": "Volkswagen is a German car manufacturer that illegally cheated in its vehicles' emissions tests, lying about their environmental performance to boost its profits [1][2].",
            "sources": {
                "1": "https://www.bbc.com/news/business-34324772",
                "2": "https://www.justice.gov/opa/pr/volkswagen-ag-agrees-plead-guilty-and-pay-43-billion-criminal-and-civil-penalties-six"
            },
            "tags": [
                "cars",
                "emissions cheating",
                "deception",
                "environmental violations",
                "greenwashing",
                "unsustainable practices"
            ],
            "score": 35,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/6d/Volkswagen_logo_2019.svg",
            "siteUrl": "https://www.volkswagen.com/",
            "updatedAt": "2024-04-16T17:45:46.620Z",
            "key": "volkswagen"
        },
        "audi": {
            "names": [
                "Audi",
                "Audi AG"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "cars"
            ],
            "score": 35,
            "ownedBy": [
                "volkswagen"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/92/Audi-Logo_2016.svg",
            "siteUrl": "https://www.audi.com/en.html",
            "updatedAt": "2024-04-16T17:45:46.620Z",
            "key": "audi"
        },
        "bentley": {
            "names": [
                "Bentley",
                "Bentley Motors Limited",
                "Bentley Motors"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "cars"
            ],
            "score": 35,
            "ownedBy": [
                "volkswagen"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/e/e4/Bentley_logo_2.svg",
            "siteUrl": "http://bentleymotors.com/",
            "updatedAt": "2024-04-16T17:45:46.620Z",
            "key": "bentley"
        },
        "ducati": {
            "names": [
                "Ducati"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "motorcycles"
            ],
            "score": 35,
            "ownedBy": [
                "volkswagen"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/36/Ducati_red_logo.svg",
            "siteUrl": "https://www.ducati.com/",
            "updatedAt": "2024-04-16T17:45:46.620Z",
            "key": "ducati"
        },
        "cupra": {
            "names": [
                "Cupra",
                "SEAT Cupra S.A.U."
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "cars"
            ],
            "score": 35,
            "ownedBy": [
                "volkswagen"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/70/Cupra.svg",
            "siteUrl": "http://www.cupraofficial.com/",
            "updatedAt": "2024-04-16T17:45:46.620Z",
            "key": "cupra"
        },
        "lamborghini": {
            "names": [
                "Lamborghini",
                "Automobili Lamborghini S.p.A."
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "cars"
            ],
            "score": 35,
            "ownedBy": [
                "volkswagen"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/thumb/d/df/Lamborghini_Logo.svg/500px-Lamborghini_Logo.svg.png",
            "siteUrl": "http://lamborghini.com/en-en/",
            "updatedAt": "2024-04-16T17:45:46.620Z",
            "key": "lamborghini"
        },
        "porsche": {
            "names": [
                "Porsche",
                "Dr. Ing. h.c. F. Porsche AG",
                "Porsche Automobil Holding SE",
                "Porsche SE"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "cars"
            ],
            "score": 35,
            "ownedBy": [
                "volkswagen"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/8/8c/Porsche_logo.svg",
            "siteUrl": "https://www.porsche.com/",
            "updatedAt": "2024-04-16T17:45:46.620Z",
            "key": "porsche"
        },
        "seat": {
            "names": [
                "SEAT",
                "SEAT S.A."
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "cars"
            ],
            "score": 35,
            "ownedBy": [
                "volkswagen"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/7e/SEAT_S.A._logo.svg",
            "siteUrl": "http://www.seat.com/",
            "updatedAt": "2024-04-16T17:45:46.620Z",
            "key": "seat"
        },
        "skoda": {
            "names": [
                "Škoda",
                "Skoda",
                "Škoda Auto",
                "Škoda Auto a.s."
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "cars"
            ],
            "score": 35,
            "ownedBy": [
                "volkswagen"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/%C5%A0koda_nieuw.png/120px-%C5%A0koda_nieuw.png.png",
            "siteUrl": "http://skoda-auto.com/",
            "updatedAt": "2024-04-16T17:45:46.620Z",
            "key": "skoda"
        },
        "toyota": {
            "names": [
                "Toyota",
                "Toyota Motor Corporation",
                "トヨタ自動車株式会社",
                "Toyota Group",
                "トヨタグループ",
                "TYT",
                "TM"
            ],
            "comment": "Toyota is a Japanese automaker that has faced various ethical issues, including the death of an employee from overwork [1], a $180 million settlement for violating environmental standards [2], rigging vehicles to perform better in crash tests [3], and cheating in emissions testing [4].",
            "sources": {
                "1": "http://www.japantimes.co.jp/news/2007/12/01/national/nagoya-court-rules-toyota-employee-died-from-overwork/",
                "2": "https://web.archive.org/web/20210114205251/https://www.nytimes.com/2021/01/14/climate/toyota-emissions-fine.html",
                "3": "https://www.motor1.com/news/664748/toyota-admits-daihatsu-side-crash-tests-rigged/",
                "4": "https://apnews.com/article/japan-toyota-auto-daihatsu-scandal-bdfec73ce59ab336bc6ff1502ac3db46"
            },
            "tags": [
                "cars",
                "poor working conditions",
                "emissions cheating",
                "unsustainable",
                "unsafe working conditions",
                "deception",
                "environmental violations",
                "unsafe practices",
                "greenwashing"
            ],
            "score": 35,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/e/e7/Toyota.svg",
            "siteUrl": "https://global.toyota/",
            "updatedAt": "2024-04-17T07:45:08.623Z",
            "key": "toyota"
        },
        "lexus": {
            "names": [
                "Lexus",
                "レクサス"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "cars"
            ],
            "score": 35,
            "ownedBy": [
                "toyota"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/d1/Lexus_division_emblem.svg",
            "siteUrl": "https://discoverlexus.com/lexus-in-your-region",
            "updatedAt": "2024-04-17T17:41:12.162Z",
            "key": "lexus"
        },
        "stellantis": {
            "names": [
                "Stellantis",
                "Stellantis N.V."
            ],
            "comment": "Stellantis is a multinational car conglomerate that cheated on emissions tests, resulting in a $300 million fine [1].",
            "sources": {
                "1": "https://edition.cnn.com/2022/06/03/business/stellantis-us-guilty-diesel-emissions/index.html"
            },
            "tags": [
                "cars",
                "emissions cheating",
                "deception",
                "environmental violations"
            ],
            "score": 38,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/d/dd/Stellantis.svg",
            "siteUrl": "https://www.stellantis.com/",
            "updatedAt": "2024-04-17T17:41:12.162Z",
            "key": "stellantis"
        },
        "abarth": {
            "names": [
                "Abarth",
                "Abarth & C. S.p.A."
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "cars"
            ],
            "score": 38,
            "ownedBy": [
                "stellantis"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/c/cd/New_Fiat_Abarth_Logo.png",
            "siteUrl": "https://www.abarth.com/",
            "updatedAt": "2024-04-17T17:41:12.162Z",
            "key": "abarth"
        },
        "alfa-romeo": {
            "names": [
                "Alfa Romeo",
                "Alfa Romeo Automobiles S.p.A."
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "cars"
            ],
            "score": 38,
            "ownedBy": [
                "stellantis"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/2/2a/Alfa_Romeo_logo.png",
            "siteUrl": "https://www.alfaromeo.com/",
            "updatedAt": "2024-04-17T21:14:18.762Z",
            "key": "alfa-romeo"
        },
        "chrysler": {
            "names": [
                "Chrysler",
                "Chrysler Corporation"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "cars"
            ],
            "score": 38,
            "ownedBy": [
                "stellantis"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/d/dd/Stellantis.svg",
            "siteUrl": "https://media.stellantisnorthamerica.com/",
            "updatedAt": "2024-04-17T21:14:18.762Z",
            "key": "chrysler"
        },
        "citroen": {
            "names": [
                "Citroën",
                "Citroen"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "cars"
            ],
            "score": 38,
            "ownedBy": [
                "stellantis"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/d/dd/Citroen_2022.svg",
            "siteUrl": "http://citroen.com/en",
            "updatedAt": "2024-04-17T21:14:18.762Z",
            "key": "citroen"
        },
        "dodge": {
            "names": [
                "Dodge"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "cars"
            ],
            "score": 38,
            "ownedBy": [
                "stellantis"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/bb/Dodge_black_logo.svg",
            "siteUrl": "https://www.dodge.com/",
            "updatedAt": "2024-04-17T21:14:18.762Z",
            "key": "dodge"
        },
        "ds-automobiles": {
            "names": [
                "DS Automobiles",
                "DS"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "cars"
            ],
            "score": 38,
            "ownedBy": [
                "stellantis"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/9/90/DS_Automobiles_logo.svg",
            "siteUrl": "https://www.dsautomobiles.com/en/home.html",
            "updatedAt": "2024-04-17T21:14:18.762Z",
            "key": "ds-automobiles"
        },
        "fiat": {
            "names": [
                "Fiat",
                "Fiat Automobiles S.p.A."
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "cars"
            ],
            "score": 38,
            "ownedBy": [
                "stellantis"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/b5/FIAT_logo_%282020%29.svg",
            "siteUrl": "https://www.fiat.com/",
            "updatedAt": "2024-04-17T21:14:18.762Z",
            "key": "fiat"
        },
        "jeep": {
            "names": [
                "Jeep"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "cars"
            ],
            "score": 38,
            "ownedBy": [
                "stellantis"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/92/Jeep_wordmark.svg",
            "siteUrl": "https://www.jeep.com/",
            "updatedAt": "2024-04-17T21:14:18.762Z",
            "key": "jeep"
        },
        "lancia": {
            "names": [
                "Lancia"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "cars"
            ],
            "score": 38,
            "ownedBy": [
                "stellantis"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/e/ed/Lancia_Logo_2023.svg",
            "siteUrl": "https://www.lancia.com/",
            "updatedAt": "2024-04-17T21:14:18.762Z",
            "key": "lancia"
        },
        "maserati": {
            "names": [
                "Maserati"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "cars"
            ],
            "score": 38,
            "ownedBy": [
                "stellantis"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/78/Maserati_logo_2.svg",
            "siteUrl": "http://www.maserati.com/",
            "updatedAt": "2024-04-17T21:14:18.762Z",
            "key": "maserati"
        },
        "peugeot": {
            "names": [
                "Peugeot"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "cars"
            ],
            "score": 38,
            "ownedBy": [
                "stellantis"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f7/Peugeot_Logo.svg/120px-Peugeot_Logo.svg.png",
            "siteUrl": "https://www.peugeot.com/en/",
            "updatedAt": "2024-04-17T21:14:18.762Z",
            "key": "peugeot"
        },
        "vauxhall": {
            "names": [
                "Vauxhall",
                "Vauxhall Motors",
                "Vauxhall Motors Limited"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "cars"
            ],
            "score": 38,
            "ownedBy": [
                "stellantis"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/1/18/Vauxhall_logo_2019.svg",
            "siteUrl": "https://vauxhall.co.uk/",
            "updatedAt": "2024-04-17T21:14:18.762Z",
            "key": "vauxhall"
        },
        "mercedes-benz": {
            "names": [
                "Mercedes-Benz",
                "Mercedes-Benz AG",
                "Mercedes-Benz Group",
                "Mercedes-Benz Group AG",
                "Daimler-Benz",
                "MBG"
            ],
            "comment": "Mercedez-Benz is a German car company that has been fined $1 billion for illegally cheating on vehicle emissions tests [1].",
            "sources": {
                "1": "https://www.theverge.com/2019/9/24/20881603/daimler-dieselgate-mercedes-benz-emissions-cheating-fine"
            },
            "tags": [
                "cars",
                "emissions cheating",
                "environmental violations",
                "deception"
            ],
            "score": 40,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/e/e1/Mercedes-Benz_Group_black.svg",
            "siteUrl": "http://group.mercedes-benz.com/",
            "updatedAt": "2024-04-17T21:14:18.762Z",
            "key": "mercedes-benz"
        },
        "honda": {
            "names": [
                "Honda",
                "Honda Motor Co., Ltd.",
                "本田技研工業株式会社",
                "HMC"
            ],
            "comment": "Honda is a Japanese automobile manufacturer whise executives stole millions through bribes and fraud [1], has sold cars with defective airbags [3], and has settled the largest Clean Air Act violation in history by paying $267 million for selling vehicles with disabled emission control systems [3].",
            "sources": {
                "1": "https://www.independent.co.uk/news/business/us-bribe-scandal-rocks-honda-former-car-company-executives-accused-of-dollars-10m-fraud-spanning-14-years-1429462.html",
                "2": "https://consent.yahoo.com/v2/collectConsent?sessionId=3_cc-session_a61f87ce-6924-4aca-ac4e-bf3234cbbe45",
                "3": "https://www.epa.gov/enforcement/american-honda-motor-company-clean-air-act-settlement"
            },
            "tags": [
                "cars",
                "unsafe working conditions",
                "emissions cheating",
                "corruption",
                "deception",
                "environmental violations",
                "unsafe practices"
            ],
            "score": 38,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/76/Honda_logo.svg",
            "siteUrl": "https://global.honda/",
            "updatedAt": "2024-04-17T21:14:18.762Z",
            "key": "honda"
        },
        "nissan": {
            "names": [
                "Nissan",
                "Nissan Motor Co. Ltd.",
                "日産自動車株式会社",
                "TYO",
                "TOPIX"
            ],
            "comment": "Nissan is a Japanese automaker embroiled in scandals, including a high-profile case of financial misconduct by its former chairman Carlos Ghosn, who was accused of hiding $79 million in earnings and fleeing Japan while under house arrest [1], as well as using cheat devices to manipulate emissions tests in South Korea and falsifying data in Japanese factories [2][3].",
            "sources": {
                "1": "https://auto.hindustantimes.com/auto/cars/nissan-scandal-tokyo-court-determines-carlos-ghosn-main-culprit-41646614640853.html",
                "2": "https://www.autocar.co.uk/car-news/business/nissan-found-guilty-using-diesel-emissions-cheat-device-south-korea",
                "3": "https://www.bbc.co.uk/news/business-44763905"
            },
            "tags": [
                "cars",
                "emissions cheating",
                "corruption",
                "deception",
                "environmental violations"
            ],
            "score": 37,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/bb/Nissan_Motor_Corporation_2020_logo-local_file.svg",
            "siteUrl": "https://www.nissan-global.com/",
            "updatedAt": "2024-04-19T07:30:48.152Z",
            "key": "nissan"
        },
        "hyundai": {
            "names": [
                "Hyundai",
                "Hyundai Motor Company",
                "Hyundai Motors"
            ],
            "comment": "Hyundai is a South Korean car manufacturer that falsely claimed its vehicles were more fuel-efficient than they were [1], illegally employed child refugees in their US factories [2], and published an advert that depucted suicide [3]. Hyundai also sold vehicles that cheated on emission tests [4].",
            "sources": {
                "1": "https://web.archive.org/web/20121205051247/http://www.forbes.com/sites/jimgorzelany/2012/11/02/epa-slams-hyundai-and-kia-for-overestimating-mpg/",
                "2": "https://www.reuters.com/world/us/how-fake-id-repeatedly-enabled-hyundai-suppliers-employ-child-labor-alabama-2023-04-27/",
                "3": "https://web.archive.org/web/20160401175224/http://adage.com/article/news/hyundai-apologizes-u-k-ad-depicts-suicide-attempt/241119/",
                "4": "https://cleantechnica.com/2022/07/04/another-diesel-cheating-scandal-this-time-its-hyundai-kia/"
            },
            "tags": [
                "cars",
                "emissions cheating",
                "child labour",
                "deception",
                "environmental violations",
                "unsafe practices",
                "greenwashing",
                "unsustainable practices"
            ],
            "score": 35,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/78/Hyundai_Motor_Group_CI.svg",
            "siteUrl": "http://hyundaimotorgroup.com/",
            "updatedAt": "2024-04-19T07:30:48.152Z",
            "key": "hyundai"
        },
        "kia": {
            "names": [
                "Kia",
                "Kia Corporation",
                "기아",
                "Kyungsung Precision Industry",
                "Kia Motors Corporation",
                "KRX"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "cars"
            ],
            "score": 35,
            "ownedBy": [
                "hyundai"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/b6/KIA_logo3.svg",
            "siteUrl": "https://kia.com/",
            "updatedAt": "2024-04-19T07:30:48.152Z",
            "key": "kia"
        },
        "renault": {
            "names": [
                "Renault",
                "Groupe Renault",
                "Renault Group",
                "Renault S.A.",
                "RNO",
                "CAC"
            ],
            "comment": "Renault is a French automaker that has faced criticism for its decision to continue operating in Russia despite the country's invasion of Ukraine, with Ukrainian President Volodymyr Zelensky calling on the company to leave the Russian market [1]. Renault has also been charged with deception after its vehicles were found to be cheating in emissions tests [2].",
            "sources": {
                "1": "https://www.france24.com/en/europe/20220323-ukraine-s-zelensky-shames-french-companies-still-operating-in-russia-calls-on-them-to-leave",
                "2": "https://www.reuters.com/business/autos-transportation/frances-renault-charged-with-deception-over-dieselgate-probe-2021-06-08/"
            },
            "tags": [
                "cars",
                "russia",
                "emissions cheating",
                "connections to russia",
                "deception",
                "environmental violations"
            ],
            "score": 35,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/09/2021_Renault_Group_logo.svg",
            "siteUrl": "https://www.renaultgroup.com/en/",
            "updatedAt": "2024-04-19T15:34:09.496Z",
            "key": "renault"
        },
        "dacia": {
            "names": [
                "Dacia",
                "Automobile Dacia",
                "S.C. Automobile Dacia S.A."
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "cars"
            ],
            "score": 35,
            "ownedBy": [
                "renault"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/41/Dacia-Logo-2021.svg",
            "siteUrl": "http://dacia.ro/",
            "updatedAt": "2024-04-19T15:56:44.496Z",
            "key": "dacia"
        },
        "volvo": {
            "names": [
                "Volvo",
                "Volvo Cars",
                "VOLV"
            ],
            "comment": "Volvo is a Swedish automaker that has pledged to build greener cars in the future, but has been accused of installing \"cheat devices\" in its diesel vehicles to manipulate emissions tests, resulting in harmful NOx emissions exceeding legal limits [1]. The company's diesel models have been found to emit toxic fumes, affecting up to 320,000 vehicles on UK roads, and it is now facing a legal claim from affected owners, contradicting its reputation for trusted and reliable vehicles [1].",
            "sources": {
                "1": "https://www.leighday.co.uk/news/news/2021-news/volvo-faces-legal-claim-over-toxic-emissions-from-diesel-vehicles/"
            },
            "tags": [
                "cars",
                "emissions cheating",
                "deception",
                "environmental violations",
                "greenwashing",
                "unsustainable practices",
                "fossil fuels",
                "unsafe practices"
            ],
            "score": 26,
            "ownedBy": [
                "geely"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/cd/Volvo-Spread-Word-Mark-Black.svg",
            "siteUrl": "https://www.volvogroup.com/",
            "updatedAt": "2024-04-19T15:56:44.496Z",
            "key": "volvo"
        },
        "polestar": {
            "names": [
                "Polestar",
                "PSNY"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "cars"
            ],
            "score": 26,
            "ownedBy": [
                "geely"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/f/f0/Polestar_Logo.svg",
            "siteUrl": "https://www.polestar.com/uk/",
            "updatedAt": "2024-04-19T16:31:06.067Z",
            "key": "polestar"
        },
        "suzuki": {
            "names": [
                "Suzuki",
                "Suzuki Motor Corporation",
                "スズキ株式会社"
            ],
            "comment": "Suzuki is a Japanese car manufacturer that has been caught cheating on its vehicles' emissions tests [1] and inflating fuel economy numbers [2].",
            "sources": {
                "1": "https://www.reuters.com/business/autos-transportation/german-prosecutors-mount-raids-over-suzuki-cars-alleged-test-dodging-2022-04-27/",
                "2": "https://uk.finance.yahoo.com/news/suzuki-suspected-using-improper-fuel-033613366.html?guccounter=1"
            },
            "tags": [
                "cars",
                "emissions cheating",
                "deception",
                "environmental violations"
            ],
            "score": 40,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/12/Suzuki_logo_2.svg",
            "siteUrl": "http://www.globalsuzuki.com/",
            "updatedAt": "2024-04-19T16:31:06.067Z",
            "key": "suzuki"
        },
        "mazda": {
            "names": [
                "Mazda",
                "Mazda Motor Corporation",
                "マツダ株式会社"
            ],
            "comment": "Mazda is a Japanese car company that has been implicated in faking emissions tests [1].",
            "sources": {
                "1": "https://asia.nikkei.com/Business/Companies/Suzuki-and-Mazda-admit-faking-emissions-tests"
            },
            "tags": [
                "cars",
                "emissions cheating",
                "deception",
                "environmental violations"
            ],
            "score": 30,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/1/18/Mazda_logo_with_emblem.svg",
            "siteUrl": "https://www.mazda.com/",
            "updatedAt": "2024-04-19T16:31:06.067Z",
            "key": "mazda"
        },
        "jaguar-land-rover": {
            "names": [
                "Jaguar Land Rover",
                "JLR",
                "Jaguar",
                "Land Rover",
                "Range Rover"
            ],
            "comment": "Jaguar Land Rover is a British luxury car manufacturer that is accused of fitting emissions cheat devices to its diesel vehicles, deceiving owners and contributing to excessive NOx emissions and climate harm [1], and has recalled over 44,000 cars for producing excessive CO2 emissions, requiring software updates and repairs [2].",
            "sources": {
                "1": "https://www.leighday.co.uk/news/news/2021-news/jaguar-land-rover-latest-manufacturer-to-face-claims-for-emissions-cheat-device/",
                "2": "https://www.which.co.uk/news/article/jaguar-and-land-rover-cars-recalled-for-excessive-co2-emissions-aN2wQ5I139PU"
            },
            "tags": [
                "cars",
                "emissions cheating",
                "deception",
                "environmental violations",
                "unsustainable practices",
                "fossil fuels"
            ],
            "score": 40,
            "ownedBy": [
                "tata"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/6f/Jaguar_Land_Rover_logo_2023.svg",
            "siteUrl": "https://www.jaguarlandrover.com/",
            "updatedAt": "2024-04-19T22:32:22.251Z",
            "key": "jaguar-land-rover"
        },
        "mitsubishi": {
            "names": [
                "Mitsubishi",
                "Mitsubishi Group",
                "Mitsubishi Motors",
                "Mitsubishi Motors Corporation",
                "三菱自動車工業株式会社"
            ],
            "comment": "Mitsubishi is a Japanese conglomerate. Mitubishi has lied about its vehicles' fuel efficiency for 25 years [1].",
            "sources": {
                "1": "https://money.cnn.com/2016/04/26/news/companies/mitsubishi-cheating-fuel-tests-25-years/index.html"
            },
            "tags": [
                "cars",
                "deception",
                "greenwashing"
            ],
            "score": 35,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/5a/Mitsubishi_logo.svg",
            "siteUrl": "https://www.mitsubishi.com/en/",
            "updatedAt": "2024-04-19T22:32:22.251Z",
            "key": "mitsubishi"
        },
        "general-motors": {
            "names": [
                "General Motors",
                "GM",
                "General Motors Company",
                "General Motors Corporation"
            ],
            "comment": "General Motors is an American car manufacturer that provided services to perpetuate the Apartheid in South Africa [1], has benefitted from Uyghur forced labour [2], and sold cars with faulty ignition switches which have led to 13 deaths [3].",
            "sources": {
                "1": "https://www.reuters.com/article/safrica-apartheid-gm-idCNL5E8E11YJ20120301",
                "2": "https://web.archive.org/web/20200824215335/https://www.aspi.org.au/report/uyghurs-sale",
                "3": "https://www.vox.com/2014/10/3/18073458/gm-car-recall"
            },
            "tags": [
                "cars",
                "forced labour",
                "unsafe working conditions",
                "racial discrimination",
                "forced uyghur labour",
                "unsafe practices"
            ],
            "score": 15,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/e/ea/General_Motors_%28logo_with_wordmark%2C_horizontal%29.svg",
            "siteUrl": "https://gm.com/",
            "updatedAt": "2024-04-20T08:18:44.669Z",
            "key": "general-motors"
        },
        "buick": {
            "names": [
                "Buick",
                "Buick Motor Company"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "cars"
            ],
            "score": 15,
            "ownedBy": [
                "general-motors"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/2/2f/Buick_logo_2023.svg",
            "siteUrl": "https://www.buick.com/",
            "updatedAt": "2024-04-20T08:18:44.669Z",
            "key": "buick"
        },
        "cadillac": {
            "names": [
                "Cadillac",
                "Cadillac Motor Car Division"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "cars"
            ],
            "score": 15,
            "ownedBy": [
                "general-motors"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/43/Cadillac_simple_logo.svg",
            "siteUrl": "https://www.cadillac.com/",
            "updatedAt": "2024-04-20T08:18:44.669Z",
            "key": "cadillac"
        },
        "chevrolet": {
            "names": [
                "Chevrolet",
                "Chevy",
                "Chevrolet Motor Company"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "cars"
            ],
            "score": 15,
            "ownedBy": [
                "general-motors"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/b/bd/Chevrolet_%28logo%29.svg",
            "siteUrl": "https://www.chevrolet.com/",
            "updatedAt": "2024-04-20T08:18:44.669Z",
            "key": "chevrolet"
        },
        "gmc": {
            "names": [
                "GMC",
                "General Motors Truck Company"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "cars"
            ],
            "score": 15,
            "ownedBy": [
                "general-motors"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f9/GMC-Logo_2.svg/120px-GMC-Logo_2.svg.png",
            "siteUrl": "https://www.gmc.com/",
            "updatedAt": "2024-04-20T08:18:44.669Z",
            "key": "gmc"
        },
        "uber": {
            "names": [
                "Uber",
                "Uber Technologies, Inc."
            ],
            "comment": "Uber is an American tech company that refuses to provide standard employee protections to its drivers [1], misled drivers about potential earnings [4], underpaid its drivers [5], and has had a culture of workplace sexual harassment [2][3]. Uber has avoided taxes using offshore companies [6], has discriminated against disabled passengers [7], and has conducted invasive surveillance on its passengers' journey data [8].",
            "sources": {
                "1": "https://web.archive.org/web/20211031160651/https://www.theguardian.com/business/2021/aug/27/gig-workers-massachusetts-lawsuit-independent-contractor-status",
                "2": "https://web.archive.org/web/20170607072309/https://www.theguardian.com/technology/2017/jun/06/uber-fires-employees-sexual-harassment-investigation",
                "3": "https://web.archive.org/web/20180909191906/https://money.cnn.com/2018/08/21/technology/uber-settlement/index.html",
                "4": "https://www.reuters.com/article/us-uber-ftc/uber-to-pay-20-million-to-settle-u-s-claims-it-misled-drivers-idUSKBN15334C",
                "5": "https://web.archive.org/web/20190109121055/https://www.theguardian.com/technology/2017/may/23/uber-underpaid-drivers-new-york-city",
                "6": "https://web.archive.org/web/20180808002415/https://www.dw.com/en/paradise-papers-expose-tax-schemes-of-global-elite/a-41246087",
                "7": "https://www.cnn.com/2021/04/02/business/uber-blind-passenger-arbitration-trnd/index.html",
                "8": "https://web.archive.org/web/20120729043726/http://blog.uber.com/2012/03/26/uberdata-the-ride-of-glory/"
            },
            "tags": [
                "tech",
                "transport",
                "poor working conditions",
                "sexual harassment",
                "antiprivacy",
                "tax avoidance",
                "deception",
                "unfair pay",
                "privacy violations",
                "unsafe working conditions"
            ],
            "score": 30,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/58/Uber_logo_2018.svg",
            "siteUrl": "https://uber.com/",
            "updatedAt": "2024-04-20T08:48:25.117Z",
            "key": "uber"
        },
        "disney": {
            "names": [
                "Disney",
                "The Walt Disney Company",
                "Walt Disney Studio",
                "Walt Disney",
                "DSNY"
            ],
            "comment": "Disney is an American media conglomerate whose factories have inflicted inhumane working conditions on employees [1], has plagarised from independent creators [2], has filmed in the Xinjang region where human rights abuses are taking place [3], and has stolen the likeness of extras in its films to use for AI character synthesis [4]. Disney has covered up sexual harassment it enabled executives to commit [5] and underpaid female employees [6], and owned the studio Harvey Weinstein was working for when he sexually assaulted multiple women [7].",
            "sources": {
                "1": "https://issuu.com/iglhr/docs/1212_dream_international_toys_china_408b569c59015f",
                "2": "https://www.ew.com/article/2015/06/25/disney-frozen-lawsuit-the-snowman-settlement/",
                "3": "https://www.bbc.com/news/world-54064654",
                "4": "https://screenrant.com/prom-pact-movie-background-actors-digital-scans-clip/",
                "5": "https://www.hollywoodreporter.com/business/business-news/disney-employee-sues-alleged-cover-up-of-sexual-assault-1235779014/#!",
                "6": "https://www.theguardian.com/us-news/2023/jun/30/disney-female-employees-wage-disparity-lawsuit",
                "7": "https://www.huffingtonpost.co.uk/entry/disney-harvey-weinstein_n_59f8a894e4b00c6145e1e72b"
            },
            "tags": [
                "media",
                "entertainment",
                "forced labour",
                "sexual harassment",
                "poor working conditions",
                "unfair pay",
                "gender discrimination",
                "privacy violations",
                "unsafe working conditions"
            ],
            "score": 20,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/f/fe/Disney_Experiences_logo.svg",
            "siteUrl": "http://thewaltdisneycompany.com/",
            "updatedAt": "2024-04-20T08:48:25.117Z",
            "key": "disney"
        },
        "next": {
            "names": [
                "Next",
                "Next plc",
                "NEXT",
                "J Hepworth & Son",
                "NXT"
            ],
            "comment": "Next is a British home & clothing retailer that makes use of forced Uyghur labour [1], failed to pay employees a living wage [2][3] and destroyed evidence in an equal pay claim case [4].",
            "sources": {
                "1": "https://www.shu.ac.uk/-/media/home/research/helena-kennedy-centre/projects/eu-apparel/eu-tailoring-responsibility-february-24.pdf",
                "2": "http://www.thetimes.co.uk/tto/opinion/columnists/article4226577.ece",
                "3": "https://www.bbc.co.uk/news/uk-england-leicestershire-27431336",
                "4": "https://www.theguardian.com/business/2020/oct/21/next-accused-of-destroying-documents-in-equal-pay-claim"
            },
            "tags": [
                "clothing",
                "retail",
                "forced uyghur labour",
                "unfair pay"
            ],
            "score": 44,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/c/c2/Next_plc_Logo.svg",
            "siteUrl": "https://www.next.co.uk/",
            "updatedAt": "2024-04-28T14:14:56.468Z",
            "key": "next"
        },
        "joules": {
            "names": [
                "Joules"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "clothing",
                "retail"
            ],
            "score": 44,
            "ownedBy": [
                "next"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/dc/Joules_UK_logo.jpg",
            "siteUrl": "https://www.joules.com/",
            "updatedAt": "2024-04-28T20:20:17.185Z",
            "key": "joules"
        },
        "cath-kidston": {
            "names": [
                "Cath Kidston"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "clothing",
                "retail"
            ],
            "score": 44,
            "ownedBy": [
                "next"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f5/Cath_Kidston_london_logo.png/120px-Cath_Kidston_london_logo.png.png",
            "siteUrl": "http://www.cathkidston.co.uk/",
            "updatedAt": "2024-04-28T20:20:17.185Z",
            "key": "cath-kidston"
        },
        "made.com": {
            "names": [
                "Made.com",
                "made.com",
                "made",
                "MADE"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "retail"
            ],
            "score": 44,
            "ownedBy": [
                "next"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/8/8b/MADE.COM_Logo.jpg",
            "siteUrl": "https://www.made.com/",
            "updatedAt": "2024-04-28T20:20:17.185Z",
            "key": "made.com"
        },
        "lipsy": {
            "names": [
                "Lipsy"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "clothing",
                "retail"
            ],
            "score": 44,
            "ownedBy": [
                "next"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/Lipsy_Master-logo-full.jpg/120px-Lipsy_Master-logo-full.jpg.png",
            "siteUrl": "http://next.co.uk/lipsy",
            "updatedAt": "2024-04-28T20:20:17.185Z",
            "key": "lipsy"
        },
        "mytos": {
            "names": [
                "Mytos"
            ],
            "comment": "Mytos is a British biotech startup which creates systems to automate human cell manufacture, with the potential to underpin breakthroughs in drug discovery and cell therapy [1].",
            "sources": {
                "1": "https://www.forbes.com/sites/alexknapp/2023/11/30/this-startup-just-raised-19-million-to-bring-an-industrial-revolution-to-biology/"
            },
            "tags": [
                "healthcare",
                "tech",
                "none"
            ],
            "score": 85,
            "ownedBy": [],
            "logoUrl": "https://assets-global.website-files.com/62042a797b21a1c243311ba5/62043273b7d6bb2c7fbe8886_Mytos%20logo.svg",
            "siteUrl": "https://www.mytos.bio/",
            "updatedAt": "2024-04-29T06:50:06.453Z",
            "key": "mytos"
        },
        "the-times": {
            "names": [
                "The Times",
                "The Daily Universal Register"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "news"
            ],
            "score": 25,
            "ownedBy": [
                "news-corp"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/02/The_Times_masthead.svg/120px-The_Times_masthead.svg.png",
            "siteUrl": "https://thetimes.co.uk/",
            "updatedAt": "2024-05-29T16:01:37.989Z",
            "key": "the-times"
        },
        "the-sunday-times": {
            "names": [
                "The Sunday Times",
                "The New Observer"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "news"
            ],
            "score": 25,
            "ownedBy": [
                "news-corp"
            ],
            "logoUrl": "https://media.info/l/o/1/1575.1405339476.png",
            "siteUrl": "thesundaytimes.co.uk",
            "updatedAt": "2024-05-29T16:01:37.989Z",
            "key": "the-sunday-times"
        },
        "the-sun": {
            "names": [
                "The Sun"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "news"
            ],
            "score": 25,
            "ownedBy": [
                "news-corp"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/3b/The_Sun.svg",
            "siteUrl": "https://thesun.co.uk/",
            "updatedAt": "2024-05-29T16:01:37.989Z",
            "key": "the-sun"
        },
        "dow-jones": {
            "names": [
                "Dow Jones",
                "Dow Jones & Company",
                "Dow Jones & Company, Inc."
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "news"
            ],
            "score": 25,
            "ownedBy": [
                "news-corp"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f8/Dow_Jones_Logo.svg/120px-Dow_Jones_Logo.svg.png",
            "siteUrl": "http://dowjones.com/",
            "updatedAt": "2024-05-29T16:01:37.989Z",
            "key": "dow-jones"
        },
        "the-wall-street-journal": {
            "names": [
                "The Wall Street Journal"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "news"
            ],
            "score": 25,
            "ownedBy": [
                "news-corp"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/4a/WSJ_Logo.svg",
            "siteUrl": "http://wsj.com/",
            "updatedAt": "2024-05-29T16:01:37.989Z",
            "key": "the-wall-street-journal"
        },
        "harpercollins": {
            "names": [
                "HarperCollins"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "books"
            ],
            "score": 25,
            "ownedBy": [
                "news-corp"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/0/00/Harpercollins-logo.svg",
            "siteUrl": "https://harpercollins.com/",
            "updatedAt": "2024-05-29T16:01:37.989Z",
            "key": "harpercollins"
        },
        "news-of-the-world": {
            "names": [
                "News of the World"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "news"
            ],
            "score": 25,
            "ownedBy": [
                "news-corp"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/94/News_of_the_World_Logo_2009.svg/120px-News_of_the_World_Logo_2009.svg.png",
            "siteUrl": "http://www.newsoftheworld.co.uk/",
            "updatedAt": "2024-05-29T16:01:37.989Z",
            "key": "news-of-the-world"
        },
        "news-corp": {
            "names": [
                "News Corp",
                "News Corporation",
                "NWSA",
                "NWS",
                "NWSLV"
            ],
            "comment": "News Corp is an American media conglomerate owned by Rupert Murdoch which \"lacks any ethical base\" [1], having engaged in police corruption and bribery [2][3], and hacked the phones of murder victims [4] and those killed in 9/11 [5]. ",
            "sources": {
                "1": "https://www.huffpost.com/entry/murdoch-media-empire-a-jo_b_896836",
                "2": "https://www.theguardian.com/media/2011/mar/11/news-of-the-world-police-corruption",
                "3": "https://www.bbc.co.uk/news/uk-16996275",
                "4": "https://www.theguardian.com/uk/2011/jul/04/milly-dowler-family-phone-hacking",
                "5": "https://www.mirror.co.uk/2011/07/11/phone-hacking-9-11-victims-may-have-had-mobiles-tapped-by-news-of-the-world-reporters-115875-23262694/"
            },
            "tags": [
                "news",
                "corruption",
                "privacy violations",
                "data breach"
            ],
            "score": 25,
            "ownedBy": [
                "news-corp"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/55/News_Corp_logo_2013.svg",
            "siteUrl": "http://newscorp.com/",
            "updatedAt": "2024-05-29T16:01:37.989Z",
            "key": "news-corp"
        },
        "levi's": {
            "names": [
                "Levi's",
                "Levi Strauss",
                "Levi Strauss & Co.",
                "Levi"
            ],
            "comment": "Levi's is an American clothing brand that has used AI to generate images modelling their products [1] and has usied toxic chemicals in their clothes [2] linked to water pollution in Mexico. Levis was also suspended from the Ethical Trading Initiative for refusing to pay a living wage [3][4]",
            "sources": {
                "1": "https://www.independent.co.uk/life-style/fashion/levis-ai-models-diversity-backlash-b2310280.html",
                "2": "https://www.greenpeace.org/international/publication/6889/toxic-threads-the-big-fashion-stitch-up/",
                "3": "https://www.business-humanrights.org/en/latest-news/levi-strauss-drops-from-first-to-fifth-place-in-etag-report-card-after-being-suspended-from-eti-for-refusing-to-commit-to-living-wage/",
                "4": "https://en.archive.maquilasolidarity.org/en/node/369"
            },
            "tags": [
                "clothing",
                "unfair pay",
                "unsustainable practices",
                "environmental violations"
            ],
            "score": 40,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/09/Levis-logo-quer.svg",
            "siteUrl": "https://www.levistrauss.com/",
            "updatedAt": "2024-06-06T18:53:03.266Z",
            "key": "levi's"
        },
        "highland-spring": {
            "names": [
                "Highland Spring"
            ],
            "comment": "Highland Spring is the UK's leading natural source water brand which has sold water containing toxic phthalates [2] and microplastics [3], alongside a poor environmental footprint [3]. Highland Spring was the first brand to launch a 100% recycled bottle [1].",
            "sources": {
                "1": "https://www.bbc.co.uk/news/uk-scotland-scotland-business-44404453",
                "2": "https://www.standard.co.uk/hp/front/dangerous-chemical-found-in-bottled-water-6934399.html",
                "3": "https://www.telegraph.co.uk/food-and-drink/drinks/the-great-bottled-water-scandal/"
            },
            "tags": [
                "beverages",
                "environmental violations",
                "unsustainable practices"
            ],
            "score": 30,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/f/f6/Highland_Spring_logo.jpg",
            "siteUrl": "https://www.highlandspring.com/",
            "updatedAt": "2024-06-09T08:06:36.089Z",
            "key": "highland-spring"
        },
        "tp-link": {
            "names": [
                "TP Link",
                "TP-Link"
            ],
            "comment": "TP-Link is a Singaporean electronics manufacturer which has not posted a sustainability report on their website since 2022 [1].",
            "sources": {
                "1": "https://web.archive.org/web/20240715143848/https://www.tp-link.com/uk/sustainability/"
            },
            "tags": [
                "electronics",
                "greenwashing"
            ],
            "score": 48,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/d/d0/TPLINK_Logo_2.svg",
            "siteUrl": "https://www.tp-link.com/en/",
            "updatedAt": "2024-07-21T08:06:36.089Z",
            "key": "tp-link"
        },
        "anker": {
            "names": [
                "Anker",
                "Anker Innovations",
                "安克",
                "Anker Innovations Co., Ltd",
                "Oceanwing"
            ],
            "comment": "Anker is a Chinese electronics company that has claimed not to store user data while sending images to its cloud servers [1].",
            "sources": {
                "1": "https://www.howtogeek.com/138235/why-review-geek-cant-recommend-wyze-or-eufy-cameras-anymore/"
            },
            "tags": [
                "electronics",
                "antiprivacy",
                "privacy violations",
                "deception"
            ],
            "score": 38,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/9c/Anker_logo.svg",
            "siteUrl": "https://anker.com/",
            "updatedAt": "2024-07-16T18:27:48.537Z",
            "key": "anker"
        },
        "eufy": {
            "names": [
                "eufy"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "electronics",
                "antiprivacy"
            ],
            "score": 38,
            "ownedBy": [
                "anker"
            ],
            "logoUrl": "https://tse1.mm.bing.net/th?id=OIP.-FydNiaKlphq7je0BVEUYQHaHa&pid=Api",
            "siteUrl": "https://www.eufy.com/",
            "updatedAt": "2024-07-16T18:27:48.537Z",
            "key": "eufy"
        },
        "soundcore": {
            "names": [
                "Soundcore"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "electronics",
                "antiprivacy"
            ],
            "score": 38,
            "ownedBy": [
                "anker"
            ],
            "logoUrl": "https://cdn.shopify.com/s/files/1/0501/7678/6607/files/logo.png?v=1681995409",
            "siteUrl": "https://uk.soundcore.com/",
            "updatedAt": "2024-07-16T18:27:48.537Z",
            "key": "soundcore"
        },
        "black-sheep-coffee": {
            "names": [
                "Black Sheep Coffee"
            ],
            "comment": "Black Sheep Coffee is a British coffee shop chain that claims to stand up to corporate giants and support homeless people [1], but sources close to the company's executives have described this messaging as performative [original research].",
            "sources": {
                "1": "https://archive.is/WVEk5"
            },
            "tags": [
                "beverages",
                "food",
                "deception"
            ],
            "score": 44,
            "ownedBy": [],
            "logoUrl": "https://cdn.shopify.com/s/files/1/0013/8530/0032/files/creaml.svg",
            "siteUrl": "https://leavetheherdbehind.com/",
            "updatedAt": "2024-07-22T06:11:30.920Z",
            "key": "black-sheep-coffee"
        },
        "famous-brands": {
            "names": [
                "Famous Brands",
                "Steers Group",
                "Famous Brands Limited",
                "FBR"
            ],
            "comment": "Famous Brands is a South African fast food conglomerate.",
            "sources": {},
            "tags": [
                "retail",
                "food",
                ""
            ],
            "score": 50,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/5/53/Famous_Brands_logo.png",
            "siteUrl": "https://famousbrands.co.za/",
            "updatedAt": "2025-08-08T12:00:52.779Z",
            "key": "famous-brands"
        },
        "twitch": {
            "names": [
                "Twitch"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "tech"
            ],
            "score": 5,
            "ownedBy": [
                "amazon"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/ce/Twitch_logo_2019.svg",
            "siteUrl": "https://www.twitch.tv/",
            "updatedAt": "2025-08-08T12:00:52.779Z",
            "key": "twitch"
        },
        "audible": {
            "names": [
                "Audible"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "tech"
            ],
            "score": 5,
            "ownedBy": [
                "amazon"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/d/d2/Audible_logo.svg",
            "siteUrl": "https://www.audible.com/",
            "updatedAt": "2025-08-08T12:00:52.779Z",
            "key": "audible"
        },
        "goodreads": {
            "names": [
                "Goodreads"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "tech"
            ],
            "score": 5,
            "ownedBy": [
                "amazon"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/ae/Goodreads_logo_2025.svg",
            "siteUrl": "https://www.goodreads.com/",
            "updatedAt": "2025-08-08T12:00:52.779Z",
            "key": "goodreads"
        },
        "imdb": {
            "names": [
                "IMDb",
                "Internet Movie Database"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "tech"
            ],
            "score": 5,
            "ownedBy": [
                "amazon"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/69/IMDB_Logo_2016.svg",
            "siteUrl": "https://www.imdb.com/",
            "updatedAt": "2025-08-08T12:00:52.779Z",
            "key": "imdb"
        },
        "mgm": {
            "names": [
                "MGM",
                "Metro-Goldwyn Mayer",
                "Metro-Goldwyn-Mayer Studios Inc."
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "tech"
            ],
            "score": 5,
            "ownedBy": [
                "amazon"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/7/74/Metro-Goldwyn-Mayer_2021.png",
            "siteUrl": "http://mgm.com/",
            "updatedAt": "2025-08-08T12:00:52.779Z",
            "key": "mgm"
        },
        "ring": {
            "names": [
                "Ring"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "tech"
            ],
            "score": 5,
            "ownedBy": [
                "amazon"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/9b/Ring-Logo.svg",
            "siteUrl": "https://ring.com/",
            "updatedAt": "2025-08-08T12:00:52.779Z",
            "key": "ring"
        },
        "ebay": {
            "names": [
                "eBay",
                "eBay, Inc.",
                "ebay",
                "EBAY"
            ],
            "comment": "eBay is an American ecommerce company which has avoided tax [1] and been ranked as the worst ecommerce site for carbon emissions [2], while eBay employees launched a harassment and stalking campaign against a journalist [3]. eBay sales saved 87 million items from landfill in 2021 [4].",
            "sources": {
                "1": "https://web.archive.org/web/20201127180330/https://www.bbc.co.uk/news/business-20022365",
                "2": "https://web.archive.org/web/20220626015517/https://www.chargedretail.co.uk/2022/03/22/ebay-amazon-ecommerce-carbon/",
                "3": "https://web.archive.org/web/20201027154507/https://www.bostonglobe.com/2020/06/15/metro/six-former-ebay-employees-charged-federal-cyberstalking-case-targeting-natick-couple/",
                "4": "https://web.archive.org/web/20221121235643/https://www.independent.co.uk/climate-change/sustainable-living/ebay-second-hand-fashion-landfill-sustainable-b1913771.html"
            },
            "tags": [
                "ecommerce",
                "retail",
                "tax avoidance",
                "unsustainable practices",
                "environmental violations",
                "sexual harassment"
            ],
            "score": 60,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/1b/EBay_logo.svg",
            "siteUrl": "https://www.ebay.com/",
            "updatedAt": "2024-07-27T08:02:18.176Z",
            "key": "ebay"
        },
        "moonpig": {
            "names": [
                "Moonpig",
                "MOON"
            ],
            "comment": "Moonpig is a British gift retailer that has donated hundreds of thousands of pounds to charity [1] and creating opportunities for underrepresented groups.  Moonpig has leaked customer information [2] and created 'insensitive' greetings cards [3].",
            "sources": {
                "1": "https://web.archive.org/web/20220811121056/https://www.moonpig.group/responsibility/our-communities/",
                "2": "https://realbusiness.co.uk/moonpig-com-api-chaos-shows-there-is-no-excuse-for-organisations-not-to-fix-problems",
                "3": "https://www.walesonline.co.uk/lifestyle/tv/moonpig-remove-divisive-nella-card-28211586"
            },
            "tags": [
                "retail",
                "privacy violations"
            ],
            "score": 50,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/a/aa/Moonpig_Logo.svg",
            "siteUrl": "http://moonpig.com/",
            "updatedAt": "2024-07-27T08:19:15.220Z",
            "key": "moonpig"
        },
        "supreme": {
            "names": [
                "Supreme"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "clothing"
            ],
            "score": 44,
            "ownedBy": [
                "essilorluxottica"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/28/Supreme_Logo.svg",
            "siteUrl": "http://supreme.com/",
            "updatedAt": "2024-10-03T06:49:27.232Z",
            "key": "supreme"
        },
        "essilorluxottica": {
            "names": [
                "EssilorLuxottica",
                "EssilorLuxottica SA",
                "Luxottica",
                "Essilor",
                "EL"
            ],
            "comment": "EssilorLuxottica is an Italian-French eyewear conglomerate that has engaged in anticompetitive [1] and anti-union practices [2].",
            "sources": {
                "1": "https://www.pymnts.com/cpi-posts/eyewear-manufacturer-essilorluxottica-accused-of-artificially-inflating-prices/",
                "2": "https://www.reuters.com/business/ray-ban-maker-luxottica-accused-anti-union-behaviour-us-georgia-plant-2021-07-15/"
            },
            "tags": [
                "clothing",
                "anticompetitive",
                "antiunion",
                "anticompetitive practices",
                "anti-union practices"
            ],
            "score": 44,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ed/Logo_EssilorLuxottica.svg/120px-Logo_EssilorLuxottica.svg.png",
            "siteUrl": "http://essilorluxottica.com/",
            "updatedAt": "2024-10-03T06:49:27.232Z",
            "key": "essilorluxottica"
        },
        "sunglass-hut": {
            "names": [
                "Sunglass Hut"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "clothing"
            ],
            "score": 44,
            "ownedBy": [
                "essilorluxottica"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/Sunglasshutnew.jpg/120px-Sunglasshutnew.jpg.png",
            "siteUrl": "http://sunglasshut.com/",
            "updatedAt": "2024-10-03T06:49:27.232Z",
            "key": "sunglass-hut"
        },
        "varilux": {
            "names": [
                "Varilux"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "clothing"
            ],
            "score": 44,
            "ownedBy": [
                "essilorluxottica"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/7/7e/VariluxFrenchLogo.jpg",
            "siteUrl": "http://www.varilux.com/",
            "updatedAt": "2024-10-03T06:49:27.232Z",
            "key": "varilux"
        },
        "ray-ban": {
            "names": [
                "Ray-Ban",
                "RayBan"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "clothing"
            ],
            "score": 44,
            "ownedBy": [
                "essilorluxottica"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/d/d1/Ray-Ban_logo.svg",
            "siteUrl": "http://ray-ban.com/",
            "updatedAt": "2024-10-03T06:49:27.232Z",
            "key": "ray-ban"
        },
        "oakley": {
            "names": [
                "Oakley",
                "Oakley, Inc."
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "clothing"
            ],
            "score": 44,
            "ownedBy": [
                "essilorluxottica"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/88/Oakley_logo.svg",
            "siteUrl": "http://www.oakley.com/",
            "updatedAt": "2024-10-03T06:49:27.232Z",
            "key": "oakley"
        },
        "under-armour": {
            "names": [
                "Under Armour",
                "Under Armour, Inc.",
                "UA",
                "UAA"
            ],
            "comment": "Under Armour is an American clothing and sportswear company thats has created advertising campaigns featuring trophy hunters [1], supported Donald Trump [2] and created clothing that could lead to burn injuries [3].",
            "sources": {
                "1": "http://www.businessinsider.com/under-armour-drops-sarah-bowmar-after-bear-hunt-video-2016-8",
                "2": "http://mashable.com/2017/02/07/under-armour-ceo-praises-trump/",
                "3": "https://web.archive.org/web/20130512185359/https://www.fs.fed.us/t-d/pubs/pdfpubs/pdf08512348/pdf08512348dpi72.pdf"
            },
            "tags": [
                "clothing",
                "animal abuse",
                "unsafe practices"
            ],
            "score": 42,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/44/Under_armour_logo.svg",
            "siteUrl": "http://underarmour.com/",
            "updatedAt": "2024-10-03T06:49:27.232Z",
            "key": "under-armour"
        },
        "urban-outfitters": {
            "names": [
                "Urban Outfitters",
                "Urban Outfitters, Inc.",
                "URBN",
                "Free People"
            ],
            "comment": "Urban Outfitters is an American clothing company that has sold board games and clothing described as \"racist\" [1][2], fired workers who attempted to unionise [3], harbored racist attitudes towards staff [4], stolen designs from independent artists [5], discontinued items supporting same-sex marriage [6], and racially profiled customers [7].",
            "sources": {
                "1": "https://www.thedp.com/article/2003/10/controversy_continues_over_racist_board_game",
                "2": "https://web.archive.org/web/20041114092914/https://www.adl.org/PresRele/DiRaB_41/4438_41.htm",
                "3": "https://www.aftonbladet.se/nyheter/a/oRMrPV/sparkas-efter-krav-pa-kollektivavtal",
                "4": "https://www.phillymag.com/news/2019/04/12/urban-outfitters-lawsuit/",
                "5": "https://www.tumblr.com/imakeshinythings/5855716317/not-cool-urban-outfitters-not-cool",
                "6": "https://www.thecut.com/2008/12/urban_outfitters_yanks_same-se.html",
                "7": "https://edition.cnn.com/2020/06/26/business/urban-outfitters-racial-profiling-trnd/index.html"
            },
            "tags": [
                "clothing",
                "fastfashion",
                "racial discrimination",
                "anti-union practices"
            ],
            "score": 35,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/a7/Urban_Outfitters_logo.svg",
            "siteUrl": "http://urbn.com/",
            "updatedAt": "2024-10-05T09:10:52.335Z",
            "key": "urban-outfitters"
        },
        "anthropologie": {
            "names": [
                "Anthropologie"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "urban-outfitters"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/37/Anthropologie_Logo.svg/120px-Anthropologie_Logo.svg.png",
            "siteUrl": "http://anthropologie.com/",
            "updatedAt": "2024-10-03T06:49:27.232Z",
            "key": "anthropologie"
        },
        "millions": {
            "names": [
                "Millions"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "confectionary"
            ],
            "score": 50,
            "ownedBy": [
                "golden-casket"
            ],
            "logoUrl": "https://goldencasket.co.uk/wp-content/uploads/2024/06/1_k3pGXtMillions-Brand-Logo.png",
            "siteUrl": "https://goldencasket.co.uk/millions/",
            "updatedAt": "2024-10-06T12:30:23.573Z",
            "key": "millions"
        },
        "haleon": {
            "names": [
                "Haleon",
                "Haleon plc",
                "HLN"
            ],
            "comment": "Haleon is an American consumer goods company which has been engaged in price fixing [1] and which was linked to the sale of Zantac, a gastrointestinal drug that led to cases of cancer [2][3].",
            "sources": {
                "1": "https://www.belgiancompetition.be/sites/default/files/content/download/files/20250424_Press_release_16_BCA_0.pdf",
                "2": "https://pharmaphorum.com/news/gsk-sanofi-and-haleon-facing-billions-of-dollars-in-zantac-liability",
                "3": "https://www.ft.com/content/3406ba6d-4ff3-4315-98d3-fac336d19445"
            },
            "tags": [
                "consumer goods",
                "pharmaceuticals",
                "anticompetitive practices",
                "unsafe products"
            ],
            "score": 40,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/3e/Haleon.svg",
            "siteUrl": "https://www.haleon.com/",
            "updatedAt": "2025-08-04T09:45:32.418Z",
            "key": "haleon"
        },
        "advil": {
            "names": [
                "Advil"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "consumer goods",
                "pharmaceuticals"
            ],
            "score": 40,
            "ownedBy": [
                "haleon"
            ],
            "logoUrl": "https://commons.wikimedia.org/wiki/File:Advil_200mg_Caplets.jpg",
            "siteUrl": "https://www.advil.com/",
            "updatedAt": "2025-08-04T10:20:22.070Z",
            "key": "advil"
        },
        "centrum": {
            "names": [
                "Centrum"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "consumer goods",
                "pharmaceuticals"
            ],
            "score": 40,
            "ownedBy": [
                "haleon"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Centrum_%28multivitamin%29_logo.png/120px-Centrum_%28multivitamin%29_logo.png.png",
            "siteUrl": "https://www.centrum.co.uk/",
            "updatedAt": "2025-08-04T10:20:22.070Z",
            "key": "centrum"
        },
        "nicorette": {
            "names": [
                "Nicorette"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "consumer goods",
                "pharmaceuticals"
            ],
            "score": 40,
            "ownedBy": [
                "haleon"
            ],
            "logoUrl": "https://clipground.com/nicorette-logo-png.html",
            "siteUrl": "http://nicorette.com/",
            "updatedAt": "2025-08-04T10:20:22.070Z",
            "key": "nicorette"
        },
        "aquafresh": {
            "names": [
                "Aquafresh"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "consumer goods",
                "pharmaceuticals"
            ],
            "score": 40,
            "ownedBy": [
                "haleon"
            ],
            "logoUrl": "https://1000logos.net/wp-content/uploads/2020/04/Aquafresh-Logo-140x79.png",
            "siteUrl": "https://www.aquafresh.com/en-gb/",
            "updatedAt": "2025-08-04T10:20:22.070Z",
            "key": "aquafresh"
        },
        "voltaren": {
            "names": [
                "Voltaren",
                "Voltarol"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "consumer goods",
                "pharmaceuticals"
            ],
            "score": 40,
            "ownedBy": [
                "haleon"
            ],
            "logoUrl": "https://i-cf65.ch-static.com/content/dam/cf-consumer-healthcare/voltaren-delta/en_GB/header/Voltarol_Tagline_201x60.png?auto=format",
            "siteUrl": "https://www.voltarol.co.uk/",
            "updatedAt": "2025-08-04T10:20:22.070Z",
            "key": "voltaren"
        },
        "sensodyne": {
            "names": [
                "Sensodyne"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "consumer goods",
                "pharmaceuticals"
            ],
            "score": 40,
            "ownedBy": [
                "haleon"
            ],
            "logoUrl": "https://www.sensodyne.com/2a237035-1639-4d34-9604-830dd5d30297",
            "siteUrl": "http://www.sensodyne.com/",
            "updatedAt": "2025-08-04T10:20:22.070Z",
            "key": "sensodyne"
        },
        "bose": {
            "names": [
                "Bose",
                "Bose Corporation"
            ],
            "comment": "Bose is an American electronics and audio company that has spied on users [1][2]. Amar Bose donated non-voting shares to MIT, which is now the majority owner.",
            "sources": {
                "1": "https://www.csoonline.com/article/561275/bose-accused-of-spying-on-users-illegal-wiretapping-via-bose-connect-app.html",
                "2": "https://www.foxbusiness.com/features/bose-headphones-spy-on-listeners-lawsuit"
            },
            "tags": [
                "electronics",
                "antiprivacy",
                "privacy violations"
            ],
            "score": 47,
            "ownedBy": [
                "mit"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/0c/Bose_logo.svg",
            "siteUrl": "http://www.bose.com/",
            "updatedAt": "2024-10-05T21:27:26.200Z",
            "key": "bose"
        },
        "guess": {
            "names": [
                "Guess",
                "GES",
                "Guess Inc.",
                "GUESS",
                "Guess?"
            ],
            "comment": "Guess is an American clothing company with connections to forced Uyghur Labour [1] and sweatshop manufacturing conditions [2], while Guess's cofounder engaged in sexual misconduct [3].",
            "sources": {
                "1": "https://www.shu.ac.uk/-/media/home/research/helena-kennedy-centre/projects/eu-apparel/eu-tailoring-responsibility-february-24.pdf",
                "2": "https://southendpress.org/what-companies-use-sweatshops/",
                "3": "https://fortune.com/2023/09/29/guess-settlement-marciano-sexual-misconduct-lawsuit/"
            },
            "tags": [
                "clothing",
                "forced uyghur labour",
                "forced labour",
                "poor working conditions",
                "sexual harassment"
            ],
            "score": 40,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/89/Guess_logo.svg",
            "siteUrl": "http://www.guess.com/",
            "updatedAt": "2024-10-05T10:39:46.568Z",
            "key": "guess"
        },
        "nintendo": {
            "names": [
                "Nintendo",
                "Nintendo Co., Ltd.",
                "Nintendo Co.",
                "Nintendō kabushiki gaisha",
                "任天堂株式会社",
                "Nintendo Koppai"
            ],
            "comment": "Nintendo is a Japanese video games company which has seen sexual misconduct and sexism against female employees [1][2], engaged in price fixing [3][4].",
            "sources": {
                "1": "https://www.engadget.com/nintendo-investigates-sexual-misconduct-claims-194740757.html?guccounter=1",
                "2": "https://arstechnica.com/gaming/2022/08/sweeping-report-alleges-inequity-sexual-harassment-at-nintendos-american-hq/",
                "3": "https://www.gamesindustry.biz/nintendos-price-fixing-fine-reduced-by-gbp27m",
                "4": "http://news.bbc.co.uk/2/hi/business/2375967.stm"
            },
            "tags": [
                "video games",
                "anticompetitive",
                "sexual harassment",
                "anticompetitive practices",
                "gender discrimination"
            ],
            "score": 43,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/0d/Nintendo.svg",
            "siteUrl": "http://nintendo.com/",
            "updatedAt": "2024-10-05T09:10:52.335Z",
            "key": "nintendo"
        },
        "mattel": {
            "names": [
                "Mattel",
                "Mattel, Inc.",
                "MAT"
            ],
            "comment": "Mattel is an American toy corporation that sold 19 millon toys containing dangerous levels of lead [1], subjected factory workers to inhumane condtions [2][3], and sold baby rockers that killed almost 100 babies despite warnings from experts to discontinue the product [4].",
            "sources": {
                "1": "https://www.nytimes.com/2007/08/15/business/worldbusiness/15imports.html",
                "2": "https://chinalaborwatch.org/deterioration-of-mattels-labor-conditions-an-investigation-of-four-factories/",
                "3": "https://www.google.com/url?sa=t&source=web&cd=&ved=2ahUKEwiEl5317quJAxXJU0EAHZYJHywQFnoECBgQBQ&url=https%3A%2F%2Fchinalaborwatch.org%2Fmattels-unceasing-abuse-of-chinese-workers-an-investigation-of-six-mattel-supplier-factories%2F&usg=AOvVaw0I6P_Dtel3pAqjsZccu7VL&opi=89978449",
                "4": "https://abcnews.go.com/US/fisher-price-warnings-rock-play-sleepers-led-dozens/story?id=78128719"
            },
            "tags": [
                "toys",
                "poor working conditions",
                "unsafe working conditions",
                "unsafe practices"
            ],
            "score": 10,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/7b/Mattel_%282019%29.svg",
            "siteUrl": "http://mattel.com/",
            "updatedAt": "2024-10-26T10:34:12.014Z",
            "key": "mattel"
        },
        "barbie": {
            "names": [
                "Barbie"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "toys"
            ],
            "score": 10,
            "ownedBy": [
                "mattel"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/0b/Barbie_Logo.svg",
            "siteUrl": "https://shop.mattel.com/pages/barbie",
            "updatedAt": "2024-10-26T10:34:12.014Z",
            "key": "barbie"
        },
        "hot-wheels": {
            "names": [
                "Hot Wheels"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "toys"
            ],
            "score": 10,
            "ownedBy": [
                "mattel"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/0/08/Hot_Wheels_logo-en.svg",
            "siteUrl": "https://hotwheels.com/",
            "updatedAt": "2024-10-26T10:34:12.014Z",
            "key": "hot-wheels"
        },
        "fisher-price": {
            "names": [
                "Fisher-Price"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "toys"
            ],
            "score": 10,
            "ownedBy": [
                "mattel"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/7e/Fisher-Price_2019.svg",
            "siteUrl": "http://fisher-price.com/",
            "updatedAt": "2024-10-26T10:34:12.014Z",
            "key": "fisher-price"
        },
        "kellogg's": {
            "names": [
                "Kellogg's",
                "Kellanova",
                "The Kellogg Company",
                "K"
            ],
            "comment": "Kellogg's is an American food company that has made false claims about the health impacts of its foods [1][2], sourced palm oil produced by child labour and forced labour [3][4][5], and fired over 1000 workers who went on strike [6].",
            "sources": {
                "1": "https://web.archive.org/web/20100605074858/http://ftc.gov/opa/2010/06/kellogg.shtm",
                "2": "https://web.archive.org/web/20100605083122/http://www.nytimes.com/2010/06/04/business/04ftc.html",
                "3": "https://web.archive.org/web/20180423210624/https://www.amnesty.org/en/documents/asa21/5184/2016/en/",
                "4": "https://web.archive.org/web/20161203061058/http://www.ibtimes.co.uk/amnesty-report-slams-popular-brands-profiting-labour-abuses-wilmar-1594102",
                "5": "https://web.archive.org/web/20161202053632/https://www.theguardian.com/law/2016/nov/30/kelloggs-unilever-nestle-child-labour-palm-oil-wilmar-amnesty",
                "6": "https://web.archive.org/web/20211209051128/https://www.businessinsider.com/kellogg-replacing-1400-striking-workers-reject-deal-wage-increase-2021-12"
            },
            "tags": [
                "food",
                "deception",
                "child labour",
                "forced labour",
                "anti‑union practices"
            ],
            "score": 17,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/0a/Kellogg%27s-Logo.svg",
            "siteUrl": "http://kellanova.com/",
            "updatedAt": "2024-12-26T15:02:40.507Z",
            "key": "kellogg's"
        },
        "heineken": {
            "names": [
                "Heineken",
                "Heineken N.V.",
                "HEIA"
            ],
            "comment": "Heineken is a Dutch beverage company that broke its promise to withdraw from Russia [1], engaged in price fixing [2], and engaged in high-level corruption, suppression of local brewers, and collaborations with authoritarian regimes in Africa [3]. Heineken has also interfered with alcohol policies in the US and EU [4].",
            "sources": {
                "1": "https://nltimes.nl/2023/02/21/heineken-still-investing-russia-despite-promises-stop",
                "2": "http://business.guardian.co.uk/story/0,,2059542,00.html",
                "3": "https://www.premiumtimesng.com/news/top-news/756714-at-book-reading-dutch-journalist-recounts-expose-on-heinekens-practices-in-africa.html?tztc=1",
                "4": "https://movendi.ngo/the-issues/the-problem/big-alcohol-exposed/heineken-company-profile/"
            },
            "tags": [
                "alcohol",
                "anticompetitive",
                "anticompetitive practices",
                "corruption",
                "connections to russia"
            ],
            "score": 15,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/24/Heineken_logo.svg",
            "siteUrl": "http://www.heinekeninternational.com/",
            "updatedAt": "2025-01-05T09:56:01.496Z",
            "key": "heineken"
        },
        "byd": {
            "names": [
                "BYD",
                "BYD Company",
                "比亚迪"
            ],
            "comment": "BYD is a Chinese car and manufacturing company which is the world's largest manufacturer of electric vehicles and has ties to the Chinese Communist Party and Chinese Military [1][2], and has utilised forced Uyghur labour [1], \"slave-like\" working conditions [3][4] and human-trafficked workers [5]. BYD has tried to silence those who criticise them using legal action [6][7], and its factories have polluted their surroundings and caused illnesses in local children [8][9][10].",
            "sources": {
                "1": "https://web.archive.org/web/20200422081513/https://www.vice.com/en_us/article/qjdqnb/trump-blacklisted-this-chinese-company-now-its-making-coronavirus-masks-for-us-hospitals",
                "2": "https://www.hongkongwatch.org/all-posts/2024/1/18/hong-kong-watch-publishes-briefing-exposing-the-risks-of-huawei-and-byd-to-the-eu",
                "3": "https://www.bloomberg.com/news/articles/2024-12-24/brazil-halts-byd-site-after-workers-found-in-slave-conditions",
                "4": "https://www.theverge.com/2024/5/18/24158518/ev-critical-mineral-mining-human-rights-abuse-allegations",
                "5": "https://www.reuters.com/world/americas/brazilian-authorities-workers-byd-construction-site-victims-international-human-2024-12-27/",
                "6": "https://www.stcn.com/article/detail/928873.html",
                "7": "https://web.archive.org/web/20240729015033/https://www.thewirechina.com/2024/07/28/libel-lawfare-chinese-companies-defamation-suit-anti-slapp/",
                "8": "https://www.asiafinancial.com/warren-buffett-backed-byd-plunges-on-pollution-probe",
                "9": "https://www.reuters.com/world/china/chinese-city-probing-byd-factory-emissions-over-allegations-childrens-nosebleeds-2022-05-09/",
                "10": "https://www.fairplanet.org/editors-pick/chinas-not-so-green-electric-vehicles/"
            },
            "tags": [
                "manufacturing",
                "cars",
                "forced Uyghur labour",
                "forced labour",
                "poor working conditions",
                "unsafe working conditions",
                "environmental violations"
            ],
            "score": 20,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/99/BYD_Company%2C_Ltd._-_Logo.svg",
            "siteUrl": "https://www.bydglobal.com/",
            "updatedAt": "2025-03-20T19:45:15.978Z",
            "key": "byd"
        },
        "gap": {
            "names": [
                "Gap",
                "Gap Inc.",
                "The Gap, Inc.",
                "The Gap",
                "GGP",
                "GAP"
            ],
            "comment": "Gap is an American clothing conglomerate that has sourced garments from factories with squalid conditions, wage nonpayment and mandatory overtime, which have forced employees to have abortions, and where employees have been sexually assaulted [1][2][3][4]. GAP has also sold clothes produced by child labour [5] and forced labour of Uyghur Muslims [6].",
            "sources": {
                "1": "https://www.globalcitizen.org/en/content/hm-gap-factory-abuse-fast-fashion-workers/",
                "2": "https://www.independent.co.uk/news/shirts-for-the-fashionable-at-a-price-paid-in-human-misery-on-us-soil-the-gap-workers-are-forced-to-1121362.html",
                "3": "https://web.archive.org/web/20170915133212/http://www.msmagazine.com/spring2006/paradise_full.asp",
                "4": "https://wayback.archive-it.org/all/20080309041041/http://www.nlcnet.org/documents/Jordan_PDF_Web/04_Western.pdf",
                "5": "http://news.bbc.co.uk/1/hi/world/south_asia/7066019.stm",
                "6": "https://archive.is/GSvdC"
            },
            "tags": [
                "clothing",
                "child labour",
                "forced labour",
                "forced uyghur labour",
                "sexual harassment",
                "poor working conditions",
                "unfair pay"
            ],
            "score": 15,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/c8/Gap_Inc._logo_2024.svg",
            "siteUrl": "http://gapinc.com/",
            "updatedAt": "2025-04-26T16:31:06.518Z",
            "key": "gap"
        },
        "banana-republic": {
            "names": [
                "Banana Republic"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "clothing"
            ],
            "score": 15,
            "ownedBy": [
                "gap"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/69/Banana_Republic_Logo.svg",
            "siteUrl": "http://www.bananarepublic.com/",
            "updatedAt": "2025-04-26T16:31:06.518Z",
            "key": "banana-republic"
        },
        "old-navy": {
            "names": [
                "Old Navy"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "clothing"
            ],
            "score": 15,
            "ownedBy": [
                "gap"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/d/d3/Old_Navy_Logo.svg",
            "siteUrl": "http://oldnavy.gap.com/",
            "updatedAt": "2025-04-26T16:31:06.518Z",
            "key": "old-navy"
        },
        "7-eleven": {
            "names": [
                "7-Eleven",
                "7-11",
                "7-Eleven, Inc.",
                "Seven-Eleven",
                "Seven & I Holdings",
                "Southland Ice Company",
                "Seven Eleven",
                "Seven-Eleven Japan",
                "Seven-Eleven Japan Co., Ltd.",
                "株式会社セブン‐イレブン・ジャパン"
            ],
            "comment": "7-Eleven is a Japanese-American supermarket chain that has mistreated and underpaid its workers [1][2][3][4][5].",
            "sources": {
                "1": "https://www.orgsthatmatter.com/communication/7-eleven-unethical/",
                "2": "https://www.abc.net.au/news/2020-10-30/7-11-pays-back-$176-million-worth-of-backpay-super-to-staff/12831176",
                "3": "https://www.workplaceethicsadvice.com/2015/10/7-eleven-wage-scandal-reflects-corporate-irresponsibility.html",
                "4": "https://www.news.com.au/finance/business/retail/virtual-slave-paid-47-cents-an-hour-to-work-at-7eleven-store/news-story/3ffc332f3fbd0c5e42fe561690d8bd54",
                "5": "https://www.abc.net.au/news/2015-08-31/exploitation-part-of-7-eleven-business-model-insider-says/6733682"
            },
            "tags": [
                "retail",
                "supermarket",
                "unfair pay",
                "poor working conditions"
            ],
            "score": 46,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/e/e0/7-Eleven_logo_2021.svg",
            "siteUrl": "http://www.7-eleven.com/",
            "updatedAt": "2025-05-20T19:29:06.368Z",
            "key": "7-eleven"
        },
        "acer": {
            "names": [
                "Acer",
                "Acer Inc."
            ],
            "comment": "Acer is a Taiwanese electronics company which continues to operate in Russia [1][2] and which has sourced manufacturing from factories where forced labour is prevalent [3][5], including that of Uyghurs and other ethnic minorities [4]",
            "sources": {
                "1": "https://som.yale.edu/story/2022/over-450-companies-have-withdrawn-russia-some-remain",
                "2": "https://www.reuters.com/technology/taiwans-acer-ships-computer-hardware-russia-after-saying-it-would-suspend-2023-06-08/",
                "3": "https://chinalaborwatch.org/labor-conditions-in-chinas-consumer-electronics-sector/",
                "4": "https://www.aspi.org.au/report/uyghurs-sale",
                "5": "https://www.theguardian.com/global-development/2017/oct/06/laptop-firms-accused-of-labour-abuses-against-chinese-students-sony-hp-acer"
            },
            "tags": [
                "electronics",
                "connections to russia",
                "forced labour",
                "forced uyghur labour",
                "racial discrimination"
            ],
            "score": 35,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/00/Acer_2011.svg",
            "siteUrl": "https://www.acer.com/",
            "updatedAt": "2025-08-02T07:43:01.582Z",
            "key": "acer"
        },
        "abercrombie-and-fitch": {
            "names": [
                "Abercrombie & Fitch",
                "Abercrombie and Fitch",
                "A&F",
                "Abercrombie & Fitch Co.",
                "Abercrombie",
                "ANF"
            ],
            "comment": "Abercrombie & Fitch is an American clothing retailer that discriminated against African American, Latino and minority employees [1], discriminated against a law student with a prosthetic arm [2] and discriminated against Muslim employees for wearing a hijab [3][4], with the US Supreme Court ruling against the company [5]. Abercrombie and Fitch has been linked to forced Uyghur labour [6][7], while its former CEO Mike Jeffries sexually abused dozens of employees and models [8][9] while perpetuating a toxic and racist culture within the company [10].",
            "sources": {
                "1": "https://web.archive.org/web/20070308195814/http://www.afjustice.com/index.htm",
                "2": "http://news.bbc.co.uk/1/hi/england/london/8116231.stm",
                "3": "https://web.archive.org/web/20090926025427/http://www.time.com/time/business/article/0,8599,1925607,00.html",
                "4": "https://web.archive.org/web/20100612155054/http://www.aolnews.com/nation/article/hollister-fires-hani-khan-19-for-wearing-muslim-head-scarf/19373618",
                "5": "http://www.cnn.com/2015/06/01/politics/supreme-court-abercrombie-fitch-headscarf/index.html",
                "6": "https://web.archive.org/web/20201125195127/https://uhrp.org/press-release/press-release-180-orgs-demand-apparel-brands-end-complicity-uyghur-forced-labour.html",
                "7": "https://www.business-humanrights.org/en/latest-news/china-83-major-brands-implicated-in-report-on-forced-labour-of-ethnic-minorities-from-xinjiang-assigned-to-factories-across-provinces-includes-company-responses/",
                "8": "https://www.forbes.com/sites/tylerroush/2025/03/21/more-than-40-men-accuse-ex-abercrombie--fitch-ceo-mike-jeffries-of-sexual-abuse-report-says/",
                "9": "https://wwd.com/business-news/legal/abercrombie-amp-fitch-mike-jeffries-sex-allegations-1237058562/",
                "10": "https://inews.co.uk/news/world/abercrombie-and-fitch-toxic-culture-sex-racism-claims-explained-2658763"
            },
            "tags": [
                "clothing",
                "retail",
                "racial discrimination",
                "forced uyghur labour",
                "sexual harassment"
            ],
            "score": 25,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3e/Abercrombie_%26_Fitch_logo.svg/120px-Abercrombie_%26_Fitch_logo.svg.png",
            "siteUrl": "http://abercrombie.com/",
            "updatedAt": "2025-05-29T15:10:54.745Z",
            "key": "abercrombie-and-fitch"
        },
        "hollister": {
            "names": [
                "Hollister",
                "Hollister Co.",
                "HCo."
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "clothing",
                "retail"
            ],
            "score": 25,
            "ownedBy": [
                "abercrombie-and-fitch"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/a8/Hollister_logo.svg",
            "siteUrl": "http://hollisterco.com/",
            "updatedAt": "2025-05-29T15:39:58.998Z",
            "key": "hollister"
        },
        "gilly-hicks": {
            "names": [
                "Gilly Hicks"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "clothing",
                "retail"
            ],
            "score": 25,
            "ownedBy": [
                "abercrombie-and-fitch"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/af/Gilly_Hicks_by_Hollister_logo.svg",
            "siteUrl": "https://www.hollisterco.com/shop/us/gilly-hicks",
            "updatedAt": "2025-05-29T15:39:58.998Z",
            "key": "gilly-hicks"
        },
        "king": {
            "names": [
                "King",
                "King.com",
                "King.com Limited",
                "Midasplayer.com",
                "Candy Crush"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "video games"
            ],
            "score": 35,
            "ownedBy": [
                "microsoft"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/1/1a/King_logo.svg",
            "siteUrl": "https://king.com/",
            "updatedAt": "2025-08-02T09:51:45.208Z",
            "key": "king"
        },
        "blizzard": {
            "names": [
                "Blizzard",
                "Blizzard Entertainment",
                "Blizzard Entertainment, Inc."
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "video games"
            ],
            "score": 35,
            "ownedBy": [
                "microsoft"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Blizzard_Entertainment_Logo_2015.svg/120px-Blizzard_Entertainment_Logo_2015.svg.png",
            "siteUrl": "http://blizzard.com/",
            "updatedAt": "2025-08-02T09:51:45.208Z",
            "key": "blizzard"
        },
        "activision": {
            "names": [
                "Activision"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "video games"
            ],
            "score": 35,
            "ownedBy": [
                "microsoft"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/01/Activision.svg",
            "siteUrl": "https://www.activision.com/",
            "updatedAt": "2025-08-02T09:51:45.208Z",
            "key": "activision"
        },
        "bbc": {
            "names": [
                "BBC",
                "British Broadcasting Corporation",
                "BBC News"
            ],
            "comment": "The BBC is a British public broadcaster funded by a government tax [1], which has been accused of left-wing [2] and right-wing [3] bias. The BBC represents one of the largest news gathering operations in the world [4] and offers free educational resources to teachers and children [5][6], but particular criticism has been directed to its treatment of LGBT+ communities [7][8], the Isreal-Palestine conflict [9], and racism [10].",
            "sources": {
                "1": "https://web.archive.org/web/20071117105208/http://www.telegraph.co.uk/arts/main.jhtml?xml=%2Farts%2F2006%2F09%2F22%2Fftlicence22.xml",
                "2": "https://web.archive.org/web/20170807023223/https://www.theguardian.com/media/2012/oct/10/bbc-review-liberal-bias",
                "3": "https://web.archive.org/web/20181209123856/https://www.theguardian.com/commentisfree/2018/apr/11/bbc-andrew-neil-media-politics",
                "4": "https://www.bbc.co.uk/news/19888761",
                "5": "https://archive.is/IbwWv",
                "6": "https://www.bbc.co.uk/bitesize/articles/zmjdhbk",
                "7": "https://www.pinknews.co.uk/2020/06/22/bbc-news-institutional-transphobia-kamal-ahmed-crispin-blunt-trans-media-watch/",
                "8": "https://mermaidsuk.org.uk/news/lgbtq-complaint-to-the-bbc/",
                "9": "https://web.archive.org/web/20231124032059/https://www.aljazeera.com/news/2023/11/23/as-israel-pounds-gaza-bbc-journalists-accuse-broadcaster-of-bias",
                "10": "https://ghostarchive.org/archive/20220112/https://www.telegraph.co.uk/news/2020/07/31/bbc-receives-complaints-white-reporter-uses-n-word-air/"
            },
            "tags": [
                "news",
                "media",
                "entertainment",
                "racial discrimination",
                "gender discrimination"
            ],
            "score": 75,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/41/BBC_Logo_2021.svg",
            "siteUrl": "https://bbc.com/",
            "updatedAt": "2024-01-01T10:47:27.404Z",
            "key": "bbc"
        },
        "air-wick": {
            "names": [
                "Air Wick",
                "Airwick"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "consumer goods"
            ],
            "score": 6,
            "ownedBy": [
                "reckitt"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/2/2c/Air_Wick_circle_logo.png",
            "siteUrl": "http://www.airwick.us/",
            "updatedAt": "2025-08-10T21:41:01.378Z",
            "key": "air-wick"
        },
        "dettol": {
            "names": [
                "Dettol"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer-goods"
            ],
            "score": 6,
            "ownedBy": [
                "reckitt"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/a/a9/250px-Dettol_logo.png",
            "siteUrl": "https://www.dettol.co.uk/",
            "updatedAt": "2025-11-26T17:40:46.998Z",
            "key": "dettol"
        },
        "airbnb": {
            "names": [
                "Airbnb"
            ],
            "comment": "Airbnb is an American holiday rental website that has avoided billions in tax [1][2], raised rental prices and caused evictions for local people where it operates  [3][4][5], lobbied governments to avoid regulation [6], and operated rentals in illegal settlements in the West Bank [7][8][9]. One of Airbnb's founders joined the US government DOGE organisation [10], hidden cameras have been found in several Airbnb properties [11][12][13], and thousands of reports of sexual assaults in Airbnbs are made every year, using settlements and legal tactics to silence surviors [14][15][16][17].",
            "sources": {
                "1": "https://irishbusinessnews.ie/airbnb-faces-massive-tax-settlement-in-italy/",
                "2": "http://archive.today/2025.08.16-223020/https://news.airbnb.com/an-update-on-withholding-host-income-taxes-in-italy/",
                "3": "https://web.archive.org/web/20201210140814/https://hbr.org/2019/04/research-when-airbnb-listings-in-a-city-increase-so-do-rent-prices",
                "4": "https://web.archive.org/web/20240709161639/https://www.forbes.com/sites/garybarker/2020/02/21/the-airbnb-effect-on-housing-and-rent/",
                "5": "https://web.archive.org/web/20190410171641/https://prospect.org/article/evictions-and-conversions-dark-side-airbnb",
                "6": "https://web.archive.org/web/20191014111009/https://www.thetimes.co.uk/article/airbnb-lobby-msps-every-month-bs8scg2r5",
                "7": "https://web.archive.org/web/20220923033358/https://www.nytimes.com/2019/04/09/world/middleeast/airbnb-israel-west-bank.html",
                "8": "https://www.theguardian.com/world/ng-interactive/2025/feb/27/seized-settled-let-how-airbnb-and-bookingcom-help-israelis-make-money-from-stolen-palestinian-land",
                "9": "https://web.archive.org/web/20190626190143/https://globalnews.ca/news/5148940/airbnb-west-bank-settlements/",
                "10": "https://www.newsweek.com/airbnb-boycott-calls-joe-gebbia-elon-musk-doge-2033847",
                "11": "https://edition.cnn.com/2024/07/09/business/airbnb-hidden-camera-invs/index.html",
                "12": "https://web.archive.org/web/20240709162214/https://www.theatlantic.com/technology/archive/2019/03/what-happens-when-you-find-cameras-your-airbnb/585007/",
                "13": "https://web.archive.org/web/20240709162724/https://qz.com/airbnb-hidden-cameras-stories-reports-complaints-ftc-1851442432",
                "14": "https://www.businessinsider.com/airbnb-faces-thousands-sexual-assault-claims-yearly-report-2021-6",
                "15": "https://www.bbc.com/news/business-57487970",
                "16": "https://www.vice.com/en/article/airbnb-reportedly-paid-rape-victim-7-million-for-settlement-silence/",
                "17": "https://www.bloomberg.com/news/articles/2021-08-18/two-sexual-assault-survivors-spur-airbnb-arbitration-turnaround"
            },
            "tags": [
                "tech",
                "travel",
                "tax avoidance",
                "privacy violations",
                "sexual harassment",
                "connections to israel"
            ],
            "score": 19,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/69/Airbnb_Logo_B%C3%A9lo.svg",
            "siteUrl": "https://www.airbnb.com/",
            "updatedAt": "2025-08-16T21:45:26.540Z",
            "key": "airbnb"
        },
        "allianz": {
            "names": [
                "Allianz",
                "Allianz SE",
                "Allianz AG",
                "ALV"
            ],
            "comment": "Allianz is a German insurance company that has engaged in price fixing [1] and misled consumers [2],  discriminated against those with mental health issues [3], bribed government officials in indonesia [4],  invested billions into businesses involved with illegal settlements in the West Bank and the Israeli Government [5][6], and had close with Nazism during the 20th century [7].",
            "sources": {
                "1": "https://www.gov.uk/cma-cases/private-motor-insurance-exchange-of-data",
                "2": "https://www.google.com/url?sa=t&source=web&rct=j&opi=89978449&url=https://www.asic.gov.au/about-asic/news-centre/find-a-media-release/2025-releases/25-028mr-allianz-and-awp-convicted-and-fined-16-8-million-for-making-false-or-misleading-statements/&ved=2ahUKEwjN9fvvu5GPAxWTUkEAHbKYPI8QFnoECBQQAQ&usg=AOvVaw2aeJN0o5tYz5sxHWsjHh0b",
                "3": "https://www.atg.wa.gov/news/news-releases/ag-ferguson-insurance-company-must-repay-every-penny-washingtonians-it-denied",
                "4": "https://web.archive.org/web/20160607080301/https://www.sec.gov/News/PressRelease/Detail/PressRelease/1365171486902",
                "5": "https://web.archive.org/web/20221225234520/https://www.banktrack.org/download/exposing_the_financial_flows_into_illegal_israeli_settlements/dbio_report_def_aangepast.pdf",
                "6": "https://www.aljazeera.com/news/2025/7/1/un-report-lists-companies-complicit-in-israels-genocide-who-are-they",
                "7": "https://web.archive.org/web/20190110012801/https://www.allianz.com/content/dam/onemarketing/azcom/Allianz_com/about-us/who-we-are/documents/Allianz_during_the_Nazi_era.pdf"
            },
            "tags": [
                "insurance",
                "finance",
                "anticompetitive practices",
                "deception",
                "corruption",
                "connections to Israel"
            ],
            "score": 26,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/4b/Allianz.svg",
            "siteUrl": "http://allianz.com/",
            "updatedAt": "2025-08-16T23:15:14.879Z",
            "key": "allianz"
        },
        "liverpool-victoria": {
            "names": [
                "Liverpool Victoria",
                "LV",
                "LV="
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "insurance",
                "finance"
            ],
            "score": 26,
            "ownedBy": [
                "allianz"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/6/6c/Liverpool_Victoria_logo.png",
            "siteUrl": "https://www.lv.com/",
            "updatedAt": "2025-08-16T23:15:14.879Z",
            "key": "liverpool-victoria"
        },
        "petplan": {
            "names": [
                "Petplan",
                "PetPlan",
                "Pet Plan",
                "PetPlan UK",
                "Pet Plan Limited"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "insurance",
                "finance"
            ],
            "score": 26,
            "ownedBy": [
                "allianz"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/48/Petplan_logo_.jpg/120px-Petplan_logo_.jpg.png",
            "siteUrl": "http://petplan.co.uk/",
            "updatedAt": "2025-08-16T23:15:14.879Z",
            "key": "petplan"
        },
        "amd": {
            "names": [
                "AMD",
                "Advanced Micro Devices",
                "Advanced Micro Devices, Inc."
            ],
            "comment": "AMD is an American electronics company that underpaid its staff [1], engaged in price fixing of its GPUs [2], and falsely advertised its products [3].",
            "sources": {
                "1": "https://www.law360.com/articles/570431/amd-pays-5-2m-to-settle-sabbatical-pay-class-action",
                "2": "https://www.law360.com/articles/88284/class-seeks-final-ok-for-1-7m-deal-in-gpu-mdl-",
                "3": "https://www.law360.com/classaction/articles/1192508/amd-inks-12-1m-deal-in-computer-chip-false-ad-row"
            },
            "tags": [
                "tech",
                "electronics",
                "anticompetitive practices",
                "unfair pay",
                "deception"
            ],
            "score": 44,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/7c/AMD_Logo.svg",
            "siteUrl": "https://www.amd.com/",
            "updatedAt": "2025-08-17T22:11:17.770Z",
            "key": "amd"
        },
        "ati": {
            "names": [
                "ATI",
                "ATY",
                "ATYT",
                "ATI Technologies",
                "ATI Technologies Inc.",
                "Array Technology Inc.",
                "Array Technologies Inc.",
                "Array Technologies Inc."
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "tech",
                "electronics"
            ],
            "score": 44,
            "ownedBy": [
                "amd"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/a5/ATI-Logo.svg",
            "siteUrl": "https://web.archive.org/web/20061008230707/http://www.ati.com/",
            "updatedAt": "2025-08-17T22:11:17.770Z",
            "key": "ati"
        },
        "american-eagle": {
            "names": [
                "American Eagle",
                "American Eagle Outfitters",
                "American Eagle Outfitters, Inc.",
                "AEO"
            ],
            "comment": "American Eagle is an American clothing brand that sourced clothes from factories that exploited workers [1] and stole the work of independent artists [2].",
            "sources": {
                "1": "https://www.dailymail.co.uk/news/article-13346715/US-Customs-investigating-forced-labor-factory-clothes-Armour-American-Eagle.html",
                "2": "https://www.huffingtonpost.co.uk/entry/aholsniffsglue-american-eagle-artist-lawsuit-copyright_n_5627862"
            },
            "tags": [
                "clothing",
                "retail",
                "forced labour",
                "unfair pay",
                "poor working conditions",
                "deception"
            ],
            "score": 42,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/18/American_Eagle_Outfitters_wordmark.svg",
            "siteUrl": "https://ae.com/",
            "updatedAt": "2025-08-20T22:27:45.242Z",
            "key": "american-eagle"
        },
        "american-express": {
            "names": [
                "American Express",
                "American Express Company",
                "Amex",
                "AMEX",
                "AXP",
                "Livingston, Fargo & Company",
                "Wells, Butterfield & Company",
                "Wells & Company"
            ],
            "comment": "American Express is an American payment card company that has repeatedly forced unlawful fees on its customers [1][2][3][4], misled small business about its services [5], engaged in various anticompetitive practices [6][7] and discriminated against female employees [8] as well as spanish-speaking customers [9].",
            "sources": {
                "1": "https://www.cbc.ca/news/business/amex-fined-112m-for-unlawful-fees-and-sales-tactics-1.1185636",
                "2": "https://blogs.ubc.ca/robsandall/2012/10/01/american-express-fined-112-million-for-unethical-proceedings/",
                "3": "https://www.consumerfinance.gov/about-us/newsroom/cfpb-orders-american-express-to-pay-59-5-million-for-illegal-credit-card-practices/",
                "4": "https://www.consumerfinance.gov/about-us/newsroom/cfpb-orders-american-express-to-pay-85-million-refund-to-consumers-harmed-by-illegal-credit-card-practices/",
                "5": "https://www.electronicpaymentsinternational.com/news/american-express-fined-230m/?cf-view&cf-closed",
                "6": "https://news.bloomberglaw.com/antitrust/american-express-accused-of-violating-antitrust-law-by-merchants",
                "7": "https://www.law360.com/articles/336422/amex-s-50m-payout-in-currency-fee-suit-gets-judge-s-ok",
                "8": "https://clearinghouse.net/doc/34470/",
                "9": "https://www.consumerfinance.gov/about-us/newsroom/cfpb-and-american-express-reach-resolution-address-discriminatory-card-terms-puerto-rico-and-us-territories/"
            },
            "tags": [
                "finance",
                "tech",
                "anticompetitive practices",
                "deception",
                "gender discrimination",
                "racial discrimination"
            ],
            "score": 43,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/f/fa/American_Express_logo_%282018%29.svg",
            "siteUrl": "https://americanexpress.com/",
            "updatedAt": "2025-08-21T20:17:23.254Z",
            "key": "american-express"
        },
        "anthropic": {
            "names": [
                "Anthropic",
                "Anthropic PBC"
            ],
            "comment": "Anthropic is an American artificial intelligence company that illegally used stolen books [1][4], songs [2], and information scraped from the internet [3] to train its systems.",
            "sources": {
                "1": "https://web.archive.org/web/20250725124441/https://storage.courtlistener.com/recap/gov.uscourts.cand.434709/gov.uscourts.cand.434709.231.0_3.pdf",
                "2": "https://venturebeat.com/ai/major-music-publishers-sue-anthropic-for-copyright-infringement-over-song-lyrics/",
                "3": "https://arstechnica.com/tech-policy/2025/06/reddit-sues-anthropic-over-ai-scraping-that-retained-users-deleted-posts/",
                "4": "https://www.theguardian.com/technology/article/2024/aug/20/anthropic-ai-lawsuit-author"
            },
            "tags": [
                "tech",
                "ai",
                "deception"
            ],
            "score": 46,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/78/Anthropic_logo.svg",
            "siteUrl": "https://www.anthropic.com/",
            "updatedAt": "2025-08-21T20:31:25.258Z",
            "key": "anthropic"
        },
        "asos": {
            "names": [
                "ASOS",
                "ASOS plc",
                "ASC",
                "Winsupply Public Limited Company",
                "AsSeenOnScreen Holdings plc",
                "AsSeenOnScreen"
            ],
            "comment": "ASOS is a Brtish clothing retailer that has mistreated its workers [1][2], failed to keep its employees safe during the pandemic [3][4], sourced clothing produced by child labour [5], and allowed sennior managers to sexually harass young female employees [6].",
            "sources": {
                "1": "https://www.buzzfeed.com/saraspary/these-asos-workers-are-paying-the-true-price-of-your-order",
                "2": "https://www.theguardian.com/business/2017/apr/04/asos-chief-executive-says-barnsley-warehouse-conditions-great",
                "3": "https://www.theguardian.com/global/2020/mar/30/asos-workers-coronavirus-fears-online-fashion-safety-barnsley-warehouse",
                "4": "https://web.archive.org/web/20200503123321/https://novaramedia.com/2020/05/02/this-isnt-essential-asos-workers-fight-for-safety-during-coronavirus/",
                "5": "https://www.forbes.com/sites/jwebb/2016/10/25/child-workers-found-in-clothing-supply-chain-asos-marks-spencer-implicated/",
                "6": "https://www.telegraph.co.uk/news/2021/07/29/asos-brings-lawyers-tackle-sex-harassment-claims/"
            },
            "tags": [
                "clothing",
                "retail",
                "child labour",
                "sexual harassment",
                "unsafe working conditions",
                "poor working conditions"
            ],
            "score": 36,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/a8/Asos.svg",
            "siteUrl": "http://asos.com/",
            "updatedAt": "2025-08-21T21:01:33.825Z",
            "key": "asos"
        },
        "topshop": {
            "names": [
                "Topshop",
                "TOPSHOP",
                "Top Shop"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "clothing",
                "retail"
            ],
            "score": 36,
            "ownedBy": [
                "bestseller",
                "asos"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/66/TopshopJan2018.svg",
            "siteUrl": "https://www.topshop.com/gb/topshop",
            "updatedAt": "2025-08-21T21:01:33.825Z",
            "key": "topshop"
        },
        "topman": {
            "names": [
                "Topman"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "clothing",
                "retail"
            ],
            "score": 36,
            "ownedBy": [
                "bestseller",
                "asos"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/e/e9/TOPMAN2018.svg",
            "siteUrl": "http://topshop.com/gb/topman",
            "updatedAt": "2025-08-21T21:01:33.825Z",
            "key": "topman"
        },
        "miss-selfridge": {
            "names": [
                "Miss Selfridge"
            ],
            "comment": "",
            "sources": {},
            "tags": [
                "clothing",
                "retail"
            ],
            "score": 36,
            "ownedBy": [
                "bestseller",
                "asos"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/MissSelfridge.svg/120px-MissSelfridge.svg.png",
            "siteUrl": "https://www.asos.com/miss-selfridge/",
            "updatedAt": "2025-08-21T21:01:33.825Z",
            "key": "miss-selfridge"
        },
        "astrazeneca": {
            "names": [
                "AstraZeneca",
                "Astra",
                "Zeneca",
                "AstraZeneca plc",
                "AZ",
                "AZN",
                "Astra AB",
                "Zenenca Group"
            ],
            "comment": "AstraZeneca is a pharmaceutical company that has remained active in Russia during international sanctions [1], ran a negligently managed antipsychotic trial resulting in a patient's death [2], and falsely marketed drugs with serious side effects as safe, including a cholesterol medication [3] and a cancer drug linked to multiple deaths [4]. The company has faced major legal actions for illegally marketing the unsafe antipsychotic drug Seroquel to vulnerable populations [5], filing false claims with U.S. government health programs [6], misrepresenting study results for a heart drug [7], bribing doctors in China and Russia [8], and engaging in price fixing and anti-competitive drug pricing schemes [9].",
            "sources": {
                "1": "https://www.independent.co.uk/news/business/astrazeneca-doubled-exports-from-sweden-to-russia-after-start-of-war-report-b2295772.html",
                "2": "https://www.motherjones.com/environment/2010/09/dan-markingson-drug-trial-astrazeneca/",
                "3": "https://www.drug-injury.com/druginjurycom/2005/05/side_effects_oc.html",
                "4": "https://www.nytimes.com/2002/10/16/business/astrazeneca-alters-cancer-drug-label.html",
                "5": "https://abcnews.go.com/Politics/Health/astrazeneca-pay-520-million-illegally-marketing-seroquel-schizophrenia/story?id=10488647",
                "6": "https://www.justice.gov/archive/opa/pr/2003/June/03_civ_371.htm",
                "7": "https://bmjgroup.com/bmj-finds-inaccuracies-in-key-studies-for-astrazenecas-blockbuster-heart-drug-ticagrelor/",
                "8": "https://www.statnews.com/pharmalot/2016/08/31/astrazeneca-bribes-china-russia/",
                "9": "https://www.law360.com/articles/176078/astrazeneca-to-pay-103m-to-settle-awp-claims"
            },
            "sourceNotes": {
                "1": "still active in russia",
                "2": "Dan Markingson died in a negligently run antipsychotic trial",
                "3": "Marketed anticholesterol drug with serious side effects as safe",
                "4": "continued to sell cancer drug that caused multiple deaths",
                "5": "Fined $520 million for illegally marketed the anti-psychotic drug Seroquel to children and elderly patients",
                "6": "company caused false and fraudulent claims to be filed with the Medicare, TriCare, Department of Defense and Railroad Retirement Board Medicare programs as a result of AstraZeneca’s fraudulent drug pricing schemes and sales and marketing misconduct",
                "7": "Lied about results of study of new heart drug",
                "8": "AstraZeneca to pay $5.5 million for bribing doctors in China and Russia",
                "9": "price fixing and anticompetetive inflation of drug prices"
            },
            "tags": [
                "pharmaceuticals",
                "connections to russia",
                "corruption",
                "anticompetitive practices",
                "deception",
                "unsafe practices"
            ],
            "score": 24,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/4/4f/AstraZeneca.svg",
            "siteUrl": "https://astrazeneca.com/",
            "updatedAt": "2025-08-30T14:45:56.267Z",
            "key": "astrazeneca"
        },
        "asus": {
            "names": [
                "ASUS",
                "Asus",
                "ASUSTeK",
                "ASUSTeK Computer Inc.",
                "Huáshuò",
                "華碩",
                "華碩電腦股份有限公司"
            ],
            "comment": "ASUS is a Taiwanese electronics company known for manufacturing computers and hardware components. It has been criticized for non-consumer-friendly repair and warranty practices [1], while its supply chain has been found to benefit from forced Uyghur labour [2].",
            "sources": {
                "1": "https://www.pcmag.com/news/asus-apologizes-for-heavily-criticized-warranty-and-return-service",
                "2": "https://www.aspi.org.au/report/uyghurs-sale/"
            },
            "sourceNotes": {
                "1": "non consumer friendly repair and warranty practices",
                "2": "forced Uyghur labour in supply chain"
            },
            "tags": [
                "electronics",
                "tech",
                "forced labour",
                "forced uyghur labour"
            ],
            "score": 50,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/2e/ASUS_Logo.svg",
            "siteUrl": "https://www.asus.com/",
            "updatedAt": "2025-08-30T23:55:31.755Z",
            "key": "asus"
        },
        "lenovo": {
            "names": [
                "Lenovo",
                "Lenovo Group Limited",
                "联想"
            ],
            "comment": "Lenovo is a Chinese technology company that came under scrutiny for preinstalling software on its devices that compromised user privacy [1][2], as well as  firing an employee returning from Family and Medical Leave [3].",
            "sources": {
                "1": "https://www.ftc.gov/news-events/news/press-releases/2017/09/lenovo-settles-ftc-charges-it-harmed-consumers-preinstalled-software-its-laptops-compromised-online",
                "2": "https://theconversation.com/lenovos-security-debacle-reveals-blurred-boundary-between-adware-and-malware-37945",
                "3": "https://www.dol.gov/newsroom/releases/whd/whd20201120-0"
            },
            "sourceNotes": {
                "1": "Preinstalled software that compromised user privacy",
                "2": "Preinstalled software that compromised user privacy",
                "3": "fired an employee returning from Family/Medical Leave"
            },
            "tags": [
                "electronics",
                "tech",
                "privacy violations",
                "anti-union practices"
            ],
            "score": 44,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/c9/Lenovo_%282015%29.svg",
            "siteUrl": "https://www.lenovo.com/",
            "updatedAt": "2025-08-31T09:15:51.557Z",
            "key": "lenovo"
        },
        "hp": {
            "names": [
                "HP",
                "Hewlett-Packard",
                "The Hewlett-Packard Company",
                "HP Inc.",
                "HPQ"
            ],
            "comment": "HP is a multinational technology company that has engaged in anticompetitive and anticonsumer practices [1][2][3] and has been linked to abusive labour conditions in its supply chain, including the use of forced Uyghur labour [4][5]. HP also provides services to the Israel Police and Population and Immigration Authority [6] and has received over $368 million in U.S. military contracts [7].",
            "sources": {
                "1": "https://www.saverilawfirm.com/our-cases/hp/",
                "2": "https://web.archive.org/web/20230525063023/https://www.lexgroup.ca/classaction/hp-officejet-printers-dynamic-security-non-hp-ink-cartridges-canadian-class-action-settlement/",
                "3": "https://web.archive.org/web/20230625064707/https://www.euroconsumers.org/activities/hp-and-euroconsumers-reach-a-settlement-on-dynamic-security-dispute",
                "4": "https://chinalaborwatch.org/labor-conditions-in-chinas-consumer-electronics-sector/",
                "5": "https://www.aspi.org.au/report/uyghurs-sale/",
                "6": "https://bdsmovement.net/BoycottHP-GazaGenocide-Update",
                "7": "https://www.washingtontechnology.com/rankings/company/195/top-100/2024/"
            },
            "sourceNotes": {
                "1": "anticompetitive and anticonsumer practices",
                "2": "anticompetitive and anticonsumer practices",
                "3": "anticompetitive and anticonsumer practices",
                "4": "abusive labour conditions in factories in supply chain",
                "5": "forced Uyghur labour in supply chain",
                "6": "provides services to Israel Police and Population and Immigration Authority",
                "7": "over $368 million in US military contracts"
            },
            "tags": [
                "electronics",
                "tech",
                "anticompetitive practices",
                "forced uyghur labour",
                "connections to israel"
            ],
            "score": 37,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/05/HP_logo_2025.svg",
            "siteUrl": "https://www.hp.com/",
            "updatedAt": "2025-08-31T09:29:05.085Z",
            "key": "hp"
        },
        "aviva": {
            "names": [
                "Aviva",
                "Aviva plc",
                "Commercial Union plc",
                "CGU plc",
                "CGNU plc",
                "Norwich Union",
                "AVIVA",
                "AV.",
                "Hand in Hand Fire & Life Insurance Society"
            ],
            "comment": "Aviva is a British insurance and asset management company that has unfairly raised rents for residents in its buildings [1], refused to address safety issues its properties in order to maximise shareholder returns [2], and is also connected to investments in and insurance for Israeli arms manufacturers [3].",
            "sources": {
                "1": "https://thenegotiator.co.uk/news/leasehold-scandal-persimmon-aviva-cma/",
                "2": "https://endourcladdingscandal.org/wp-content/uploads/2023/07/Our-meeting-with-Aviva-Investors-and-Aviva-Insurance.pdf",
                "3": "https://www.thecanary.co/uk/news/2025/03/11/aviva-palestine-action-protest/"
            },
            "sourceNotes": {
                "1": "unfairly raised rents to residents in its buildings",
                "2": "refuses to fix safety issues in its buildings to increase shareholder returns",
                "3": "connected to investments in and insurance for isaeli arms manufacturers"
            },
            "tags": [
                "insurance",
                "connections to israel",
                "unsafe practices"
            ],
            "score": 37,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1e/Aviva_Logo.svg/120px-Aviva_Logo.svg.png",
            "siteUrl": "https://aviva.com/",
            "updatedAt": "2025-08-31T10:13:43.364Z",
            "key": "aviva"
        },
        "direct-line": {
            "names": [
                "Direct Line",
                "Direct Line Group"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {
                "1": "unfairly raised rents to residents in its buildings",
                "2": "refuses to fix safety issues in its buildings to increase shareholder returns",
                "3": "connected to investments in and insurance for isaeli arms manufacturers"
            },
            "tags": [
                "insurance"
            ],
            "score": 37,
            "ownedBy": [
                "aviva"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/3/3f/Direct_Line_logo.png",
            "siteUrl": "https://www.directline.com/",
            "updatedAt": "2025-08-31T10:13:43.364Z",
            "key": "direct-line"
        },
        "churchill": {
            "names": [
                "Churchill",
                "Churchill Insurance"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {
                "1": "unfairly raised rents to residents in its buildings",
                "2": "refuses to fix safety issues in its buildings to increase shareholder returns",
                "3": "connected to investments in and insurance for isaeli arms manufacturers"
            },
            "tags": [
                "insurance"
            ],
            "score": 37,
            "ownedBy": [
                "aviva"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/0/09/Churchill_Insurance_logo.png",
            "siteUrl": "https://churchill.com/",
            "updatedAt": "2025-08-31T10:13:43.364Z",
            "key": "churchill"
        },
        "privilege": {
            "names": [
                "Privilege"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {
                "1": "unfairly raised rents to residents in its buildings",
                "2": "refuses to fix safety issues in its buildings to increase shareholder returns",
                "3": "connected to investments in and insurance for isaeli arms manufacturers"
            },
            "tags": [
                "insurance"
            ],
            "score": 37,
            "ownedBy": [
                "aviva"
            ],
            "logoUrl": "https://www.directlinegroup.co.uk/content/dlg/corporate/en/brands/_jcr_content/brands-grids/pageteaser_2089173228/image.img.jpg/1656501188720.jpg",
            "siteUrl": "http://www.privilege.com/",
            "updatedAt": "2025-08-31T10:13:43.364Z",
            "key": "privilege"
        },
        "by-miles": {
            "names": [
                "By Miles"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {
                "1": "unfairly raised rents to residents in its buildings",
                "2": "refuses to fix safety issues in its buildings to increase shareholder returns",
                "3": "connected to investments in and insurance for isaeli arms manufacturers"
            },
            "tags": [
                "insurance"
            ],
            "score": 37,
            "ownedBy": [
                "aviva"
            ],
            "logoUrl": "https://www.bymiles.co.uk/static/assets/bymiles-logo-white.svg",
            "siteUrl": "https://www.bymiles.co.uk/",
            "updatedAt": "2025-08-31T10:13:43.364Z",
            "key": "by-miles"
        },
        "green-flag": {
            "names": [
                "Green Flag"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {
                "1": "unfairly raised rents to residents in its buildings",
                "2": "refuses to fix safety issues in its buildings to increase shareholder returns",
                "3": "connected to investments in and insurance for isaeli arms manufacturers"
            },
            "tags": [
                "insurance"
            ],
            "score": 37,
            "ownedBy": [
                "aviva"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/9/9d/Green_Flag_logo.png",
            "siteUrl": "https://greenflag.com/",
            "updatedAt": "2025-08-31T10:13:43.364Z",
            "key": "green-flag"
        },
        "axa": {
            "names": [
                "AXA",
                "Axa S.A.",
                "CS"
            ],
            "comment": "AXA is a global insurance company that has underpaid workers [1], invested in companies linked to illegal deforestation [2], and financially supported fracking for shale gas in the US [3]. AXA has insured and paid out for illegal animal hunting [4], and invested in Israeli banks and arms manufacturers [5].",
            "sources": {
                "1": "https://www.law360.com/articles/793681/ny-judge-greenlights-2-3m-axa-advisors-wage-deal",
                "2": "https://www.business-humanrights.org/en/latest-news/brazil-sherpa-calls-for-bnp-paribas-cr%C3%A9dit-agricole-bpce-and-axa-to-be-investigated-in-france-for-buying-bonds-of-companies-linked-to-illegal-deforestation/",
                "3": "https://disclose.ngo/en/article/despite-their-climate-commitments-insurers-axa-and-scor-support-u-s-shale-gas",
                "4": "https://www.ethicalconsumer.org/money-finance/axa-must-axe-hunts",
                "5": "https://bdsmovement.net/axa-divest"
            },
            "sourceNotes": {
                "1": "underpaid workers",
                "2": "bought bonds of companies linked to illegal deforestation",
                "3": "financially supports fracking for shale gas in the US",
                "4": "insures illegal animal hunting",
                "5": "invests in israeli banks and arms manufacturers"
            },
            "tags": [
                "insurance",
                "unfair pay",
                "deforestation",
                "fossil fuels",
                "animal abuse",
                "connections to israel",
                "unsustainable practices"
            ],
            "score": 33,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/94/AXA_Logo.svg",
            "siteUrl": "https://www.axa.com/",
            "updatedAt": "2025-08-31T17:31:34.842Z",
            "key": "axa"
        },
        "bandq": {
            "names": [
                "B&Q",
                "B&Q Limited",
                "Block & Quayle",
                "B & Q",
                "B & Q (Retail) Limited",
                "B & Q plc",
                "B&Q plc"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 45,
            "ownedBy": [
                "kingfisher"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/c0/B%26Q_company_logo.svg",
            "siteUrl": "https://diy.com/",
            "updatedAt": "2025-09-01T14:56:50.189Z",
            "key": "bandq"
        },
        "screwfix": {
            "names": [
                "Screwfix"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 45,
            "ownedBy": [
                "kingfisher"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/f/fe/Screwfix_Logo.png",
            "siteUrl": "https://screwfix.com/",
            "updatedAt": "2025-09-01T14:56:50.189Z",
            "key": "screwfix"
        },
        "blue-bottle-coffee": {
            "names": [
                "Blue Bottle Coffee",
                "Blue Bottle Coffee, Inc."
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "coffee"
            ],
            "score": 10,
            "ownedBy": [
                "nestle"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/0/06/Blue_Bottle_Coffee_logo.svg",
            "siteUrl": "https://bluebottlecoffee.com/",
            "updatedAt": "2025-09-01T15:02:42.928Z",
            "key": "blue-bottle-coffee"
        },
        "kingfisher": {
            "names": [
                "Kingfisher",
                "Kingfisher plc",
                "Paternoster Stones Public Limited Company",
                "Woolworth Holdings plc"
            ],
            "comment": "Kingfisher is a British retailer whose website has featured sexist and racist marketing content [1][2] and has been accused of harassing customers in stores [3]. Kingfisher has cut employee benefits in response to a  rise in minimum wage [4], reduced employees' break times [5], and failed to pay minimum wage [6].",
            "sources": {
                "1": "https://www.independent.co.uk/news/uk/home-news/b-q-sexist-advertisement-shelf-cabinet-b2759037.html",
                "2": "https://www.thesun.co.uk/news/23457747/bampq-forced-to-apologise-shocking-book/",
                "3": "https://iaingould.co.uk/case-reports/woman-wrongfully-detained-in-bq-agrees-out-of-court-settlement/",
                "4": "https://www.retailgazette.co.uk/blog/2016/05/man-behind-b-and-q-petition-callls-for-others-to-follow-example/",
                "5": "https://www.retail-week.com/home-and-diy/exclusive-bandq-faces-staff-backlash-over-contract-changes/7045162.article",
                "6": "https://www.gov.uk/government/news/over-500-companies-named-for-not-paying-minimum-wage"
            },
            "sourceNotes": {
                "1": "sexist marketing on website",
                "2": "racist marketing on website",
                "3": "harassed customer in store",
                "4": "cut employee benefits in response to rise in minimum wage",
                "5": "cut employees' breaks in response to rise in minimum wage",
                "6": "failed to pay minimum wage"
            },
            "tags": [
                "retail",
                "racial discrimination",
                "gender discrimination",
                "unfair pay",
                "poor working conditions"
            ],
            "score": 45,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/5/5a/Kingfisher_plc.svg",
            "siteUrl": "https://kingfisher.com/",
            "updatedAt": "2025-09-01T14:56:50.189Z",
            "key": "kingfisher"
        },
        "babolat": {
            "names": [
                "Babolat"
            ],
            "comment": "Babolat is a sportswear company that has been falsely advertised its products [1].",
            "sources": {
                "1": "https://www.law360.com/articles/640516/racket-maker-gets-final-nod-for-4-5m-false-ad-pact-"
            },
            "sourceNotes": {
                "1": "false advertising"
            },
            "tags": [
                "retail",
                "clothing",
                "sport",
                "deception"
            ],
            "score": 48,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/f/f2/Babolat_logo.svg",
            "siteUrl": "https://www.babolat.com/",
            "updatedAt": "2025-09-01T15:26:23.947Z",
            "key": "babolat"
        },
        "bisto": {
            "names": [
                "Bisto"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 43,
            "ownedBy": [
                "premier-foods"
            ],
            "logoUrl": "",
            "siteUrl": "https://www.bisto.co.uk/",
            "updatedAt": "2025-09-01T15:26:23.947Z",
            "key": "bisto"
        },
        "premier-foods": {
            "names": [
                "Premier Foods",
                "Premier Foods plc",
                "PFD"
            ],
            "comment": "Premier Foods is a British food manufacturer that has faced accusations of unsafe working conditions [1], anticompetitive supplier practices [2][3], and price fixing [4]. It has also reversed its promise to use free‑range eggs to cut costs [5] and sold food containing carcinogens [6].",
            "sources": {
                "1": "https://www.thompsons.law/news/news-releases/accidents-at-work-news/premier-foods-pays-compensation-to-worker-electrocuted-at-barnsley-factory",
                "2": "https://www.theguardian.com/business/2014/dec/05/premier-foods-pay-stay-supplier",
                "3": "https://www.safe-collections.com/blog/debt-collection/premier-foods-named-and-shamed-on-exceedingly-bad-payment-practices/",
                "4": "https://www.sowetanlive.co.za/news/2016-05-10-why-premier-foods-is-off-the-hook-in-bread-price-scandal/",
                "5": "https://web.archive.org/web/20250902074958/https://www.thetimes.com/article/mr-kipling-not-such-a-good-egg-after-all-hw3mhnnxsf0",
                "6": "https://www.abc.net.au/health/thepulse/stories/2005/03/03/1313354.htm"
            },
            "sourceNotes": {
                "1": "unsafe working conditions",
                "2": "anticompetitive supplier practices",
                "3": "anticompetitive supplier practices",
                "4": "engaged in price fixing",
                "5": "reversed promise to use free range eggs to save costs",
                "6": "sold food containing carcinogens"
            },
            "tags": [
                "food",
                "beverages",
                "anticompetitive practices",
                "unsafe working conditions",
                "greenwashing"
            ],
            "score": 43,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/66/Logo-04.png/120px-Logo-04.png.png",
            "siteUrl": "http://www.premierfoods.co.uk/",
            "updatedAt": "2025-09-01T15:26:23.947Z",
            "key": "premier-foods"
        },
        "oxo": {
            "names": [
                "OXO",
                "Oxo"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {
                "1": "unsafe working conditions",
                "2": "anticompetitive supplier practices",
                "3": "anticompetitive supplier practices",
                "4": "engaged in price fixing",
                "5": "reversed promise to use free range eggs to save costs",
                "6": "sold food containing carcinogens"
            },
            "tags": [
                "food",
                "beverages"
            ],
            "score": 43,
            "ownedBy": [
                "premier-foods"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/0/0f/Oxo_logo.png",
            "siteUrl": "http://www.oxo.co.uk/",
            "updatedAt": "2025-09-01T15:26:23.947Z",
            "key": "oxo"
        },
        "paxo": {
            "names": [
                "Paxo"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {
                "1": "unsafe working conditions",
                "2": "anticompetitive supplier practices",
                "3": "anticompetitive supplier practices",
                "4": "engaged in price fixing",
                "5": "reversed promise to use free range eggs to save costs",
                "6": "sold food containing carcinogens"
            },
            "tags": [
                "food",
                "beverages"
            ],
            "score": 43,
            "ownedBy": [
                "premier-foods"
            ],
            "logoUrl": "",
            "siteUrl": "http://www.paxo.co.uk/",
            "updatedAt": "2025-09-01T15:26:23.947Z",
            "key": "paxo"
        },
        "saxa": {
            "names": [
                "Saxa"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {
                "1": "unsafe working conditions",
                "2": "anticompetitive supplier practices",
                "3": "anticompetitive supplier practices",
                "4": "engaged in price fixing",
                "5": "reversed promise to use free range eggs to save costs",
                "6": "sold food containing carcinogens"
            },
            "tags": [
                "food",
                "beverages"
            ],
            "score": 43,
            "ownedBy": [
                "premier-foods"
            ],
            "logoUrl": "",
            "siteUrl": "",
            "updatedAt": "2025-09-01T15:26:23.947Z",
            "key": "saxa"
        },
        "sharwood's": {
            "names": [
                "Sharwood's"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {
                "1": "unsafe working conditions",
                "2": "anticompetitive supplier practices",
                "3": "anticompetitive supplier practices",
                "4": "engaged in price fixing",
                "5": "reversed promise to use free range eggs to save costs",
                "6": "sold food containing carcinogens"
            },
            "tags": [
                "food",
                "beverages"
            ],
            "score": 43,
            "ownedBy": [
                "premier-foods"
            ],
            "logoUrl": "",
            "siteUrl": "http://www.sharwoods.com/",
            "updatedAt": "2025-09-01T15:26:23.947Z",
            "key": "sharwood's"
        },
        "smash": {
            "names": [
                "Smash"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {
                "1": "unsafe working conditions",
                "2": "anticompetitive supplier practices",
                "3": "anticompetitive supplier practices",
                "4": "engaged in price fixing",
                "5": "reversed promise to use free range eggs to save costs",
                "6": "sold food containing carcinogens"
            },
            "tags": [
                "food",
                "beverages"
            ],
            "score": 43,
            "ownedBy": [
                "premier-foods"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/4/41/Smashxl.jpg",
            "siteUrl": "",
            "updatedAt": "2025-09-01T15:26:23.947Z",
            "key": "smash"
        },
        "loyd-grossman": {
            "names": [
                "Loyd Grossman"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {
                "1": "unsafe working conditions",
                "2": "anticompetitive supplier practices",
                "3": "anticompetitive supplier practices",
                "4": "engaged in price fixing",
                "5": "reversed promise to use free range eggs to save costs",
                "6": "sold food containing carcinogens"
            },
            "tags": [
                "food",
                "beverages"
            ],
            "score": 43,
            "ownedBy": [
                "premier-foods"
            ],
            "logoUrl": "",
            "siteUrl": "http://www.loydgrossmansauces.co.uk/",
            "updatedAt": "2025-09-01T15:26:23.947Z",
            "key": "loyd-grossman"
        },
        "ambrosia": {
            "names": [
                "Ambrosia"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {
                "1": "unsafe working conditions",
                "2": "anticompetitive supplier practices",
                "3": "anticompetitive supplier practices",
                "4": "engaged in price fixing",
                "5": "reversed promise to use free range eggs to save costs",
                "6": "sold food containing carcinogens"
            },
            "tags": [
                "food",
                "beverages"
            ],
            "score": 43,
            "ownedBy": [
                "premier-foods"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/3/33/Ambrosia_logo.png",
            "siteUrl": "http://www.ambrosia.co.uk/",
            "updatedAt": "2025-09-01T15:26:23.947Z",
            "key": "ambrosia"
        },
        "super-noodles": {
            "names": [
                "Super Noodles"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {
                "1": "unsafe working conditions",
                "2": "anticompetitive supplier practices",
                "3": "anticompetitive supplier practices",
                "4": "engaged in price fixing",
                "5": "reversed promise to use free range eggs to save costs",
                "6": "sold food containing carcinogens"
            },
            "tags": [
                "food",
                "beverages"
            ],
            "score": 43,
            "ownedBy": [
                "premier-foods"
            ],
            "logoUrl": "",
            "siteUrl": "https://www.batchelorsrange.co.uk/",
            "updatedAt": "2025-09-01T15:26:23.947Z",
            "key": "super-noodles"
        },
        "batchelors": {
            "names": [
                "Batchelors"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {
                "1": "unsafe working conditions",
                "2": "anticompetitive supplier practices",
                "3": "anticompetitive supplier practices",
                "4": "engaged in price fixing",
                "5": "reversed promise to use free range eggs to save costs",
                "6": "sold food containing carcinogens"
            },
            "tags": [
                "food",
                "beverages"
            ],
            "score": 43,
            "ownedBy": [
                "premier-foods"
            ],
            "logoUrl": "",
            "siteUrl": "https://www.batchelorsrange.co.uk/",
            "updatedAt": "2025-09-01T15:26:23.947Z",
            "key": "batchelors"
        },
        "cup-a-soup": {
            "names": [
                "Cup-a-Soup"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {
                "1": "unsafe working conditions",
                "2": "anticompetitive supplier practices",
                "3": "anticompetitive supplier practices",
                "4": "engaged in price fixing",
                "5": "reversed promise to use free range eggs to save costs",
                "6": "sold food containing carcinogens"
            },
            "tags": [
                "food",
                "beverages"
            ],
            "score": 43,
            "ownedBy": [
                "premier-foods"
            ],
            "logoUrl": "",
            "siteUrl": "https://www.batchelorsrange.co.uk/",
            "updatedAt": "2025-09-01T15:26:23.947Z",
            "key": "cup-a-soup"
        },
        "mr-kipling": {
            "names": [
                "Mr Kipling"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {
                "1": "unsafe working conditions",
                "2": "anticompetitive supplier practices",
                "3": "anticompetitive supplier practices",
                "4": "engaged in price fixing",
                "5": "reversed promise to use free range eggs to save costs",
                "6": "sold food containing carcinogens"
            },
            "tags": [
                "food",
                "beverages"
            ],
            "score": 43,
            "ownedBy": [
                "premier-foods"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/5/50/Mr_Kipling_logo.png",
            "siteUrl": "http://mrkipling.co.uk/",
            "updatedAt": "2025-09-01T15:26:23.947Z",
            "key": "mr-kipling"
        },
        "bird's-custard": {
            "names": [
                "Bird's Custard"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {
                "1": "unsafe working conditions",
                "2": "anticompetitive supplier practices",
                "3": "anticompetitive supplier practices",
                "4": "engaged in price fixing",
                "5": "reversed promise to use free range eggs to save costs",
                "6": "sold food containing carcinogens"
            },
            "tags": [
                "food",
                "beverages"
            ],
            "score": 43,
            "ownedBy": [
                "premier-foods"
            ],
            "logoUrl": "",
            "siteUrl": "",
            "updatedAt": "2025-09-01T15:26:23.947Z",
            "key": "bird's-custard"
        },
        "bayer": {
            "names": [
                "Bayer",
                "Bayer AG",
                "BAYN"
            ],
            "comment": "Bayer is a German multinational pharmaceutical and life sciences company which used bribery and false advertising to sell unnecessary drugs [1], sold Monsanto herbicides linked to cancer [2][3][4], and contaminated water sources with toxic chemicals [5][6]. Bayer also rushed production processes that led to an explosion killing two people [7], sold contraceptive coils that caused serious health issues [8], knowingly supplied HIV‑contaminated medications in Asia and Latin America [9], and supported the Nazis by producing Zyklon B for gas chambers [10].",
            "sources": {
                "1": "https://www.justice.gov/archives/opa/pr/bayer-pay-40-million-resolve-alleged-use-kickbacks-and-false-statements-relating-three-drugs",
                "2": "https://www.usatoday.com/story/news/2018/08/10/jury-orders-monsanto-pay-289-million-cancer-patient-roundup-lawsuit/962297002/",
                "3": "https://www.washingtonpost.com/business/2019/07/26/judge-cuts-billion-award-couple-with-cancer-million-roundup-lawsuit",
                "4": "https://www.wsj.com/articles/bayer-loses-roundup-appeal-11595275537",
                "5": "https://www.reuters.com/article/us-bayer-pcb-settlement-idUSKBN28B3G0/",
                "6": "https://wtop.com/dc/2020/05/dcs-top-prosecutor-sues-herbicide-maker-for-decades-of-chemical-dumping/",
                "7": "https://cen.acs.org/articles/89/i4/Bayer-Accused-Skirting-Safety.html",
                "8": "https://www.law360.com/articles/1303088/bayer-pays-1-6b-to-settle-suits-over-essure-contraceptive",
                "9": "https://www.tandfonline.com/doi/abs/10.1080/08989621.2014.882780",
                "10": "https://encyclopedia.ushmm.org/content/en/article/bayer"
            },
            "sourceNotes": {
                "1": "used bribes and false advertising to sell drugs that were not neccessary",
                "2": "bayer subsidiary monsanto sold herbicides that caused cancer",
                "3": "bayer subsidiary monsanto sold herbicides that caused cancer",
                "4": "bayer subsidiary monsanto sold herbicides that caused cancer",
                "5": "contaminated water sources with toxic chemicals",
                "6": "contaminated water sources with toxic chemicals",
                "7": "rushed production processes leading to an explosion that killed two people",
                "8": "sold contraceptive coils that caused serious health issues",
                "9": "knowingly supplied HIV-contaminated medications to patients in asian and latin america",
                "10": "supported the nazis and produced zyklon B for gas chambers"
            },
            "tags": [
                "pharmaceuticals",
                "chemicals",
                "corruption",
                "deception",
                "environmental violations",
                "unsustainable practices",
                "unsafe practices",
                "unsafe working conditions"
            ],
            "score": 2,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/f/f7/Logo_Bayer.svg",
            "siteUrl": "https://www.bayer.com/",
            "updatedAt": "2025-09-05T15:18:12.583Z",
            "key": "bayer"
        },
        "beats": {
            "names": [
                "Beats",
                "Beats by Dre",
                "Beats Electronics",
                "Beats Electronics, LLC",
                "Beats by Dr. Dre"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "electronics",
                "music"
            ],
            "score": 55,
            "ownedBy": [
                "apple"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/17/Beats_Electronics_logo.svg",
            "siteUrl": "https://beatsbydre.com/",
            "updatedAt": "2025-09-06T20:00:16.924Z",
            "key": "beats"
        },
        "shazam": {
            "names": [
                "Shazam"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "music",
                "tech"
            ],
            "score": 55,
            "ownedBy": [
                "apple"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/d/d2/Shazam_logo.svg",
            "siteUrl": "https://www.shazam.com/",
            "updatedAt": "2025-09-06T20:08:34.243Z",
            "key": "shazam"
        },
        "benefit": {
            "names": [
                "Benefit",
                "Benefit Cosmetics",
                "Benefit Cosmetics LLC"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 34,
            "ownedBy": [
                "lvmh"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/8c/Benefit_Cosmetics_logo.svg",
            "siteUrl": "https://benefitcosmetics.com/",
            "updatedAt": "2025-09-06T20:08:34.243Z",
            "key": "benefit"
        },
        "bic": {
            "names": [
                "Bic",
                "Société Bic",
                "Société Bic S.A.",
                "BIC",
                "BB"
            ],
            "comment": "Bic is a consumer goods company that has been accused of greenwashing and deception in their advertising [1], sexist advertising [2], and animal testing [3].",
            "sources": {
                "1": "https://sustainablegraphicdesign.blogspot.com/2010/06/greenwashing-bic-pens-wins-our.html",
                "2": "https://www.bbc.co.uk/news/world-africa-33893386",
                "3": "https://crueltyfree.peta.org/wp-content/uploads/companies-do-test.pdf"
            },
            "sourceNotes": {
                "1": "greenwashing and deception in their advertising ",
                "2": "sexist advertising",
                "3": "animal testing"
            },
            "tags": [
                "manufacturing",
                "greenwashing",
                "deception",
                "gender discrimination",
                "animal abuse"
            ],
            "score": 47,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/c/c7/Bic_%28company%29_Logo.svg",
            "siteUrl": "https://us.bic.com/en_us",
            "updatedAt": "2025-09-06T20:12:40.456Z",
            "key": "bic"
        },
        "pvh": {
            "names": [
                "PVH",
                "PVH Corp.",
                "Phillips-Van Heusen Corporation"
            ],
            "comment": "PVH is a global apparel and fashion company whose supply chain has polluted rivers in China [1] and has been accused of using forced Uyghur labour [2]. PVH has also faced criticism for failing to pay overtime to employees [3].",
            "sources": {
                "1": "https://www.greenpeace.org/international/publication/7168/dirty-laundry/",
                "2": "https://www.aspi.org.au/report/uyghurs-sale",
                "3": "https://www.law360.com/articles/849298/tommy-hilfiger-parent-to-pay-3-3m-to-end-ot-suit"
            },
            "sourceNotes": {
                "1": "supply chain polluted rivers in china",
                "2": "forced utghur labour in supply chain",
                "3": "failed to pay overtime to employees"
            },
            "tags": [
                "clothing",
                "environmental violations",
                "forced uyghur labour",
                "unfair pay"
            ],
            "score": 45,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/f/f1/PVH_logo.svg",
            "siteUrl": "http://www.pvh.com/",
            "updatedAt": "2025-09-07T21:34:52.092Z",
            "key": "pvh"
        },
        "calvin-klein": {
            "names": [
                "Calvin Klein",
                "Calvin Klein Inc."
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing"
            ],
            "score": 45,
            "ownedBy": [
                "pvh"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/a6/Calvin_klein_logo_web23.svg",
            "siteUrl": "http://calvinklein.com/",
            "updatedAt": "2025-09-07T21:57:23.057Z",
            "key": "calvin-klein"
        },
        "tommy-hilfiger": {
            "names": [
                "Tommy Hilfiger",
                "Tommy Hilfiger B.V.",
                "Tommy Hilfiger Inc."
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing"
            ],
            "score": 45,
            "ownedBy": [
                "pvh"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/26/Tommy_hilfig_vectorlogo.svg",
            "siteUrl": "https://global.tommy.com/",
            "updatedAt": "2025-09-07T21:57:23.057Z",
            "key": "tommy-hilfiger"
        },
        "billabong": {
            "names": [
                "Billabong",
                "Billabong International Limited"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing"
            ],
            "score": 40,
            "ownedBy": [
                "authentic-brands-group"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/c/c8/Billabong_logo.svg",
            "siteUrl": "https://www.billabong.com/",
            "updatedAt": "2025-09-09T19:56:36.347Z",
            "key": "billabong"
        },
        "roxy": {
            "names": [
                "Roxy"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing"
            ],
            "score": 40,
            "ownedBy": [
                "authentic-brands-group"
            ],
            "logoUrl": "https://seeklogo.com/images/R/roxy-logo-DD2027C284-seeklogo.com.png",
            "siteUrl": "https://www.roxy.com/",
            "updatedAt": "2025-09-09T19:56:36.347Z",
            "key": "roxy"
        },
        "airwalk": {
            "names": [
                "Airwalk"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing"
            ],
            "score": 40,
            "ownedBy": [
                "authentic-brands-group"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/cf/Airwalk_Logo.svg",
            "siteUrl": "http://www.airwalk.com/",
            "updatedAt": "2025-09-09T19:56:36.347Z",
            "key": "airwalk"
        },
        "vision-street-wear": {
            "names": [
                "Vision Street Wear"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing"
            ],
            "score": 40,
            "ownedBy": [
                "authentic-brands-group"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Vision_streetwear_logo.png/120px-Vision_streetwear_logo.png.png",
            "siteUrl": "https://visionstreetwear.com/",
            "updatedAt": "2025-09-09T19:56:36.347Z",
            "key": "vision-street-wear"
        },
        "ted-baker": {
            "names": [
                "Ted Baker"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing"
            ],
            "score": 40,
            "ownedBy": [
                "authentic-brands-group"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/3a/TedBaker.svg",
            "siteUrl": "http://tedbaker.com/",
            "updatedAt": "2025-09-09T19:56:36.347Z",
            "key": "ted-baker"
        },
        "tapout": {
            "names": [
                "Tapout"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing"
            ],
            "score": 40,
            "ownedBy": [
                "authentic-brands-group"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Tapout_brand_logo.png/120px-Tapout_brand_logo.png.png",
            "siteUrl": "https://tapout.com/",
            "updatedAt": "2025-09-09T19:56:36.347Z",
            "key": "tapout"
        },
        "aeropostale": {
            "names": [
                "Aéropostale"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing"
            ],
            "score": 40,
            "ownedBy": [
                "authentic-brands-group"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/Aeropostale_logo17.png/120px-Aeropostale_logo17.png.png",
            "siteUrl": "https://www.aeropostale.com/",
            "updatedAt": "2025-09-09T19:56:36.347Z",
            "key": "aeropostale"
        },
        "forever-21": {
            "names": [
                "Forever 21",
                "F21 OpCo LLC",
                "Fashion 21"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing"
            ],
            "score": 40,
            "ownedBy": [
                "authentic-brands-group"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/ae/Forever_21_logo.svg",
            "siteUrl": "http://forever21.com/",
            "updatedAt": "2025-09-09T19:56:36.347Z",
            "key": "forever-21"
        },
        "brooks-brothers": {
            "names": [
                "Brooks Brothers",
                "Brooks Brothers Inc."
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing"
            ],
            "score": 40,
            "ownedBy": [
                "authentic-brands-group"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/7/7c/Brooks_Brothers_new_logo.svg",
            "siteUrl": "https://www.brooksbrothers.com/",
            "updatedAt": "2025-09-09T19:56:36.347Z",
            "key": "brooks-brothers"
        },
        "champion": {
            "names": [
                "Champion",
                "Champion U.S.A."
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing"
            ],
            "score": 40,
            "ownedBy": [
                "authentic-brands-group"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/6f/Champion_USA_logo.svg",
            "siteUrl": "https://www.champion.com/",
            "updatedAt": "2025-09-09T19:56:36.347Z",
            "key": "champion"
        },
        "dc-shoes": {
            "names": [
                "DC Shoes",
                "DC Shoes, Inc."
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing"
            ],
            "score": 40,
            "ownedBy": [
                "authentic-brands-group"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/7/70/DCSHOECOUSA_Logo.svg",
            "siteUrl": "http://www.dcshoes.com/",
            "updatedAt": "2025-09-09T19:56:36.347Z",
            "key": "dc-shoes"
        },
        "juicy-couture": {
            "names": [
                "Juicy Couture"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing"
            ],
            "score": 40,
            "ownedBy": [
                "authentic-brands-group"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ce/Juicy_Couture_logo.svg/120px-Juicy_Couture_logo.svg.png",
            "siteUrl": "https://juicycouture.com/",
            "updatedAt": "2025-09-09T19:56:36.347Z",
            "key": "juicy-couture"
        },
        "lucky-brand": {
            "names": [
                "Lucky Brand",
                "Lucky Brand Jeans"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing"
            ],
            "score": 40,
            "ownedBy": [
                "authentic-brands-group"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/74/Lucky_Brand_Jeans_logo.svg",
            "siteUrl": "http://www.luckybrand.com/",
            "updatedAt": "2025-09-09T19:56:36.347Z",
            "key": "lucky-brand"
        },
        "nautica": {
            "names": [
                "Nautica"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing"
            ],
            "score": 40,
            "ownedBy": [
                "authentic-brands-group"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/2/22/Nautica_%28clothing_logo%29.png",
            "siteUrl": "http://www.nautica.com/",
            "updatedAt": "2025-09-09T19:56:36.347Z",
            "key": "nautica"
        },
        "reebok": {
            "names": [
                "Reebok"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing"
            ],
            "score": 40,
            "ownedBy": [
                "authentic-brands-group"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/11/Reebok_red_logo.svg",
            "siteUrl": "https://www.reebok.com/us/",
            "updatedAt": "2025-09-09T19:56:36.347Z",
            "key": "reebok"
        },
        "nine-west": {
            "names": [
                "Nine West",
                "9 West"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing"
            ],
            "score": 40,
            "ownedBy": [
                "authentic-brands-group"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/26/Nine_West_logo.png/120px-Nine_West_logo.png.png",
            "siteUrl": "https://ninewest.com/",
            "updatedAt": "2025-09-09T19:56:36.347Z",
            "key": "nine-west"
        },
        "authentic-brands-group": {
            "names": [
                "Authentic Brands Group",
                "Authentic Brands Group LLC",
                "ABG"
            ],
            "comment": "Authentic Brands Group is an American private equity firm that has been connected to forced labour in Chinese factories [1].",
            "sources": {
                "1": "https://www.ituc-csi.org/apparel-brands-Uyghur-forced-labour"
            },
            "sourceNotes": {
                "1": "connected to forced labour in china"
            },
            "tags": [
                "private equity",
                "forced labour"
            ],
            "score": 40,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/Authentic_2024_Logo.jpg/120px-Authentic_2024_Logo.jpg.png",
            "siteUrl": "https://corporate.authentic.com/",
            "updatedAt": "2025-09-10T20:59:37.727Z",
            "key": "authentic-brands-group"
        },
        "black-and-decker": {
            "names": [
                "Black & Decker"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "electronics"
            ],
            "score": 24,
            "ownedBy": [
                "stanley-black-and-decker"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b9/Black%2BDecker_Logo.svg/120px-Black%2BDecker_Logo.svg.png",
            "siteUrl": "http://blackanddecker.com/",
            "updatedAt": "2025-09-10T22:09:41.231Z",
            "key": "black-and-decker"
        },
        "stanley-black-and-decker": {
            "names": [
                "Stanley Black & Decker",
                "Stanley Black & Decker, Inc.",
                "The Stanley Works",
                "Stanley",
                "SWK"
            ],
            "comment": "Stanley Black & Decker is a multinational tool and security company that has hidden payments to executives [1] and underpaid field technicians and other employees [2][3]. The firm has continued to sell known unsafe garden tools that caused injuries [4][5] and removed LGBTQ and DEI content from its websites [6].",
            "sources": {
                "1": "https://www.sec.gov/newsroom/press-releases/2023-111",
                "2": "https://www.law360.com/articles/577611/black-decker-shells-out-5m-to-settle-wage-class-action",
                "3": "https://www.law360.com/articles/391580/judge-oks-class-settlement-in-black-decker-wages-suit",
                "4": "https://web.archive.org/web/20150511182124/http://www.cpsc.gov/en/Newsroom/News-Releases/2015/Black-and-Decker-Agrees-to-1575-Million-Dollar-Civil-Penalty-Internal-Compliance-Program-for-Failure-to-Report-Defective-Lawnmowers/",
                "5": "https://web.archive.org/web/20130420152711/http://www.cpsc.gov/en/newsroom/news-releases/2011/black--decker-agrees-to-960000-civil-penalty-for-failing-to-report-defective-grasshog-xp-weed-trimmeredgers/",
                "6": "https://www.dailymail.co.uk/news/article-13834661/toolmaker-stanley-black-decker-dei-lgbtq-campaign-website-boycott.html"
            },
            "sourceNotes": {
                "1": "hid payments to executives",
                "2": "deprived field technichians of proper wages and underpaid employees",
                "3": "deprived field technichians of proper wages and underpaid employees",
                "4": "continued to sell known unsafe garden tools which injured multiple people",
                "5": "continued to sell known unsafe garden tools which injured multiple people",
                "6": "removed LGBTQ and DEI content from its websites"
            },
            "tags": [
                "retail",
                "electronics",
                "corruption",
                "deception",
                "unfair pay",
                "unsafe practices"
            ],
            "score": 24,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/2c/Stanley_Black_%26_Decker_Logo.svg",
            "siteUrl": "https://stanleyblackanddecker.com/",
            "updatedAt": "2025-09-13T17:14:54.841Z",
            "key": "stanley-black-and-decker"
        },
        "dewalt": {
            "names": [
                "DeWalt"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "power tools"
            ],
            "score": 24,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/89/DeWalt_Logo.svg",
            "siteUrl": "https://www.dewalt.com/",
            "updatedAt": "2025-09-13T17:14:54.841Z",
            "key": "dewalt"
        },
        "irwin": {
            "names": [
                "Irwin",
                "Irwin Industrial Tools",
                "Irwin Auger Bit Company"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "power tools"
            ],
            "score": 24,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/d/dd/Irwin_Tools_logo.svg",
            "siteUrl": "https://www.irwin.com/",
            "updatedAt": "2025-09-13T17:14:54.841Z",
            "key": "irwin"
        },
        "boden": {
            "names": [
                "Boden"
            ],
            "comment": "Boden is a British clothing retailer with an emphasis on sustainability. Its childrens clothing catalogue and clothing has been accused of perpetuating gender stereotypes [1][2].",
            "sources": {
                "1": "https://ww.fashionnetwork.com/news/Boden-accused-of-kidswear-sexism,1064107.html",
                "2": "https://www.dailymail.co.uk/femail/article-6577311/Boden-criticised-sexist-childrens-clothing.html"
            },
            "sourceNotes": {
                "1": "perpetuated gender stereotypes in its catalogue",
                "2": "perpetuated gender stereotypes in its childrens clothing"
            },
            "tags": [
                "clothing",
                "retail",
                "gender discrimination"
            ],
            "score": 45,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/8e/Boden_logo_green.svg",
            "siteUrl": "https://boden.com/",
            "updatedAt": "2025-09-13T17:14:54.841Z",
            "key": "boden"
        },
        "bloomingdale's": {
            "names": [
                "Bloomingdale's"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 17,
            "ownedBy": [
                "macy's"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/68/Bloomingdale%27s_Logo.svg",
            "siteUrl": "https://www.bloomingdales.com/",
            "updatedAt": "2025-09-13T17:14:54.841Z",
            "key": "bloomingdale's"
        },
        "macy's": {
            "names": [
                "Macy's",
                "Macy's, Inc.",
                "Federated Department Stores, Inc.",
                "Federated Department Stores",
                "M"
            ],
            "comment": "Macy's is an American retailer that has been accused of racially profiling customers [1][2][3], discriminating against disabled employees [4], underpaying its workforce [5], and illegally enforcing criminal background checks on minority job applicants [6]. The company also faces environmental violations involving irresponsible hazardous waste disposal [7] and was fined after an employee died in unsafe working conditions [8].",
            "sources": {
                "1": "https://www.cbsnews.com/news/macys-will-pay-650000-to-settle-racial-bias-claims/",
                "2": "https://www.cbsnews.com/newyork/news/report-sharpton-set-to-meet-with-macys-ceo-over-racial-profiling-claims/",
                "3": "https://www.huffpost.com/entry/macys-profiling-asian-shoppers-lawsuit_n_59c12e73e4b0186c2205dc2a",
                "4": "https://www.eeoc.gov/newsroom/macys-pay-75000-settle-eeoc-disability-discrimination-lawsuit",
                "5": "https://www.law360.com/articles/1215328/macy-s-drivers-get-3-5m-wage-deal-with-xpo-unit-approved",
                "6": "https://web.archive.org/web/20200905083449/https://www.reuters.com/article/macys-settlement/macys-settles-lawsuit-over-nyc-criminal-background-checks-of-minority-applicants-idUSL1N2G11CO",
                "7": "https://rivcoda.org/news/macys-llc-ordered-pay-16-million-environmental-violations",
                "8": "https://violationtracker.goodjobsfirst.org/violation-tracker/ca-macys-corporate-services-inc"
            },
            "sourceNotes": {
                "1": "racially profiled customers",
                "2": "racially profiled customers",
                "3": "racially profiled customers",
                "4": "discriminated against disabled employees",
                "5": "underpaid employees",
                "6": "illegally enforced criminal background checks on minority job applicants",
                "7": "environmental violations; irresposible disposal of hazardous waste",
                "8": "fined after an employee died in unsafe working conditions"
            },
            "tags": [
                "retail",
                "racial discrimination",
                "unfair pay",
                "environmental violations",
                "unsafe working conditions"
            ],
            "score": 17,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/a6/Macy%27s_logo.svg",
            "siteUrl": "http://macys.com/",
            "updatedAt": "2025-09-13T17:14:54.841Z",
            "key": "macy's"
        },
        "bluemercury": {
            "names": [
                "Bluemercury"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {
                "1": "racially profiled customers",
                "2": "racially profiled customers",
                "3": "racially profiled customers",
                "4": "discriminated against disabled employees",
                "5": "underpaid employees",
                "6": "illegally enforced criminal background checks on minority job applicants",
                "7": "environmental violations; irresposible disposal of hazardous waste",
                "8": "fined after an employee died in unsafe working conditions"
            },
            "tags": [
                "retail"
            ],
            "score": 17,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/Bluemercury_Makeup_Skincare_Spa.jpg/120px-Bluemercury_Makeup_Skincare_Spa.jpg.png",
            "siteUrl": "http://www.bluemercury.com/",
            "updatedAt": "2025-09-13T17:14:54.841Z",
            "key": "bluemercury"
        },
        "booking.com": {
            "names": [
                "Booking.com"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "travel",
                "tech"
            ],
            "score": 34,
            "ownedBy": [
                "booking-holdings"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/be/Booking.com_logo.svg",
            "siteUrl": "https://booking.com/",
            "updatedAt": "2025-09-14T16:24:42.245Z",
            "key": "booking.com"
        },
        "priceline.com": {
            "names": [
                "Priceline.com"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "travel",
                "tech"
            ],
            "score": 34,
            "ownedBy": [
                "booking-holdings"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/e/e1/Priceline.com_logo.svg",
            "siteUrl": "http://www.priceline.com/",
            "updatedAt": "2025-09-14T16:24:42.245Z",
            "key": "priceline.com"
        },
        "agoda": {
            "names": [
                "Agoda"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "travel",
                "tech"
            ],
            "score": 34,
            "ownedBy": [
                "booking-holdings"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/a4/Agoda_logo_2019.svg",
            "siteUrl": "https://www.agoda.com/",
            "updatedAt": "2025-09-14T16:24:42.245Z",
            "key": "agoda"
        },
        "kayak": {
            "names": [
                "Kayak",
                "KAYAK"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "travel",
                "tech"
            ],
            "score": 34,
            "ownedBy": [
                "booking-holdings"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/cb/Kayak_Logo.svg",
            "siteUrl": "https://www.kayak.com/",
            "updatedAt": "2025-09-14T16:24:42.245Z",
            "key": "kayak"
        },
        "opentable": {
            "names": [
                "OpenTable"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "travel",
                "tech"
            ],
            "score": 34,
            "ownedBy": [
                "booking-holdings"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/1a/OpenTable_logo.svg",
            "siteUrl": "https://opentable.com/",
            "updatedAt": "2025-09-14T16:24:42.245Z",
            "key": "opentable"
        },
        "momondo": {
            "names": [
                "Momondo",
                "momondo"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "travel",
                "tech"
            ],
            "score": 34,
            "ownedBy": [
                "booking-holdings"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/0/0c/Momondo_A-S_logo.svg",
            "siteUrl": "http://momondo.com/",
            "updatedAt": "2025-09-14T16:24:42.245Z",
            "key": "momondo"
        },
        "booking-holdings": {
            "names": [
                "Booking  Holdings",
                "Booking Holdings Inc."
            ],
            "comment": "Booking Holdings is a global online travel conglomerate which has been implicated in anti‑competitive collusion and unfair pricing practices [1][2][3]. It has been criticized for failing to pay small hotels while distributing billions to shareholders and seeking pandemic government aid [4][5], and for operating in illegal Israeli settlements in the West Bank [6][7].",
            "sources": {
                "1": "https://webarchive.nationalarchives.gov.uk/ukgwa/20140402153926/http://www.oft.gov.uk/OFTwork/competition-act-and-cartels/ca98/closure/online-booking/",
                "2": "https://www.reuters.com/article/us-turkey-tourism-booking-idUSKBN1701XC",
                "3": "https://gulfnews.com/travel/only-one-room-left-bookingcom-faces-massive-lawsuits-over-anti-competitive-practices-market-abuse-deceptive-pricing-fabricated-scarcity-tactics-1.500230124",
                "4": "https://www.theguardian.com/business/2023/oct/03/bookingcom-makes-a-fortune-so-why-is-it-leaving-its-bills-to-small-hotels-unpaid",
                "5": "https://www.bloomberg.com/news/articles/2020-04-24/tech-firm-s-call-for-help-draws-public-outcry-policy-rethink",
                "6": "https://www.ohchr.org/EN/NewsEvents/Pages/DisplayNews.aspx?NewsID=25542",
                "7": "https://www.justiceinfo.net/en/132249-is-booking-com-profiting-from-war-crimes-in-palestine.html"
            },
            "sourceNotes": {
                "1": "anticompetetive collusion",
                "2": "Booking.com was accused of violating Turkish competition law through unfair, anti‑competitive practices against travel agencies.",
                "3": "unfair pricing practices",
                "4": "failing to pay small hotels while paying shareholders billions",
                "5": "asked for government financial support during pandemic while paying shareholders billions",
                "6": "conducted operations in illegal israeli settlements in the west bank",
                "7": "conducted operations in illegal israeli settlements in the west bank"
            },
            "tags": [
                "travel",
                "tech",
                "anticompetitive practices",
                "unfair pay",
                "connections to israel"
            ],
            "score": 34,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/3d/Booking_Holdings_Inc._Logo.svg",
            "siteUrl": "http://bookingholdings.com/",
            "updatedAt": "2025-09-14T16:24:42.245Z",
            "key": "booking-holdings"
        },
        "boots": {
            "names": [
                "Boots"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": null,
            "ownedBy": [
                "sycamore-partners"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/d8/Boots_logo.svg",
            "siteUrl": "https://me.boots.com/",
            "updatedAt": "2025-09-14T16:24:42.245Z",
            "key": "boots"
        },
        "bt": {
            "names": [
                "BT",
                "BT Group plc",
                "British Telecom",
                "BT.A",
                "Electric Telegraph Company"
            ],
            "comment": "BT is a British telecommunications company that supplied military infrastructure used in drone strikes in Yemen and Somalia [1], overcharged customers by £600 million and concealed information about those overcharges [2][3][4], and engaged in price‑fixing schemes that underpaid freelancers [5]. It has also been responsible for failures that crippled the UK's emergency call handling system [6] and for unsafe working conditions that contributed to a technician's death due to lack of training [7].",
            "sources": {
                "1": "https://web.archive.org/web/20140521031829/http://www.reprieve.org.uk/media/downloads/2013_07_15_PUB_Complaint_to_UK_NCP_re_BT_plc.pdf",
                "2": "https://www.callclaim.co.uk/media/y5hlb5kd/2021-01-17-call-press-release-final.pdf",
                "3": "https://www.ofcom.org.uk/phones-and-broadband/service-quality/18m-in-refunds-and-credits-for-bt-customers-following-ofcom-enforcement",
                "4": "https://www.ofcom.org.uk/about-ofcom/latest/bulletins/competition-bulletins/all-closed-cases/cw_01217",
                "5": "https://www.cityam.com/sky-bt-img-itv-and-bbc-broadcasters-caught-in-freelancer-pay-fixing-scandal/",
                "6": "https://www.ofcom.org.uk/phones-and-broadband/telecoms-infrastructure/bt-fined-17.5m-for-999-call-handling-failures",
                "7": "https://www.ioshmagazine.com/2024/06/11/ps14m-fine-telecoms-giant-after-engineers-body-found-river"
            },
            "sourceNotes": {
                "1": "was involved in providing military infrastructure used in drone strikes in yemen and somalia",
                "2": "overcharged customers by £600 million",
                "3": "engaged in price fixing to underpay freelancers",
                "4": "hid information and overcharged customers",
                "5": "hid information and overcharged customers",
                "6": "responsible for problems that disabled the company's provision of the UK's emergency call handling system",
                "7": "unsafe working conditions and lack of training led to a technician's death"
            },
            "tags": [
                "telecommunications",
                "anticompetitive practices",
                "unfair pay",
                "unsafe working conditions",
                "deception"
            ],
            "score": 20,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/17/BT_Group_2022.svg",
            "siteUrl": "https://www.bt.com/about",
            "updatedAt": "2025-09-16T09:26:11.926Z",
            "key": "bt"
        },
        "openreach": {
            "names": [
                "Openreach",
                "Openreach Limited"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {
                "1": "was involved in providing military infrastructure used in drone strikes in yemen and somalia",
                "2": "overcharged customers by £600 million",
                "3": "engaged in price fixing to underpay freelancers",
                "4": "hid information and overcharged customers",
                "5": "hid information and overcharged customers",
                "6": "responsible for problems that disabled the company's provision of the UK's emergency call handling system",
                "7": "unsafe working conditions and lack of training led to a technician's death"
            },
            "tags": [
                "telecommunications"
            ],
            "score": 20,
            "ownedBy": [
                "bt"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/e/e7/Openreach_2023.svg",
            "siteUrl": "https://www.openreach.com/",
            "updatedAt": "2025-09-16T09:26:11.926Z",
            "key": "openreach"
        },
        "plusnet": {
            "names": [
                "Plusnet",
                "Plusnet plc"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {
                "1": "was involved in providing military infrastructure used in drone strikes in yemen and somalia",
                "2": "overcharged customers by £600 million",
                "3": "engaged in price fixing to underpay freelancers",
                "4": "hid information and overcharged customers",
                "5": "hid information and overcharged customers",
                "6": "responsible for problems that disabled the company's provision of the UK's emergency call handling system",
                "7": "unsafe working conditions and lack of training led to a technician's death"
            },
            "tags": [
                "telecommunications"
            ],
            "score": 20,
            "ownedBy": [
                "bt"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/a/ab/Plusnet_logo.svg",
            "siteUrl": "https://plus.net/",
            "updatedAt": "2025-09-16T09:26:11.926Z",
            "key": "plusnet"
        },
        "ee": {
            "names": [
                "EE",
                "EE Limited",
                "Everything Everywhere",
                "Everything Everywhere Limited"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {
                "1": "was involved in providing military infrastructure used in drone strikes in yemen and somalia",
                "2": "overcharged customers by £600 million",
                "3": "engaged in price fixing to underpay freelancers",
                "4": "hid information and overcharged customers",
                "5": "hid information and overcharged customers",
                "6": "responsible for problems that disabled the company's provision of the UK's emergency call handling system",
                "7": "unsafe working conditions and lack of training led to a technician's death"
            },
            "tags": [
                "telecommunications"
            ],
            "score": 20,
            "ownedBy": [
                "bt"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/7/7e/EE_Logo_2022.svg",
            "siteUrl": "https://ee.co.uk/",
            "updatedAt": "2025-09-16T09:26:11.926Z",
            "key": "ee"
        },
        "zoom": {
            "names": [
                "Zoom",
                "Zoom Communications",
                "Zoom Communications, Inc.",
                "Zoom Video Communications, Inc.",
                "Saasbee",
                "Saasbee, Inc."
            ],
            "comment": "Zoom is an American video‑conferencing platform that published terms of service permitting the company to train artificial intelligence on user data [1]. It has illegally shared user data with large technology firms [2][3] and, at the behest of the Chinese government, suspended the accounts of human‑rights activists discussing the 1989 Tiananmen Square incident [4][5].",
            "sources": {
                "1": "https://www.vox.com/technology/2023/8/9/23824799/zoom-ai-privacy-return-to-office",
                "2": "https://www.law360.com/articles/1486153/-85m-deal-over-zoombombing-gets-ok-despite-objections",
                "3": "https://www.npr.org/2021/08/01/1023468165/zoom-agrees-to-settle-a-privacy-lawsuit-for-85-million",
                "4": "https://time.com/5855033/zoom-ceo-eric-yuan-time100-talks/",
                "5": "https://techcrunch.com/2020/06/11/zoom-admits-to-shutting-down-activist-accounts-at-the-request-of-the-chinese-government/"
            },
            "sourceNotes": {
                "1": "published terms of service allowing training AI on user data",
                "2": "Illegally shared data with big tech companies",
                "3": "Illegally shared data with big tech companies",
                "4": "suspended the accounts of three human rights activists hosting Zoom calls discussing Beijing’s 1989 Tianamen Square incident at request of the chinese government",
                "5": "suspended the accounts of three human rights activists hosting Zoom calls discussing Beijing’s 1989 Tianamen Square incident at request of the chinese government"
            },
            "tags": [
                "tech",
                "telecommunications",
                "privacy violations",
                "data breach",
                "deception"
            ],
            "score": 42,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/11/Zoom_Logo_2022.svg",
            "siteUrl": "https://www.zoom.com/",
            "updatedAt": "2025-09-16T14:16:36.759Z",
            "key": "zoom"
        },
        "keybase": {
            "names": [
                "Keybase"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech"
            ],
            "score": 42,
            "ownedBy": [
                "zoom"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/bb/Keybase_logo_official.svg",
            "siteUrl": "https://keybase.io/",
            "updatedAt": "2025-09-16T14:16:36.759Z",
            "key": "keybase"
        },
        "morrocanoil": {
            "names": [
                "Morrocanoil"
            ],
            "comment": "Morrocanoil is an Israeli cosmetics company that has hid its connections with Israel [1][2] and sold shampoo containing carcinogens [3].",
            "sources": {
                "1": "https://electronicintifada.net/blogs/sarah-irving/moroccanoil-israeli-hair-products-glamorize-apartheid",
                "2": "https://www.cjpme.org/fs_154",
                "3": "https://ceh.org/latest/press-releases/lawsuit-launched-testing-finds-cancer-causing-chemical-in-100-shampoos-haircare-products/"
            },
            "sourceNotes": {
                "1": "Hiding connections with israel",
                "2": "Hiding connections with israel",
                "3": "sold shampoo containing carcinogens"
            },
            "tags": [
                "consumer goods",
                "connections to israel",
                "deception",
                "unsafe practices"
            ],
            "score": 43,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/50/Moroccanoil_logo.png/120px-Moroccanoil_logo.png.png",
            "siteUrl": "http://www.moroccanoil.com/",
            "updatedAt": "2025-09-17T06:38:19.310Z",
            "key": "morrocanoil"
        },
        "currys": {
            "names": [
                "Currys",
                "Currys plc",
                "Currys PC World",
                "PC World",
                "Dixons"
            ],
            "comment": "Currys is a UK electronics retailer that has sold numerous defective goods and delayed refunds [1][2], forced additional fees on customers [3], mis‑sold insurance to customers [4], and failed to pay minimum wage [5].",
            "sources": {
                "1": "https://www.which.co.uk/news/article/currys-pc-world-failing-customers-with-faulty-products-and-failed-deliveries-az2gl2v0bsxx",
                "2": "https://www.lbc.co.uk/article/c24c0532e4f640fb91eb0f315e02a2df-DWymFz_2/",
                "3": "https://www.google.com/url?sa=t&source=web&rct=j&opi=89978449&url=https://pcr-online.biz/2018/03/19/currys-pc-world-slammed-for-forcing-set-up-fees-on-customers/&ved=2ahUKEwj51fihyeCPAxVTQkEAHY_MBy0Q-tANegQINRAC&usg=AOvVaw00tKLXJZI3U6PKhFLf9e8R",
                "4": "https://www.fca.org.uk/fca-fines-the-carphone-warehouse-over-29-million-for-insurance-misselling",
                "5": "https://www.gov.uk/government/news/over-500-companies-named-for-not-paying-minimum-wage"
            },
            "sourceNotes": {
                "1": "sold numerous defective goods and delayed refunds",
                "2": "sold numerous defective goods and delayed refunds",
                "3": "forced additional fees on customers",
                "4": "mis-sold insurance to customers",
                "5": "falied to pay minimum wage"
            },
            "tags": [
                "retail",
                "tech",
                "unfair pay",
                "deception",
                "unsafe practices"
            ],
            "score": 46,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/42/Currys_Logo.svg",
            "siteUrl": "https://currys.co.uk/",
            "updatedAt": "2025-09-17T19:42:01.202Z",
            "key": "currys"
        },
        "carphone-warehouse": {
            "names": [
                "Carphone Warehouse"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "tech"
            ],
            "score": 46,
            "ownedBy": [
                "currys"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/c4/Carphone_Warehouse_logo.svg",
            "siteUrl": "https://www.carphonewarehouse.com/",
            "updatedAt": "2025-09-17T19:42:01.202Z",
            "key": "carphone-warehouse"
        },
        "yamaha-corporation": {
            "names": [
                "Yamaha Corporation",
                "ヤマハ株式会社",
                "Nippon Gakki Co., Ltd.",
                "日本楽器製造株式会社"
            ],
            "comment": "Yamaha Corporation is a Japanese musical equipment manufacturer that has engaged in price fixing [1][2][3].",
            "sources": {
                "1": "https://www.gov.uk/cma-cases/musical-instruments-and-equipment-suspected-anti-competitive-agreements-50565-6",
                "2": "https://www.ashurst.com/en/insights/cn08---fco-imposes-fines-of-21-million-on-manufacturers-and-retailers-of-musical-instruments/",
                "3": "https://pogustgoodhead.com/musical-price-fixing-scandal/"
            },
            "sourceNotes": {
                "1": "engaged in price fixing",
                "2": "engaged in price fixing",
                "3": "engaged in price fixing"
            },
            "tags": [
                "manufacturing",
                "music",
                "anticompetitive practices"
            ],
            "score": 48,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/9d/Yamaha_logo.svg",
            "siteUrl": "https://www.yamaha.com/en/",
            "updatedAt": "2025-09-17T19:39:20.441Z",
            "key": "yamaha-corporation"
        },
        "yamaha-motor-company": {
            "names": [
                "Yamaha Motor Company",
                "Yamaha Motor Co.",
                "Yamaha Motor Co., Ltd.",
                "ヤマハ発動機株式会社"
            ],
            "comment": "Yamaha Motor Company is a Japanese motor vehicle manufacturer that has sold vehicles not meeting emissions standards [1], and has also falsified emissions data on multiple occasions [2][3].",
            "sources": {
                "1": "https://ww2.arb.ca.gov/news/yamaha-fined-22-million-violating-air-quality-rules",
                "2": "https://www.popularmechanics.com/cars/car-technology/a22691073/suzuki-mazda-yamaha-all-used-falsified-emissions-data/",
                "3": "https://english.kyodonews.net/articles/-/48487"
            },
            "sourceNotes": {
                "1": "sold vehicles not meeting emissions standards",
                "2": "falsified emissions data",
                "3": "falsified emissions data"
            },
            "tags": [
                "cars",
                "manufacturing",
                "deception",
                "greenwashing",
                "environmental violations"
            ],
            "score": 45,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1b/Yamaha_Motor_2025.svg/120px-Yamaha_Motor_2025.svg.png",
            "siteUrl": "https://global.yamaha-motor.com/",
            "updatedAt": "2025-09-17T19:39:20.441Z",
            "key": "yamaha-motor-company"
        },
        "xbox": {
            "names": [
                "Xbox"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "video games",
                "tech"
            ],
            "score": 35,
            "ownedBy": [
                "microsoft"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/d/d7/Xbox_logo_%282019%29.svg",
            "siteUrl": "https://xbox.com/",
            "updatedAt": "2025-09-17T19:39:20.441Z",
            "key": "xbox"
        },
        "callaway": {
            "names": [
                "Callaway",
                "Callaway Golf Company",
                "Topgolf Callaway Brands",
                "Topgolf Callaway Brands Corp.",
                "MODG"
            ],
            "comment": "Callaway is an American golf equipment company that has been accused of misleading marketing practices [1] and unsafe working conditions at its factories [2][3]. Additionally, employees at its Topgolf locations have faced sexual harassment and wage theft [4][5][6].",
            "sources": {
                "1": "https://mygolfspy.com/news-opinion/callaways-2-clubs-longer-claim-is-misleading/",
                "2": "https://www.osha.gov/ords/imis/establishment.inspection_detail?id=125932418",
                "3": "https://www.osha.gov/ords/imis/establishment.inspection_detail?id=301275202",
                "4": "https://www.restaurantdive.com/news/report-54-of-topgolf-employees-report-being-sexually-harassed/611136/",
                "5": "https://www.ktnv.com/13-investigates/new-lawsuit-accuses-topgolf-of-covering-up-for-serial-sexual-predator-in-dehumanizing-toxic-work-environment",
                "6": "https://www.reviewjournal.com/crime/sex-crimes/topgolf-las-vegas-cases-triggered-national-study-on-sexual-harassment-2497841/"
            },
            "sourceNotes": {
                "1": "misleading marketing",
                "2": "unsafe working conditions",
                "3": "unsafe working conditions",
                "4": "sexual harassment and wage theft at topgolf locations",
                "5": "sexual harassment and wage theft at topgolf locations",
                "6": "sexual harassment and wage theft at topgolf locations"
            },
            "tags": [
                "retail",
                "sport",
                "deception",
                "unsafe working conditions",
                "sexual harassment",
                "unfair pay"
            ],
            "score": 38,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/52/Topgolf_company_brands.svg",
            "siteUrl": "https://www.callawaygolf.com/",
            "updatedAt": "2025-09-19T21:19:46.742Z",
            "key": "callaway"
        },
        "topgolf": {
            "names": [
                "Topgolf",
                "Topgolf Entertainment Group",
                "Topgolf International, Inc."
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {
                "1": "misleading marketing",
                "2": "unsafe working conditions",
                "3": "unsafe working conditions",
                "4": "sexual harassment and wage theft at topgolf locations",
                "5": "sexual harassment and wage theft at topgolf locations",
                "6": "sexual harassment and wage theft at topgolf locations"
            },
            "tags": [
                "retail",
                "sport"
            ],
            "score": 38,
            "ownedBy": [
                "callaway"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/96/Topgolf_Logo.svg",
            "siteUrl": "https://www.topgolf.com/",
            "updatedAt": "2025-09-19T21:19:46.742Z",
            "key": "topgolf"
        },
        "canon": {
            "names": [
                "Canon",
                "Canon Inc.",
                "キヤノン株式会社",
                "Kyanon kabushiki gaisha",
                "Precision Optical Industry Co. Ltd.",
                "Canon Camera Co., Inc"
            ],
            "comment": "Canon is a Japanese multinational corporation accused of anti-competitive conduct [1][2], failing to pay technicians for overtime and breaks [3], and engaging in predatory printer ink sales practices [4]. Canon has also been linked to climate change denial groups [5][6].",
            "sources": {
                "1": "https://www.cfo.com/news/canon-toshiba-fined-over-antitrust-violations/657745/",
                "2": "https://www.reuters.com/business/eu-court-backs-29-mln-eu-gun-jumping-fine-against-canon-2022-05-18/",
                "3": "https://www.law360.com/articles/518867/canon-s-4-4m-flsa-settlement-wins-court-approval",
                "4": "https://www.businessinsider.com/canon-printers-class-action-lawsuit-filed-over-printers-2021-10",
                "5": "https://www.theguardian.com/environment/2022/feb/27/thinktank-linked-to-tech-giant-canon-under-pressure-to-remove-dangerous-climate-articles",
                "6": "https://energytracker.asia/canon-backed-think-tank-cigs-spreads-climate-change-denial/"
            },
            "sourceNotes": {
                "1": "anticompetitive conduct",
                "2": "anticompetitive conduct",
                "3": "failed to pay technicians on overtime and breaks",
                "4": "predatory printer ink sales practices",
                "5": "connected to climate change denial groups",
                "6": "connected to climate change denial groups"
            },
            "tags": [
                "electronics",
                "manufacturing",
                "anticompetitive practices",
                "unfair pay",
                "environmental violations"
            ],
            "score": 42,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/0a/Canon_wordmark.svg",
            "siteUrl": "https://global.canon/en/",
            "updatedAt": "2025-09-19T21:19:46.742Z",
            "key": "canon"
        },
        "axis-communications": {
            "names": [
                "Axis Communications",
                "Axis Communications AB"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {
                "1": "anticompetitive conduct",
                "2": "anticompetitive conduct",
                "3": "failed to pay technicians on overtime and breaks",
                "4": "predatory printer ink sales practices",
                "5": "connected to climate change denial groups",
                "6": "connected to climate change denial groups"
            },
            "tags": [
                "electronics",
                "manufacturing"
            ],
            "score": 42,
            "ownedBy": [
                "canon"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/2b/Axis_Communications_logo.svg",
            "siteUrl": "http://axis.com/",
            "updatedAt": "2025-09-19T21:19:46.742Z",
            "key": "axis-communications"
        },
        "nikon": {
            "names": [
                "Nikon",
                "Nikon Corporation",
                "株式会社ニコン",
                "Kabushiki-gaisha Nikon"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "electronics",
                "manufacturing"
            ],
            "score": 35,
            "ownedBy": [
                "mitsubishi"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/f/f3/Nikon_Logo.svg",
            "siteUrl": "https://www.nikon.com/",
            "updatedAt": "2025-09-19T21:19:46.742Z",
            "key": "nikon"
        },
        "jab-holding-company": {
            "names": [
                "JAB Holding Company",
                "JAB Holding Company S.à r.l.",
                "JAB",
                "Joh. A. Benckiser"
            ],
            "comment": "JAB Holding Company is a multinational corporation founded by individuals with Nazi sympathies [1][2]. The company illegally collected employees' fingerprints [3] and failed to maintain safe working conditions, which led to an employee nearly dying trapped in a freezer [4].",
            "sources": {
                "1": "https://www.nytimes.com/2019/03/25/world/europe/nazi-laborers-jab-holding.html",
                "2": "https://www.nbcbayarea.com/news/national-international/family-that-owns-krispy-kreme-panera-peets-coffee-acknowledges-nazi-past/159805/",
                "3": "https://www.law360.com/articles/1455415/pret-a-manger-would-pay-677k-to-end-fingerprint-suit",
                "4": "https://web.archive.org/web/20230831100239/https://www.westminster.gov.uk/news/pret-manger-fined-ps800000-after-cafe-worker-left-locked-walk-freezer",
                "5": "https://www.msn.com/en-us/money/companies/why-this-coffee-giant-is-staying-put-in-russia/ar-AA1frXiL"
            },
            "sourceNotes": {
                "1": "founded by firm nazi supporters",
                "2": "founded by firm nazi supporters",
                "3": "Illegally collected employees' fingerprints",
                "4": "unsafe working conditions led to an employee nearly dying trapped in a freezer",
                "5": "continued to operate in russia"
            },
            "tags": [
                "consumer goods",
                "coffee",
                "fast food",
                "privacy violations",
                "unsafe working conditions",
                "unsafe practices",
                "poor working conditions",
                "racial discrimination"
            ],
            "score": 35,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/9f/JAB_Holding_Company_Logo.svg",
            "siteUrl": "http://jabholco.com/",
            "updatedAt": "2025-09-21T14:29:22.220Z",
            "key": "jab-holding-company"
        },
        "carrefour": {
            "names": [
                "Carrefour",
                "Groupe Carrefour",
                "Carrefour Group, S.A.",
                "CA"
            ],
            "comment": "Carrefour is a French supermarket chain that has subjected employees to carbon monoxide poisoning [1], and sourced goods from supply chains involving animal abuse [2], slave labour [3], and illegal deforestation of the amazon rainforest [4][5]. Carrefour has subjected LGBT customers to discrimination [6], and refused to compensate the families of workers who were killed in the unsafe working conditions of one of its garment factories [7][8], while a young girl died in one if its stores after being electrocuted [9] and multiple people have been beaten and killed by store security guards [10][11].",
            "sources": {
                "1": "https://web.archive.org/web/20081013181813/http://www.detiknews.com/index.php/detik.read/tahun/2007/bulan/05/tgl/01/time/212433/idnews/774875/idkanal/10",
                "2": "https://noticias.uol.com.br/meio-ambiente/ultimas-noticias/rfi/2018/11/03/imagens-de-animais-cortados-vivos-em-abatedouro-chocam-a-franca.htm",
                "3": "https://web.archive.org/web/20200428183820/https://www.theguardian.com/global-development/2014/jun/10/supermarket-prawns-thailand-produced-slave-labour",
                "4": "https://www.lefigaro.fr/flash-eco/deforestation-en-amazonie-carrefour-interpelle-sur-ses-fournisseurs-20220905",
                "5": "https://www.20minutes.fr/planete/3346891-20220906-amazonie-carrefour-accuse-participer-deforestation-biais-fournisseurs",
                "6": "https://web.archive.org/web/20090829214838/http://portal.prefeitura.sp.gov.br/noticias/coordenadorias/diversidade_sexual/2008/09/0006",
                "7": "https://web.archive.org/web/20160325223918/http://www.dhakatribune.com/business/2013/nov/17/buyers%e2%80%99-compensation-rana-plaza-victims-far-reality",
                "8": "https://web.archive.org/web/20201114001448/http://edition.cnn.com/2013/05/14/world/asia/bangladesh-building-collapse-aftermath/",
                "9": "http://g1.globo.com/sao-paulo/noticia/2010/12/freezer-que-eletrocutou-e-matou-menina-em-hipermercado-e-periciado.html",
                "10": "https://agora.folha.uol.com.br/policia/ult10104u606868.shtml",
                "11": "https://web.archive.org/web/20201120164413/https://istoe.com.br/homem-negro-e-espancado-e-morto-em-supermercado-de-porto-alegre/"
            },
            "sourceNotes": {
                "1": "unsafe working conditions that led to carbon monoxide poisoning for multiple employees",
                "2": "animal abuse in supply chain",
                "3": "slave labour in supply chain",
                "4": "involved in illegal deforestation in the amazon",
                "5": "involved in illegal deforestation in the amazon",
                "6": "discriminated against LGBT customers",
                "7": "refused to compensate workers who were killed in unsafe rana plaza building collapse",
                "8": "refused to compensate workers who were killed in unsafe rana plaza building collapse",
                "9": "young girl electrocuted and killed in store",
                "10": "store security guards have murdered alleged shoplifters",
                "11": "store security guards murdered customer"
            },
            "tags": [
                "retail",
                "supermarket",
                "animal abuse",
                "forced labour",
                "deforestation",
                "unsustainable practices",
                "unsafe working conditions"
            ],
            "score": 4,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/6/65/Carrefour_Groupe.svg",
            "siteUrl": "https://www.carrefour.com/en/",
            "updatedAt": "2025-09-26T12:19:58.817Z",
            "key": "carrefour"
        },
        "cerave": {
            "names": [
                "CeraVe"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 15,
            "ownedBy": [
                "l'oreal"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/42/CeraVe_logo.png/120px-CeraVe_logo.png.png",
            "siteUrl": "https://www.cerave.com/",
            "updatedAt": "2025-09-27T20:34:26.706Z",
            "key": "cerave"
        },
        "aesop": {
            "names": [
                "Aesop"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 15,
            "ownedBy": [
                "l'oreal"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/4d/Aesop_logo_2013.svg",
            "siteUrl": "http://aesop.com/",
            "updatedAt": "2025-09-27T20:34:26.706Z",
            "key": "aesop"
        },
        "garnier": {
            "names": [
                "Garnier"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 15,
            "ownedBy": [
                "l'oreal"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/d6/Garnier_Logo.PNG",
            "siteUrl": "https://www.garnierusa.com/",
            "updatedAt": "2025-09-27T20:34:26.706Z",
            "key": "garnier"
        },
        "kiehl's": {
            "names": [
                "Kiehl's",
                "Kiehl's LLC"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 15,
            "ownedBy": [
                "l'oreal"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/d/d8/Kiehl%27s_logo.svg",
            "siteUrl": "http://kiehls.com/",
            "updatedAt": "2025-09-27T20:34:26.706Z",
            "key": "kiehl's"
        },
        "lancome": {
            "names": [
                "Lancôme",
                "Lancome"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 15,
            "ownedBy": [
                "l'oreal"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/42/Lanc%C3%B4me_logo.svg",
            "siteUrl": "http://www.lancome.com/",
            "updatedAt": "2025-09-27T20:34:26.706Z",
            "key": "lancome"
        },
        "maybelline": {
            "names": [
                "Maybelline"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 15,
            "ownedBy": [
                "l'oreal"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/a3/Maybelline-Logo.svg",
            "siteUrl": "http://maybelline.com/",
            "updatedAt": "2025-09-27T20:34:26.706Z",
            "key": "maybelline"
        },
        "nyx": {
            "names": [
                "NYX",
                "NYX DARIEN",
                "NYX Professional Makeup"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 15,
            "ownedBy": [
                "l'oreal"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/c/cb/NYX_cosmetics_logo.png",
            "siteUrl": "http://www.nyxcosmetics.com/",
            "updatedAt": "2025-09-27T20:34:26.706Z",
            "key": "nyx"
        },
        "cheesecake-factory": {
            "names": [
                "Cheesecake Factory",
                "The Cheesecake Factory",
                "The Cheesecake Factory Incorporated",
                "CAKE"
            ],
            "comment": "Cheesecake Factory is an American restaurant chain that has been criticized for using cruel pig cages in its supply chain [1] and for abusing undocumented workers [2][3]. The company has also withheld wages from hundreds of janitors [4], underpaid employees [5], and fired a worker in retaliation for a discrimination complaint [6].",
            "sources": {
                "1": "https://www.greenqueen.com.hk/gestation-cages-pigs-cage-free-kfc-dennys-taco-bell/",
                "2": "https://www.thestreet.com/restaurants/popular-restaurant-chain-slammed-with-lawsuit-by-undocumented-workers",
                "3": "https://www.business-humanrights.org/en/latest-news/usa-undocumented-workers-file-lawsuit-against-the-cheesecake-factory-alleging-wage-theft-denial-of-breaks-among-other-rights-violations-incl-co-comment/",
                "4": "https://www.nytimes.com/2018/06/12/business/cheesecake-factory-wage-theft.html",
                "5": "https://news.bloomberglaw.com/litigation/cheesecake-factory-accused-of-underpaying-its-tipped-workers",
                "6": "https://erlich.lawyer/2019/12/cheesecake-factory-sued-for-firing-worker-in-retaliation-for-discrimination-complaint/"
            },
            "sourceNotes": {
                "1": "uses cruel pig cages in supply chain",
                "2": "abused undocumented workers",
                "3": "abused undocumented workers",
                "4": "withheld wages from hundreds of janitors",
                "5": "underpaid employees",
                "6": "fired worker in retaliation for discrimination complaint"
            },
            "tags": [
                "food",
                "animal abuse",
                "unfair pay",
                "forced labour"
            ],
            "score": 22,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/d4/The_Cheesecake_Factory_%28logo%2C_stacked%29.svg",
            "siteUrl": "http://thecheesecakefactory.com/",
            "updatedAt": "2025-09-28T19:27:04.759Z",
            "key": "cheesecake-factory"
        },
        "chewy": {
            "names": [
                "Chewy"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "pets"
            ],
            "score": null,
            "ownedBy": [
                "bc-partners"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/63/Chewy_pet_food_logo.svg",
            "siteUrl": "http://chewy.com/",
            "updatedAt": "2025-09-28T20:20:37.193Z",
            "key": "chewy"
        },
        "chick-fil-a": {
            "names": [
                "Chick-fil-a"
            ],
            "comment": "Chick-fil-a is an American fast food chain that is deeply opposed to gay marriage [1][2][3]. The company has abused chickens in its supply chain [4] and underpaid its employees [5].",
            "sources": {
                "1": "https://web.archive.org/web/20180805233901/https://www.wsj.com/articles/SB10000872396390444840104577553341868014390",
                "2": "https://archive.sltrib.com/article.php?id=52888536&itype=CMSID",
                "3": "https://web.archive.org/web/20120727070937/http://www.ocregister.com/news/family-365324-chick-fil.html",
                "4": "https://www.change.org/p/help-the-simpsons-co-creator-sam-simon-take-a-bite-out-of-chick-fil-a-s-animal-cruelty",
                "5": "https://www.dol.gov/newsroom/releases/whd/whd20230928"
            },
            "sourceNotes": {
                "1": "deeply against gay marriage",
                "2": "deeply against gay marriage",
                "3": "deeply against gay marriage",
                "4": "unethical treatment of chickens in supply chain",
                "5": "underpaid employees"
            },
            "tags": [
                "food",
                "animal abuse",
                "unfair pay"
            ],
            "score": 25,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/02/Chick-fil-A_Logo.svg",
            "siteUrl": "http://www.chick-fil-a.com/",
            "updatedAt": "2025-09-28T20:33:35.035Z",
            "key": "chick-fil-a"
        },
        "cathedral-city": {
            "names": [
                "Cathedral City"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 18,
            "ownedBy": [
                "saputo"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/8/84/Cathedral_City_logo.jpg",
            "siteUrl": "https://cathedralcity.co.uk/",
            "updatedAt": "2025-09-27T18:07:05.707Z",
            "key": "cathedral-city"
        },
        "saputo": {
            "names": [
                "Saputo",
                "Saputo Inc.",
                "Dairy Crest",
                "Dairy Crest plc",
                "SAP"
            ],
            "comment": "Saputo is a Canadian dairy processing company that has underpaid employees [1], polluted local rivers [2], and seen animal abuse on its farms [3]. The company has also faced serious workplace safety issues including worker injuries [4] and employee deaths in unsafe conditions [5][6].",
            "sources": {
                "1": "https://www.classaction.org/news/saputo-dairy-foods-usa-failed-to-pay-employees-for-all-hours-worked-lawsuit-claims",
                "2": "https://www.dairyreporter.com/Article/2022/06/29/saputo-uk-s-dairy-crest-business-hit-with-largest-fine-ever-over-environmental-offences/",
                "3": "https://perishablenews.com/dairy/saputo-drops-milk-supplier-in-wake-of-video-scandal/",
                "4": "https://www.ohscanada.com/saputo-fined-75000-after-worker-injured-by-cheese-cutting-machine-in-tavistock-ont/",
                "5": "https://news.bloomberglaw.com/safety/saputo-inc-fined-after-cheese-guillotine-kills-worker",
                "6": "https://www.thesafetymag.com/ca/news/general/worker-killed-on-cheese-production-line-company-fined-150000/186696"
            },
            "sourceNotes": {
                "1": "underpaid employees",
                "2": "factories polluted local rivers",
                "3": "animal abuse on its farms",
                "4": "worker injured in unsafe working conditions",
                "5": "employee was killed in unsafe working conditions",
                "6": "employee was killed in unsafe working conditions"
            },
            "tags": [
                "food",
                "unfair pay",
                "animal abuse",
                "unsafe working conditions",
                "environmental violations"
            ],
            "score": 18,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/d/d9/Saputo_company_logo.svg",
            "siteUrl": "http://saputo.com/",
            "updatedAt": "2025-09-30T15:49:15.775Z",
            "key": "saputo"
        },
        "utterly-butterly": {
            "names": [
                "Utterly Butterly"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 18,
            "ownedBy": [
                "saputo"
            ],
            "logoUrl": "https://tse2.mm.bing.net/th/id/OIP.TwliERarD2edFCF5SzzpNgHaHa?pid=Api",
            "siteUrl": "https://uk.saputo.com/en/brands/utterly-butterly",
            "updatedAt": "2025-10-02T07:39:03.369Z",
            "key": "utterly-butterly"
        },
        "clover": {
            "names": [
                "Clover"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 18,
            "ownedBy": [
                "saputo"
            ],
            "logoUrl": "https://tse3.mm.bing.net/th/id/OIP.1HtnSnNhwcK_jnQdF9J-rwHaHa?pid=Api",
            "siteUrl": "https://uk.saputo.com/en/brands/clover",
            "updatedAt": "2025-10-02T07:39:03.369Z",
            "key": "clover"
        },
        "vitalite": {
            "names": [
                "Vitalite"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 18,
            "ownedBy": [
                "saputo"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/a/a4/Vitalite_logo.png",
            "siteUrl": "https://www.vitalitedairyfree.co.uk/en",
            "updatedAt": "2025-10-02T07:39:03.369Z",
            "key": "vitalite"
        },
        "country-life": {
            "names": [
                "Country Life"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 18,
            "ownedBy": [
                "saputo"
            ],
            "logoUrl": "https://tse3.mm.bing.net/th/id/OIP.Xr_AW9leQon6HjJJrhmxogHaHa?pid=Api",
            "siteUrl": "https://uk.saputo.com/en/brands/country-life",
            "updatedAt": "2025-10-02T07:39:03.369Z",
            "key": "country-life"
        },
        "fry-light": {
            "names": [
                "Fry Light"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 18,
            "ownedBy": [
                "saputo"
            ],
            "logoUrl": "https://saputo.canto.com/direct/image/nkl37pv1od56j6el5ehm8k092b/GIjnsDkSCVRWeY_0E1KpPMBxBCE/original?content-type=image%2Fpng&amp;name=Frylight-Logo.png",
            "siteUrl": "https://www.frylight.com/",
            "updatedAt": "2025-10-02T07:39:03.369Z",
            "key": "fry-light"
        },
        "sheese": {
            "names": [
                "Sheese"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 18,
            "ownedBy": [
                "saputo"
            ],
            "logoUrl": "https://saputo.canto.com/direct/image/8nse1d1shp2c3ba08rtj7nso2f/qyjJLnrZDZ-FSORjKDmjDHq_ge0/original?content-type=image%2Fpng&amp;name=sheese-logo-new.png",
            "siteUrl": "https://www.buteisland.com/en",
            "updatedAt": "2025-10-02T07:39:03.369Z",
            "key": "sheese"
        },
        "wensleydale-creamery": {
            "names": [
                "Wensleydale Creamery"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 18,
            "ownedBy": [
                "saputo"
            ],
            "logoUrl": "https://www.wensleydale.co.uk/images/modules/promo_units/xsmall/retina-1698327818-20065000.jpg",
            "siteUrl": "https://www.wensleydale.co.uk/",
            "updatedAt": "2025-10-02T07:39:03.369Z",
            "key": "wensleydale-creamery"
        },
        "davidstow-cheddar": {
            "names": [
                "Davidstow Cheddar"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 18,
            "ownedBy": [
                "saputo"
            ],
            "logoUrl": "https://saputo.canto.com/direct/image/t1ecovq2tl12ne5ed5fbgqhl7o/Hp_iwImFYufMidxJEQSF9VA40jY/original?content-type=image%2Fpng&amp;name=Davidstow_logo-beige.png",
            "siteUrl": "https://www.davidstowcheddar.co.uk/",
            "updatedAt": "2025-10-02T07:39:03.369Z",
            "key": "davidstow-cheddar"
        },
        "clarks": {
            "names": [
                "Clarks"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing"
            ],
            "score": null,
            "ownedBy": [
                "viva-china-holdings"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/d/d7/C_%26_J_Clarks_International_company_logo.svg",
            "siteUrl": "https://clarks.com/",
            "updatedAt": "2025-09-28T20:48:58.875Z",
            "key": "clarks"
        },
        "estee-lauder": {
            "names": [
                "Estee Lauder",
                "Estée Lauder",
                "The Estée Lauder Companies",
                "Estée Lauder Companies",
                "The Estée Lauder Companies Inc.",
                "EL"
            ],
            "comment": "Estee Lauder is an American cosmetics company whose founding family has expressed pro-Israel Zionist views [1], donated $5 million to Donald Trump [2], and suggested the U.S. purchase Greenland [3]. The company has underpaid employees [4], engaged in price fixing [5], sourced from factories using child labour [6][7][8], and seen sexual abuse of women on its palm oil farms [9].",
            "sources": {
                "1": "http://www.inminds.co.uk/boycott-estee-lauder.html",
                "2": "https://web.archive.org/web/20250802155110/https://www.nytimes.com/2025/08/02/us/politics/donor-list-suggests-scale-of-trumps-pay-for-access-operation.html",
                "3": "https://www.businessinsider.com/estee-lauder-heir-pitched-trump-plan-to-buy-greenland-book-2022-9",
                "4": "https://www.gov.uk/government/news/over-500-companies-named-for-not-paying-minimum-wage",
                "5": "https://greekcitytimes.com/2017/10/06/leading-cosmetics-brands-fined-price-fixing-greece/",
                "6": "https://littlethings.com/lifestyle/estee-lauder-and-loreal-linked-to-child-labor-bbc-investigation-finds",
                "7": "https://www.cxtoday.com/voice-of-the-customer/how-will-customers-react-to-the-loreal-estee-lauder-child-labour-scandal/",
                "8": "https://nypost.com/2001/04/09/state-probes-cult-in-child-labor-scandal-acting-on-heels-of-post-report/",
                "9": "https://apnews.com/article/palm-oil-abuse-investigation-cosmetics-2a209d60c42bf0e8fcc6f8ea6daa11c7"
            },
            "sourceNotes": {
                "1": "lauder family has pro-israel zionist views",
                "2": "lauder family donated $5 million to donald trump",
                "3": "suggestion for the US to buy greenland came from the lauder family",
                "4": "underpaid employees",
                "5": "engaged in price fixing",
                "6": "child labour in supply chain",
                "7": "child labour in supply chain",
                "8": "sourced products from a new york factory using child labour",
                "9": "sexual abuse of women in its palm oil farms"
            },
            "tags": [
                "consumer goods",
                "cosmetics",
                "anticompetitive practices",
                "unfair pay",
                "child labour",
                "sexual harassment",
                "connections to israel"
            ],
            "score": 15,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/79/Est%C3%A9e_Lauder_Companies_Logo.svg",
            "siteUrl": "http://elcompanies.com/",
            "updatedAt": "2025-09-28T20:58:45.533Z",
            "key": "estee-lauder"
        },
        "jo-malone": {
            "names": [
                "Jo Malone",
                "Jo Malone London"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "cosmetics"
            ],
            "score": 15,
            "ownedBy": [
                "estee-lauder"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d1/JoMalone_Logo.jpg/120px-JoMalone_Logo.jpg.png",
            "siteUrl": "https://www.jomalone.com/",
            "updatedAt": "2025-09-30T07:31:08.156Z",
            "key": "jo-malone"
        },
        "deciem": {
            "names": [
                "DECIEM"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "cosmetics"
            ],
            "score": 15,
            "ownedBy": [
                "estee-lauder"
            ],
            "logoUrl": "https://wp.sfdcdigital.com/en-us/wp-content/uploads/sites/4/2024/09/deciem-3.png?w=789",
            "siteUrl": "https://deciem.com/",
            "updatedAt": "2025-09-30T07:31:08.156Z",
            "key": "deciem"
        },
        "the-abnormal-beauty-company": {
            "names": [
                "The Abnormal Beauty Company"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "cosmetics"
            ],
            "score": 15,
            "ownedBy": [
                "estee-lauder"
            ],
            "logoUrl": "https://shopsquareone.com/wp-content/uploads/2021/09/8ae17ece7533a306a7ba191e807a8a769562d418.png",
            "siteUrl": "https://deciem.com/",
            "updatedAt": "2025-09-30T07:31:08.156Z",
            "key": "the-abnormal-beauty-company"
        },
        "bobbi-brown": {
            "names": [
                "Bobbi Brown"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "cosmetics"
            ],
            "score": 15,
            "ownedBy": [
                "estee-lauder"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/1b/Bobbi_Brown_logo_2013.gif",
            "siteUrl": "https://www.bobbibrown.com.au/",
            "updatedAt": "2025-09-30T07:31:08.156Z",
            "key": "bobbi-brown"
        },
        "clinique": {
            "names": [
                "Clinique",
                "Clinique Laboratories",
                "Clinique Laboratories, LLC"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "cosmetics"
            ],
            "score": 15,
            "ownedBy": [
                "estee-lauder"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/45/Clinique_logo.svg",
            "siteUrl": "http://www.clinique.com/",
            "updatedAt": "2025-09-30T07:31:08.156Z",
            "key": "clinique"
        },
        "mac-cosmetics": {
            "names": [
                "MAC Cosmetics",
                "M A C Cosmetics",
                "MAC",
                "M A C",
                "Make-Up Art Cosmetics"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "cosmetics"
            ],
            "score": 15,
            "ownedBy": [
                "estee-lauder"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/MAC_Cosmetics_logo.png/120px-MAC_Cosmetics_logo.png.png",
            "siteUrl": "https://www.maccosmetics.com/",
            "updatedAt": "2025-09-30T07:31:08.156Z",
            "key": "mac-cosmetics"
        },
        "the-ordinary": {
            "names": [
                "The Ordinary"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "cosmetics"
            ],
            "score": 15,
            "ownedBy": [
                "estee-lauder"
            ],
            "logoUrl": "https://seeklogo.com/images/T/the-ordinary-logo-6367E3AB69-seeklogo.com.png",
            "siteUrl": "https://theordinary.com/",
            "updatedAt": "2025-09-30T07:31:08.156Z",
            "key": "the-ordinary"
        },
        "too-faced": {
            "names": [
                "Too Faced"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "cosmetics"
            ],
            "score": 15,
            "ownedBy": [
                "estee-lauder"
            ],
            "logoUrl": "https://vectorseek.com/wp-content/uploads/2023/09/Toofaced-Logo-Vector.svg-.png",
            "siteUrl": "https://www.toofaced.co.uk/",
            "updatedAt": "2025-09-30T07:31:08.156Z",
            "key": "too-faced"
        },
        "clorox": {
            "names": [
                "Clorox"
            ],
            "comment": "",
            "sources": {
                "1": "https://www.accc.gov.au/media-release/clorox-ordered-to-pay-825m-in-penalties-for-misleading-ocean-plastic-claims-about-certain-glad-products",
                "2": "https://www.lexology.com/library/detail.aspx?g=ff2c9274-ce08-4583-8d2e-5826c0dae851",
                "3": "https://web.archive.org/web/20111005211706/http://bitchmagazine.org/post/mad-mens-portrayal-of-sexism-seeps-unironically-into-its-commercial-breaks",
                "4": "https://www.law360.com/articles/1705274/clorox-buyers-reach-5-65m-deal-over-tainted-pine-sol",
                "5": "https://www.wholefoodsmagazine.com/articles/5782-rainbow-light-sued-for-false-advertising-lead-content"
            },
            "sourceNotes": {
                "1": "greenwashing in marketing",
                "2": "greenwashing in marketing",
                "3": "sexism in marketing",
                "4": "sold products containing harmful bacteria",
                "5": "sold nutrient supplements that contain lead"
            },
            "tags": [
                "consumer goods"
            ],
            "score": 40,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/The_Clorox_Company_logo%2C_2021.svg/120px-The_Clorox_Company_logo%2C_2021.svg.png",
            "siteUrl": "https://thecloroxcompany.com/",
            "updatedAt": "2025-09-30T07:31:08.156Z",
            "key": "clorox"
        },
        "burt's-bees": {
            "names": [
                "Burt's Bees"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 40,
            "ownedBy": [
                "clorox"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/81/Burts-bees-logo.svg",
            "siteUrl": "http://burtsbees.com/",
            "updatedAt": "2025-09-30T07:31:08.156Z",
            "key": "burt's-bees"
        },
        "colgate-palmolive": {
            "names": [
                "Colgate-Palmolive",
                "Colgate",
                "Palmolive",
                "Colgate-Palmolive-Peet Company",
                "CL"
            ],
            "comment": "Colgate-Palmolive is an American consumer goods company that has engaged in price fixing [1][2], sold contaminated products including toothpaste with heavy metals [3], cleaning products with bacteria [4], and unsafe dog food [5], and sells toothpaste with racist branding in China [6]. The company has been linked to illegal deforestation [7] and child labour in its supply chain [8], and conducted exploitative toothpaste trials using Chinese schoolchildren [9].",
            "sources": {
                "1": "https://www.accc.gov.au/media-release/colgate-ordered-to-pay-18-million-penalty-in-laundry-detergent-cartel-proceedings",
                "2": "https://au.news.yahoo.com/dirty-trick-colgate-palmolive-fined-211151335.html?guccounter=1&guce_referrer=aHR0cHM6Ly93d3cuZWNvc2lhLm9yZy8&guce_referrer_sig=AQAAAHQM7ilKIyGPJMRCNmghCBBfNYVTW1-emOtrFOGF6Tn59pp4Fo5BTgIKtUpkqCGHUD2SovJ_9udPLMLnTaweRGQ5FK1Tk1TA7Ccx-q1vnhNX7e40lAuuIoufm5f986Y0SMq1Z-eLwd3kp29MV0oEwBZnmDqfhdoojJpZbkS1sz4K",
                "3": "https://www.hbsslaw.com/cases/colgate-toothpaste-heavy-metal-contamination",
                "4": "https://www.sultzerlipari.com/news/2024/january/judge-approves-2-million-settlement-in-colgate-p/",
                "5": "https://www.law360.com/articles/1351731/-12-5m-deal-over-vitamin-d-in-hill-s-dog-food-goes-forward",
                "6": "https://thechinaproject.com/2020/06/19/colgate-considers-rebranding-its-black-people-toothpaste-and-chinese-consumers-are-confused/",
                "7": "https://www.ran.org/wp-content/uploads/2022/09/Rainforest-Action-Network-Leuser-Report-FINAL-WEB.pdf",
                "8": "https://www.rainforest-rescue.org/petitions/1081/kelloggs-nestle-unilever-no-to-child-labor-for-palm-oil",
                "9": "https://www.nature.com/articles/sj.bdj.2015.950"
            },
            "sourceNotes": {
                "1": "engaged in price fixing",
                "2": "engaged in price fixing",
                "3": "sold toothpaste contaminated with heavy mentals",
                "4": "sold cleaning products contamintated with bacteria",
                "5": "sold unsafe dog food",
                "6": "sells toothpaste branded with racist elements in china",
                "7": "Illegal deforestation in supply chain",
                "8": "child labour in supply chain",
                "9": "involved in exploitative toothpaste trials using chinese schoolchildren"
            },
            "tags": [
                "consumer goods",
                "anticompetitive practices",
                "unsafe practices",
                "racial discrimination",
                "deforestation",
                "child labour"
            ],
            "score": 20,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/86/Colgate-Palmolive_%282025%29.svg",
            "siteUrl": "https://colgatepalmolive.com/",
            "updatedAt": "2025-09-30T08:28:05.506Z",
            "key": "colgate-palmolive"
        },
        "ajax": {
            "names": [
                "Ajax"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 20,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/04/Ajax_logo.svg",
            "siteUrl": "https://colgatepalmolive.com/",
            "updatedAt": "2025-09-30T08:28:05.506Z",
            "key": "ajax"
        },
        "darlie": {
            "names": [
                "Darlie"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 20,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/0/03/Darlie_logo_2024.png",
            "siteUrl": "http://www.darlie.com/",
            "updatedAt": "2025-09-30T08:28:05.506Z",
            "key": "darlie"
        },
        "sanex": {
            "names": [
                "Sanex"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 20,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/7/74/Sanex_logo.png",
            "siteUrl": "http://www.sanex.co.uk/",
            "updatedAt": "2025-09-30T08:28:05.506Z",
            "key": "sanex"
        },
        "corsair": {
            "names": [
                "Corsair",
                "Corsair Gaming",
                "Corsair Gaming, Inc.",
                "CORSAIR",
                "Corsair Components",
                "Corsair Memory",
                "Corsair Microsystems",
                "CRSR"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "electronics",
                "retail"
            ],
            "score": null,
            "ownedBy": [
                "eagletree-capital"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/2c/Corsair_2020_logo.svg",
            "siteUrl": "https://corsair.com/",
            "updatedAt": "2025-10-02T13:10:32.050Z",
            "key": "corsair"
        },
        "coursera": {
            "names": [
                "Coursera"
            ],
            "comment": "Coursera is an American edutech company that offers online courses but has been accused of prioritising shareholder returns over their learners [1][2].",
            "sources": {
                "1": "https://www.classcentral.com/report/coursera-preview-mode-paywall/",
                "2": "https://www.insidehighered.com/news/2016/01/29/critics-see-mismatch-between-courseras-mission-business-model"
            },
            "sourceNotes": {
                "1": "prioritised wall street returns over learners",
                "2": "prioritised wall street returns over learners"
            },
            "tags": [
                "education",
                "tech",
                ""
            ],
            "score": 49,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/5f/Coursera_logo_%282020%29.svg",
            "siteUrl": "https://coursera.org/",
            "updatedAt": "2025-10-02T17:01:43.219Z",
            "key": "coursera"
        },
        "crocs": {
            "names": [
                "Crocs",
                "Crocs, Inc.",
                "CROX",
                "Foam Creations, Inc."
            ],
            "comment": "Crocs is an American footwear company that has been accused of false advertising [1] and suppressing negative reviews [2].",
            "sources": {
                "1": "https://www.fashiondive.com/news/crocs-class-action-lawsuit-shrinking-shoes/713417/",
                "2": "https://www.ftc.gov/legal-library/browse/cases-proceedings/x2123082-hey-dude-inc-ftc-v"
            },
            "sourceNotes": {
                "1": "accused of false advertising",
                "2": "supressed negative reviews"
            },
            "tags": [
                "clothing",
                "deception"
            ],
            "score": 46,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/e/e1/Crocs_logo.svg",
            "siteUrl": "http://crocs.com/",
            "updatedAt": "2025-10-02T17:01:43.219Z",
            "key": "crocs"
        },
        "heydude": {
            "names": [
                "HEYDUDE"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing"
            ],
            "score": 46,
            "ownedBy": [
                "crocs"
            ],
            "logoUrl": "https://www.theindustry.fashion/wp-content/uploads/2024/04/heydude.jpg",
            "siteUrl": "https://www.heydude.com/",
            "updatedAt": "2025-10-02T17:01:43.219Z",
            "key": "heydude"
        },
        "cvs": {
            "names": [
                "CVS",
                "CVS Pharmacy",
                "CVS Pharmacy Inc.",
                "CVS Health",
                "CVS Health Corporation"
            ],
            "comment": "CVS is an American pharmacy chain that accepted kickbacks for prescribing drugs [1] and contributed to the opioid addiction crisis [2][3][4][5][6]. The company also negligently induced abortion in a woman undergoing IVF [7][8].",
            "sources": {
                "1": "https://www.wsj.com/articles/SB112619614344635329",
                "2": "https://www.nbcnews.com/news/us-news/kentucky-sues-cvs-accuses-company-fueling-opioid-crisis-turning-blind-n1269389",
                "3": "https://www.wsj.com/articles/ohio-jury-finds-pharmacies-operated-by-cvs-walgreens-walmart-contributed-to-opioid-epidemic-11637695351",
                "4": "https://www.nbcnews.com/news/us-news/walgreens-walmart-cvs-ordered-pay-650-million-opioid-sales-rcna43698",
                "5": "https://edition.cnn.com/2024/12/18/business/doj-cvs-opioid",
                "6": "https://www.myfloridalegal.com/newsrelease/ag-moody-secures-more-870-million-cvs-teva-allergan-and-endo?Open=",
                "7": "https://www.businessinsider.com/woman-accidentally-given-abortion-pills-cvs-pharmacy-ending-pregnancy-2023-10",
                "8": "https://web.archive.org/web/20231123034313/https://themessenger.com/health/las-vegas-nevada-abortion-woman-timika-thomas-accidental"
            },
            "sourceNotes": {
                "1": "accepted kickbacks for prescribing drugs",
                "2": "contributed to opioid addiction crisis",
                "3": "contributed to opioid additcion crisis",
                "4": "contributed to opioid addiction crisis",
                "5": "contributed to opioid addiction crisis",
                "6": "contributed to opioid addiction crisis",
                "7": "negligently induced abortion in a woman undergoing IVF",
                "8": "negligently induced abortion in a woman undergoing IVF"
            },
            "tags": [
                "healthcare",
                "corruption",
                "deception",
                "unsafe practices"
            ],
            "score": 7,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/d/df/CVS_Health_Logo.svg",
            "siteUrl": "http://cvshealth.com/",
            "updatedAt": "2025-10-03T10:17:56.255Z",
            "key": "cvs"
        },
        "minuteclinic": {
            "names": [
                "MinuteClinic"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "healthcare"
            ],
            "score": 7,
            "ownedBy": [
                "cvs"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/MinuteClinicLogo2014.png/120px-MinuteClinicLogo2014.png.png",
            "siteUrl": "https://www.cvs.com/minuteclinic",
            "updatedAt": "2025-10-03T11:58:52.401Z",
            "key": "minuteclinic"
        },
        "longs-drugs": {
            "names": [
                "Longs Drugs"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "healthcare"
            ],
            "score": 7,
            "ownedBy": [
                "cvs"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Longs_Drugs_logo.svg/120px-Longs_Drugs_logo.svg.png",
            "siteUrl": "https://www.longs.com/",
            "updatedAt": "2025-10-03T11:58:52.401Z",
            "key": "longs-drugs"
        },
        "aetna": {
            "names": [
                "Aetna"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "healthcare"
            ],
            "score": 7,
            "ownedBy": [
                "cvs"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/b4/1_Heart_Aetna_logo_sm_rgb_violet.svg",
            "siteUrl": "https://www.aetna.com/",
            "updatedAt": "2025-10-03T12:00:10.343Z",
            "key": "aetna"
        },
        "navarro": {
            "names": [
                "Navarro",
                "Navarro Discount Pharmacies",
                "Navarro Discount Pharmacies, Inc."
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "healthcare"
            ],
            "score": 7,
            "ownedBy": [
                "cvs"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/79/Navarro_Discount_Pharmacy_Logo_12.2018.svg/120px-Navarro_Discount_Pharmacy_Logo_12.2018.svg.png",
            "siteUrl": "http://navarro.com/",
            "updatedAt": "2025-10-03T12:00:10.343Z",
            "key": "navarro"
        },
        "omnicare": {
            "names": [
                "Omnicare"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "healthcare"
            ],
            "score": 7,
            "ownedBy": [
                "cvs"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/df/Omnicare_logo.svg",
            "siteUrl": "http://www.omnicare.com/",
            "updatedAt": "2025-10-03T12:00:10.343Z",
            "key": "omnicare"
        },
        "oak-street-health": {
            "names": [
                "Oak Street Health"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "healthcare"
            ],
            "score": 7,
            "ownedBy": [
                "cvs"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/OSH_Logo.png/120px-OSH_Logo.png.png",
            "siteUrl": "http://www.oakstreethealth.com/",
            "updatedAt": "2025-10-03T12:00:10.343Z",
            "key": "oak-street-health"
        },
        "danone": {
            "names": [
                "Danone",
                "Danone S.A.",
                "Boussois-Souchon-Neuvesel",
                "BSN",
                "BSN-Gervais Danone",
                "BSN Groupe",
                "BN"
            ],
            "comment": "Danone is a multinational food company that has misled mothers about infant formula to boost sales [1] and paid midwives kickbacks for selling its formula [2]. It has also engaged in price fixing [3], failed to take accountability for its plastic waste footprint [4], dried up natural water supplies near its facilities [5], polluted communities in Bali [6], and illegally built a plastic recycling plant that harmed local communities' health [7].",
            "sources": {
                "1": "https://web.archive.org/web/20201112021537/http://www.independent.co.uk/news/uk/home-news/after-nestle-aptamil-manufacturer-danone-now-hit-breast-milk-scandal-8679226.html",
                "2": "https://web.archive.org/web/20160502150942/http://www.theguardian.com/world/2013/feb/15/babies-health-formula-indonesia-breastfeeding",
                "3": "https://www.eldiario.es/galicia/cartel-leche-enfrenta-pagar-miles-millones-euros-productores-perjudicados_1_10952915.html",
                "4": "https://www.theguardian.com/environment/2023/jan/10/activists-sue-french-food-firm-danone-plastics-footprint",
                "5": "https://www.euronews.com/2023/06/15/french-region-on-the-brink-of-desertification-says-hydrobiologist",
                "6": "https://stoppoisonplastic.org/blog/bali-community-tells-danone-stop-poisoning-us-with-toxic-plastic/",
                "7": "https://unearthed.greenpeace.org/2024/04/26/danone-plastic-offsetting-verra-indonesia-treaty/"
            },
            "sourceNotes": {
                "1": "misled mothers about infant formula to sell more of its products",
                "2": "gave midwives kickbacks for selling its infant formula",
                "3": "engaged in price fixing",
                "4": "failed to take accountability for its plastic waste footprint",
                "5": "dried up natural water supplies around its facilities",
                "6": "facilities polluted communities in Bali",
                "7": "illegally constructed a plastic recycling facility that impacted the local community's health"
            },
            "tags": [
                "food",
                "anticompetitive practices",
                "deception",
                "corruption",
                "unsustainable practices",
                "water depletion",
                "environmental violations",
                "unsafe practices"
            ],
            "score": 14,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f4/DANONE_LOGO_HORIZONTAL.png/120px-DANONE_LOGO_HORIZONTAL.png.png",
            "siteUrl": "https://www.danone.com/",
            "updatedAt": "2025-10-07T21:25:02.406Z",
            "key": "danone"
        },
        "volvic": {
            "names": [
                "Volvic"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "water"
            ],
            "score": 14,
            "ownedBy": [
                "danone"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8a/Volvic_brand_logo.png/120px-Volvic_brand_logo.png.png",
            "siteUrl": "https://www.volvic.com/",
            "updatedAt": "2025-10-08T19:51:20.084Z",
            "key": "volvic"
        },
        "activia": {
            "names": [
                "Activia"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 14,
            "ownedBy": [
                "danone"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/Activia_logo.png/120px-Activia_logo.png.png",
            "siteUrl": "https://www.activia.us.com/",
            "updatedAt": "2025-10-08T19:51:20.084Z",
            "key": "activia"
        },
        "actimel": {
            "names": [
                "Actimel"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 14,
            "ownedBy": [
                "danone"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dc/Actimel_Logo.png/120px-Actimel_Logo.png.png",
            "siteUrl": "https://www.activia.us.com/",
            "updatedAt": "2025-10-08T19:51:20.084Z",
            "key": "actimel"
        },
        "alpro": {
            "names": [
                "Alpro"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 14,
            "ownedBy": [
                "danone"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/1/15/Alpro_2019_logo.png",
            "siteUrl": "http://alpro.com/",
            "updatedAt": "2025-10-08T19:51:20.084Z",
            "key": "alpro"
        },
        "evian": {
            "names": [
                "Evian"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "water"
            ],
            "score": 14,
            "ownedBy": [
                "danone"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/18/Evian_logo.svg",
            "siteUrl": "https://www.evian.com/en_int/",
            "updatedAt": "2025-10-08T19:51:20.084Z",
            "key": "evian"
        },
        "decathlon": {
            "names": [
                "Decathlon"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "sport"
            ],
            "score": null,
            "ownedBy": [
                "association-familiale-mulliez"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/bc/Decathlon_-_logo_%28France%2C_2024%29.svg",
            "siteUrl": "http://decathlon.com/",
            "updatedAt": "2025-10-27T20:26:51.564Z",
            "key": "decathlon"
        },
        "paul": {
            "names": [
                "Paul"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 50,
            "ownedBy": [
                "groupe-holder"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0f/Logo_Paul.png/120px-Logo_Paul.png.png",
            "siteUrl": "http://boulangeries-paul.com/",
            "updatedAt": "2025-10-30T17:35:21.223Z",
            "key": "paul"
        },
        "groupe-holder": {
            "names": [
                "Groupe Holder",
                "Groupe Holder SAS"
            ],
            "comment": "Groupe Holder is a French business conglomerate.",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "private equity",
                ""
            ],
            "score": 50,
            "ownedBy": [],
            "logoUrl": "https://alchetron.com/cdn/groupe-holder-a6f0e224-7b99-4fdb-a3e6-f50ed364cd1-resize-750.jpg",
            "siteUrl": "http://www.groupeholder.com/",
            "updatedAt": "2025-10-30T17:35:21.223Z",
            "key": "groupe-holder"
        },
        "fnac-darty": {
            "names": [
                "Fnac Darty",
                "Groupe Fnac Darty",
                "Groupe Fnac S.A.",
                "Darty",
                "Kesa Electricals plc",
                "Darty plc",
                "FNAC"
            ],
            "comment": "",
            "sources": {
                "1": "https://markets.ft.com/data/announce/detail?dockey=1330-1000827528en-75E5N0PM5B7UR067NDTCNT4172",
                "2": "https://www.autoritedelaconcurrence.fr/en/press-release/autorite-imposes-fines-eu611-million-10-manufacturers-and-2-distributors-household",
                "3": "https://www.economie.gouv.fr/dgccrf/laction-de-la-dgccrf/injonctions-et-sanctions/amende-de-1-950-000-eu-prononcee-lencontre-de"
            },
            "sourceNotes": {
                "1": "engaged in anticompetetive practices",
                "2": "engaged in anticompetetive practices",
                "3": "engaged in anticompetetive practices"
            },
            "tags": [
                "retail",
                "electronics"
            ],
            "score": 42,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/95/Logo_Fnac_Darty.svg",
            "siteUrl": "https://www.fnacdarty.com/en/",
            "updatedAt": "2025-11-05T15:19:41.538Z",
            "key": "fnac-darty"
        },
        "deezer": {
            "names": [
                "Deezer",
                "Deezer S.A.",
                "DEEZR"
            ],
            "comment": "Deezer is a French music streaming service that suffered a data breach leaking over 200 million users' data [1].",
            "sources": {
                "1": "https://www.musicbusinessworldwide.com/deezer-admits-data-breach-that-potentially-exposed-over-220-million-users-info/#:~:text=Deezer's%20security%20systems%20remain%20effective%2C%20and%20our,shortly%20after%20the%20information%20came%20to%20light."
            },
            "sourceNotes": {
                "1": "data breach"
            },
            "tags": [
                "tech",
                "music",
                "data breach",
                "privacy violations"
            ],
            "score": 49,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/75/Deezer_logo%2C_2023.svg",
            "siteUrl": "https://www.deezer.com/",
            "updatedAt": "2025-11-07T13:41:09.582Z",
            "key": "deezer"
        },
        "deliveroo": {
            "names": [
                "Deliveroo",
                "deliveroo"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech",
                "food"
            ],
            "score": 37,
            "ownedBy": [
                "doordash"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/1/17/Deliveroologo.svg",
            "siteUrl": "https://deliveroo.co.uk/",
            "updatedAt": "2025-11-26T17:10:05.643Z",
            "key": "deliveroo"
        },
        "doordash": {
            "names": [
                "DoorDash",
                "Doordash",
                "DoorDash, Inc.",
                "DASH"
            ],
            "comment": "DoorDash is an American delivery platform that has been criticized for poor working conditions, misclassifying workers and withholding tips [1][2][3][4]. It has also engaged in monopolistic practices [5] and violated workers' sick pay rights [6].",
            "sources": {
                "1": "https://www.npr.org/2021/07/31/1023265561/why-doordash-drivers-are-on-strike",
                "2": "https://www.nytimes.com/2019/07/21/nyregion/doordash-ubereats-food-app-delivery-bike.html",
                "3": "https://news.bloomberglaw.com/daily-labor-report/doordash-100-million-driver-settlement-tentatively-approved",
                "4": "https://gizmodo.com/doordash-settlement-would-pay-a-paltry-130-to-workers-1847586519",
                "5": "https://www.reuters.com/article/us-health-coronavirus-food-delivery-laws-idUSKCN21V2C1",
                "6": "https://apnews.com/article/doordash-seattle-sick-time-policy-violation-settlement-b8fd725e9b50631c40e041b418112ae0"
            },
            "sourceNotes": {
                "1": "poor working conditions, misclassifying workers and withholding tips",
                "2": "poor working conditions, misclassifying workers and withholding tips",
                "3": "poor working conditions, misclassifying workers and withholding tips",
                "4": "poor working conditions, misclassifying workers and withholding tips",
                "5": "anticompetitive monopolistic practices",
                "6": "violated workers' sick pay rights"
            },
            "tags": [
                "tech",
                "food",
                "poorworkingconditions",
                "anticompetitive practices",
                "poor working conditions",
                "unfair pay"
            ],
            "score": 37,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/6a/DoorDash_Logo.svg",
            "siteUrl": "https://doordash.com/",
            "updatedAt": "2025-11-26T17:10:05.643Z",
            "key": "doordash"
        },
        "wolt": {
            "names": [
                "Wolt",
                "Wolt Enterprises Oy"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech",
                "food"
            ],
            "score": 37,
            "ownedBy": [
                "doordash"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b0/Wolt-app-icon-2019.png/120px-Wolt-app-icon-2019.png.png",
            "siteUrl": "https://wolt.com/en/",
            "updatedAt": "2025-11-26T17:10:05.643Z",
            "key": "wolt"
        },
        "desigual": {
            "names": [
                "Desigual"
            ],
            "comment": "Desigual is a Spanish clothing retailer.",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing",
                "retail",
                ""
            ],
            "score": 50,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/cb/Desigual_logo_2022.svg",
            "siteUrl": "http://www.desigual.com/",
            "updatedAt": "2025-11-26T17:24:43.867Z",
            "key": "desigual"
        },
        "reckitt": {
            "names": [
                "Reckitt",
                "Reckitt Benckiser Group PLC",
                "Reckitt Benckiser",
                "RKT"
            ],
            "comment": "Reckitt is a British consumer goods company that has been implicated in anti‑competitive monopolistic practices [1][2] and continues operations in Russia despite ethical concerns [3]. The company has also attempted to block a ban on its rat poison despite cases of poisoning [4], relied on forced and child labour in its palm oil supply chain [5], polluted rivers leading to mass fish deaths [6], and sold lethal humidifier steriliser products that killed over 100 people [7][8].",
            "sources": {
                "1": "https://web.archive.org/web/20240921185833/https://www.theguardian.com/business/2010/oct/15/reckitt-benckiser-fined-oft-gaviscon",
                "2": "https://archive.today/20170209165431/http://www.connexionfrance.com/court-appeal-price-fixing-fine-upheld-consumer-companies-gillette-loreal-procter-gamble-sc-johnson-18567-view-article.html",
                "3": "https://www.reuters.com/business/retail-consumer/reckitt-stays-course-process-aimed-at-transferring-russian-business-2023-07-26/",
                "4": "http://www.mercurynews.com/business/ci_25461592/makers-rat-poison-d-con-sue-state",
                "5": "https://web.archive.org/web/20180423210624/https://www.amnesty.org/en/documents/asa21/5184/2016/en/",
                "6": "https://www.gov.uk/government/news/reckitt-benckiser-make-charity-payment-for-breach-of-regulations",
                "7": "https://web.archive.org/web/20240921185313/https://www.bbc.com/news/world-asia-36185549",
                "8": "https://web.archive.org/web/20160426165552/http://www.koreatimes.co.kr/www/news/nation/2016/04/116_203380.html"
            },
            "sourceNotes": {
                "1": "anti-competetive monopolistic practices",
                "2": "anti-competetive monopolistic practices",
                "3": "continuing operations in russia",
                "4": "attempted to block ban of rat poison despite cases of children and pets being poisoned",
                "5": "forced labour and child labour in palm oil supply chain",
                "6": "polluted rivers killing hundreds of fish",
                "7": "sold lethal humidifier steriliser products that killed over 100 people",
                "8": "sold lethal humidifier steriliser products that killed over 100 people"
            },
            "tags": [
                "consumer-goods",
                "anticompetitive practices",
                "connections to russia",
                "forced labour",
                "child labour",
                "environmental violations",
                "unsafe products",
                "deception"
            ],
            "score": 6,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/b/b8/Reckitt_logo.svg",
            "siteUrl": "https://reckitt.com/",
            "updatedAt": "2025-11-26T17:42:01.997Z",
            "key": "reckitt"
        },
        "strepsils": {
            "names": [
                "Strepsils"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer-goods"
            ],
            "score": 6,
            "ownedBy": [
                "reckitt"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/1/12/250px-Strepsils-logo.png",
            "siteUrl": "http://www.strepsils.co.uk/",
            "updatedAt": "2025-11-26T17:40:46.998Z",
            "key": "strepsils"
        },
        "harpic": {
            "names": [
                "Harpic"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer-goods"
            ],
            "score": 6,
            "ownedBy": [
                "reckitt"
            ],
            "logoUrl": "https://www.liblogo.com/img-logo/ha5286hf6a-harpic-logo-harpic-logo-misc--com.png",
            "siteUrl": "https://www.reckitt.com/powerbrands/hygiene/harpic/",
            "updatedAt": "2025-11-26T17:40:46.998Z",
            "key": "harpic"
        },
        "veet": {
            "names": [
                "Veet"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer-goods"
            ],
            "score": 6,
            "ownedBy": [
                "reckitt"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/0/0b/250px-Veet_Logo.jpg",
            "siteUrl": "https://www.veet.com/",
            "updatedAt": "2025-11-26T17:40:46.998Z",
            "key": "veet"
        },
        "airborne": {
            "names": [
                "Airborne"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer-goods"
            ],
            "score": 6,
            "ownedBy": [
                "reckitt"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/4b/250px-Airborne-logo.png",
            "siteUrl": "https://www.schiffvitamins.com/",
            "updatedAt": "2025-11-26T17:40:46.998Z",
            "key": "airborne"
        },
        "gaviscon": {
            "names": [
                "Gaviscon"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer-goods"
            ],
            "score": 6,
            "ownedBy": [
                "reckitt"
            ],
            "logoUrl": "https://www.wikicorporates.org/mediawiki/images/thumb/5/57/Reckitt-Benckiser-Gaviscon.svg/1000px-Reckitt-Benckiser-Gaviscon.svg.png",
            "siteUrl": "https://www.gaviscon.co.uk/",
            "updatedAt": "2025-11-26T17:40:46.998Z",
            "key": "gaviscon"
        },
        "mead-johnson": {
            "names": [
                "Mead Johnson"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer-goods"
            ],
            "score": 6,
            "ownedBy": [
                "reckitt"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Mead_Johnson_logo.svg/120px-Mead_Johnson_logo.svg.png",
            "siteUrl": "http://www.meadjohnson.com/",
            "updatedAt": "2025-11-26T17:40:46.998Z",
            "key": "mead-johnson"
        },
        "calgon": {
            "names": [
                "Calgon"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer-goods"
            ],
            "score": 6,
            "ownedBy": [
                "reckitt"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/7/7d/Calgon_RB_logo.png",
            "siteUrl": "http://calgon.com/",
            "updatedAt": "2025-11-26T17:40:46.998Z",
            "key": "calgon"
        },
        "clearasil": {
            "names": [
                "Clearasil"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer-goods"
            ],
            "score": 6,
            "ownedBy": [
                "reckitt"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/72/250px-Logo_clearasil.png",
            "siteUrl": "http://www.clearasil.us/",
            "updatedAt": "2025-11-26T17:40:46.998Z",
            "key": "clearasil"
        },
        "durex": {
            "names": [
                "Durex"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 6,
            "ownedBy": [
                "reckitt"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/80/New_Logo_Durex.svg",
            "siteUrl": "https://durex.com/",
            "updatedAt": "2025-12-26T23:00:26.303Z",
            "key": "durex"
        },
        "lysol": {
            "names": [
                "Lysol",
                "Lizol"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer-goods"
            ],
            "score": 6,
            "ownedBy": [
                "reckitt"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Lysol_Logo.svg/120px-Lysol_Logo.svg.png",
            "siteUrl": "https://www.lysol.com/",
            "updatedAt": "2025-11-26T17:40:46.998Z",
            "key": "lysol"
        },
        "vanish": {
            "names": [
                "Vanish"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer-goods"
            ],
            "score": 6,
            "ownedBy": [
                "reckitt"
            ],
            "logoUrl": "https://vignette.wikia.nocookie.net/logopedia/images/0/05/Vanish2016.png/revision/latest?cb=20170106132603",
            "siteUrl": "https://www.reckitt.com/powerbrands/hygiene/vanish/",
            "updatedAt": "2025-11-26T17:40:46.998Z",
            "key": "vanish"
        },
        "enfamil": {
            "names": [
                "Enfamil"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer-goods"
            ],
            "score": 6,
            "ownedBy": [
                "reckitt"
            ],
            "logoUrl": "https://logodix.com/logo/2022592.png",
            "siteUrl": "https://www.enfamil.com/",
            "updatedAt": "2025-11-26T17:40:46.998Z",
            "key": "enfamil"
        },
        "finish": {
            "names": [
                "Finish"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer-goods"
            ],
            "score": 6,
            "ownedBy": [
                "reckitt"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/23/250px-Finish_logo.jpg",
            "siteUrl": "https://www.finishdishwashing.com/",
            "updatedAt": "2025-11-26T17:40:46.998Z",
            "key": "finish"
        },
        "dfs": {
            "names": [
                "DFS",
                "dfs",
                "DFS Furniture plc",
                "Diamond Holdco 1 Limited",
                "DFS Furniture Limited",
                "Direct Furnishing Supplies"
            ],
            "comment": "DFS is a British company that has been accused of unethical sales tactics [1] and misleading sales practices [2], has lost customers' orders [3], and published misleading advertisements [4].",
            "sources": {
                "1": "https://www.bbc.co.uk/programmes/articles/r5pvRcspQH8jjJ5JJpNkvq/dfs-sales-tactics",
                "2": "https://www.dailymail.co.uk/news/article-6603395/Pensioners-protest-outside-DFS-claiming-furniture-chain-cheated-600.html",
                "3": "https://www.walesonline.co.uk/news/uk-news/disabled-couple-face-christmas-sitting-25748012",
                "4": "https://www.insidermedia.com/news/national/dfs-ad-complaints-upheld-by-asa"
            },
            "sourceNotes": {
                "1": "unethical sales tactics",
                "2": "misleading sales practices",
                "3": "lost customers' orders",
                "4": "misleading advertising"
            },
            "tags": [
                "furniture",
                "retail",
                "deception"
            ],
            "score": 48,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/f/f6/DFS_Furniture_logo.svg",
            "siteUrl": "https://dfs.co.uk/",
            "updatedAt": "2025-11-27T23:04:12.476Z",
            "key": "dfs"
        },
        "sofology": {
            "names": [
                "Sofology",
                "Sofaworks",
                "CSL",
                "Clayton Salerooms",
                "CS Lounge Suites Ltd"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "furniture",
                "retail"
            ],
            "score": 48,
            "ownedBy": [
                "dfs"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/2/23/Sofology_logo.png",
            "siteUrl": "http://www.sofology.co.uk/",
            "updatedAt": "2025-11-27T23:21:53.511Z",
            "key": "sofology"
        },
        "dhl": {
            "names": [
                "DHL",
                "DHL Group",
                "Deutsche Post AG",
                "Deutsche Post",
                "Dalsey, Hillblom and Lynn",
                "DHL Express"
            ],
            "comment": "DHL is an American and German logistics company that has been accused of anticompetitive practices [1], workers rights abuses [2], and racial discrimination against employees [3]. Additionally, the company faces allegations of anti‑union practices and further workers rights abuses [4], and its founder has been implicated in the rape of underage girls [5][6].",
            "sources": {
                "1": "https://www.law360.com/articles/741436",
                "2": "https://www.etf-europe.org/dhl-in-the-firing-line-over-escalating-rights-abuses-questions-pile-up-about-logistics-giant/",
                "3": "https://teamster.org/2024/04/teamsters-local-705-members-win-racial-discrimination-lawsuit-against-dhl-express/",
                "4": "https://www.theguardian.com/us-news/2023/apr/03/dhl-workers-inmates-union-airport",
                "5": "https://www.independent.co.uk/news/tycoon-s-estate-pays-360m-to-children-fathered-on-sex-safaris-1138216.html",
                "6": "https://www.utterlyinteresting.com/post/the-evil-story-of-larry-hillblom-the-h-from-dhl"
            },
            "sourceNotes": {
                "1": "anticompetetive practices",
                "2": "workers rights abuses",
                "3": "racial discrimination against employees",
                "4": "workers rights abuses and anti union practices",
                "5": "founder raped underage girls",
                "6": "founder raped underage girls"
            },
            "tags": [
                "delivery",
                "shipping",
                "anticompetitive practices",
                "anti-union practices",
                "racial discrimination",
                "sexual harassment",
                "poor working conditions"
            ],
            "score": 35,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/ac/DHL_Logo.svg",
            "siteUrl": "https://www.dhl.com/",
            "updatedAt": "2025-11-29T13:24:25.358Z",
            "key": "dhl"
        },
        "diesel": {
            "names": [
                "Diesel",
                "Diesel USA",
                "Diesel S.p.A."
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing",
                "retail"
            ],
            "score": 36,
            "ownedBy": [
                "otb-group"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/ca/Diesel.svg",
            "siteUrl": "https://diesel.com/",
            "updatedAt": "2025-11-29T22:09:52.600Z",
            "key": "diesel"
        },
        "maison-margiela": {
            "names": [
                "Maison Margiela"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing",
                "retail"
            ],
            "score": 36,
            "ownedBy": [
                "otb-group"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Maison_Margiela_logo.svg/120px-Maison_Margiela_logo.svg.png",
            "siteUrl": "https://www.maisonmargiela.com/",
            "updatedAt": "2025-11-29T22:09:52.600Z",
            "key": "maison-margiela"
        },
        "amiri": {
            "names": [
                "AMIRI"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing",
                "retail"
            ],
            "score": 36,
            "ownedBy": [
                "otb-group"
            ],
            "logoUrl": "https://www.vectorkhazana.com/assets/images/products/Amiri_Logo.png",
            "siteUrl": "http://amiri.com/",
            "updatedAt": "2025-11-29T22:09:52.600Z",
            "key": "amiri"
        },
        "otb-group": {
            "names": [
                "OTB Group"
            ],
            "comment": "OTB Group is an Italian clothing brand holding company that has faced criticism for underpaying its workers [1] and for sourcing goods from suppliers with abusive working conditions [2], while continuing operations in Russia [3].",
            "sources": {
                "1": "https://www.law360.com/california/articles/302059/diesel-settles-calif-employees-wage-and-break-claims",
                "2": "https://www.somo.nl/maid-in-india/",
                "3": "https://som.yale.edu/story/2022/over-1000-companies-have-curtailed-operations-russia-some-remain#list"
            },
            "sourceNotes": {
                "1": "underpaid workers",
                "2": "sourced from suppliers with abusive working conditions",
                "3": "still operating in russia"
            },
            "tags": [
                "clothing",
                "retail",
                "unfair pay",
                "poor working conditions",
                "unsafe working conditions",
                "connections to russia"
            ],
            "score": 36,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/42/OTB_Group_logo.svg",
            "siteUrl": "https://www.otb.net/",
            "updatedAt": "2025-11-29T22:09:52.600Z",
            "key": "otb-group"
        },
        "dr.-martens": {
            "names": [
                "Dr. Martens",
                "Dr Martens",
                "Dr. Marten's",
                "Doc Martens",
                "Doc Marten"
            ],
            "comment": "Dr. Martens is a British footwear brand accused of price gouging and anti-consumer practices [1].",
            "sources": {
                "1": "https://agmeek.co.uk/blogs/news/want-dr-marten-s-here-s-why-they-re-so-expensive-now"
            },
            "sourceNotes": {
                "1": "price gouging and anti consumer practices"
            },
            "tags": [
                "clothing",
                "retail",
                "deception"
            ],
            "score": 46,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/Dr._Martens_Logo.svg/120px-Dr._Martens_Logo.svg.png",
            "siteUrl": "http://www.drmartens.com/",
            "updatedAt": "2025-12-22T11:25:58.483Z",
            "key": "dr.-martens"
        },
        "dropbox": {
            "names": [
                "Dropbox"
            ],
            "comment": "Dropbox is an American technology company that has faced allegations of gender discrimination [1] and nonconsensual use of user data for research [2].",
            "sources": {
                "1": "https://venturebeat.com/technology/dozens-of-current-and-former-dropbox-employees-allege-gender-discrimination",
                "2": "https://www.wired.com/story/dropbox-sharing-data-study-ethics/"
            },
            "sourceNotes": {
                "1": "gender discrimination",
                "2": "nonconsenual use of user data for research"
            },
            "tags": [
                "tech",
                "gender discrimination",
                "privacy violations"
            ],
            "score": 44,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/cb/Dropbox_logo_2017.svg",
            "siteUrl": "https://www.dropbox.com/",
            "updatedAt": "2025-12-25T16:12:44.578Z",
            "key": "dropbox"
        },
        "dunkin'-donuts": {
            "names": [
                "Dunkin' Donuts",
                "Dunkin'",
                "Dunkin",
                "Dunkin Donuts"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fast food"
            ],
            "score": null,
            "ownedBy": [
                "inspire-brands"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/14/Dunkin%27_2022.svg",
            "siteUrl": "http://dunkindonuts.com/",
            "updatedAt": "2025-12-26T16:59:19.613Z",
            "key": "dunkin'-donuts"
        },
        "duolingo": {
            "names": [
                "Duolingo",
                "Duolingo, Inc.",
                "Duolingo, Inc",
                "DUOL"
            ],
            "comment": "Duolingo is an American language-learning app that replaced employees with AI [1][2].",
            "sources": {
                "1": "https://uk.news.yahoo.com/people-outraged-duolingo-ceos-controversial-100851504.html",
                "2": "https://fortune.com/2025/06/09/duolingo-ceo-surprised-backlash-ai-first-company-announcement/"
            },
            "sourceNotes": {
                "1": "replaced employees with AI",
                "2": "replaced employees with AI"
            },
            "tags": [
                "tech",
                "education",
                ""
            ],
            "score": 45,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/5c/Duolingo_logo_%282019%29.svg",
            "siteUrl": "http://duolingo.com/",
            "updatedAt": "2025-12-26T17:09:27.197Z",
            "key": "duolingo"
        },
        "duracell": {
            "names": [
                "Duracell"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "electronics"
            ],
            "score": 17,
            "ownedBy": [
                "berkshire-hathaway"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/65/Duracell_logo.svg",
            "siteUrl": "https://www.duracell.com/",
            "updatedAt": "2025-12-26T22:13:40.448Z",
            "key": "duracell"
        },
        "dyson": {
            "names": [
                "Dyson",
                "Dyson Appliances Ltd",
                "Dyson Ltd",
                "Dyson Limited"
            ],
            "comment": "Dyson is a British technology company that has faced allegations of corruption and attempts to circumvent taxation [1]. The company has also been criticized for laying off workers with only one day notice [2] and for using forced labour in its supply chain [3][4].",
            "sources": {
                "1": "https://www.theguardian.com/technology/2021/apr/21/lobbying-row-james-dyson-is-no-stranger-to-political-controversy",
                "2": "https://www.channelnewsasia.com/singapore/dyson-lazada-layoffs-unions-manpower-ministry-tripartism-4662881",
                "3": "https://web.archive.org/web/20220211163001/https://www.channel4.com/news/exclusive-dyson-faces-legal-action-over-forced-labour-and-exploitation",
                "4": "https://www.pinsentmasons.com/out-law/news/dyson-face-human-rights-abuse-claims"
            },
            "sourceNotes": {
                "1": "corruption and attempts to circumvent taxation",
                "2": "laid off workers with 1 day notice",
                "3": "forced labour in supply chain",
                "4": "forced labour in supply chain"
            },
            "tags": [
                "electronics",
                "corruption",
                "tax avoidance",
                "forced labour"
            ],
            "score": 37,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/2f/Dyson_logo.svg",
            "siteUrl": "https://www.dyson.com/",
            "updatedAt": "2025-12-26T23:00:26.303Z",
            "key": "dyson"
        },
        "foot-locker": {
            "names": [
                "Foot Locker"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing",
                "retail"
            ],
            "score": 43,
            "ownedBy": [
                "dick's-sporting-goods"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/c/c7/FootLockerInc.svg",
            "siteUrl": "http://footlocker.com/",
            "updatedAt": "2026-01-13T20:50:35.063Z",
            "key": "foot-locker"
        },
        "grubhub": {
            "names": [
                "Grubhub",
                "Grubhub Inc.",
                "GRUBHUB",
                "GRUB"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "tech"
            ],
            "score": 43,
            "ownedBy": [
                "wonder-group"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/87/Grubhub_2025_logo.svg",
            "siteUrl": "https://www.grubhub.com/",
            "updatedAt": "2026-01-24T09:05:56.980Z",
            "key": "grubhub"
        },
        "domestos": {
            "names": [
                "Domestos"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 5,
            "ownedBy": [
                "unilever"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2d/Domestos_logo.png/120px-Domestos_logo.png.png",
            "siteUrl": "https://www.domestos.com/uk/home.html",
            "updatedAt": "2025-12-26T23:00:26.303Z",
            "key": "domestos"
        },
        "ea": {
            "names": [
                "EA",
                "Electronic Arts"
            ],
            "comment": "EA is an American video game company that has been criticized for overworking employees [1][2] and underpaying staff [3][4]. The company has also been accused of anticompetitive monopolistic practices [5].",
            "sources": {
                "1": "https://web.archive.org/web/20131113111900/http://www.gamespot.com/articles/employees-readying-class-action-lawsuit-against-ea/1100-6112998/",
                "2": "https://web.archive.org/web/20200311163854/https://www.kotaku.com.au/2020/02/how-biowares-anthem-went-wrong/",
                "3": "https://www.sec.gov/Archives/edgar/data/712515/000095013406002079/f16210e10vq.htm",
                "4": "https://web.archive.org/web/20221004061842/https://www.sec.gov/Archives/edgar/data/712515/000095013406011401/f21019e10vk.htm",
                "5": "https://www.law360.com/articles/446348"
            },
            "sourceNotes": {
                "1": "overworked employees",
                "2": "overworked employees",
                "3": "underpaid employees",
                "4": "underpaid employees",
                "5": "anticompetetive monopolistic practices"
            },
            "tags": [
                "entertainment",
                "tech",
                "anticompetitive practices",
                "unfair pay",
                "poor working conditions"
            ],
            "score": 42,
            "ownedBy": [
                "public-investment-fund"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/c0/Electronic_Arts_Logo_Blue.svg",
            "siteUrl": "https://www.ea.com/",
            "updatedAt": "2025-12-27T14:17:53.295Z",
            "key": "ea"
        },
        "bioware": {
            "names": [
                "Bioware"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "tech"
            ],
            "score": 42,
            "ownedBy": [
                "ea"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/f/f8/BioWare_2018.svg",
            "siteUrl": "http://www.bioware.com/",
            "updatedAt": "2025-12-30T21:54:37.088Z",
            "key": "bioware"
        },
        "criterion-games": {
            "names": [
                "Criterion Games"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "tech"
            ],
            "score": 42,
            "ownedBy": [
                "ea"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/2/2f/Criterion_Games_2018_logo.svg",
            "siteUrl": "https://www.ea.com/ea-studios/criterion-games",
            "updatedAt": "2025-12-30T21:54:37.088Z",
            "key": "criterion-games"
        },
        "dice": {
            "names": [
                "DICE"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "tech"
            ],
            "score": 42,
            "ownedBy": [
                "ea"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/00/DICE_logo.svg",
            "siteUrl": "http://dice.se/",
            "updatedAt": "2025-12-30T21:54:37.088Z",
            "key": "dice"
        },
        "respawn-entertainment": {
            "names": [
                "Respawn Entertainment"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "tech"
            ],
            "score": 42,
            "ownedBy": [
                "ea"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/be/Respawn_Logo.png",
            "siteUrl": "https://www.respawn.com/",
            "updatedAt": "2025-12-30T21:54:37.088Z",
            "key": "respawn-entertainment"
        },
        "eucerin": {
            "names": [
                "Eucerin"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer-goods"
            ],
            "score": 38,
            "ownedBy": [
                "beiersdorf"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/bd/Eucerin_logo.svg",
            "siteUrl": "https://www.eucerinus.com/",
            "updatedAt": "2025-12-31T13:44:43.333Z",
            "key": "eucerin"
        },
        "beiersdorf": {
            "names": [
                "Beiersdorf",
                "Beiersdorf AG",
                "BEI"
            ],
            "comment": "Beiersdorf is a German company that has faced allegations of false advertising [1], anticompetitive practices [2][3], and greenwashing [4][5]. It remains active in Russia [6] and its suncreams have been found to contain carcinogens [7][8].",
            "sources": {
                "1": "https://evilcorporations.com/beiersdorf-nivea-natural-claims-lawsuit-corporate-misconduct/",
                "2": "https://www.reuters.com/sustainability/boards-policy-regulation/switzerland-investigates-beiersdorf-dispute-over-nivea-pricing-2025-06-24/",
                "3": "https://www.autoritedelaconcurrence.fr/en/communiques-de-presse/autorite-de-la-concurrence-fines-concerted-practices-between-manufacturers",
                "4": "https://www.petersandpeters.com/case/german-drugstore-commits-to-greater-transparency-in-response-to-consumer-greenwashing-claim/",
                "5": "https://www.climatecasechart.com/document/deutsche-umwelthilfe-v-beiersdorf-ag_eee4",
                "6": "https://leave-russia.org/beiersdorf",
                "7": "https://www.law360.com/articles/1517695/bayer-buyers-get-go-ahead-on-2-3m-sunscreen-settlement",
                "8": "https://www.cosmeticsandtoiletries.com/regulations/claims-labeling/news/22444969/bayer-beiersdorf-pay-out-23-m-for-coppertone-false-ad-suit"
            },
            "sourceNotes": {
                "1": "false advertising",
                "2": "anticompetetive practices",
                "3": "anticompetetive practices",
                "4": "greenwashing",
                "5": "greenwashing",
                "6": "still active in russia",
                "7": "included carcinogens in suncream",
                "8": "included carcinogens in suncream"
            },
            "tags": [
                "consumer-goods",
                "anticompetitive practices",
                "deception",
                "greenwashing",
                "connections to russia",
                "unsafe practices"
            ],
            "score": 38,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/0b/Beiersdorf_Logo.svg",
            "siteUrl": "https://www.beiersdorf.com/",
            "updatedAt": "2026-01-01T08:56:00.694Z",
            "key": "beiersdorf"
        },
        "nivea": {
            "names": [
                "Nivea"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer-goods"
            ],
            "score": 38,
            "ownedBy": [
                "beiersdorf"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/d/d3/NIVEA_logo_2021.svg",
            "siteUrl": "https://www.nivea.com/",
            "updatedAt": "2025-12-31T13:44:43.333Z",
            "key": "nivea"
        },
        "elastoplast": {
            "names": [
                "Elastoplast",
                "Hansaplast"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer-goods"
            ],
            "score": 38,
            "ownedBy": [
                "beiersdorf"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/6a/Elastoplast_logo.svg",
            "siteUrl": "https://www.elastoplast.co.uk/",
            "updatedAt": "2025-12-31T13:44:43.333Z",
            "key": "elastoplast"
        },
        "coppertone": {
            "names": [
                "Coppertone"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer-goods"
            ],
            "score": 38,
            "ownedBy": [
                "beiersdorf"
            ],
            "logoUrl": "https://logonoid.com/images/thumbs/coppertone-logo.gif",
            "siteUrl": "http://www.coppertone.com/",
            "updatedAt": "2025-12-31T13:44:43.333Z",
            "key": "coppertone"
        },
        "expedia": {
            "names": [
                "Expedia",
                "Expedia Group",
                "Expedia Group, Inc.",
                "EXPE"
            ],
            "comment": "Expedia is a American travel company that has engaged in false advertising [1], tax avoidance [2], predatory pricing [3], and misleading sales tactics with hidden charges [4]. Additionally, Expedia has discriminated against victims of sexual harassment [5] and operated in illegal West Bank settlements [6][7][8].",
            "sources": {
                "1": "https://www.courthousenews.com/expedia-settles-false-advertising-class-action-with-hotels/",
                "2": "https://www.reviewjournal.com/crime/courts/travelscape-ordered-to-pay-south-carolina/",
                "3": "https://www.travolution.com/news/travel-sectors/accommodation/which-raises-concern-over-expedia-and-hotels.com-pricing-disparities/",
                "4": "https://www.thisismoney.co.uk/money/news/article-6672995/Hotel-booking-sites-agree-end-misleading-sales-tactics.html",
                "5": "https://www.law360.com/articles/2323969/expedia-forced-restroom-spy-cam-victim-to-quit-suit-says",
                "6": "https://www.ohchr.org/EN/NewsEvents/Pages/DisplayNews.aspx?NewsID=25542",
                "7": "https://reliefweb.int/report/occupied-palestinian-territory/database-all-business-enterprises-involved-certain-activities",
                "8": "https://amnesty.org.nz/israelopt-tourism-companies-driving-settlement-expansion-profiting-war-crimes/"
            },
            "sourceNotes": {
                "1": "false advertising",
                "2": "tax avoidance",
                "3": "predatory pricing",
                "4": "misleading sales tactics and hidden charges",
                "5": "discriminated against victims of sexal harassment",
                "6": "operating in illegal west bank settlements",
                "7": "operating in illegal west bank settlements",
                "8": "operating in illegal west bank settlements"
            },
            "tags": [
                "travel",
                "tech",
                "anticompetitive practices",
                "deception",
                "tax avoidance",
                "sexual harassment",
                "connections to Israel"
            ],
            "score": 15,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/3b/Expedia_Logo_2023.svg",
            "siteUrl": "https://www.expedia.com/",
            "updatedAt": "2026-01-02T08:30:22.126Z",
            "key": "expedia"
        },
        "hotels.com": {
            "names": [
                "Hotels.com",
                "Hotels.com, L.P."
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "travel",
                "tech"
            ],
            "score": 15,
            "ownedBy": [
                "expedia"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/41/Hotels.com_Logo_2025.svg",
            "siteUrl": "http://hotels.com/",
            "updatedAt": "2026-01-02T09:03:27.846Z",
            "key": "hotels.com"
        },
        "vrbo": {
            "names": [
                "Vrbo"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "travel",
                "tech"
            ],
            "score": 15,
            "ownedBy": [
                "expedia"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/4/4c/Vrbo_logo.svg",
            "siteUrl": "https://www.vrbo.com/",
            "updatedAt": "2026-01-02T09:03:27.846Z",
            "key": "vrbo"
        },
        "travelocity": {
            "names": [
                "Travelocity"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "travel",
                "tech"
            ],
            "score": 15,
            "ownedBy": [
                "expedia"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/7/7f/Travelocity_logo.svg",
            "siteUrl": "https://www.travelocity.com/",
            "updatedAt": "2026-01-02T09:03:27.846Z",
            "key": "travelocity"
        },
        "hotwire": {
            "names": [
                "Hotwire",
                "Hotwire.com"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "travel",
                "tech"
            ],
            "score": 15,
            "ownedBy": [
                "expedia"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/56/Hotwire_Logo.svg",
            "siteUrl": "http://www.hotwire.com/",
            "updatedAt": "2026-01-02T09:03:27.846Z",
            "key": "hotwire"
        },
        "orbitz": {
            "names": [
                "Orbitz"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "travel",
                "tech"
            ],
            "score": 15,
            "ownedBy": [
                "expedia"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/8/8f/Orbitz_logo.svg",
            "siteUrl": "http://orbitz.com/",
            "updatedAt": "2026-01-02T09:03:27.846Z",
            "key": "orbitz"
        },
        "cheaptickets": {
            "names": [
                "CheapTickets"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "travel",
                "tech"
            ],
            "score": 15,
            "ownedBy": [
                "expedia"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/c/c5/CheapTickets_logo.svg",
            "siteUrl": "http://www.cheaptickets.com/",
            "updatedAt": "2026-01-02T09:03:27.846Z",
            "key": "cheaptickets"
        },
        "trivago": {
            "names": [
                "Trivago",
                "Trivago N.V.",
                "TRVG"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "travel",
                "tech"
            ],
            "score": 15,
            "ownedBy": [
                "expedia"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/b9/Trivago_logo_2023.svg",
            "siteUrl": "https://www.trivago.com/",
            "updatedAt": "2026-01-02T09:03:27.846Z",
            "key": "trivago"
        },
        "wotif": {
            "names": [
                "Wotif"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "travel",
                "tech"
            ],
            "score": 15,
            "ownedBy": [
                "expedia"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/6/6f/Wotif.com_Logo.svg",
            "siteUrl": "http://www.wotif.com/",
            "updatedAt": "2026-01-02T09:03:27.846Z",
            "key": "wotif"
        },
        "reach": {
            "names": [
                "Reach",
                "Reach plc",
                "Trinity Mirror",
                "RCH"
            ],
            "comment": "Reach is a UK media company that has been implicated in phone hacking [1][2] and has used misleading clickbait headlines [3][4][5]. It has also replaced journalists with AI [6] and underpaid its staff [7].",
            "sources": {
                "1": "https://www.standard.co.uk/showbiz/celebrity-news/high-court-daily-mirror-daily-express-jim-mullen-graham-b1143181.html",
                "2": "https://www.bbc.co.uk/news/uk-66055386",
                "3": "https://pressgazette.substack.com/p/ipso-rules-against-reach-over-clickbait",
                "4": "https://pressgazette.co.uk/the-wire/newspaper-corrections-media-mistakes-errors-legal/birmingham-headlines-actively-misleading-says-ipso/",
                "5": "https://www.thecanary.co/trending/2024/09/22/met-office-mirror-tiktok-reach-plc/",
                "6": "https://www.nuj.org.uk/resource/nuj-decries-new-job-cuts-by-reach-plc.html",
                "7": "https://novaramedia.com/2022/08/23/daily-mirror-journalists-striking-over-low-pay-were-offered-advice-on-side-hustles-by-publishing-giant/#:~:text=Walkouts%20on%2026%20August%20mark%20the%20beginning,members%20who%20are%20requesting%20an%208.5%25%20rise."
            },
            "sourceNotes": {
                "1": "phone hacking",
                "2": "phone hacking",
                "3": "misleading clickbait headlines",
                "4": "misleading clickbait headlines",
                "5": "misleading clickbait headlines",
                "6": "replacing journalists with AI",
                "7": "underpaying journalists"
            },
            "tags": [
                "news",
                "privacy violations",
                "deception",
                "unfair pay"
            ],
            "score": 24,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/75/Reach_plc_logo.svg",
            "siteUrl": "http://reachplc.com/",
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "key": "reach"
        },
        "daily-express": {
            "names": [
                "Daily Express"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Daily_Express",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Daily_Express_masthead.svg/120px-Daily_Express_masthead.svg.png",
            "siteUrl": "http://express.co.uk/",
            "key": "daily-express"
        },
        "sunday-express": {
            "names": [
                "Sunday Express"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Sunday_Express",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Daily_Express_masthead.svg/120px-Daily_Express_masthead.svg.png",
            "siteUrl": "http://express.co.uk/",
            "key": "sunday-express"
        },
        "daily-mirror": {
            "names": [
                "Daily Mirror"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Daily_Mirror",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/a7/Daily_Mirror_masthead.svg",
            "siteUrl": "http://www.mirror.co.uk/",
            "key": "daily-mirror"
        },
        "sunday-mirror": {
            "names": [
                "Sunday Mirror"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Sunday_Mirror",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/79/Sunday_Mirror_main.png/120px-Sunday_Mirror_main.png.png",
            "siteUrl": "https://www.mirror.co.uk/",
            "key": "sunday-mirror"
        },
        "daily-record": {
            "names": [
                "Daily Record"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Daily_Record_(Scotland)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/3/3d/Daily_Record_logo.svg",
            "siteUrl": "http://dailyrecord.co.uk/",
            "key": "daily-record"
        },
        "sunday-mail": {
            "names": [
                "Sunday Mail"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Sunday_Mail_(Scotland)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/2/2f/Sunday_Mail%2C_1.7.07.jpg",
            "siteUrl": "http://sundaymail.co.uk/",
            "key": "sunday-mail"
        },
        "daily-star": {
            "names": [
                "Daily Star"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Daily_Star_(United_Kingdom)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/c/cc/Daily_Star_logo.svg",
            "siteUrl": "http://dailystar.co.uk/",
            "key": "daily-star"
        },
        "daily-star-sunday": {
            "names": [
                "Daily Star Sunday"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Daily_Star_Sunday",
            "siteUrl": "http://dailystar.co.uk/sunday",
            "key": "daily-star-sunday"
        },
        "irish-daily-mirror": {
            "names": [
                "Irish Daily Mirror"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Daily_Mirror",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/a7/Daily_Mirror_masthead.svg",
            "siteUrl": "http://www.mirror.co.uk/",
            "key": "irish-daily-mirror"
        },
        "irish-daily-star": {
            "names": [
                "Irish Daily Star"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Irish_Daily_Star",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/b/b8/Irish_Daily_Star_Logo.jpg",
            "siteUrl": "https://thestar.ie/",
            "key": "irish-daily-star"
        },
        "the-mirror-us": {
            "names": [
                "The Mirror US"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Daily_Mirror",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/a7/Daily_Mirror_masthead.svg",
            "siteUrl": "http://www.mirror.co.uk/",
            "key": "the-mirror-us"
        },
        "sunday-people": {
            "names": [
                "Sunday People"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Sunday_People",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/2/24/The_Sunday_People.jpg",
            "siteUrl": "https://www.mirror.co.uk/all-about/sunday-people",
            "key": "sunday-people"
        },
        "western-mail": {
            "names": [
                "Western Mail"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Western_Mail_(Wales)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Western_Mail_May_1_1869.jpg/120px-Western_Mail_May_1_1869.jpg.png",
            "siteUrl": "http://walesonline.co.uk/",
            "key": "western-mail"
        },
        "wales-on-sunday": {
            "names": [
                "Wales on Sunday"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Western_Mail_(Wales)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Western_Mail_May_1_1869.jpg/120px-Western_Mail_May_1_1869.jpg.png",
            "siteUrl": "http://walesonline.co.uk/",
            "key": "wales-on-sunday"
        },
        "derby-telegraph": {
            "names": [
                "Derby Telegraph"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Derby_Telegraph",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/a/ab/Derby_Telegraph_logo.svg",
            "siteUrl": "http://www.derbytelegraph.co.uk/",
            "key": "derby-telegraph"
        },
        "hinckley-times": {
            "names": [
                "Hinckley Times"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Hinckley_Times",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1d/Hinckley_Times_masthead.jpg/120px-Hinckley_Times_masthead.jpg.png",
            "siteUrl": "http://www.leicestermercury.co.uk/all-about/hinckley",
            "key": "hinckley-times"
        },
        "leicester-mercury": {
            "names": [
                "Leicester Mercury"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Leicester_Mercury",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/2/2a/Leicester_Mercury_June_2010.jpg",
            "siteUrl": "http://www.leicestermercury.co.uk/",
            "key": "leicester-mercury"
        },
        "lincolnshire-echo": {
            "names": [
                "Lincolnshire Echo"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Lincolnshire_Echo",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/Lincolnshire_Echo_-_geograph.org.uk_-_1308221.jpg/120px-Lincolnshire_Echo_-_geograph.org.uk_-_1308221.jpg.png",
            "siteUrl": "http://lincolnshirelive.co.uk/",
            "key": "lincolnshire-echo"
        },
        "loughborough-echo": {
            "names": [
                "Loughborough Echo"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Loughborough_Echo",
            "siteUrl": "http://www.loughboroughecho.net/",
            "key": "loughborough-echo"
        },
        "nottingham-post": {
            "names": [
                "Nottingham Post"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Nottingham_Post",
            "siteUrl": "http://nottinghampost.com/",
            "key": "nottingham-post"
        },
        "retford-times": {
            "names": [
                "Retford Times"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Retford_Times",
            "siteUrl": "http://lincolnshirelive.co.uk/all-about/retford",
            "key": "retford-times"
        },
        "glossop-advertiser": {
            "names": [
                "Glossop Advertiser"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Glossop_Advertiser",
            "siteUrl": "http://glossopadvertiser.co.uk/",
            "key": "glossop-advertiser"
        },
        "tameside-advertiser": {
            "names": [
                "Tameside Advertiser"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Tameside_Advertiser",
            "siteUrl": "http://tamesideadvertiser.co.uk/",
            "key": "tameside-advertiser"
        },
        "the-wharf": {
            "names": [
                "The Wharf"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/The_Wharf_(newspaper)",
            "key": "the-wharf"
        },
        "chronicle-extra": {
            "names": [
                "Chronicle Extra"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Chronicle_Extra",
            "siteUrl": "http://icnewcastle.icnetwork.co.uk/chroniclelive/extra",
            "key": "chronicle-extra"
        },
        "evening-chronicle": {
            "names": [
                "Evening Chronicle"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Evening_Chronicle",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/7/7f/Evening_Chronicle_%28North_East_England_daily_newspaper%29_logo.png",
            "siteUrl": "http://chroniclelive.co.uk/",
            "key": "evening-chronicle"
        },
        "the-journal": {
            "names": [
                "The Journal"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/The_Journal_(Newcastle_upon_Tyne_newspaper)",
            "siteUrl": "http://chroniclelive.co.uk/",
            "key": "the-journal"
        },
        "sunday-sun": {
            "names": [
                "Sunday Sun"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Sunday_Sun",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/0/00/Sunday_Sun_%28North_East_England_newspaper%29_logo.png",
            "siteUrl": "http://www.sundaysun.co.uk/",
            "key": "sunday-sun"
        },
        "accrington-observer": {
            "names": [
                "Accrington Observer"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Accrington_Observer",
            "siteUrl": "http://lancs.live/all-about/accrington",
            "key": "accrington-observer"
        },
        "chester-chronicle": {
            "names": [
                "Chester Chronicle"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Chester_Chronicle",
            "siteUrl": "http://cheshire-live.co.uk/",
            "key": "chester-chronicle"
        },
        "crewe-chronicle": {
            "names": [
                "Crewe Chronicle"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Crewe_Chronicle",
            "siteUrl": "http://cheshire-live.co.uk/all-about/crewe",
            "key": "crewe-chronicle"
        },
        "liverpool-echo": {
            "names": [
                "Liverpool Echo"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Liverpool_Echo",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/b/b3/Liverpool_Echo_logo.svg",
            "siteUrl": "http://www.liverpoolecho.co.uk/",
            "key": "liverpool-echo"
        },
        "manchester-evening-news": {
            "names": [
                "Manchester Evening News"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Manchester_Evening_News",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/d7/ManchesterEveningNewscover.jpg",
            "siteUrl": "https://www.manchestereveningnews.co.uk/",
            "key": "manchester-evening-news"
        },
        "manchester-metro-news": {
            "names": [
                "Manchester Metro News"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Manchester_Metro_News",
            "key": "manchester-metro-news"
        },
        "oldham-advertiser": {
            "names": [
                "Oldham Advertiser"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Oldham_Advertiser",
            "siteUrl": "http://oldhamadvertiser.co.uk/",
            "key": "oldham-advertiser"
        },
        "rochdale-observer": {
            "names": [
                "Rochdale Observer"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Rochdale_Observer",
            "siteUrl": "http://rochdaleobserver.co.uk/",
            "key": "rochdale-observer"
        },
        "rossendale-free-press": {
            "names": [
                "Rossendale Free Press"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Rossendale_Free_Press",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/8/8b/Rossendale_Free_Press_logo.svg",
            "siteUrl": "http://rossendalefreepress.co.uk/",
            "key": "rossendale-free-press"
        },
        "salford-advertiser": {
            "names": [
                "Salford Advertiser"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Salford_Advertiser",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/8/8b/Advertiserlogo.png",
            "siteUrl": "http://www.salfordadvertiser.co.uk/",
            "key": "salford-advertiser"
        },
        "south-manchester-reporter": {
            "names": [
                "South Manchester Reporter"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/South_Manchester_Reporter",
            "siteUrl": "http://southmanchesterreporter.co.uk/",
            "key": "south-manchester-reporter"
        },
        "southport-visiter": {
            "names": [
                "Southport Visiter"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Southport_Visiter",
            "siteUrl": "http://southportvisiter.co.uk/",
            "key": "southport-visiter"
        },
        "stockport-express": {
            "names": [
                "Stockport Express"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Stockport_Express",
            "siteUrl": "http://stockportexpress.co.uk/",
            "key": "stockport-express"
        },
        "macclesfield-express": {
            "names": [
                "Macclesfield Express"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Macclesfield_Express",
            "siteUrl": "http://cheshire-live.co.uk/all-about/macclesfield",
            "key": "macclesfield-express"
        },
        "the-sentinel-(staffordshire)": {
            "names": [
                "The Sentinel (Staffordshire)"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/The_Sentinel_(Staffordshire)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/2/2e/The_Sentinel_logo.png",
            "siteUrl": "http://stokesentinel.co.uk/",
            "key": "the-sentinel-(staffordshire)"
        },
        "airdrie-and-coatbridge-advertiser": {
            "names": [
                "Airdrie and Coatbridge Advertiser"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Airdrie_and_Coatbridge_Advertiser",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d8/Airdrie_%26_Coatbridge_Advertiser%2C_3_April_1858.png/250px-Airdrie_%26_Coatbridge_Advertiser%2C_3_April_1858.png",
            "siteUrl": "http://dailyrecord.co.uk/",
            "key": "airdrie-and-coatbridge-advertiser"
        },
        "ayrshire-post": {
            "names": [
                "Ayrshire Post"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Ayrshire_Post",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/0/05/Ayrshire-post-banner.gif",
            "siteUrl": "https://www.dailyrecord.co.uk/authors/ayrshire-post/",
            "key": "ayrshire-post"
        },
        "blairgowrie-advertiser": {
            "names": [
                "Blairgowrie Advertiser"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Blairgowrie_Advertiser",
            "siteUrl": "http://dailyrecord.co.uk/",
            "key": "blairgowrie-advertiser"
        },
        "dumfries-and-galloway-standard": {
            "names": [
                "Dumfries & Galloway Standard"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Dumfries_%26_Galloway_Standard",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/d2/Dumfries_and_Galloway_Standard.jpg",
            "siteUrl": "http://www.dgstandard.co.uk/",
            "key": "dumfries-and-galloway-standard"
        },
        "east-kilbride-news": {
            "names": [
                "East Kilbride News"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/East_Kilbride_News",
            "siteUrl": "http://dailyrecord.co.uk/",
            "key": "east-kilbride-news"
        },
        "hamilton-advertiser": {
            "names": [
                "Hamilton Advertiser"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Hamilton_Advertiser",
            "siteUrl": "http://www.hamiltonadvertiser.co.uk/",
            "key": "hamilton-advertiser"
        },
        "kilmarnock-standard": {
            "names": [
                "Kilmarnock Standard"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Kilmarnock_Standard",
            "siteUrl": "http://kilmarnockstandard.co.uk/",
            "key": "kilmarnock-standard"
        },
        "paisley-daily-express": {
            "names": [
                "Paisley Daily Express"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Paisley_Daily_Express",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/8/80/PDEfrontcover.jpg",
            "siteUrl": "http://paisleydailyexpress.co.uk/",
            "key": "paisley-daily-express"
        },
        "perthshire-advertiser": {
            "names": [
                "Perthshire Advertiser"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Perthshire_Advertiser",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/c/c3/Perthshirefront.jpg",
            "siteUrl": "http://perthshireadvertiser.co.uk/",
            "key": "perthshire-advertiser"
        },
        "rutherglen-reformer": {
            "names": [
                "Rutherglen Reformer"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Rutherglen_Reformer",
            "siteUrl": "https://www.dailyrecord.co.uk/all-about/rutherglen/",
            "key": "rutherglen-reformer"
        },
        "wishaw-press": {
            "names": [
                "Wishaw Press"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Wishaw_Press",
            "siteUrl": "http://www.dailyrecord.co.uk/all-about/wishaw",
            "key": "wishaw-press"
        },
        "staines-informer": {
            "names": [
                "Staines Informer"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Staines_Informer",
            "key": "staines-informer"
        },
        "surrey-advertiser": {
            "names": [
                "Surrey Advertiser"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Surrey_Advertiser",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/Surrey_Advertiser_1.jpg/250px-Surrey_Advertiser_1.jpg",
            "siteUrl": "http://getsurrey.co.uk/",
            "key": "surrey-advertiser"
        },
        "bath-chronicle": {
            "names": [
                "Bath Chronicle"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Bath_Chronicle",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/df/Bath_Chronicle_2014_redesign%2C_cover.jpg",
            "siteUrl": "http://bathchronicle.co.uk/",
            "key": "bath-chronicle"
        },
        "bristol-post": {
            "names": [
                "Bristol Post"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Bristol_Post",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/1f/Bristol_Post.svg",
            "siteUrl": "http://bristolpost.co.uk/",
            "key": "bristol-post"
        },
        "cornish-guardian": {
            "names": [
                "Cornish Guardian"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Cornish_Guardian",
            "siteUrl": "http://cornwalllive.com/",
            "key": "cornish-guardian"
        },
        "the-cornishman": {
            "names": [
                "The Cornishman"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/The_Cornishman_(newspaper)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/9/93/The_Cornishman.png",
            "siteUrl": "https://cornwalllive.com/",
            "key": "the-cornishman"
        },
        "express-and-echo": {
            "names": [
                "Express & Echo"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Express_%26_Echo",
            "siteUrl": "http://exeterexpressandecho.co.uk/",
            "key": "express-and-echo"
        },
        "gloucester-citizen": {
            "names": [
                "Gloucester Citizen"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Gloucester_Citizen",
            "siteUrl": "http://gloucestershirelive.co.uk/",
            "key": "gloucester-citizen"
        },
        "gloucestershire-echo": {
            "names": [
                "Gloucestershire Echo"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Gloucestershire_Echo",
            "siteUrl": "http://gloucestershirelive.co.uk/",
            "key": "gloucestershire-echo"
        },
        "the-herald": {
            "names": [
                "The Herald"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/The_Herald_(Plymouth)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/7/73/Herald_Front.jpg",
            "siteUrl": "http://plymouthherald.co.uk/",
            "key": "the-herald"
        },
        "mid-devon-gazette": {
            "names": [
                "Mid Devon Gazette"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Mid_Devon_Gazette",
            "key": "mid-devon-gazette"
        },
        "north-devon-journal": {
            "names": [
                "North Devon Journal"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/North_Devon_Journal",
            "siteUrl": "http://devonlive.com/",
            "key": "north-devon-journal"
        },
        "the-west-briton": {
            "names": [
                "The West Briton"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/The_West_Briton",
            "siteUrl": "http://www.westbriton.co.uk/",
            "key": "the-west-briton"
        },
        "western-morning-news": {
            "names": [
                "Western Morning News"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Western_Morning_News",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fe/Western_Morning_News_February_18_2023.jpg/250px-Western_Morning_News_February_18_2023.jpg",
            "key": "western-morning-news"
        },
        "daily-post": {
            "names": [
                "Daily Post"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Daily_Post_(North_Wales)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/1/19/Daily_Post.png",
            "siteUrl": "http://www.dailypost.co.uk/",
            "key": "daily-post"
        },
        "south-wales-echo": {
            "names": [
                "South Wales Echo"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/South_Wales_Echo",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/7/75/South_Wales_Echo.jpg",
            "siteUrl": "https://www.walesonline.co.uk/",
            "key": "south-wales-echo"
        },
        "south-wales-evening-post": {
            "names": [
                "South Wales Evening Post"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/South_Wales_Evening_Post",
            "siteUrl": "http://walesonline.co.uk/",
            "key": "south-wales-evening-post"
        },
        "birmingham-post": {
            "names": [
                "Birmingham Post"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Birmingham_Post",
            "siteUrl": "http://birminghampost.co.uk/",
            "key": "birmingham-post"
        },
        "birmingham-mail": {
            "names": [
                "Birmingham Mail"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Birmingham_Mail",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/95/Birmingham_Mail.svg",
            "siteUrl": "http://birminghamlive.co.uk/",
            "key": "birmingham-mail"
        },
        "sunday-mercury": {
            "names": [
                "Sunday Mercury"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Sunday_Mercury",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/12/SundayMercuryLogo.png",
            "siteUrl": "http://www.sundaymercury.net/",
            "key": "sunday-mercury"
        },
        "coventry-telegraph": {
            "names": [
                "Coventry Telegraph"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Coventry_Telegraph",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/c/cf/Coventry_Telegraph_front_page.jpg",
            "siteUrl": "http://coventrytelegraph.net/",
            "key": "coventry-telegraph"
        },
        "grimsby-telegraph": {
            "names": [
                "Grimsby Telegraph"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Grimsby_Telegraph",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/5/56/Grimsby_Telegraph_Cover.jpg",
            "siteUrl": "http://www.grimsbytelegraph.co.uk/",
            "key": "grimsby-telegraph"
        },
        "huddersfield-daily-examiner": {
            "names": [
                "Huddersfield Daily Examiner"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Huddersfield_Daily_Examiner",
            "siteUrl": "http://examinerlive.co.uk/",
            "key": "huddersfield-daily-examiner"
        },
        "hull-daily-mail": {
            "names": [
                "Hull Daily Mail"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Hull_Daily_Mail",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/e/ed/Hull_Daily_Mail_Logo_%282015%29.jpg",
            "siteUrl": "http://hulldailymail.co.uk/",
            "key": "hull-daily-mail"
        },
        "scunthorpe-telegraph": {
            "names": [
                "Scunthorpe Telegraph"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Scunthorpe_Telegraph",
            "siteUrl": "http://grimsbytelegraph.co.uk/all-about/scunthorpe",
            "key": "scunthorpe-telegraph"
        },
        "bristol-live": {
            "names": [
                "Bristol Live"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Bristol_Live",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/1f/Bristol_Post.svg",
            "siteUrl": "http://bristolpost.co.uk/",
            "key": "bristol-live"
        },
        "buzz.ie": {
            "names": [
                "Buzz.ie"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Buzz.ie",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/b/b8/Irish_Daily_Star_Logo.jpg",
            "siteUrl": "https://thestar.ie/",
            "key": "buzz.ie"
        },
        "cheshire-live": {
            "names": [
                "Cheshire Live"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Cheshire_Live",
            "siteUrl": "http://cheshire-live.co.uk/",
            "key": "cheshire-live"
        },
        "cornwall-live": {
            "names": [
                "Cornwall Live"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Cornwall_Live",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/9/93/The_Cornishman.png",
            "siteUrl": "https://cornwalllive.com/",
            "key": "cornwall-live"
        },
        "devon-live": {
            "names": [
                "Devon Live"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Express_%26_Echo",
            "siteUrl": "http://exeterexpressandecho.co.uk/",
            "key": "devon-live"
        },
        "yorkshire-live": {
            "names": [
                "Yorkshire Live"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Yorkshire_Live",
            "siteUrl": "http://examinerlive.co.uk/",
            "key": "yorkshire-live"
        },
        "hull-live": {
            "names": [
                "Hull Live"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Hull_Live",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/e/ed/Hull_Daily_Mail_Logo_%282015%29.jpg",
            "siteUrl": "http://hulldailymail.co.uk/",
            "key": "hull-live"
        },
        "leicestershire-live": {
            "names": [
                "Leicestershire Live"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Leicestershire_Live",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/2/2a/Leicester_Mercury_June_2010.jpg",
            "siteUrl": "http://www.leicestermercury.co.uk/",
            "key": "leicestershire-live"
        },
        "lincolnshire-live": {
            "names": [
                "Lincolnshire Live"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Lincolnshire_Live",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/Lincolnshire_Echo_-_geograph.org.uk_-_1308221.jpg/120px-Lincolnshire_Echo_-_geograph.org.uk_-_1308221.jpg.png",
            "siteUrl": "http://lincolnshirelive.co.uk/",
            "key": "lincolnshire-live"
        },
        "mylondon": {
            "names": [
                "MyLondon"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/MyLondon",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/24/MyLondon.png",
            "siteUrl": "http://mylondon.news/",
            "key": "mylondon"
        },
        "plymouth-live": {
            "names": [
                "Plymouth Live"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Plymouth_Live",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/7/73/Herald_Front.jpg",
            "siteUrl": "http://plymouthherald.co.uk/",
            "key": "plymouth-live"
        },
        "somerset-live": {
            "names": [
                "Somerset Live"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Somerset_Live",
            "siteUrl": "http://somersetlive.co.uk/",
            "key": "somerset-live"
        },
        "surrey-live": {
            "names": [
                "Surrey Live"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Surrey_Live",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/Surrey_Advertiser_1.jpg/120px-Surrey_Advertiser_1.jpg.png",
            "siteUrl": "http://getsurrey.co.uk/",
            "key": "surrey-live"
        },
        "teesside-live": {
            "names": [
                "Teesside Live"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Teesside_Live",
            "siteUrl": "http://www.gazettelive.co.uk/",
            "key": "teesside-live"
        },
        "walesonline": {
            "names": [
                "WalesOnline"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Media_Wales#WalesOnline",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/94/Media_Wales%2C_Cardiff.jpg/120px-Media_Wales%2C_Cardiff.jpg.png",
            "siteUrl": "https://www.walesonline.co.uk/",
            "key": "walesonline"
        },
        "buckinghamshire-examiner": {
            "names": [
                "Buckinghamshire Examiner"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Buckinghamshire_Examiner",
            "siteUrl": "http://www.buckinghamshireexaminer.co.uk/",
            "key": "buckinghamshire-examiner"
        },
        "reading-post": {
            "names": [
                "Reading Post"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Reading_Post",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/8/88/Reading_Post.jpg",
            "siteUrl": "http://getreading.co.uk/",
            "key": "reading-post"
        },
        "neath-guardian": {
            "names": [
                "Neath Guardian"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "news"
            ],
            "score": 24,
            "ownedBy": [
                "reach"
            ],
            "updatedAt": "2026-01-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Neath_Guardian",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/9/91/Neathguardian.png",
            "key": "neath-guardian"
        },
        "fatface": {
            "names": [
                "FatFace",
                "Fat Face",
                "Fat Face Limited"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing",
                "retail"
            ],
            "score": 44,
            "ownedBy": [
                "next"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/8/8d/Fat_Face_Limited._-_Company_Logo.jpg",
            "siteUrl": "https://fatface.com/",
            "updatedAt": "2026-01-04T10:39:38.234Z",
            "key": "fatface"
        },
        "ferrero": {
            "names": [
                "Ferrero",
                "Ferrero SpA",
                "Ferrero International",
                "Ferrero International SpA",
                "Ferrero Group"
            ],
            "comment": "Ferrero is an Italian confectionery company that has falsely advertised its products as healthy [1][2][3], sourced unethical cocoa [4], and sold Kinder Eggs contaminated with  salmonella [7][8][9]. The company has underpaid employees [5], racially discriminated against workers [6], and taken advantage of child labour in its supply chain [10][11].",
            "sources": {
                "1": "https://www.foodnavigator-usa.com/Article/2012/04/30/Ferrero-backs-away-from-Nutella-health-claims-in-3m-class-action-settlement/",
                "2": "https://www.npr.org/sections/thesalt/2012/04/26/151454929/nutella-maker-may-settle-deceptive-ad-lawsuit-for-3-million",
                "3": "https://www.law360.com/classaction/articles/1363988/kellogg-buyers-say-revised-13m-false-ad-deal-is-gr-r-reat-",
                "4": "https://www.just-food.com/news/nestle-mars-among-chocolate-makers-criticised-in-cocoa-sourcing-report/",
                "5": "https://www.law360.com/articles/2365526/wk-kellogg-kellanova-settle-overtime-suit-for-1-5m",
                "6": "https://topclassactions.com/lawsuit-settlements/closed-settlements/ferrara-candy-company-discrimination-class-action-settlement/",
                "7": "https://brusselssignal.eu/2023/07/belgian-ferrero-chocolate-factory-suffers-second-salmonella-outbreak/",
                "8": "https://www.food.gov.uk/news-alerts/news/further-kinder-products-recalled-following-an-outbreak-of-salmonella",
                "9": "https://www.foodsafetynews.com/2025/03/study-adds-to-details-about-ferrero-salmonella-outbreak/",
                "10": "https://www.business-humanrights.org/en/latest-news/turkey-investigation-links-ferrero-to-exploitation-of-hazelnut-pickers-child-labour-low-pay-long-hours-includes-comments-from-ferrero/",
                "11": "https://www.confectioneryproduction.com/news/52287/ferreros-human-rights-progress-report-underlines-key-work-tackling-child-labour-issues/"
            },
            "sourceNotes": {
                "1": "falsely advertising their products as healthy",
                "2": "falsely advertising their products as healthy",
                "3": "falsely advertising their products as healthy",
                "4": "unethical cocoa sourcing",
                "5": "underpaid employees",
                "6": "racial discrimination against employees",
                "7": "sold kinder eggs containing salmonella",
                "8": "sold kinder eggs containing salmonella",
                "9": "sold kinder eggs containing salmonella",
                "10": "overworking and child labour in supply chain",
                "11": "overworking and child labour in supply chain"
            },
            "tags": [
                "food",
                "deception",
                "child labour",
                "racial discrimination",
                "unfair pay",
                "unsafe products"
            ],
            "score": 22,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/b/b9/Ferrero_logo.svg",
            "siteUrl": "https://www.ferrero.com/",
            "updatedAt": "2026-01-05T15:03:39.285Z",
            "key": "ferrero"
        },
        "nutella": {
            "names": [
                "Nutella"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 22,
            "ownedBy": [
                "ferrero"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/8a/Logo_Nutella.svg",
            "siteUrl": "https://www.ferrero.it/NUTELLA",
            "updatedAt": "2026-01-05T15:13:09.216Z",
            "key": "nutella"
        },
        "kinder": {
            "names": [
                "Kinder"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 22,
            "ownedBy": [
                "ferrero"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/94/Kinder_%28Wortmarke%29_logo.svg",
            "siteUrl": "https://kinder.com/",
            "updatedAt": "2026-01-05T15:13:09.216Z",
            "key": "kinder"
        },
        "tic-tac": {
            "names": [
                "Tic Tac"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 22,
            "ownedBy": [
                "ferrero"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c8/Tic_Tac_logo_2022-present.png/120px-Tic_Tac_logo_2022-present.png.png",
            "siteUrl": "http://ferrero.it/tic-tac",
            "updatedAt": "2026-01-05T15:13:09.216Z",
            "key": "tic-tac"
        },
        "thorntons": {
            "names": [
                "Thorntons",
                "Thorntons Limited"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 22,
            "ownedBy": [
                "ferrero"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/f/f4/Thorntons_company_logo.svg",
            "siteUrl": "https://www.thorntons.com/",
            "updatedAt": "2026-01-05T15:13:09.216Z",
            "key": "thorntons"
        },
        "ferrara": {
            "names": [
                "Ferrara",
                "Ferrara Candy Company",
                "Ferrara Pan Candy Company"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 22,
            "ownedBy": [
                "ferrero"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/52/Ferrara_Candy_Company_logo.svg",
            "siteUrl": "http://www.ferrarausa.com/",
            "updatedAt": "2026-01-05T15:13:09.216Z",
            "key": "ferrara"
        },
        "nerds": {
            "names": [
                "Nerds"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 22,
            "ownedBy": [
                "ferrero"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cc/Nerds-Candies.jpg/250px-Nerds-Candies.jpg",
            "siteUrl": "https://www.nerdscandy.com/",
            "updatedAt": "2026-01-05T15:13:09.216Z",
            "key": "nerds"
        },
        "jelly-belly": {
            "names": [
                "Jelly Belly"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 22,
            "ownedBy": [
                "ferrero"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/4/48/Jelly_Belly_Logo.svg",
            "siteUrl": "http://jellybelly.com/",
            "updatedAt": "2026-01-05T15:13:09.216Z",
            "key": "jelly-belly"
        },
        "fox's": {
            "names": [
                "Fox's"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 22,
            "ownedBy": [
                "ferrero"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/c/c8/Fox%27s_Biscuits_logo.png",
            "siteUrl": "http://www.foxs-biscuits.co.uk/",
            "updatedAt": "2026-01-05T15:13:09.216Z",
            "key": "fox's"
        },
        "eat-natural": {
            "names": [
                "Eat Natural"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 22,
            "ownedBy": [
                "ferrero"
            ],
            "logoUrl": "https://www.ferrero.com/int/sites/ferrero_int/files/2023-06/eat_natural.jpg",
            "siteUrl": "https://www.eatnatural.com/",
            "updatedAt": "2026-01-05T15:13:09.216Z",
            "key": "eat-natural"
        },
        "halo-top": {
            "names": [
                "Halo Top"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 22,
            "ownedBy": [
                "ferrero"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/c/c6/Halo_Top_Creamery_logo.png",
            "siteUrl": "http://halotop.com/",
            "updatedAt": "2026-01-05T15:13:09.216Z",
            "key": "halo-top"
        },
        "mon-cheri": {
            "names": [
                "Mon Cheri",
                "Mon Chéri"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 22,
            "ownedBy": [
                "ferrero"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8d/Ferrero_moncheri_logo.png/120px-Ferrero_moncheri_logo.png.png",
            "siteUrl": "https://www.ferrero.it/prodotti/praline-e-specialita-ferrero/mon-cheri/",
            "updatedAt": "2026-01-05T15:13:09.216Z",
            "key": "mon-cheri"
        },
        "raffaello": {
            "names": [
                "Raffaello"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 22,
            "ownedBy": [
                "ferrero"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/Raffaello_brand_logo.png/120px-Raffaello_brand_logo.png.png",
            "siteUrl": "https://www.ferrero.it/Raffaello",
            "updatedAt": "2026-01-05T15:13:09.216Z",
            "key": "raffaello"
        },
        "first-choice": {
            "names": [
                "First Choice"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "travel"
            ],
            "score": 25,
            "ownedBy": [
                "tui"
            ],
            "logoUrl": "https://ukp.tcb-cdn.com/images/ex-desc/firstchoice-logo-oct23.png",
            "siteUrl": "http://www.firstchoice.co.uk/",
            "updatedAt": "2026-01-06T06:10:28.431Z",
            "key": "first-choice"
        },
        "tui": {
            "names": [
                "TUI",
                "TUI Group",
                "TUI AG",
                "Touristik Union International"
            ],
            "comment": "TUI is a German tourism company that has been accused of false advertising [1], breaching ABTA guidelines [2], and selling tickets to marine parks that abuse orcas [3][4][5]. The company has also caused customers to become ill [6][7][8], used fake parts in its planes [9][10], and enforced the biggest gender pay gap in any UK company [11].",
            "sources": {
                "1": "https://www.sundaypost.com/fp/travel-companies-jet2holidays-and-tui-have-adverts-banned-for-misleading-claims/",
                "2": "https://www.bbc.co.uk/news/business-39000881",
                "3": "https://secure.peta.org.uk/page/31471/action/1?locale=en-GB",
                "4": "https://www.peta.org.uk/blog/tui/",
                "5": "https://www.euronews.com/travel/2022/10/06/swimming-with-dolphins-thousands-call-on-tui-to-stop-selling-cruel-trips",
                "6": "https://www.gbnews.com/news/tui-sued-tourists-holidaymakers-luxury-hotels",
                "7": "https://uk.news.yahoo.com/tui-faces-legal-action-836-143442793.html",
                "8": "https://www.hudgellsolicitors.co.uk/client-stories/tui-agrees-damages-holidaymaker-needed-hospital-treatment-after-being-diagnosed-with-legionnaires-disease-after-trip-india#:~:text=Post%20Office%20Scandal%20%2D%3E%20%C2%B7%20Post%20Office%20IT%20Scandal%20%2D%3E%20%C2%B7%20Horizon%20Convictions%20Redress&text=TUI%20agrees%20damages%20for%20holidaymaker%20who%20needed%20hospital%20treatment",
                "9": "https://www.independent.co.uk/news/uk/home-news/aog-technics-planes-tui-aircraft-parts-b2423123.html",
                "10": "https://simpleflying.com/tui-impacted-parts-with-forged-safety-records/",
                "11": "https://www.theguardian.com/society/2018/feb/16/tui-travel-group-male-employees-paid-more-than-double-female-staff-report"
            },
            "sourceNotes": {
                "1": "false advertising",
                "2": "breached ABTA guidelines",
                "3": "sells tickets to marine parks abusing orcas",
                "4": "sells tickets to marine parks abusing orcas",
                "5": "sells tickets to marine parks abusing orcas",
                "6": "made customers ill",
                "7": "made customers ill",
                "8": "made customers ill",
                "9": "fake parts found in its planes",
                "10": "fake parts found in its planes",
                "11": "biggest gender pay gap in the UK"
            },
            "tags": [
                "travel",
                "deception",
                "animal abuse",
                "unsafe practices",
                "gender discrimination",
                "unfair pay"
            ],
            "score": 25,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/6f/TUI_Logo_2016.svg",
            "siteUrl": "https://www.tuigroup.com/en-en",
            "updatedAt": "2026-01-07T08:44:14.019Z",
            "key": "tui"
        },
        "marella": {
            "names": [
                "Marella",
                "Marella Cruises"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "travel"
            ],
            "score": 25,
            "ownedBy": [
                "tui"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/28/Marella_Cruises_logo.png/120px-Marella_Cruises_logo.png.png",
            "siteUrl": "http://tui.co.uk/cruise.html",
            "updatedAt": "2026-01-07T16:23:16.426Z",
            "key": "marella"
        },
        "hapag-lloyd-cruises": {
            "names": [
                "Hapag-Lloyd cruises"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "travel"
            ],
            "score": 25,
            "ownedBy": [
                "tui"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/d/d6/Hapag-Lloyd_Cruises_logo.svg",
            "siteUrl": "https://www.hl-cruises.com/",
            "updatedAt": "2026-01-07T16:23:16.426Z",
            "key": "hapag-lloyd-cruises"
        },
        "robinson-club": {
            "names": [
                "Robinson Club"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "travel"
            ],
            "score": 25,
            "ownedBy": [
                "tui"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/6b/ROBINSON.svg",
            "siteUrl": "http://www.robinson.com/",
            "updatedAt": "2026-01-07T16:23:16.426Z",
            "key": "robinson-club"
        },
        "energizer": {
            "names": [
                "Energizer",
                "Energizer Holdings, Inc.",
                "Energizer Holdings",
                "ENR"
            ],
            "comment": "Energizer is an American battery company that engaged in false advertising [1], price fixing and monopolistic anti‑competitive practices [2][3], and has poisoned hudreds of its workers with cadmium [4].",
            "sources": {
                "1": "https://news.bloomberglaw.com/litigation/energizer-deceptive-ad-suit-dismissal-gets-affirmed-at-9th-cir",
                "2": "https://www.cohenmilstein.com/case-study/energizer-batteries-antitrust-litigation/",
                "3": "https://www.mlex.com/mlex/articles/2348687/energizer-walmart-hit-with-amended-us-antitrust-complaint-over-batteries",
                "4": "https://pulitzercenter.org/stories/china-powerless-fight-poison"
            },
            "sourceNotes": {
                "1": "false advertising",
                "2": "price fixing, monopolistic anticompetetive practices",
                "3": "price fixing, monopolistic anticompetetive practices",
                "4": "poisoned workers with cadmium"
            },
            "tags": [
                "electronics",
                "consumer goods",
                "anticompetitive practices",
                "deception",
                "unsafe working conditions",
                "unsafe practices"
            ],
            "score": 34,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/e/e0/Energizer_holdings_inc_logo.svg",
            "siteUrl": "https://energizerholdings.com/",
            "updatedAt": "2026-01-02T17:28:41.538Z",
            "key": "energizer"
        },
        "eveready": {
            "names": [
                "Eveready"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "electronics",
                "consumer goods"
            ],
            "score": 34,
            "ownedBy": [
                "energizer"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/af/EvereadyLogo.jpg",
            "siteUrl": "https://eveready.com/",
            "updatedAt": "2026-01-08T09:24:41.373Z",
            "key": "eveready"
        },
        "varta": {
            "names": [
                "VARTA"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "electronics",
                "consumer goods"
            ],
            "score": 34,
            "ownedBy": [
                "energizer"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/a4/Varta-logo-2021.svg",
            "siteUrl": "https://www.varta-ag.com/",
            "updatedAt": "2026-01-08T09:24:41.373Z",
            "key": "varta"
        },
        "armor-all": {
            "names": [
                "Armor All"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "electronics",
                "consumer goods"
            ],
            "score": 34,
            "ownedBy": [
                "energizer"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/8/82/Armor_All_logo.png",
            "siteUrl": "https://www.armorall.com/",
            "updatedAt": "2026-01-08T09:24:41.373Z",
            "key": "armor-all"
        },
        "fitbit": {
            "names": [
                "Fitbit"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech",
                "health"
            ],
            "score": 20,
            "ownedBy": [
                "google"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/a3/Fitbit_logo16.svg",
            "siteUrl": "http://store.google.com/category/watches_trackers",
            "updatedAt": "2026-01-10T01:56:53.443Z",
            "key": "fitbit"
        },
        "fjallraven": {
            "names": [
                "Fjällräven",
                "Fjallraven"
            ],
            "comment": "Fjällräven is a Swedish company that has faced criticism for animal cruelty in its supply chain [1][2].",
            "sources": {
                "1": "https://www.advnture.com/news/fjallraven-and-helly-hansen-suppliers-accused-of-animal-cruelty-following-controversial-investigation",
                "2": "https://www.peta.org.uk/media/news-releases/fjallraven-helly-hansen-implicated-in-peta-expose-revealing-sheep-beaten-whipped-and-killed/"
            },
            "sourceNotes": {
                "1": "connected to animal cruelty",
                "2": "connected to animal cruelty"
            },
            "tags": [
                "clothing",
                "retail",
                "animal abuse"
            ],
            "score": 40,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/5/58/Fj%C3%A4llr%C3%A4ven_logo.svg",
            "siteUrl": "http://fjallraven.com/",
            "updatedAt": "2026-01-10T09:32:11.437Z",
            "key": "fjallraven"
        },
        "flora": {
            "names": [
                "Flora"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": null,
            "ownedBy": [
                "flora-food-group"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/a/ac/Flora_Food_Group.png",
            "siteUrl": "https://florafoodgroup.com/",
            "updatedAt": "2026-01-11T12:13:40.870Z",
            "key": "flora"
        },
        "flora-food-group": {
            "names": [
                "Flora Food Group",
                "Flora Food Group B.V."
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": null,
            "ownedBy": [
                "kkr"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/a/ac/Flora_Food_Group.png",
            "siteUrl": "https://florafoodgroup.com/",
            "updatedAt": "2026-01-11T12:13:40.870Z",
            "key": "flora-food-group"
        },
        "country-crock": {
            "names": [
                "Country Crock"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": null,
            "ownedBy": [
                "flora-food-group"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bb/Country_Crock_Masterbrand_Logo.png/120px-Country_Crock_Masterbrand_Logo.png.png",
            "siteUrl": "https://florafoodgroup.com/",
            "updatedAt": "2026-01-11T12:13:40.870Z",
            "key": "country-crock"
        },
        "blue-band": {
            "names": [
                "Blue Band"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": null,
            "ownedBy": [
                "flora-food-group"
            ],
            "logoUrl": "https://www.blueband.com/en-ke/-/media/Project/Upfield/Brands/Blue-Band-Global/Blue-Band-Consumer-KE/Assets/Logos/BB-logo-mobile.svg?iar=0&rev=-1",
            "siteUrl": "https://www.blueband.com/en-ke/products/blue-band-spread-for-bread",
            "updatedAt": "2026-01-11T12:13:40.870Z",
            "key": "blue-band"
        },
        "stork": {
            "names": [
                "Stork"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": null,
            "ownedBy": [
                "flora-food-group"
            ],
            "logoUrl": "https://www.bakewithstork.com/-/media/Project/Upfield/Whitelabels/Bake-With-Stork-UK/Logos/stork_last_logo.png?h=120&iar=0&w=208&rev=d36584e68b934b24bc824823fe164969",
            "siteUrl": "https://www.bakewithstork.com/",
            "updatedAt": "2026-01-11T12:13:40.870Z",
            "key": "stork"
        },
        "i-can't-believe-it's-not-butter!": {
            "names": [
                "I Can't Believe It's Not Butter!"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": null,
            "ownedBy": [
                "flora-food-group"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/9/91/NotButter.jpg",
            "siteUrl": "https://www.icantbelieveitsnotbutter.com/",
            "updatedAt": "2026-01-11T12:13:40.870Z",
            "key": "i-can't-believe-it's-not-butter!"
        },
        "becel": {
            "names": [
                "Becel"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": null,
            "ownedBy": [
                "flora-food-group"
            ],
            "logoUrl": "https://www.becel.com/-/media/Project/Upfield/Brands/Becel-NL/Becel-Splash/Becel-logo.png?rev=f9f5478e04ce40bbbb22451a609f34c8",
            "siteUrl": "http://www.becel.ca/",
            "updatedAt": "2026-01-11T12:13:40.870Z",
            "key": "becel"
        },
        "folgers": {
            "names": [
                "Folgers"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "coffee"
            ],
            "score": null,
            "ownedBy": [
                "jm-smucker"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/5/57/FolgersLogo.png",
            "siteUrl": "https://www.folgerscoffee.com/",
            "updatedAt": "2026-01-12T19:10:11.661Z",
            "key": "folgers"
        },
        "fossil": {
            "names": [
                "Fossil",
                "Fossil Group, Inc.",
                "Fossil Group",
                "FOSL"
            ],
            "comment": "Fossil is an American clothing and accessory company that is alleged to have engaged in deceptive pricing [1].",
            "sources": {
                "1": "https://topclassactions.com/lawsuit-settlements/lawsuit-news/shoppers-accuse-fossil-of-deceptive-reference-pricing-scheme/"
            },
            "sourceNotes": {
                "1": "deceptive pricing"
            },
            "tags": [
                "clothing",
                "retail",
                "deception"
            ],
            "score": 49,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Fossil_Group.png/120px-Fossil_Group.png.png",
            "siteUrl": "http://fossilgroup.com/",
            "updatedAt": "2026-01-14T18:09:01.064Z",
            "key": "fossil"
        },
        "friskies": {
            "names": [
                "Friskies"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "pets"
            ],
            "score": 10,
            "ownedBy": [
                "nestle"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/2/25/Logo_friskies_site.png",
            "siteUrl": "https://www.purina.com/friskies",
            "updatedAt": "2026-01-15T22:44:10.007Z",
            "key": "friskies"
        },
        "loveholidays": {
            "names": [
                "Loveholidays",
                "We Love Holidays Ltd",
                "loveholidays"
            ],
            "comment": "Loveholidays is a British online holiday booking platform that has allowed customers to fall victim to scams [1][2][3] and misleading pricing [4][5] as well as sending customers to closed hotels [6].",
            "sources": {
                "1": "https://www.bbc.co.uk/news/articles/c778xg2zgrvo",
                "2": "https://www.express.co.uk/travel/articles/1312939/loveholidays-warning-fraud-scam-holidays-refunds-2020-Facebook",
                "3": "https://www.msn.com/en-gb/travel/news/manchester-family-claim-loveholidays-1-800-five-star-resort-was-scam/ar-AA1KRE4D",
                "4": "https://www.lewissilkin.com/insights/2025/07/23/love-holidays-but-dislike-misleading-price-claims-so-does-the-asa-102kv4m",
                "5": "https://travelweekly.co.uk/news/loveholidays-adverts-misled-customers-with-price-discount-claims-watchdog-rules",
                "6": "https://www.which.co.uk/news/article/loveholidays-customers-beings-sent-to-padlocked-hotels-afTen1t8ekaO"
            },
            "sourceNotes": {
                "1": "allowed customers to fall victim to scams",
                "2": "allowed customers to fall victim to scams",
                "3": "allowed customers to fall victim to scams",
                "4": "misleading pricing",
                "5": "misleading pricing",
                "6": "sent customers to closed hotels"
            },
            "tags": [
                "travel",
                "deception"
            ],
            "score": 45,
            "ownedBy": [],
            "logoUrl": "https://cdn.tgvg.net/dyn/eY/19/eY19aU9OyAA/_/yQhLmznjKO0/xFbB/loveholidays.jpg?auto=webp&width=3840&quality=75&enable=upscale",
            "siteUrl": "https://www.loveholidays.com/",
            "updatedAt": "2026-01-16T13:38:30.077Z",
            "key": "loveholidays"
        },
        "funko": {
            "names": [
                "Funko",
                "Funko Inc.",
                "FNKO"
            ],
            "comment": "Funko is a U.S.-based company that has misled customers [1][2] and has engaged in an excessive use of DMCA to take down innocent websites [3][4]. It has also been criticized for sending $30 million worth of stock to landfill [5][6][7].",
            "sources": {
                "1": "https://www.the-sun.com/money/14072219/funko-toy-maker-checks-misleading-class-action-settlement/",
                "2": "https://www.valueaddedresource.net/funko-2-million-lawsuit-misleading-statements/",
                "3": "https://game-whisper.com/2024/12/10/funko-pop-issues-a-non-apology-full-of-holes-over-itch-io-takedown/",
                "4": "https://gamerant.com/funko-itchio-controversy-response/",
                "5": "https://www.businessinsider.com/funko-pop-sends-plastic-figurines-to-dump-excess-inventory-2023-3",
                "6": "https://www.businessinsider.com/funko-pop-sends-plastic-figurines-to-dump-excess-inventory-2023-3",
                "7": "https://www.npr.org/2023/03/04/1161070238/funko-pop-landfill"
            },
            "sourceNotes": {
                "1": "misled customers",
                "2": "misled customers",
                "3": "excessive use of DMCA to take down innocent websites",
                "4": "excessive use of DMCA to take down innocent websites",
                "5": "wasted $30 million worth of stock",
                "6": "wasted $30 million worth of stock",
                "7": "wasted $30 million worth of stock"
            },
            "tags": [
                "retail",
                "toys",
                "deception",
                "unsustainable practices",
                "environmental violations"
            ],
            "score": 40,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/c/cc/Funko.svg",
            "siteUrl": "https://www.funko.com/",
            "updatedAt": "2026-01-17T11:16:45.330Z",
            "key": "funko"
        },
        "gamestop": {
            "names": [
                "Gamestop"
            ],
            "comment": "Gamestop is an American video‑game retailer whose CEO has issued anti‑DEI statements [1] and has engaged in anti‑consumer practices [2]; its stores have been reported to have poor working conditions [3][4] and the company has leaked customer data to Facebook [5][6].",
            "sources": {
                "1": "https://thehill.com/business/5152167-gamestop-ceo-attacks-wokeness/",
                "2": "https://www.gamespot.com/articles/gamestop-cuts-coupon-ethical-corners/1100-6330897/",
                "3": "https://geekoutpost.com/gamestop-sucks/",
                "4": "https://kotaku.com/we-are-all-scared-for-our-jobs-gamestop-employees-talk-1791963185",
                "5": "https://www.gamespot.com/articles/heres-how-to-get-free-money-from-gamestop-maybe/1100-6532337/",
                "6": "https://www.claimdepot.com/settlements/gamestop-vppa-settlement"
            },
            "sourceNotes": {
                "1": "anti-DEI statements by CEO",
                "2": "anticonsumer practices",
                "3": "poor working conditions",
                "4": "poor working conditions",
                "5": "leaked customer data to facebook",
                "6": "leaked customer data to facebook"
            },
            "tags": [
                "videogames",
                "entertainment",
                "retail",
                "gender discrimination",
                "poor working conditions",
                "privacy violations",
                "data breach"
            ],
            "score": 41,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/38/GameStop_Logo.svg",
            "siteUrl": "http://gamestop.com/",
            "updatedAt": "2026-01-18T11:01:16.246Z",
            "key": "gamestop"
        },
        "garmin": {
            "names": [
                "Garmin",
                "Garmin Ltd.",
                "ProNav",
                "GRMN"
            ],
            "comment": "Garmin is a US-based technology company that has been accused of hiding features behind paywalls [1] and engaging in false advertising [2], and has also illegally fired pregnant migrant workers [3].",
            "sources": {
                "1": "https://finance.yahoo.com/news/bad-news-garmin-users-future-094951033.html?guccounter=1",
                "2": "https://www.ragtrader.com.au/news/fitness-watchmaker-garmin-forced-to-pull-claims",
                "3": "https://newbloommag.net/2023/05/08/garmin-migrant-worker/"
            },
            "sourceNotes": {
                "1": "hides features behind paywalls",
                "2": "false advertising",
                "3": "illegally fired pregant migrant workers"
            },
            "tags": [
                "electronics",
                "tech",
                "deception",
                "gender discrimination"
            ],
            "score": 37,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/1/1d/Garmin_2024_logo.svg",
            "siteUrl": "http://garmin.com/",
            "updatedAt": "2026-01-19T19:27:17.045Z",
            "key": "garmin"
        },
        "geico": {
            "names": [
                "Geico"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "insurance"
            ],
            "score": 17,
            "ownedBy": [
                "berkshire-hathaway"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/d/d2/Geico_logo.svg",
            "siteUrl": "https://www.geico.com/",
            "updatedAt": "2026-01-20T10:01:17.307Z",
            "key": "geico"
        },
        "ghirardelli": {
            "names": [
                "Ghirardelli",
                "Ghirardelli Chocolate Company",
                "The Ghirardelli Chocolate Company"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 29,
            "ownedBy": [
                "lindt"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/4/49/Ghirardelli_Chocolate_Company_logo.webp",
            "siteUrl": "https://www.ghirardelli.com/",
            "updatedAt": "2026-01-21T10:36:24.663Z",
            "key": "ghirardelli"
        },
        "havaianas": {
            "names": [
                "Havaianas"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "shoes",
                "retail"
            ],
            "score": null,
            "ownedBy": [
                "itaúsa"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Havaianas_brand_logo.png/120px-Havaianas_brand_logo.png.png",
            "siteUrl": "https://havaianas.com/",
            "updatedAt": "2026-01-31T08:38:09.336Z",
            "key": "havaianas"
        },
        "gopro": {
            "names": [
                "GoPro",
                "GoPro, Inc.",
                "goPRO",
                "GPRO"
            ],
            "comment": "",
            "sources": {
                "1": "https://www.ft.com/content/1e997764-b71d-11e6-ba85-95d1533d9a62",
                "2": "https://portal.ct.gov/-/media/ag/press_releases/2015/20150715ficollectiontotalsfy15pdf.pdf?rev=7aeb8fc23b8a4591bd5fad8746d8f241&hash=93E758C9AB23DDEEFAE3CEAF9C11B992",
                "3": "https://www.youtube.com/watch?v=XW_jl6tR1EA",
                "4": "https://community.gopro.com/s/question/0D58a0000AGqwTECQZ/go-pro-hero-11-is-not-water-proof?language=en_US",
                "5": "https://chinalaborwatch.org/labor-conditions-in-chinas-consumer-electronics-sector/"
            },
            "sourceNotes": {
                "1": "laid off hundreds of employees",
                "2": "tax avoidance",
                "3": "misleading advertising/design flaws in cameras",
                "4": "misleading advertising/design flaws in cameras",
                "5": "forced labour in supply chain"
            },
            "tags": [
                "electronics"
            ],
            "score": 45,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/67/GoPro_logo_light.svg",
            "siteUrl": "https://gopro.com/",
            "updatedAt": "2026-01-23T12:28:29.126Z",
            "key": "gopro"
        },
        "gsk": {
            "names": [
                "GSK",
                "GSK plc",
                "GlaxoSmithKline plc",
                "GlaxoSmithKline",
                "Glaxo Wellcome",
                "SmithKline Beecham",
                "Smith, Kline & French"
            ],
            "comment": "GSK is a British pharmaceutical company that has been implicated in tax avoidance [1], market manipulation and anticompetitive practices [2], and continued operations in Russia despite international pressure [3][4]. The company has engaged in widespread bribery of doctors [5][6][7][8], fraud, drug safety violations, and the illegal manufacturing and sale of contaminated drugs [9][10][11].",
            "sources": {
                "1": "https://web.archive.org/web/20170329043037/http://www.nytimes.com/2006/09/12/business/worldbusiness/12glaxo.html",
                "2": "https://ghostarchive.org/archive/20220111/https://www.telegraph.co.uk/finance/newsbysector/pharmaceuticalsandchemicals/12153450/Watchdog-fines-GSK-37m-for-paying-to-keep-generic-drugs-out-of-UK-market.html",
                "3": "https://www.reuters.com/business/healthcare-pharmaceuticals/gsk-supply-essential-medicines-russia-halts-clinical-trials-2022-03-17/",
                "4": "https://www.inquirer.com/business/big-pharma-russia-ukraine-merck-johnson-and-johnson-pfizer-gsk-20220311.html",
                "5": "https://web.archive.org/web/20220831183705/https://www.theguardian.com/world/2004/may/27/italy.heatherstewart",
                "6": "https://web.archive.org/web/20151017042412/http://www.ncbi.nlm.nih.gov/pmc/articles/PMC420312/pdf/bmj3281333a.pdf",
                "7": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC420312",
                "8": "https://web.archive.org/web/20220221193748/https://www.reuters.com/article/us-britain-fraud-sfo-gsk-idUSKBN0FS1U320140723",
                "9": "https://web.archive.org/web/20230405082107/https://www.nytimes.com/2010/10/27/business/27drug.html",
                "10": "https://web.archive.org/web/20140909141736/http://www.justice.gov/opa/pr/2012/July/12-civ-842.html",
                "11": "https://www.theguardian.com/business/2012/jul/03/glaxosmithkline-fined-bribing-doctors-pharmaceuticals"
            },
            "sourceNotes": {
                "1": "tax avoidance",
                "2": "market manipulation and anticompetetive practices",
                "3": "continued operations in russia",
                "4": "continued operations in russia",
                "5": "bribed doctors",
                "6": "bribed doctors",
                "7": "bribed doctors",
                "8": "bribed doctors",
                "9": "illegally manufactured and sold contaminated drugs",
                "10": "fraud, drug safety violations, and bribery",
                "11": "fraud, drug safety violations, and bribery"
            },
            "tags": [
                "pharmaceuticals",
                "consumer goods",
                "anticompetitive practices",
                "tax avoidance",
                "connections to russia",
                "corruption",
                "deception",
                "unsafe practices"
            ],
            "score": 5,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/thumb/3/32/GSK_logo_2022.svg/250px-GSK_logo_2022.svg.png",
            "siteUrl": "http://gsk.com/",
            "updatedAt": "2026-01-25T09:50:44.120Z",
            "key": "gsk"
        },
        "halfords": {
            "names": [
                "Halfords",
                "Halfords Group",
                "Halfords Group plc",
                "Halfords Group PLC",
                "Halfords Autocentre",
                "HFD"
            ],
            "comment": "Halfords is a British automotive retailer that has engaged in fraudulent MOT testing [1] and has been repeatedly accused of racial discrimination against employees [2][3][4] and customers [5], as well as discrimination against disabled employees [6][7]. The company has also been cited for misuse of personal data [8][9].",
            "sources": {
                "1": "https://garagewire.co.uk/news/mot-news/halfords-mot-tester-admits-issuing-31-fraudulent-certificates/",
                "2": "https://www.independent.co.uk/news/uk/home-news/halfords-race-discrimination-court-claim-b2142508.html",
                "3": "https://www.mylondon.news/news/south-london-news/south-london-halfords-manager-racially-26484932",
                "4": "https://www.mirror.co.uk/news/uk-news/two-halfords-staff-axed-racism-7323072",
                "5": "https://racism-at-halfords.blogspot.com/",
                "6": "https://www.gov.uk/employment-tribunal-decisions/mr-p-withers-v-halfords-autocentres-ltd-3300451-slash-2022",
                "7": "https://hrreview.co.uk/hr-news/employment-law/halfords-ordered-to-implement-new-edi-training-following-discrimination-case/372613",
                "8": "https://www.lewissilkin.com/insights/2022/09/15/no-means-no-ico-fines-halfords-for-misuse-of-consent-over-nearly-500-000-emails-102hwhv",
                "9": "https://www.mils.co.uk/legal-articles/halfords-fined-for-sending-nearly-500000-unwanted-marketing-emails/"
            },
            "sourceNotes": {
                "1": "fraudulent MOT tests given",
                "2": "racial discrimination against employees",
                "3": "racial discrimination against employees",
                "4": "racial discrimination against employees",
                "5": "racial discrimination against customers",
                "6": "discrimination against disabled employees",
                "7": "discrimination against disabled employees",
                "8": "misuse of personal data",
                "9": "misuse of personal data"
            },
            "tags": [
                "retail",
                "deception",
                "privacy violations",
                "racial discrimination",
                "unsafe practices"
            ],
            "score": 42,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/3/36/Halfords_logo.svg",
            "siteUrl": "https://www.halfords.com/",
            "updatedAt": "2026-01-26T09:11:22.664Z",
            "key": "halfords"
        },
        "boardman-bikes": {
            "names": [
                "Boardman Bikes"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "sports"
            ],
            "score": 42,
            "ownedBy": [
                "halfords"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/3/38/Boardman_logo_2015.svg",
            "siteUrl": "https://www.boardmanbikes.com/",
            "updatedAt": "2026-01-27T11:51:40.919Z",
            "key": "boardman-bikes"
        },
        "halifax": {
            "names": [
                "Halifax"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "bank"
            ],
            "score": 20,
            "ownedBy": [
                "lloyds"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/d9/Halifax_logo.svg",
            "siteUrl": "http://www.halifax.co.uk/",
            "updatedAt": "2026-01-28T19:21:44.236Z",
            "key": "halifax"
        },
        "head": {
            "names": [
                "HEAD",
                "Head Sport",
                "Head Sport GmbH"
            ],
            "comment": "HEAD is an American-Austrian sports gear manufacturing company which has released toxic chemicals into the environment [1].",
            "sources": {
                "1": "https://echo.epa.gov/enforcement-case-report?id=09-2009-3002"
            },
            "sourceNotes": {
                "1": "release of toxic chemicals"
            },
            "tags": [
                "sports",
                "retail",
                "clothing",
                "environmental violations",
                "unsustainable practices"
            ],
            "score": 50,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/88/HEAD.svg",
            "siteUrl": "https://www.head.com/",
            "updatedAt": "2026-02-02T21:06:51.456Z",
            "key": "head"
        },
        "zoggs": {
            "names": [
                "Zoggs"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "sports",
                "retail",
                "clothing"
            ],
            "score": 50,
            "ownedBy": [
                "head"
            ],
            "logoUrl": "https://swim2u.com.au/wp-content/uploads/2021/09/Zoggs-new-logo.jpg",
            "siteUrl": "https://www.zoggs.com/",
            "updatedAt": "2026-02-02T21:06:51.456Z",
            "key": "zoggs"
        },
        "penn": {
            "names": [
                "Penn",
                "Penn Racquet Sports",
                "Penn Racquet Sports, Inc."
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "sports",
                "retail",
                "clothing"
            ],
            "score": 50,
            "ownedBy": [
                "head"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/6/6e/Penn_Racquet_Sports_logo.png",
            "siteUrl": "http://www.pennracquet.com/",
            "updatedAt": "2026-02-02T21:06:51.456Z",
            "key": "penn"
        },
        "mares": {
            "names": [
                "Mares"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "sports",
                "retail",
                "clothing"
            ],
            "score": 50,
            "ownedBy": [
                "head"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/22/Mares_logo.svg",
            "siteUrl": "http://www.mares.com/",
            "updatedAt": "2026-02-02T21:06:51.456Z",
            "key": "mares"
        },
        "harley-davidson": {
            "names": [
                "Harley-Davidson",
                "Harley-Davidson, Inc.",
                "HOG"
            ],
            "comment": "Harley-Davidson is an American motorcycle manufacturer that has sold bike modifications violating emissions standards [2][3], ended DEI programs and received a poor Corporate Equality Index ranking [4][5], and sold unsafe bikes resulting in lethal crashes [6][7]. The company has also fraudulently underpaid customer refunds [8] and maintained unsafe working conditions that caused a worker to lose a finger [9].",
            "sources": {
                "2": "https://web.archive.org/web/20160818235952/http://arstechnica.com/cars/2016/08/harley-davidson-to-pay-12-million-for-emissions-spewing-aftermarket-tuners/",
                "3": "https://web.archive.org/web/20160818183214/http://www.cleveland.com/metro/index.ssf/2016/08/epa_cracks_down_on_harley-davi.html",
                "4": "https://www.independent.co.uk/news/world/americas/harleydavidson-boycott-woke-diversity-b2598619.html",
                "5": "https://www.ydr.com/story/opinion/readers/2024/08/27/its-disappointing-that-harley-davidson-backed-away-from-dei/74951951007/",
                "6": "https://13wham.com/news/local/caledonia-man-awarded-240m-in-damages-in-lawsuit-against-harley-davidson-harold-morris-pamela-sinclair-north-township-pennsylvania",
                "7": "https://jurimatic.com/harley-davidson-hit-with-287m-verdict-in-fatal-motorcycle-crash/",
                "8": "https://web.archive.org/web/20140709014611/http://www.mass.gov/ago/news-and-updates/press-releases/2014/2014-06-06-harley-davidson.html",
                "9": "https://www.osha.gov/ords/imis/establishment.inspection_detail?id=1361101.015"
            },
            "sourceNotes": {
                "2": "sold bike modifications which violated emmissions standards",
                "3": "sold bike modifications which violated emmissions standards",
                "4": "ended DEI programs",
                "5": "ended DEI programs and poor ranking on Corporate Equality Index",
                "6": "sold unsafe bikes resulting in lethal crash",
                "7": "sold unsafe bikes resulting in lethal crash",
                "8": "fraudulently underpaid customer refunds",
                "9": "unsafe working conditions resulting in worker losing a finger"
            },
            "tags": [
                "cars",
                "vehicles",
                "environmental violations",
                "unsustainable practices",
                "deception",
                "unsafe products",
                "unsafe working conditions",
                "gender discrimination"
            ],
            "score": 15,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dd/Harley_Davidson_logo.gif/120px-Harley_Davidson_logo.gif.png",
            "siteUrl": "https://www.harley-davidson.com/",
            "updatedAt": "2026-01-29T08:20:24.570Z",
            "key": "harley-davidson"
        },
        "hasbro": {
            "names": [
                "Hasbro",
                "Hasbro, Inc.",
                "Hassenfeld Brothers",
                "HAS"
            ],
            "comment": "Hasbro is an American toy company that has been repeatedly criticized for gender and ethnic bias in its toy lines [1][2][3][4] and for selling defective infant carriers that caused injuries [5]. The company has also faced allegations of forced labour and child labour in its supply chain [6][7][8].",
            "sources": {
                "1": "https://web.archive.org/web/20150925162900/http://www.independent.co.uk/news/uk/home-news/guess-whos-sexist-classic-board-games-gender-bias-leaves-sixyearold-fuming-8324067.html",
                "2": "https://web.archive.org/web/20140407102709/http://gma.yahoo.com/blogs/abc-blogs/teen-starts-campaign-gender-neutral-easy-bake-oven-155338662--abc-news-topstories.html",
                "3": "https://web.archive.org/web/20230530075646/https://www.latimes.com/business/la-xpm-2012-dec-04-la-fi-easy-bake-20121204-story.html",
                "4": "https://web.archive.org/web/20171201182552/https://www.polygon.com/2016/1/5/10715144/hasbro-explains-why-rey-was-excluded-from-star-wars-monopoly",
                "5": "https://web.archive.org/web/20170115211630/https://www.cpsc.gov/Newsroom/News-Releases/2000/Hasbro-Pays-400000-Civil-Penalty-for-Delay-in-Reporting-Infant-Carrier-Defect",
                "6": "https://web.archive.org/web/20170130222327/http://www.nytimes.com/2007/08/22/business/worldbusiness/22factory.html?ref=business",
                "7": "https://fortune.com/2015/11/22/hasbro-mattel-china-labor/",
                "8": "https://www.cnbc.com/2018/12/07/nightmare-at-chinese-factories-making-hasbro-and-disney-toys.html"
            },
            "sourceNotes": {
                "1": "gender and ethnic bias in toys",
                "2": "gender and ethnic bias in toys",
                "3": "gender and ethnic bias in toys",
                "4": "gender and ethnic bias in toys",
                "5": "sold defective infant carriers leading to several injuries",
                "6": "forced labour and child labour in supply chain",
                "7": "forced labour and child labour in supply chain",
                "8": "forced labour and child labour in supply chain"
            },
            "tags": [
                "toys",
                "retail",
                "gender discrimination",
                "racial discrimination",
                "child labour",
                "forced labour",
                "unsafe practices"
            ],
            "score": 25,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ea/Hasbro_logo.svg/120px-Hasbro_logo.svg.png",
            "siteUrl": "http://shop.hasbro.com/",
            "updatedAt": "2026-01-30T07:01:01.873Z",
            "key": "hasbro"
        },
        "wizards-of-the-coast": {
            "names": [
                "Wizards of the Coast",
                "Wizards of the Coast LLC",
                "WotC"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys",
                "retail",
                "entertainment"
            ],
            "score": 25,
            "ownedBy": [
                "hasbro"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/25/Wizards_of_the_coast_logo_21.webp/120px-Wizards_of_the_coast_logo_21.webp.png",
            "siteUrl": "https://company.wizards.com/en",
            "updatedAt": "2026-01-30T11:05:25.212Z",
            "key": "wizards-of-the-coast"
        },
        "dungeons-and-dragons": {
            "names": [
                "Dungeons & Dragons",
                "DnD"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys",
                "retail",
                "entertainment"
            ],
            "score": 25,
            "ownedBy": [
                "hasbro"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/8/8e/Dungeons_%26_Dragons_5th_Edition_logo.svg",
            "siteUrl": "https://www.dndbeyond.com/",
            "updatedAt": "2026-01-30T11:05:25.212Z",
            "key": "dungeons-and-dragons"
        },
        "magic:-the-gathering": {
            "names": [
                "Magic: The Gathering",
                "MtG",
                "MTG"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys",
                "retail",
                "entertainment"
            ],
            "score": 25,
            "ownedBy": [
                "hasbro"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/a/aa/Magic_the_gathering-card_back.jpg/250px-Magic_the_gathering-card_back.jpg",
            "siteUrl": "http://magic.wizards.com/",
            "updatedAt": "2026-01-30T11:05:25.212Z",
            "key": "magic:-the-gathering"
        },
        "action-man": {
            "names": [
                "Action Man"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys",
                "retail",
                "entertainment"
            ],
            "score": 25,
            "ownedBy": [
                "hasbro"
            ],
            "updatedAt": "2026-01-30T11:05:25.212Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Action_Man",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/50/Action_man_toyline_logo.png/120px-Action_man_toyline_logo.png.png",
            "key": "action-man"
        },
        "bop-it!": {
            "names": [
                "Bop It!"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys",
                "retail",
                "entertainment"
            ],
            "score": 25,
            "ownedBy": [
                "hasbro"
            ],
            "updatedAt": "2026-01-30T11:05:25.212Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Bop_It!",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/94/Bop_It_logo.svg",
            "key": "bop-it!"
        },
        "cluedo": {
            "names": [
                "Cluedo"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys",
                "retail",
                "entertainment"
            ],
            "score": 25,
            "ownedBy": [
                "hasbro"
            ],
            "updatedAt": "2026-01-30T11:05:25.212Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Cluedo",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Cluedo_Clue_pack_logo.png/120px-Cluedo_Clue_pack_logo.png.png",
            "key": "cluedo"
        },
        "g.i.-joe": {
            "names": [
                "G.I. Joe"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys",
                "retail",
                "entertainment"
            ],
            "score": 25,
            "ownedBy": [
                "hasbro"
            ],
            "updatedAt": "2026-01-30T11:05:25.212Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/G.I._Joe",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Gi_joe_franchise_logo.png/120px-Gi_joe_franchise_logo.png.png",
            "key": "g.i.-joe"
        },
        "jem-and-the-holograms": {
            "names": [
                "Jem and The Holograms"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys",
                "retail",
                "entertainment"
            ],
            "score": 25,
            "ownedBy": [
                "hasbro"
            ],
            "updatedAt": "2026-01-30T11:05:25.212Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Jem_and_The_Holograms",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/8/88/Jem_logo.jpg",
            "key": "jem-and-the-holograms"
        },
        "littlest-pet-shop": {
            "names": [
                "Littlest Pet Shop"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys",
                "retail",
                "entertainment"
            ],
            "score": 25,
            "ownedBy": [
                "hasbro"
            ],
            "updatedAt": "2026-01-30T11:05:25.212Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Littlest_Pet_Shop",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/Littlest_Pet_Shop_%282012_TV_series%29_logo.png/120px-Littlest_Pet_Shop_%282012_TV_series%29_logo.png.png",
            "key": "littlest-pet-shop"
        },
        "monopoly": {
            "names": [
                "Monopoly"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys",
                "retail",
                "entertainment"
            ],
            "score": 25,
            "ownedBy": [
                "hasbro"
            ],
            "updatedAt": "2026-01-30T11:05:25.212Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Monopoly_(game)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1d/Monopoly_logo_white_border.svg/120px-Monopoly_logo_white_border.svg.png",
            "key": "monopoly"
        },
        "my-little-pony": {
            "names": [
                "My Little Pony"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys",
                "retail",
                "entertainment"
            ],
            "score": 25,
            "ownedBy": [
                "hasbro"
            ],
            "updatedAt": "2026-01-30T11:05:25.212Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/My_Little_Pony",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/2d/My_little_pony_logo22.svg",
            "key": "my-little-pony"
        },
        "nerf": {
            "names": [
                "Nerf"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys",
                "retail",
                "entertainment"
            ],
            "score": 25,
            "ownedBy": [
                "hasbro"
            ],
            "updatedAt": "2026-01-30T11:05:25.212Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Nerf",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e3/Nerf_orange_logo.png/120px-Nerf_orange_logo.png.png",
            "siteUrl": "https://shop.hasbro.com/en-us/nerf",
            "key": "nerf"
        },
        "ouija": {
            "names": [
                "Ouija"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys",
                "retail",
                "entertainment"
            ],
            "score": 25,
            "ownedBy": [
                "hasbro"
            ],
            "updatedAt": "2026-01-30T11:05:25.212Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Ouija",
            "key": "ouija"
        },
        "post-it": {
            "key": "post-it",
            "names": [
                "Post-it"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 19,
            "ownedBy": [
                "3m"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/d/dc/Post-it-2020.svg",
            "siteUrl": "https://www.post-it.com/",
            "updatedAt": "2026-05-17T09:15:00.177Z"
        },
        "peppa-pig": {
            "names": [
                "Peppa Pig"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys",
                "retail",
                "entertainment"
            ],
            "score": 25,
            "ownedBy": [
                "hasbro"
            ],
            "updatedAt": "2026-01-30T11:05:25.212Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Peppa_Pig",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/8/86/Peppa_Pig_logo.svg",
            "key": "peppa-pig"
        },
        "playskool": {
            "names": [
                "Playskool"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys",
                "retail",
                "entertainment"
            ],
            "score": 25,
            "ownedBy": [
                "hasbro"
            ],
            "updatedAt": "2026-01-30T11:05:25.212Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Playskool",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bf/Playskool_brand_logo.png/120px-Playskool_brand_logo.png.png",
            "key": "playskool"
        },
        "pj-masks": {
            "names": [
                "PJ Masks"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys",
                "retail",
                "entertainment"
            ],
            "score": 25,
            "ownedBy": [
                "hasbro"
            ],
            "updatedAt": "2026-01-30T11:05:25.212Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/PJ_Masks",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/f/f0/PJ-Masks-logo-2.png",
            "key": "pj-masks"
        },
        "play-doh": {
            "names": [
                "Play-Doh"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys",
                "retail",
                "entertainment"
            ],
            "score": 25,
            "ownedBy": [
                "hasbro"
            ],
            "updatedAt": "2026-01-30T11:05:25.212Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Play-Doh",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Play_doh_craftbrand_logo.svg/120px-Play_doh_craftbrand_logo.svg.png",
            "key": "play-doh"
        },
        "potato-head": {
            "names": [
                "Potato Head"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys",
                "retail",
                "entertainment"
            ],
            "score": 25,
            "ownedBy": [
                "hasbro"
            ],
            "updatedAt": "2026-01-30T11:05:25.212Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Potato_Head",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f7/Santa_Claus_Parade_%284107912568%29.jpg/120px-Santa_Claus_Parade_%284107912568%29.jpg.png",
            "key": "potato-head"
        },
        "power-rangers": {
            "names": [
                "Power Rangers"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys",
                "retail",
                "entertainment"
            ],
            "score": 25,
            "ownedBy": [
                "hasbro"
            ],
            "updatedAt": "2026-01-30T11:05:25.212Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Power_Rangers",
            "key": "power-rangers"
        },
        "stretch-armstrong": {
            "names": [
                "Stretch Armstrong"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys",
                "retail",
                "entertainment"
            ],
            "score": 25,
            "ownedBy": [
                "hasbro"
            ],
            "updatedAt": "2026-01-30T11:05:25.212Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Stretch_Armstrong",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d3/Stretch_armstrong_brand_logo.png/120px-Stretch_armstrong_brand_logo.png.png",
            "key": "stretch-armstrong"
        },
        "tonka": {
            "names": [
                "Tonka"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys",
                "retail",
                "entertainment"
            ],
            "score": 25,
            "ownedBy": [
                "hasbro"
            ],
            "updatedAt": "2026-01-30T11:05:25.212Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Tonka",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/80/Tonka_logo.svg",
            "key": "tonka"
        },
        "transformers": {
            "names": [
                "Transformers"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys",
                "retail",
                "entertainment"
            ],
            "score": 25,
            "ownedBy": [
                "hasbro"
            ],
            "updatedAt": "2026-01-30T11:05:25.212Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Transformers",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e3/Transformers_2014_logo.png/120px-Transformers_2014_logo.png.png",
            "key": "transformers"
        },
        "warner-bros.-discovery": {
            "names": [
                "Warner Bros. Discovery",
                "Warner Bros.",
                "Discovery",
                "Warner Bros. Discovery, Inc.",
                "WBD"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/64/Warner_Bros._Discovery.svg",
            "siteUrl": "https://www.wbd.com/",
            "updatedAt": "2026-02-01T19:01:19.364Z",
            "key": "warner-bros.-discovery"
        },
        "hbo-max": {
            "names": [
                "HBO Max"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/HBO_Max",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/b3/HBO_Max_%282025%29.svg",
            "siteUrl": "https://www.hbomax.com/",
            "key": "hbo-max"
        },
        "hbo": {
            "names": [
                "HBO"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/HBO",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/d/de/HBO_logo.svg",
            "siteUrl": "http://hbo.com/",
            "key": "hbo"
        },
        "warner-bros.": {
            "names": [
                "Warner Bros."
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Warner_Bros.",
            "key": "warner-bros."
        },
        "hgtv": {
            "names": [
                "HGTV"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/HGTV",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/a8/HGTV_2010.svg",
            "siteUrl": "https://www.hgtv.com/",
            "key": "hgtv"
        },
        "discovery-channel": {
            "names": [
                "Discovery Channel"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Discovery_Channel",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/27/Discovery_Channel_-_Logo_2019.svg/120px-Discovery_Channel_-_Logo_2019.svg.png",
            "siteUrl": "https://www.discovery.com/",
            "key": "discovery-channel"
        },
        "discovery+": {
            "names": [
                "Discovery+"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Discovery%2B",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/Discovery_Plus_logo.svg/120px-Discovery_Plus_logo.svg.png",
            "siteUrl": "https://www.discoveryplus.com/",
            "key": "discovery+"
        },
        "tbs": {
            "names": [
                "TBS"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/TBS_(American_TV_channel)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/TBS_2020.svg/120px-TBS_2020.svg.png",
            "siteUrl": "https://www.tbs.com/",
            "key": "tbs"
        },
        "food-network": {
            "names": [
                "Food Network"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Food_Network",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/Food_Network_logo.svg/120px-Food_Network_logo.svg.png",
            "siteUrl": "http://foodnetwork.com/",
            "key": "food-network"
        },
        "tnt": {
            "names": [
                "TNT"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/TNT_(American_TV_network)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/e/ec/TNT_%28TV_Channel%29.svg",
            "siteUrl": "https://www.tntdrama.com/",
            "key": "tnt"
        },
        "oprah-winfrey-network": {
            "names": [
                "Oprah Winfrey Network"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Oprah_Winfrey_Network",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/19/OWN_2011_logo.svg",
            "siteUrl": "http://www.oprah.com/app/own-tv.html",
            "key": "oprah-winfrey-network"
        },
        "investigation-discovery": {
            "names": [
                "Investigation Discovery"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Investigation_Discovery",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/35/InvestigationDiscoveryLogo2020.svg",
            "siteUrl": "http://investigationdiscovery.com/",
            "key": "investigation-discovery"
        },
        "tlc": {
            "names": [
                "TLC"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/TLC_(TV_network)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/74/TLC_Logo.svg",
            "siteUrl": "http://www.tlc.com/",
            "key": "tlc"
        },
        "warner-bros.-television-group": {
            "names": [
                "Warner Bros. Television Group"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Warner_Bros._Television_Group",
            "key": "warner-bros.-television-group"
        },
        "warner-bros.-pictures": {
            "names": [
                "Warner Bros. Pictures"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Warner_Bros._Pictures",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0c/Warner_Bros._Pictures_2023_%28Alt%29.svg/120px-Warner_Bros._Pictures_2023_%28Alt%29.svg.png",
            "siteUrl": "https://www.warnerbros.com/movies",
            "key": "warner-bros.-pictures"
        },
        "tnt-sports": {
            "names": [
                "TNT Sports"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/TNT_Sports",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/83/TNT_Sports_%282023%29.svg",
            "key": "tnt-sports"
        },
        "eurosport": {
            "names": [
                "Eurosport"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Eurosport",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/17/Eurosport_Logo_2015.svg",
            "siteUrl": "https://www.eurosport.com/",
            "key": "eurosport"
        },
        "magnolia-network": {
            "names": [
                "Magnolia Network"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Magnolia_Network",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/40/Magnolia_Network.svg",
            "siteUrl": "http://www.magnolia.com/network",
            "key": "magnolia-network"
        },
        "cooking-channel": {
            "names": [
                "Cooking Channel"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Cooking_Channel_(American_TV_channel)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/39/Cooking_Channel.svg",
            "siteUrl": "http://www.cookingchanneltv.com/",
            "key": "cooking-channel"
        },
        "warner-bros.-games": {
            "names": [
                "Warner Bros. Games"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Warner_Bros._Games",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3e/Warner_Bros._Games_logo_%28December_2023%29.svg/120px-Warner_Bros._Games_logo_%28December_2023%29.svg.png",
            "siteUrl": "https://warnerbrosgames.com/",
            "key": "warner-bros.-games"
        },
        "animal-planet": {
            "names": [
                "Animal Planet"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Animal_Planet",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/20/2018_Animal_Planet_logo.svg",
            "siteUrl": "https://www.animalplanet.com/",
            "key": "animal-planet"
        },
        "adult-swim": {
            "names": [
                "Adult Swim"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Adult_Swim",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/e/e4/Adult_Swim_2003_logo.svg",
            "siteUrl": "https://www.adultswim.com/",
            "key": "adult-swim"
        },
        "hln": {
            "names": [
                "HLN"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/HLN_(TV_network)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/64/HLN_2023.webp/120px-HLN_2023.webp.png",
            "siteUrl": "https://www.cnn.com/specials/videos/hln",
            "key": "hln"
        },
        "cartoon-network": {
            "names": [
                "Cartoon Network"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Cartoon_Network",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f7/Cartoon_Network_Games_%282016%29_logo.svg/120px-Cartoon_Network_Games_%282016%29_logo.svg.png",
            "siteUrl": "https://www.cartoonnetwork.com/",
            "key": "cartoon-network"
        },
        "new-line-cinema": {
            "names": [
                "New Line Cinema"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/New_Line_Cinema",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/0f/New_Line_Cinema_2024.svg",
            "siteUrl": "https://www.warnerbros.com/company/divisions/motion-pictures#new-line-cinema",
            "key": "new-line-cinema"
        },
        "golf-digest": {
            "names": [
                "Golf Digest"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Golf_Digest",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Golf_Digest_September_1960_cover.jpg/120px-Golf_Digest_September_1960_cover.jpg.png",
            "siteUrl": "http://www.golfdigest.com/",
            "key": "golf-digest"
        },
        "travel-channel": {
            "names": [
                "Travel Channel"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Travel_Channel",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/8a/2018_Travel_Channel_logo.svg",
            "siteUrl": "http://www.travelchannel.com/",
            "key": "travel-channel"
        },
        "hogar-de-hgtv": {
            "names": [
                "Hogar de HGTV"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Hogar_de_HGTV",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/a8/HGTV_2010.svg",
            "siteUrl": "https://www.hgtv.com/",
            "key": "hogar-de-hgtv"
        },
        "warner-bros.-pictures-animation": {
            "names": [
                "Warner Bros. Pictures Animation"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Warner_Bros._Pictures_Animation",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/Warner_Bros._Pictures_Animation_2024.svg/120px-Warner_Bros._Pictures_Animation_2024.svg.png",
            "siteUrl": "https://www.warnerbrospicturesanimation.com/",
            "key": "warner-bros.-pictures-animation"
        },
        "cartoonito": {
            "names": [
                "Cartoonito"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Cartoonito",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/a5/Cartoonito_-_Logo_2021.svg",
            "siteUrl": "https://www.cartoonito.co.uk/international-sites",
            "key": "cartoonito"
        },
        "quest": {
            "names": [
                "Quest"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Quest_(British_TV_channel)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/84/Quest_%282026%29.svg",
            "siteUrl": "https://www.discoveryplus.co.uk/channel/quest",
            "key": "quest"
        },
        "quest-red": {
            "names": [
                "Quest Red"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Quest_Red",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/a6/Quest_Red_2026.svg",
            "siteUrl": "https://www.discoveryplus.com/gb/channel/quest-red",
            "key": "quest-red"
        },
        "trutv": {
            "names": [
                "TruTV"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/TruTV",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/36/TruTV_2014.svg",
            "siteUrl": "https://www.trutv.com/",
            "key": "trutv"
        },
        "cinemax": {
            "names": [
                "Cinemax"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Cinemax",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/66/Cinemax_2016.svg",
            "siteUrl": "https://www.cinemax.com/",
            "key": "cinemax"
        },
        "tvn": {
            "names": [
                "TVN"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/TVN_(Polish_TV_channel)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/26/TVN_logo_2024.svg",
            "siteUrl": "https://tvn.pl/",
            "key": "tvn"
        },
        "science-channel": {
            "names": [
                "Science Channel"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Science_Channel",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/Science_Channel_2016.png/120px-Science_Channel_2016.png.png",
            "siteUrl": "https://www.sciencechannel.com/",
            "key": "science-channel"
        },
        "american-heroes-channel": {
            "names": [
                "American Heroes Channel"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/American_Heroes_Channel",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/75/American_Heroes_Channel_logo.svg/120px-American_Heroes_Channel_logo.svg.png",
            "siteUrl": "http://www.ahctv.com/",
            "key": "american-heroes-channel"
        },
        "asian-food-network": {
            "names": [
                "Asian Food Network"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Asian_Food_Network",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/Asian_Food_Network.svg/120px-Asian_Food_Network.svg.png",
            "siteUrl": "https://www.asianfoodnetwork.com/",
            "key": "asian-food-network"
        },
        "bleacher-report": {
            "names": [
                "Bleacher Report"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Bleacher_Report",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/c3/Bleacher_Report_logo.svg",
            "siteUrl": "https://www.bleacherreport.com/",
            "key": "bleacher-report"
        },
        "destination-america": {
            "names": [
                "Destination America"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Destination_America",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/57/Destination_America_logo.svg",
            "siteUrl": "http://www.destinationamerica.com/",
            "key": "destination-america"
        },
        "turner-classic-movies": {
            "names": [
                "Turner Classic Movies"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Turner_Classic_Movies",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/63/TCM_2021.svg",
            "siteUrl": "https://www.tcm.com/",
            "key": "turner-classic-movies"
        },
        "discovery-family": {
            "names": [
                "Discovery Family"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Discovery_Family",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c0/Discovery_Family_Logo_%282014%29.svg/120px-Discovery_Family_Logo_%282014%29.svg.png",
            "siteUrl": "https://www.discovery.com/discovery-family-channel",
            "key": "discovery-family"
        },
        "boomerang": {
            "names": [
                "Boomerang"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Boomerang_(TV_network)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/35/Boomerang_2014_logo.svg",
            "key": "boomerang"
        },
        "dmax": {
            "names": [
                "DMAX"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/DMAX_(TV_channel)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/98/DMAX_BLACK.svg",
            "siteUrl": "http://dmax.de/",
            "key": "dmax"
        },
        "real-time": {
            "names": [
                "Real Time"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Real_Time_(TV_channel)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/7a/Real_Time_logo.svg",
            "siteUrl": "http://www.realtimetv.it/",
            "key": "real-time"
        },
        "giallo": {
            "names": [
                "Giallo"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Giallo_(TV_channel)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/8e/Giallo_-_Logo_2014.svg",
            "key": "giallo"
        },
        "frisbee": {
            "names": [
                "Frisbee"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Frisbee_(TV_channel)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/FRISBEE_LOGO_2015.png/120px-FRISBEE_LOGO_2015.png.png",
            "siteUrl": "http://frisbeetv.it/",
            "key": "frisbee"
        },
        "k2": {
            "names": [
                "K2"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/K2_(TV_channel)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/b4/K2_new_logo.svg",
            "siteUrl": "https://wbditalia.com/k2",
            "key": "k2"
        },
        "nove": {
            "names": [
                "Nove"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Nove_(TV_channel)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/2d/Nove_-_Logo_2017.svg",
            "siteUrl": "http://nove.tv/",
            "key": "nove"
        },
        "canal-9": {
            "names": [
                "Canal 9"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Canal_9_(Danish_TV_channel)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/0f/Canal_9_Logo_2024.svg",
            "siteUrl": "http://www.discoveryplus.com/dk/channel/canal-9",
            "key": "canal-9"
        },
        "discovery-familia": {
            "names": [
                "Discovery Familia"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Discovery_Familia",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/64/Discovery_Familia_Logo_%282022%29.svg/120px-Discovery_Familia_Logo_%282022%29.svg.png",
            "siteUrl": "https://www.latamwbd.com/discovery-familia/es",
            "key": "discovery-familia"
        },
        "space": {
            "names": [
                "Space"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Space_(Latin_American_TV_channel)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/1a/SpaceLogo.svg",
            "key": "space"
        },
        "discovery-life": {
            "names": [
                "Discovery Life"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Discovery_Life",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/14/Discovery_Life_logo_2016.svg",
            "siteUrl": "http://discoverylife.com/",
            "key": "discovery-life"
        },
        "pogo": {
            "names": [
                "Pogo"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Pogo_(TV_channel)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/POGO-logo.png/120px-POGO-logo.png.png",
            "siteUrl": "https://www.pogo.tv/",
            "key": "pogo"
        },
        "tooncast": {
            "names": [
                "Tooncast"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Tooncast",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c8/Tooncast_logo_%282%29.svg/120px-Tooncast_logo_%282%29.svg.png",
            "key": "tooncast"
        },
        "cnn-en-espanol": {
            "names": [
                "CNN en Español"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/CNN_en_Espa%C3%B1ol",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/b6/Logo_de_CNN_en_Espa%C3%B1ol_%282010-2015%29.svg",
            "siteUrl": "https://cnnespanol.cnn.com/",
            "key": "cnn-en-espanol"
        },
        "warner-tv": {
            "names": [
                "Warner TV"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Warner_TV",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Warner2018LA.png/120px-Warner2018LA.png.png",
            "siteUrl": "https://www.warnerchannel.com/br/",
            "key": "warner-tv"
        },
        "boing": {
            "names": [
                "Boing"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Boing_(TV_channel)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8c/Logo_Boing.png/120px-Logo_Boing.png.png",
            "siteUrl": "https://www.boingtv.it/",
            "key": "boing"
        },
        "cnn-app": {
            "names": [
                "CNN app"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/CNNgo",
            "key": "cnn-app"
        },
        "warner-bros.-entertainment": {
            "names": [
                "Warner Bros. Entertainment"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Warner_Bros._Entertainment",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/4e/Warner_Bros._logo_2023.svg",
            "siteUrl": "http://www.warnerbros.com/",
            "key": "warner-bros.-entertainment"
        },
        "cnn": {
            "names": [
                "CNN",
                "Cable News Network"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/CNN",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/9d/CNN_Logo_%282014%29.svg",
            "siteUrl": "https://www.cnn.com/",
            "key": "cnn"
        },
        "dc-comics": {
            "names": [
                "DC Comics",
                "DC"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 50,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-02-01T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/DC_Comics",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/71/DC_Comics_2024.svg",
            "key": "dc-comics"
        },
        "hermes": {
            "names": [
                "Hermes",
                "Evri"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "logistics"
            ],
            "score": 23,
            "ownedBy": [
                "otto"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/d/d4/Logo_Hermes_Europe.jpg/250px-Logo_Hermes_Europe.jpg",
            "siteUrl": "http://hermesworld.com/",
            "updatedAt": "2026-02-03T15:09:53.259Z",
            "key": "hermes"
        },
        "witt-gruppe": {
            "names": [
                "Witt-Gruppe"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 23,
            "ownedBy": [
                "otto"
            ],
            "updatedAt": "2026-02-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Witt_Weiden",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/77/Logo_Witt-Gruppe.png/120px-Logo_Witt-Gruppe.png.png",
            "siteUrl": "https://www.witt-gruppe.eu/",
            "key": "witt-gruppe"
        },
        "bonprix": {
            "names": [
                "Bonprix"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 23,
            "ownedBy": [
                "otto"
            ],
            "updatedAt": "2026-02-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Bonprix",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/08/Bonprix_Logo_2023.svg",
            "siteUrl": "https://en.bonprix.de/corporate/",
            "key": "bonprix"
        },
        "crate-and-barrel": {
            "names": [
                "Crate and Barrel",
                "Euromarket Designs",
                "Euromarket Designs Inc."
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 23,
            "ownedBy": [
                "otto"
            ],
            "updatedAt": "2026-02-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Crate_%26_Barrel",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/51/CrateandBarrelLogo.svg",
            "siteUrl": "http://crateandbarrel.com/",
            "key": "crate-and-barrel"
        },
        "sheego-ag": {
            "names": [
                "Sheego AG"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 23,
            "ownedBy": [
                "otto"
            ],
            "updatedAt": "2026-02-03T06:28:22.531Z",
            "wikipediaUrl": "https://de.wikipedia.org/wiki/Sheego",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/f/f6/Sheego_Logo.svg",
            "siteUrl": "https://company.sheego.de/",
            "key": "sheego-ag"
        },
        "frankonia": {
            "names": [
                "Frankonia"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 23,
            "ownedBy": [
                "otto"
            ],
            "updatedAt": "2026-02-03T06:28:22.531Z",
            "wikipediaUrl": "https://de.wikipedia.org/wiki/Frankonia",
            "siteUrl": "https://www.frankonia.de/",
            "key": "frankonia"
        },
        "lascana": {
            "names": [
                "Lascana"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 23,
            "ownedBy": [
                "otto"
            ],
            "updatedAt": "2026-02-03T06:28:22.531Z",
            "wikipediaUrl": "https://de.wikipedia.org/wiki/Lascana",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/Lascana-logo-2018.png/120px-Lascana-logo-2018.png.png",
            "siteUrl": "https://www.lascana.de/",
            "key": "lascana"
        },
        "limango": {
            "names": [
                "Limango"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 23,
            "ownedBy": [
                "otto"
            ],
            "updatedAt": "2026-02-03T06:28:22.531Z",
            "wikipediaUrl": "https://nl.wikipedia.org/wiki/Limango",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/79/Limango.png/120px-Limango.png.png",
            "siteUrl": "https://www.limango.nl/",
            "key": "limango"
        },
        "manufactum": {
            "names": [
                "Manufactum"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 23,
            "ownedBy": [
                "otto"
            ],
            "updatedAt": "2026-02-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Manufactum",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/Manufactum_Logo.jpg/120px-Manufactum_Logo.jpg.png",
            "siteUrl": "http://www.manufactum.com/",
            "key": "manufactum"
        },
        "eos-group": {
            "names": [
                "EOS Group"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 23,
            "ownedBy": [
                "otto"
            ],
            "updatedAt": "2026-02-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/EOS_Group",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/21/EOS_Gruppe_Logo.svg",
            "siteUrl": "http://www.eos-solutions.com/",
            "key": "eos-group"
        },
        "hanseatic-bank": {
            "names": [
                "Hanseatic Bank"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 23,
            "ownedBy": [
                "otto"
            ],
            "updatedAt": "2026-02-03T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Hanseatic_Bank",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/f/f2/Hanseatic_Bank_Logo_2019.svg",
            "siteUrl": "https://www.hanseaticbank.de/",
            "key": "hanseatic-bank"
        },
        "otto": {
            "names": [
                "Otto",
                "Otto Group",
                "The Otto Group",
                "Otto GmbH & Co. KGaA"
            ],
            "comment": "Otto is a German e-commerce company that has mishandled parcels [1], mishandled customer data [2], and violated employee data privacy [3]. It pays employees below minimum wage and underpays them [4][5][6], and its supply chain has experienced labour rights abuses [7][8].",
            "sources": {
                "1": "https://www.thetimes.com/uk/article/hermes-our-undercover-reporter-sees-couriers-manhandle-parcels-and-customers-mocked-wdbnqvzvw",
                "2": "https://www.bigclassaction.com/settlement/3m-settlement-proposed-in-crate-7-barrel-song.php",
                "3": "https://www.law360.com/articles/1856381/-2-4-million-crate-barrel-bipa-deal-gets-final-ok",
                "4": "https://www.theguardian.com/society/2016/jul/18/hermes-couriers-paying-staff-less-than-living-wage",
                "5": "https://www.dorset.live/news/dorset-news/evri-delivery-drivers-quit-after-8224600",
                "6": "https://www.mirror.co.uk/money/evri-accused-employing-people-slave-34483225",
                "7": "https://myanmarlabournews.com/posts/chu-yang-myanmar-%E1%80%85%E1%80%80%E1%80%BA%E1%80%9B%E1%80%AF%E1%80%B6-%E1%80%9C%E1%80%AF%E1%80%95%E1%80%BA%E1%80%84%E1%80%94%E1%80%BA%E1%80%B8%E1%80%9B%E1%80%BE%E1%80%84%E1%80%BA%E1%80%A1%E1%80%AC%E1%80%B8-%E1%80%90%E1%80%9B%E1%80%AC%E1%80%B8%E1%80%85%E1%80%BD%E1%80%B2%E1%80%86%E1%80%AD%E1%80%AF%E1%80%91%E1%80%AC%E1%80%B8%E1%80%99%E1%80%BE%E1%80%AF%E1%80%85%E1%80%90%E1%80%84%E1%80%BA%E1%80%85%E1%80%85%E1%80%BA%E1%80%86%E1%80%B1%E1%80%B8",
                "8": "https://www.business-humanrights.org/en/latest-news/myanmar-workers-at-chu-yang-factory-file-13-cases-against-factory-owner-re-labour-rights-abuses/"
            },
            "sourceNotes": {
                "1": "mishandling of parcels",
                "2": "mishandling of customer data",
                "3": "mishandling and privacy violation of employee data",
                "4": "pays employees below minimum wage",
                "5": "underpaid employees",
                "6": "underpaid employees",
                "7": "labour rights abuses in supply chain",
                "8": "labour rights abuses in supply chain"
            },
            "tags": [
                "retail",
                "logistics",
                "privacy violations",
                "unfair pay",
                "forced labour"
            ],
            "score": 23,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/11/Otto_Group_Logo_2022.svg",
            "siteUrl": "https://www.ottogroup.com/en",
            "updatedAt": "2026-02-03T15:09:53.259Z",
            "key": "otto"
        },
        "almond-joy": {
            "names": [
                "Almond Joy"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Almond_Joy",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/01/Almondjoy_brand_logo.png/120px-Almondjoy_brand_logo.png.png",
            "siteUrl": "https://www.hersheyland.com/almond-joy",
            "key": "almond-joy"
        },
        "5th-avenue": {
            "names": [
                "5th Avenue"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/5th_Avenue_(candy)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/db/5th_avenue_brand_logo.png/120px-5th_avenue_brand_logo.png.png",
            "siteUrl": "https://www.hersheyland.com/5th-avenue",
            "key": "5th-avenue"
        },
        "eat-more": {
            "names": [
                "Eat-More"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Eat-More",
            "key": "eat-more"
        },
        "payday": {
            "names": [
                "PayDay"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/PayDay_(confection)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8a/Payday_brand_logo.png/120px-Payday_brand_logo.png.png",
            "siteUrl": "https://www.hersheyland.com/payday",
            "key": "payday"
        },
        "heath-bar": {
            "names": [
                "Heath bar"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Heath_bar",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Heath_bar_brandlogo.png/120px-Heath_bar_brandlogo.png.png",
            "siteUrl": "https://www.hersheyland.com/products/heath-milk-chocolate-english-toffee-candy-bar-1-4-oz.html",
            "key": "heath-bar"
        },
        "hershey's-extra-dark": {
            "names": [
                "Hershey's Extra Dark"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Hershey%27s_Extra_Dark",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/Hershey%27s_Special_Dark_Miniatures.jpg/120px-Hershey%27s_Special_Dark_Miniatures.jpg.png",
            "siteUrl": "https://www.hersheyland.com/products/hersheys-special-dark-mildly-sweet-chocolate-candy-bars-8-7-oz-6-pack.html",
            "key": "hershey's-extra-dark"
        },
        "hershey's-kisses": {
            "names": [
                "Hershey's Kisses"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Hershey%27s_Kisses",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5d/Hershey_kisses_logo.png/120px-Hershey_kisses_logo.png.png",
            "siteUrl": "https://www.hersheyland.com/kisses",
            "key": "hershey's-kisses"
        },
        "oh-henry!": {
            "names": [
                "Oh Henry!"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Oh_Henry!",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/9/91/Oh-Henry-Wrapper-Small.jpg",
            "key": "oh-henry!"
        },
        "krackel": {
            "names": [
                "Krackel"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Krackel",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/57/Krackel-Fun-Size.jpg/120px-Krackel-Fun-Size.jpg.png",
            "siteUrl": "https://www.hersheyland.com/products/hersheys-miniatures-assortment-10-4-oz-pack.html",
            "key": "krackel"
        },
        "military-chocolate": {
            "names": [
                "Military chocolate"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Military_chocolate_(United_States)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/D_ration_chocolate_bar.jpg/120px-D_ration_chocolate_bar.jpg.png",
            "key": "military-chocolate"
        },
        "mounds": {
            "names": [
                "Mounds"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Mounds_(candy_bar)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Mounds_brand_logo.png/120px-Mounds_brand_logo.png.png",
            "siteUrl": "https://www.hersheyland.com/mounds",
            "key": "mounds"
        },
        "mr.-goodbar": {
            "names": [
                "Mr. Goodbar"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Mr._Goodbar",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5b/Mrgoodbar_brand_logo.png/120px-Mrgoodbar_brand_logo.png.png",
            "siteUrl": "https://www.hersheyland.com/mrgoodbar",
            "key": "mr.-goodbar"
        },
        "nutrageous": {
            "names": [
                "NutRageous"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/NutRageous",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f1/NutRageous-Split.jpg/250px-NutRageous-Split.jpg",
            "siteUrl": "https://www.hersheyland.com/products/reeses-nutrageous-milk-chocolate-peanut-butter-candy-bar-1-66-oz.html",
            "key": "nutrageous"
        },
        "reese's-pieces": {
            "names": [
                "Reese's Pieces"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Reese%27s_Pieces",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/e/e1/Reese%27s_Pieces_Bag.png",
            "siteUrl": "https://www.hersheyland.com/products/reeses-pieces-peanut-butter-candy-9-9-oz-bag.html",
            "key": "reese's-pieces"
        },
        "skor": {
            "names": [
                "Skor"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Skor",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/d4/Skor_brand_logo.png",
            "siteUrl": "https://www.hersheyland.com/products/skor-milk-chocolate-with-crisp-butter-toffee-candy-bar-1-4-oz.html",
            "key": "skor"
        },
        "snack-barz": {
            "names": [
                "Snack Barz"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Snack_Barz",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Snackbarz_logo.png/120px-Snackbarz_logo.png.png",
            "key": "snack-barz"
        },
        "symphony": {
            "names": [
                "Symphony"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Symphony_(candy)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/19/Symphony_hershey_brand_logo.png/120px-Symphony_hershey_brand_logo.png.png",
            "siteUrl": "https://www.hersheyland.com/products/symphony-milk-chocolate-xl-candy-bar-4-25-oz.html",
            "key": "symphony"
        },
        "whatchamacallit": {
            "names": [
                "Whatchamacallit"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Whatchamacallit_(candy)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Whatchamacallit_brand_logo.png/120px-Whatchamacallit_brand_logo.png.png",
            "siteUrl": "https://www.hersheyland.com/whatchamacallit",
            "key": "whatchamacallit"
        },
        "whozeewhatzit": {
            "names": [
                "Whozeewhatzit"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Whatchamacallit_(candy)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Whatchamacallit_brand_logo.png/120px-Whatchamacallit_brand_logo.png.png",
            "siteUrl": "https://www.hersheyland.com/whatchamacallit",
            "key": "whozeewhatzit"
        },
        "zero-bar": {
            "names": [
                "Zero bar"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Zero_bar",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/55/Zero_candybrand_logo.png/120px-Zero_candybrand_logo.png.png",
            "siteUrl": "https://www.hersheyland.com/zero",
            "key": "zero-bar"
        },
        "zagnut": {
            "names": [
                "Zagnut"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Zagnut",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/c/c9/Zagnut-Wrapper-Small.jpg",
            "siteUrl": "https://www.hersheyland.com/products/zagnut-peanut-butter-and-coconut-candy-bar-1-75-oz.html",
            "key": "zagnut"
        },
        "cherry-blossom": {
            "names": [
                "Cherry Blossom"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Cherry_Blossom_(candy)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/54/Cherryblossom_candy_logo.png/120px-Cherryblossom_candy_logo.png.png",
            "key": "cherry-blossom"
        },
        "hershey's-kissables": {
            "names": [
                "Hershey's Kissables"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Hershey%27s_Kissables",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/Miniture_Hershey_Kisses_%282830832406%29.jpg/120px-Miniture_Hershey_Kisses_%282830832406%29.jpg.png",
            "key": "hershey's-kissables"
        },
        "milk-duds": {
            "names": [
                "Milk Duds"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Milk_Duds",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Milk_duds_logo.png/120px-Milk_duds_logo.png.png",
            "siteUrl": "https://www.hersheyland.com/milk-duds",
            "key": "milk-duds"
        },
        "swoops": {
            "names": [
                "Swoops"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Swoops",
            "key": "swoops"
        },
        "york-peppermint-pattie": {
            "names": [
                "York Peppermint Pattie"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/York_Peppermint_Pattie",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/York_peppermint_logo.png/120px-York_peppermint_logo.png.png",
            "siteUrl": "https://www.hersheyland.com/york",
            "key": "york-peppermint-pattie"
        },
        "whoppers": {
            "names": [
                "Whoppers"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Whoppers",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e7/Whoppers_brand_logo.png/120px-Whoppers_brand_logo.png.png",
            "siteUrl": "https://hersheyland.com/whoppers",
            "key": "whoppers"
        },
        "breath-savers": {
            "names": [
                "Breath Savers"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Breath_Savers",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/Breathsavers-Peppermint.jpg/250px-Breathsavers-Peppermint.jpg",
            "siteUrl": "https://www.hersheyland.com/breath-savers",
            "key": "breath-savers"
        },
        "bubble-yum": {
            "names": [
                "Bubble Yum"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Bubble_Yum",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/4/43/Bubble_yum_logo.png",
            "siteUrl": "https://www.hersheyland.com/bubbleyum",
            "key": "bubble-yum"
        },
        "clodhopper": {
            "names": [
                "Clodhopper"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Clodhopper_(candy)",
            "key": "clodhopper"
        },
        "good-and-fruity": {
            "names": [
                "Good & Fruity"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Good_%26_Fruity",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Goodandfruity_logo.png/120px-Goodandfruity_logo.png.png",
            "key": "good-and-fruity"
        },
        "good-and-plenty": {
            "names": [
                "Good & Plenty"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Good_%26_Plenty",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/Goodplenty_brand_logo.png/120px-Goodplenty_brand_logo.png.png",
            "siteUrl": "https://www.hersheyland.com/good-and-plenty",
            "key": "good-and-plenty"
        },
        "ice-breakers-candy": {
            "names": [
                "Ice Breakers candy"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Ice_Breakers_candy",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/aa/Icebreakers_brand_logo.png/120px-Icebreakers_brand_logo.png.png",
            "siteUrl": "https://www.hersheyland.com/ice-breakers",
            "key": "ice-breakers-candy"
        },
        "jolly-rancher": {
            "names": [
                "Jolly Rancher"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Jolly_Rancher",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ae/Jolly_rancher_logo.png/120px-Jolly_rancher_logo.png.png",
            "siteUrl": "https://www.hersheyland.com/jolly-rancher",
            "key": "jolly-rancher"
        },
        "pelon-pelo-rico": {
            "names": [
                "Pelon Pelo Rico"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Pelon_Pelo_Rico",
            "siteUrl": "https://www.thehersheycompany.com/es_mx/pelon.html",
            "key": "pelon-pelo-rico"
        },
        "twizzlers": {
            "names": [
                "Twizzlers"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Twizzlers",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f9/Twizzlers_brand_logo.png/120px-Twizzlers_brand_logo.png.png",
            "siteUrl": "https://www.hersheyland.com/twizzlers",
            "key": "twizzlers"
        },
        "dot's-pretzels": {
            "names": [
                "Dot's Pretzels"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Dot%27s_Pretzels",
            "key": "dot's-pretzels"
        },
        "pirate's-booty": {
            "names": [
                "Pirate's Booty"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Pirate%27s_Booty",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/ba/Robert%27s_American_Gourmet_Pirate%27s_Booty.JPG/250px-Robert%27s_American_Gourmet_Pirate%27s_Booty.JPG",
            "siteUrl": "https://www.hersheyland.com/pirates-booty",
            "key": "pirate's-booty"
        },
        "skinnypop": {
            "names": [
                "SkinnyPop"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/SkinnyPop",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/3/30/Skinny-pop-logo%402x.png",
            "siteUrl": "https://www.skinnypop.com/",
            "key": "skinnypop"
        },
        "c4": {
            "names": [
                "C4"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/C4",
            "key": "c4"
        },
        "reese's-puffs": {
            "names": [
                "Reese's Puffs"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 26,
            "ownedBy": [
                "general-mills"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Reese%27s_Puffs",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/Reese%27s_Puffs_%E2%80%93_Sweet_and_crunchy_corn_puffs%2C_with_milk.jpg/120px-Reese%27s_Puffs_%E2%80%93_Sweet_and_crunchy_corn_puffs%2C_with_milk.jpg.png",
            "key": "reese's-puffs"
        },
        "cocoa-puffs": {
            "names": [
                "Cocoa Puffs"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "nestle",
                "general-mills"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Cocoa_Puffs",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/c/cf/CocoaPuffs.jpg",
            "key": "cocoa-puffs"
        },
        "selecta": {
            "names": [
                "Selecta"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Selecta_(dairy_products)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/f/fa/Selecta_philippines_logo.jpg",
            "siteUrl": "https://www.selectaphilippines.com/",
            "key": "selecta"
        },
        "breyers": {
            "names": [
                "Breyers"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 12,
            "ownedBy": [
                "hershey's"
            ],
            "updatedAt": "2026-02-04T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Breyers",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/e/ec/Breyers_logo_%282025%29.webp",
            "siteUrl": "http://breyers.com/",
            "key": "breyers"
        },
        "hershey's": {
            "names": [
                "Hershey's",
                "Hersheys",
                "Hershey",
                "The Hershey Company",
                "Hershey Chocolate Co.",
                "Hershey Chocolate Corporation",
                "Hershey Foods Corporation",
                "HSY"
            ],
            "comment": "Hersheys is an American chocolate manufacturer that has been implicated in fraud and malpractice in its trust foundation [1][2], sold chocolate with harmful heavy metal levels [3][4], and used hazardous PFAS in packaging [5]. The company has also been accused of child slavery, forced labor, deforestation, worker abuse in its supply chain, and manipulating cocoa prices to underpay farmers [6][7][8][9][10].",
            "sources": {
                "1": "https://capitalresearch.org/article/miltons-bittersweet-legacy-part-1/",
                "2": "https://archive.triblive.com/news/wire-stories/fate-of-hershey-merger-lies-with-scandal-plagued-trust/",
                "3": "https://www.cbsnews.com/news/hersheys-dark-chocolate-heavy-metals-lead-cadmium/",
                "4": "https://www.bbc.co.uk/news/business-64123157",
                "5": "https://www.bakeryandsnacks.com/Article/2025/07/01/hersheys-pfas-lawsuits-spotlight-snack-brand-risks/",
                "6": "https://eu.usatoday.com/story/money/legal/2025/07/22/hershey-nestle-mars-child-slavery/85331901007/",
                "7": "https://www.classaction.org/news/hersheys-organic-chocolate-not-as-sustainable-ethically-sourced-as-advertised-class-action-alleges",
                "8": "https://www.business-humanrights.org/en/latest-news/usa-chocolate-manufacturer-hershey-to-face-consumers-lawsuit-alleging-failure-to-disclose-human-rights-abuses-in-their-supply-chain/",
                "9": "https://www.sierraclub.org/sierra/rainforest-alliance-and-hershey-chocolate-sued-falsely-claiming-fair-labor-and-sustainability",
                "10": "https://www.nbcnews.com/business/business-news/war-cocoa-hershey-co-accused-not-upholding-sustainability-efforts-west-n1250798"
            },
            "sourceNotes": {
                "1": "fraud and malpractice in the hershey trust foundation",
                "2": "fraud and malpractice in the hershey trust foundation",
                "3": "sold chocolate containing harmful levels of heavy metal",
                "4": "sold chocolate containing harmful levels of heavy metal",
                "5": "used harmful PFAS in packaging",
                "6": "child slave labour in supply chain",
                "7": "abuse of workers in supply chain",
                "8": "abuse of workers in supply chain",
                "9": "child labor, forced labor, and deforestation",
                "10": "manipulated cocoa prices to underpay impoverished cocoa farmers"
            },
            "tags": [
                "food",
                "confectionery",
                "child labour",
                "forced labour",
                "deforestation",
                "unsustainable practices",
                "poor working conditions",
                "unfair pay",
                "corruption",
                "deception",
                "unsafe practices",
                "environmental violations"
            ],
            "score": 12,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/81/HersheyCo.svg/120px-HersheyCo.svg.png",
            "siteUrl": "https://www.thehersheycompany.com/en_us/home.html",
            "updatedAt": "2026-02-04T16:42:19.893Z",
            "key": "hershey's"
        },
        "hilton": {
            "names": [
                "Hilton",
                "Hilton Hotels & Resorts",
                "Hilton Hotels",
                "Hilton Worldwide",
                "Hilton Worldwide Holdings",
                "Hilton Worldwide Holdings Inc.",
                "Hilton Hotels Corporation",
                "HLT"
            ],
            "comment": "Hilton is a U.S. hotel chain that has engaged in price fixing [1], greenwashing [2], and imposing hidden fees on guests [3]. The company has also hosted a right‑wing extremist event  [4], housed ICE agents [5][6], discriminated against black guests [7][8], negligently facilitated a guest's sexual assault [9], and facilitated sex trafficking [10].",
            "sources": {
                "1": "https://www.classaction.org/news/class-action-lawsuit-claims-hilton-wyndham-hyatt-others-illegally-conspired-to-fix-hotel-room-prices",
                "2": "https://www.cabidigitallibrary.org/do/10.5555/collection-news-15943#:~:text=War%20of%20words%20on%20Hilton%20%E2%80%98greenwash%E2%80%99%20claims,spotlight%20on%20tourism%20ethics%20%7C%20CABI%20News.",
                "3": "https://topclassactions.com/lawsuit-settlements/lawsuit-news/hilton-faces-lawsuit-over-alleged-hidden-hotel-fees/",
                "4": "https://wislawjournal.com/2024/04/04/hilton-hotels-under-fire-for-hosting-allegedly-racist-anti-lqbtqright-wing-extremist-event/",
                "5": "https://www.cnbc.com/2026/01/06/hilton-hotels-dhs-minneapolis-immigration-ban.html",
                "6": "https://www.kare11.com/article/news/local/ice-in-minnesota/hundreds-protesting-downtown-minneapolis-hotel-friday/89-f3c46c0a-0699-491e-85d6-de23a573a3d2",
                "7": "https://www.theroot.com/several-lawsuits-accuse-hilton-of-routinely-discriminating-against-its-black-hotel-guests",
                "8": "https://eu.usatoday.com/story/travel/hotels/2020/07/21/hilton-discrimination-lawsuits-black-guests-allege-racism-hotels/5405270002/",
                "9": "https://www.prnewswire.com/news-releases/hilton-hotels-hit-with-record-44m-negligence-verdict-for-facilitating-a-sexual-assault-of-a-hotel-guest-301431024.html",
                "10": "https://news.bloomberglaw.com/litigation/hilton-must-continue-facing-lawsuit-from-sex-trafficking-victim"
            },
            "sourceNotes": {
                "1": "price fixing",
                "2": "greenwashing",
                "3": "imposed hidden fees on guests",
                "4": "hosted right-wing extremist event",
                "5": "Housed ICE agents",
                "6": "Housed ICE agents",
                "7": "discriminated against black guests",
                "8": "discriminated against black guests",
                "9": "negligently facilitated the sexual assult of a guest",
                "10": "facilitated sex trafficking"
            },
            "tags": [
                "hospitality",
                "anticompetitive practices",
                "greenwashing",
                "deception",
                "racial discrimination",
                "sexual harassment",
                "unsafe practices"
            ],
            "score": 14,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/39/HiltonHotelsLogo.svg",
            "siteUrl": "https://www.hilton.com/en/brands/hilton-hotels/",
            "updatedAt": "2026-02-05T17:38:28.207Z",
            "key": "hilton"
        },
        "waldorf-astoria-hotels-and-resorts": {
            "names": [
                "Waldorf Astoria Hotels & Resorts"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "hospitality"
            ],
            "score": 14,
            "ownedBy": [
                "hilton"
            ],
            "updatedAt": "2026-02-05T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Waldorf_Astoria_Hotels_%26_Resorts",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/8e/WaldorfLogo.svg",
            "siteUrl": "https://www.hilton.com/en/brands/waldorf-astoria/",
            "key": "waldorf-astoria-hotels-and-resorts"
        },
        "conrad-hotels": {
            "names": [
                "Conrad Hotels"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "hospitality"
            ],
            "score": 14,
            "ownedBy": [
                "hilton"
            ],
            "updatedAt": "2026-02-05T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Conrad_Hotels",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/12/ConradHotelsLogo.svg",
            "siteUrl": "http://conradhotels.com/",
            "key": "conrad-hotels"
        },
        "signia-by-hilton": {
            "names": [
                "Signia by Hilton"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "hospitality"
            ],
            "score": 14,
            "ownedBy": [
                "hilton"
            ],
            "updatedAt": "2026-02-05T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Signia_by_Hilton_San_Jose",
            "siteUrl": "http://www.hilton.com/en/hotels/sjcsmsa-signia-san-jose/",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0b/Sanjose_plaze_de_cesar_chavez.jpg/120px-Sanjose_plaze_de_cesar_chavez.jpg.png",
            "key": "signia-by-hilton"
        },
        "the-nomad": {
            "names": [
                "The NoMad"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "hospitality"
            ],
            "score": 14,
            "ownedBy": [
                "hilton"
            ],
            "updatedAt": "2026-02-05T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/The_NoMad",
            "siteUrl": "https://www.thenomadhotel.com/",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/NoMad_Hotel_1170_Broadway.jpg/120px-NoMad_Hotel_1170_Broadway.jpg.png",
            "key": "the-nomad"
        },
        "canopy-by-hilton": {
            "names": [
                "Canopy by Hilton"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "hospitality"
            ],
            "score": 14,
            "ownedBy": [
                "hilton"
            ],
            "updatedAt": "2026-02-05T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Canopy_by_Hilton",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/37/Canopy_by_Hilton_logo.svg",
            "siteUrl": "http://canopybyhilton.com/",
            "key": "canopy-by-hilton"
        },
        "graduate-hotels": {
            "names": [
                "Graduate Hotels"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "hospitality"
            ],
            "score": 14,
            "ownedBy": [
                "hilton"
            ],
            "updatedAt": "2026-02-05T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Graduate_Hotels",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/b/b7/Graduate_Hotels_logo.svg",
            "siteUrl": "http://graduatehotels.com/",
            "key": "graduate-hotels"
        },
        "hilton-hotels-and-resorts": {
            "names": [
                "Hilton Hotels & Resorts"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "hospitality"
            ],
            "score": 14,
            "ownedBy": [
                "hilton"
            ],
            "updatedAt": "2026-02-05T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Hilton_Hotels_%26_Resorts",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/39/HiltonHotelsLogo.svg",
            "siteUrl": "https://www.hilton.com/en/brands/hilton-hotels/",
            "key": "hilton-hotels-and-resorts"
        },
        "doubletree": {
            "names": [
                "DoubleTree"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "hospitality"
            ],
            "score": 14,
            "ownedBy": [
                "hilton"
            ],
            "updatedAt": "2026-02-05T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/DoubleTree",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/0/0a/DoubletreeLogo.svg",
            "siteUrl": "http://www.doubletree.com/",
            "key": "doubletree"
        },
        "curio": {
            "names": [
                "Curio"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "hospitality"
            ],
            "score": 14,
            "ownedBy": [
                "hilton"
            ],
            "updatedAt": "2026-02-05T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Curio_(brand)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/57/Curio_by_Hilton_logo.svg",
            "siteUrl": "https://www.hilton.com/en/curio/",
            "key": "curio"
        },
        "embassy-suites-by-hilton": {
            "names": [
                "Embassy Suites by Hilton"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "hospitality"
            ],
            "score": 14,
            "ownedBy": [
                "hilton"
            ],
            "updatedAt": "2026-02-05T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Embassy_Suites_by_Hilton",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/6/67/Embassy_Suites_Hotels.svg",
            "siteUrl": "http://embassysuites.com/",
            "key": "embassy-suites-by-hilton"
        },
        "homewood-suites-by-hilton": {
            "names": [
                "Homewood Suites by Hilton"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "hospitality"
            ],
            "score": 14,
            "ownedBy": [
                "hilton"
            ],
            "updatedAt": "2026-02-05T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Homewood_Suites_by_Hilton",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/51/Homewood_Suites_Logo_%282021%29.svg",
            "siteUrl": "http://www.homewoodsuites.com/",
            "key": "homewood-suites-by-hilton"
        },
        "home2-suites-by-hilton": {
            "names": [
                "Home2 Suites by Hilton"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "hospitality"
            ],
            "score": 14,
            "ownedBy": [
                "hilton"
            ],
            "updatedAt": "2026-02-05T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Home2_Suites_by_Hilton",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/c2/Home2_Suites_by_Hilton_logo.svg",
            "siteUrl": "https://www.home2suites.com/",
            "key": "home2-suites-by-hilton"
        },
        "hilton-garden-inn": {
            "names": [
                "Hilton Garden Inn"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "hospitality"
            ],
            "score": 14,
            "ownedBy": [
                "hilton"
            ],
            "updatedAt": "2026-02-05T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Hilton_Garden_Inn",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/HGI-Logo-Color_HR.png/120px-HGI-Logo-Color_HR.png.png",
            "siteUrl": "https://www.hilton.com/en/hilton-garden-inn",
            "key": "hilton-garden-inn"
        },
        "hampton-by-hilton": {
            "names": [
                "Hampton by Hilton"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "hospitality"
            ],
            "score": 14,
            "ownedBy": [
                "hilton"
            ],
            "updatedAt": "2026-02-05T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Hampton_by_Hilton",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/28/Hampton-by-Hilton-Logo-Color.png/120px-Hampton-by-Hilton-Logo-Color.png.png",
            "siteUrl": "http://www.hampton.com/",
            "key": "hampton-by-hilton"
        },
        "tru-by-hilton": {
            "names": [
                "Tru by Hilton"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "hospitality"
            ],
            "score": 14,
            "ownedBy": [
                "hilton"
            ],
            "updatedAt": "2026-02-05T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Tru_by_Hilton",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/e/e2/Tru_by_Hilton_logo.svg",
            "siteUrl": "http://www.trubyhilton.com/",
            "key": "tru-by-hilton"
        },
        "spark-by-hilton": {
            "names": [
                "Spark by Hilton"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "hospitality"
            ],
            "score": 14,
            "ownedBy": [
                "hilton"
            ],
            "updatedAt": "2026-02-05T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Spark_by_Hilton",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/20/Spark-by-Hilton-Logo-Color.png/120px-Spark-by-Hilton-Logo-Color.png.png",
            "siteUrl": "http://sparkbyhilton.com/",
            "key": "spark-by-hilton"
        },
        "hilton-grand-vacations": {
            "names": [
                "Hilton Grand Vacations"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "hospitality"
            ],
            "score": 14,
            "ownedBy": [
                "hilton"
            ],
            "updatedAt": "2026-02-05T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Hilton_Grand_Vacations",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/Hilton_Grand_Vacations_logo.png/120px-Hilton_Grand_Vacations_logo.png.png",
            "siteUrl": "http://hgv.com/",
            "key": "hilton-grand-vacations"
        },
        "hobbycraft": {
            "names": [
                "Hobbycraft",
                "Hobbycraft Trading Limited"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": null,
            "ownedBy": [
                "mondella-capital"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/b/b4/Hobbycraft_logo_2011.svg",
            "siteUrl": "http://hobbycraft.co.uk/",
            "updatedAt": "2026-02-06T10:22:36.519Z",
            "key": "hobbycraft"
        },
        "holland-and-barrett": {
            "names": [
                "Holland & Barrett",
                "Holland & Barrett International",
                "Holland & Barrett International Limited",
                "NBTY Europe Limited"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "health",
                "food"
            ],
            "score": null,
            "ownedBy": [
                "letterone"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/5/52/Holland_%26_Barrett_logo.svg",
            "siteUrl": "https://hollandandbarrett.com/",
            "updatedAt": "2026-02-07T22:00:22.209Z",
            "key": "holland-and-barrett"
        },
        "home-depot": {
            "names": [
                "Home Depot",
                "The Home Depot",
                "The Home Depot, Inc.",
                "HD"
            ],
            "comment": "Home Depot is an American retailer that has overcharged customers [1][2], nonconsensually shared data with Facebook [3], removed DEI policies [4][5], discriminated against anti‑racist protesters [6][7], fired an employee with cancer rather than providing reasonable accommodation [8], illegally released environmental waste [9], has a Zionist founder [10], was complicit in ICE migrant detentions at its stores [11][12], and ignored safety recommendations after employees died in a store collapse [13].",
            "sources": {
                "1": "https://www.msn.com/en-us/technology/hardware-and-devices/millions-lost-in-home-depot-s-2m-overcharge-scheme-the-scanner-trap-uncovered/ar-AA1Sh8OV",
                "2": "https://www.entrepreneur.com/business-news/home-depot-settles-scanner-violation-claims-for-2-million/479929",
                "3": "https://www.cbc.ca/news/politics/home-depot-privacy-commissioner-meta-1.6726668",
                "4": "https://www.independent.co.uk/news/world/americas/home-depot-customer-boycott-dei-policy-b2750723.html",
                "5": "https://www.msn.com/en-us/money/companies/home-depot-under-fire-as-boycott-grows-over-diversity-concerns/ar-AA1HQSMK",
                "6": "https://www.bbc.com/news/business-58251211",
                "7": "https://www.cnn.com/2024/02/21/business/home-depot-broke-labor-law-by-firing-an-employee-with-blm-on-apron-nlrb-rules",
                "8": "http://www.natlawreview.com/article/home-depot-to-pay-100000-to-settle-eeoc-disability-discrimination-suit",
                "9": "https://www.oag.ca.gov/news/press-releases/attorney-general-becerra-home-depot-agrees-2784-million-settlement-violations",
                "10": "https://brusselsmorning.com/does-home-depot-back-israel-role-of-co-founder-bernie-marcus/77666/",
                "11": "https://www.npr.org/2025/08/19/nx-s1-5504124/home-depot-earnings-immigration-raids-day-laborers",
                "12": "https://newjerseymonitor.com/briefs/anti-ice-protestors-target-home-depot-to-denounce-immigration-arrests/",
                "13": "https://web.archive.org/web/20110627135242/http://www.kansascity.com/2011/06/25/2975177/experts-challenge-building-design.html#ixzz1QZoEgC5d"
            },
            "sourceNotes": {
                "1": "overcharged customers",
                "2": "overcharged customers",
                "3": "nonconsentually shared data with facebook",
                "4": "removed DEI policies",
                "5": "removed DEI policies",
                "6": "discriminated aginst anti-racist protesters",
                "7": "discriminated aginst anti-racist protesters",
                "8": "fired an employee with cancer rather than providing reasaonable accomadation",
                "9": "illegally released environmental waste",
                "10": "zionist founder",
                "11": "complicity as ICE detained migrants at their stores",
                "12": "complicity as ICE detained migrants at their stores",
                "13": "ignored construction safety recommendations after employees died in a store collapse"
            },
            "tags": [
                "retail",
                "deception",
                "privacy violations",
                "racial discrimination",
                "unsafe working conditions",
                "environmental violations",
                "connections to israel",
                "unsustainable practices"
            ],
            "score": 10,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5f/TheHomeDepot.svg/120px-TheHomeDepot.svg.png",
            "siteUrl": "https://homedepot.com/",
            "updatedAt": "2026-02-07T23:14:55.264Z",
            "key": "home-depot"
        },
        "hotel-chocolat": {
            "names": [
                "Hotel Chocolat",
                "Hotel Chocolat Group",
                "Hotel Chocolat Group Limited",
                "HOTC"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "confectionery"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fd/Hotel_chocolat_group_logo.png/120px-Hotel_chocolat_group_logo.png.png",
            "siteUrl": "https://hotelchocolat.com/",
            "updatedAt": "2026-02-08T17:29:02.321Z",
            "key": "hotel-chocolat"
        },
        "frasers-group": {
            "names": [
                "Frasers Group",
                "Frasers Group plc",
                "Sports Direct International plc",
                "Sports Direct International Limited",
                "FRAS"
            ],
            "comment": "Frasers Group is a British retail group that has engaged in predatory pricing [1], repeatedly underpaid employees [2][3][4], maintained poor working conditions and wages below minimum wage [5][6][7], and treated employees inhumanely [8]. The company has also illegally handled redundancies [9], failed to inform victims of a data breach [10], employed in-store facial recognition [11], and abused female employees [12].",
            "sources": {
                "1": "https://www.which.co.uk/news/article/dodgy-pricing-tactics-at-sports-direct-may-be-breaking-the-law-ajikA1s0WjDi",
                "2": "https://www.theguardian.com/business/2016/aug/15/sports-direct-staff-to-receive-back-pay-unite-hmrc",
                "3": "https://www.bbc.co.uk/news/uk-england-derbyshire-37085244",
                "4": "https://www.theguardian.com/business/2017/mar/28/sports-direct-workers-yet-to-receive-backpay-transline-mps-told",
                "5": "https://www.theguardian.com/business/2015/dec/09/how-sports-direct-effectively-pays-below-minimum-wage-pay",
                "6": "https://www.theguardian.com/business/2015/sep/09/sports-direct-investors-revolt-against-chairman-and-pay-policy",
                "7": "https://www.theguardian.com/business/2015/oct/05/ambulances-called-to-sports-direct-hq-more-than-80-times-in-two-years",
                "8": "https://www.bbc.co.uk/news/uk-england-derbyshire-36855374#:~:text=Sports%20Direct%20staff%20'not%20treated%20as%20humans'%2C%20says%20MPs'%20report",
                "9": "https://www.theguardian.com/business/2015/oct/09/sports-direct-chief-executive-david-forsey-charged-usc-administration",
                "10": "https://www.theregister.co.uk/2017/02/08/sports_direct_fails_to_inform_staff_over_hack_and_data_breach/",
                "11": "https://internetretailing.net/frasers-group-cameras/#:~:text=Frasers%20group%20criticised%20over%20'invasive'%20and%20'discriminatory'%20in%2Dstore%20facial%20recognition%20tech",
                "12": "https://www.drapersonline.com/news/missy-empire-co-founder-hit-with-toxic-workplace-allegations"
            },
            "sourceNotes": {
                "1": "predatory pricing",
                "2": "underpaid employees",
                "3": "underpaid employees",
                "4": "underpaid employees",
                "5": "poor working conditions and pay below minimum wage",
                "6": "poor working conditions",
                "7": "poor working conditions - ambulances called to hq",
                "8": "treated employees inhumanely",
                "9": "illegal handling of redundancies",
                "10": "failed to inform victims of data breach",
                "11": "uses in-store facial recognition",
                "12": "abusive treatment towards female employees"
            },
            "tags": [
                "retail",
                "anticompetitive practices",
                "unfair pay",
                "poor working conditions",
                "privacy violations",
                "data breach",
                "sexual harassment",
                "gender discrimination"
            ],
            "score": 24,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/5c/Logo_Frasers_Group.svg",
            "siteUrl": "https://frasers.group/",
            "updatedAt": "2026-02-09T10:30:58.001Z",
            "key": "frasers-group"
        },
        "firetrap": {
            "names": [
                "Firetrap"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Firetrap",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Firetrap_logo.png/120px-Firetrap_logo.png.png",
            "siteUrl": "https://www.firetrap.com/",
            "key": "firetrap"
        },
        "flannels": {
            "names": [
                "Flannels"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Flannels_(retail)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b3/Flanels_blacklogo.png/120px-Flanels_blacklogo.png.png",
            "siteUrl": "https://flannels.com/",
            "key": "flannels"
        },
        "game": {
            "names": [
                "Game"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Game_(retailer)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/3/38/Game_Retail_Ltd_Logo.webp",
            "siteUrl": "https://www.game.co.uk/",
            "key": "game"
        },
        "gieves-and-hawkes": {
            "names": [
                "Gieves & Hawkes"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Gieves_%26_Hawkes",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/Gieves_%26_Hawkes_-_logo.png/120px-Gieves_%26_Hawkes_-_logo.png.png",
            "siteUrl": "http://gievesandhawkes.com/",
            "key": "gieves-and-hawkes"
        },
        "house-of-frasersfrasers": {
            "names": [
                "House of Frasers/Frasers"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/House_of_Fraser",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/62/House_of_Fraser_and_Frasers_logos_side_by_side.png/120px-House_of_Fraser_and_Frasers_logos_side_by_side.png.png",
            "siteUrl": "http://houseoffraser.co.uk/",
            "key": "house-of-frasersfrasers"
        },
        "jack-wills": {
            "names": [
                "Jack Wills"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Jack_Wills",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/e/e9/Jack_Wills_logo.png",
            "siteUrl": "https://www.jackwills.com/",
            "key": "jack-wills"
        },
        "sofa.com": {
            "names": [
                "Sofa.com"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Sofa.com",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/dc/Sofa.com_Logo.jpg",
            "siteUrl": "https://www.sofa.com/",
            "key": "sofa.com"
        },
        "tessuti": {
            "names": [
                "Tessuti"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Tessuti",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/3/3d/Tessuti_logo.svg",
            "siteUrl": "http://www.tessuti.co.uk/",
            "key": "tessuti"
        },
        "the-webster": {
            "names": [
                "The Webster"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/The_Webster",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/0/06/The_official_Webster_Miami_logo.png",
            "siteUrl": "http://thewebster.com/",
            "key": "the-webster"
        },
        "evans-cycles": {
            "names": [
                "Evans Cycles"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Evans_Cycles",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5d/Evanscycles_logo.png/120px-Evanscycles_logo.png.png",
            "siteUrl": "https://www.evanscycles.com/",
            "key": "evans-cycles"
        },
        "gelert": {
            "names": [
                "Gelert"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Gelert_(company)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/0/0a/Gelert_Logo.png",
            "siteUrl": "https://gelert.com/",
            "key": "gelert"
        },
        "heatons": {
            "names": [
                "Heatons"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Heatons",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/19/Heatonslogo.png/120px-Heatonslogo.png.png",
            "siteUrl": "https://www.heatonsstores.com/",
            "key": "heatons"
        },
        "sports-direct": {
            "names": [
                "Sports Direct"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Sports_Direct",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/07/Sports_Direct_logo_2020.svg",
            "siteUrl": "https://sportsdirect.com/",
            "key": "sports-direct"
        },
        "sweatshop": {
            "names": [
                "Sweatshop"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Sweatshop_(retailer)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/3/34/Sweatshop_logo.png",
            "siteUrl": "https://www.sweatshop.com/",
            "key": "sweatshop"
        },
        "usc": {
            "names": [
                "USC"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/USC_(clothing_retailer)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/4e/USC_logo_%28Frasers_Group%29.svg",
            "siteUrl": "https://www.usc.co.uk/",
            "key": "usc"
        },
        "coggles": {
            "names": [
                "Coggles"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Coggles",
            "siteUrl": "http://coggles.com/",
            "key": "coggles"
        },
        "ebuyer": {
            "names": [
                "Ebuyer"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Ebuyer",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/0/0b/Ebuyer_Logo_%282021%29.svg",
            "siteUrl": "http://www.ebuyer.com/",
            "key": "ebuyer"
        },
        "studio": {
            "names": [
                "Studio"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Studio_Retail_Group",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/52/Studio_New_Logo_2024.jpeg/250px-Studio_New_Logo_2024.jpeg",
            "siteUrl": "https://www.studio.co.uk/",
            "key": "studio"
        },
        "wiggle": {
            "names": [
                "Wiggle"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Wiggle_Ltd",
            "key": "wiggle"
        },
        "british-knights": {
            "names": [
                "British Knights"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/British_Knights",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/69/Britishknights_brand_logo.png/120px-Britishknights_brand_logo.png.png",
            "siteUrl": "http://www.bkfootwear.com/",
            "key": "british-knights"
        },
        "carlton": {
            "names": [
                "Carlton"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Carlton_Sports",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/7d/Carlton_Sports_logo.svg",
            "siteUrl": "https://ukstore.carltonsports.com/",
            "key": "carlton"
        },
        "donnay": {
            "names": [
                "Donnay"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Donnay_(sports)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/50/Donnay_logo.png/120px-Donnay_logo.png.png",
            "siteUrl": "https://donnay.com/",
            "key": "donnay"
        },
        "everlast": {
            "names": [
                "Everlast"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Everlast_(brand)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/5c/Everlast-logo-2011.svg",
            "siteUrl": "https://www.everlast.com/",
            "key": "everlast"
        },
        "gul": {
            "names": [
                "Gul"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Gul_(watersports)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/a/ae/Gul_waterports_Logo.svg",
            "siteUrl": "http://gul.com/",
            "key": "gul"
        },
        "hot-tuna": {
            "names": [
                "Hot Tuna"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Hot_Tuna_Clothing",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/de/Hot_Tuna_logo.png",
            "siteUrl": "http://www.hot-tuna.com/",
            "key": "hot-tuna"
        },
        "kangol": {
            "names": [
                "Kangol"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Kangol",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/8/8b/Kangol.svg",
            "siteUrl": "http://kangol.com/",
            "key": "kangol"
        },
        "karrimor": {
            "names": [
                "Karrimor"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Karrimor",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/9/9a/Karrimor_logo.svg",
            "key": "karrimor"
        },
        "la-gear": {
            "names": [
                "LA Gear"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/LA_Gear",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4b/LA_GEAR_LOGO.jpg/120px-LA_GEAR_LOGO.jpg.png",
            "siteUrl": "https://lagear.com/",
            "key": "la-gear"
        },
        "lillywhites": {
            "names": [
                "Lillywhites"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Lillywhites",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/34/Lillywhites_green_logo.png/120px-Lillywhites_green_logo.png.png",
            "siteUrl": "https://www.lillywhites.com/",
            "key": "lillywhites"
        },
        "lonsdale": {
            "names": [
                "Lonsdale"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Lonsdale_(clothing)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/7/7d/Lonsdale_logo.svg",
            "siteUrl": "https://www.lonsdale.com/",
            "key": "lonsdale"
        },
        "muddyfox": {
            "names": [
                "Muddyfox"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Muddyfox",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/1/19/Muddyfox_logo.png",
            "siteUrl": "https://www.muddyfox.com/",
            "key": "muddyfox"
        },
        "no-fear": {
            "names": [
                "No Fear"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/No_Fear",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/3/30/No_Fear_logo.png",
            "siteUrl": "http://www.nofear.com/",
            "key": "no-fear"
        },
        "slazenger": {
            "names": [
                "Slazenger"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Slazenger",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/6/64/Slazenger_logo.svg",
            "siteUrl": "http://store.slazenger.com/",
            "key": "slazenger"
        },
        "gamestation": {
            "names": [
                "Gamestation"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Gamestation",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/0/05/Gamestation_%28logo%29.png",
            "siteUrl": "http://gamestation.co.uk/",
            "key": "gamestation"
        },
        "jjb-sports": {
            "names": [
                "JJB Sports"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/JJB_Sports",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/5/52/JJB_Sports_%28logo%29.png",
            "siteUrl": "http://jjbsports.com/",
            "key": "jjb-sports"
        },
        "republic": {
            "names": [
                "Republic"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "frasers-group"
            ],
            "updatedAt": "2026-02-09T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Republic_(retailer)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/6/62/Republic_logo.png",
            "siteUrl": "http://www.republic.co.uk/",
            "key": "republic"
        },
        "htc": {
            "names": [
                "HTC",
                "HTC Corporation",
                "High Tech Computer Corporation",
                "宏達國際電子股份有限公司"
            ],
            "comment": "HTC is a Taiwanese electronics manufacturer that has failed to protect customers by selling insecure devices [1] and has sourced components from suppliers with unacceptable and abusive working conditions [2][3][4]. The company has also engaged in illegal surveillance on users' devices [5][6].",
            "sources": {
                "1": "https://www.ftc.gov/news-events/news/press-releases/2013/02/htc-america-settles-ftc-charges-it-failed-secure-millions-mobile-devices-shipped-consumers#:~:text=Mobile%20device%20manufacturer%20HTC%20America%20has%20agreed,that%20the%20company%20failed%20to%20take%20reasonable",
                "2": "http://johninnit.co.uk/2011/10/19/have-htc-read-their-own-code-of-ethics-recently/",
                "3": "https://goodelectronics.org/report-paying-the-price-for-flexibility-workers-experiences-in-the-electronics-industry-in-mexico/",
                "4": "https://web.archive.org/web/20210616223125/https://sacom.hk/2013/11/25/investigative-report-no-more-bloodstained-cover-glass-on-iphones-biel-crystal-stop-bloody-exploitation-now/",
                "5": "https://venturebeat.com/mobile/htc-samsung-carrieriq",
                "6": "https://www.phonearena.com/news/Class-action-lawsuits-aimed-at-Carrier-IQ-HTC-Samsung_id24299"
            },
            "sourceNotes": {
                "1": "failed to protect customers by selling insecure devices",
                "2": "sourced from suppliers with unacceptable working conditions",
                "3": "sourced from suppliers with unacceptable working conditions",
                "4": "sourced from suppliers with abusive working conditions",
                "5": "engaged in illegal surveillance on users' devices",
                "6": "engaged in illegal surveillance on users' devices"
            },
            "tags": [
                "electronics",
                "unsafe products",
                "poor working conditions",
                "privacy violations"
            ],
            "score": 27,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/d/d5/HTC.svg",
            "siteUrl": "http://www.htc.com/",
            "updatedAt": "2026-02-10T18:16:05.298Z",
            "key": "htc"
        },
        "huawei": {
            "names": [
                "Huawei",
                "Huawei Corporation",
                "HUAWEI",
                "华为技术有限公司",
                "华为"
            ],
            "comment": "Huawei is a Chinese technology company that has colluded with police to imprison former employees [1][2], spied on the African Union [3], and has been linked to labor rights abuses, including forced overwork leading to death [4][5][6][7], and the forced use of Uyghur labor in its supply chain. Huawei has collaborated with the Burmese military to suppress human rights [8], and participated in the oppression of Uyghur minorities and other human rights abuses [9][10][11][12][13][14][15].",
            "sources": {
                "1": "https://web.archive.org/web/20191223051032/https://www.theguardian.com/technology/2019/dec/23/this-is-not-rule-of-law-detention-of-huawei-workers-sparks-backlash",
                "2": "https://web.archive.org/web/20191203190157/http://www.sixthtone.com/news/1004908/huawei-breaks-silence-after-sending-former-employee-to-jail",
                "3": "https://www.bbc.co.uk/news/resources/idt-sh/Huawei",
                "4": "https://web.archive.org/web/20110716065253/http://www.clb.org.hk/en/node/50739",
                "5": "https://web.archive.org/web/20081006132653/http://www.clb.org.hk/en/node/100253",
                "6": "https://web.archive.org/web/20110120111359/http://www.cbc.ca/news/viewpoint/vp_metz/20071105.html",
                "7": "https://web.archive.org/web/20110514044112/http://english.ohmynews.com/articleview/article_view.asp?menu=c10400&no=296942&rel_no=1",
                "8": "https://burmacampaign.org.uk/take-action/Huawei/",
                "9": "https://web.archive.org/web/20200422202834/https://www.theguardian.com/technology/2020/mar/03/tory-mp-asks-bt-using-huawei-complies-anti-slavery-policy",
                "10": "https://web.archive.org/web/20200505103837/https://www.ft.com/content/8912445a-5bd3-11ea-8033-fa40a0d65a98",
                "11": "https://web.archive.org/web/20191125180459/https://www.nytimes.com/2019/05/22/world/asia/china-surveillance-xinjiang.html",
                "12": "https://web.archive.org/web/20200511163329/https://www.thetimes.co.uk/article/chinese-tech-giant-huawei-helps-to-persecute-uighurs-7dfcb56nw",
                "13": "https://web.archive.org/web/20200823221956/https://thehill.com/policy/technology/507443-us-announces-sanctions-on-huawei-citing-human-rights-abuses",
                "14": "https://www.washingtonpost.com/technology/2020/12/08/huawei-tested-ai-software-that-could-recognize-uighur-minorities-alert-police-report-says/",
                "15": "https://www.bbc.com/news/world-europe-55265989"
            },
            "sourceNotes": {
                "1": "colluded with police to imprison former employees",
                "2": "colluded with police to imprison former employees",
                "3": "spyed on the african union",
                "4": "labour rights abuses",
                "5": "labour rights abuses",
                "6": "overworked employees leading to death",
                "7": "overworked employees leading to death",
                "8": "collaborated with Burmese military to supress human rights",
                "9": "forced Uyghur labour in supply chain",
                "10": "forced Uyghur labour in supply chain",
                "11": "participated in oppression of Uyghur minorities",
                "12": "participated in oppression of Uyghur minorities",
                "13": "participated in oppression of Uyghur minorities and human rights abuses",
                "14": "participated in oppression of Uyghur minorities and human rights abuses",
                "15": "participated in oppression of Uyghur minorities and human rights abuses"
            },
            "tags": [
                "electronics",
                "forced labour",
                "forced uyghur labour",
                "privacy violations",
                "racial discrimination",
                "poor working conditions"
            ],
            "score": 14,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/0/04/Huawei_Standard_logo.svg",
            "siteUrl": "https://www.huawei.com/",
            "updatedAt": "2026-02-11T10:47:42.082Z",
            "key": "huawei"
        },
        "huggies": {
            "names": [
                "Huggies"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 17,
            "ownedBy": [
                "kimberly-clark"
            ],
            "logoUrl": "https://seeklogo.com/images/H/huggies-logo-19A14219BD-seeklogo.com.png",
            "siteUrl": "https://www.huggies.com/",
            "updatedAt": "2026-02-12T17:56:04.678Z",
            "key": "huggies"
        },
        "hulu": {
            "names": [
                "hulu",
                "Hulu"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 20,
            "ownedBy": [
                "disney"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/f/f9/Hulu_logo_%282018%29.svg",
            "siteUrl": "https://www.hulu.com/",
            "updatedAt": "2026-02-13T19:54:19.595Z",
            "key": "hulu"
        },
        "hyatt": {
            "names": [
                "Hyatt",
                "Hyatt Hotels Corporation",
                "Hyatt Hotels & Resorts",
                "H"
            ],
            "comment": "",
            "sources": {
                "1": "https://onemileatatime.com/news/hyatt-hotel-scam-honoring-low-rate/",
                "2": "https://www.thestreet.com/travel/lawsuit-filed-on-hidden-fees-travelers-pay-at-major-u-s-hotel-chain",
                "3": "https://www.texasattorneygeneral.gov/news/releases/attorney-general-ken-paxton-secures-125-million-settlement-hyatt-hotels-forcing-company-stop-hiding",
                "4": "https://www.law360.com/articles/1602985/hyatt-to-pay-1m-to-end-seattle-workers-unpaid-wages-suit",
                "5": "https://truthout.org/articles/why-boycotting-hyatt-is-more-than-just-a-union-issue-an-interview-with-activist-cleve-jones/",
                "6": "https://www.ncronline.org/news/people/hyatt-has-huge-moral-challenge-overcome-treatment-employees",
                "7": "https://www.wkbw.com/news/local-news/buffalo/hyatt-regency-fighting-to-unionize-say-key-organizer-was-wrongfully-terminated",
                "8": "https://www.dir.ca.gov/DIRNews/2023/2023-76.html",
                "9": "https://web.archive.org/web/20211202125937/http://www.hyattbipasettlement.com/"
            },
            "sourceNotes": {
                "1": "price gouging and hidden fees",
                "2": "price gouging and hidden fees",
                "3": "hidden fees",
                "4": "underpaid employees",
                "5": "overworking employees",
                "6": "exploiting employees and anti-union practices",
                "7": "discriminated against employees trying to unionize",
                "8": "mistreated employees during covid",
                "9": "mishandled employee biometric data"
            },
            "tags": [
                "hospitality"
            ],
            "score": 40,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/91/Hyatt_Logo.svg",
            "siteUrl": "https://hyatt.com/",
            "updatedAt": "2026-02-14T10:10:06.890Z",
            "key": "hyatt"
        },
        "apple-leisure-group": {
            "names": [
                "Apple Leisure Group"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "hospitality"
            ],
            "score": 20,
            "ownedBy": [
                "hyatt"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/6/6c/Apple_Leisure_Group_logo.png/250px-Apple_Leisure_Group_logo.png",
            "siteUrl": "http://www.appleleisuregroup.com/",
            "updatedAt": "2026-02-14T18:26:35.570Z",
            "key": "apple-leisure-group"
        },
        "alila": {
            "names": [
                "Alila"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "hospitality"
            ],
            "score": 20,
            "ownedBy": [
                "hyatt"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/1b/Alila_Hotels_and_Resorts_logo.svg",
            "siteUrl": "http://alilahotels.com/",
            "updatedAt": "2026-02-14T18:26:35.570Z",
            "key": "alila"
        },
        "iheartmedia": {
            "names": [
                "iHeartMedia",
                "iHeartMedia, Inc.",
                "CC Media Holdings, Inc.",
                "CC Media Holdings",
                "Clear Channel",
                "IHRT"
            ],
            "comment": "iHeartMedia is a U.S. media conglomerate that has forced musicians to work without pay [1][2], illegally gifted services to Republican politicians [3], and engaged in deceptive advertising [4]. The company has also demonstrated poor crisis management with a lack of local staff during emergencies [5], refused to air adverts containing same‑sex couples [6][7][8], and censored political music critical of the Iraq war [9][10].",
            "sources": {
                "1": "https://www.yahoo.com/news/fcc-probes-iheartmedia-following-accusations-030411548.html",
                "2": "https://www.newsweek.com/trump-official-investigating-iheartmedia-allegedly-forcing-musicians-work-no-pay-2036724",
                "3": "https://www.forbes.com/sites/zacheverson/2022/12/01/ted-cruzs-podcast-deal-with-iheartmedia-may-violate-ethics-laws-watchdog-says-in-new-complaint/",
                "4": "https://natlawreview.com/article/google-iheartmedia-pay-94-million-to-settle-ftc-and-state-allegations-deceptive",
                "5": "https://web.archive.org/web/20101206055034/http://www.democracynow.org/2007/1/25/exclusive_911_calls_in_north_dakota",
                "6": "http://www.wtsp.com/news/local/story.aspx?storyid=133980&catid=8",
                "7": "https://www.glaad.org/2010/calltoaction/clearchannel",
                "8": "http://banbillboardblight.org/clear-channel-wont-allow-gay-pride-images-on-billboards/",
                "9": "https://web.archive.org/web/20111010015435/http://www.bizjournals.com/jacksonville/stories/2003/03/17/daily14.html",
                "10": "https://web.archive.org/web/20120716180633/http://www.usatoday.com/news/nation/2005-08-20-bush-ad_x.htm"
            },
            "sourceNotes": {
                "1": "forced musicisns to work without pay",
                "2": "forced musicisns to work without pay",
                "3": "illegally gifted services to republican politicians",
                "4": "deceptive advertising",
                "5": "Lack of local staff leading to failed emergency response",
                "6": "refused to show adverts containing same-sex couples",
                "7": "refused to show adverts containing same-sex couples",
                "8": "refused to show adverts containing same-sex couples",
                "9": "censored political music and criticism of the war in iraq",
                "10": "censored political music and criticism of the war in iraq"
            },
            "tags": [
                "media",
                "forced labour",
                "corruption",
                "deception",
                "unfair pay"
            ],
            "score": 40,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/57/IHeartMedia_Logo.svg/120px-IHeartMedia_Logo.svg.png",
            "siteUrl": "https://www.iheartmedia.com/",
            "updatedAt": "2026-02-14T18:31:31.978Z",
            "key": "iheartmedia"
        },
        "bauer-media-outdoor-uk": {
            "names": [
                "Bauer Media Outdoor UK"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "media"
            ],
            "score": 40,
            "ownedBy": [
                "iheartmedia"
            ],
            "updatedAt": "2026-02-15T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Bauer_Media_Outdoor_UK",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/Bauer_Media_Outdoor_Logo_2025.png/120px-Bauer_Media_Outdoor_Logo_2025.png.png",
            "siteUrl": "http://www.bauermedia.com/business/outdoor",
            "key": "bauer-media-outdoor-uk"
        },
        "black-information-network": {
            "names": [
                "Black Information Network"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "media"
            ],
            "score": 40,
            "ownedBy": [
                "iheartmedia"
            ],
            "updatedAt": "2026-02-15T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Black_Information_Network",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/7/77/Black_Information_Network_logo.webp",
            "siteUrl": "https://www.binnews.com/",
            "key": "black-information-network"
        },
        "clear-channel-outdoor": {
            "names": [
                "Clear Channel Outdoor"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "media"
            ],
            "score": 40,
            "ownedBy": [
                "iheartmedia"
            ],
            "updatedAt": "2026-02-15T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Clear_Channel_Outdoor",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/f/f9/Clear_Channel_Outdoor_logo.svg",
            "siteUrl": "http://clearchanneloutdoor.com/",
            "key": "clear-channel-outdoor"
        },
        "clear-channel-uk": {
            "names": [
                "Clear Channel UK"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "media"
            ],
            "score": 40,
            "ownedBy": [
                "iheartmedia"
            ],
            "updatedAt": "2026-02-15T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Clear_Channel_UK",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/Bauer_Media_Outdoor_Logo_2025.png/120px-Bauer_Media_Outdoor_Logo_2025.png.png",
            "siteUrl": "http://www.bauermedia.com/business/outdoor",
            "key": "clear-channel-uk"
        },
        "evolution": {
            "names": [
                "Evolution"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "media"
            ],
            "score": 40,
            "ownedBy": [
                "iheartmedia"
            ],
            "updatedAt": "2026-02-15T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Evolution_(radio_network)",
            "key": "evolution"
        },
        "howstuffworks": {
            "names": [
                "HowStuffWorks"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "media"
            ],
            "score": 40,
            "ownedBy": [
                "iheartmedia"
            ],
            "updatedAt": "2026-02-15T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/HowStuffWorks",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/8d/Howstuffworks_logo.svg",
            "siteUrl": "https://www.howstuffworks.com/",
            "key": "howstuffworks"
        },
        "iheartradio": {
            "names": [
                "iheartmedia"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "media"
            ],
            "score": 40,
            "ownedBy": [
                "iheartmedia"
            ],
            "updatedAt": "2026-02-15T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/IHeartRadio",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/e/e5/IHeartRadio_Logo.svg",
            "key": "iheartradio"
        },
        "mediabase": {
            "names": [
                "Mediabase"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "media"
            ],
            "score": 40,
            "ownedBy": [
                "iheartmedia"
            ],
            "updatedAt": "2026-02-15T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Mediabase",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/1/18/Mediabase_corporate_logo.png",
            "siteUrl": "http://www.mediabase.com/",
            "key": "mediabase"
        },
        "premiere-networks": {
            "names": [
                "Premiere Networks"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "media"
            ],
            "score": 40,
            "ownedBy": [
                "iheartmedia"
            ],
            "updatedAt": "2026-02-15T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Premiere_Networks",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/46/Premiere_Networks_new_logo.png",
            "siteUrl": "https://www.premierenetworks.com/",
            "key": "premiere-networks"
        },
        "radio-computing-services": {
            "names": [
                "Radio Computing Services"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "media"
            ],
            "score": 40,
            "ownedBy": [
                "iheartmedia"
            ],
            "updatedAt": "2026-02-15T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Radio_Computing_Services",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/8/8d/RCS_corporate_logo.png",
            "siteUrl": "http://www.rcsworks.com/",
            "key": "radio-computing-services"
        },
        "triton-digital": {
            "names": [
                "Triton Digital"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "media"
            ],
            "score": 40,
            "ownedBy": [
                "iheartmedia"
            ],
            "updatedAt": "2026-02-15T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Triton_Digital",
            "key": "triton-digital"
        },
        "the-volume": {
            "names": [
                "The Volume"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "media"
            ],
            "score": 40,
            "ownedBy": [
                "iheartmedia"
            ],
            "updatedAt": "2026-02-15T06:28:22.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/The_Volume",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/The_Volume_2023_logo.png/120px-The_Volume_2023_logo.png.png",
            "siteUrl": "https://www.thevolume.com/",
            "key": "the-volume"
        },
        "illy": {
            "names": [
                "Illy",
                "Illycaffè",
                "Illycaffè S.p.A.",
                "illy"
            ],
            "comment": "Illy is an Italian coffee company that does not certify its coffee as fairtrade [1] and which has potentially been connected with forced labour in its supply chain [2].",
            "sources": {
                "1": "https://qz.com/gateway/trump-takeover-venezuela-cuba-regime-change",
                "2": "https://www.business-humanrights.org/en/latest-news/IllycafferesponsetothereportBitterBrew/"
            },
            "sourceNotes": {
                "1": "does not certify its coffee as fairtrade",
                "2": "potential connections to forced labour in supply chain"
            },
            "tags": [
                "coffee",
                "beverages",
                "forced labour"
            ],
            "score": 49,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/d/d0/Logo_Illy.svg",
            "siteUrl": "https://www.illy.com/",
            "updatedAt": "2026-02-16T13:20:28.997Z",
            "key": "illy"
        },
        "in-n-out": {
            "names": [
                "In-N-Out",
                "In-N-Out Burger",
                "In-N-Out Burgers"
            ],
            "comment": "In-N-Out is an American fast‑food chain that has donated to the Republican Party [1][2], has been accused of racial discrimination against employees [3][4], and has violated labor rights by preventing workers from wearing badges [5]. The company has opposed COVID‑19 vaccines [6][7][8] and mask mandates [9][10][11], overuses antibiotics in its meat supply chain [12][13], and has resisted improved climate change regulations [14].",
            "sources": {
                "1": "https://www.cnbc.com/2018/08/30/in-n-out-burger-faces-boycott-for-california-gop-donation.html",
                "2": "https://www.mashed.com/201369/secrets-in-n-out-burger-doesnt-want-you-to-know/",
                "3": "https://ktla.com/news/local-news/former-in-n-out-employees-files-3-million-lawsuit-accusing-company-of-alleged-discrimination-over-hairstyle/",
                "4": "https://www.sfgate.com/food/article/calif-man-sues-in-n-out-over-hairstyle-20384020.php",
                "5": "https://www.hinshawlaw.com/en/insights/blogs/employment-law-observer/the-fight-for-dollar15-and-the-nlrb#:~:text=In%2DN%2DOut%20Burger%2C%20Incorporated%20(In%2DN%2DOut%20(%20In%2DN%2DOut%20Burger,Fifth%20Circuit%2C%20in%20In%2DN%2DOut%20Burger%2C%20Incorporated%20v.",
                "6": "https://www.npr.org/2021/10/20/1047638276/in-n-out-burger-san-francisco-vaccine-mandate",
                "7": "https://www.latimes.com/california/story/2021-10-29/in-n-out-closes-all-of-its-contra-costa-county-indoor-dining-rooms-over-local-vaccine-mandates",
                "8": "https://www.wsj.com/articles/in-n-out-burger-in-san-francisco-closed-for-violating-city-vaccine-policy-11634746703",
                "9": "https://www.sfchronicle.com/health/article/in-n-out-bans-covid-masking-employees-az-nv-ut-18205121.php",
                "10": "https://www.sfgate.com/politics/article/in-n-out-finally-comments-on-anti-mask-policy-18252998.php",
                "11": "https://www.theguardian.com/food/2023/jul/18/in-n-out-ban-masks-workers-texas-arizona-colorado#:~:text=In%2DN%2DOut%20Burger%20has%20been%20criticized%20previously%20for,the%20vaccination%20status%20of%20indoor%20dining%20customers.",
                "12": "https://www.thedailymeal.com/1962975/in-n-out-meat-sourcing-controversy/",
                "13": "https://www.chowhound.com/1680480/mcdonalds-burgers-ranked-worst-best/",
                "14": "https://www.levernews.com/why-in-n-out-burger-is-fighting-a-landmark-climate-bill/"
            },
            "sourceNotes": {
                "1": "donated to republican party",
                "2": "donated to republican party",
                "3": "racial discrimination against employees",
                "4": "racial discrimination against employees",
                "5": "violated labour rights by preventing employees from wearing badges",
                "6": "opposed covid vaccines",
                "7": "opposed covid vaccines",
                "8": "opposed covid vaccines",
                "9": "opposed covid face mask requirements",
                "10": "opposed covid face mask requirements",
                "11": "opposed covid face mask requirements",
                "12": "overuse of antibiotics in meat supply chain",
                "13": "overuse of antibiotics in meat supply chain",
                "14": "opposed improved climate change regulations"
            },
            "tags": [
                "food",
                "racial discrimination",
                "unsustainable practices"
            ],
            "score": 36,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/8c/InNOut_2021_logo.svg",
            "siteUrl": "https://in-n-out.com/",
            "updatedAt": "2026-02-17T16:36:30.912Z",
            "key": "in-n-out"
        },
        "ing": {
            "names": [
                "ING",
                "ING Group",
                "ING Group N.V.",
                "ING Groep",
                "INGA"
            ],
            "comment": "ING is a Dutch banking group that has been repeatedly criticized for anti‑money‑laundering failures [1], involvement in money laundering and the extraction of funds from Russia [2][3], and corruption linked to money laundering [4]. The institution has also faced scrutiny for its inaction on climate change while continuing to finance fossil fuels [5], discriminatory treatment of minority clients [6][7], and price‑fixing and other anti‑competitive practices [8].",
            "sources": {
                "1": "https://northlark.com/ing-banks-aml-failures-and-200-million-fine/",
                "2": "https://www.bloomberg.com/news/articles/2018-09-04/ing-to-pay-784-million-in-fines-to-settle-dutch-criminal-case",
                "3": "https://www.dw.com/en/how-ing-bank-in-poland-helped-russians-launder-money/a-55322399",
                "4": "https://brusselssignal.eu/2025/08/alleged-corruption-investigation-into-reynders-expands-to-ing-bank/",
                "5": "https://www.business-humanrights.org/en/latest-news/netherlands-ing-sued-by-dutch-non-profit-for-alleged-failures-over-climate/",
                "6": "https://nltimes.nl/2025/05/27/ing-apologizes-customers-discriminating-anti-money-laundering-approach",
                "7": "https://pilp.nu/en/ing-discriminates-against-customers-based-on-their-origin-in-transaction-checks/",
                "8": "https://www.law360.com/articles/1494088"
            },
            "sourceNotes": {
                "1": "anti money laundering failures",
                "2": "involved in money laundering",
                "3": "involved in money laundering and extraction of funds from Russia",
                "4": "involved in corruption and money laundering",
                "5": "inaction over climate, continuing to finance fossil fuels",
                "6": "discriminated against minority clients",
                "7": "discriminated against minority clients",
                "8": "prive fixing and anti competetive practices"
            },
            "tags": [
                "bank",
                "anticompetitive practices",
                "corruption",
                "connections to russia",
                "fossil fuels",
                "racial discrimination",
                "unsustainable practices",
                "environmental violations"
            ],
            "score": 40,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/49/ING_Group_N.V._Logo.svg/120px-ING_Group_N.V._Logo.svg.png",
            "siteUrl": "http://ing.com/",
            "updatedAt": "2026-02-18T04:50:31.869Z",
            "key": "ing"
        },
        "bank-mendes-gans": {
            "names": [
                "Bank Mendes Gans"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "bank"
            ],
            "score": 40,
            "ownedBy": [
                "ing"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/d5/Bank_Mendes_Gans.gif/250px-Bank_Mendes_Gans.gif",
            "siteUrl": "http://www.mendesgans.com/",
            "updatedAt": "2026-02-18T04:50:31.869Z",
            "key": "bank-mendes-gans"
        },
        "instacart": {
            "names": [
                "Instacart",
                "Maplebear Inc.",
                "Maplebear",
                "CART"
            ],
            "comment": "Instacart is an American online grocery delivery service that has engaged in deceptive pricing [1][2][3], mistreatment and misclassification of employees [4][5][6][7], and suffered a data breach that leaked users’ personal data [8]. Instacart has also covertly used AI to manipulate prices [9][10].",
            "sources": {
                "1": "https://www.cnbc.com/2025/12/18/instacart-ftc-settlement-deceptive-billing.html",
                "2": "https://www.reuters.com/world/trump-nominates-joshua-rudd-director-national-security-agency-pentagon-says-2025-12-18/",
                "3": "https://www.grocerydive.com/news/instacart-settles-legal-dispute-over-service-fee-with-district-of-columbi/630172/",
                "4": "https://www.grocerydive.com/news/instacart-agrees-to-465m-settlement-over-worker-classification/633898/",
                "5": "https://web.archive.org/web/20190430092238/https://www.recode.net/2017/3/23/14804094/instacart-settlement-class-action-lawsuit-workers",
                "6": "https://www.latimes.com/business/technology/story/2020-08-27/shopping-for-instacart-metrics",
                "7": "https://web.archive.org/web/20150319113650/https://time.com/3748438/instacart-lawsuit/",
                "8": "https://www.forbes.com/sites/thomasbrewster/2025/08/27/instacart-target-shipt-gig-workers-hacked/",
                "9": "https://www.consumerreports.org/money/questionable-business-practices/instacart-ai-pricing-experiment-inflating-grocery-bills-a1142182490/",
                "10": "https://honeytree.co/post/ai-transparency-and-instacart-pricing-concerns"
            },
            "sourceNotes": {
                "1": "deceptive pricing",
                "2": "deceptive pricing",
                "3": "deceptive pricing an misleading customers",
                "4": "misclassification and mistreatment of employees",
                "5": "mistreatment of employees",
                "6": "poor working conditions",
                "7": "mistreatment of employees",
                "8": "leaked users personal data in breach",
                "9": "used AI to for covert price gauging",
                "10": "used AI to covertly increase prices"
            },
            "tags": [
                "food",
                "logistics",
                "deception",
                "unfair pay",
                "poor working conditions",
                "data breach"
            ],
            "score": 44,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/9f/Instacart_logo_and_wordmark.svg",
            "siteUrl": "https://instacart.com/",
            "updatedAt": "2026-02-19T08:35:58.152Z",
            "key": "instacart"
        },
        "instagram": {
            "names": [
                "Instagram"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "media",
                "tech"
            ],
            "score": 10,
            "ownedBy": [
                "meta"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/95/Instagram_logo_2022.svg",
            "siteUrl": "https://www.instagram.com/",
            "updatedAt": "2026-02-19T21:13:03.874Z",
            "key": "instagram"
        },
        "whatsapp": {
            "names": [
                "Whatsapp",
                "WhatsApp Messenger"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "media",
                "tech"
            ],
            "score": 10,
            "ownedBy": [
                "meta"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/4c/WhatsApp_Logo_green.svg",
            "siteUrl": "https://whatsapp.com/",
            "updatedAt": "2026-02-19T21:13:03.874Z",
            "key": "whatsapp"
        },
        "facebook": {
            "names": [
                "Facebook"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "media",
                "tech"
            ],
            "score": 10,
            "ownedBy": [
                "meta"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/b9/2023_Facebook_icon.svg",
            "siteUrl": "https://www.facebook.com/",
            "updatedAt": "2026-02-19T21:13:03.874Z",
            "key": "facebook"
        },
        "intel": {
            "names": [
                "Intel",
                "Intel Corporation",
                "NM Electronics",
                "intel",
                "INTC"
            ],
            "comment": "Intel is a U.S. company that has engaged in anticompetitive monopolistic practices [1][2][3][4][5], tax avoidance [6][7], age discrimination against employees [8], and a CEO sex scandal [9]. Additionally, Intel has sold known defective chips [10][11][12], maintained unacceptable working conditions in its supply chain [13] and wage suppression of employees [14], while maintaining close connections to the U.S. military [15] and the Israeli government and military [16].",
            "sources": {
                "1": "https://web.archive.org/web/20081216122419/http://uk.reuters.com/article/technologyNews/idUKL1730607220080718?pageNumber=3&virtualBrandChannel=0",
                "2": "https://www.nytimes.com/2008/01/10/technology/10cnd-chip.html",
                "3": "http://news.bbc.co.uk/2/hi/business/8343179.stm",
                "4": "https://web.archive.org/web/20231024140302/https://europa.eu/commission/presscorner/detail/en/ip_23_4570",
                "5": "https://web.archive.org/web/20090516170330/http://www.time.com/time/business/article/0,8599,1897913,00.html",
                "6": "http://greatgameindia.com/rothschild-inside-garbage-outside/",
                "7": "http://www.dontmesswithtaxes.com/2016/08/indian-city-raises-stink-over-unpaid-tax-by-intel.html",
                "8": "https://web.archive.org/web/20090522163807/http://www.programmersguild.org/archives/lib/agediscimination/upm19981207older.htm",
                "9": "https://appleinsider.com/articles/18/06/21/intel-ceo-brian-krzanich-resigns-amidst-relationship-scandal",
                "10": "https://www.tomshardware.com/pc-components/cpus/intel-slapped-with-class-action-lawsuit-for-raptor-lake-cpu-instability-issues-chipmaker-accused-of-consciously-selling-defective-chips",
                "11": "https://www.pcgamer.com/hardware/processors/new-class-action-lawsuit-alleges-intel-knew-its-cpus-were-crashing-even-before-they-went-on-sale/",
                "12": "https://www.tomshardware.com/pc-components/cpus/lawsuit-claims-intel-sold-billions-of-cpus-knowing-of-downfall-vulnerability",
                "13": "https://chinalaborwatch.org/the-chaos-in-global-supply-chain-exacerbates-terrible-working-conditions-in-china/",
                "14": "https://www.cnet.com/tech/tech-industry/apple-google-others-settle-anti-poaching-lawsuit-for-415-million/",
                "15": "https://www.datacenterdynamics.com/en/news/intel-secures-35bn-military-semiconductor-grant-despite-ongoing-chips-act-funding-dispute/",
                "16": "https://bdsmovement.net/Guide-to-BDS-Boycott"
            },
            "sourceNotes": {
                "1": "anticompetetive monopolistic practices",
                "2": "anticompetetive monopolistic practices",
                "3": "anticompetetive monopolistic practices and bribery",
                "4": "anticompetetive monopolistic practices",
                "5": "anticompetetive monopolistic practices",
                "6": "tax avoidance",
                "7": "tax avoidance",
                "8": "age discrimination against employees",
                "9": "ceo sex scandal",
                "10": "sold known defective chips",
                "11": "sold known defective chips",
                "12": "sold known defective chips",
                "13": "unacceptable working conditions in supply chain",
                "14": "wage supression of employees",
                "15": "close connections to US military",
                "16": "close connection to israeli government and military"
            },
            "tags": [
                "tech",
                "electronics",
                "anticompetitive practices",
                "tax avoidance",
                "unfair pay",
                "poor working conditions",
                "connections to israel",
                "unsafe practices",
                "sexual harassment"
            ],
            "score": 25,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/85/Intel_logo_2023.svg",
            "siteUrl": "https://www.intel.com/",
            "updatedAt": "2026-02-20T08:00:29.907Z",
            "key": "intel"
        },
        "intelligentsia": {
            "names": [
                "intelligentsia",
                "Intelligentsia Coffee",
                "Intelligentsia Coffee & Tea"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "coffee"
            ],
            "score": 35,
            "ownedBy": [
                "jab-holding-company"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/9/93/Intelligentsia_logo.png",
            "siteUrl": "http://intelligentsiacoffee.com/",
            "updatedAt": "2026-02-21T08:51:03.526Z",
            "key": "intelligentsia"
        },
        "jbl": {
            "names": [
                "JBL"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "electronics"
            ],
            "score": 45,
            "ownedBy": [
                "samsung"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/bc/JBL_logo.svg",
            "siteUrl": "http://jbl.com/",
            "updatedAt": "2026-02-20T22:47:51.809Z",
            "key": "jbl"
        },
        "jcpenney": {
            "names": [
                "JCPenney"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing",
                "retail"
            ],
            "score": null,
            "ownedBy": [
                "brookfield-corportion",
                "simon-property-group"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/23/JCPenney_logo.svg",
            "siteUrl": "http://jcpenney.com/",
            "updatedAt": "2026-02-23T16:24:51.625Z",
            "key": "jcpenney"
        },
        "berghaus": {
            "names": [
                "Berghaus"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "clothing",
                "sports"
            ],
            "score": 39,
            "ownedBy": [
                "pentland-group"
            ],
            "updatedAt": "2026-02-28T10:57:00.469Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Berghaus",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/0/08/Berghaus_logo.svg",
            "siteUrl": "http://berghaus.com/",
            "key": "berghaus"
        },
        "boxfresh": {
            "names": [
                "Boxfresh"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "clothing",
                "sports"
            ],
            "score": 39,
            "ownedBy": [
                "pentland-group"
            ],
            "updatedAt": "2026-02-28T10:57:00.666Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Boxfresh",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Boxfresh_logo.png/120px-Boxfresh_logo.png.png",
            "siteUrl": "http://www.boxfresh.com/",
            "key": "boxfresh"
        },
        "canterbury": {
            "names": [
                "Canterbury"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "clothing",
                "sports"
            ],
            "score": 39,
            "ownedBy": [
                "pentland-group"
            ],
            "updatedAt": "2026-02-28T10:57:01.154Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Canterbury_of_New_Zealand",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/e/e3/Canterbury_of_New_Zealand_logo.svg",
            "siteUrl": "https://www.canterbury.com/",
            "key": "canterbury"
        },
        "ellesse": {
            "names": [
                "Ellesse"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "clothing",
                "sports"
            ],
            "score": 39,
            "ownedBy": [
                "pentland-group"
            ],
            "updatedAt": "2026-02-28T10:57:01.254Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Ellesse",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d3/Ellesse_logo.png/120px-Ellesse_logo.png.png",
            "siteUrl": "http://ellesse.com/",
            "key": "ellesse"
        },
        "endura": {
            "names": [
                "Endura"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "clothing",
                "sports"
            ],
            "score": 39,
            "ownedBy": [
                "pentland-group"
            ],
            "updatedAt": "2026-02-28T10:57:01.328Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Endura_Racing",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/6/62/Endura_Racing_logo.jpg",
            "siteUrl": "https://www.enduraracing.com/",
            "key": "endura"
        },
        "kangaroos": {
            "names": [
                "KangaRoos"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "clothing",
                "sports"
            ],
            "score": 39,
            "ownedBy": [
                "pentland-group"
            ],
            "updatedAt": "2026-02-28T10:57:01.866Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/KangaRoos",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/7/75/Kangaroos_shoes_logo.png",
            "siteUrl": "http://www.kangaroos.com/",
            "key": "kangaroos"
        },
        "kickers": {
            "names": [
                "Kickers"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "clothing",
                "sports"
            ],
            "score": 39,
            "ownedBy": [
                "pentland-group"
            ],
            "updatedAt": "2026-02-28T10:57:01.915Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Kickers_(brand)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/Kickers_shoes_logo.png/120px-Kickers_shoes_logo.png.png",
            "siteUrl": "http://www.kickers.co.uk/",
            "key": "kickers"
        },
        "lacoste": {
            "names": [
                "Lacoste"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing",
                "retail"
            ],
            "score": null,
            "ownedBy": [
                "maus-freres"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/4/43/Lacoste_logo.svg",
            "siteUrl": "https://lacoste.com/",
            "updatedAt": "2026-03-13T10:05:17.094Z",
            "key": "lacoste"
        },
        "mitre": {
            "names": [
                "Mitre"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "clothing",
                "sports"
            ],
            "score": 39,
            "ownedBy": [
                "pentland-group"
            ],
            "updatedAt": "2026-02-28T10:57:02.341Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Mitre_Sports_International",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c8/Mitre_sports_logo.png/120px-Mitre_sports_logo.png.png",
            "siteUrl": "https://www.mitre.com/",
            "key": "mitre"
        },
        "red-or-dead": {
            "names": [
                "Red or Dead"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "clothing",
                "sports"
            ],
            "score": 39,
            "ownedBy": [
                "pentland-group"
            ],
            "updatedAt": "2026-02-28T10:57:02.523Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Red_or_Dead",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c6/Red_or_dead_logo.png/120px-Red_or_dead_logo.png.png",
            "siteUrl": "http://www.redordead.com/",
            "key": "red-or-dead"
        },
        "speedo": {
            "names": [
                "Speedo"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "clothing",
                "sports"
            ],
            "score": 39,
            "ownedBy": [
                "pentland-group"
            ],
            "updatedAt": "2026-02-28T10:57:02.677Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Speedo",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/90/Speedo_brand_logo.svg",
            "siteUrl": "https://www.speedo.com/",
            "key": "speedo"
        },
        "pentland-group": {
            "names": [
                "Pentland Group",
                "Pentland",
                "Pentland Group Limited"
            ],
            "comment": "Pentland Group is a British clothing conglomerate that has been repeatedly accused of anti‑competitive practices [1][2][3], mistreatment of employees and illegal working conditions [4][5][6], and failure to pay a living wage [7]. The company has also engaged in tax avoidance [8] and shown inaction on environmental and social responsibility [9].",
            "sources": {
                "1": "https://www.catribunal.org.uk/sites/cat/files/2021-07/1367_Pentland_Ruling_Costs_CAT_19_050721_1.pdf",
                "2": "https://www.bbc.co.uk/news/business-60373402",
                "3": "https://www.reuters.com/business/retail-consumer/jd-sports-fined-16-mln-by-uk-regulator-over-merchandise-pricing-2022-09-27/",
                "4": "https://www.channel4.com/news/ive-sacked-people-for-sitting-down-undercover-inside-jd-sports",
                "5": "https://www.cipd.org/uk/about/press-releases-archive/191216-jdsports-response/",
                "6": "https://www.burytimes.co.uk/news/23539405.jd-sports-forced-pay-14-000-unfair-dismissal/",
                "7": "https://labourbehindthelabel.org/tailoredwagesuk2019/",
                "8": "https://www.thetimes.com/article/billionaire-rubins-move-518m-offshore-fk58gcdvg",
                "9": "https://www.bbc.com/news/business-47057870"
            },
            "sourceNotes": {
                "1": "anti-competetive practices",
                "2": "anti-competetive practices",
                "3": "anti-competetive practices",
                "4": "mistreatment of employees",
                "5": "illegal working conditions",
                "6": "mistreatment of employees",
                "7": "failure to pay living wage",
                "8": "tax avoidance",
                "9": "inaction on environmental and social resposibility"
            },
            "tags": [
                "retail",
                "sports",
                "anticompetitive practices",
                "poor working conditions",
                "unsafe working conditions",
                "unfair pay",
                "tax avoidance",
                "unsustainable practices"
            ],
            "score": 35,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/b/b2/Pentland_logo.png",
            "siteUrl": "https://pentlandgroup.com/",
            "updatedAt": "2026-02-28T10:04:33.536Z",
            "key": "pentland-group"
        },
        "jersey-mike's": {
            "names": [
                "Jersey Mike's"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": null,
            "ownedBy": [
                "blackstone"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/91/Jersey_Mike%27s_logo.svg/120px-Jersey_Mike%27s_logo.svg.png",
            "siteUrl": "https://www.jerseymikes.com/",
            "updatedAt": "2026-02-28T11:01:17.914Z",
            "key": "jersey-mike's"
        },
        "jd-sports": {
            "names": [
                "JD Sports",
                "JD Sports Fashion plc",
                "JD Group"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "clothing",
                "sports"
            ],
            "score": 39,
            "ownedBy": [
                "pentland-group"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/d8/JD_Sports_logo.svg",
            "siteUrl": "http://jdplc.com/",
            "updatedAt": "2026-02-28T11:01:17.914Z",
            "key": "jd-sports"
        },
        "finish-line": {
            "names": [
                "Finish Line",
                "Finish Line, Inc.",
                "FINL"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "sports",
                "clothing"
            ],
            "score": 39,
            "ownedBy": [
                "pentland-group"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/77/Finish_Line%2C_Inc._logo.svg",
            "siteUrl": "http://finishline.com/",
            "updatedAt": "2026-02-28T13:59:49.776Z",
            "key": "finish-line"
        },
        "johnson-and-johnson": {
            "names": [
                "Johnson & Johnson",
                "J&J",
                "JNJ"
            ],
            "comment": "Johnson & Johnson is an American health company which sold asbestos‑containing baby powder leading to cancer and lung disease [1][2], conducted experiments on black prisoners [3][4], and sold a dangerous birth‑control patch that caused strokes, unwanted pregnancies, and deaths [5]. The company concealed the overdose risk of Tylenol leading to several deaths [6], sold fentanyl patches that killed more than fifty people [7][8], deployed a disinformation campaign to sell tranquilizer pills that disfigured  tens of thousands of children and killed elderly patients [9][10], sold a defective hip replacement that ruined over a thousand lives [13], targeted high‑risk individuals to encourage opioid addiction [14], and covered up research about the danger of its cancer therapy, leading to hundreds of thousands of deaths [11][12],  - all while bribing doctors to prescribe its products [15][16].",
            "sources": {
                "1": "https://newrepublic.com/article/194726/johnson-and-johnson-investigation-crimes-health-care-system",
                "2": "https://www.bbc.co.uk/news/articles/c797wv928g8o",
                "3": "https://newrepublic.com/article/194726/johnson-and-johnson-investigation-crimes-health-care-system",
                "4": "https://www.independent.co.uk/news/world/americas/johnson-and-johnson-talcum-racism-b2030530.html",
                "5": "https://newrepublic.com/article/194726/johnson-and-johnson-investigation-crimes-health-care-system",
                "6": "https://newrepublic.com/article/194726/johnson-and-johnson-investigation-crimes-health-care-system",
                "7": "https://newrepublic.com/article/194726/johnson-and-johnson-investigation-crimes-health-care-system",
                "8": "https://www.bmj.com/content/374/bmj.n1867",
                "9": "https://newrepublic.com/article/194726/johnson-and-johnson-investigation-crimes-health-care-system",
                "10": "https://www.justice.gov/usao-edpa/pr/johnson-johnson-pay-more-22-billion-resolve-fraud-and-misbranding-allegations",
                "11": "https://newrepublic.com/article/194726/johnson-and-johnson-investigation-crimes-health-care-system",
                "12": "https://www.statnews.com/2025/04/03/erythropoietin-epo-scandal-cancer-drug-johnson-and-johnson-no-more-tears-excerpt/",
                "13": "https://www.irishtimes.com/news/health/suspect-device-the-all-metal-hip-replacement-that-caused-untold-hardship-1.3708479",
                "14": "https://newrepublic.com/article/194726/johnson-and-johnson-investigation-crimes-health-care-system",
                "15": "https://newrepublic.com/article/194726/johnson-and-johnson-investigation-crimes-health-care-system",
                "16": "https://www.ft.com/content/368d1408-6222-11e0-8ee4-00144feab49a"
            },
            "sourceNotes": {
                "1": "sold and covered up sale of baby powder containing asbestos, leading to lung disease and cancer",
                "2": "sold and covered up sale of baby powder containing asbestos, leading to lung disease and cancer",
                "3": "experimented on black prisoners",
                "4": "experimented on black prisoners",
                "5": "sold a birth control patch that caused unwanted pregnancy, stroke, and death",
                "6": "covered up overdose risk of tylenol leading to several deaths",
                "7": "sold fentanyl patches that killed over 50 people",
                "8": "sold fentanyl patches that killed over 50 people",
                "9": "used a disinformation campaign to encouraged the overprescription of tranquilizer pills that disfigured thousands of children and led to deaths in elderly patients",
                "10": "used a disinformation campaign to encouraged the overprescription of tranquilizer pills that disfigured thousands of children and led to deaths in elderly patients",
                "11": "covered up research that its cancer treatment was deadly, leading to hundreds of thousands of deaths",
                "12": "covered up research that its cancer treatment was deadly, leading to hundreds of thousands of deaths",
                "13": "sold a dangerous hip replacement that ruined over 1000 patients lives",
                "14": "targeted high-risk inidividuals in the opioid crisis to encourage addiction",
                "15": "bribed doctors to prescribe their products",
                "16": "bribed doctors to prescribe their products"
            },
            "tags": [
                "health",
                "deception",
                "unsafe practices",
                "corruption",
                "racial discrimination"
            ],
            "score": 1,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/be/JNJ_Logo_New.svg",
            "siteUrl": "https://www.jnj.com/",
            "updatedAt": "2026-03-01T08:53:06.939Z",
            "key": "johnson-and-johnson"
        },
        "just-eat": {
            "names": [
                "Just Eat",
                "Just Eat Takeaway.com",
                "Takeaway.com",
                "Just Eat Takeaway.com N.V."
            ],
            "comment": "Just Eat is a UK-based online food‑ordering platform that has repeatedly violated employees' rights through automated firings [1][2] and reclassified workers to diminish protections [3]. It has also imposed fraudulent charges and refunds on small businesses [4][5][6], enabled scam listings [7], and pressured local shops, eroding their profits [8].",
            "sources": {
                "1": "https://www.business-humanrights.org/en/latest-news/just-beat-it-how-just-eat-robo-fires-its-workers/",
                "2": "https://www.workerinfoexchange.org/post/report-reveals-the-algorithmic-dismissal-of-workers-over-false-fraud-allegations-at-just-eat",
                "3": "https://www.hrmagazine.co.uk/content/news/just-eat-employees-forced-to-take-up-gig-economy-model",
                "4": "https://www.bbc.co.uk/news/articles/cz609qw4e30o",
                "5": "https://www.manchestereveningnews.co.uk/whats-on/its-like-blackmail-situation-takeaway-22855716",
                "6": "https://www.manchestereveningnews.co.uk/news/greater-manchester-news/takeaway-owners-speak-out-against-22050922",
                "7": "https://www.which.co.uk/news/article/which-finds-multiple-scam-listings-on-just-eat-a44GX9N8Mzyg",
                "8": "https://www.ft.com/content/0bd3a6a0-9d1c-11e7-8cd4-932067fbf946"
            },
            "sourceNotes": {
                "1": "violation of employees rights and automated firing",
                "2": "violation of employees rights and automated firing",
                "3": "reclassified workers leading to reduction in rights and protections",
                "4": "placed fraudulent charges and refunds to small businesses",
                "5": "placed fraudulent charges and refunds to small businesses",
                "6": "placed fraudulent charges and refunds to small businesses",
                "7": "enabled scam listings",
                "8": "put pressure on small local businesses b reducing their profits"
            },
            "tags": [
                "food",
                "tech",
                "deception"
            ],
            "score": 44,
            "ownedBy": [
                "prosus"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/4/46/Just_Eat_orange_logo.svg",
            "siteUrl": "http://just-eat.co.uk/",
            "updatedAt": "2026-03-02T15:18:24.582Z",
            "key": "just-eat"
        },
        "kitchenaid": {
            "names": [
                "KitchenAid"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "electronics"
            ],
            "score": 8,
            "ownedBy": [
                "whirlpool-corporation"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/c6/Kitchenaid_logo.svg",
            "siteUrl": "http://www.kitchenaid.com/",
            "updatedAt": "2026-03-06T08:52:09.636Z",
            "key": "kitchenaid"
        },
        "whirlpool-corporation": {
            "names": [
                "Whirlpool Corporation",
                "Whirlpool",
                "WHR"
            ],
            "comment": "Whirlpool Corporation is an American appliance manufacturer that has defrauded thousands of customers [1], sold defective fridges [2], and released toxic carcinogenic pollution around its plant and in nearby groundwater [3][4]. It's appliances have caused hundreds of fires, killed at least two people [5][6][7][8], posed fire and safety risks [9], and led to the Grenfell Tower fire that killed 72 people [10][11].",
            "sources": {
                "1": "https://www.beasleyallen.com/article/whirlpool-581m-alabama-consumer-fraud-verdict/",
                "2": "https://topclassactions.com/lawsuit-settlements/lawsuit-news/whirlpool-class-action-lawsuit-and-settlement-news/whirlpool-class-action-alleges-several-refrigerator-brands-house-defective-wires/",
                "3": "https://talkbusiness.net/2020/02/cleanup-of-dangerous-chemical-continues-near-former-whirlpool-plant/",
                "4": "https://eu.swtimes.com/story/news/2016/02/22/whirlpool-releases-report-on-fort/26321222007/",
                "5": "https://www.theguardian.com/uk-news/2017/nov/24/whirlpool-named-worst-offender-for-white-goods-fires-in-london",
                "6": "https://www.theguardian.com/money/2016/sep/24/killer-tumble-dryer-faulty-whirlpool-machine-product-safety-scandal",
                "7": "https://www.which.co.uk/news/2019/12/whirlpool-announces-recall-of-up-to-519000-indesit-and-hotpoint-fire-risk-washing-machines-in-the-uk/",
                "8": "https://inews.co.uk/news/consumer/whirlpool-tumble-dryer-fire-product-recall-312802",
                "9": "https://www.cpsc.gov/Newsroom/News-Releases/2023/Whirlpool-Agrees-to-Pay-11-5-Million-Civil-Penalty-for-Failure-to-Immediately-Report-Glass-Cooktops-Posing-Burn-and-Fire-Hazards",
                "10": "https://www.ft.com/content/11c35448-2eb9-4c6a-9a56-f31a5fd18525",
                "11": "https://www.theguardian.com/uk-news/2025/apr/27/grenfell-fire-fridge-maker-accused-of-safety-test-failings-in-council-lawsuit"
            },
            "sourceNotes": {
                "1": "defrauded thousands of customers",
                "2": "sold defective fridges",
                "3": "toxic carcinogenic pollution around manufacturing plant",
                "4": "toxic carcinogenic pollution in groundwater around manufacturing plant",
                "5": "sold appliances that caused hundreds of fires and killed at least 2 people",
                "6": "sold appliances that caused hundreds of fires and killed at least 2 people",
                "7": "sold appliances that caused hundreds of fires and killed at least 2 people",
                "8": "sold appliances that caused hundreds of fires and killed at least 2 people",
                "9": "sold defective cookers that posed a fire and safety risk",
                "10": "sold defective fridges that led to the fire in Grenfell Tower killing 72 people",
                "11": "sold defective fridges that led to the fire in Grenfell Tower killing 72 people"
            },
            "tags": [
                "electronics",
                "deception",
                "environmental violations",
                "unsafe practices",
                "unsustainable practices"
            ],
            "score": 8,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/95/Whirlpool_Corporation_Logo_%28as_of_2017%29.svg",
            "siteUrl": "http://whirlpool.com/",
            "updatedAt": "2026-03-06T08:52:09.636Z",
            "key": "whirlpool-corporation"
        },
        "amana": {
            "names": [
                "Amana"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "electronics"
            ],
            "score": 8,
            "ownedBy": [
                "whirlpool-corporation"
            ],
            "updatedAt": "2026-03-06T11:22:47.336Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Amana_Corporation",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/3c/Amana_Corporation_logo.svg",
            "siteUrl": "http://amana.com/",
            "key": "amana"
        },
        "brastemp": {
            "names": [
                "Brastemp"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "electronics"
            ],
            "score": 8,
            "ownedBy": [
                "whirlpool-corporation"
            ],
            "updatedAt": "2026-03-06T11:22:48.094Z",
            "wikipediaUrl": "https://pt.wikipedia.org/wiki/Brastemp",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/14/Brastemp.svg",
            "siteUrl": "http://www.brastemp.com.br/",
            "key": "brastemp"
        },
        "inglis": {
            "names": [
                "Inglis"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "electronics"
            ],
            "score": 8,
            "ownedBy": [
                "whirlpool-corporation"
            ],
            "updatedAt": "2026-03-06T11:22:48.182Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/John_Inglis_and_Company",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/a/a4/Inglis_Appliances_Logo.svg",
            "siteUrl": "http://www.inglis.ca/",
            "key": "inglis"
        },
        "insinkerator": {
            "names": [
                "InSinkErator"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "electronics"
            ],
            "score": 8,
            "ownedBy": [
                "whirlpool-corporation"
            ],
            "updatedAt": "2026-03-06T11:22:48.252Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/InSinkErator",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/44/Insinkerator_logo.svg",
            "siteUrl": "http://www.insinkerator.com/",
            "key": "insinkerator"
        },
        "jenn-air": {
            "names": [
                "Jenn-Air"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "electronics"
            ],
            "score": 8,
            "ownedBy": [
                "whirlpool-corporation"
            ],
            "updatedAt": "2026-03-06T11:22:48.650Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Jenn-Air",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/8e/JennAir_logo.svg",
            "siteUrl": "https://www.jennair.com/",
            "key": "jenn-air"
        },
        "laden": {
            "names": [
                "Laden"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "electronics"
            ],
            "score": 8,
            "ownedBy": [
                "whirlpool-corporation"
            ],
            "updatedAt": "2026-03-06T11:22:49.151Z",
            "wikipediaUrl": "https://fr.wikipedia.org/wiki/Laden_(marque)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/fr/1/10/Laden-logo.png",
            "siteUrl": "http://www.laden.fr/",
            "key": "laden"
        },
        "maytag": {
            "names": [
                "Maytag"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "electronics"
            ],
            "score": 8,
            "ownedBy": [
                "whirlpool-corporation"
            ],
            "updatedAt": "2026-03-06T11:22:49.239Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Maytag",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/4/46/Maytag_logo_2015.png",
            "siteUrl": "http://www.maytag.com/",
            "key": "maytag"
        },
        "royalstar": {
            "names": [
                "Royalstar"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "electronics"
            ],
            "score": 8,
            "ownedBy": [
                "whirlpool-corporation"
            ],
            "updatedAt": "2026-03-06T11:22:49.847Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Royalstar",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/Royalstar_red.png/120px-Royalstar_red.png.png",
            "siteUrl": "http://www.rsdgroup.com.cn/en/",
            "key": "royalstar"
        },
        "indesit": {
            "names": [
                "Indesit"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "electronics"
            ],
            "score": 8,
            "ownedBy": [
                "whirlpool-corporation"
            ],
            "updatedAt": "2026-03-06T11:22:49.890Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Indesit",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/63/IndesitCo_logo_%282005%29.png/120px-IndesitCo_logo_%282005%29.png.png",
            "siteUrl": "http://www.indesit.com/",
            "key": "indesit"
        },
        "hotpoint": {
            "names": [
                "Hotpoint"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "electronics"
            ],
            "score": 8,
            "ownedBy": [
                "whirlpool-corporation"
            ],
            "updatedAt": "2026-03-06T11:22:49.947Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Hotpoint",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/f/f4/Logo_hotpoint.png",
            "siteUrl": "http://hotpoint.com/",
            "key": "hotpoint"
        },
        "yummly": {
            "names": [
                "Yummly"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "electronics"
            ],
            "score": 8,
            "ownedBy": [
                "whirlpool-corporation"
            ],
            "updatedAt": "2026-03-06T11:22:50.012Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Yummly",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/Yummly-Logo-2019.png/120px-Yummly-Logo-2019.png.png",
            "siteUrl": "https://yummly.com/",
            "key": "yummly"
        },
        "kohl's": {
            "names": [
                "Kohl's",
                "Kohl's Corporation",
                "KSS"
            ],
            "comment": "Kohls is an American retailer that has been accused of misleading customers [1][2] and deceptive pricing [3][4]. The company has also faced criticism for underpaying its employees [5][6].",
            "sources": {
                "1": "https://www.justice.gov/archives/opa/pr/kohl-s-and-walmart-agree-pay-55-million-combined-penalties-alleged-deceptive-violations",
                "2": "https://www.law360.com/classaction/articles/1138249/kohl-s-customers-seek-ok-on-1-8m-credit-monitoring-deal",
                "3": "https://www.co.fresno.ca.us/Home/ShowDocument?id=10364",
                "4": "https://www.law360.com/articles/783451/kohl-s-wins-early-approval-of-6-15m-deceptive-sales-deal",
                "5": "https://www.law360.com/articles/1346889/kohl-s-workers-land-2-9m-deal-to-end-overtime-claims",
                "6": "https://www.law360.com/articles/743824/kohl-s-4m-manager-ot-settlement-gets-final-approval"
            },
            "sourceNotes": {
                "1": "misleading customers",
                "2": "misleading customers",
                "3": "deceptive pricing",
                "4": "deceptive pricing",
                "5": "underpaid employees",
                "6": "underpaid employees"
            },
            "tags": [
                "retail",
                "deception",
                "unfair pay"
            ],
            "score": 43,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/60/Kohl%27s_logo.svg",
            "siteUrl": "https://www.kohls.com/",
            "updatedAt": "2026-03-07T08:47:15.989Z",
            "key": "kohl's"
        },
        "kong": {
            "names": [
                "Kong"
            ],
            "comment": "Kong is an American pet toy company whose operations have resulted in environmental violations [1][2] and whose products have been linked to the death of pets due to unsafe design [3][4].",
            "sources": {
                "1": "https://www.business-live.co.uk/retail-consumer/dog-toy-company-kong-forced-19151872",
                "2": "https://web.archive.org/web/20210608153410/https://www.360environmental.co.uk/documents/Enforcement%20Undertakings%20accepted%20by%20the%20Environment%20Agency%20160620%20-%20GOV.UK.pdf",
                "3": "https://www.thedodo.com/dog-dies-chew-toy-1316361321.html",
                "4": "https://www.cornwalllive.com/news/uk-world-news/dog-died-park-owner-tried-9307348"
            },
            "sourceNotes": {
                "1": "environmental violation",
                "2": "environmental violation",
                "3": "sold unsafe toys leading to pet death",
                "4": "sold unsafe toys leading to pet death"
            },
            "tags": [
                "pets",
                "environmental violations",
                "unsafe practices"
            ],
            "score": 35,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/b/bc/Kong_Company_Logo.png/250px-Kong_Company_Logo.png",
            "siteUrl": "https://www.kongcompany.com/",
            "updatedAt": "2026-03-08T11:59:15.908Z",
            "key": "kong"
        },
        "kroger": {
            "names": [
                "Kroger",
                "The Kroger Co.",
                "The Kroger Company",
                "KR"
            ],
            "comment": "Kroger is an American supermarket chain that has sold plates containing toxic chemicals [1], consistently underpaid employees [2][3], closed stores instead of providing COVID hazard pay [4], and created psychologically unsafe working conditions leading to employee suicide [5]. The company has also been linked to child labor violations [6][7], profited from forced monkey labor [8][9], and discriminated against black employees and shoppers, contributing to wrongful arrests [10][11].",
            "sources": {
                "1": "https://topclassactions.com/lawsuit-settlements/consumer-products/household/kroger-class-action-says-disposable-plates-contain-toxic-materials/",
                "2": "https://www.fox19.com/2025/12/16/kroger-sued-cheating-overtime-retails-dirty-little-secret/",
                "3": "https://www.supermarketnews.com/retail-labor/kroger-has-faced-more-than-20-wage-left-lawsuits-since-2020",
                "4": "https://www.vice.com/en/article/why-is-kroger-closing-stores-instead-of-paying-hazard-wages-for-its-employees/",
                "5": "https://www.wcpo.com/news/local-news/hamilton-county/cincinnati/lawsuit-kroger-manager-drove-employee-to-suicide",
                "6": "https://www.business-humanrights.org/en/latest-news/usa-executive-poultry-employed-children-to-operate-dangerous-machinery-held-back-wages-retaliated-against-co-operative-workers-says-labor-agency/",
                "7": "https://www.kansascity.com/news/nation-world/national/article261521867.html",
                "8": "https://www.citybeat.com/food-drink/kroger-finally-stops-selling-coconut-milk-obtained-via-monkey-labor-after-repeated-peta-requests-12266714/",
                "9": "https://www.fox19.com/2020/11/19/coconuts-dumped-outside-kroger-headquarters-peta-protests-forced-monkey-labor/",
                "10": "https://www.just-food.com/news/us-kroger-settles-racial-discrimination-lawsuit/?cf-view",
                "11": "https://news.bloomberglaw.com/daily-labor-report/kroger-black-shopper-settle-racial-profiling-suit-before-trial"
            },
            "sourceNotes": {
                "1": "sold plates containing toxic checmicals",
                "2": "underpaid employees",
                "3": "consistently underpaid employees",
                "4": "closed stores rather than paying employees covid hazard pay",
                "5": "created psychologically unsafe working conditions leading to employee suicide",
                "6": "connected to child labour",
                "7": "overworked child employees, violated child labour laws",
                "8": "profited from forced monkey labour",
                "9": "profited from forced monkey labour",
                "10": "discriminated against black employees",
                "11": "discriminated against and racially profiled black shoppers leading to wrongful arrest"
            },
            "tags": [
                "retail",
                "supermarket",
                "unsafe practices",
                "unsafe working conditions",
                "unfair pay",
                "child labour",
                "forced labour",
                "racial discrimination",
                "environmental violations"
            ],
            "score": 12,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/1/1c/Kroger_%282021%29_logo.svg",
            "siteUrl": "https://thekrogerco.com/",
            "updatedAt": "2026-03-09T20:12:43.681Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Kroger",
            "key": "kroger"
        },
        "dillons": {
            "names": [
                "Dillons"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "supermarket"
            ],
            "score": 12,
            "ownedBy": [
                "kroger"
            ],
            "updatedAt": "2026-03-10T16:15:08.151Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Dillons",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/40/Dillons_logo.svg",
            "siteUrl": "https://www.dillons.com/",
            "key": "dillons"
        },
        "baker's": {
            "names": [
                "Baker's"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "supermarket"
            ],
            "score": 12,
            "ownedBy": [
                "kroger"
            ],
            "updatedAt": "2026-03-10T16:15:08.407Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Baker%27s_Supermarkets",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/78/Baker%27s_Supermarkets_logo.svg",
            "siteUrl": "https://bakersplus.com/",
            "key": "baker's"
        },
        "gerbes": {
            "names": [
                "Gerbes"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "supermarket"
            ],
            "score": 12,
            "ownedBy": [
                "kroger"
            ],
            "updatedAt": "2026-03-10T16:15:08.497Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Gerbes",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/40/Dillons_logo.svg",
            "siteUrl": "https://www.dillons.com/",
            "key": "gerbes"
        },
        "food-4-less": {
            "names": [
                "Food 4 Less"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "supermarket"
            ],
            "score": 12,
            "ownedBy": [
                "kroger"
            ],
            "updatedAt": "2026-03-10T16:15:09.850Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Food_4_Less",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/75/Food4Less_logo.svg",
            "siteUrl": "http://www.food4less.com/",
            "key": "food-4-less"
        },
        "fred-meyer": {
            "names": [
                "Fred Meyer"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "supermarket"
            ],
            "score": 12,
            "ownedBy": [
                "kroger"
            ],
            "updatedAt": "2026-03-10T16:15:10.066Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Fred_Meyer",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/7e/Fred_Meyer_Logo_%282021%29.svg",
            "siteUrl": "http://www.fredmeyer.com/",
            "key": "fred-meyer"
        },
        "fred-meyer-jewelers": {
            "names": [
                "Fred Meyer Jewelers"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "supermarket"
            ],
            "score": 12,
            "ownedBy": [
                "kroger"
            ],
            "updatedAt": "2026-03-10T16:15:10.786Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Fred_Meyer_Jewelers",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/8d/Fred_Meyer_Jewelers_logo.svg",
            "siteUrl": "http://www.fredmeyerjewelers.com/",
            "key": "fred-meyer-jewelers"
        },
        "fry's": {
            "names": [
                "Fry's"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "supermarket"
            ],
            "score": 12,
            "ownedBy": [
                "kroger"
            ],
            "updatedAt": "2026-03-10T16:15:10.955Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Fry%27s_Food_and_Drug",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/1b/Fry%27s_Logo.svg",
            "siteUrl": "http://www.frysfood.com/",
            "key": "fry's"
        },
        "harris-teeter": {
            "names": [
                "Harris Teeter"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "supermarket"
            ],
            "score": 12,
            "ownedBy": [
                "kroger"
            ],
            "updatedAt": "2026-03-10T16:15:11.109Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Harris_Teeter",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/7/7d/Harris_Teeter_logo_%282023%29.svg",
            "siteUrl": "https://www.harristeeter.com/",
            "key": "harris-teeter"
        },
        "home-chef": {
            "names": [
                "Home Chef"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "supermarket"
            ],
            "score": 12,
            "ownedBy": [
                "kroger"
            ],
            "updatedAt": "2026-03-10T16:15:11.214Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Home_Chef",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/5/56/Home_Chef_logo.svg",
            "siteUrl": "http://www.homechef.com/",
            "key": "home-chef"
        },
        "king-soopers": {
            "names": [
                "King Soopers"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "supermarket"
            ],
            "score": 12,
            "ownedBy": [
                "kroger"
            ],
            "updatedAt": "2026-03-10T16:15:11.298Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/King_Soopers",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/ca/King_Soopers_logo.svg",
            "siteUrl": "http://kingsoopers.com/",
            "key": "king-soopers"
        },
        "city-market": {
            "names": [
                "City Market"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "supermarket"
            ],
            "score": 12,
            "ownedBy": [
                "kroger"
            ],
            "updatedAt": "2026-03-10T16:15:11.528Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/City_Market_(US_grocery_store_chain)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/1b/City_Market_logo.svg",
            "siteUrl": "http://www.kingsoopers.com/",
            "key": "city-market"
        },
        "pay-less": {
            "names": [
                "Pay Less"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "supermarket"
            ],
            "score": 12,
            "ownedBy": [
                "kroger"
            ],
            "updatedAt": "2026-03-10T16:15:12.944Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Pay_Less_Super_Markets",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/32/Payless-footer-logo--payless_web_header.svg",
            "siteUrl": "https://www.pay-less.com/",
            "key": "pay-less"
        },
        "mariano's": {
            "names": [
                "Mariano's"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "supermarket"
            ],
            "score": 12,
            "ownedBy": [
                "kroger"
            ],
            "updatedAt": "2026-03-10T16:15:13.414Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Mariano%27s",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/9/92/Mariano%27s_logo.svg",
            "siteUrl": "http://marianos.com/",
            "key": "mariano's"
        },
        "qfc": {
            "names": [
                "QFC"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "supermarket"
            ],
            "score": 12,
            "ownedBy": [
                "kroger"
            ],
            "updatedAt": "2026-03-10T16:15:13.588Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/QFC",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/5/5e/Quality_Food_Centers_%28logo%29.svg",
            "siteUrl": "http://www.qfc.com/",
            "key": "qfc"
        },
        "ralphs": {
            "names": [
                "Ralphs"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "supermarket"
            ],
            "score": 12,
            "ownedBy": [
                "kroger"
            ],
            "updatedAt": "2026-03-10T16:15:13.784Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Ralphs",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/96/Ralphs.svg",
            "siteUrl": "http://www.ralphs.com/",
            "key": "ralphs"
        },
        "roundy's": {
            "names": [
                "Roundy's"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "supermarket"
            ],
            "score": 12,
            "ownedBy": [
                "kroger"
            ],
            "updatedAt": "2026-03-10T16:15:13.892Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Roundy%27s",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/c/c8/Roundy%27s_logo.svg",
            "siteUrl": "https://www.roundys.com/",
            "key": "roundy's"
        },
        "jayc": {
            "names": [
                "JayC"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "supermarket"
            ],
            "score": 12,
            "ownedBy": [
                "kroger"
            ],
            "updatedAt": "2026-03-10T16:15:14.393Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/JayC_Food_Stores",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/de/JayC_Food_Stores_logo.svg",
            "siteUrl": "http://www.jaycfoods.com/",
            "key": "jayc"
        },
        "ruler-foods": {
            "names": [
                "Ruler Foods"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "supermarket"
            ],
            "score": 12,
            "ownedBy": [
                "kroger"
            ],
            "updatedAt": "2026-03-10T16:15:14.594Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Ruler_Foods",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/de/JayC_Food_Stores_logo.svg",
            "siteUrl": "http://www.jaycfoods.com/",
            "key": "ruler-foods"
        },
        "smith's": {
            "names": [
                "Smith's"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "supermarket"
            ],
            "score": 12,
            "ownedBy": [
                "kroger"
            ],
            "updatedAt": "2026-03-10T16:15:14.680Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Smith%27s_Food_and_Drug",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/d/da/Smith%27s_logo.svg",
            "siteUrl": "https://www.smithsfoodanddrug.com/",
            "key": "smith's"
        },
        "vitacost": {
            "names": [
                "Vitacost"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "supermarket"
            ],
            "score": 12,
            "ownedBy": [
                "kroger"
            ],
            "updatedAt": "2026-03-10T16:15:14.887Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Vitacost",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/a/ae/Vitacost_logo.svg",
            "siteUrl": "http://www.vitacost.com/",
            "key": "vitacost"
        },
        "l'occitane": {
            "names": [
                "L'Occitane",
                "L'Occitane en Provence",
                "Groupe L'Occitane"
            ],
            "comment": "L'Occitane is a French cosmetics company that has faced accusations of false advertising [1][2][3], greenwashing [4], and underfilling its products' packaging. L'Occitane initially continued operations in Russia during the war [5] and has also been implicated in child labour within its supply chain [6].",
            "sources": {
                "1": "https://edition.cnn.com/2014/01/08/health/weight-loss-companies-fraud",
                "2": "https://www.leparisien.fr/economie/publicite-l-occitane-condamnee-a-450-000-dollars-d-amende-aux-etats-unis-09-04-2014-3754843.php",
                "3": "https://www.ftc.gov/legal-library/browse/cases-proceedings/122-3115-loccitane-inc-matter",
                "4": "https://www.classaction.org/news/loccitane-lotion-containers-are-more-than-half-empty-class-action-says",
                "5": "https://theindustry.beauty/beauty-brands-exposed-for-misleading-and-mendacious-packaging-claims/",
                "6": "https://www.bbc.co.uk/news/business-61096823",
                "7": "https://www.franceinfo.fr/economie/emploi/metiers/video-cash-investigation-revele-quunicef-france-a-signe-un-partenariat-avec-loccitane-dont-lun-des-fournisseurs-fait-travailler-des-enfants_5423191.html"
            },
            "sourceNotes": {
                "1": "false advertising",
                "2": "false advertising",
                "3": "false advertising",
                "4": "underfilling products",
                "5": "greenwashing",
                "6": "initially continued to operate in russia during war",
                "7": "child labour in supply chain"
            },
            "tags": [
                "consumer goods",
                "deception",
                "greenwashing",
                "child labour",
                "connections to russia"
            ],
            "score": 30,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/a6/Groupe_l_occitane_logo.png/250px-Groupe_l_occitane_logo.png",
            "siteUrl": "https://group.loccitane.com/",
            "updatedAt": "2026-03-12T19:37:06.316Z",
            "key": "l'occitane"
        },
        "melvita": {
            "names": [
                "Melvita"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 30,
            "ownedBy": [
                "l'occitane"
            ],
            "updatedAt": "2026-03-12T20:04:22.022Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Melvita",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/d1/Melvita_logo.jpg",
            "siteUrl": "http://www.melvita.com/",
            "key": "melvita"
        },
        "sol-de-janeiro": {
            "names": [
                "Sol de Janeiro"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 30,
            "ownedBy": [
                "l'occitane"
            ],
            "updatedAt": "2026-03-12T20:04:22.398Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Sol_de_Janeiro",
            "siteUrl": "http://soldejaneiro.com/",
            "key": "sol-de-janeiro"
        },
        "krups": {
            "names": [
                "Krups"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 30,
            "ownedBy": [
                "groupe-seb"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/57/Krups_Logo.svg",
            "siteUrl": "https://www.krups.com/",
            "updatedAt": "2026-03-11T17:21:20.040Z",
            "key": "krups"
        },
        "lands'-end": {
            "names": [
                "Lands' End",
                "Lands End"
            ],
            "comment": "Lands End is an American apparel retailer that has a record of customer privacy violations [1], false advertising [2][3], ending collaboration with feminist activists [4][5], and manufacturing toxic uniforms [6].",
            "sources": {
                "1": "https://www.classaction.org/news/lands-end-hit-with-class-action-lawsuit-over-alleged-use-of-tracking-tech-in-marketing-emails",
                "2": "https://topclassactions.com/lawsuit-settlements/lawsuit-news/lands-end-sued-for-alleged-fake-discounts-and-misleading-marketing/",
                "3": "https://truthinadvertising.org/class-action/lands-end/",
                "4": "https://www.nytimes.com/2016/03/01/business/catalog-interview-with-gloria-steinem-has-lands-end-on-its-heels.html",
                "5": "https://www.businessinsider.com/lands-end-removes-gloria-steinem-interview-2016-2",
                "6": "https://news.bloomberglaw.com/litigation/delta-workers-toxic-lands-end-uniform-claims-meet-wary-court"
            },
            "sourceNotes": {
                "1": "customer privacy violation",
                "2": "false advertising and misleading customers",
                "3": "false advertising and misleading customers",
                "4": "ended collaboration with feminist activist",
                "5": "ended collaboration with feminist activist",
                "6": "manufactured toxic uniforms"
            },
            "tags": [
                "clothing",
                "retail",
                "deception",
                "privacy violations",
                "unsafe practices"
            ],
            "score": 45,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/a/aa/Lands%27_End_2018.svg",
            "siteUrl": "https://landsend.com/",
            "updatedAt": "2026-03-14T08:36:12.211Z",
            "key": "lands'-end"
        },
        "lavazza": {
            "names": [
                "Lavazza",
                "Luigi Lavazza S.p.A.",
                "Luigi Lavazza"
            ],
            "comment": "Lavazza is an Italian coffee company that has been accused of misleading advertising [1], selling contaminated coffee [2], and filing false intellectual‑property claims against online retailers [3]. The company relies primarily on non‑fair‑trade suppliers [4], opposes anti‑deforestation legislation [5] and pro‑Palestine statements [6], and has ties to human‑rights abuses in its supply chain [7][8].",
            "sources": {
                "1": "https://news.sky.com/story/lavazza-and-dualit-adverts-banned-after-making-misleading-compostable-claim-13358504",
                "2": "https://www.businessonline.it/news/nuovi-dettagli-su-lavazza-e-il-caff-contaminato-rivelato-da-report-cerchiamo-di-fare-chiarezza_n76391.html",
                "3": "https://www.law.com/njlawjournal/2019/11/12/online-reseller-accuses-lavazza-coffee-of-bringing-phony-ip-infringement-claims/?slreturn=20260315045057",
                "4": "https://www.lavazzagroup.com/content/dam/lavazza/lavazza-corporate/come-lavoriamo/BilancioSostenibile2020_ENG_def.pdf",
                "5": "https://sprudge.com/lavazza-pushes-back-on-eu-deforestation-law-it-voluntarily-agreed-to-212541.html",
                "6": "https://www.skysports.com/football/news/11095/12307323/arsenal-speak-to-mohamed-elneny-over-wider-implications-of-pro-palestinian-social-media-post-amid-sponsor-concern",
                "7": "https://coffeewatch.org/coffee-and-human-rights-abuses/",
                "8": "https://reporterbrasil.org.br/2022/05/multinational-coffee-companies-ignore-accusations-and-continue-buying-from-suppliers-linked-to-farms-with-slave-labour/"
            },
            "sourceNotes": {
                "1": "misleading advertising",
                "2": "sold contaminated coffee",
                "3": "filed false IP claims against online retailers",
                "4": "uses mostly non-fairtrade suppliers",
                "5": "opposed anti-deforestation law",
                "6": "opposed pro-palestine statements",
                "7": "connected to human rights abuses in supply chain",
                "8": "connected to human rights abuses in supply chain"
            },
            "tags": [
                "coffee",
                "beverages",
                "deception",
                "deforestation",
                "forced labour",
                "unsafe practices",
                "environmental violations"
            ],
            "score": 15,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/04/Lavazza_-_logo_%28Italy%2C_1995%29.svg",
            "siteUrl": "http://lavazza.com/",
            "updatedAt": "2026-03-15T08:44:55.205Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Lavazza",
            "key": "lavazza"
        },
        "le-creuset": {
            "names": [
                "Le Creuset"
            ],
            "comment": "Le Creuset is a French-Belgian cookware manufacturer that has sold pans containing potentially toxic chemicals [1].",
            "sources": {
                "1": "https://uk.news.yahoo.com/m-fed-living-fear-m-113813957.html"
            },
            "sourceNotes": {
                "1": "sold pans containing potentially toxic checmicals"
            },
            "tags": [
                "retail",
                "unsafe practices",
                "environmental violations"
            ],
            "score": 49,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/c5/Le_Creuset_Logo.png",
            "siteUrl": "https://www.lecreuset.com/",
            "updatedAt": "2026-03-16T08:23:17.217Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Le_Creuset",
            "key": "le-creuset"
        },
        "le-pain-quotidien": {
            "names": [
                "Le Pain Quotidien"
            ],
            "comment": "",
            "sources": {
                "1": "https://www.nrn.com/fast-casual/u-s-arm-of-le-pain-quotidien-files-bankruptcy-agrees-to-sell-units-to-aurify-brands-llc"
            },
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": null,
            "ownedBy": [
                "m80",
                "aurify"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/3/30/Le_Pain_Quotidien_logo.png",
            "siteUrl": "https://www.lepainquotidien.com/",
            "updatedAt": "2026-03-17T14:55:51.026Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Le_Pain_Quotidien",
            "key": "le-pain-quotidien"
        },
        "leroy-merlin": {
            "names": [
                "Leroy Merlin"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "ownedBy": [
                "association-familiale-mulliez"
            ],
            "score": null,
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/a4/Leroy_Merlin_-_logo_%28France%2C_1995-%29.svg",
            "siteUrl": "http://www.leroymerlin.com/",
            "updatedAt": "2026-03-18T08:07:23.677Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Leroy_Merlin",
            "key": "leroy-merlin"
        },
        "levi-strauss-and-co.": {
            "names": [
                "Levi Strauss & Co.",
                "Levi's",
                "Levi Strauss",
                "LEVI"
            ],
            "comment": "Levi Strauss & Co. is an American apparel company that has used AI-generated imagery in product advertising, reportedly replacing diverse models [1][2], and has been accused of age-based discrimination against employees [3]. The company has also refused to sign a workers rights agreement and to offer employees a living wage [4][5], while reports highlight forced labor and sexual abuse in its supply chain [6][7][8][9].",
            "sources": {
                "1": "https://www.yahoo.com/lifestyle/levis-faces-backlash-after-announcing-it-will-use-ai-to-increase-the-number-and-diversity-of-models-unethical-on-so-many-levels-193304111.html",
                "2": "https://www.nbcnews.com/business/business-news/ai-models-levis-controversy-backlash-rcna77280",
                "3": "https://simplywall.st/stocks/us/consumer-durables/nyse-levi/levi-strauss/news/levi-strauss-lawsuit-tests-culture-governance-and-human-capi",
                "4": "https://www.peoplesworld.org/article/no-justice-no-jeans-unions-fight-for-levis-workers-around-the-world/",
                "5": "https://www.business-humanrights.org/en/latest-news/levis-suspended-by-ethical-group-in-living-wage-row/",
                "6": "https://www.business-humanrights.org/en/latest-news/us-apparel-cos-lawsuit-re-saipan/",
                "7": "https://core-ombuds.canada.ca/core_ombuds-ocre_ombuds/press-release-levi-strauss-communique.aspx?lang=eng",
                "8": "https://fizzymag.com/articles/us-apparel-brands-caught-up-in-sexual-abuse-scandal-of-garment-workers-in-lesotho",
                "9": "https://www.cbsnews.com/news/levis-wrangler-jeans-factories-lesotho-south-africa-sexual-harassment-abuse-violence-report/"
            },
            "sourceNotes": {
                "1": "using AI generated imagery in product advertising to replace diverse models",
                "2": "using AI generated imagery in product advertising",
                "3": "age-based discriminated against employees",
                "4": "refused to sign workers rights agreement",
                "5": "refused to offer employees a living wage",
                "6": "forced labour in supply chain",
                "7": "forced labour in supply chain",
                "8": "sexual abuse in supply chain",
                "9": "sexual abuse in supply chain"
            },
            "tags": [
                "clothing",
                "retail",
                "forced labour",
                "sexual harassment",
                "unfair pay",
                "anti-union practices",
                "deception"
            ],
            "score": 19,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/09/Levis-logo-quer.svg",
            "siteUrl": "https://www.levistrauss.com/",
            "updatedAt": "2026-03-19T08:17:03.826Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Levi_Strauss_%26_Co.",
            "key": "levi-strauss-and-co."
        },
        "liberty-mutual": {
            "names": [
                "Liberty Mutual",
                "Liberty Mutual Insurance Company",
                "Liberty Mutual Group",
                "Liberty Mutual Insurance"
            ],
            "comment": "Liberty Mutual is an American insurance company that has mishandled customer complaints [1][2], misled customers [3], manipulated insurance markets to overcharge customers [4], bribed government officials in India to secure new business [5], and violated insurance laws [6]. The company has also underpaid employees [7][8] while paying excessive executive compensation and supplying private jets [9][10][11][12].",
            "sources": {
                "1": "https://www.simmons-simmons.com/en/publications/ck0agd58pnbu00b339yyienuc/171218-fca-fines-liberty-mutual-insurance",
                "2": "https://www.fca.org.uk/news/press-releases/liberty-mutual-insurance-europe-se-fined",
                "3": "https://news.delaware.gov/2025/04/14/liberty-mutual-pays-300000-penalty-for-misleading-consumers/",
                "4": "https://www.insurancejournal.com/magazines/mag-features/2011/01/10/185650.htm",
                "5": "https://www.justice.gov/criminal/media/1410761/dl?inline",
                "6": "https://www.cbsnews.com/minnesota/news/liberty-mutual-agrees-to-pay-over-7m-to-policyholders-in-consent-order-with-the-mn-dept-of-commerce/",
                "7": "http://www.leagle.com/xmlresult.aspx?xmldoc=In%20FDCO%2020120927799.xml&docbase=CsLwAr3-2007-Curr",
                "8": "https://web.archive.org/web/20170929135402/http://www.businessinsurance.com/article/20120101/NEWS08/301019991",
                "9": "https://web.archive.org/web/20150427143114/http://www.bostonglobe.com/metro/2012/05/01/liberty-mutual-accounting-for-executive-privileges/sSVU5HithurylpBKJlcxxM/story.html",
                "10": "https://web.archive.org/web/20170430165808/http://www.bostonglobe.com/metro/2012/05/22/deval-patrick-liberty-mutual-the-benefits-friendship/6RkpCKxitx4Xih0Dg2D3dN/story.html",
                "11": "https://web.archive.org/web/20150712074626/http://www.bostonglobe.com/metro/2012/04/24/brian-mcgrory-there-more-lots-more-liberty-mutual-compensation-story/hbzbaX4WfCZG6BypJf8uRK/story.html",
                "12": "https://web.archive.org/web/20150712173019/http://www.boston.com/news/local/massachusetts/articles/2012/05/02/at_liberty_mutual_no_accounting_for_executive_privileges/"
            },
            "sourceNotes": {
                "1": "mishandled customer complaints",
                "2": "mishandled customer complaints",
                "3": "misled customers",
                "4": "manipulated insurance markets to overcharge customers",
                "5": "bribed government officials in india to get new business",
                "6": "violated insurance laws",
                "7": "underpaid employees",
                "8": "underpaid employees",
                "9": "excessive executive pay and private jets",
                "10": "excessive executive pay and private jets",
                "11": "excessive executive pay and private jets",
                "12": "excessive executive pay and private jets"
            },
            "tags": [
                "insurance",
                "finance",
                "deception",
                "unfair pay",
                "corruption"
            ],
            "score": 38,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/5/5a/Liberty_Mutual_Insurance_logo.svg",
            "siteUrl": "http://libertymutualgroup.com/",
            "updatedAt": "2026-03-20T08:32:53.991Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Liberty_Mutual",
            "key": "liberty-mutual"
        },
        "state-auto-group": {
            "names": [
                "State Auto Group"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "insurance",
                "finance"
            ],
            "score": 38,
            "ownedBy": [
                "liberty-mutual"
            ],
            "updatedAt": "2026-03-20T08:51:42.102Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/State_Auto_Group",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/c4/State_Auto_Logo_Cropped.jpg",
            "key": "state-auto-group"
        },
        "safeco": {
            "names": [
                "Safeco"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "insurance",
                "finance"
            ],
            "score": 38,
            "ownedBy": [
                "liberty-mutual"
            ],
            "updatedAt": "2026-03-20T08:51:42.596Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Safeco",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/80/Safeco_logo.svg",
            "siteUrl": "https://www.safeco.com/",
            "key": "safeco"
        },
        "ironshore": {
            "names": [
                "Ironshore"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "insurance",
                "finance"
            ],
            "score": 38,
            "ownedBy": [
                "liberty-mutual"
            ],
            "updatedAt": "2026-03-20T08:51:42.666Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Ironshore",
            "key": "ironshore"
        },
        "linkedin": {
            "names": [
                "Linkedin"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech"
            ],
            "score": 35,
            "ownedBy": [
                "microsoft"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/aa/LinkedIn_2021.svg",
            "siteUrl": "https://linkedin.com/",
            "updatedAt": "2026-03-21T10:38:42.191Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/LinkedIn",
            "key": "linkedin"
        },
        "l.l.bean": {
            "names": [
                "L.L.Bean"
            ],
            "comment": "L.L.Bean is an American outdoor apparel retailer that has misled customers [1][2], has executives who donated to Donald Trump [3][4][5][7], and has faced allegations of sexual discrimination against employees [6]. The company has also sold unsafe child carriers and delayed reporting [8], opposed consumer privacy regulations [9], and potentially profited from forced Uyghur labor [10].",
            "sources": {
                "1": "https://topclassactions.com/lawsuit-settlements/consumer-products/apparel/l-l-bean-class-action-alleges-fake-discounts-and-sale-prices/",
                "2": "https://www.classaction.org/media/bondi-v-l-l-bean-inc.pdf",
                "3": "https://www.npr.org/2017/04/16/523960521/-grabyourwallets-anti-trump-boycott-looks-to-expand-its-reach",
                "4": "http://www.pressherald.com/2017/01/12/our-view-l-l-bean-boycott-would-harm-the-wrong-people/",
                "5": "https://www.nytimes.com/2017/01/12/us/politics/linda-bean-ll-bean-boycott.html",
                "6": "https://caselaw.findlaw.com/court/us-1st-circuit/1161010.html",
                "7": "https://www.cbsnews.com/news/after-calls-for-l-l-bean-boycott-trump-tweets-support-for-company/",
                "8": "https://web.archive.org/web/20170115211445/https://www.cpsc.gov/Newsroom/News-Releases/2000/LL-Bean-Inc-to-Pay-750000-Civil-Penalty-for-Delay-in-Reporting-Backpack-Child-Carriers",
                "9": "https://www.politico.com/news/2023/12/18/ll-bean-joins-the-national-privacy-wars-00132120",
                "10": "https://www.aspi.org.au/report/uyghurs-sale/"
            },
            "sourceNotes": {
                "1": "misleading customers",
                "2": "misleading customers",
                "3": "executive donated to donald trump",
                "4": "executive donated to donald trump",
                "5": "executive donated to donald trump",
                "6": "sexual discrimination against employees",
                "7": "executive donated to donald trump",
                "8": "sold unsafe child carriers and delayed reporting",
                "9": "opposed consumer privacy regulations",
                "10": "potentially profiting from forced Uyghur labour"
            },
            "tags": [
                "clothing",
                "retail",
                "deception",
                "sexual harassment",
                "gender discrimination",
                "unsafe practices",
                "forced uyghur labour"
            ],
            "score": 36,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/74/L.L.Bean_wordmark.svg",
            "siteUrl": "https://www.llbean.com/",
            "updatedAt": "2026-03-21T20:30:08.090Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/L.L.Bean",
            "key": "l.l.bean"
        },
        "lloyds": {
            "names": [
                "Lloyds",
                "Lloyds Banking Group plc",
                "Lloyds Banking Group",
                "LLoyds TSB",
                "HBOS",
                "LLOY",
                "LYG"
            ],
            "comment": "Lloyds is a British bank that has engaged in tax avoidance [1], libor interest rate fraud [2], and has misled customers through greenwashing [3][4][5], defrauded customers [6][7][8], used threatening language and misleading branding to intimidate customers into paying bills [9], and engaged in car finance fraud [10]. Additionally, it has pressured employees leading to product mis-selling [11] and financed nuclear weapons and arms sales to Israel [12].",
            "sources": {
                "1": "https://www.theguardian.com/business/2009/feb/11/tax-gap-lloyds",
                "2": "https://www.bbc.co.uk/news/business-28528349",
                "3": "https://www.independent.co.uk/news/uk/lloyds-bank-asa-linkedin-government-investment-b2666153.html",
                "4": "https://www.mirror.co.uk/news/business/lloyds-bank-advert-banned-watchdog-34334841",
                "5": "https://www.bbc.co.uk/news/business-57768515",
                "6": "https://www.cambridge-news.co.uk/business/business-news/cambridge-couple-vindicated-massive-fraud-12529459",
                "7": "https://www.ft.com/content/2fb12910-264d-11e9-b329-c7e6ceb5ffdf",
                "8": "https://www.bbc.com/news/uk-england-bristol-61974749",
                "9": "https://www.bbc.co.uk/news/business-28343256",
                "10": "https://www.theguardian.com/business/2025/oct/23/lloyds-profits-plunge-as-it-feels-impact-of-uk-car-finance-scandal",
                "11": "https://www.theguardian.com/business/2013/dec/11/lloyds-banking-group-fined-misselling-scandal",
                "12": "https://theecologist.org/2018/may/21/are-you-funding-fracking-and-nuclear-weapon-manufacturing"
            },
            "sourceNotes": {
                "1": "tax avoidance",
                "2": "libor interest rate fraud",
                "3": "misleading customers and greenwashing",
                "4": "misleading customers and greenwashing",
                "5": "misleading customers",
                "6": "defrauded customers",
                "7": "defrauded customers",
                "8": "defrauded customers",
                "9": "used threatening language and misleading branding to intimidate customers into paying bills",
                "10": "involved in car finance fraud",
                "11": "poor working conditions and pressure on employees leading to product mis-selling",
                "12": "financing nuclear weapons and arms sales to Israel"
            },
            "tags": [
                "bank",
                "finance",
                "tax avoidance",
                "deception",
                "greenwashing",
                "connections to israel"
            ],
            "score": 20,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/9c/Lloyds_Banking_Group_Plc.png",
            "siteUrl": "https://lloydsbankinggroup.com/",
            "updatedAt": "2026-03-21T20:30:08.090Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Lloyds_Banking_Group",
            "key": "lloyds"
        },
        "logitech": {
            "names": [
                "Logitech",
                "Logitech International S.A.",
                "Logitech International",
                "LOGN",
                "LOGI"
            ],
            "comment": "Logitech is a Swiss company that has ended support for customers' existing products causing them to stop working [1] and engaged in accounting fraud [2]. The company has also violated customer privacy [3] and maintained unacceptable working conditions in its supply chain [4].",
            "sources": {
                "1": "https://www.slashgear.com/logitech-harmony-link-bricked-iot-cloud-failure-08507393/",
                "2": "https://www.corporatecrimereporter.com/news/200/logitech-international-to-pay-7-5-million-neither-admit-nor-deny-sec-charges/",
                "3": "https://topclassactions.com/lawsuit-settlements/privacy/logitech-class-action-alleges-company-wiretaps-website-conversations/",
                "4": "https://chinalaborwatch.org/labor-conditions-in-chinas-consumer-electronics-sector/"
            },
            "sourceNotes": {
                "1": "ended support for existing products causing them to stop working",
                "2": "accounting fraud",
                "3": "customer privacy violation",
                "4": "unnacceptable working conditions in supply chain"
            },
            "tags": [
                "electronics",
                "tech",
                "corruption",
                "deception",
                "privacy violations",
                "poor working conditions"
            ],
            "score": 40,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/17/Logitech_logo.svg",
            "siteUrl": "https://www.logitech.com/",
            "updatedAt": "2026-03-24T08:18:37.244Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Logitech",
            "key": "logitech"
        },
        "lowe's": {
            "names": [
                "Lowe's",
                "Lowe's Companies",
                "Lowe's Companies, Inc.",
                "Lowe’s HIW",
                "LOWE"
            ],
            "comment": "Lowe's is an American home improvement retailer that has misled customers [1], used facial recognition on shoppers without consent [2], ended DEI initiatives [3][4], illegally prevented employees from discussing pay [5], engaged in anti‑union operations and dismissals [6][7], misclassified and under‑compensated workers [8][9][10][12], discriminated against disabled workers [11], forced employees into overtime [13], and sold wood from illegal logging [14]. The company has also committed environmental violations, including air pollution [15][16] and illegal hazardous waste dumping [17].",
            "sources": {
                "1": "https://topclassactions.com/lawsuit-settlements/lawsuit-news/lowes-class-action-alleges-false-discount-advertising-scheme/q",
                "2": "https://www.aclu.org/news/privacy-technology/are-stores-you-shop-secretly-using-face",
                "3": "https://www.charlotteobserver.com/news/business/article291529415.html",
                "4": "https://www.insurancejournal.com/news/national/2024/08/27/790092.htm",
                "5": "https://web.archive.org/web/20240206080804/https://www.hrdive.com/news/lowes-policy-forbidding-workers-from-discussing-pay-is-unlawful-nlrb-judg/522086/",
                "6": "https://web.archive.org/web/20240509014344/https://www.nola.com/news/business/lowes-worker-claims-he-was-fired-for-organizing-union/article_33bc6e0c-15ea-11ee-aef0-bf0fc1c66868.html",
                "7": "https://web.archive.org/web/20240214193904/https://www.wwno.org/business/2023-08-22/how-lowes-fought-back-unionization-in-new-orleans",
                "8": "https://www.cpmlegal.com/newsroom/news/Lowes-Settlement",
                "9": "https://www.prosalesmagazine.com/business/operations/lowes-settles-for-9-5m-in-class-action-wage-suit_o",
                "10": "https://www.forbes.com/sites/waldleventhal/2015/01/20/lowes-10-million-settlement-provides-3-lessons-for-firms-working-with-independent-contractors/?sh=49c0215c1d12",
                "11": "https://www.eeoc.gov/newsroom/lowes-pay-86-million-settle-eeoc-disability-discrimination-suit",
                "12": "https://www.sommerspc.com/verdicts/9950000-settlement-for-lowes-hourly-managers-who-alleged-unpaid-off-the-clock-work/",
                "13": "https://violationtracker.goodjobsfirst.org/archive/FLSA1034.pdf",
                "14": "http://news.mongabay.com/2006/0323-png.html",
                "15": "https://www.justice.gov/opa/pr/corporate-wide-settlement-lowe-s-protects-public-lead-pollution-during-home-renovations",
                "16": "https://www.aqmd.gov/docs/default-source/Agendas/Governing-Board/2020/2020-mar6-014.pdf",
                "17": "https://fox5sandiego.com/news/lowes-paying-18-1m-settlement-over-waste-dumping-scandal/"
            },
            "sourceNotes": {
                "1": "misleading customers",
                "2": "uses facial recognition on customers without consent",
                "3": "ended DEI policies",
                "4": "ended DEI policies",
                "5": "illegally prevented employees from discussing pay",
                "6": "anti-union operations and dismissals",
                "7": "anti-union operations and dismissals",
                "8": "misclassified and undercompensated workers",
                "9": "misclassified and undercompensated workers",
                "10": "misclassified and undercompensated workers",
                "11": "discriminated against disabled workers",
                "12": "misclassified and undercompensated workers",
                "13": "made emloyees engage in forced overtime",
                "14": "sold wood from illegal logging",
                "15": "environmental violations",
                "16": "air pollution violation",
                "17": "illegally dumped hazardous waste"
            },
            "tags": [
                "retail",
                "diy",
                "deception",
                "privacy violations",
                "anti-union practices",
                "unfair pay",
                "forced labour",
                "deforestation",
                "environmental violations",
                "unsustainable practices"
            ],
            "score": 20,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/2c/Lowes_Companies_Logo.svg",
            "siteUrl": "https://lowes.com/",
            "updatedAt": "2026-03-25T09:08:20.651Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Lowe%27s",
            "key": "lowe's"
        },
        "lululemon": {
            "names": [
                "lululemon",
                "Lululemon",
                "lululemon athletica inc.",
                "LULU"
            ],
            "comment": "lululemon is a Canadian athletic apparel company that has been accused of false advertising [1][2], deceptive advertising and greenwashing [3][4][5], while its founder has made misogynistic statements [6][7] and racist and fatphobic remarks accompanied by performative DEI initiatives [8]. The company has refused to produce plus‑size clothing [9], blamed customers for product quality issues [10], fostered a racist work culture [11], engaged in racial profiling of customers [12], and workers in its supply chain have faced abuse [13][14].",
            "sources": {
                "1": "https://www.nytimes.com/2007/11/14/business/14seaweed.html",
                "2": "http://www.competitionbureau.gc.ca/internet/index.cfm?itemID=2517&lg=e",
                "3": "https://www.forbes.com/sites/jonmcgowan/2024/05/13/canada-launches-greenwashing-investigation-into-lululemon/",
                "4": "https://www.thestreet.com/retail/lululemon-accused-of-issue-customers-should-know-about",
                "5": "https://www.waste360.com/sustainability/lululemon-s-environmentally-focused-campaign-leads-to-lawsuit-alleging-deceptive-representations",
                "6": "https://ideas.time.com/2013/11/13/forget-feminist-outrage-by-shunning-plus-size-customers-lululemon-is-making-a-terrible-business-decision/",
                "7": "https://www.businessinsider.com/outrageous-remarks-by-lululemon-founder-chip-wilson-2013-12",
                "8": "https://www.independent.co.uk/life-style/fashion/lululemon-ceo-scandal-controversy-b2473505.html",
                "9": "http://www.huffingtonpost.com/2013/07/31/lululemon-plus-size_n_3675605.html",
                "10": "https://www.businessoffashion.com/articles/sports/lululemon-blames-customers-again-after-see-through-tights-fiasco/",
                "11": "https://www.thestreet.com/retail/lululemon-accused-of-an-ugly-problem-thats-slowly-coming-to-light",
                "12": "https://www.blackenterprise.com/lululemon-racial-profiling-nyc/",
                "13": "https://www.euronews.com/2019/10/17/lululemon-responds-to-allegations-of-abuse-in-garment-factory",
                "14": "https://uhrp.org/statement/explosive-report-exposes-uyghur-forced-labour-connections-in-global-retail-brands-supply-chains/"
            },
            "sourceNotes": {
                "1": "false advertising",
                "2": "false advertising",
                "3": "greenwashing",
                "4": "greenwashing",
                "5": "deceptive advertising and greenwashing",
                "6": "misogynistic statements by founder",
                "7": "misogynistic statements by founder",
                "8": "racist and fatphobic statements by founder and performative DEI initiaitives",
                "9": "refused to make clothing for plus-sized customers",
                "10": "blamed customers for poor quality products",
                "11": "racist work culture",
                "12": "racial profiling of customers",
                "13": "abuse of workers in supply chain",
                "14": "abuse of workers in supply chain"
            },
            "tags": [
                "clothing",
                "retail",
                "sports",
                "deception",
                "greenwashing",
                "gender discrimination",
                "racial discrimination",
                "poor working conditions"
            ],
            "score": 35,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/22/Lululemon_Athletica_logo.svg",
            "siteUrl": "https://shop.lululemon.com/",
            "updatedAt": "2026-03-26T20:01:12.840Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Lululemon",
            "key": "lululemon"
        },
        "lush": {
            "names": [
                "Lush"
            ],
            "comment": "Lush is a British cosmetics company that has underpaid staff [1][2] and maintained unsafe working conditions [3]. The company has also engaged in anti‑union practices [4][5][6] and exploited freelance workers [7].",
            "sources": {
                "1": "http://www.abc.net.au/news/2018-07-17/lush-cosmetics-admits-it-underpayed-staff-two-million-dollars/10002750",
                "2": "https://www.theguardian.com/australia-news/2020/nov/17/cosmetics-company-lush-admits-to-underpaying-australian-workers-by-44m",
                "3": "https://www.theguardian.com/australia-news/2020/aug/21/ethical-cosmetics-company-lush-accused-of-poor-working-conditions-for-australian-staff",
                "4": "https://www.businessinsider.com/lush-leadership-rejects-union-despite-supporting-them-for-other-brands-2020-12",
                "5": "https://www.vice.com/en/article/how-lush-cosmetics-tried-to-crush-a-union-drive/",
                "6": "https://jacobin.com/2021/06/lush-cosmetics-toronto-union-busting-progressive-image-hypocrisy",
                "7": "https://cosmeticsbusiness.com/lush-accused-of-exploiting-freelance-workers-during-christmas-rush"
            },
            "sourceNotes": {
                "1": "underpaid staff",
                "2": "underpaid staff",
                "3": "unsafe working conditions",
                "4": "anti-union practices",
                "5": "anti-union practices",
                "6": "anti-union practices",
                "7": "exploiting freelance workers"
            },
            "tags": [
                "retail",
                "consumer goods",
                "unfair pay",
                "unsafe working conditions",
                "anti‑union practices"
            ],
            "score": 42,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/d4/LushCosmetics.svg",
            "siteUrl": "https://lush.com/",
            "updatedAt": "2026-03-27T07:38:36.384Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Lush_(company)",
            "key": "lush"
        },
        "lyft": {
            "names": [
                "Lyft"
            ],
            "comment": "Lyft is an American ride‑hailing company that has faced customer privacy violations [1], price‑fixing allegations with Uber [2], denied drivers fair wages [3] while deceiving them with misleading earnings claims [4] and maintaining low pay and unfair working conditions [5][6][7][8]. It has also failed to protect customers from sexual assault [9][10], allowed abuser drivers to use the app to reach children [11], and has been linked to at least 10 deaths, 4000 assaults, and 360 rapes in Lyft rides [12][13].",
            "sources": {
                "1": "https://web.archive.org/web/20190402042907/https://topclassactions.com/lawsuit-settlements/lawsuit-news/863072-lyft-consumers-seek-approval-4m-texting-class-action-settlement/",
                "2": "https://fingfx.thomsonreuters.com/gfx/legaldocs/klvykrnkmvg/Uber-Lyft%20Complaint.pdf",
                "3": "https://www.business-humanrights.org/en/latest-news/usa-uber-lyft-allegedly-exploit-loopholes-to-deny-drivers-fair-wages-impacting-mental-health/",
                "4": "https://www.ftc.gov/news-events/news/press-releases/2024/10/ftc-takes-action-stop-lyft-deceiving-drivers-misleading-earnings-claims",
                "5": "https://www.theguardian.com/business/2023/mar/10/uber-lyft-driver-suspension-deactivation-pay",
                "6": "https://calmatters.org/economy/2025/03/uber-lyft-could-owe-california-gig-workers-billions-of-dollars-in-california-wage-theft-case/",
                "7": "https://violationtracker.goodjobsfirst.org/archive/FLSA768.pdf",
                "8": "https://www.law360.com/employment/articles/1027806/lyft-settles-calif-drivers-premium-fare-suit-for-1-95m",
                "9": "https://www.reuters.com/legal/lyft-officials-settle-lawsuit-over-sexual-assaults-by-drivers-2024-07-24/",
                "10": "https://www.npr.org/2022/09/01/1120391757/lyft-lawsuits-assault-allegations",
                "11": "https://www.nbcnews.com/tech/tech-news/uber-lyft-lawsuit-abuse-rape-sexual-assault-children-rcna149529",
                "12": "https://www.theverge.com/2021/10/22/22740609/lyft-safety-report-2017-2019-physical-sexual-assault-death",
                "13": "https://nypost.com/2021/10/22/lyft-releases-sex-assault-data-showing-360-rapes-during-three-year-span/"
            },
            "sourceNotes": {
                "1": "customer privacy violations",
                "2": "price fixing with uber",
                "3": "denied drivers fair wages",
                "4": "Deceiving Drivers with Misleading Earnings Claims",
                "5": "low pay and unfair working conditions",
                "6": "wage theft against drivers",
                "7": "wage theft against drivers",
                "8": "wage theft against drivers",
                "9": "failed to protect customers from sexual assault",
                "10": "failed to protect customers from sexual assault",
                "11": "abuser drivers used the app to reach children",
                "12": "at least 10 people died and 4000 people have been assaulted in lyft rides",
                "13": "at least 360 rapes occured in lyft journeys"
            },
            "tags": [
                "tech",
                "transportation",
                "anticompetitive practices",
                "privacy violations",
                "unfair pay",
                "poor working conditions",
                "deception"
            ],
            "score": 10,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/63/Lyft_logo_2025.svg",
            "siteUrl": "https://lyft.com/",
            "updatedAt": "2026-03-28T17:16:34.820Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Lyft",
            "key": "lyft"
        },
        "motivate": {
            "names": [
                "Motivate"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech",
                "transportation"
            ],
            "score": 10,
            "ownedBy": [
                "lyft"
            ],
            "updatedAt": "2026-03-28T22:49:09.193Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Motivate_(company)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/2/23/Motivate_logo.png",
            "siteUrl": "http://motivateco.com/",
            "key": "motivate"
        },
        "free-now": {
            "names": [
                "Free Now"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech",
                "transportation"
            ],
            "score": 10,
            "ownedBy": [
                "lyft"
            ],
            "updatedAt": "2026-03-28T22:49:09.399Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Free_Now_(service)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/10/Freenow_2025_logo.svg",
            "siteUrl": "https://www.free-now.com/",
            "key": "free-now"
        },
        "mandm's": {
            "names": [
                "M&M's"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "confectionery",
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/45/M%26M%27s_2022.svg",
            "siteUrl": "http://mms.com/",
            "updatedAt": "2026-03-29T15:06:40.114Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/M%26M%27s",
            "key": "mandm's"
        },
        "marriott": {
            "names": [
                "Marriott",
                "Marriott International",
                "Marriott International, Inc.",
                "Marriott Corporation",
                "Marriott Hotels & Resorts",
                "MAR"
            ],
            "comment": "Marriott is a US hotel chain that has bribed customers for good reviews [1], evaded taxes [2], failed to meet animal welfare commitments [3][4], attempted to silence activists about its animal welfare progress [5], and built a hotel that disrupted Serengeti wildlife migrations [6]. The company has replaced striking workers with vulnerable migrants [7], prevented staff from taking breaks [8], stolen gratuities from employees [9], engaged in human trafficking and abuse against hospitality staff [10], refused to share prevalence of sexual harassment against employees [11], and ignored and profited from sex trafficking [12].",
            "sources": {
                "1": "https://nypost.com/2025/10/13/lifestyle/marriott-guests-accuse-brand-of-bribing-them-for-positive-reviews/",
                "2": "https://business-review.eu/news/prosecutors-raid-marriott-hotel-in-bucharest-in-tax-evasion-case-111805",
                "3": "https://www.washingtonpost.com/travel/2026/01/14/marriott-protests-cage-free-eggs/",
                "4": "https://www.washingtonpost.com/travel/2026/01/14/marriott-protests-cage-free-eggs/",
                "5": "https://mercyforanimals.org/blog/when-truth-becomes-a-threat-how-corporations-are-silencing-activists/",
                "6": "https://www.thestreet.com/travel/marriott-sued-over-environment-complaint-seeks-demolition",
                "7": "https://www.business-humanrights.org/en/latest-news/usa-ihg-marriott-hotels-allegedly-replace-strikers-with-vulnerable-migrants-incl-children-who-were-subsequently-subject-to-long-hours-few-breaks-wage-theft-prompting-district-attorney-investigation/",
                "8": "https://www.law360.com/articles/1138159/marriott-housekeepers-seek-final-ok-on-4m-break-deal",
                "9": "https://www.law360.com/articles/1594926/sf-marriott-servers-near-9m-win-in-gratuity-bench-trial",
                "10": "https://techbullion.com/marriott-criminal-investigation-whitewashing-in-the-hotel-industry/",
                "11": "https://aflcio.org/2019/4/26/marriott-should-tell-truth-about-sexual-harassment",
                "12": "https://www.fastcompany.com/90472842/lawsuits-accuse-marriott-hilton-and-other-hotel-chains-of-ignoring-sex-trafficking"
            },
            "sourceNotes": {
                "1": "bribing customers for good reviews",
                "2": "tax evasion",
                "3": "failed to meet animal welfare commitments",
                "4": "failed to meet animal welfare commitments",
                "5": "attempted to silence activists commenting on its animal welfare progress",
                "6": "built a hotel that disrupted the Serengeti wildlife migrations",
                "7": "replaced striking workers with vulnerable migrants",
                "8": "prevented staff from taking breaks",
                "9": "stole gratuites from employees",
                "10": "human trafficking and abuse against hopsitality staff",
                "11": "refused to share prevalance of sexual harassment against employees",
                "12": "ignored and profited from sex trafficking"
            },
            "tags": [
                "hospitality",
                "corruption",
                "tax avoidance",
                "animal abuse",
                "deception",
                "environmental violations",
                "anti-union practices",
                "poor working conditions",
                "unfair pay",
                "forced labour",
                "sexual harassment"
            ],
            "score": 22,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/e/e7/Marriott_International.svg",
            "siteUrl": "http://marriott.com/",
            "updatedAt": "2026-03-29T16:56:03.593Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Marriott_International",
            "key": "marriott"
        },
        "le-meridien": {
            "names": [
                "Le Méridien"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "hospitality"
            ],
            "score": 22,
            "ownedBy": [
                "marriott"
            ],
            "updatedAt": "2026-03-30T15:31:33.862Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Le_M%C3%A9ridien",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/6a/LeMeridien.svg",
            "siteUrl": "https://le-meridien.marriott.com/",
            "key": "le-meridien"
        },
        "ritz-carlton-hotels": {
            "names": [
                "Ritz-Carlton Hotels"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "hospitality"
            ],
            "score": 22,
            "ownedBy": [
                "marriott"
            ],
            "updatedAt": "2026-03-30T15:31:34.256Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/The_Ritz-Carlton_Hotel_Company",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/a/a0/RitzCarlton.svg",
            "siteUrl": "http://ritzcarlton.com/",
            "key": "ritz-carlton-hotels"
        },
        "sheraton-hotels": {
            "names": [
                "Sheraton Hotels"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "hospitality"
            ],
            "score": 22,
            "ownedBy": [
                "marriott"
            ],
            "updatedAt": "2026-03-30T15:31:34.500Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Sheraton_Hotels_and_Resorts",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/59/Sheraton_%281%29.svg",
            "siteUrl": "http://sheraton.marriott.com/",
            "key": "sheraton-hotels"
        },
        "westin-hotels-and-resorts": {
            "names": [
                "Westin Hotels & Resorts"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "hospitality"
            ],
            "score": 22,
            "ownedBy": [
                "marriott"
            ],
            "updatedAt": "2026-03-30T15:31:34.984Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Westin_Hotels_%26_Resorts",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/87/Westin_Hotels_%26_Resorts_logo.svg",
            "siteUrl": "https://westin.marriott.com/",
            "key": "westin-hotels-and-resorts"
        },
        "mars": {
            "names": [
                "Mars",
                "Mars Inc.",
                "Mars, Incorporated"
            ],
            "comment": "Mars is an American company that has been identified as one of the world's biggest plastic polluters [1], has engaged in price fixing [2][3], and has been accused of underpaying employees [4] and misleading customers with false health claims [5]. The company has also been linked to deforestation in african national parks [6], exploitation of cocoa farmers [7], investment in Israeli tech companies [8], continued operations in Russia [9] - being labelled an international sponsor of war by Ukraine [10], complicity in human trafficking and forced labour [11], and connections to child slavery [12][13][14].",
            "sources": {
                "1": "https://brandaudit.breakfreefromplastic.org/brand-audit-2023/",
                "2": "https://www.autoritedelaconcurrence.fr/en/communiques-de-presse/20-march-2012-sale-dry-dog-and-cat-food-specialist-retail",
                "3": "https://www.bbc.co.uk/news/business-22807887",
                "4": "https://www.law360.com/employment/articles/1027501/kellogg-gets-green-light-for-16-8m-ot-deal",
                "5": "https://www.law360.com/articles/172035/wrigley-settles-false-ad-class-action-for-6m",
                "6": "https://web.archive.org/web/20171107055533/http://49tmko49h46b4e0czy3rlqaye1b.wpengine.netdna-cdn.com/wp-content/uploads/2017/09/Olam-Livelihood-Charter-report-2016-2.pdf",
                "7": "https://www.theguardian.com/food/2023/dec/02/brands-to-avoid-mars-cadbury-chocolate-firms-criticised-ethics-report",
                "8": "https://www.jpost.com/jpost-tech/mars-turns-to-israeli-tech-to-develop-global-food-solutions-602933",
                "9": "https://www.business-humanrights.org/en/latest-news/us-co-mars-leases-40000-sqm-warehouse-in-russia-despite-pledges-to-halt-investments/",
                "10": "https://nazk.gov.ua/en/news/you-re-not-you-when-you-continue-to-work-in-the-russian-federation-the-nacp-added-pepsico-and-mars-to-the-list-of-international-sponsors-of-the-war/",
                "11": "https://www.business-humanrights.org/en/latest-news/nestle-mars-among-firms-named-in-cocoa-child-labour-suit/",
                "12": "https://harvardpolitics.com/sweet-chocolate-bitter-truth-internet-distraction-and-the-reality-of-mars-inc-s-child-slavery-practices/",
                "13": "https://eu.usatoday.com/story/money/2023/12/01/mars-child-labor-cbs-investigation-findings-response/71769249007/",
                "14": "https://www.newser.com/story/343264/investigation-finds-disturbing-news-about-a-candy-giant.html"
            },
            "sourceNotes": {
                "1": "one of the worlds biggest plastic polluters",
                "2": "price fixing",
                "3": "price fixing",
                "4": "underpaid employees",
                "5": "misled customers with false health claims",
                "6": "deforestation in african national parks",
                "7": "exploited cocoa farmers",
                "8": "invested in israeli tech companies",
                "9": "continued operations in russia",
                "10": "labelled international sponsor of war by ukraine",
                "11": "complicity in human trafficking and forced labour",
                "12": "connected to child slavery",
                "13": "connected to child slavery",
                "14": "connected to child slavery"
            },
            "tags": [
                "confectionery",
                "food",
                "anticompetitive practices",
                "unfair pay",
                "deception",
                "deforestation",
                "child labour",
                "forced labour",
                "connections to Israel",
                "connections to Russia",
                "environmental violations",
                "unsustainable practices"
            ],
            "score": 17,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/9c/Mars_Incorporated_2019_logo.svg",
            "siteUrl": "https://www.mars.com/",
            "updatedAt": "2026-03-31T09:29:08.242Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Mars_Inc.",
            "key": "mars"
        },
        "cocoavia": {
            "names": [
                "CocoaVia"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:38.084Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/CocoaVia",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/0c/Cocoavia_simple_logo.png",
            "siteUrl": "https://www.cocoavia.com/",
            "key": "cocoavia"
        },
        "foodspring": {
            "names": [
                "Foodspring"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:38.509Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Foodspring",
            "siteUrl": "http://foodspring.de/",
            "key": "foodspring"
        },
        "ben's-original": {
            "names": [
                "Ben's Original"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:38.562Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Ben%27s_Original",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/47/BensOriginalLogo.svg",
            "siteUrl": "https://www.bensoriginal.com/",
            "key": "ben's-original"
        },
        "dolmio": {
            "names": [
                "Dolmio"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:38.625Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Dolmio",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/3/3e/Dolmio_brand_logo.png",
            "siteUrl": "https://www.dolmio.com.au/",
            "key": "dolmio"
        },
        "masterfoods": {
            "names": [
                "MasterFoods"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:38.684Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/MasterFoods",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/ae/Mastrfoods_brand_logo.png",
            "siteUrl": "https://www.masterfoods.com.au/",
            "key": "masterfoods"
        },
        "miracoli": {
            "names": [
                "Mirácoli"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:39.068Z",
            "wikipediaUrl": "https://de.wikipedia.org/wiki/Mir%C3%A1coli",
            "key": "miracoli"
        },
        "seeds-of-change": {
            "names": [
                "Seeds of Change"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:39.111Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Seeds_of_Change_(company)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/3b/Seeds_change_logo.png",
            "siteUrl": "https://www.seedsofchange.com/",
            "key": "seeds-of-change"
        },
        "tasty-bite": {
            "names": [
                "Tasty Bite"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:39.966Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Tasty_Bite",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/b/b7/Tasty_bite_logo.png",
            "siteUrl": "http://www.tastybite.com/",
            "key": "tasty-bite"
        },
        "mars-petcare": {
            "names": [
                "Mars Petcare"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:40.233Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Mars_Petcare",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/9c/Mars_Incorporated_2019_logo.svg",
            "siteUrl": "https://www.mars.com/",
            "key": "mars-petcare"
        },
        "banfield-pet-hospital": {
            "names": [
                "Banfield Pet Hospital"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:40.965Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Banfield_Pet_Hospital",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/d9/Banfield_logo.png",
            "siteUrl": "http://www.banfield.com/",
            "key": "banfield-pet-hospital"
        },
        "bluepearl-specialty-and-emergency-pet-hospital": {
            "names": [
                "BluePearl Specialty and Emergency Pet Hospital"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:41.027Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/BluePearl_Specialty_and_Emergency_Pet_Hospital",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/7/75/BluePearl_Veterinary_Partners_Logo_Registered.png",
            "siteUrl": "http://bluepearlvet.com/",
            "key": "bluepearl-specialty-and-emergency-pet-hospital"
        },
        "vca-animal-hospitals": {
            "names": [
                "VCA Animal Hospitals"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:41.076Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/VCA_Animal_Hospitals",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/72/VCA_logo.svg",
            "siteUrl": "https://vcahospitals.com/",
            "key": "vca-animal-hospitals"
        },
        "anicura": {
            "names": [
                "AniCura"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:41.794Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/AniCura",
            "key": "anicura"
        },
        "eukanuba": {
            "names": [
                "Eukanuba"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:42.229Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Eukanuba",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/af/Eukanuba_brand_logo.svg",
            "siteUrl": "https://www.eukanuba.com/",
            "key": "eukanuba"
        },
        "the-goodlife-recipe": {
            "names": [
                "The Goodlife Recipe"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:42.698Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/The_Goodlife_Recipe",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/7/78/Goodlife_Recipe_logo.png",
            "siteUrl": "http://www.goodliferecipe.com/",
            "key": "the-goodlife-recipe"
        },
        "iams": {
            "names": [
                "Iams"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:43.229Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Iams",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/50/IAMS-Logo.svg",
            "siteUrl": "https://www.iams.com/",
            "key": "iams"
        },
        "nutro-products": {
            "names": [
                "Nutro Products"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:43.797Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Nutro_Products",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/72/Nutro_food_brand_logo.png",
            "siteUrl": "https://www.nutro.com/",
            "key": "nutro-products"
        },
        "pedigree": {
            "names": [
                "Pedigree"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:44.252Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Pedigree_Petfoods",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/d1/Pedigree_dog_food_logo.png",
            "siteUrl": "https://www.pedigree.com/",
            "key": "pedigree"
        },
        "prettylitter": {
            "names": [
                "PrettyLitter"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:44.309Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/PrettyLitter",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/b1/PrettyLitter_logo.svg",
            "siteUrl": "http://prettylitter.com/",
            "key": "prettylitter"
        },
        "royal-canin": {
            "names": [
                "Royal Canin"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:44.892Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Royal_Canin",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/af/Royal-Canin-Logo.svg",
            "siteUrl": "http://royalcanin.com/",
            "key": "royal-canin"
        },
        "sheba": {
            "names": [
                "Sheba"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:45.554Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Sheba_(cat_food)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/8/81/Sheba_cat_food_brand_logo.png",
            "siteUrl": "https://www.sheba.com/",
            "key": "sheba"
        },
        "whiskas": {
            "names": [
                "Whiskas"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:45.592Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Whiskas",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/c/c9/Whiskas_logo.png",
            "siteUrl": "https://www.whiskas.me/en-me",
            "key": "whiskas"
        },
        "3-musketeers": {
            "names": [
                "3 Musketeers"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:45.972Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/3_Musketeers_(chocolate_bar)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/1c/3_musketeers_bar_logo.png",
            "siteUrl": "https://www.3musketeers.com/",
            "key": "3-musketeers"
        },
        "balisto": {
            "names": [
                "Balisto"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:46.382Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Balisto",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/48/Balisto_brand_logo.png",
            "key": "balisto"
        },
        "bounty": {
            "names": [
                "Bounty"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:46.431Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Bounty_(chocolate_bar)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/1/19/Bounty-Wrapper-Small.jpg",
            "key": "bounty"
        },
        "celebrations": {
            "names": [
                "Celebrations"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:46.485Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Celebrations_(confectionery)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/86/Celebrations_logo.svg",
            "siteUrl": "https://www.celebrations.de/en",
            "key": "celebrations"
        },
        "cirku": {
            "names": [
                "Cirku"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:46.531Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Cirku",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/0c/Cocoavia_simple_logo.png",
            "siteUrl": "https://www.cocoavia.com/",
            "key": "cirku"
        },
        "combos": {
            "names": [
                "Combos"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:47.134Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Combos",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/79/Combos_snacks_logo.png",
            "siteUrl": "https://www.combos.com/",
            "key": "combos"
        },
        "dove-bar": {
            "names": [
                "Dove Bar"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:47.227Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Dove_Bar",
            "key": "dove-bar"
        },
        "ethel-m-chocolates": {
            "names": [
                "Ethel M Chocolates"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:47.265Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Ethel_M_Chocolate_Factory",
            "siteUrl": "http://www.ethelm.com/",
            "key": "ethel-m-chocolates"
        },
        "flavia": {
            "names": [
                "FLAVIA"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:47.917Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Flavia_Beverage_Systems",
            "key": "flavia"
        },
        "flyte": {
            "names": [
                "Flyte"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:48.160Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Flyte_(chocolate_bar)",
            "key": "flyte"
        },
        "galaxy": {
            "names": [
                "Galaxy"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:48.338Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Galaxy_(chocolate)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/f/f9/Galaxy_chocolate_brand_logo.png",
            "siteUrl": "https://www.galaxychocolate.co.uk/",
            "key": "galaxy"
        },
        "galaxy-bubbles": {
            "names": [
                "Galaxy Bubbles"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:48.532Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Galaxy_Bubbles",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/f/f9/Galaxy_chocolate_brand_logo.png",
            "siteUrl": "https://www.galaxychocolate.co.uk/",
            "key": "galaxy-bubbles"
        },
        "galaxy-honeycomb-crisp": {
            "names": [
                "Galaxy Honeycomb Crisp"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:48.728Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Galaxy_Honeycomb_Crisp",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/f/f9/Galaxy_chocolate_brand_logo.png",
            "siteUrl": "https://www.galaxychocolate.co.uk/",
            "key": "galaxy-honeycomb-crisp"
        },
        "galaxy-minstrels": {
            "names": [
                "Galaxy Minstrels"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:49.119Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Galaxy_Minstrels",
            "key": "galaxy-minstrels"
        },
        "kudos": {
            "names": [
                "Kudos"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:49.174Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Kudos_(granola_bar)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/8b",
            "key": "kudos"
        },
        "m-azing": {
            "names": [
                "M-Azing"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:49.923Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/M-Azing",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/b/b3/M-Azing.JPG/250px-M-Azing.JPG",
            "key": "m-azing"
        },
        "maltesers": {
            "names": [
                "Maltesers"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:50.414Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Maltesers",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/6/60/Maltesers-Wrapper-Small.jpg",
            "siteUrl": "http://maltesers.co.uk/",
            "key": "maltesers"
        },
        "marathon": {
            "names": [
                "Marathon"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:50.465Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Curly_Wurly#U.S._Marathon",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/5/51/Curlywurly-Wrapper-Small.jpg",
            "siteUrl": "http://www.cadbury.co.uk/",
            "key": "marathon"
        },
        "milky-way": {
            "names": [
                "Milky Way"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:51.146Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Milky_Way_(chocolate_bar)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/1f/Baton_Milky_Way_USA.jpg",
            "siteUrl": "https://www.milkywaybar.com/",
            "key": "milky-way"
        },
        "munch": {
            "names": [
                "Munch"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:51.684Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Munch_(candy_bar)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/33/Munch_bar_logo.png",
            "siteUrl": "https://www.marsfoodservices.com/product/munch-bar",
            "key": "munch"
        },
        "promite": {
            "names": [
                "Promite"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:52.037Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Promite",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/59/Jar_of_Promite.jpg",
            "key": "promite"
        },
        "revels": {
            "names": [
                "Revels"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:52.505Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Revels_(confectionery)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/e/e0/Revels-Candies.jpg",
            "key": "revels"
        },
        "snickers": {
            "names": [
                "Snickers"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:52.544Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Snickers",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/5b/Snickers_2025.svg",
            "siteUrl": "http://snickers.com/",
            "key": "snickers"
        },
        "topic": {
            "names": [
                "Topic"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:52.658Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Topic_(chocolate_bar)",
            "key": "topic"
        },
        "tracker": {
            "names": [
                "Tracker"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:52.700Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Tracker_(granola_bar)",
            "key": "tracker"
        },
        "treets": {
            "names": [
                "Treets"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:52.851Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Treets",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/88/Project_365_-249_060909_Rennaissance_Sweet_%283894308802%29.jpg",
            "siteUrl": "https://treets.eu/",
            "key": "treets"
        },
        "twix": {
            "names": [
                "Twix"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:52.892Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Twix",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/43/Twix_brand_logo.png",
            "siteUrl": "https://www.twix.com/",
            "key": "twix"
        },
        "5-(gum)": {
            "names": [
                "5 (gum)"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:52.990Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/5_(gum)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/5a/5_gum_brand_logo.png",
            "siteUrl": "https://www.5gum.com/",
            "key": "5-(gum)"
        },
        "a.-korkunov": {
            "names": [
                "A. Korkunov"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:53.050Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/A._Korkunov",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/07/Korkunov_chocolate_logo.png",
            "siteUrl": "https://www.korkunov.ru/",
            "key": "a.-korkunov"
        },
        "airwaves": {
            "names": [
                "Airwaves"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:53.710Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Airwaves_(gum)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/d7/Airwaves_gum_logo.png",
            "siteUrl": "https://www.airwavesgum.co.uk/",
            "key": "airwaves"
        },
        "alert": {
            "names": [
                "Alert"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:54.053Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Alert_(gum)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/73",
            "siteUrl": "https://stage.marsfoodservices.com/product/alert-fruit",
            "key": "alert"
        },
        "altoids": {
            "names": [
                "Altoids"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:54.645Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Altoids",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/4c/Altoids_brand_logo.png",
            "siteUrl": "https://www.altoids.com/",
            "key": "altoids"
        },
        "big-red": {
            "names": [
                "Big Red"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:54.707Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Big_Red_(gum)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/20/Big_red_gum_logo.png",
            "siteUrl": "https://www.marsfoodservices.com/product/big-red-cinnamon",
            "key": "big-red"
        },
        "bubble-tape": {
            "names": [
                "Bubble Tape"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:54.752Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Bubble_Tape",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/2e/Hb_bubble_tape_logo.png",
            "siteUrl": "https://www.hubbabubba.com/products/hubba-bubba-original-bubble-gum-tape-2-oz-pack-tape",
            "key": "bubble-tape"
        },
        "callard-andamp-bowser-suchard": {
            "names": [
                "Callard &amp; Bowser-Suchard"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:55.354Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Callard_%26_Bowser-Suchard",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/9/9f",
            "key": "callard-andamp-bowser-suchard"
        },
        "doublemint": {
            "names": [
                "Doublemint"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:55.405Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Doublemint",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/99/Doublemint_logo.svg",
            "siteUrl": "https://www.marsfoodservices.com/product/doublemint-gum",
            "key": "doublemint"
        },
        "eclipse": {
            "names": [
                "Eclipse"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:55.455Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Eclipse_(breath_freshener)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/42/Eclipse_mints_brand_logo.png",
            "siteUrl": "https://www.eclipsemints.com.au/",
            "key": "eclipse"
        },
        "excel": {
            "names": [
                "Excel"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:55.504Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Excel_(gum)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/42/Eclipse_mints_brand_logo.png",
            "siteUrl": "https://www.eclipsemints.com.au/",
            "key": "excel"
        },
        "extra": {
            "names": [
                "Extra"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:56.081Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Extra_(gum)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/20/Extra_gum_brand_logo.png",
            "siteUrl": "https://www.extragum.com/",
            "key": "extra"
        },
        "freedent": {
            "names": [
                "Freedent"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:56.126Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Freedent",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/b9/Freedentlogo.png",
            "siteUrl": "https://www.marsfoodservices.com/product/freedent-spearmint-gum",
            "key": "freedent"
        },
        "hubba-bubba": {
            "names": [
                "Hubba Bubba"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:56.332Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Hubba_Bubba",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/cf/Hubba_bubba_gum_logo.png",
            "siteUrl": "https://www.hubbabubba.com/",
            "key": "hubba-bubba"
        },
        "juicy-fruit": {
            "names": [
                "Juicy Fruit"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:56.372Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Juicy_Fruit",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/7d/Juicy_Fruit.svg",
            "siteUrl": "https://www.marsfoodservices.com/product/juicy-fruit",
            "key": "juicy-fruit"
        },
        "life-savers": {
            "names": [
                "Life Savers"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:56.423Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Life_Savers",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/13/Life-Savers-Logo.jpg",
            "siteUrl": "https://www.life-savers.com/",
            "key": "life-savers"
        },
        "lockets": {
            "names": [
                "Lockets"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:56.617Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Lockets",
            "key": "lockets"
        },
        "orbit": {
            "names": [
                "Orbit"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:56.803Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Orbit_(gum)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/e/e2/Orbit_gum_brand_logo.png",
            "siteUrl": "https://www.orbitgum.com/",
            "key": "orbit"
        },
        "ouch!": {
            "names": [
                "Ouch!"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:56.862Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Ouch!_(gum)",
            "key": "ouch!"
        },
        "skittles": {
            "names": [
                "Skittles"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:57.027Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Skittles_(confectionery)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/1/19/Skittles_brand_logo.png",
            "siteUrl": "https://www.skittles.com/",
            "key": "skittles"
        },
        "starburst": {
            "names": [
                "Starburst"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:57.100Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Starburst_(candy)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/ac/Starburst-Candies.jpg",
            "siteUrl": "https://www.starburst.com/",
            "key": "starburst"
        },
        "sugus": {
            "names": [
                "Sugus"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:57.158Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Sugus",
            "key": "sugus"
        },
        "surpass": {
            "names": [
                "Surpass"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:57.785Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Surpass",
            "key": "surpass"
        },
        "rondo": {
            "names": [
                "Rondo"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:58.369Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Rondo_(confectionery)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/e/ee/The_Wrigley_Company_logo._2012.svg",
            "key": "rondo"
        },
        "tunes": {
            "names": [
                "Tunes"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:59.197Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Tunes_(confectionery)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/bc/Tunes_brand_logo.png",
            "key": "tunes"
        },
        "wrigley's": {
            "names": [
                "Wrigley's"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:16:59.726Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Wrigley%27s",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/e/ee/The_Wrigley_Company_logo._2012.svg",
            "key": "wrigley's"
        },
        "wrigley's-spearmint": {
            "names": [
                "Wrigley's Spearmint"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:17:00.653Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Wrigley%27s_Spearmint",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/a2/Wrigley_spearmint_logo.png",
            "key": "wrigley's-spearmint"
        },
        "wrigley-company": {
            "names": [
                "Wrigley Company"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:17:00.714Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Wrigley_Company",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/e/ee/The_Wrigley_Company_logo._2012.svg",
            "key": "wrigley-company"
        },
        "winterfresh": {
            "names": [
                "Winterfresh"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:17:00.821Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Winterfresh",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/e/ef/Winterfresh_brand_logo.png",
            "siteUrl": "https://www.marsfoodservices.com/product/winterfresh-gum",
            "key": "winterfresh"
        },
        "kellanova": {
            "names": [
                "Kellanova"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:17:01.305Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Kellanova",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/59/Kellanova_logo.svg",
            "siteUrl": "http://kellanova.com/",
            "key": "kellanova"
        },
        "all-bran": {
            "names": [
                "All-Bran"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:17:01.525Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/All-Bran",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/8/83/All_bran_cereal_logo.png",
            "siteUrl": "https://www.all-bran.com/en_US/home.html",
            "key": "all-bran"
        },
        "bran-flakes": {
            "names": [
                "Bran Flakes"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:17:01.579Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Bran_Flakes",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/9/90/Bran_flakes_post_logo.png",
            "siteUrl": "https://www.postconsumerbrands.com/bran-flakes/",
            "key": "bran-flakes"
        },
        "cheez-it": {
            "names": [
                "Cheez-It"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:17:01.745Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Cheez-It",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/2a/Cheez-It_Logo.svg",
            "siteUrl": "https://www.cheezit.com/en_US/home.html",
            "key": "cheez-it"
        },
        "club-crackers": {
            "names": [
                "Club Crackers"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:17:01.804Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Club_Crackers",
            "key": "club-crackers"
        },
        "cocoa-krispies": {
            "names": [
                "Cocoa Krispies"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:17:01.987Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Cocoa_Krispies",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/b9/Cocoakrispies_brand_logo.png",
            "key": "cocoa-krispies"
        },
        "corn-flakes": {
            "names": [
                "Corn Flakes"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:17:02.849Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Corn_Flakes",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/d1",
            "siteUrl": "https://www.wkkellogg.com/our-foods/our-brands/corn-flakes",
            "key": "corn-flakes"
        },
        "crunchy-nut": {
            "names": [
                "Crunchy Nut"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:17:03.079Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Crunchy_Nut",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/a/a3/Crunchynut_brand_logo.png",
            "siteUrl": "https://www.kelloggs.co.uk/en_GB/products/crunchy-nut-corn-flakes.html",
            "key": "crunchy-nut"
        },
        "eggo": {
            "names": [
                "Eggo"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:17:03.242Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Eggo",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/a9/Eggo_logo_%282006-present%29.svg",
            "siteUrl": "https://www.leggomyeggo.com/",
            "key": "eggo"
        },
        "froot-loops": {
            "names": [
                "Froot Loops"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:17:03.318Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Froot_Loops",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/9/9d/Frootloops_brand_logo.png",
            "siteUrl": "https://www.frootloops.com/en_US/home.html",
            "key": "froot-loops"
        },
        "frosted-flakes": {
            "names": [
                "Frosted Flakes"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:17:03.374Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Frosted_Flakes",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/7e/Frostedflakes_brand_logo.png",
            "siteUrl": "https://www.frostedflakes.com/en_US/home.html",
            "key": "frosted-flakes"
        },
        "honey-smacks": {
            "names": [
                "Honey Smacks"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:17:03.563Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Honey_Smacks",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/0e/Honeymacks_brand_logo.png",
            "siteUrl": "https://www.kelloggs.com/en_US/brands/honey-smacks-consumer-brand.html",
            "key": "honey-smacks"
        },
        "morningstar-farms": {
            "names": [
                "Morningstar Farms"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:17:03.794Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Morningstar_Farms",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/96/Morningstar_Farms.svg",
            "siteUrl": "https://www.morningstarfarms.com/",
            "key": "morningstar-farms"
        },
        "nutri-grain": {
            "names": [
                "Nutri-Grain"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:17:04.193Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Nutri-Grain",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/f/f2/Nutrigrain_brand_logo.png",
            "siteUrl": "https://www.kelloggs.com/en_US/brands/nutri-grain-consumer-brand.html",
            "key": "nutri-grain"
        },
        "pop-tarts": {
            "names": [
                "Pop-Tarts"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:17:04.807Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Pop-Tarts",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/cc/Poptarts_brand_logo.png",
            "siteUrl": "https://www.poptarts.com/en_US/home.html",
            "key": "pop-tarts"
        },
        "pringles": {
            "names": [
                "Pringles",
                "Pringle's Newfangled Potato Chips"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:17:05.047Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Pringles",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/f/f6/Pringles_2021.svg",
            "siteUrl": "https://www.pringles.com/us/home.html",
            "key": "pringles"
        },
        "rice-krispies": {
            "names": [
                "Rice Krispies"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:17:05.121Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Rice_Krispies",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/59/Rice_Krispies_logo.svg",
            "siteUrl": "https://www.ricekrispies.com/en_US/home.html",
            "key": "rice-krispies"
        },
        "rice-krispies-treats": {
            "names": [
                "Rice Krispies Treats"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:17:05.190Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Rice_Krispies_Treats",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/e/ec/Ricekrispiestreats_brand_logo.png",
            "siteUrl": "https://www.kelloggs.com/en_US/brands/rice-krispies-consumer-brand.html",
            "key": "rice-krispies-treats"
        },
        "rxbar": {
            "names": [
                "Rxbar"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:17:05.268Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Rxbar",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/04/RXBAR_Logo.png",
            "siteUrl": "https://www.rxbar.com/",
            "key": "rxbar"
        },
        "special-k": {
            "names": [
                "Special K"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:17:05.337Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Special_K",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/03/Specialk_brand_logo.png",
            "siteUrl": "https://www.specialk.com/en_US/products/cereal.html",
            "key": "special-k"
        },
        "kind": {
            "names": [
                "KIND"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 17,
            "ownedBy": [
                "mars"
            ],
            "updatedAt": "2026-03-31T10:17:06.039Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Kind_(company)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/77/Logo_for_KIND_Bars_Healthy_Snacks.jpg",
            "siteUrl": "https://www.kindsnacks.com/",
            "key": "kind"
        },
        "marshalls": {
            "names": [
                "Marshalls"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 45,
            "ownedBy": [
                "tk-maxx"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/8b/Marshalls_Logo.svg",
            "siteUrl": "https://www.marshalls.com/",
            "updatedAt": "2026-04-01T17:42:32.610Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Marshalls_plc",
            "key": "marshalls"
        },
        "marvel": {
            "names": [
                "Marvel"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "toys"
            ],
            "score": 20,
            "ownedBy": [
                "disney"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/b9/Marvel_Logo.svg",
            "siteUrl": "http://marvel.com/",
            "updatedAt": "2026-04-02T15:00:27.919Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Marvel_Entertainment",
            "key": "marvel"
        },
        "mastercard": {
            "names": [
                "Mastercard",
                "Mastercard Inc.",
                "Interbank",
                "Master Charge",
                "Mastercard Worldwide",
                "MA"
            ],
            "comment": "Mastercard is a U.S. company that collaborated with the Nigerian government to track payments linked to ID cards [1], tricked customers into sharing financial data [2], and sells customer payment data for profit [3]. It has charged illegal fees and overcharged customers [4][5][6], engaged in anticompetitive monopolistic practices [7][8][9], and discriminated against employees on race and gender grounds [10].",
            "sources": {
                "1": "https://www.premiumtimesng.com/featured-news/167479-scandalous-outrage-in-nigeria-as-government-brands-national-id-card-with-mastercards-logo.html",
                "2": "https://news.bloomberglaw.com/litigation/mastercard-unit-hit-with-lawsuit-over-sharing-of-financial-data",
                "3": "https://www.theverge.com/2018/8/30/17801880/google-mastercard-data-online-ads-offline-purchase-history-privacy",
                "4": "https://www.quinnemanuel.com/the-firm/news-events/firm-news-14-billion-damages-claim-filed-against-mastercard-by-uk-consumers-in-landmark-collective-action/",
                "5": "https://www.ft.com/content/19c70ff2-3aaa-4e07-96e0-0e657a68920f?syn-25a6b1a6=1",
                "6": "https://www.bbc.co.uk/news/business-55273546",
                "7": "https://www.reuters.com/sustainability/boards-policy-regulation/mastercard-visas-merchant-fees-breach-competition-law-uk-tribunal-rules-2025-06-27/",
                "8": "https://www.bbc.co.uk/news/business-56594987",
                "9": "https://www.law360.com/articles/1083744",
                "10": "https://fortune.com/2025/01/17/mastercard-accused-underpaying-employees-discrimination-lawsuit/"
            },
            "sourceNotes": {
                "1": "collaborated with the Nigerian govnermnent to track payments connected to ID cards",
                "2": "tricked customers into sharing financial data",
                "3": "sells customer payment data for profit",
                "4": "charged illegal fees to customers",
                "5": "overcharged customers",
                "6": "overcharged customers",
                "7": "anticompetitive molopolistic practices",
                "8": "anticompetitive molopolistic practices",
                "9": "anticompetitive molopolistic practices",
                "10": "race and gender discrimination against thousands of employees"
            },
            "tags": [
                "finance",
                "tech",
                "anticompetitive practices",
                "deception",
                "privacy violations",
                "racial discrimination",
                "gender discrimination"
            ],
            "score": 34,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/a4/Mastercard_2019_logo.svg",
            "siteUrl": "http://mastercard.com/",
            "updatedAt": "2026-04-02T15:00:27.919Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Mastercard",
            "key": "mastercard"
        },
        "mercadona": {
            "key": "mercadona",
            "names": [
                "Mercadona"
            ],
            "comment": "Mercadona is a Spanish supermarket chain which has consistently subjected its employees to excessive pressure, harassment, and wrongful termination [1][2][3][4][5], forcing employees to work while unwell [6] and even sending delivery drivers into deadly floods [7]. The company has also illegally used facial recognition and surveillance in its stores without customer consent [8][9].",
            "sources": {
                "1": "https://cadenaser.com/galicia/2025/06/20/la-cig-denuncia-acoso-laboral-en-el-mercadona-de-porto-do-molle-en-nigran-radio-vigo/",
                "2": "https://www.theolivepress.es/spain-news/2024/11/18/mercadona-worker-who-was-fired-for-eating-a-croqueta-destined-for-the-trash-wins-legal-battle-in-spain/",
                "3": "https://russpain.com/en/news-3/mercadona-scandal-veteran-fired-over-single-snack-bag-what-s-behind-the-story-377539/",
                "4": "https://www.rtp.pt/noticias/pais/prova-dos-factos-rede-mercadona-acusada-de-agir-como-uma-seita_v1534194",
                "5": "https://www.huffingtonpost.es/sociedad/una-empleada-siente-presionada-mercadona-busca-abogado-juez-obliga-indemnizarla-40000-euros-mercadona-me-dejar-entrar-supermercadosbr.html",
                "6": "https://inspain.news/call-for-a-boycott-of-mercadona-because-of-labour-abuse/",
                "7": "https://www.business-humanrights.org/en/latest-news/criminal-companies-outrage-as-mercadona-sends-driver-out-into-deadly-floods-while-other-firms-are-slammed-for-endangering-employees/",
                "8": "https://euroweeklynews.com/2025/06/04/is-your-supermarket-spying-on-you-mercadona-carrefour-got-caught/",
                "9": "https://gdprhub.eu/index.php?title=AEPD_(Spain)_-_PS/00120/2021"
            },
            "sourceNotes": {
                "1": "workplace harassment",
                "2": "fired employee for eating one out of date item",
                "3": "fired employee for eating one out of date item",
                "4": "pressure on and harassment of employees",
                "5": "pressure on and harassment of employees",
                "6": "poor working conditions, forcing employees to work while unwell",
                "7": "sent delivery driver into deadly floods",
                "8": "used facial recognition in stores without customers consent"
            },
            "tags": [
                "retail",
                "supermarket",
                "forced labour",
                "poor working conditions",
                "unsafe working conditions",
                "privacy violations",
                "sexual harassment"
            ],
            "score": 37,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/8/89/Mercadona_logo.png",
            "siteUrl": "http://www.mercadona.com/",
            "updatedAt": "2026-04-09T06:32:30.327Z"
        },
        "rank-hovis-mcdougall": {
            "key": "rank-hovis-mcdougall",
            "names": [
                "Rank Hovis McDougall",
                "McDougall's"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "beverages"
            ],
            "score": 43,
            "ownedBy": [
                "premier-foods"
            ],
            "updatedAt": "2026-04-05T15:04:45.095Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Rank_Hovis_McDougall",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/dc/RHMlogo.PNG"
        },
        "mediamarkt": {
            "names": [
                "MediaMarkt"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "electronics"
            ],
            "score": 24,
            "ownedBy": [
                "ceconomy"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/f/f0/Media_Markt_logo.svg",
            "siteUrl": "https://www.mediamarktsaturn.com/",
            "updatedAt": "2026-04-06T08:39:29.014Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/MediaMarkt"
        },
        "ceconomy": {
            "names": [
                "Ceconomy",
                "Ceconomy AG",
                "CEC"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "electronics"
            ],
            "score": 24,
            "ownedBy": [
                "jingdong-group"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/e/ec/Ceconomy_2017_logo.svg",
            "siteUrl": "https://www.ceconomy.de/",
            "updatedAt": "2026-04-06T09:00:20.474Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Ceconomy"
        },
        "saturn": {
            "key": "saturn",
            "names": [
                "Saturn"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "electronics"
            ],
            "score": 24,
            "ownedBy": [
                "ceconomy"
            ],
            "updatedAt": "2026-04-06T09:03:40.964Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Saturn_(store)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/c3/Saturn-Logo.svg",
            "siteUrl": "https://www.mediamarktsaturn.com/"
        },
        "imtron": {
            "key": "imtron",
            "names": [
                "Imtron"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "electronics"
            ],
            "score": 24,
            "ownedBy": [
                "ceconomy"
            ],
            "updatedAt": "2026-04-06T09:03:41.126Z",
            "wikipediaUrl": "https://de.wikipedia.org/wiki/Imtron",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/29/IMTRON_N2017_RGB.png",
            "siteUrl": "https://www.imtron.eu/"
        },
        "melissa-and-doug": {
            "key": "melissa-and-doug",
            "names": [
                "Melissa & Doug"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys"
            ],
            "score": 36,
            "ownedBy": [
                "spin-master"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/a0/Melissa_%26_Doug_logo.svg",
            "siteUrl": "http://melissaanddoug.com/",
            "updatedAt": "2026-04-07T17:49:26.008Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Melissa_%26_Doug"
        },
        "maxwell-house": {
            "names": [
                "Maxwell House"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "coffee"
            ],
            "score": 35,
            "ownedBy": [
                "jde-peet's",
                "kraft-heinz"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/8/89/Maxwellhouse_coffee_logo.png",
            "siteUrl": "https://themaxwell.house/",
            "updatedAt": "2026-04-04T11:57:36.825Z"
        },
        "menards": {
            "key": "menards",
            "names": [
                "Menards"
            ],
            "comment": "Menards is an American home improvement store that has been accused of false advertising and misleading pricing [1][2], price gouging during the pandemic [3], and a strongly anti‑union stance that refuses to hire anyone who has worked in a union shop [4]. The company has also faced allegations of overworking employees, punishing young mothers for pumping breast milk [5], illegal waste dumping and environmental violations including discharging pollutants into rivers [6][7][8], engaging in corruption with politicians [9], subjecting employees to sexual harassment in the workplace [10], and multiple employee deaths on the job [11].",
            "sources": {
                "1": "https://openclassactions.com/settlements/menards-false-advertising-class-action-settlement.php",
                "2": "https://www.msn.com/en-us/money/general/menards-to-pay-millions-after-rebates-called-misleading/ar-AA1T7VL0",
                "3": "https://www.fox2detroit.com/news/michigan-ag-sends-cease-and-desist-letter-to-menards-over-price-gouging",
                "4": "https://www.milwaukeemag.com/bigmoney-john-menard/",
                "5": "https://www.slashgear.com/2005865/lawsuit-against-menards-explained-hardware-store-legal-trouble/",
                "6": "https://archive.jsonline.com/business/114143619.html/",
                "7": "https://www.milwaukeemag.com/bigmoney-john-menard/",
                "8": "https://dailyreporter.com/2005/08/09/menard-fined-for-violating-water-pollution-laws/",
                "9": "https://www.yahoo.com/politics/wisconsin-gov-scott-walker-photo-charlie-114429739886.html?guccounter=1",
                "10": "https://www.clevescene.com/news/menards-to-pay-former-avon-employee-342000-after-failing-to-take-action-against-serial-harasser-41771832/",
                "11": "https://www.slashgear.com/2005865/lawsuit-against-menards-explained-hardware-store-legal-trouble/"
            },
            "sourceNotes": {
                "1": "false advertising and misleading pricing",
                "2": "false advertising and misleading pricing",
                "3": "price gouging duing pandemic",
                "4": "strongly anti-union, refusing to hire anyone having worked in a union shop",
                "5": "overworked employees, punishing young mothers for pumping breast milk",
                "6": "illegal waste dumping",
                "7": "several environmental violations",
                "8": "illegally discharging pollutants into rivers",
                "9": "engaged in corruption, donating and receiving benefits from politicians",
                "10": "sexual harassment in workplace",
                "11": "several employees killed at work"
            },
            "tags": [
                "retail",
                "diy",
                "deception",
                "anti‑union practices",
                "poor working conditions",
                "sexual harassment",
                "corruption",
                "environmental violations",
                "unsafe working conditions"
            ],
            "score": 20,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/e/e0/Menards_Stripe_Logo.svg",
            "siteUrl": "https://www.menards.com/",
            "updatedAt": "2026-04-08T07:15:30.433Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Menards"
        },
        "merck": {
            "key": "merck",
            "names": [
                "Merck",
                "Merck & Co.",
                "Merck & Co., Inc.",
                "MRK"
            ],
            "comment": "Merck is a U.S. pharmaceutical company that has engaged in tax avoidance [1], sold several unsafe medications [2][3][4][5], and discharged toxic chemicals into rivers, causing fish deaths [6]. The company has defrauded Medicaid of hundreds of millions of dollars [7][8][9], engaged in deceptive marketing of unsafe products [10][11], discredited doctors who questioned their dangerous medication [12], and sold medication that killed 25,000 people while refusing to compensate victims fairly [13][14].",
            "sources": {
                "1": "https://www.cnbc.com/2007/02/14/merck-agrees-to-settle-23-billion-tax-dispute-with-irs.html",
                "2": "https://www.reuters.com/legal/litigation/court-revives-more-than-500-lawsuits-over-fosamax-femur-fracture-risk-2024-09-20/",
                "3": "https://www.reuters.com/article/us-merck-fosamax-idUSBRE9B811S20131209",
                "4": "https://www.biospace.com/article/investigation-finds-merck-s-anti-baldness-drug-long-linked-to-suicide-reports/",
                "5": "https://time.com/6515/nuvaring-settlement-100-million-dollars/",
                "6": "https://www.epa.gov/archive/epapages/newsroom_archive/newsreleases/fcf170d8474c34db852573b0006806a8.html",
                "7": "https://www.justice.gov/opa/pr/2008/February/08_civ_094.html",
                "8": "https://www.washingtonpost.com/wp-dyn/content/article/2008/02/07/AR2008020701336.html",
                "9": "https://www.fiercebiotech.com/biotech/merck-resolves-federal-and-state-investigations-related-to-certain-activities",
                "10": "http://ktar.com/?nid=6&sid=842595&r=1",
                "11": "https://www.justice.gov/archives/opa/pr/us-pharmaceutical-company-merck-sharp-dohme-pay-nearly-one-billion-dollars-over-promotion?bm-verify=AAQAAAAN_____92eTKFngIA0z4TNADFhCoXlfr82-ziWJ3aP7TjkmZKkXaU2eHSMb1C7Ge_1GpZG-nFykcsesT2StBtlCzHoJBpXK-qBRAw8NYx9l0cCsd1cpthw42MW8Gker-pHWwtvSQMp3a3oMxg6lIBS16ErbTb-x_zyK1CtET8IQHHbQlrbjuO0Y8FCZqzAcj7P_V2gd_7cu4cv6EAJlblC7pt8YGWBeepQKWzNy0-nZJsZodh8az-B_0fSWsS4gwwpxuVJfs4T5fSHWsY_xbtwi1XzqtBN-7O0PkhihxuYEgia-fvd4JGVoK3HwqEkpNxB5HFTrjD0Fv9QMb4NelUkRCJJlziZ6H9SMhm3vfxAuxgUdUEaLBiFqRJGq8nRU_qZNJfSKA5dRCT1ns28l59ejd9Tp1Esbdo",
                "12": "https://www.news.com.au/news/drug-company-drew-up-doctor-hit-list/news-story/eb55ca36e081d497730629e6c8559abf",
                "13": "https://web.archive.org/web/20081027220130/http://www.prospect-magazine.co.uk/article_details.php?id=10425",
                "14": "https://www.nbcnews.com/health/health-news/report-vioxx-linked-thousands-deaths-flna1c9445945#:~:text=The%20Journal's%20report,%20citing%20a,been%20used%20instead%20of%20Vioxx."
            },
            "sourceNotes": {
                "1": "tax avoidance",
                "2": "sold several unsafe medications",
                "3": "sold several unsafe medications",
                "4": "sold several unsafe medications",
                "5": "sold several unsafe medications",
                "6": "discharged toxic chemicals into rivers, leading to fish deaths",
                "7": "defrauded medicaid of hundreds of millions of dollars",
                "8": "defrauded medicaid of hundreds of millions of dollars",
                "9": "defrauded medicaid of hundreds of millions of dollars",
                "10": "deceptive marketing of unsafe products",
                "11": "deceptive marketing of unsafe products",
                "12": "discredited doctors who questioned their dangerous medication",
                "13": "sold medication that killed 25,000 people and refused to compensate victims fairly",
                "14": "sold medication that killed 25,000 people and refused to compensate victims fairly"
            },
            "tags": [
                "pharmaceuticals",
                "tax avoidance",
                "unsafe practices",
                "environmental violations",
                "deception",
                "corruption"
            ],
            "score": 3,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/94/Merck_Logo.svg",
            "siteUrl": "http://merck.com/",
            "updatedAt": "2026-04-10T11:35:07.290Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Merck_Group"
        },
        "micro-center": {
            "key": "micro-center",
            "names": [
                "Micro Center"
            ],
            "comment": "Micro Center is a US-based electronics retailer that has been accused of mis-selling empty boxes to customers rather than products [1].",
            "sources": {
                "1": "https://www.tomshardware.com/pc-components/gpus/dude-wheres-my-gpu-microcenter-customer-gets-backpack-stuffed-box-instead-of-rtx-5090"
            },
            "sourceNotes": {
                "1": "mis-sold empty boxes to customers rather than products"
            },
            "tags": [
                "retail",
                "electronics",
                "deception"
            ],
            "score": 50,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/3e/Micro_Center_logo.svg",
            "siteUrl": "https://microcenter.com/",
            "updatedAt": "2026-04-10T11:35:07.290Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Micro_Center"
        },
        "monzo": {
            "key": "monzo",
            "names": [
                "Monzo",
                "Monzo Bank Limited",
                "Monzo Bank",
                "Focus FS Limited"
            ],
            "comment": "Monzo is a UK-based digital bank that has provided inaccurate fee and statement information to customers [1][2][3][4], froze customer accounts without good reason [5], prioritized profits over customers and employees [6], failed in anti‑money‑laundering compliance [7][8], and wrongly denied refunds to scam victims [9].",
            "sources": {
                "1": "https://www.gov.uk/government/publications/cma-letter-to-monzo-about-breaching-parts-3-7-8-and-12-of-the-retail-banking-order",
                "2": "https://assets.publishing.service.gov.uk/government/uploads/system/uploads/attachment_data/file/995344/Public_letter_to_Monzo_2021_.pdf",
                "3": "https://www.gov.uk/government/publications/cma-letter-to-monzo-about-one-breach-of-the-retail-banking-order",
                "4": "https://www.gov.uk/government/publications/cma-letter-to-monzo-on-a-breach-of-the-retail-banking-order",
                "5": "https://inews.co.uk/inews-lifestyle/money/saving-and-banking/monzo-stole-money-online-bank-facebook-group-995493",
                "6": "https://www.telegraph.co.uk/business/2023/03/11/how-monzo-shelved-righteous-mission-pursuit-profits/",
                "7": "https://www.ft.com/content/d9587544-fb84-40c0-aab5-89a75670285f?syn-25a6b1a6=1",
                "8": "https://complyfactor.com/the-21-1-million-wake-up-call-critical-lessons-from-monzos-aml-failures/",
                "9": "https://www.theguardian.com/money/2026/feb/07/monzo-natwest-hsbc-refunds-fraud-scam-fos-ombudsman"
            },
            "sourceNotes": {
                "1": "provided innaccurate fee and statement information to customers",
                "2": "provided innaccurate fee and statement information to customers",
                "3": "provided innaccurate fee and statement information to customers",
                "4": "provided innaccurate fee and statement information to customers",
                "5": "froze customer accounts without good reason",
                "6": "prioritised profits over customers and employees",
                "7": "Anti money-laundering failures",
                "8": "Anti money-laundering failures",
                "9": "wrongly denied refunds to scam victims"
            },
            "tags": [
                "finance",
                "deception",
                "privacy violations"
            ],
            "score": 45,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/b2/Monzo_2022_logo.svg",
            "siteUrl": "https://monzo.com/",
            "updatedAt": "2026-04-12T06:00:09.562Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Monzo"
        },
        "7-up": {
            "key": "7-up",
            "names": [
                "7 Up"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:13.544Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/7_Up",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/25/7Up_logo_%282024%29.svg",
            "siteUrl": "https://www.7up.com/"
        },
        "agousha": {
            "key": "agousha",
            "names": [
                "Agousha"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:14.521Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Wimm-Bill-Dann_Foods",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/8/8f/WBD_logo_en.png"
        },
        "amp-energy": {
            "key": "amp-energy",
            "names": [
                "AMP Energy"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:14.890Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/AMP_Energy",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/79/Mountaindew_amp_brand_logo.png",
            "siteUrl": "https://www.mountaindew.com/product/mtn-dew-amp-original"
        },
        "aquafina": {
            "key": "aquafina",
            "names": [
                "Aquafina"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:15.516Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Aquafina",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/69/Aquafina_Logo.svg",
            "siteUrl": "http://aquafina.com/"
        },
        "aunt-jemima": {
            "key": "aunt-jemima",
            "names": [
                "Aunt Jemima"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:15.704Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Aunt_Jemima",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/50/Aunt_Jemima_logo_%28red%29.png"
        },
        "pearl-milling-company": {
            "key": "pearl-milling-company",
            "names": [
                "Pearl Milling Company"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:16.158Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Pearl_Milling_Company",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/3d/Pearl_milling_co_textlogo.png",
            "siteUrl": "https://www.pearlmillingcompany.com/"
        },
        "cap'n-crunch": {
            "key": "cap'n-crunch",
            "names": [
                "Cap'n Crunch"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:16.473Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Cap%27n_Crunch",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/d/d4/Capcrunch_textlogo.png",
            "siteUrl": "https://www.capncrunch.com/"
        },
        "cheetos": {
            "key": "cheetos",
            "names": [
                "Cheetos"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:16.835Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Cheetos",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/24/Cheetos_logo.svg",
            "siteUrl": "https://www.cheetos.com/"
        },
        "chipsy": {
            "key": "chipsy",
            "names": [
                "Chipsy"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:17.007Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Lay%27s",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/c4/Lay%27s_2025.svg",
            "siteUrl": "https://www.lays.com/"
        },
        "cracker-jack": {
            "key": "cracker-jack",
            "names": [
                "Cracker Jack"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:17.186Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Cracker_Jack",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/9/99/Cracker_jack_brand_logo.png",
            "siteUrl": "https://www.fritolay.com/products/cracker-jack-original-caramel-coated-popcorn-peanuts"
        },
        "crush": {
            "key": "crush",
            "names": [
                "Crush"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:17.342Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Crush_(drink)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/6a/Crush_Soda_Logo_New.png",
            "siteUrl": "https://www.crushsoda.com/"
        },
        "doritos": {
            "key": "doritos",
            "names": [
                "Doritos"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:19.410Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Doritos",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/9/9a/Doritos_Logo_%282013%29.png",
            "siteUrl": "http://doritos.com/"
        },
        "duyvis": {
            "key": "duyvis",
            "names": [
                "Duyvis"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:19.766Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Duyvis"
        },
        "elma-chips": {
            "key": "elma-chips",
            "names": [
                "Elma Chips"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:20.163Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Elma_Chips",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/16/ElmaChips_logo.svg",
            "siteUrl": "https://elmachips.com.br/"
        },
        "emperador": {
            "key": "emperador",
            "names": [
                "Emperador",
                "Gamesa"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:20.579Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Gamesa",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/b/b5/Gamesa.gif",
            "siteUrl": "https://www.gamesacookies.com/"
        },
        "fandangos": {
            "key": "fandangos",
            "names": [
                "Fandangos"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:21.182Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Fandangos_(snack)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/f/fb/Fandangos_EC.png",
            "siteUrl": "https://www.pepsico.com.br/nossas-marcas/nossas-marcas"
        },
        "frito-lay": {
            "key": "frito-lay",
            "names": [
                "Frito-Lay"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:21.270Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Frito-Lay",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/67/Fritolay_company_logo.svg",
            "siteUrl": "https://fritolay.com/"
        },
        "fritos": {
            "key": "fritos",
            "names": [
                "Fritos"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:21.418Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Fritos",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/1/11",
            "siteUrl": "https://www.fritos.com/"
        },
        "frustyle": {
            "key": "frustyle",
            "names": [
                "Frustyle"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:21.805Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Lebedyansky_(company)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/4/4d"
        },
        "g2": {
            "key": "g2",
            "names": [
                "G2"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:22.011Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Gatorade#Products",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/9b/Gatorade_logo.svg",
            "siteUrl": "https://gatorade.com/"
        },
        "gatorade": {
            "key": "gatorade",
            "names": [
                "Gatorade"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:22.400Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Gatorade",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/9b/Gatorade_logo.svg",
            "siteUrl": "https://gatorade.com/"
        },
        "grandma's": {
            "key": "grandma's",
            "names": [
                "Grandma's"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:22.650Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Grandma%27s_(brand)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/67/Fritolay_company_logo.svg",
            "siteUrl": "https://fritolay.com/"
        },
        "izze": {
            "key": "izze",
            "names": [
                "Izze"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:23.498Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Izze_(drink)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/6/6b/Izze_drink_logo.png"
        },
        "kas": {
            "key": "kas",
            "names": [
                "Kas"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:23.832Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Kas_(drink)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/10/Kas_marca_logo.png",
            "siteUrl": "https://www.pepsico.es/es-es/marcas/informaci%C3%B3n-de-producto"
        },
        "kurkure": {
            "key": "kurkure",
            "names": [
                "Kurkure"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:24.011Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Kurkure",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/e/e5/Kurkure_Logo.png"
        },
        "life": {
            "key": "life",
            "names": [
                "Life"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:24.199Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Life_(cereal)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/63/Life_cereal_logo.png/120px-Life_cereal_logo.png.png",
            "siteUrl": "https://www.quakeroats.com/products/cold-cereals/life-cereal"
        },
        "lifewater": {
            "key": "lifewater",
            "names": [
                "Lifewater"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:24.733Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/SoBe",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/b/bf/Current_SoBe_logo.svg",
            "siteUrl": "http://www.sobe.com/"
        },
        "manzanita-sol": {
            "key": "manzanita-sol",
            "names": [
                "Manzanita Sol"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:25.300Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Manzanita_Sol",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/f/f2/Manzanita_Sol.jpg"
        },
        "matutano": {
            "key": "matutano",
            "names": [
                "Matutano"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:25.735Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Matutano",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/1/12/Matutano_company_logo.png"
        },
        "marbo-product": {
            "key": "marbo-product",
            "names": [
                "Marbo Product"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:25.822Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Marbo_Product",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/2/29/Marbo_Product_logo.png",
            "siteUrl": "http://www.pepsico.rs/"
        },
        "mirinda": {
            "key": "mirinda",
            "names": [
                "Mirinda"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:25.939Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Mirinda",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/b8/Mirinda_logo_2023.svg"
        },
        "miss-vickie's": {
            "key": "miss-vickie's",
            "names": [
                "Miss Vickie's"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:26.069Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Miss_Vickie%27s",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ce/Miss_vickies_brand_logo.png/120px-Miss_vickies_brand_logo.png.png",
            "siteUrl": "https://www.tastyrewards.com/en-ca/brands/missvickies/"
        },
        "mountain-dew": {
            "key": "mountain-dew",
            "names": [
                "Mountain Dew"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:26.460Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Mountain_Dew",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/97/Mountain_Dew_2025_logo.svg/120px-Mountain_Dew_2025_logo.svg.png",
            "siteUrl": "https://mountaindew.com/"
        },
        "mug": {
            "key": "mug",
            "names": [
                "Mug"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:29.375Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Mug_Root_Beer",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/0/05/Mug_root_beer_logo.png",
            "siteUrl": "https://mugrootbeer.com/"
        },
        "naked": {
            "key": "naked",
            "names": [
                "Naked"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:29.623Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Naked_Juice",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/8/89/NakedJuiceLogo.svg",
            "siteUrl": "https://www.nakedjuice.com/"
        },
        "paso-de-los-toros": {
            "key": "paso-de-los-toros",
            "names": [
                "Paso de los Toros"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:30.194Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Paso_de_los_Toros_(drink)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/e/ea"
        },
        "pasta-roni": {
            "key": "pasta-roni",
            "names": [
                "Pasta Roni"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:30.730Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Pasta_Roni",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/5/54/Pasta_Roni-Rice_a_Roni_Logos.png",
            "siteUrl": "https://www.ricearoni.com/"
        },
        "pepsi": {
            "key": "pepsi",
            "names": [
                "Pepsi"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:31.176Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Pepsi",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/68/Pepsi_2023.svg",
            "siteUrl": "https://www.pepsi.com/"
        },
        "pioneer-foods": {
            "key": "pioneer-foods",
            "names": [
                "Pioneer Foods"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:32.700Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Pioneer_Foods",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/6/6d/Pioneer_Foods_logo.png",
            "siteUrl": "http://pioneerfoods.co.za/"
        },
        "punica": {
            "key": "punica",
            "names": [
                "Punica"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:32.935Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Punica_(drink)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/79/Punica-Logo.svg/120px-Punica-Logo.svg.png",
            "siteUrl": "https://www.punica.de/"
        },
        "propel": {
            "key": "propel",
            "names": [
                "Propel"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:33.071Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Propel_Fitness_Water",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/d9/Propel_logo.svg",
            "siteUrl": "https://www.propelwater.com/"
        },
        "quaker": {
            "key": "quaker",
            "names": [
                "Quaker"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:33.391Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Quaker_Oats_Company",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/5/5d/Quaker_Oats_logo_2017.png",
            "siteUrl": "https://www.quakeroats.com/"
        },
        "rice-a-roni": {
            "key": "rice-a-roni",
            "names": [
                "Rice-A-Roni"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:33.551Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Rice-A-Roni",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/5/54/Pasta_Roni-Rice_a_Roni_Logos.png",
            "siteUrl": "https://www.ricearoni.com/"
        },
        "rockstar-(drink)": {
            "key": "rockstar-(drink)",
            "names": [
                "Rockstar (drink)"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:33.723Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Rockstar_(drink)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/b/bf/Primary_logo_for_Rockstar_Energy_as_of_2024.svg",
            "siteUrl": "https://rockstarenergy.com/"
        },
        "rold-gold": {
            "key": "rold-gold",
            "names": [
                "Rold Gold"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:34.210Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Rold_Gold",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/Roldgold_brand_logo.png/120px-Roldgold_brand_logo.png.png",
            "siteUrl": "https://www.roldgold.com/"
        },
        "ruffles": {
            "key": "ruffles",
            "names": [
                "Ruffles"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:34.295Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Ruffles_(potato_chips)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/4a/Ruffles_2021.svg",
            "siteUrl": "https://www.ruffles.com/"
        },
        "sabra": {
            "key": "sabra",
            "names": [
                "Sabra"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:34.695Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Sabra_(company)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/7/7e/Sabra_%28food_industry_business%29_logo.png",
            "siteUrl": "https://sabra.com/"
        },
        "sabritas": {
            "key": "sabritas",
            "names": [
                "Sabritas"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:35.166Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Sabritas",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/39/Sabritas_2026_logo.svg",
            "siteUrl": "https://www.sabritas.com.mx/"
        },
        "sakata": {
            "key": "sakata",
            "names": [
                "Sakata"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:35.398Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/The_Smith%27s_Snackfood_Company",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/8/8e/Smiths_Logo.png",
            "siteUrl": "https://smiths-chips.com.au/"
        },
        "smartfood": {
            "key": "smartfood",
            "names": [
                "Smartfood"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:35.864Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Smartfood",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/2/27/Smartfoodpopcorn.png",
            "siteUrl": "https://www.smartfood.com/"
        },
        "sodastream": {
            "key": "sodastream",
            "names": [
                "Sodastream"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:36.131Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Sodastream",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/SodaStream_Logo_2025.png/120px-SodaStream_Logo_2025.png.png",
            "siteUrl": "https://sodastream.com/"
        },
        "starry": {
            "key": "starry",
            "names": [
                "Starry"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:36.990Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Starry_(drink)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/e/e2/Can_of_Starry_Lemon-Lime_Soda.png",
            "siteUrl": "http://starrylemonlime.com/"
        },
        "sunchips": {
            "key": "sunchips",
            "names": [
                "SunChips"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:37.224Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/SunChips",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/b/bc",
            "siteUrl": "https://www.sunchips.com/"
        },
        "tostitos": {
            "key": "tostitos",
            "names": [
                "Tostitos"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:37.817Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Tostitos",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fe/Tostitos_logo_2026.webp/120px-Tostitos_logo_2026.webp.png",
            "siteUrl": "https://www.tostitos.com/"
        },
        "twisties": {
            "key": "twisties",
            "names": [
                "Twisties"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:38.365Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Twisties",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/b/bf/Twisties_logo.png",
            "siteUrl": "http://www.smiths.com.au/brands/twisties"
        },
        "walkers": {
            "key": "walkers",
            "names": [
                "Walkers"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "plastic",
                "water depletion",
                "deforestation"
            ],
            "score": 20,
            "ownedBy": [
                "pepsico"
            ],
            "updatedAt": "2026-04-12T18:44:39.014Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Walkers_Crisps",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/f/fb/Walkers_Logo%2C_2026.svg",
            "siteUrl": "http://walkers.co.uk/"
        },
        "mozilla": {
            "key": "mozilla",
            "names": [
                "Mozilla",
                "Firefox"
            ],
            "comment": "Mozilla is an American organization that has sold users' data to advertisers without consent [1][2], claimed broad rights to user data accessed through Firefox [3], and tracked users without consent [4][5][6][7]. Mozilla has also discriminated against employees based on a cancer diagnosis [8][9] and refused to hire people involved in unions [10].",
            "sources": {
                "1": "https://arstechnica.com/information-technology/2015/12/firefox-retires-much-maligned-sponsored-tiles-hunts-for-new-revenue-streams/",
                "2": "https://www.zdnet.com/article/firefox-tests-cliqz-engine-which-slurps-user-browsing-data/",
                "3": "https://thehackernews.com/2025/03/mozilla-updates-firefox-terms-again.html",
                "4": "https://noyb.eu/en/firefox-tracks-you-privacy-preserving-feature",
                "5": "https://www.reuters.com/technology/mozilla-hit-with-privacy-complaint-over-firefox-user-tracking-2024-09-25/",
                "6": "https://blog.ssuiteoffice.com/articles/general/mozilla-firefox-ppa-tracking-w3c-privacy-spying-scandal.htm",
                "7": "https://www.windowscentral.com/software-apps/browsing/firefox-users-slam-mozilla-over-controversial-data-privacy-update",
                "8": "https://www.geekwire.com/2024/mozillas-product-chief-sues-the-firefox-maker-alleging-discrimination-after-cancer-diagnosis/",
                "9": "https://www.theregister.com/2024/06/24/mozilla_product_chief_sues_over/",
                "10": "https://www.bloomberg.com/news/articles/2023-11-22/nlrb-files-case-against-mozilla-for-not-hiring-labor-activist"
            },
            "sourceNotes": {
                "1": "sold users data to advertisers without consent",
                "2": "sold users data to advertisers without consent",
                "3": "claimed broad rights to user data accessed through firefox",
                "4": "tracking users without consent",
                "5": "tracking users without consent",
                "6": "tracking users without consent",
                "7": "tracking users without consent",
                "8": "discriminated against employee based on cancer diagnosis",
                "9": "discriminated against employee based on cancer diagnosis",
                "10": "refused to hire people who have been involved in unions"
            },
            "tags": [
                "privacy violations",
                "anti-union practices",
                "deception"
            ],
            "score": 40,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/d/df/Mozilla_2024_logo.svg",
            "siteUrl": "https://www.mozilla.org/",
            "updatedAt": "2026-04-13T18:29:01.486Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Mozilla_Corporation"
        },
        "s.-c.-johnson": {
            "key": "s.-c.-johnson",
            "names": [
                "S. C. Johnson",
                "SC Johnson",
                "S. C. Johnson & Son",
                "S. C. Johnson & Son, Inc."
            ],
            "comment": "S. C. Johnson is an American company that has engaged in false advertising [1], price‑fixing [2], tax evasion [3][4][5], dismissal of whistleblowers [4][5][6], underpaying of employee pensions [7], greenwashing [8], and continuing operations in Russia during the conflict [9]. The company has sold products that release microplastics into food [10] and exceeded air‑pollution limits [11], while the founding family has been implicated in paedophilic crimes [12][13].",
            "sources": {
                "1": "https://topclassactions.com/lawsuit-settlements/closed-settlements/method-cleaners-2-25m-class-action-settlement/",
                "2": "http://www.connexionfrance.com/court-appeal-price-fixing-fine-upheld-consumer-companies-gillette-loreal-procter-gamble-sc-johnson-18567-view-article.html",
                "3": "https://www.politifact.com/article/2011/sep/12/inside-sc-johnson-vs-david-cay-johnston-dispute-co/",
                "4": "https://web.archive.org/web/20110716194036/http://www.tax.com/taxcom/taxblog.nsf/Permalink/UBEN-8BTJ35?OpenDocument",
                "5": "http://www.whistleblowersblog.org/2011/12/articles/corporate-1/major-victory-for-whistleblowers-in-seventh-circuit-says-retaliation-is-a-rico-violation/",
                "6": "https://thenationonlineng.net/man-seeks-n50m-alleged-wrongful-sack/",
                "7": "https://www.law360.com/articles/564664/sc-johnson-settles-2-long-running-class-action-erisa-suits",
                "8": "http://www.scjohnson.com/en/press-room/press-releases/07-08-2011/SC-Johnson-Settles-Cases-Involving-Greenlist-Labeling.aspx",
                "9": "https://www.tmj4.com/news/local-news/s-c-johnson-defends-decision-to-stay-in-russia-following-f-from-yale-professor",
                "10": "https://eu.usatoday.com/story/money/2025/05/12/ziploc-class-action-lawsuit-microplastics/83577508007/",
                "11": "https://ww2.arb.ca.gov/sc-johnson-son-inc-case-settlement",
                "12": "https://www.forbes.com/sites/clareoconnor/2014/06/09/s-c-johnson-billionaire-gets-4-months-jail-6k-fine-in-child-sex-assault-case/",
                "13": "https://www.dailymail.co.uk/news/article-1369792/Billionaire-heir-SC-Johnson-family-fortune-charged-sexual-assault-15-year-old-girl.html"
            },
            "sourceNotes": {
                "1": "false advertising",
                "2": "price-fixing",
                "3": "tax evasion",
                "4": "tax evasion and dismissal of whistleblowers",
                "5": "tax evasion and dismissal of whistleblowers",
                "6": "dismissal of whistleblowers",
                "7": "underpaid employee pensions",
                "8": "greenwashing",
                "9": "initially continued operations in russia",
                "10": "sold products that release microplastics into food",
                "11": "sold products that exceeded air pollution limits",
                "12": "founding family committed paedophilic crimes",
                "13": "founding family committed paedophilic crimes"
            },
            "tags": [
                "consumer goods",
                "anticompetitive practices",
                "deception",
                "tax avoidance",
                "unfair pay",
                "greenwashing",
                "connections to russia",
                "environmental violations",
                "unsustainable practices"
            ],
            "score": 32,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/10/SC_Johnson_2018.svg",
            "siteUrl": "http://scjohnson.com/",
            "updatedAt": "2026-04-13T20:38:12.388Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/S._C._Johnson_%26_Son"
        },
        "baygon": {
            "key": "baygon",
            "names": [
                "Baygon"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 32,
            "ownedBy": [
                "s.-c.-johnson"
            ],
            "updatedAt": "2026-04-14T08:25:30.349Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Baygon",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/be/Baygonlogo.png"
        },
        "drano": {
            "key": "drano",
            "names": [
                "Drano"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 32,
            "ownedBy": [
                "s.-c.-johnson"
            ],
            "updatedAt": "2026-04-14T08:25:30.711Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Drano",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/29/Drano_Logo.png/120px-Drano_Logo.png.png",
            "siteUrl": "http://drano.com/"
        },
        "fantastik": {
            "key": "fantastik",
            "names": [
                "Fantastik"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 32,
            "ownedBy": [
                "s.-c.-johnson"
            ],
            "updatedAt": "2026-04-14T08:25:30.772Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Fantastik",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d7/Fantastik_logo.png/120px-Fantastik_logo.png.png",
            "siteUrl": "http://www.fantastik.com/"
        },
        "glade": {
            "key": "glade",
            "names": [
                "Glade"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 32,
            "ownedBy": [
                "s.-c.-johnson"
            ],
            "updatedAt": "2026-04-14T08:30:52.784Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Glade_(brand)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/d/d0/Glade_logo_2.gif",
            "siteUrl": "http://www.glade.com/"
        },
        "janitor-in-a-drum": {
            "key": "janitor-in-a-drum",
            "names": [
                "Janitor in a Drum"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 32,
            "ownedBy": [
                "s.-c.-johnson"
            ],
            "updatedAt": "2026-04-14T08:30:52.845Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Janitor_in_a_Drum",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/4/44/Janitor_in_a_Drum.jpg",
            "siteUrl": "http://www.scjohnson.com/"
        },
        "kiwi": {
            "key": "kiwi",
            "names": [
                "Kiwi"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 32,
            "ownedBy": [
                "s.-c.-johnson"
            ],
            "updatedAt": "2026-04-14T08:30:52.981Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Kiwi_(shoe_polish)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/3/39/Kiwi_%28shoe_polish%29_logo.png",
            "siteUrl": "http://kiwicare.com/"
        },
        "off!": {
            "key": "off!",
            "names": [
                "OFF!"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 32,
            "ownedBy": [
                "s.-c.-johnson"
            ],
            "updatedAt": "2026-04-14T08:30:53.054Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Off!_(brand)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/9/98/Off%21_Logo_2015.png",
            "siteUrl": "http://www.off.com/"
        },
        "pledge": {
            "key": "pledge",
            "names": [
                "Pledge"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 32,
            "ownedBy": [
                "s.-c.-johnson"
            ],
            "updatedAt": "2026-04-14T08:30:53.154Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Pledge_(brand)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/0/07/Pledge_logo-%282%29.png",
            "siteUrl": "https://www.pledge.com/"
        },
        "raid": {
            "key": "raid",
            "names": [
                "Raid"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 32,
            "ownedBy": [
                "s.-c.-johnson"
            ],
            "updatedAt": "2026-04-14T08:30:53.215Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Raid_(insecticide)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/3/3e/Raid_Logo_2015.png",
            "siteUrl": "https://raid.com/"
        },
        "saran": {
            "key": "saran",
            "names": [
                "Saran"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 32,
            "ownedBy": [
                "s.-c.-johnson"
            ],
            "updatedAt": "2026-04-14T08:30:53.342Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Saran_(plastic)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/e/e5/Saran_%28plastic%29_logo.png"
        },
        "scrubbing-bubbles": {
            "key": "scrubbing-bubbles",
            "names": [
                "Scrubbing Bubbles"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 32,
            "ownedBy": [
                "s.-c.-johnson"
            ],
            "updatedAt": "2026-04-14T08:30:53.414Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Scrubbing_Bubbles",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/b/bf/Scrubbing_bubbles_home_logo2.png",
            "siteUrl": "http://scrubbingbubbles.com/"
        },
        "swarfega": {
            "key": "swarfega",
            "names": [
                "Swarfega"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 32,
            "ownedBy": [
                "s.-c.-johnson"
            ],
            "updatedAt": "2026-04-14T08:30:53.504Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Swarfega"
        },
        "toilet-duck": {
            "key": "toilet-duck",
            "names": [
                "Toilet Duck"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 32,
            "ownedBy": [
                "s.-c.-johnson"
            ],
            "updatedAt": "2026-04-14T08:30:53.559Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Toilet_Duck",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/f/f3/Toilet_Duck_logo.png"
        },
        "windex": {
            "key": "windex",
            "names": [
                "Windex"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 32,
            "ownedBy": [
                "s.-c.-johnson"
            ],
            "updatedAt": "2026-04-14T08:30:53.680Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Windex",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/f/f5/Windex_Logo.png",
            "siteUrl": "http://www.windex.com/"
        },
        "ziploc": {
            "key": "ziploc",
            "names": [
                "Ziploc"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 32,
            "ownedBy": [
                "s.-c.-johnson"
            ],
            "updatedAt": "2026-04-14T08:30:53.737Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Ziploc",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fd/Ziploc_logo.svg/120px-Ziploc_logo.svg.png",
            "siteUrl": "http://www.ziploc.com/"
        },
        "ecover": {
            "key": "ecover",
            "names": [
                "Ecover"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 32,
            "ownedBy": [
                "s.-c.-johnson"
            ],
            "updatedAt": "2026-04-14T08:30:53.843Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Ecover",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/c/cf/Ecover_logo.png",
            "siteUrl": "http://www.ecover.com/"
        },
        "mr-muscle": {
            "key": "mr-muscle",
            "names": [
                "Mr Muscle"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 32,
            "ownedBy": [
                "s.-c.-johnson"
            ],
            "updatedAt": "2026-04-14T08:30:53.964Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Mr_Muscle",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/2/2a/Mr_Muscle_logo.png",
            "siteUrl": "http://www.mrmuscleclean.com/en-gb"
        },
        "muller": {
            "key": "muller",
            "names": [
                "Müller",
                "Unternehmensgruppe Theo Müller S.e.c.s.",
                "Molkerei Alois Müller GmbH & Co. KG"
            ],
            "comment": "Müller is a German company that has committed environmental violations [1], health and safety violations [2], and animal abuse in its supply chain [3]. Furthermore, a Müller employee suffered a finger amputation at work [4].",
            "sources": {
                "1": "https://www.data.gov.uk/dataset/13c0893a-049a-4608-9f9b-7f268a71f15a/climate-change-civil-penalties",
                "2": "https://resources.hse.gov.uk/convictions-history/case/case_details.asp?SF=CN&SV=4497378",
                "3": "https://www.independent.co.uk/news/uk/home-news/cows-abuse-muller-marks-spencers-milk-rspca-b2611198.html",
                "4": "https://www.foodmanufacture.co.uk/Article/2020/12/18/Mueller-UK-Ireland-fined-after-finger-amputations/"
            },
            "sourceNotes": {
                "1": "environmental violations",
                "2": "health and safety violations",
                "3": "animal abuse in supply chain",
                "4": "employee suffered finger amputation at work"
            },
            "tags": [
                "food",
                "dairy",
                "environmental violations",
                "unsafe working conditions",
                "animal abuse"
            ],
            "score": 37,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Unternehmensgruppe_Theo_M%C3%BCller_Logo.svg/120px-Unternehmensgruppe_Theo_M%C3%BCller_Logo.svg.png",
            "siteUrl": "https://www.muellergroup.com/",
            "updatedAt": "2026-04-15T15:40:03.581Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/M%C3%BCller_(company)"
        },
        "culina-group": {
            "key": "culina-group",
            "names": [
                "Culina Group"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "dairy"
            ],
            "score": 37,
            "ownedBy": [
                "muller"
            ],
            "updatedAt": "2026-04-15T15:59:57.412Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Culina_Group",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/0/05/Culina_Group_logo.png",
            "siteUrl": "https://www.culina.co.uk/"
        },
        "n26": {
            "key": "n26",
            "names": [
                "N26"
            ],
            "comment": "N26 is a German fintech company that closed customer accounts without reason, including those of Ukrainian refugees [1], enabled money laundering [2][3], failed to protect users against cyber security vulverabilities [4][5], and opposed employees forming a union [6].",
            "sources": {
                "1": "https://www.businessinsider.com/n26-bank-europe-customers-account-closures-access-savings-2022-4",
                "2": "https://www.lefigaro.fr/societes/blanchiment-d-argent-la-banque-n26-condamnee-a-une-amende-de-4-25-millions-d-euros-en-allemagne-20210929",
                "3": "https://web.archive.org/web/20230802063426/https://www.reuters.com/world/europe/bank-italy-bans-online-german-bank-n26-taking-new-clients-2022-03-29/",
                "4": "https://web.archive.org/web/20230627164935/https://www.businessinsider.de/gruenderszene/allgemein/n26-ccc-vincent-haupert-kundenservice/",
                "5": "https://web.archive.org/web/20230424030720/https://www.ibtimes.co.uk/smartphone-bank-n26-not-safe-exposes-users-hacking-says-researcher-1598474/",
                "6": "https://www.rnd.de/wirtschaft/onlinebank-n26-betriebsrat-streit-zwischen-belegschaft-und-unternehmensfuhrung-46CEZQ3XIBHZ3AFPTZJORMYI4U.html"
            },
            "sourceNotes": {
                "1": "closed customer accounts without reason, including those of Ukrainian refugees",
                "2": "enabled money laundering",
                "3": "enabled money laundering",
                "4": "failed to protect users against cyber security vulverabilities",
                "5": "failed to protect users against cyber security vulverabilities",
                "6": "opposed employees forming a union"
            },
            "tags": [
                "finance",
                "anti-union practices",
                "corruption",
                "privacy violations"
            ],
            "score": 45,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/bf/N26_logo_2019.svg",
            "siteUrl": "https://n26.com/en-eu",
            "updatedAt": "2026-04-16T07:35:09.251Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/N26"
        },
        "neutrogena": {
            "key": "neutrogena",
            "names": [
                "Neutrogena",
                "Neutrogena Corporation"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": null,
            "ownedBy": [
                "kenvue"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/30/Neutrogena_logo.svg",
            "siteUrl": "http://www.neutrogena.com/",
            "updatedAt": "2026-04-17T05:59:27.478Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Neutrogena"
        },
        "new-balance": {
            "key": "new-balance",
            "names": [
                "New Balance",
                "New Balance Athletics",
                "New Balance Athletics, Inc.",
                "New Balance Arch Support Company",
                "New Balance Athletic Shoe Company"
            ],
            "comment": "New Balance is an American footwear company that has been accused of greenwashing [1], sending shoes to landfill [2], and selling footwear that caused injuries [3]. The brand has also faced criticism for poor working conditions and labor abuses in its supply chain [4], being targeted by BDS boycotts [5], its association with white supremacy [6][7], and receiving millions of dollars to produce shoes for the US military [8].",
            "sources": {
                "1": "https://www.business-humanrights.org/en/latest-news/france-ngo-files-complaint-against-adidas-new-blance-over-allegations-of-greenwashing/",
                "2": "https://www.bbc.co.uk/news/uk-england-cumbria-64855222",
                "3": "https://www.sgieurope.com/legal/new-balance-sued-for-alleged-faulty-shoe/111265.article",
                "4": "https://web.archive.org/web/20150329071758/http://www.chinalaborwatch.org/newscast/129",
                "5": "https://masjidalaqsa.com/boycott/new-balance-israel-bds",
                "6": "https://zmj.unibo.it/article/download/13185/12850?inline=1",
                "7": "https://www.entrepreneur.com/starting-a-business/new-balance-suffers-a-brand-mangling-whitewashing/285346",
                "8": "https://web.archive.org/web/20150329071758/http://www.chinalaborwatch.org/newscast/129"
            },
            "sourceNotes": {
                "1": "greenwashing",
                "2": "sent shoes to landfill",
                "3": "sold shoes that led to injury",
                "4": "poor working conditions and labour abuses in supply chain",
                "5": "target of BDS boycotts",
                "6": "association with white supremacy",
                "7": "association with white supremacy",
                "8": "received several million dollars to produce shoes for the US military"
            },
            "tags": [
                "sportswear",
                "retail",
                "clothing",
                "greenwashing",
                "unsustainable practices",
                "environmental violations",
                "unsafe practices",
                "poor working conditions",
                "racial discrimination",
                "deception",
                "connections to israel"
            ],
            "score": 30,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/e/ea/New_Balance_logo.svg",
            "siteUrl": "https://www.newbalance.com/",
            "updatedAt": "2026-04-18T11:17:57.329Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/New_Balance"
        },
        "brine": {
            "key": "brine",
            "names": [
                "Brine"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "sportswear",
                "retail",
                "clothing"
            ],
            "score": 30,
            "ownedBy": [
                "new-balance"
            ],
            "updatedAt": "2026-04-18T11:34:14.787Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Brine_(brand)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/d4/Brinecompanylogo.png",
            "siteUrl": "https://www.brine.com/"
        },
        "warrior-sports": {
            "key": "warrior-sports",
            "names": [
                "Warrior Sports"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "sportswear",
                "retail",
                "clothing"
            ],
            "score": 30,
            "ownedBy": [
                "new-balance"
            ],
            "updatedAt": "2026-04-18T11:34:15.468Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Warrior_Sports",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/85/Warrior_Sports_logo.svg",
            "siteUrl": "https://www.warrior.com/"
        },
        "new-look": {
            "key": "new-look",
            "names": [
                "New Look"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "clothing"
            ],
            "score": null,
            "ownedBy": [
                "brait-se"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/4e/New_Look_logo_2012.svg",
            "siteUrl": "http://www.newlook.com/uk",
            "updatedAt": "2026-04-19T07:50:16.834Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/New_Look_(company)"
        },
        "nordstrom": {
            "key": "nordstrom",
            "names": [
                "Nordstrom",
                "Nordstrom, Inc."
            ],
            "comment": "Nordstrom is an American retailer that has engaged in deceptive marketing [1] and price fixing [2]. It has violated labour laws [3], underpaid employees [4], employed racist and sexist hiring practices [5], and racially profiled customers [6].",
            "sources": {
                "1": "https://topclassactions.com/lawsuit-settlements/lawsuit-news/class-action-alleges-nordstrom-racks-limited-time-sales-were-fabricated-and-perpetual/",
                "2": "https://www.sfgate.com/bayarea/article/cosmetics-firms-plan-175-million-giveaway-free-2602169.php",
                "3": "https://www.law360.com/articles/179872/calif-court-oks-nordstrom-s-9m-commissions-deal",
                "4": "https://www.law360.com/articles/543617/nordstrom-strikes-7-65m-deal-in-sales-workers-wage-suit",
                "5": "https://aflegal.org/press-release/america-first-legal-files-civil-rights-complaint-against-nordstrom-for-unlawful-racist-sexist-hiring-practices/",
                "6": "https://www.yahoo.com/lifestyle/nordstrom-rack-apologizes-3-black-shoppers-wrongly-accused-shoplifting-185429841.html"
            },
            "sourceNotes": {
                "1": "deceptive marketing",
                "2": "engaged in price fixing",
                "3": "violated labour laws",
                "4": "underpaid employees",
                "5": "racist and sexist hiring practices",
                "6": "racially profiled customers"
            },
            "tags": [
                "retail",
                "clothing",
                "anticompetitive practices",
                "deception",
                "unfair pay",
                "poor working conditions",
                "racial discrimination",
                "gender discrimination"
            ],
            "score": 40,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/81/Nordstrom_Logo_2019.svg",
            "siteUrl": "http://nordstrom.com/",
            "updatedAt": "2026-04-18T11:34:12.110Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Nordstrom"
        },
        "novartis": {
            "key": "novartis",
            "names": [
                "Novartis",
                "Novartis AG",
                "Ciba-Geigy",
                "Sandoz",
                "NOVN",
                "Novartis",
                "Novartis AG",
                "Ciba-Geigy",
                "Sandoz",
                "NOVN"
            ],
            "comment": "Novartis is a Swiss pharmaceutical company that has engaged in bribery of doctors to prescribe pills [1][2], committed bribery and fraud [3], and practiced anticompetitive monopolistic tactics [4]. The company has also harassed employees [5], discriminated against female employees [6], made false claims about drug safety and efficacy [7][8], falsified experimental data [9], stole patient cells without consent or compensation [10][11], and illegally promoted unapproved medicines for children [12].",
            "sources": {
                "1": "https://pharmaphorum.com/news/novartis-pays-678-million-to-settle-us-kickback-allegations",
                "2": "https://www.financialregulationintl.com/regulation/the-greek-novartis-scandal--whistleblowers-legal-retaliation-and-the-erosion-of-the-rule-of-law-159535.htm",
                "3": "https://www.justice.gov/usao-nj/pr/novartis-ag-and-subsidiaries-pay-345-million-resolve-foreign-corrupt-practices-act-cases",
                "4": "https://www.yalejreg.com/bulletin/shaming-big-pharma/",
                "5": "https://www.deccanchronicle.com/nation/current-affairs/100216/novartis-ex-staffer-alleges-harassment.html",
                "6": "https://sanfordheisler.com/case/discrimination-harassment/novartis-pharmaceutical-gender-discrimination-class-action/",
                "7": "https://www.thepharmaletter.com/pharma-news/novartis-to-pay-over-72-million-to-settle-false-claims-act-allegations-related-to-tobi-fda-warns-of-gleevec-and-altabax-promo",
                "8": "https://www.nytimes.com/2010/10/01/health/policy/01novartis.html",
                "9": "https://www.pharmamanufacturing.com/compliance/regulatory-guidance/article/11300653/how-novartis-data-manipulation-case-is-a-cautionary-tale-for-transparency",
                "10": "https://www.cbsnews.com/news/novartis-henrietta-lacks-settlement-stolen-cells/",
                "11": "https://www.reuters.com/legal/litigation/novartis-quietly-settles-henrietta-lacks-suit-familys-legal-push-gains-steam-2026-02-24/",
                "12": "https://www.pintas.com/blog/novartis-sued-in-whistleblower-case-over-off-label-elidel-use/"
            },
            "sourceNotes": {
                "1": "bribed doctors to prescibe pills",
                "2": "bribed doctors to prescibe pills",
                "3": "bribery and fraud",
                "4": "anticompetetive monopolistic practices",
                "5": "harassment of employees",
                "6": "discriminated against female employees",
                "7": "made false claims about the effectiveness and safety of its drugs",
                "8": "made false claims about the effectiveness and safety of its drugs",
                "9": "falsified experimental data",
                "10": "stole cells from a patient that were used for testing without consent or compensation",
                "11": "stole cells from a patient that were used for testing without consent or compensation",
                "12": "illegally encouraged the use of medicines on children without FDA approval"
            },
            "tags": [
                "pharamceuticals",
                "pharamceuticals",
                "corruption",
                "deception",
                "anticompetitive practices",
                "sexual harassment",
                "gender discrimination",
                "privacy violations",
                "unsafe practices"
            ],
            "score": 38,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/7c/Novartis-Logo-2023.svg",
            "siteUrl": "https://novartis.com/",
            "updatedAt": "2026-04-21T12:10:07.151Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Novartis"
        },
        "o2": {
            "key": "o2",
            "names": [
                "O2",
                "Telefonica UK",
                "Virgin Media O2"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "telecommunications"
            ],
            "score": 34,
            "ownedBy": [
                "liberty-global",
                "telefonica"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/1d/O2_Logo_2024.svg",
            "siteUrl": "https://o2.co.uk/",
            "updatedAt": "2026-04-22T10:01:43.645Z"
        },
        "olive-garden": {
            "key": "olive-garden",
            "names": [
                "Olive Garden",
                "Darden Concepts, Inc.",
                "The Olive Garden"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurant",
                "food"
            ],
            "score": 32,
            "ownedBy": [
                "darden-restaurants"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/6/6d/Olive_Garden_Logo.svg",
            "siteUrl": "http://www.olivegarden.com/",
            "updatedAt": "2026-04-23T07:09:16.297Z"
        },
        "oneplus": {
            "key": "oneplus",
            "names": [
                "OnePlus"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "electronics"
            ],
            "score": 29,
            "ownedBy": [
                "oppo"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/f/f8/OP_LU_Reg_1L_RGB_red_copy-01.svg",
            "siteUrl": "https://www.oneplus.com/",
            "updatedAt": "2026-04-24T07:00:54.456Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/OnePlus"
        },
        "orange": {
            "key": "orange",
            "names": [
                "Orange",
                "Orange Group",
                "Orange S.A.",
                "France Télécom S.A.",
                "france télécom",
                "ORA",
                "ORAN"
            ],
            "comment": "Orange is a French telecommunications company that has been accused of restricting access to file sharing sites [1], false advertising [2], and violations of open access licences [3][4]. The company has also faced allegations of anticompetitive monopolistic practices [5], customer privacy violations [6], corruption [7], and poor working conditions leading to suicides [8][9][10].",
            "sources": {
                "1": "https://web.archive.org/web/20150722115802/http://www.01net.com/editorial/526962/orange-dement-brider-l-acces-au-site-megaupload-maj/",
                "2": "https://web.archive.org/web/20200818042510/https://o.nouvelobs.com/high-tech/20091222.OBS1497/orange-vise-par-une-plainte-pour-publicite-mensongere.html#modal-msg",
                "3": "https://next.ink/brief_article/orange-condamnee-a-860-000-euros-pour-contrefacon-et-violation-de-la-licence-libre-gnu-gpl/",
                "4": "https://www.april.org/violation-d-une-licence-libre-entr-ouvert-fonde-a-poursuivre-orange-pour-contrefacon",
                "5": "https://www.zdnet.fr/actualites/orange-sfr-et-bouygues-telecom-condamnes-a-une-amende-record-de-534-millions-d-euros-39291618.htm",
                "6": "https://www.cnil.fr/fr/publicites-inserees-entre-les-courriels-sanction-de-50-millions-deuros-orange",
                "7": "https://web.archive.org/web/20190908230659/http://owni.fr/2011/03/03/ben-ali-les-compromission-dorange-en-tunisie/",
                "8": "https://www.reuters.com/article/france-telecom-idUSL711729320091007?pageNumber=1&virtualBrandChannel=11604",
                "9": "https://www.theguardian.com/world/2009/sep/09/france-telecom-staff-suicides-phone",
                "10": "https://www.nouvelobs.com/societe/social/20091210.OBS0287/france-telecom-la-souffrance-au-travail-est-etablie.html"
            },
            "sourceNotes": {
                "1": "restricted access to file sharing sites",
                "2": "false advertising",
                "3": "violation of open access licences",
                "4": "violation of open access licences",
                "5": "anticompetetive monopoliatic practices",
                "6": "customer privacy violations",
                "7": "corruption",
                "8": "poor working conditions leading to suicides",
                "9": "poor working conditions leading to suicides",
                "10": "poor working conditions leading to suicides"
            },
            "tags": [
                "telecommunications",
                "anticompetitive practices",
                "deception",
                "privacy violations",
                "corruption",
                "poor working conditions",
                "unsafe working conditions"
            ],
            "score": 25,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/c8/Orange_logo.svg",
            "siteUrl": "https://orange.com/",
            "updatedAt": "2026-04-27T16:27:42.088Z"
        },
        "opel": {
            "key": "opel",
            "names": [
                "Opel"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "cars",
                "emissions cheating"
            ],
            "score": 38,
            "ownedBy": [
                "stellantis"
            ],
            "updatedAt": "2026-04-25T04:30:29.224Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Opel",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/2b/Opel_logo_2023.svg",
            "siteUrl": "https://www.opel.com/"
        },
        "globecast": {
            "key": "globecast",
            "names": [
                "Globecast"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "telecommunications"
            ],
            "score": 25,
            "ownedBy": [
                "orange"
            ],
            "updatedAt": "2026-04-27T16:40:37.742Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Globecast",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Globecast_building_entrance.jpg/120px-Globecast_building_entrance.jpg.png",
            "siteUrl": "https://www.globecast.com/"
        },
        "openai": {
            "key": "openai",
            "names": [
                "OpenAI"
            ],
            "comment": "OpenAI is a United States-based artificial intelligence company that switched from a non-profit to a for-profit structure [1], has faced copyright infringement allegations [2], and has been accused of deprioritising AI safety [3]. The company has used legal threats to silence critics [4], its products have been linked to mental health episodes and suicide [5][6][7], and it works closely with the US military [8].",
            "sources": {
                "1": "https://web.archive.org/web/20230104154138/https://techcrunch.com/2019/03/11/openai-shifts-from-nonprofit-to-capped-profit-to-attract-capital/",
                "2": "https://web.archive.org/web/20241207180154/https://fortune.com/2024/10/24/openai-miles-brundage-suchir-balaji-ai-safety-copyright-sam-altman-chatgpt/",
                "3": "https://web.archive.org/web/20240829051946/https://fortune.com/2024/08/26/openai-agi-safety-researchers-exodus/",
                "4": "https://www.nbcnews.com/tech/tech-news/openai-chatgpt-accused-using-subpoenas-silence-nonprofits-rcna237348",
                "5": "https://apnews.com/article/openai-chatgpt-lawsuit-suicide-56e63e5538602ea39116f1904bf7cdc3",
                "6": "https://www.bbc.com/news/articles/cgerwp7rdlvo",
                "7": "https://www.yahoo.com/news/articles/openai-t-pull-plug-family-024400947.html",
                "8": "https://www.bbc.co.uk/news/articles/c3rz1nd0egro"
            },
            "sourceNotes": {
                "1": "switched from a non-profit to for-profit company",
                "2": "copyright infringement",
                "3": "deprioritised AI safety",
                "4": "used legal threats to silence critics",
                "5": "products involved in mental health episodes and suicide",
                "6": "products involved in mental health episodes and suicide",
                "7": "products involved in mental health episodes and suicide",
                "8": "working closely with US military"
            },
            "tags": [
                "tech",
                "ai",
                "deception",
                "unsafe practices"
            ],
            "score": 18,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/af/OpenAI_logo_2025_%28wordmark%29.svg",
            "siteUrl": "https://openai.com/",
            "updatedAt": "2026-04-26T07:56:01.228Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/OpenAI"
        },
        "outback-steakhouse": {
            "key": "outback-steakhouse",
            "names": [
                "Outback Steakhouse",
                "Outback"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurant"
            ],
            "score": 22,
            "ownedBy": [
                "bloomin-brands"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/c/cf/Outback_Steakhouse.svg",
            "siteUrl": "http://www.outback.com/",
            "updatedAt": "2026-04-27T19:17:24.683Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Outback_Steakhouse"
        },
        "panasonic": {
            "key": "panasonic",
            "names": [
                "Panasonic",
                "Panasonic Holdings Corporation",
                "Panasonic Corporation",
                "パナソニック ホールディングス株式会社",
                "Matsushita Electric Manufacturing Works",
                "Matsushita Electric Industrial Co., Ltd."
            ],
            "comment": "Panasonic is a Japanese electronics company that has been implicated in corruption [1], fraud [2], and multiple price‑fixing cases [3][4][5][6][9]. It has also faced labor rights abuses in its supply chain [7][8][9], poor working conditions in its operations at Tesla’s gigafactory [10], and allegations of poisoning workers in battery factories [11].",
            "sources": {
                "1": "https://www.bbc.com/news/business-43956968",
                "2": "https://web.archive.org/web/20180501015050/https://www.sec.gov/news/press-release/2018-73",
                "3": "https://www.law360.com/articles/1252492",
                "4": "https://www.justice.gov/archives/opa/pr/panasonic-and-its-subsidiary-sanyo-agree-plead-guilty-separate-price-fixing-conspiracies",
                "5": "https://ec.europa.eu/commission/presscorner/detail/en/ip_12_1317",
                "6": "https://ec.europa.eu/commission/presscorner/detail/en/ip_16_4356",
                "7": "https://www.business-humanrights.org/en/latest-news/panasonic-response-to-allegations-of-labour-rights-abuse-of-bangladeshi-workers-at-malaysian-supplier/",
                "8": "https://www.theguardian.com/global-development/2017/may/09/panasonic-samsung-alleged-supply-chain-labour-abuses-reforms-fall-short-malaysia",
                "9": "https://web.archive.org/web/20260429072920/https://www.indybay.org/uploads/2016/01/25/is_panasonic_the_most_unethical_company_in_tech_.pdf",
                "10": "https://www.businessinsider.com/panasonic-battery-cell-operations-tesla-gigafactory-chaotic-2019-4",
                "11": "https://pulitzercenter.org/stories/china-powerless-fight-poison"
            },
            "sourceNotes": {
                "1": "corruption",
                "2": "fraud",
                "3": "several cases of price fixing",
                "4": "several cases of price fixing",
                "5": "several cases of price fixing",
                "6": "several cases of price fixing",
                "7": "labour rights abuses in supply chain",
                "8": "labour rights abuses in supply chain",
                "9": "price fixing, labour abuses and bribery",
                "10": "poor working conditions in tesla giga-factory operation",
                "11": "poisioning of workers in battery factories"
            },
            "tags": [
                "electronics",
                "corruption",
                "deception",
                "anticompetitive practices",
                "poor working conditions",
                "unsafe working conditions",
                "unsafe practices"
            ],
            "score": 20,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/54/Panasonic_Group_logo.svg",
            "siteUrl": "https://holdings.panasonic/",
            "updatedAt": "2026-04-27T20:31:14.373Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Panasonic"
        },
        "panda-express": {
            "key": "panda-express",
            "names": [
                "Panda Express"
            ],
            "comment": "Panda Express is a U.S. restaurant chain that has failed to implement sufficient cybersecurity leading to a customer data breach [1], overcharged customers [2][3], filed spurious lawsuits to suppress small businesses [4], underpaid employees [5][6], illegally handled hazardous materials and failed to provide employee safety training [7][8], engaged in racial discrimination against employees [9][10], and subjected employees to sexual and psychological abuse [11][12][13]. Additionally, the chain has been found to serve customers dangerous metal items in their food [14].",
            "sources": {
                "1": "https://www.the-sun.com/money/16162430/panda-express-data-breach-settlement-claim-form-deadline/",
                "2": "https://eu.usatoday.com/story/money/food/2023/08/30/panda-express-class-action-lawsuit-settlement/70722361007/",
                "3": "https://www.sacbee.com/news/california/article278869299.html",
                "4": "https://eu.azcentral.com/story/entertainment/dining/2024/01/26/panda-express-phoenix-restaurant-trash-panda-vegan/72283247007/",
                "5": "https://web.archive.org/web/20230924230840/https://www.nyc.gov/site/dca/media/pr081623-dcwp-settles-with-three-major-restaurant-chains.page",
                "6": "https://www.law360.com/articles/639383/panda-express-to-pay-up-to-3m-for-managers-ot-case",
                "7": "https://www.foxla.com/news/panda-express-parent-company-ordered-pay-over-1m-violating-california-safety-laws",
                "8": "https://www.latimes.com/business/story/2025-12-03/panda-express-pays-fine-for-failing-to-train-employees-on-handling-hazardous-materials",
                "9": "https://www.eeoc.gov/newsroom/panda-express-sued-eeoc-national-origin-bias",
                "10": "https://www.courthousenews.com/panda-express-pays-600000-settle-labor-claims/",
                "11": "https://www.hcamag.com/us/specialization/employment-law/panda-express-allegedly-kept-accused-harasser-fired-women-who-complained/569375",
                "12": "https://www.lawcommentary.com/articles/panda-express-employees-forced-to-strip-in-trust-building-exercise-lawsuit-says",
                "13": "https://www.cbsnews.com/losangeles/news/panda-express-harassment-battery-lawsuit/",
                "14": "https://www.unilad.com/news/panda-express-lawsuit-miriam-yocupicio-metal-wire-in-food-922623-20240522"
            },
            "sourceNotes": {
                "1": "insufficient cybersecurity leading to customer data breach",
                "2": "overcharged customers",
                "3": "overcharged customers",
                "4": "filed spurious lawsuits to supress small businesses",
                "5": "underpaid employees",
                "6": "underpaid employees",
                "7": "illegal handling of hazardous materials and lack of employee safety training",
                "8": "illegal handling of hazardous materials and lack of employee safety training",
                "9": "racial discrimination towards employees",
                "10": "racial discrimination towards employees",
                "11": "sexual and psychological abuse of employees",
                "12": "sexual and psychological abuse of employees",
                "13": "sexual and psychological abuse of employees",
                "14": "dangerous metal items in food served to customers"
            },
            "tags": [
                "food",
                "restaurant",
                "fast food",
                "data breach",
                "privacy violations",
                "deception",
                "anticompetitive practices",
                "unfair pay",
                "unsafe working conditions",
                "poor working conditions",
                "unsafe practices",
                "racial discrimination",
                "sexual harassment",
                "environmental violations",
                "unsustainable practices"
            ],
            "score": 19,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/8/85/Panda_Express_logo.svg",
            "siteUrl": "https://www.pandaexpress.com/",
            "updatedAt": "2026-04-30T06:41:13.556Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Panda_Express"
        },
        "panda-inn": {
            "key": "panda-inn",
            "names": [
                "Panda Inn"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "restaurant",
                "fast food"
            ],
            "score": 19,
            "ownedBy": [
                "panda-express"
            ],
            "updatedAt": "2026-04-30T07:30:13.249Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Panda_Inn",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/3/3a/Pandainntopnav.png",
            "siteUrl": "https://www.pandainn.com/"
        },
        "pandora": {
            "key": "pandora",
            "names": [
                "Pandora",
                "Pandora A/S",
                "PANDORA",
                "PNDORA"
            ],
            "comment": "Pandora is a Danish jewelry company that has faced a breach of customer data [1] and violations of consumer law [2]. It has historically profited from human rights abuses in its gold supply chain [3][4].",
            "sources": {
                "1": "https://www.mirror.co.uk/money/pandora-customers-contacted-company-after-35683215",
                "2": "https://www.jewellermagazine.com/Article/8221/Pandora-admits-it-may-have-broken-consumer-law",
                "3": "https://www.hrw.org/report/2018/02/08/hidden-cost-jewelry/human-rights-supply-chains-and-responsibility-jewelry",
                "4": "https://www.ft.com/content/9a9355a4-0cc3-11e8-8eb7-42f857ea9f09?syn-25a6b1a6=1"
            },
            "sourceNotes": {
                "1": "databreach of customer information",
                "2": "breach of consumer law",
                "3": "historically profited from human rights abuses in gold supply chain",
                "4": "historically profited from human rights abuses in gold supply chain"
            },
            "tags": [
                "jewellery",
                "data breach",
                "privacy violations",
                "forced labour",
                "poor working conditions"
            ],
            "score": 45,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/1d/Pandora_logo_2025.svg",
            "siteUrl": "http://pandoragroup.com/",
            "updatedAt": "2026-05-01T11:06:39.019Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Pandora_(jewelry)"
        },
        "patagonia": {
            "key": "patagonia",
            "names": [
                "Patagonia",
                "Patagonia, Inc."
            ],
            "comment": "Patagonia is an American outdoor apparel company that has been accused of worker abuse in its supply chain, including using the same factories as fast‑fashion brands [1][2], and animal abuse in its supply chain [3]. The company has engaged in questionable sustainability practices [4] and rates itself low on climate performance [5].",
            "sources": {
                "1": "https://www.vogue.com/article/what-happens-after-a-brand-is-called-out-for-worker-exploitation-patagonia",
                "2": "https://humantraffickingsearch.org/resource/sustainable-clothing-brand-patagonia-manufactures-in-the-same-factories-as-fast-fashion-textile-workers-are-being-exploited/",
                "3": "https://www.peta.org/news/peta-responds-patagonias-lack-concern-new-sheep-cruelty-expose/",
                "4": "https://newrepublic.com/article/167780/patagonia-wont-save-world-without-addressing-prior-failures",
                "5": "https://thefifthestate.com.au/business/investment-deals/nothing-we-do-is-sustainable-patagonia-rates-itself-very-low-on-climate-performance/"
            },
            "sourceNotes": {
                "1": "worker abuse in supply chain",
                "2": "worker abuse in supply chain, using the same factories as fast-fashion",
                "3": "animal abuse in supply chain",
                "4": "engaged in questionable sustainability practices",
                "5": "rates itself low on climate performance"
            },
            "tags": [
                "sportswear",
                "clothing",
                "retail",
                "animal abuse",
                "forced labour",
                "poor working conditions",
                "unsustainable practices",
                "greenwashing"
            ],
            "score": 40,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/2a/Patagonia_%28Unternehmen%29_logo.svg",
            "siteUrl": "http://patagonia.com/",
            "updatedAt": "2026-05-02T07:42:03.746Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Patagonia,_Inc."
        },
        "paypal": {
            "key": "paypal",
            "names": [
                "Paypal",
                "PayPal Holdings, Inc.",
                "Confinity",
                "PYPL"
            ],
            "comment": "Paypal is an American company that has engaged in anticonsumer practices [1], deceptive practices [2], and inadequate anti‑fraud systems [3]. It has stolen users' funds [4][5], blocked the accounts of political activists—a practice that has supported the Russian regime [6][7][8][9][10][11], fined users promoting misinformation [12][13], and suspended journalists' payments over coverage of Syrian families [14].",
            "sources": {
                "1": "https://web.archive.org/web/20060715192615/http://pub.bna.com/eclr/021227.htm",
                "2": "https://www.bbc.co.uk/news/technology-32810280",
                "3": "https://www.bbc.co.uk/news/articles/cj6y42jggdyo",
                "4": "https://arstechnica.com/tech-policy/2022/01/paypal-stole-users-money-after-freezing-seizing-funds-lawsuit-alleges/",
                "5": "https://www.classaction.org/media/evans-et-al-v-paypal-inc.pdf",
                "6": "https://web.archive.org/web/20150801233235/https://globalvoicesonline.org/2015/05/15/paypal-blocks-donations-for-printing-boris-nemtsovs-ukraine-war-report/",
                "7": "https://web.archive.org/web/20140807001924/http://blogs.ft.com/beyond-brics/2014/05/30/russian-campaigning-website-snared-in-internet-controls/",
                "8": "https://web.archive.org/web/20170422141625/https://www.theguardian.com/world/2015/apr/21/iranian-human-rights-group-account-blocked-paypal-sanctions",
                "9": "https://web.archive.org/web/20150520204705/http://www.themoscowtimes.com/news/article/paypal-blocks-russian-account-linked-to-nemtsov-report-on-ukraine/520809.html",
                "10": "https://web.archive.org/web/20170701161416/http://www.economist.com/news/europe/21651130-posthumously-completed-report-details-russias-involvement-war-ukraine-boris-nemtsovs",
                "11": "https://web.archive.org/web/20150603011352/https://freedomhouse.org/article/paypal-blocks-donations-report-russian-actions-ukraine",
                "12": "https://web.archive.org/web/20221008232157/https://www.nationalreview.com/news/new-paypal-policy-permits-company-to-fine-users-2500-for-misinformation/",
                "13": "https://web.archive.org/web/20221008232157/https://www.nationalreview.com/news/new-paypal-policy-permits-company-to-fine-users-2500-for-misinformation/",
                "14": "https://web.archive.org/web/20200804143748/https://www.cbc.ca/news/canada/manitoba/paypal-freezes-flin-flon-newspaper-syrian-refugees-1.3977292"
            },
            "sourceNotes": {
                "1": "anticonsumer practices",
                "2": "deceptive practices",
                "3": "inadequate anti-fraud systems",
                "4": "stole users' funds",
                "5": "stole users' funds",
                "6": "blocked the accounts of political activists",
                "7": "blocked the accounts of political activists",
                "8": "blocked the accounts of political activists",
                "9": "blocked the accounts of political activists",
                "10": "supported the russian regime by blocking the accounts of political activists",
                "11": "supported the russian regime by blocking the accounts of political activists",
                "12": "stated it would fine users promoting misinformation",
                "13": "stated it would fine users promoting misinformation",
                "14": "suspended journalists' payments over coverage of syrian families"
            },
            "tags": [
                "finance",
                "tech",
                "deception",
                "connections to russia"
            ],
            "score": 35,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/c6/PayPal_2024.svg",
            "siteUrl": "http://paypal.com/",
            "updatedAt": "2026-05-03T05:40:54.962Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/PayPal"
        },
        "peacocks": {
            "key": "peacocks",
            "names": [
                "Peacocks",
                "Anglo Global Property Limited",
                "Green Spark Holdings Limited"
            ],
            "comment": "Peacocks is a UK-based clothing retailer that has failed to pay suppliers in Bangladesh [1] and failed to properly consult before making 2000 staff redundant [2][3].",
            "sources": {
                "1": "https://textiletoday.com.bd/british-clothing-brand-peacocks-faces-temporary-embargo-bangladesh",
                "2": "https://www.retailgazette.co.uk/blog/2022/03/peacocks-ex-staff-win-legal-redundancy-battle/",
                "3": "https://businessmondays.co.uk/redundant-peacocks-staff-to-launch-legal-battle-against-budget-retailer/"
            },
            "sourceNotes": {
                "1": "failed to pay suppliers in  bangladesh",
                "2": "failed to properly consult before making 2000 staff redundant",
                "3": "failed to properly consult before making 2000 staff redundant"
            },
            "tags": [
                "clothing",
                "retail",
                "unfair pay"
            ],
            "score": 46,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/6/6d/Peacockslogo.png/250px-Peacockslogo.png",
            "siteUrl": "https://www.peacocks.co.uk/",
            "updatedAt": "2026-05-03T15:18:32.934Z",
            "wikipediaUrl": "https://www.peacocks.co.uk/about-us.html"
        },
        "peet's-coffee": {
            "key": "peet's-coffee",
            "names": [
                "Peet's Coffee"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "coffee"
            ],
            "score": 30,
            "ownedBy": [
                "dr-pepper"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/d/d3/Peet%27s_Coffee_logo.svg",
            "siteUrl": "http://www.peets.com/",
            "updatedAt": "2026-05-03T15:18:32.934Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Peet%27s_Coffee"
        },
        "petco": {
            "key": "petco",
            "names": [
                "Petco",
                "Petco Health and Wellness Company, Inc.",
                "WOOF"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "pets",
                "retail"
            ],
            "score": null,
            "ownedBy": [
                "cvc-capital-partners",
                "cpp-investments"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/af/Petco_Logo.svg",
            "siteUrl": "https://petco.com/",
            "updatedAt": "2026-05-03T15:18:32.934Z",
            "error": "Error [ERR_HTTP2_INVALID_SESSION]: The session has been destroyed"
        },
        "pets-at-home": {
            "key": "pets-at-home",
            "names": [
                "Pets at Home",
                "Pets at Home Group",
                "Pets at Home Group PLC",
                "Pets",
                "PETS"
            ],
            "comment": "Pets at Home is a UK pet retail chain that has faced been accused of discriminating against disabled staff [1], discriminating against staff and unfair dismissal [2], and keeping animals in inhumane conditions [3][4][5].",
            "sources": {
                "1": "https://assets.publishing.service.gov.uk/media/5cb491fbe5274a4d0a14b502/Mr_G_Ramsay_v_Pets_At_Home_Limited_-_2424515.2017_-_Hearing_-_10.4.19.pdf",
                "2": "https://assets.publishing.service.gov.uk/media/631205d6d3bf7f4cb4fac419/Mr_M_Baller_v_Vets_Direct_Ltd_2305245-2020_Judgment_18.08.2022.pdf",
                "3": "https://web.archive.org/web/20131020195750/http://www.petproductmarketing.co.uk/content.php?sid=586",
                "4": "https://doglistener.co.uk/pets-home-stores-exposed-poor-animal-management/",
                "5": "https://ghostarchive.org/varchive/youtube/20211215/YGTy9YsO1qA"
            },
            "sourceNotes": {
                "1": "discrimination against disabled staff",
                "2": "discrimination against staff and unfair dismissal",
                "3": "animals kept in inhumane conditions",
                "4": "animals kept in inhumane conditions",
                "5": "animals kept in inhumane conditions"
            },
            "tags": [
                "pets",
                "retail",
                "animal abuse"
            ],
            "score": 30,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/48/PetsAtHome.svg",
            "siteUrl": "http://www.petsathome.com/",
            "updatedAt": "2026-05-07T17:46:48.975Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Pets_at_Home"
        },
        "vets-for-pets": {
            "key": "vets-for-pets",
            "names": [
                "Vets for Pets"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "pets",
                "retail"
            ],
            "score": 30,
            "ownedBy": [
                "pets-at-home"
            ],
            "logoUrl": "https://manchesterfort.co.uk/wp-content/uploads/2025/06/Vets-for-Pets-logo-1-1-150x150.jpg",
            "siteUrl": "https://www.vets4pets.com/",
            "updatedAt": "2026-05-08T07:31:45.985Z"
        },
        "petsmart": {
            "key": "petsmart",
            "names": [
                "Petsmart"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "pets",
                "retail"
            ],
            "score": null,
            "ownedBy": [
                "bc-partners",
                "apollo-global-management"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/01/PetSmart.svg",
            "siteUrl": "http://www.petsmart.com/",
            "updatedAt": "2026-05-08T21:13:36.033Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/PetSmart"
        },
        "pfizer": {
            "key": "pfizer",
            "names": [
                "Pfizer",
                "Pfizer Inc.",
                "Charles Pfizer & Company",
                "PFE"
            ],
            "comment": "Pfizer is a United States pharmaceutical company that has engaged in intense and unethical marketing of medications to doctors [1], illegal off‑label promotion of gabapentin [2], neurontin [3], and arthritis drug Bextra [4][5][6], bribed doctors to prescribe its drugs [7][8][9], spent millions lobbying politicians [10], evaded taxes [11], overcharged the NHS for medicines [12][13], and bullied Latin American countries into unfavorable COVID‑vaccine deals [14]. It has also sold dangerous products, including an anti‑smoking drug linked to more than 20 suicides [15], a defective heart valve that killed hundreds of patients [16][17], and conducted lethal trials on Nigerian children that killed 50 [18][19][20], while firing an employee who sued for workplace injury [21], and causing a plant explosion that injured five people [22].",
            "sources": {
                "1": "https://nymag.com/nymetro/health/features/3122/",
                "2": "https://doi.org/10.7326%2F0003-4819-145-4-200608150-00008",
                "3": "https://openclassactions.substack.com/p/the-325-million-neurontin-gabapentin",
                "4": "https://web.archive.org/web/20220512181155/https://www.justice.gov/opa/pr/justice-department-announces-largest-health-care-fraud-settlement-its-history",
                "5": "https://en.wikipedia.org/wiki/Pfizer#cite_note-Settle-181",
                "6": "https://web.archive.org/web/20110715112330/http://oig.hhs.gov/fraud/cia/agreements/pfizer_inc.pdf",
                "7": "https://www.cbsnews.com/news/blue-cross-names-and-shames-pfizer-execs-linked-to-massages-for-prescriptions-push/",
                "8": "https://www.bizjournals.com/austin/stories/2010/06/07/daily52.html",
                "9": "https://www.fiercepharma.com/pharma/bcbs-names-pfizer-managers-kickback-suit",
                "10": "https://www.opensecrets.org/federal-lobbying/clients/summary?cycle=2025&id=D000000138&name=Pfizer+Inc",
                "11": "https://www.oxfam.org/en/research/prescription-poverty",
                "12": "https://www.gov.uk/government/news/70-million-in-fines-for-pharma-firms-that-overcharged-nhs",
                "13": "https://www.bloomberg.com/news/articles/2022-07-21/pfizer-flynn-fined-70-million-for-unfair-epilepsy-drug-prices",
                "14": "https://www.aljazeera.com/news/2021/3/11/investigation-pfizer-bullied-latin-american-nations",
                "15": "https://www.theguardian.com/business/2017/sep/15/his-death-still-hurts-the-pfizer-anti-smoking-drug-ruled-to-have-contributed-to-suicide",
                "16": "https://www.nytimes.com/1992/01/25/us/lawsuit-settled-over-heart-valve-implicated-in-about-300-deaths.html",
                "17": "https://www.latimes.com/archives/la-xpm-1992-08-20-mn-6381-story.html",
                "18": "https://www.academia.edu/39569927",
                "19": "http://news.bbc.co.uk/2/hi/africa/6768799.stm",
                "20": "https://www.washingtonpost.com/wp-dyn/content/article/2006/05/06/AR2006050601338.html",
                "21": "https://www.courant.com/news/connecticut/hc-xpm-2010-03-14-hc-pfizer-virus-lawsuit-0314-artmar14-story.html",
                "22": "https://www.irishtimes.com/news/five-injured-in-chemical-blast-at-pfizer-plant-1.427581"
            },
            "sourceNotes": {
                "1": "intense and unethical marketing of medications to doctors",
                "2": "illegal marketing of gabapentin medicine for off-label uses",
                "3": "illegal marketing of neurontin medicine for off-label uses",
                "4": "illegal marketing of  arthritis medicine Bextra",
                "5": "illegal marketing of  arthritis medicine Bextra",
                "6": "illegal marketing of  arthritis medicine Bextra",
                "7": "illegally bribed doctors for prescribing their drugs",
                "8": "illegally bribed doctors for prescribing their drugs",
                "9": "illegally bribed doctors for prescribing their drugs",
                "10": "spends several million dollars each year lobbying politicians",
                "11": "tax evasion",
                "12": "overcharged NHS for medicines",
                "13": "overcharged NHS for medicines",
                "14": "bullying and excessive financial pressure against latin american countries in negotations for covid vaccines",
                "15": "sold anti-smoking medication that contributed to over 20 suicides",
                "16": "sold defective heart valve that killed hundreds of patients",
                "17": "sold defective heart valve that killed hundreds of patients",
                "18": "ran dangerous drug trials on nigerian children, killing 50 children",
                "19": "ran dangerous drug trials on nigerian children, killing 50 children",
                "20": "ran dangerous drug trials on nigerian children, killing 50 children",
                "21": "fired an employee who sued pfizer for injury at work",
                "22": "explosion at pfizer plant injured 5 people"
            },
            "tags": [
                "pharmaceuticals",
                "deception",
                "corruption",
                "tax avoidance",
                "unsafe practices",
                "unsafe working conditions"
            ],
            "score": 3,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/57/Pfizer_%282021%29.svg",
            "siteUrl": "https://www.pfizer.com/",
            "updatedAt": "2026-05-08T21:13:36.033Z",
            "error": "Error [ERR_HTTP2_INVALID_SESSION]: The session has been destroyed",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Pfizer"
        },
        "warner-lambert": {
            "key": "warner-lambert",
            "names": [
                "Warner–Lambert"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "pharmaceuticals"
            ],
            "score": 3,
            "ownedBy": [
                "pfizer"
            ],
            "updatedAt": "2026-05-09T11:42:57.934Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Warner%E2%80%93Lambert"
        },
        "searle": {
            "key": "searle",
            "names": [
                "Searle"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "pharmaceuticals"
            ],
            "score": 3,
            "ownedBy": [
                "pfizer"
            ],
            "updatedAt": "2026-05-09T11:42:58.138Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/G.D._Searle,_LLC",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/97/Searle_Company_logo.svg",
            "siteUrl": "http://searlecompany.com/"
        },
        "the-upjohn-company": {
            "key": "the-upjohn-company",
            "names": [
                "The Upjohn Company"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "pharmaceuticals"
            ],
            "score": 3,
            "ownedBy": [
                "pfizer"
            ],
            "updatedAt": "2026-05-09T11:42:58.226Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/The_Upjohn_Company",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/b4/Upjohn_Logo.svg"
        },
        "pharmacia": {
            "key": "pharmacia",
            "names": [
                "Pharmacia"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "pharmaceuticals"
            ],
            "score": 3,
            "ownedBy": [
                "pfizer"
            ],
            "updatedAt": "2026-05-09T11:42:58.447Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Pharmacia",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/a/a6/Pharmacia_logo.gif"
        },
        "pharmacia-andamp-upjohn": {
            "key": "pharmacia-andamp-upjohn",
            "names": [
                "Pharmacia &amp; Upjohn"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "pharmaceuticals"
            ],
            "score": 3,
            "ownedBy": [
                "pfizer"
            ],
            "updatedAt": "2026-05-09T11:42:58.622Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Pharmacia_%26_Upjohn",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/7/75/Pharmacia_%26_Upjohn.png"
        },
        "wyeth": {
            "key": "wyeth",
            "names": [
                "Wyeth"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "pharmaceuticals"
            ],
            "score": 3,
            "ownedBy": [
                "pfizer"
            ],
            "updatedAt": "2026-05-09T11:42:58.698Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Wyeth",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/79/Wyeth_logo.svg"
        },
        "american-cyanamid": {
            "key": "american-cyanamid",
            "names": [
                "American Cyanamid"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "pharmaceuticals"
            ],
            "score": 3,
            "ownedBy": [
                "pfizer"
            ],
            "updatedAt": "2026-05-09T11:42:58.825Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/American_Cyanamid",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/a/a4/American_Cyanamid_logo.jpg",
            "siteUrl": "https://web.archive.org/web/19970418042727/http://www.cyanamid.com/"
        },
        "king-pharmaceuticals": {
            "key": "king-pharmaceuticals",
            "names": [
                "King Pharmaceuticals"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "pharmaceuticals"
            ],
            "score": 3,
            "ownedBy": [
                "pfizer"
            ],
            "updatedAt": "2026-05-09T11:42:58.911Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/King_Pharmaceuticals",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/1/10/King_Pharmaceuticals_Logo.png",
            "siteUrl": "http://kingpharm.com/"
        },
        "medivation": {
            "key": "medivation",
            "names": [
                "Medivation"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "pharmaceuticals"
            ],
            "score": 3,
            "ownedBy": [
                "pfizer"
            ],
            "updatedAt": "2026-05-09T11:42:59.099Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Medivation",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/4/47/Medivation_inc_logo.jpg",
            "siteUrl": "http://www.medivation.com/"
        },
        "array-biopharma": {
            "key": "array-biopharma",
            "names": [
                "Array BioPharma"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "pharmaceuticals"
            ],
            "score": 3,
            "ownedBy": [
                "pfizer"
            ],
            "updatedAt": "2026-05-09T11:42:59.161Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Array_BioPharma",
            "siteUrl": "https://www.arraybiopharma.com/"
        },
        "arena-pharmaceuticals": {
            "key": "arena-pharmaceuticals",
            "names": [
                "Arena Pharmaceuticals"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "pharmaceuticals"
            ],
            "score": 3,
            "ownedBy": [
                "pfizer"
            ],
            "updatedAt": "2026-05-09T11:42:59.208Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Arena_Pharmaceuticals",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/5b/Arena_Pharmaceuticals_logo.svg",
            "siteUrl": "http://arenapharm.com/"
        },
        "seagen": {
            "key": "seagen",
            "names": [
                "Seagen"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "pharmaceuticals"
            ],
            "score": 3,
            "ownedBy": [
                "pfizer"
            ],
            "updatedAt": "2026-05-09T11:42:59.496Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Seagen",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/a6/Seattle_Genetics_logo.svg",
            "siteUrl": "http://seagen.com/"
        },
        "pg-tips": {
            "key": "pg-tips",
            "names": [
                "PG Tips"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tea",
                "retail",
                "beverages"
            ],
            "score": null,
            "ownedBy": [
                "lipton-teas-and-infusions"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/8/8e/PG_Tips.png",
            "siteUrl": "https://liptonteas.com/",
            "updatedAt": "2026-05-09T11:38:23.740Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/PG_Tips"
        },
        "lipton-teas-and-infusions": {
            "key": "lipton-teas-and-infusions",
            "names": [
                "Lipton Teas and Infusions"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tea",
                "retail",
                "beverages"
            ],
            "score": null,
            "ownedBy": [
                "cvc-capital-partners"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/f/f4/Lipton_Teas_and_Infusions_Logo.svg",
            "siteUrl": "https://liptonteas.com/",
            "updatedAt": "2026-05-10T07:45:56.573Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Lipton_Teas_and_Infusions"
        },
        "brooke-bond": {
            "key": "brooke-bond",
            "names": [
                "Brooke Bond"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tea",
                "retail",
                "beverages"
            ],
            "score": null,
            "ownedBy": [
                "lipton-teas-and-infusions"
            ],
            "updatedAt": "2026-05-10T07:47:02.415Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Brooke_Bond",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/93/Brooke-bond-logo.jpg"
        },
        "t2": {
            "key": "t2",
            "names": [
                "T2"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tea",
                "retail",
                "beverages"
            ],
            "score": null,
            "ownedBy": [
                "lipton-teas-and-infusions"
            ],
            "updatedAt": "2026-05-10T07:47:02.772Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/T2_(tea_products_company)",
            "siteUrl": "http://www.t2tea.com/"
        },
        "tazo": {
            "key": "tazo",
            "names": [
                "Tazo"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tea",
                "retail",
                "beverages"
            ],
            "score": null,
            "ownedBy": [
                "lipton-teas-and-infusions"
            ],
            "updatedAt": "2026-05-10T07:47:03.155Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Tazo",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/ab/Tazo_logo.svg",
            "siteUrl": "http://www.tazo.com/"
        },
        "red-rose-tea": {
            "key": "red-rose-tea",
            "names": [
                "Red Rose Tea"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tea",
                "retail",
                "beverages"
            ],
            "score": null,
            "ownedBy": [
                "lipton-teas-and-infusions"
            ],
            "updatedAt": "2026-05-10T07:47:03.237Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Red_Rose_Tea"
        },
        "salada": {
            "key": "salada",
            "names": [
                "Salada"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tea",
                "retail",
                "beverages"
            ],
            "score": null,
            "ownedBy": [
                "lipton-teas-and-infusions"
            ],
            "updatedAt": "2026-05-10T07:47:03.489Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Salada_tea",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/7/71/Salada_tea_logo.png"
        },
        "philips": {
            "key": "philips",
            "names": [
                "Philips",
                "Koninklijke Philips N.V.",
                "PHG"
            ],
            "comment": "Philips is a Dutch company that has engaged in price fixing [1], failed to meet medical manufacturing standards [2], paid kickbacks to encourage referrals to its machines [3], sold faulty bottles exposing babies to microplastics [4], concealed information about deadly manufacturing errors [5], and produced faulty respirator machines that killed over 300 people [6][7][8][9].",
            "sources": {
                "1": "https://www.law360.com/articles/1252492",
                "2": "https://www.reuters.com/business/healthcare-pharmaceuticals/us-fda-sends-warning-letter-philips-over-three-device-production-facilities-2025-10-28/",
                "3": "https://web.archive.org/web/20220901232234/https://www.justice.gov/opa/pr/philips-subsidiary-pay-over-24-million-alleged-false-claims-caused-respironics-respiratory",
                "4": "https://www.forbes.com/sites/ariannajohnson/2024/06/25/new-lawsuits-claim-baby-bottles-manufacturers-misleadingly-exposed-infants-to-harmful-microplastics/",
                "5": "https://www.propublica.org/article/philips-kept-warnings-about-dangerous-cpaps-secret-profits-soared",
                "6": "https://www.abc.net.au/news/2025-06-04/tga-launches-legal-action-against-philips-electronics/105375196",
                "7": "https://web.archive.org/web/20220519203053/https://www.fda.gov/medical-devices/safety-communications/update-certain-philips-respironics-ventilators-bipap-machines-and-cpap-machines-recalled-due",
                "8": "https://www.cbsnews.com/news/philips-settlement-cpap-recall-lawsuit-fda/",
                "9": "https://www.reuters.com/business/healthcare-pharmaceuticals/philips-faces-french-criminal-investigation-over-sleep-apnea-recall-2025-09-08/"
            },
            "sourceNotes": {
                "1": "price fixing",
                "2": "failed to meet medical manufacturing standards",
                "3": "paid kickbacks to encourage referrals to its machines",
                "4": "sold faulty bottles which exposed babies to microplastics",
                "5": "concealed information about deadly manufacturing errors",
                "6": "produced faulty respirator machines that killed over 300 people",
                "7": "produced faulty respirator machines that killed over 300 people",
                "8": "produced faulty respirator machines that killed over 300 people",
                "9": "produced faulty respirator machines that killed over 300 people"
            },
            "tags": [
                "electronics",
                "tech",
                "healthcare",
                "anticompetitive practices",
                "corruption",
                "deception",
                "unsafe practices"
            ],
            "score": 12,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/52/Philips_logo_new.svg",
            "siteUrl": "http://philips.com/",
            "updatedAt": "2026-05-10T07:46:30.367Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Philips"
        },
        "pinterest": {
            "key": "pinterest",
            "names": [
                "Pinterest",
                "Pinterest, Inc.",
                "PINS"
            ],
            "comment": "Pinterest is an American company that secretly tracked users [1] and failed to compensate a platform co‑creator [2]. Pinterest has a record of racial discrimination and sexism against employees [3][4][5][6][7][8][9][10].",
            "sources": {
                "1": "https://techchannel.news/pinterest-flouts-privacy-laws-by-secretly-tracking-users/",
                "2": "https://www.nytimes.com/2025/05/09/technology/pinterest-settles-lawsuit-34-7-million.html",
                "3": "https://web.archive.org/web/20210927173810/https://www.theguardian.com/technology/2021/may/10/pinterest-discrimination-ifeoma-ozoma-nda",
                "4": "https://web.archive.org/web/20210930184113/https://www.npr.org/2020/06/23/881624553/pinterest-sounds-a-more-contrite-tone-after-black-former-employees-speak-out",
                "5": "https://www.fastcompany.com/90587126/pinterest-gender-discrimination-settlement-backlash-racism",
                "6": "https://web.archive.org/web/20201216003951/https://www.theguardian.com/technology/2020/dec/15/pinterest-to-pay-20m-to-settle-gender-discrimination-lawsuit",
                "7": "https://web.archive.org/web/20210114201304/https://www.cnbc.com/2020/08/14/pinterest-to-announce-new-board-member-as-employees-stage-virtual-walkout.html",
                "8": "https://web.archive.org/web/20201215074722/https://sanfrancisco.cbslocal.com/2020/12/14/sf-based-pinterest-agrees-to-pay-22-million-to-settle-gender-discrimination-lawsuit/",
                "9": "https://web.archive.org/web/20211125235334/https://www.theverge.com/2021/11/24/22801574/pinterest-racial-gender-discrimination-shareholder-lawsuit-settlement",
                "10": "https://www.nytimes.com/2021/11/24/technology/pinterest-discrimination-settlement.html"
            },
            "sourceNotes": {
                "1": "secretly tracked users",
                "2": "failed to compensate platform co-creator",
                "3": "racial discrimination against employees",
                "4": "racial discrimination against employees",
                "5": "racial discrimination against employees",
                "6": "sexism and racial discrimination",
                "7": "sexism and racial discrimination",
                "8": "sexism and racial discrimination",
                "9": "sexism and racial discrimination",
                "10": "sexism and racial discrimination"
            },
            "tags": [
                "tech",
                "privacy violations",
                "unfair pay",
                "racial discrimination",
                "gender discrimination",
                "deception"
            ],
            "score": 35,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/e/ed/Pinterest_Logo_3.svg",
            "siteUrl": "https://pinterest.com/",
            "updatedAt": "2026-05-12T07:28:06.046Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Pinterest"
        },
        "pixar": {
            "key": "pixar",
            "names": [
                "Pixar"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 20,
            "ownedBy": [
                "disney"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/40/Pixar_logo.svg",
            "siteUrl": "https://www.pixar.com/",
            "updatedAt": "2026-05-12T07:28:06.046Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Pixar"
        },
        "playmobil": {
            "key": "playmobil",
            "names": [
                "Playmobil",
                "Brandstatter",
                "Brandstätter Group"
            ],
            "comment": "Playmobil is a German toy company that has been accused of perpetuating racism through its toy lines [1][2].",
            "sources": {
                "1": "https://www.theguardian.com/world/2015/oct/09/playmobil-toys-accused-stereotypes-racism",
                "2": "https://www.thetimes.com/comment/register/article/playmobil-accused-of-racism-over-slave-aboard-pirate-ship-f7hfrcxn8wh"
            },
            "sourceNotes": {
                "1": "perpetuated racism through toys",
                "2": "perpetuated racism through toys"
            },
            "tags": [
                "toys",
                "racial discrimination"
            ],
            "score": 48,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/41/Playmobil_logo.svg",
            "siteUrl": "https://upload.wikimedia.org/wikipedia/commons/4/41/Playmobil_logo.svg",
            "updatedAt": "2026-05-14T19:03:30.974Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Playmobil"
        },
        "playstation": {
            "key": "playstation",
            "names": [
                "PlayStation"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "videogames",
                "entertainment"
            ],
            "score": 50,
            "ownedBy": [
                "sony"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/5c/PlayStation_logo_and_wordmark.svg",
            "siteUrl": "https://www.playstation.com/",
            "updatedAt": "2026-05-14T19:03:30.974Z",
            "error": "Error [ERR_HTTP2_INVALID_SESSION]: The session has been destroyed",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/PlayStation"
        },
        "popeyes": {
            "key": "popeyes",
            "names": [
                "Popeyes",
                "Popeyes Louisiana Kitchen, Inc.",
                "Popeyes Louisiana Kitchen, Inc.",
                "Popeyes Famous Fried Chicken & Biscuits"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fast food"
            ],
            "score": null,
            "ownedBy": [
                "restaurant-brands-international"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/0d/Popeyes_Logo_2020.svg",
            "siteUrl": "http://popeyes.com/",
            "updatedAt": "2026-05-16T08:37:07.986Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Popeyes"
        },
        "tim-hortons": {
            "key": "tim-hortons",
            "names": [
                "Tim Hortons"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fast food"
            ],
            "score": null,
            "ownedBy": [
                "restaurant-brands-international"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/be/Tim_Hortons_Logo.svg",
            "siteUrl": "https://www.timhortons.com/",
            "updatedAt": "2026-05-16T08:37:07.986Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Tim_Hortons"
        },
        "waitrose": {
            "key": "waitrose",
            "names": [
                "Waitrose"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "supermarket",
                "poor working conditions"
            ],
            "score": 45,
            "ownedBy": [
                "john-lewis"
            ],
            "updatedAt": "2026-05-16T08:41:23.237Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Waitrose_%26_Partners",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/ba/Waitrose_%26_Partners_logo.svg",
            "siteUrl": "https://waitrose.com/"
        },
        "potbelly-sandwich-shop": {
            "key": "potbelly-sandwich-shop",
            "names": [
                "Potbelly Sandwich Shop",
                "Potbelly Sandwich Works",
                "Potbelly",
                "Potbelly Corporation"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fast food"
            ],
            "score": 37,
            "ownedBy": [
                "racetrac"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/5/5b/Potbelly_Sandwich_Shop_logo.svg",
            "siteUrl": "https://potbelly.com/",
            "updatedAt": "2026-05-16T08:37:07.986Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Potbelly_Sandwich_Shop"
        },
        "pottery-barn": {
            "key": "pottery-barn",
            "names": [
                "Pottery Barn"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 42,
            "ownedBy": [
                "williams-sonoma"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/d/d0/Pottery_Barn_logo.svg",
            "siteUrl": "https://www.potterybarn.com/",
            "updatedAt": "2026-05-18T17:38:03.155Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Pottery_Barn"
        },
        "prada": {
            "key": "prada",
            "names": [
                "Prada",
                "Prada",
                "Prada S.p.A.",
                "Fratelli Prada"
            ],
            "comment": "Prada is a Italian luxury fashion house that has appropriated traditional cultural clothing in its designs [1] and has been criticized for lacking animal welfare policies [2]. The brand has also faced accusations of using racist imagery in its products [3][4][5], and its supply chain has been linked to deforestation [6] and labour abuses [7][8][9].",
            "sources": {
                "1": "https://www.theguardian.com/world/2025/jun/30/prada-accused-of-cashing-in-on-indian-culture-with-kolhapuri-inspired-sandals",
                "2": "https://www.lav.it/news/prada-first-animal-welfare-policy-criticized",
                "3": "https://www.nbcnews.com/news/us-news/prada-was-slammed-over-merchandise-deemed-racist-now-it-will-n1131466",
                "4": "https://ccrjustice.org/home/press-center/press-releases/prada-blackface-scandal-results-major-settlement",
                "5": "https://edition.cnn.com/2020/02/06/business/prada-black-face-agreement/",
                "6": "https://www.ran.org/wp-content/uploads/2018/06/Lessons_From_The_Incense_Forests.pdf",
                "7": "https://www.reuters.com/business/italian-police-seek-governance-documents-13-fashion-firms-labour-abuse-probe-2025-12-04/",
                "8": "https://www.fastcompany.com/90279693/did-a-slave-make-your-sneakers-the-answer-is-probably",
                "9": "https://www.luxurytribune.com/en/fashion-brands-fail-in-transparency-and-decarbonisation"
            },
            "sourceNotes": {
                "1": "appropriated traditional cultural clothing in their designs",
                "2": "lacking animal welfare policies",
                "3": "used racist imagery",
                "4": "used racist imagery in products",
                "5": "used racist imagery in products",
                "6": "deforestation in supply chain",
                "7": "labour abuses in supply chain",
                "8": "labour abuses in supply chain",
                "9": "labour abuses in supply chain"
            },
            "tags": [
                "retail",
                "clothing",
                "deforestation",
                "racial discrimination",
                "animal abuse",
                "environmental violations",
                "unsustainable practices"
            ],
            "score": 38,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/b8/Prada-Logo.svg",
            "siteUrl": "https://www.prada.com/",
            "updatedAt": "2026-05-19T09:16:45.201Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Prada"
        },
        "versace": {
            "key": "versace",
            "names": [
                "Versace"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "clothing"
            ],
            "score": 38,
            "ownedBy": [
                "prada"
            ],
            "updatedAt": "2026-05-19T11:49:15.300Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Versace",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/4c/Versace_old_logo.svg",
            "siteUrl": "https://www.versace.com/"
        },
        "miu-miu": {
            "key": "miu-miu",
            "names": [
                "Miu Miu"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "clothing"
            ],
            "score": 38,
            "ownedBy": [
                "prada"
            ],
            "updatedAt": "2026-05-19T11:49:15.734Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Miu_Miu",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/b4/Miu_Miu_-_logo_%28Italy%2C_1993%29.svg",
            "siteUrl": "http://www.miumiu.com/"
        },
        "church's": {
            "key": "church's",
            "names": [
                "Church's"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "clothing"
            ],
            "score": 38,
            "ownedBy": [
                "prada"
            ],
            "updatedAt": "2026-05-19T11:49:15.805Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Church%27s",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/df/Churchs_logo.png",
            "siteUrl": "http://church-footwear.com/"
        },
        "car-shoe": {
            "key": "car-shoe",
            "names": [
                "Car Shoe"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "clothing"
            ],
            "score": 38,
            "ownedBy": [
                "prada"
            ],
            "updatedAt": "2026-05-19T11:49:15.894Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Car_Shoe",
            "siteUrl": "http://www.carshoe.com/"
        },
        "luna-rossa": {
            "key": "luna-rossa",
            "names": [
                "Luna Rossa"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "clothing"
            ],
            "score": 38,
            "ownedBy": [
                "prada"
            ],
            "updatedAt": "2026-05-19T11:49:15.946Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Luna_Rossa"
        },
        "fondazione-prada": {
            "key": "fondazione-prada",
            "names": [
                "Fondazione Prada"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "clothing"
            ],
            "score": 38,
            "ownedBy": [
                "prada"
            ],
            "updatedAt": "2026-05-19T11:49:16.034Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Fondazione_Prada"
        },
        "princes": {
            "key": "princes",
            "names": [
                "Princes",
                "Princes Group plc",
                "Princes Group",
                "PRN"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "beverages"
            ],
            "score": 43,
            "ownedBy": [
                "newprinces"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/5/5a/Prince_Holding_Group_logo.png",
            "siteUrl": "https://www.princeholdinggroup.com/",
            "updatedAt": "2026-05-20T08:33:07.020Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Prince_Group"
        },
        "newprinces": {
            "key": "newprinces",
            "names": [
                "NewPrinces",
                "NewPrinces S.p.A.",
                "NewPrinces Group",
                "Newlat",
                "NWL"
            ],
            "comment": "NewPrinces is an Italian food and beverage company that has been accused of punishing striking workers [1] and engaging in unsustainable fishing practices [2].",
            "sources": {
                "1": "https://www.wsws.org/en/articles/2025/01/31/ksdu-j31.html",
                "2": "https://www.liverpoolecho.co.uk/news/liverpool-news/john-west-princes-slammed-over-10204690"
            },
            "sourceNotes": {
                "1": "punished striking workers",
                "2": "unsustainable fishing practices"
            },
            "tags": [
                "food",
                "beverages",
                "anti-union practices",
                "unsustainable practices"
            ],
            "score": 43,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/01/NewPrinces.svg",
            "siteUrl": "https://www.newprinces.it/en",
            "updatedAt": "2026-05-20T08:59:19.779Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/NewPrinces"
        },
        "crisp-'n-dry": {
            "key": "crisp-'n-dry",
            "names": [
                "Crisp 'n Dry"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "beverages"
            ],
            "score": 43,
            "ownedBy": [
                "newprinces"
            ],
            "updatedAt": "2026-05-20T10:33:41.399Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Crisp_%27n_Dry"
        },
        "crosse-and-blackwell": {
            "key": "crosse-and-blackwell",
            "names": [
                "Crosse & Blackwell"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "beverages"
            ],
            "score": 43,
            "ownedBy": [
                "newprinces"
            ],
            "updatedAt": "2026-05-20T10:33:42.162Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Crosse_%26_Blackwell",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/5/5d/Crosse_blackwell_logo.png",
            "siteUrl": "https://www.crosseandblackwell.com/"
        },
        "napolina": {
            "key": "napolina",
            "names": [
                "Napolina"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 43,
            "ownedBy": [
                "newprinces"
            ],
            "updatedAt": "2026-05-20T10:33:42.162Z",
            "logoUrl": "https://www.newprinces.it/_next/image?url=%2Fmedia-library%2Fimg%2F1781ecf7982c965c07c183e46f77b91ddf2a9cbd%2Fimage.png&w=992&q=75",
            "siteUrl": "https://www.newprinces.it/en/brands/napolina"
        },
        "mazola": {
            "key": "mazola",
            "names": [
                "Mazola"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "beverages"
            ],
            "score": 43,
            "ownedBy": [
                "newprinces"
            ],
            "updatedAt": "2026-05-20T10:33:42.749Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Mazola",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/16/Associated_British_Foods_Logo.svg",
            "siteUrl": "https://abf.co.uk/"
        },
        "progressive-corporation": {
            "key": "progressive-corporation",
            "names": [
                "Progressive Corporation",
                "PGR"
            ],
            "comment": "Progressive Corporation is an American insurance company that often rejects customers' insurance claims [1], failed to protect customers' information leading to data breaches [2][3], and defrauded Medicare and Medicaid [4]. It systematically underpaid customers who lost their cars in accidents [5][6][7], provided legal assistance against its own customers to avoid paying out insurance claims [8], spied on a church group making an insurance claim [9], and drove customers into debt after delaying and rejecting their valid insurance claims [10].",
            "sources": {
                "1": "https://www.danielstark.com/blog/insurance-companies-that-might-screw-you-progressive/",
                "2": "https://www.classaction.org/news/3.25m-progressive-settlement-resolves-class-action-lawsuit-over-years-long-data-breach",
                "3": "https://legalnewsfeed.com/2024/11/12/proposed-class-action-alleges-progressive-shared-crash-victims-data-with-law-firm/",
                "4": "https://www.justice.gov/usao-nj/pr/two-insurance-companies-agree-pay-more-2-million-resolve-false-claims-act-allegations",
                "5": "https://allaboutlawyer.com/progressive-class-action-lawsuit-multiple-settlements-totaling-over-200-million-impact-thousands-of-policyholders/",
                "6": "https://www.insurancebusinessmag.com/us/news/auto-motor/progressive-in-huge-settlement-with-policyholders-495637.aspx",
                "7": "https://www.law360.com/articles/2265884/progressive-s-61m-total-loss-deal-gets-approved",
                "8": "https://www.nytimes.com/2012/08/18/your-money/progressives-side-of-the-insurance-case-that-blew-up-on-the-internet.html",
                "9": "https://www.reuters.com/article/domesticNews/idUSN2326105820070823?feedType=RSS&feedName=domesticNews",
                "10": "https://blog.cvn.com/100m-punitive-bad-faith-verdict-against-progressive-beats-1.9m-settlement-offer-watch-trial-via-cvn"
            },
            "sourceNotes": {
                "1": "often rejects customers' insurance claims",
                "2": "failed to protect customers' information leading to data breach",
                "3": "failed to protect customers' information leading to data breach",
                "4": "defrauded and  medicare and medicaid",
                "5": "systematically underpaid customers who lost their cars in accidents",
                "6": "systematically underpaid customers who lost their cars in accidents",
                "7": "systematically underpaid customers who lost their cars in accidents",
                "8": "provided legal assistance against their own customer to avoid paying out insurance claim",
                "9": "spied on church group making insurance claim",
                "10": "drove customer into debt after delaying and rejecting their valid insurance claim"
            },
            "tags": [
                "insurance",
                "finance",
                "data breach",
                "privacy violations",
                "deception",
                "unfair pay"
            ],
            "score": 38,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/d/d8/Logo_of_the_Progressive_Corporation.svg",
            "siteUrl": "https://www.progressive.com/",
            "updatedAt": "2026-05-20T10:39:28.337Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Progressive_Corporation"
        },
        "ralph-lauren": {
            "key": "ralph-lauren",
            "names": [
                "Ralph Lauren",
                "Ralph Lauren Corporation",
                "Polo Ralph Lauren",
                "Polo Ralph Lauren Corporation",
                "RL"
            ],
            "comment": "Ralph Lauren is an American fashion brand that has faced accusations of misleading pricing [1], copying Mexican indigenous designs [2] and South Asian jewellery designs [3], and editing photos of and firing a model for not being thin enough [4]. The company has also been implicated in racism against employees [5], bribing Argentinian officials [6], partnering closely with Israeli firms [7], sourcing fabrics that may involve deforestation and rainforest destruction [8], underpaying employees [9], and employing forced Uyghur labour and other forced labour in its supply chain [10][11][12].",
            "sources": {
                "1": "https://topclassactions.com/lawsuit-settlements/consumer-products/apparel/ralph-lauren-class-action-claims-retailer-advertises-fake-discount-prices/",
                "2": "https://www.bbc.co.uk/news/world-latin-america-63342715",
                "3": "https://indianexpress.com/article/lifestyle/fashion/ralph-lauren-backlash-south-asian-jhumkas-paris-fashion-week-10574002/",
                "4": "http://www.huffingtonpost.com/2009/10/14/filippa-hamilton-ralph-la_n_320396.html",
                "5": "https://www.independent.co.uk/news/uk/home-news/ralph-lauren-racism-employee-tribunal-b2494054.html",
                "6": "https://www.justice.gov/archives/opa/pr/ralph-lauren-corporation-resolves-foreign-corrupt-practices-act-investigation-and-agrees-pay",
                "7": "https://wwd.com/fashion-news/intimates/feature/delta-galil-polo-ralph-lauren-womens-intimates-licensing-deal-1234990766/",
                "8": "https://www.ran.org/wp-content/uploads/2018/06/Lessons_From_The_Incense_Forests.pdf",
                "9": "https://www.law360.com/articles/61669/judge-certifies-class-of-polo-ralph-lauren-employees",
                "10": "https://www.reuters.com/business/retail-consumer/canadas-corporate-watchdog-probes-ralph-lauren-alleged-use-forced-labor-china-2023-08-15/",
                "11": "https://www.straitstimes.com/world/ralph-lauren-probed-in-canada-over-uyghur-forced-labour-claims",
                "12": "https://www.bbc.co.uk/news/world-asia-54960346"
            },
            "sourceNotes": {
                "1": "misleading pricing",
                "2": "copied mexican indigenous designs",
                "3": "copied south asian jewellery designs",
                "4": "edited photos of and fired a model for not being thin enough",
                "5": "racism against employees",
                "6": "bribed argentinian officials",
                "7": "close partnerships with Israeli firms",
                "8": "sources fabric that may involve deforestation and rainforest destruction",
                "9": "underpaid employees",
                "10": "forced Uyghur labour in supply chain",
                "11": "forced Uyghur labour in supply chain",
                "12": "forced labour and exploitation in supply chain"
            },
            "tags": [
                "clothing",
                "retail",
                "deception",
                "unfair pay",
                "forced labour",
                "forced uyghur labour",
                "racial discrimination",
                "connections to israel",
                "deforestation",
                "unsustainable practices",
                "environmental violations",
                "corruption"
            ],
            "score": 32,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/72/Ralph_Lauren_logo.svg",
            "siteUrl": "http://ralphlauren.com/",
            "updatedAt": "2026-05-20T10:39:28.337Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Ralph_Lauren_Corporation"
        },
        "publix": {
            "key": "publix",
            "names": [
                "Publix",
                "Publix Super Markets, Inc."
            ],
            "comment": "Publix is a US-based grocery chain that has donated to Republican political funds [1][2] and to anti‑LGBTQ political funds [3]. The company has been criticized for underpaying employees [4][5], and discriminating against employees on the basis of gender [6], race [7][8], and LGBTQ status [9].",
            "sources": {
                "1": "https://www.miaminewtimes.com/news/publix-gave-100000-to-republican-florida-gov-ron-desantis-11802566",
                "2": "https://gainesvilleiguana.org/2021/articles/problems-with-publix-why-were-boycotting/",
                "3": "https://www.newsweek.com/how-publix-got-caught-dont-say-gay-aftermath-1700661",
                "4": "https://www.fslawfirm.com/blog/2021/04/publix-supermarket-to-settle-ot-lawsuit-for-over-7m/",
                "5": "https://www.law360.com/articles/618279/publix-strikes-30m-settlement-with-employees-in-ot-row",
                "6": "https://www.latimes.com/archives/la-xpm-1997-01-25-fi-22037-story.html",
                "7": "https://www.supermarketnews.com/independents-regional-grocers/publix-offers-to-settle-race-case-for-10m",
                "8": "https://clearinghouse.net/case/11516/",
                "9": "https://www.miaminewtimes.com/news/five-stories-of-publix-anti-gay-accusations-10051384/"
            },
            "sourceNotes": {
                "1": "donated to republian political funds",
                "2": "donated to republian political funds",
                "3": "donated to anti-LGBTQ poliitcal funds",
                "4": "underpaid employees",
                "5": "underpaid employees",
                "6": "gender discrimination against employees",
                "7": "racial discrimination against employees",
                "8": "racial discrimination against employees",
                "9": "discrimination against LGBTQ employees"
            },
            "tags": [
                "supermarket",
                "food",
                "retail",
                "unfair pay",
                "racial discrimination",
                "gender discrimination"
            ],
            "score": 35,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/5f/PublixLogo.svg",
            "siteUrl": "https://www.publix.com/",
            "updatedAt": "2026-05-25T23:17:20.423Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Publix"
        },
        "puma": {
            "key": "puma",
            "names": [
                "Puma",
                "Puma SE",
                "PUM"
            ],
            "comment": "Puma is a German sportswear company that has been accused of underpaying employees [1] and engaging in forced labour and exploitation throughout its supply chain [2][3], including forced overtime that caused 30 garment workers to faint [4] and sweatshop conditions in Bangladeshi suppliers [5]. The company has also been linked to forced Uyghur labour in its supply chain [6] and a tragic incident where a female employee was shot while protesting for better working conditions [7].",
            "sources": {
                "1": "https://www.law360.com/articles/134604/puma-settles-flsa-late-pay-collective-action",
                "2": "https://web.archive.org/web/20201029164347/https://www.just-style.com/news/puma-accused-of-chinese-sweatshop-exploitation_id69378.aspx",
                "3": "https://chinalaborwatch.org/pumas-failure-in-csr-suppliers-critical-conditions/",
                "4": "https://web.archive.org/web/20210905185016/https://www.washingtonpost.com/news/morning-mix/wp/2014/04/10/mass-faintings-in-cambodia-whats-the-reason/",
                "5": "https://waronwant.org/sites/default/files/Race%20to%20the%20Bottom.pdf",
                "6": "https://web.archive.org/web/20220506225913/https://www.theguardian.com/world/2022/may/05/xinjiang-cotton-found-adidas-puma-hugo-boss-tops-researchers-claim-uyghur",
                "7": "https://web.archive.org/web/20220530194234/https://www.reuters.com/article/puma-cambodia/puma-officials-go-to-cambodia-after-factory-shooting-idUSL5E8DN8S820120223"
            },
            "sourceNotes": {
                "1": "underpaid employees",
                "2": "forced labour and exploitation in supply chain",
                "3": "forced labour and exploitation in supply chain",
                "4": "forced overtime leading to 30 garment workers fainting",
                "5": "sweatshop working conditions in bangladeshi suppliers",
                "6": "forced Uyghur labour in supply chain",
                "7": "female employee was shot for protesting for better working conditions"
            },
            "tags": [
                "sportswear",
                "retail",
                "unfair pay",
                "forced labour",
                "forced uyghur labour",
                "poor working conditions",
                "unsafe working conditions"
            ],
            "score": 15,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/da/Puma_complete_logo.svg",
            "siteUrl": "https://eu.puma.com/",
            "updatedAt": "2026-05-26T06:20:38.898Z",
            "error": "Error [ERR_HTTP2_INVALID_SESSION]: The session has been destroyed",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Puma_(brand)"
        },
        "razer": {
            "key": "razer",
            "names": [
                "Razer",
                "Razer Inc.",
                "雷蛇"
            ],
            "comment": "Razer is a Singaporean company that has sold poor quality products [1] and taken a wasteful approach to product replacements [2]. The company has also falsely advertised its face mask [3], failed to protect customer data [4], and engaged in sexist advertising [5].",
            "sources": {
                "1": "https://www.pcgamer.com/hardware/gaming-laptops/a-pr-storm-has-erupted-around-razers-gaming-laptops-with-reports-of-faulty-trackpads-and-keyboards-glitchy-software-performance-issues-and-poor-customer-support/",
                "2": "https://www.thecooldown.com/green-business/razer-warranty-return-broken-mouse-e-waste/",
                "3": "https://uk.pcmag.com/game-controllers-accessories/152060/ftc-forces-razer-to-pay-1m-for-zephyr-mask-refunds-over-deceptive-marketing",
                "4": "https://www.techbloat.com/razer-accidentally-exposed-data-of-over-100000-customers.html",
                "5": "https://www.pcgamer.com/hardware/gaming-headsets/razer-thoughtlessly-alienates-half-its-audience-with-ad-showing-a-man-blocking-out-a-womans-yapping-with-its-latest-headset/"
            },
            "sourceNotes": {
                "1": "sold poor quality products",
                "2": "wasteful approach to product replacements",
                "3": "falsely advertised their face mask",
                "4": "failed to protect customer data",
                "5": "sexist advertising"
            },
            "tags": [
                "electronics",
                "deception",
                "privacy violations",
                "gender discrimination",
                "unsustainable practices",
                "unsafe practices"
            ],
            "score": 44,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/52/Razer_wordmark.svg",
            "siteUrl": "https://www.razer.com/",
            "updatedAt": "2026-05-26T06:42:16.026Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Razer_Inc."
        },
        "red-lobster": {
            "key": "red-lobster",
            "names": [
                "Red Lobster",
                "Red Lobster Hospitality LLC"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurant",
                "food"
            ],
            "score": null,
            "ownedBy": [
                "rl-investor-holdings"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/b/b1/Redlobster_logocopia.png",
            "siteUrl": "https://www.redlobster.com/",
            "updatedAt": "2026-05-27T14:10:43.126Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Red_Lobster"
        },
        "recreational-equipment-inc.": {
            "key": "recreational-equipment-inc.",
            "names": [
                "Recreational Equipment, Inc.",
                "REI"
            ],
            "comment": "Recreational Equipment, Inc. is an American company that has been criticized for poor labour standards and conditions [1][2][3], as well as labour rights abuses and anti‑union practices [4][5] and underpaying employees [6]. Additionally, the company has sold products containing unsafe PFAS chemicals [7].",
            "sources": {
                "1": "https://www.vice.com/en/article/unionizing-rei-workers-want-their-progressive-employer-to-pay-a-living-wage/",
                "2": "https://www.motherjones.com/politics/2022/02/rei-coop-union-busting/",
                "3": "https://www.rwdsu.org/news/rei-workers-take-nationwide-legal-action-against-employer",
                "4": "https://web.archive.org/web/20231115181033/https://www.reuters.com/business/retail-consumer/rei-accused-widespread-labor-law-violations-unionized-us-stores-2023-11-15/",
                "5": "https://www.aljazeera.com/economy/2023/12/7/as-retailer-reis-troubles-with-employees-continue-consumers-back-off",
                "6": "https://www.lawyersandsettlements.com/settlements/18473/2-5m-settlement-reached-in-rei-unpaid-overtime.html",
                "7": "https://www.classaction.org/media/lupia-v-recreational-equipment-inc.pdf"
            },
            "sourceNotes": {
                "1": "poor labour standards",
                "2": "poor labour standards",
                "3": "poor labour conditions",
                "4": "labour rights abuses and anti-union practices",
                "5": "anti-union practices",
                "6": "underpaid employees",
                "7": "sold products containing unsafe PFAS chemicals"
            },
            "tags": [
                "retail",
                "sportswear",
                "anti-union practices",
                "poor working conditions",
                "unfair pay",
                "unsafe working conditions",
                "unsafe practices",
                "environmental violations"
            ],
            "score": 44,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/9/9b/REI_logo.svg",
            "siteUrl": "https://www.rei.com/",
            "updatedAt": "2026-05-27T14:10:43.126Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/REI"
        },
        "revlon": {
            "key": "revlon",
            "names": [
                "Revlon",
                "Revlon",
                "Revlon, Inc."
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": null,
            "ownedBy": [
                "macandrews-and-forbes"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/5e/Revlon_logo.svg",
            "siteUrl": "https://www.revlon.com/",
            "updatedAt": "2026-05-29T07:56:45.425Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Revlon"
        },
        "revolut": {
            "key": "revolut",
            "names": [
                "Revolut",
                "Revolut Group Holdings Ltd"
            ],
            "comment": "Revolut is a UK-based fintech company that has been accused of misleading customers [1], enabling money laundering [2], and failing to protect or reimburse defrauded customers [3][4]. Its internal practices have been criticized for poor working conditions [5], high turnover and unpaid work for employees [6], and unexplained customer account closures [7][8].",
            "sources": {
                "1": "https://www.reuters.com/sustainability/boards-policy-regulation/italy-regulator-fines-revolut-13-million-alleged-unfair-commercial-practices-2026-04-02/",
                "2": "https://www.irishtimes.com/business/2025/04/08/revolut-fined-35m-by-over-money-laundering-control-failures/",
                "3": "https://www.bbc.co.uk/news/articles/cj6epzxdd77o",
                "4": "https://www.thisismoney.co.uk/money/saving/article-15152589/Revolut-receives-fraud-complaints-bank-year-running.html",
                "5": "https://web.archive.org/web/20210901154118/https://www.wired.co.uk/article/revolut-trade-unions-labour-fintech-politics-storonsky",
                "6": "https://www.fintechfutures.com/regulations-compliance/revolut-rocked-by-compliance-and-culture-criticisms",
                "7": "https://web.archive.org/web/20210111020824/https://www.thetimes.co.uk/article/nikolay-storonskys-revolut-freezes-accounts-in-money-laundering-bungle-5nt3lv6zk",
                "8": "https://web.archive.org/web/20200306172211/https://www.telegraph.co.uk/news/2020/01/24/ex-ucl-lecturer-forced-travel-london-france-attempts-unblock/"
            },
            "sourceNotes": {
                "1": "misleading customers",
                "2": "enabled money laundering",
                "3": "failed to protect or reimburse defrauded customers",
                "4": "failed to protect or reimburse defrauded customers",
                "5": "poor working conditions",
                "6": "high turnover and unpaid work for employees",
                "7": "unexplained customer account closures",
                "8": "unexplained customer account closures"
            },
            "tags": [
                "finance",
                "tech",
                "deception",
                "corruption",
                "poor working conditions",
                "unfair pay"
            ],
            "score": 44,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/73/Revolut_logo.svg",
            "siteUrl": "https://revolut.com/",
            "updatedAt": "2026-05-29T07:56:45.425Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Revolut"
        },
        "rewe-group": {
            "key": "rewe-group",
            "names": [
                "REWE Group",
                "REWE",
                "Revisionsverband der Westkauf-Genossenschaften",
                "Stüssgen",
                "Rewe"
            ],
            "comment": "REWE Group is a German retail company that has breached customers' data privacy [1], engaged in misleading pricing [2], and used wasteful packaging [3]. The group has also run misleading advertising campaigns [4] and pursued anticompetitive monopolistic practices [5].",
            "sources": {
                "1": "https://responsema.org/privacy/rewe-international-9m-gdpr-fine-a-lesson-in-managing-subsidiary-risk/",
                "2": "https://www.expats.cz/czech-news/article/czech-supermarkets-rack-up-millions-in-fines-for-misleading-discounts",
                "3": "https://www.huffingtonpost.co.uk/entry/billa-peeled-bananas-plastic-wrap_n_1900267",
                "4": "https://seenews.com/news/billa-bulgaria-gets-fined-for-misleading-advertisements-1279666",
                "5": "https://uohs.gov.cz/cs/vyznamna-trzni-sila/aktuality-z-vyznamne-trzni-sily/2558-retezce-skupiny-rewe-zneuzily-vyznamnou-trzni-silu-po-narovnani-cini-jejich-pokuta-164-milionu-korun.html"
            },
            "sourceNotes": {
                "1": "breached customers' data privacy",
                "2": "misleading pricing",
                "3": "wasteful packaging",
                "4": "misleading advertising",
                "5": "anticompetitive monopolistic practices"
            },
            "tags": [
                "retail",
                "supermarket",
                "anticompetitive practices",
                "privacy violations",
                "data breach",
                "deception",
                "unsustainable practices",
                "environmental violations"
            ],
            "score": 43,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/36/Rewe-group.svg",
            "siteUrl": "http://rewe-group.com/",
            "updatedAt": "2026-05-31T20:57:29.372Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/REWE_Group"
        },
        "billa": {
            "key": "billa",
            "names": [
                "Billa"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "supermarket"
            ],
            "score": "43",
            "ownedBy": [
                "rewe-group"
            ],
            "updatedAt": "2026-05-31T22:34:57.607Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Billa_(supermarket)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/51/BILLA_LOGO.png",
            "siteUrl": "https://www.billa.at/"
        },
        "penny": {
            "key": "penny",
            "names": [
                "Penny"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "supermarket"
            ],
            "score": "43",
            "ownedBy": [
                "rewe-group"
            ],
            "updatedAt": "2026-05-31T22:34:57.878Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Penny_(supermarket)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/8e/Penny-Logo.svg",
            "siteUrl": "http://www.penny.de/"
        },
        "rewe": {
            "key": "rewe",
            "names": [
                "Rewe"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "supermarket"
            ],
            "score": "43",
            "ownedBy": [
                "rewe-group"
            ],
            "updatedAt": "2026-05-31T22:34:57.961Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/REWE",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/4c/Logo_REWE.svg"
        },
        "toom": {
            "key": "toom",
            "names": [
                "Toom"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "supermarket"
            ],
            "score": "43",
            "ownedBy": [
                "rewe-group"
            ],
            "updatedAt": "2026-05-31T22:34:58.014Z",
            "wikipediaUrl": "https://de.wikipedia.org/wiki/Toom_Baumarkt",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/44/Toom_Baumarkt.svg",
            "siteUrl": "https://www.toom.de/"
        },
        "der-touristik-germany": {
            "key": "der-touristik-germany",
            "names": [
                "DER Touristik Germany"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "supermarket"
            ],
            "score": "43",
            "ownedBy": [
                "rewe-group"
            ],
            "updatedAt": "2026-05-31T22:34:58.115Z",
            "wikipediaUrl": "https://de.wikipedia.org/wiki/DER_Touristik_Deutschland",
            "siteUrl": "https://www.dertour-group.com/markenwelt/"
        },
        "reisen": {
            "key": "reisen",
            "names": [
                "Reisen"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "supermarket"
            ],
            "score": "43",
            "ownedBy": [
                "rewe-group"
            ],
            "updatedAt": "2026-05-31T22:34:58.460Z",
            "wikipediaUrl": "https://de.wikipedia.org/wiki/ITS_Reisen",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/de/2/29/ITS.svg",
            "siteUrl": "https://www.its.de/"
        },
        "lekkerland": {
            "key": "lekkerland",
            "names": [
                "Lekkerland"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "supermarket"
            ],
            "score": "43",
            "ownedBy": [
                "rewe-group"
            ],
            "updatedAt": "2026-05-31T22:34:58.793Z",
            "wikipediaUrl": "https://de.wikipedia.org/wiki/Lekkerland",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/de/6/65/Lekkerland_logo.svg",
            "siteUrl": "https://www.lekkerland.com/"
        },
        "rimmel": {
            "key": "rimmel",
            "names": [
                "Rimmel",
                "Rimmel London",
                "The House of Rimmel"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer-goods"
            ],
            "score": 19,
            "ownedBy": [
                "coty"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/47/Rimmel_logo.svg",
            "siteUrl": "http://rimmellondon.com/",
            "updatedAt": "2026-06-01T08:53:58.578Z",
            "error": "Error [ERR_HTTP2_INVALID_SESSION]: The session has been destroyed",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Rimmel"
        },
        "rip-curl": {
            "key": "rip-curl",
            "names": [
                "Rip Curl"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "sportswear",
                "clothing",
                "retail"
            ],
            "score": 34,
            "ownedBy": [
                "kmd-brands"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/3/30/Rip_Curl_logo.svg",
            "siteUrl": "http://www.ripcurl.com/",
            "updatedAt": "2026-06-02T12:11:22.211Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Rip_Curl"
        },
        "river-island": {
            "key": "river-island",
            "names": [
                "River Island",
                "River Island Clothing Co. Limited",
                "RiverIsland",
                "RI"
            ],
            "comment": "River Island is a British fashion retailer that has sold sexist products [1, has been linked to exploitation of garment workers in its supply chain [2][3][4], failed to pay minimum wage [5], and has connections to Israel and Zionism [6].",
            "sources": {
                "1": "https://www.theguardian.com/business/2014/may/06/river-island-anti-nag-gag-off-sale-sexism-twitter",
                "2": "https://uk.news.yahoo.com/river-island-responds-dispatches-3-123805139.html",
                "3": "https://www.bbc.co.uk/news/articles/c4ng1y78wppo",
                "4": "https://www.theguardian.com/society/2017/jan/23/textile-firms-paying-uk-workers-3-per-hour-investigation-finds",
                "5": "https://www.gov.uk/government/news/over-500-companies-named-for-not-paying-minimum-wage",
                "6": "https://www.thejc.com/news/isrotel-founder-david-lewis-dies-at-87-khjf9asd"
            },
            "sourceNotes": {
                "1": "sold sexist products",
                "2": "exploitation of garment workers in supply chain",
                "3": "exploitation of garment workers in supply chain",
                "4": "exploitation of garment workers in supply chain",
                "5": "failed to pay minimum wage",
                "6": "connections to israel and zionism"
            },
            "tags": [
                "retail",
                "clothing",
                "gender discrimination",
                "unfair pay",
                "poor working conditions",
                "forced labour",
                "connections to israel"
            ],
            "score": 42,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/1f/River_Island_logo_2024.svg",
            "siteUrl": "http://riverisland.com/",
            "updatedAt": "2026-06-03T17:34:27.564Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/River_Island"
        },
        "robert-dyas": {
            "key": "robert-dyas",
            "names": [
                "Robert Dyas"
            ],
            "comment": "Robert Dyas is a British retailer that has been criticized for poor customer service [1][2].",
            "sources": {
                "1": "https://forums.moneysavingexpert.com/discussion/6538599/robert-dyas",
                "2": "https://forums.moneysavingexpert.com/discussion/6472853/robert-dyas-complaints"
            },
            "sourceNotes": {
                "1": "poor customer service",
                "2": "poor customer service"
            },
            "tags": [
                "none"
            ],
            "score": 50,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/c/cd/Robert_Dyas.png",
            "siteUrl": "http://www.robertdyas.co.uk/",
            "updatedAt": "2026-06-03T17:34:27.564Z",
            "error": "Error [ERR_HTTP2_INVALID_SESSION]: The session has been destroyed",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Robert_Dyas"
        },
        "roche": {
            "key": "roche",
            "names": [
                "Roche",
                "F. Hoffmann-La Roche AG",
                "Roche Holding AG",
                "Hoffmann-La Roche",
                "Hoffmann, Traub & Co.",
                "RO",
                "ROG"
            ],
            "comment": "Roche is a Swiss pharmaceutical company that has violated marketing regulations by omitting safety information [1], engaged in price fixing and other anticompetitive practices [2][3], illegally promoted drugs for off‑label uses [4] and committed hazardous waste environmental violations [5]. The firm has also underpaid and discriminated against employees [6][7], penalised a whistleblower who exposed regulatory lies [8], continued operations in Russia [9], exploited people in developing countries for clinical trials [10], failed to report thousands of side‑effect cases and deaths related to its medicines [11], conducted trials using organs from executed prisoners in China [12], and collaborated with Nazis during World War II [13].",
            "sources": {
                "1": "https://www.fiercepharma.com/marketing/roche-again-found-guilty-most-serious-marketing-breach-time-omitting-safety-information",
                "2": "https://www.nytimes.com/2000/03/31/business/settlement-in-vitamin-case-is-approved.html",
                "3": "https://www.law360.com/articles/81272/-33m-roche-antitrust-deal-gets-final-ok-",
                "4": "https://www.justice.gov/archive/opa/pr/2006/October/06_civ_728.html",
                "5": "https://www.epa.gov/newsreleases/genentech-pay-penalty-claims-hazardous-waste-violations-south-san-francisco-facility",
                "6": "https://web.archive.org/web/20150302054833/http://gbdhlegal.com/cases/galu-v-genentech-inc/",
                "7": "https://law.justia.com/cases/federal/district-courts/nevada/nvdce/2:2009cv00245/64263/42/",
                "8": "https://www.irishtimes.com/business/work/2023/11/16/pharma-giant-roche-ordered-to-pay-whistleblower-8000-for-penalising-him-over-protected-disclosure/",
                "9": "https://leave-russia.org/roche",
                "10": "https://www.publiceye.ch/en/media-corner/press-releases/detail/clinical-trials-roche-and-novartis-neglect-their-ethical-responsibility-in-emerging-countries",
                "11": "https://european-biotechnology.com/latest-news/roche-does-not-have-to-pay-us685m-fine/",
                "12": "https://www.jstor.org/stable/42921383",
                "13": "https://web.archive.org/web/20220206230020/https://www.swissinfo.ch/eng/chemical-firms-exploited-nazi-links--probe-found/2218350"
            },
            "sourceNotes": {
                "1": "violated marketing regulations, omitting safety information",
                "2": "price fixing",
                "3": "anticompetitive practices",
                "4": "illegal promotion of drugs for off-label uses",
                "5": "hazardous waste environmental violations",
                "6": "underpaid employees",
                "7": "discriminated against employees",
                "8": "penalised whistleblower for reporting that the company lied to regulators",
                "9": "continuing to operate in russia",
                "10": "exploitative use of people in developing countries for clinical trials",
                "11": "failed to report thousands of cases of side effects and deaths related to their medicines",
                "12": "conducted clinical trials with organs taken from executed prisoners in China",
                "13": "collaborated with Nazis in WW2"
            },
            "tags": [
                "pharmaceuticals",
                "anticompetitive practices",
                "deception",
                "environmental violations",
                "unfair pay",
                "forced labour",
                "poor working conditions",
                "unsafe practices",
                "connections to russia"
            ],
            "score": 20,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/f/f4/F._Hoffmann-La_Roche_2021_logo.svg",
            "siteUrl": "https://www.roche.com/",
            "updatedAt": "2026-06-04T21:50:53.833Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Roche",
            "error": "TypeError: Cannot read properties of undefined (reading '0')"
        },
        "rossingol": {
            "key": "rossingol",
            "names": [
                "Rossingol",
                "Skis Rossingol"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "sportswear"
            ],
            "score": null,
            "ownedBy": [
                "altor-capital-partners"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/ae/Rossignol-logo.svg",
            "siteUrl": "https://www.rossignol.com/",
            "updatedAt": "2026-06-05T08:19:31.496Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Skis_Rossignol"
        },
        "ryanair": {
            "key": "ryanair",
            "names": [
                "Ryanair",
                "Ryanair Holdings PLC",
                "RYA",
                "RYAAY",
                "Ryanair DAC"
            ],
            "comment": "Ryanair is an Irish airline that has been accused of greenwashing and false environmental claims [1][2], engaged in anticompetitive practices [3][4] and pursued anti‑union tactics [5]. The company has also misled customers about fares and services [6][7] while employing tax avoidance strategies [8].",
            "sources": {
                "1": "https://www.bbc.co.uk/news/business-51372780",
                "2": "https://news.sky.com/story/ryanair-adverts-banned-for-making-misleading-co2-emissions-claims-11926471",
                "3": "https://www.theguardian.com/business/2025/dec/23/ryanair-fined-limit-online-travel-agencies-ticket-sales-ota",
                "4": "https://www.rte.ie/news/business/2025/1223/1550281-italy-regulator-fines-ryanair/",
                "5": "https://www.business-humanrights.org/en/latest-news/unions-allege-ryanair-is-breaching-labour-laws-by-trying-to-deter-workers-from-striking-co-denies-allegations/",
                "6": "https://news.sky.com/story/ryanair-faces-action-by-regulator-for-persistently-misleading-passengers-11056439",
                "7": "https://www.ft.com/content/a2f8509d-48a3-3f6b-84bc-5e08a0139d0c?syn-25a6b1a6=1",
                "8": "https://www.bbc.co.uk/news/business-24371633"
            },
            "sourceNotes": {
                "1": "greenwashing and false environmental claims",
                "2": "greenwashing and false environmental claims",
                "3": "anticompetetive practices",
                "4": "anticompetetive practices",
                "5": "anti union practices",
                "6": "misleading customers",
                "7": "misleading customers",
                "8": "tax avoidance"
            },
            "tags": [
                "airline",
                "anticompetitive practices",
                "anti-union practices",
                "greenwashing",
                "deception",
                "tax avoidance"
            ],
            "score": 44,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/d5/Ryanair.svg",
            "siteUrl": "https://www.ryanair.com/",
            "updatedAt": "2026-06-06T21:02:14.117Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Ryanair"
        },
        "fujifilm": {
            "key": "fujifilm",
            "names": [
                "Fujifilm",
                "Fujifilm Holdings Corporation",
                "富士フイルムホールディングス株式会社",
                "Fuji-fuirumu Hōrudingusu kabushiki gaisha",
                "富士フイルム",
                "Fuji-fuirumu",
                "Fuji",
                "Fuji Photo Film Co",
                "Fuji Photo Film Co., Ltd."
            ],
            "comment": "Fujifilm is a Japanese company that has been accused of unfair contracts with small businesses [1][2] and tax avoidance [3]. It has also faced environmental waste violations [4][5][6] and chemical poisoning of workers in its supply chain [7].",
            "sources": {
                "1": "https://www.accc.gov.au/media-release/38-contract-terms-in-11-fuji-small-business-contracts-declared-unfair-and-void",
                "2": "https://www.businessnewsaustralia.com/articles/court-finds-fuji-misled-thousands-of-businesses-with-unfair-printer-contracts.html",
                "3": "https://www.innercitypress.com/sdny16vyskocilfujifilmicp093020.html",
                "4": "https://www.reliableplant.com/Read/8192/fujicolor-processing-pleads-guilty-to-environmental-crime",
                "5": "https://www.justice.gov/archive/opa/pr/2007/September/07_enrd_685.html",
                "6": "https://portal.deq.virginia.gov/public-docs/80FFD996-0000-CD12-8A96-3130088993CE",
                "7": "https://www.somo.nl/poisonous-pearl/"
            },
            "sourceNotes": {
                "1": "unfair contracts with small businesses",
                "2": "unfair contracts with small businesses",
                "3": "tax avoidance",
                "4": "environmental waste violations",
                "5": "environmental waste violations",
                "6": "environmental waste violations",
                "7": "chemical poisoning of workers in supply chain"
            },
            "tags": [
                "electronics",
                "tax avoidance",
                "environmental violations",
                "unsafe working conditions",
                "poor working conditions"
            ],
            "score": 40,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/a1/Fujifilm_logo.svg",
            "siteUrl": "https://holdings.fujifilm.com/en",
            "updatedAt": "2026-06-09T07:32:38.784Z",
            "error": "Error: read EADDRNOTAVAIL",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Fujifilm"
        },
        "albertsons": {
            "key": "albertsons",
            "names": [
                "Albertsons",
                "Albertsons Companies, Inc.",
                "Albertson's Inc.",
                "ACI"
            ],
            "comment": "Albertsons is an American grocery chain that has of overcharged customers [1], underpaid employees [2][3], violated data privacy laws [4], and caused environmental violations [5][6]. The company has also subjected employees to unsafe working conditions [7], engaged in racist hiring and employment practices [8], discriminated against disabled employees [9], and played a role in the opioid crisis [10].",
            "sources": {
                "1": "https://www.ocregister.com/2024/10/04/albertsons-ordered-to-pay-4-million-for-overcharging-california-shoppers/",
                "2": "https://www.law360.com/articles/21232/albertsons-employees-settle-for-53m",
                "3": "https://www.bigclassaction.com/settlement/albertsons-termination-paycheck.php",
                "4": "https://www.law360.com/articles/1700600/albertsons-unit-inks-1-1m-deal-in-biometric-privacy-case",
                "5": "https://ww2.arb.ca.gov/albertsons-companies-inc-settlement",
                "6": "https://web.archive.org/web/20160321050936/http://rivcoda.org/opencms/system/galleries/download/daReleases/NEWS_RELEASE_--_Albertsons_ordered_to_pay_$3_million_settlement_in_hazardous_waste_lawsuit.pdf",
                "7": "https://www.dir.ca.gov/DIRNews/2025/2025-02.html",
                "8": "https://www.eeoc.gov/newsroom/albertsons-agrees-pay-89-million-job-bias-based-race-color-national-origin-retaliation",
                "9": "https://www.eeoc.gov/newsroom/jewel-osco-agrees-pay-195-million-resolve-eeoc-disability-investigation",
                "10": "https://www.claimsjournal.com/news/national/2026/04/14/336872.htm"
            },
            "sourceNotes": {
                "1": "overcharged customers",
                "2": "underpaid employees",
                "3": "underpaid employees",
                "4": "data privacy violations",
                "5": "environmental violations",
                "6": "environmental violations",
                "7": "unsafe working conditions",
                "8": "racism in hiring and employment practices",
                "9": "discrimination against disabled employees",
                "10": "contributed to opioid crisis"
            },
            "tags": [
                "supermarket",
                "retail",
                "deception",
                "unfair pay",
                "privacy violations",
                "environmental violations",
                "unsafe working conditions",
                "racial discrimination"
            ],
            "score": 24,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/6/69/Albertsons_Companies_%28logo%29.svg",
            "siteUrl": "https://www.albertsons.com/",
            "updatedAt": "2026-06-10T07:08:05.907Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Albertsons"
        },
        "acme-markets": {
            "key": "acme-markets",
            "names": [
                "Acme Markets"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "supermarket",
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "albertsons"
            ],
            "updatedAt": "2026-06-10T07:28:07.897Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Acme_Markets",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/5e/Acme_Markets_lolo.svg",
            "siteUrl": "http://acmemarkets.com/"
        },
        "carrs-safeway": {
            "key": "carrs-safeway",
            "names": [
                "Carrs-Safeway"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "supermarket",
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "albertsons"
            ],
            "updatedAt": "2026-06-10T07:28:08.403Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Carrs-Safeway",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/64/Carrs_Safeway_Logo.svg",
            "siteUrl": "http://www.carrsqc.com/"
        },
        "haggen": {
            "key": "haggen",
            "names": [
                "Haggen"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "supermarket",
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "albertsons"
            ],
            "updatedAt": "2026-06-10T07:28:09.677Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Haggen_(supermarket)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/76/Haggen_logo.svg",
            "siteUrl": "http://www.haggen.com/"
        },
        "jewel-osco": {
            "key": "jewel-osco",
            "names": [
                "Jewel-Osco"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "supermarket",
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "albertsons"
            ],
            "updatedAt": "2026-06-10T07:28:10.220Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Jewel-Osco",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/e/ea/Jewel-Osco_logo.svg",
            "siteUrl": "http://jewelosco.com/"
        },
        "kings": {
            "key": "kings",
            "names": [
                "Kings"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "supermarket",
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "albertsons"
            ],
            "updatedAt": "2026-06-10T07:28:11.751Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Kings_Food_Markets",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/0/09/Kings_Food_Markets_logo.svg",
            "siteUrl": "http://kingsfoodmarkets.com/"
        },
        "pavilions": {
            "key": "pavilions",
            "names": [
                "Pavilions"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "supermarket",
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "albertsons"
            ],
            "updatedAt": "2026-06-10T07:28:12.229Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Pavilions_(supermarket)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/6f/Pavilions_%28supermarket%29_Logo.svg",
            "siteUrl": "http://pavilions.com/"
        },
        "plated": {
            "key": "plated",
            "names": [
                "Plated"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "supermarket",
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "albertsons"
            ],
            "updatedAt": "2026-06-10T07:28:13.047Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Plated_(meal_kits)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/b8/Plated_Logo_Red_Large.png",
            "siteUrl": "https://plated.com/"
        },
        "randalls": {
            "key": "randalls",
            "names": [
                "Randalls"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "supermarket",
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "albertsons"
            ],
            "updatedAt": "2026-06-10T07:28:13.944Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Randalls",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/28/Randalls_new_logo.svg",
            "siteUrl": "http://www.randalls.com/"
        },
        "safeway": {
            "key": "safeway",
            "names": [
                "Safeway"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "supermarket",
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "albertsons"
            ],
            "updatedAt": "2026-06-10T07:28:14.648Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Safeway",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/ce/Safeway_Logo.svg",
            "siteUrl": "http://safeway.com/"
        },
        "shaw's-and-star-market": {
            "key": "shaw's-and-star-market",
            "names": [
                "Shaw's and Star Market"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "supermarket",
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "albertsons"
            ],
            "updatedAt": "2026-06-10T07:28:14.815Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Shaw%27s_and_Star_Market",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/56/Shaw%27s_and_Star_Market_logos.svg",
            "siteUrl": "http://shaws.com/"
        },
        "tom-thumb": {
            "key": "tom-thumb",
            "names": [
                "Tom Thumb"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "supermarket",
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "albertsons"
            ],
            "updatedAt": "2026-06-10T07:28:15.326Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Tom_Thumb_(grocery_store)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/94/Tom_Thumb_logo.svg",
            "siteUrl": "http://www.tomthumb.com/"
        },
        "united-supermarkets": {
            "key": "united-supermarkets",
            "names": [
                "United Supermarkets"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "supermarket",
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "albertsons"
            ],
            "updatedAt": "2026-06-10T07:28:15.650Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/United_Supermarkets",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/f/f5/United_Supermarkets_logo.svg",
            "siteUrl": "http://www.unitedsupermarkets.com/"
        },
        "vons": {
            "key": "vons",
            "names": [
                "Vons"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "supermarket",
                "retail"
            ],
            "score": 24,
            "ownedBy": [
                "albertsons"
            ],
            "updatedAt": "2026-06-10T07:28:16.646Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Vons",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/0e/Vons_logo.svg",
            "siteUrl": "http://vons.com/"
        },
        "anta-sports": {
            "key": "anta-sports",
            "names": [
                "Anta Sports",
                "Anta Sports",
                "Anta Sports Products Limited",
                "安踏体育用品有限公司",
                "2020",
                "安踏體育用品有限公司"
            ],
            "comment": "Anta Sports is a Chinese sportswear company that has engaged in age discrimination [1] and continues operations in Russia amid international scrutiny [2]. The firm has been linked to forced labour in its supply chain, including the use of cotton produced by Uyghur forced labour after exiting the Better Cotton Initiative [3][4], and broader human rights abuses have been reported [5].",
            "sources": {
                "1": "https://www.eeoc.gov/newsroom/amer-sports-winter-outdoor-company-pay-350000-eeoc-age-discrimination-and-retaliation-case",
                "2": "https://www.sgieurope.com/anta-rus-opens-flagship-store-in-moscow/102799.article",
                "3": "https://www.axios.com/2021/04/27/olympic-uniform-supplier-anta-xinjiang-cotton",
                "4": "https://www.business-humanrights.org/en/latest-news/chinese-company-anta-to-quit-bci-will-continue-to-use-cotton-from-xinjiang/",
                "5": "https://www.rollingstone.com/culture/culture-sports/kyrie-irving-anta-china-human-rights-abuses-1234839461/"
            },
            "sourceNotes": {
                "1": "age discrimination",
                "2": "still operating in russia",
                "3": "forced labour in supply chain",
                "4": "exited the Better Cotton Initiative to continue using cotton produced by forced Uyghur labour",
                "5": "human rights abuses"
            },
            "tags": [
                "sportswear",
                "clothing",
                "forced labour",
                "forced uyghur labour",
                "connections to russia"
            ],
            "score": 25,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/29/Anta_logo.svg",
            "siteUrl": "https://anta.com/",
            "updatedAt": "2026-06-11T17:47:46.883Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Anta_Sports"
        },
        "amer-sports": {
            "key": "amer-sports",
            "names": [
                "Amer Sports"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "sportswear",
                "clothing"
            ],
            "score": 25,
            "ownedBy": [
                "anta-sports"
            ],
            "updatedAt": "2026-06-15T06:59:50.544Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Amer_Sports",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/f/f9/Amer_Sports.svg",
            "siteUrl": "https://amersports.com/"
        },
        "arc'teryx": {
            "key": "arc'teryx",
            "names": [
                "Arc'teryx"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "sportswear",
                "clothing"
            ],
            "score": 25,
            "ownedBy": [
                "anta-sports"
            ],
            "updatedAt": "2026-06-15T06:59:50.841Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Arc%27teryx",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/7/72/ARC%27TERYX_logo.svg",
            "siteUrl": "http://arcteryx.com/"
        },
        "armada": {
            "key": "armada",
            "names": [
                "Armada"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "sportswear",
                "clothing"
            ],
            "score": 25,
            "ownedBy": [
                "anta-sports"
            ],
            "updatedAt": "2026-06-15T06:59:50.938Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Armada_(company)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/8a/Armada_ski_logo.png",
            "siteUrl": "https://www.armadaskis.com/en-us"
        },
        "atec": {
            "key": "atec",
            "names": [
                "Atec"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "sportswear",
                "clothing"
            ],
            "score": 25,
            "ownedBy": [
                "anta-sports"
            ],
            "updatedAt": "2026-06-15T06:59:51.400Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Atec",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/2/2c/Atec%2C_Inc._Logo.png"
        },
        "atomic": {
            "key": "atomic",
            "names": [
                "Atomic"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "sportswear",
                "clothing"
            ],
            "score": 25,
            "ownedBy": [
                "anta-sports"
            ],
            "updatedAt": "2026-06-15T06:59:51.452Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Atomic_Skis",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/04/Atomic_ski_logo.png",
            "siteUrl": "http://www.atomic.com/"
        },
        "demarini": {
            "key": "demarini",
            "names": [
                "DeMarini"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "sportswear",
                "clothing"
            ],
            "score": 25,
            "ownedBy": [
                "anta-sports"
            ],
            "updatedAt": "2026-06-15T06:59:51.655Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/DeMarini",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/13/Demarini_complete_logo.svg",
            "siteUrl": "https://www.demarini.com/en-us"
        },
        "evoshield": {
            "key": "evoshield",
            "names": [
                "EvoShield"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "sportswear",
                "clothing"
            ],
            "score": 25,
            "ownedBy": [
                "anta-sports"
            ],
            "updatedAt": "2026-06-15T06:59:52.118Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/EvoShield",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/e/e3/Evoshield_logo.png",
            "siteUrl": "https://www.evoshield.com/en-us"
        },
        "louisville-slugger": {
            "key": "louisville-slugger",
            "names": [
                "Louisville Slugger"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "sportswear",
                "clothing"
            ],
            "score": 25,
            "ownedBy": [
                "anta-sports"
            ],
            "updatedAt": "2026-06-15T06:59:52.411Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Hillerich_%26_Bradsby",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/ca/Hillerich_bradsby_co_logo.png",
            "siteUrl": "https://hillerichandbradsby.com/"
        },
        "peak-performance": {
            "key": "peak-performance",
            "names": [
                " Peak Performance"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "sportswear",
                "clothing"
            ],
            "score": 25,
            "ownedBy": [
                "anta-sports"
            ],
            "updatedAt": "2026-06-15T06:59:52.996Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Peak_Performance_(clothing_brand)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/69/Peak_Performance_logo.svg",
            "siteUrl": "http://peakperformance.com/"
        },
        "salomon": {
            "key": "salomon",
            "names": [
                "Salomon"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "sportswear",
                "clothing"
            ],
            "score": 25,
            "ownedBy": [
                "anta-sports"
            ],
            "updatedAt": "2026-06-15T06:59:53.028Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Salomon_Group",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/9b/Salomon_logo_2022.svg",
            "siteUrl": "http://www.salomon.com/"
        },
        "wilson": {
            "key": "wilson",
            "names": [
                "Wilson"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "sportswear",
                "clothing"
            ],
            "score": 25,
            "ownedBy": [
                "anta-sports"
            ],
            "updatedAt": "2026-06-15T06:59:53.096Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Wilson_Sporting_Goods",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/be/Wilson_logo.svg",
            "siteUrl": "http://www.wilson.com/"
        },
        "santander": {
            "key": "santander",
            "names": [
                "Santander",
                "Banco Santander S.A.",
                "Santander Group",
                "Banco Santander",
                "SAN",
                "BNC"
            ],
            "comment": "Santander is a Spanish banking company that has been accused of poor working conditions [1], underpaying employees [2], giving customers bad investment advice [3], and engaging in tax avoidance [4] and tax fraud [5]. It also enabled money laundering [6][7][8], overcharged customers on predatory car loans [9][10][11] and used deceptive loan practices [12], while financing fossil fuel projects [13] and contributing to deforestation in Paraguay [14] and South America with more than $1 billion in loans [15].",
            "sources": {
                "1": "https://cwa-union.org/news/workers-shut-down-santander-headquarters-in-mass-protest",
                "2": "https://www.law360.com/articles/1460110/santander-managers-reach-4-25m-ot-deal-with-bank",
                "3": "https://www.fca.org.uk/news/press-releases/santander-uk-fined-%C2%A3124m-widespread-investment-advice-failings",
                "4": "https://theecologist.org/2018/may/21/are-you-funding-fracking-and-nuclear-weapon-manufacturing",
                "5": "https://www.reuters.com/business/finance/santander-agrees-26-million-settlement-france-tax-fraud-case-2025-12-05/",
                "6": "https://www.bbc.co.uk/news/business-63914275",
                "7": "https://www.standard.co.uk/business/santander-ant-dec-money-laundering-fca-fines-b1046049.html",
                "8": "https://www.fca.org.uk/news/press-releases/fca-fines-santander-uk-repeated-anti-money-laundering-failures",
                "9": "https://www.theguardian.com/business/2026/feb/04/santander-fca-compensation-scheme-car-loan-scandal-bill",
                "10": "https://www.ft.com/content/e10dd7d9-299a-4a55-b875-328bea7744c5?syn-25a6b1a6=1",
                "11": "https://oag.ca.gov/news/press-releases/attorney-general-becerra-announces-over-550-million-settlement-against-nation%E2%80%99s",
                "12": "https://web.archive.org/web/20181121034812/https://www.consumerfinance.gov/about-us/newsroom/bureau-consumer-financial-protection-settles-santander-consumer-usa-inc/",
                "13": "https://www.bankingonclimatechaos.org/wp-content/uploads/2026/06/BOCC_2026_vFINAL.pdf",
                "14": "https://globalwitness.org/en/campaigns/forests/santander-and-blackrock-continue-to-turn-a-blind-eye-to-deforestation-of-paraguays-gran-chaco/",
                "15": "https://www.forbes.com/sites/davidrvetter/2025/05/15/santander-blamed-in--13-billion-south-american-deforestation-scandal/"
            },
            "sourceNotes": {
                "1": "poor working conditions",
                "2": "underpaid employees",
                "3": "provided poor investment advice to customers",
                "4": "linked to tax avoidance",
                "5": "comitted tax fraud",
                "6": "enabled money laundering",
                "7": "enabled money laundering",
                "8": "enabled money laundering",
                "9": "overcharged customers on predatory car loans",
                "10": "overcharged customers on predatory car loans",
                "11": "overcharged customers on predatory car loans",
                "12": "deceptive and predatory loan practices",
                "13": "increasing financing for fossil fuel projects",
                "14": "enabling deforestation in paraguay",
                "15": "provided over $1 billion in financing for deforestation in south america"
            },
            "tags": [
                "finance",
                "bank",
                "poor working conditions",
                "unfair pay",
                "deception",
                "tax avoidance",
                "fossil fuels",
                "deforestation",
                "unsustainable practices"
            ],
            "score": 21,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/b8/Banco_Santander_Logotipo.svg",
            "siteUrl": "https://santander.com/",
            "updatedAt": "2026-06-15T06:59:06.125Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Banco_Santander"
        },
        "onstar": {
            "key": "onstar",
            "names": [
                "OnStar"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "cars",
                "forced labour",
                "unsafe working conditions"
            ],
            "score": 15,
            "ownedBy": [
                "general-motors"
            ],
            "updatedAt": "2026-06-17T09:28:55.761Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/OnStar",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/3a/OnStar_logo.svg",
            "siteUrl": "https://www.onstar.com/us/en/home/"
        },
        "acdelco": {
            "key": "acdelco",
            "names": [
                "ACDelco"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "cars",
                "forced labour",
                "unsafe working conditions"
            ],
            "score": 15,
            "ownedBy": [
                "general-motors"
            ],
            "updatedAt": "2026-06-17T09:28:56.053Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/ACDelco",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/58/ACDelco_logo.svg",
            "siteUrl": "https://www.gmparts.com/"
        },
        "saturn-corporation": {
            "key": "saturn-corporation",
            "names": [
                "Saturn Corporation",
                "Saturn"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "cars",
                "forced labour",
                "unsafe working conditions"
            ],
            "score": 15,
            "ownedBy": [
                "general-motors"
            ],
            "updatedAt": "2026-06-17T15:32:26.356Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Saturn_Corporation",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/94/Saturn_corporation_logo.png"
        },
        "genesco": {
            "key": "genesco",
            "names": [
                "Genesco",
                "Genesco Inc.",
                "Jarman Shoe Company",
                "General Shoe Corporation",
                "GCO"
            ],
            "comment": "Genesco is an American footwear company that has faced criticism for its labour practices. Employees have reported being underpaid [1][2], and the company has been accused of gender discrimination against staff [3].",
            "sources": {
                "1": "https://violationtracker.goodjobsfirst.org/archive/FLSA699.pdf",
                "2": "https://violationtracker.goodjobsfirst.org/archive/FLSA697.pdf",
                "3": "https://www.eeoc.gov/newsroom/retailer-genesco-sued-sex-discrimination"
            },
            "sourceNotes": {
                "1": "underpaid employees",
                "2": "underpaid employees",
                "3": "gender discrimination against employees"
            },
            "tags": [
                "clothing",
                "retail",
                "unfair pay",
                "gender discrimination"
            ],
            "score": 45,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/2/29/Genesco_logo.svg",
            "siteUrl": "http://www.genesco.com/",
            "updatedAt": "2026-06-18T16:52:04.289Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Genesco",
            "error": "Error [ERR_HTTP2_INVALID_SESSION]: The session has been destroyed"
        },
        "dockers": {
            "key": "dockers",
            "names": [
                "Dockers"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing",
                "retail"
            ],
            "score": 45,
            "ownedBy": [
                "genesco"
            ],
            "updatedAt": "2026-06-18T17:36:33.566Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Dockers_(brand)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/6/64/Dockers_logo.png",
            "siteUrl": "http://www.dockers.com/"
        },
        "johnston-and-murphy": {
            "key": "johnston-and-murphy",
            "names": [
                "Johnston & Murphy"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing",
                "retail"
            ],
            "score": 45,
            "ownedBy": [
                "genesco"
            ],
            "updatedAt": "2026-06-18T17:36:33.740Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Johnston_%26_Murphy",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/05/JohnstonAndMurphy.png",
            "siteUrl": "http://www.johnstonmurphy.com/"
        },
        "journeys": {
            "key": "journeys",
            "names": [
                "Journeys"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing",
                "retail"
            ],
            "score": 45,
            "ownedBy": [
                "genesco"
            ],
            "updatedAt": "2026-06-18T17:36:33.808Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Journeys_(company)",
            "siteUrl": "http://journeys.com/"
        },
        "schuh": {
            "key": "schuh",
            "names": [
                "Schuh"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing",
                "retail"
            ],
            "score": 45,
            "ownedBy": [
                "genesco"
            ],
            "updatedAt": "2026-06-18T17:36:33.970Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Schuh",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/b/be/Schuh_logo.png",
            "siteUrl": "https://www.schuh.co.uk/"
        },
        "quiksilver": {
            "key": "quiksilver",
            "names": [
                "Quiksilver"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing",
                "retail"
            ],
            "score": 40,
            "ownedBy": [
                "authentic-brands-group"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/c/c6/Quiksilver-brand.svg",
            "siteUrl": "https://www.quiksilver.com/",
            "updatedAt": "2026-06-18T17:42:30.923Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Quiksilver"
        },
        "mccormick-and-company": {
            "key": "mccormick-and-company",
            "names": [
                "McCormick and Company",
                "McCormick & Company, Incorporated",
                "McCormick & Co.",
                "MKC.V",
                "MKC"
            ],
            "comment": "McCormick and Company is an American spice manufacturer that has been accused of exploiting farmers [1].",
            "sources": {
                "1": "https://theecologist.org/2011/jan/25/pepper-how-our-favourite-spice-tainted-deadly-legacy"
            },
            "sourceNotes": {
                "1": "exploitation of farmers"
            },
            "tags": [
                "food",
                "unfair pay"
            ],
            "score": 42,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/e/ec/McCormick.svg",
            "siteUrl": "http://mccormickcorporation.com/",
            "updatedAt": "2026-06-18T17:42:30.923Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/McCormick_%26_Company"
        },
        "aeroplane-jelly": {
            "key": "aeroplane-jelly",
            "names": [
                "Aeroplane Jelly"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 42,
            "ownedBy": [
                "mccormick-and-company"
            ],
            "updatedAt": "2026-06-19T08:44:58.218Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Aeroplane_Jelly",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/1/10/Aeroplane_Jelly_Logo.png",
            "siteUrl": "https://www.aeroplanejelly.com.au/"
        },
        "cholula-hot-sauce": {
            "key": "cholula-hot-sauce",
            "names": [
                "Cholula Hot Sauce"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 42,
            "ownedBy": [
                "mccormick-and-company"
            ],
            "updatedAt": "2026-06-19T08:44:58.710Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Cholula_Hot_Sauce",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/f/f3/Cholula_Hot_Sauce_logo.png",
            "siteUrl": "https://www.cholula.com/"
        },
        "frank's-redhot": {
            "key": "frank's-redhot",
            "names": [
                "Frank's RedHot"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 42,
            "ownedBy": [
                "mccormick-and-company"
            ],
            "updatedAt": "2026-06-19T08:44:58.777Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Frank%27s_RedHot",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/8/83/FranksBottleShot1.jpg",
            "siteUrl": "http://www.franksredhot.com/"
        },
        "french's": {
            "key": "french's",
            "names": [
                "French's"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 42,
            "ownedBy": [
                "mccormick-and-company"
            ],
            "updatedAt": "2026-06-19T08:44:59.105Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/French%27s",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/6/6f/French%27s_food_logo.png",
            "siteUrl": "http://www.frenchsmustard.com/"
        },
        "kamis": {
            "key": "kamis",
            "names": [
                "Kamis"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 42,
            "ownedBy": [
                "mccormick-and-company"
            ],
            "updatedAt": "2026-06-19T08:44:59.175Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Kamis",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/a/ac/Kamis_S.A._Logo.jpg"
        },
        "keen's": {
            "key": "keen's",
            "names": [
                "Keen's"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 42,
            "ownedBy": [
                "mccormick-and-company"
            ],
            "updatedAt": "2026-06-19T08:44:59.340Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Keen%27s"
        },
        "lawry's": {
            "key": "lawry's",
            "names": [
                "Lawry's"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 42,
            "ownedBy": [
                "mccormick-and-company"
            ],
            "updatedAt": "2026-06-19T08:44:59.538Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Lawry%27s_and_Adolph%27s"
        },
        "old-bay": {
            "key": "old-bay",
            "names": [
                "Old Bay"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 42,
            "ownedBy": [
                "mccormick-and-company"
            ],
            "updatedAt": "2026-06-19T08:44:59.585Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Old_Bay_Seasoning",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/4f/Old_Bay_Seasoning.jpg",
            "siteUrl": "http://mccormick.com/old-bay"
        },
        "schwartz": {
            "key": "schwartz",
            "names": [
                "Schwartz"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 42,
            "ownedBy": [
                "mccormick-and-company"
            ],
            "updatedAt": "2026-06-19T08:44:59.644Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Schwartz_(brand)"
        },
        "tiger's-milk": {
            "key": "tiger's-milk",
            "names": [
                "Tiger's Milk"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 42,
            "ownedBy": [
                "mccormick-and-company"
            ],
            "updatedAt": "2026-06-19T08:44:59.680Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Tiger%27s_Milk_(nutrition_bar)"
        },
        "zatarain's": {
            "key": "zatarain's",
            "names": [
                "Zatarain's"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 42,
            "ownedBy": [
                "mccormick-and-company"
            ],
            "updatedAt": "2026-06-19T08:44:59.828Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Zatarain%27s",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/7/7d/Zatarain%27s_logo_1.jpg",
            "siteUrl": "http://www.zatarains.com/"
        },
        "3m": {
            "key": "3m",
            "names": [
                "3M",
                "3M",
                "3M Company",
                "Minnesota Mining and Manufacturing Company",
                "MMM"
            ],
            "comment": "3M is a United States-based manufacturing corporation that has been found underpaying workers [1], engaging in age‑based employment discrimination [2][3], bribing Chinese officials [4][5], covering up widespread environmental contamination and releasing pollution into Belgium's environment [6][7][8]. The company has also sold toxic firefighting foams that contaminated rivers and exposed workers to carcinogenic chemicals [9][10], contaminated drinking water supplies with PFAS chemicals, affecting families with young children [11][12][13], knowingly sold faulty dental products [14], and distributed defective earplugs that caused hearing loss [15][16].",
            "sources": {
                "1": "https://www.law360.com/articles/156288/3m-employees-seek-ok-for-5m-deal-in-flsa-suit",
                "2": "https://violationtracker.goodjobsfirst.org/archive/discr75.pdf",
                "3": "https://www.eeoc.gov/newsroom/3m-pay-3-million-settle-eeoc-age-discrimination-suit",
                "4": "https://www.occrp.org/en/news/3ms-recent-bribery-violations-a-very-common-practice-in-business-expert-says",
                "5": "https://www.sec.gov/newsroom/press-releases/2023-160",
                "6": "https://minnesotareformer.com/2022/12/15/toxic-3m-knew-its-chemicals-were-harmful-decades-ago-but-didnt-tell-the-public-government/",
                "7": "https://www.propublica.org/article/3m-forever-chemicals-pfas-pfos-inside-story",
                "8": "https://www.dw.com/en/belgium-us-company-3m-agrees-to-massive-payout-for-chemical-leak/a-62385891",
                "9": "https://www.theguardian.com/environment/2025/jan/15/3m-firefighting-foams-pfas-forever-chemicals-documents",
                "10": "https://www.bbc.co.uk/news/articles/cx2gdzl3lewo",
                "11": "https://edition.cnn.com/2023/06/22/business/3m-forever-chemicals-settlement/",
                "12": "https://time.com/6289893/3m-forever-chemical-pfas-settlement/",
                "13": "https://www.brusselstimes.com/506509/pfas-pollution-3m-ordered-to-compensate-affected-family",
                "14": "https://www.law360.com/classaction/articles/1142893/3m-settles-dentists-defective-crown-suit-for-32-5m",
                "15": "https://finance.yahoo.com/news/3ms-legal-troubles-arent-over-despite-185-billion-in-settlements-115913197.html",
                "16": "https://www.law360.com/articles/1715917"
            },
            "sourceNotes": {
                "1": "underpaid workers",
                "2": "engaged in age-based employment discrimination",
                "3": "engaged in age-based employment discrimination",
                "4": "engaged in bribery of Chinese officials",
                "5": "engaged in bribery of Chinese officials",
                "6": "covered up evidence of widespread environmental contamination",
                "7": "covered up evidence of widespread environmental contamination",
                "8": "released pollution into the environment in Belgium",
                "9": "sold toxic firefighting foams that contaminated rivers",
                "10": "exposed workers to toxic, carcinogenic firefighting foams",
                "11": "contaminated drinking water supplies with PFAS forever chemicals",
                "12": "contaminated drinking water supplies with PFAS forever chemicals",
                "13": "exposed family with young children to dangerous levels of PFAS",
                "14": "knowingly sold faulty dental products",
                "15": "sold defective earplugs that caused hearing loss",
                "16": "sold defective earplugs that caused hearing loss"
            },
            "tags": [
                "manufacturing",
                "chemicals",
                "unfair pay",
                "corruption",
                "environmental violations",
                "unsafe practices",
                "unsustainable practices"
            ],
            "score": 19,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/15/3M_wordmark.svg",
            "siteUrl": "http://3m.com/",
            "updatedAt": "2026-06-20T07:05:42.399Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/3M"
        },
        "scotch-tape": {
            "key": "scotch-tape",
            "names": [
                "Scotch Tape"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "manufacturing",
                "chemicals"
            ],
            "score": 19,
            "ownedBy": [
                "3m"
            ],
            "updatedAt": "2026-06-20T08:31:49.922Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Scotch_Tape",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/8a/Scotch_Logo.svg",
            "siteUrl": "http://www.scotchtape.com/"
        },
        "scotchgard": {
            "key": "scotchgard",
            "names": [
                "Scotchgard"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "manufacturing",
                "chemicals"
            ],
            "score": 19,
            "ownedBy": [
                "3m"
            ],
            "updatedAt": "2026-06-20T08:31:50.075Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Scotchgard"
        },
        "nexcare": {
            "key": "nexcare",
            "names": [
                "Nexcare"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "manufacturing",
                "chemicals"
            ],
            "score": 19,
            "ownedBy": [
                "3m"
            ],
            "updatedAt": "2026-06-20T08:31:51.314Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Nexcare",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/ab/Nexcare_logo.svg",
            "siteUrl": "http://www.nexcare.com/"
        },
        "command": {
            "key": "command",
            "names": [
                "Command"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "manufacturing",
                "chemicals"
            ],
            "score": 19,
            "ownedBy": [
                "3m"
            ],
            "updatedAt": "2026-06-20T08:31:51.314Z",
            "logoUrl": "https://command.3m.co.uk/3m_theme_assets/themes/3MTheme/assets/images/lion/command/Command_Logo.svg",
            "siteUrl": "https://command.3m.co.uk/3M/en_GB/command-gb/"
        },
        "seiko": {
            "key": "seiko",
            "names": [
                "Seiko",
                "Seiko Group Corporation",
                "セイコーグループ株式会社",
                "Seikō Gurūpu kabushiki gaisha",
                "Hattori Tokeiten",
                "K. Hattori & Co.",
                "K. Hattori & Co., Ltd.",
                "Hattori Seiko Co., Ltd.",
                "Seiko Corporation",
                "Seiko Holdings Corporation",
                "Seiko Group"
            ],
            "comment": "Seiko is a Japanese watchmaker that has faced criticism for leaking customer data in a data breach [1] and engaging in monopolistic price‑fixing practices [2].",
            "sources": {
                "1": "https://www.theregister.com/security/2023/10/25/seiko-group-says-blackcat-stole-60k-personal-data-records/1080481",
                "2": "https://web.archive.org/web/20211023142247/http://www.lindapatent.com/en/info_news/383.html"
            },
            "sourceNotes": {
                "1": "leaked customer data in data breach",
                "2": "monopolistic price fixing"
            },
            "tags": [
                "electronics",
                "retail",
                "data breach",
                "privacy violations",
                "anticompetitive practices"
            ],
            "score": 49,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/2c/Seiko_logo.svg",
            "siteUrl": "http://www.seiko.co.jp/en",
            "updatedAt": "2026-06-21T07:41:29.216Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Seiko"
        },
        "wako-co.-ltd.": {
            "key": "wako-co.-ltd.",
            "names": [
                "Wako Co., Ltd."
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "electronics",
                "retail"
            ],
            "score": 49,
            "ownedBy": [
                "seiko"
            ],
            "updatedAt": "2026-06-21T08:50:12.338Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Wako_(retailer)",
            "siteUrl": "http://www.wako.co.jp/"
        },
        "pulsar": {
            "key": "pulsar",
            "names": [
                "Pulsar"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "electronics",
                "retail"
            ],
            "score": 49,
            "ownedBy": [
                "seiko"
            ],
            "updatedAt": "2026-06-21T08:50:12.521Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Pulsar_(watch)"
        },
        "alba": {
            "key": "alba",
            "names": [
                "Alba"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "electronics",
                "retail"
            ],
            "score": 49,
            "ownedBy": [
                "seiko"
            ],
            "updatedAt": "2026-06-21T08:50:12.597Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Alba_(watch)"
        },
        "selfridges": {
            "key": "selfridges",
            "names": [
                "Selfridges",
                "Selfridges Retail Limited",
                "Selfridges & Co."
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": null,
            "ownedBy": [
                "central-group",
                "public-investment-fund"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/5b/Selfridges_%26_Co._Logo_12.2022.svg",
            "siteUrl": "http://selfridges.com/",
            "updatedAt": "2026-06-22T07:52:33.505Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Selfridges"
        },
        "sephora": {
            "key": "sephora",
            "names": [
                "Sephora",
                "Sephora SA"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "cosmetics"
            ],
            "score": 34,
            "ownedBy": [
                "lvmh"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/21/Sephora_logo.svg",
            "siteUrl": "https://www.sephora.com/",
            "updatedAt": "2026-06-22T07:52:33.505Z",
            "error": "Error [ERR_HTTP2_INVALID_SESSION]: The session has been destroyed",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Sephora"
        },
        "shein": {
            "key": "shein",
            "names": [
                "Shein",
                "SHEIN",
                "希音",
                "Xīyīn",
                "ZZKKO"
            ],
            "comment": "Shein is a Chinese fast‑fashion retailer that has been implicated in data breaches and cover‑ups involving customer information [1][2], deceptive pricing [3], theft of independent artists' designs [4][5], use of cotton sourced from forced Uyghur labour [6][7], freshwater and microplastic pollution [8], greenwashing claims [9], sale of clothes containing dangerous chemicals [10][11], exploitative working conditions [12] and overworking garment workers [13], child labour in its supply chain [14], and the sale of sex dolls resembling children [15].",
            "sources": {
                "1": "https://web.archive.org/web/20230128170649/https://www.securityweek.com/over-6-million-users-hit-breach-fashion-retailer-shein/",
                "2": "https://web.archive.org/web/20230606202754/https://www.bbc.com/news/technology-63255661",
                "3": "https://www.economie.gouv.fr/files/files/directions_services/dgccrf/media-document/cp-dgccrf-SHEIN-sanctionne-amende-40millions.pdf",
                "4": "https://web.archive.org/web/20230606201935/https://www.wsj.com/articles/chinas-fast-fashion-giant-shein-faces-dozens-of-lawsuits-alleging-design-theft-11656840601",
                "5": "https://web.archive.org/web/20221206071934/https://www.34st.com/article/2020/07/shein-swastika-necklace-controversy-boycott-shein-fast-fashion-upenn-ivy-league",
                "6": "https://web.archive.org/web/20230611003014/https://www.bloomberg.com/news/features/2022-11-21/shein-s-cotton-clothes-tied-to-xinjiang-china-region-accused-of-forced-labor",
                "7": "https://web.archive.org/web/20250108164315/https://apnews.com/article/uk-parliament-shein-temu-a24fa3a6511cde7fe6b4763d693b986b",
                "8": "https://opentext.ku.edu/environmentalgeopolitics/chapter/evil-fashion-giant-shein/##renzreferences",
                "9": "https://www.theguardian.com/business/2025/aug/05/shein-fined-1m-in-italy-for-misleading-environmental-claims-about-products",
                "10": "https://web.archive.org/web/20230617051650/https://www.cbc.ca/news/business/marketplace-fast-fashion-chemicals-1.6193385",
                "11": "https://web.archive.org/web/20240614104244/https://www.straitstimes.com/business/south-korea-finds-high-levels-of-toxic-chemicals-in-shein-products",
                "12": "https://www.nytimes.com/2025/02/14/business/economy/china-exports-trump-tariffs.html?searchResultPosition=3",
                "13": "https://web.archive.org/web/20211126095529/https://www.bbc.com/news/business-59245708",
                "14": "https://www.the-sun.com/lifestyle/13284122/shein-village-china-factories-rights/",
                "15": "https://www.bbc.com/news/articles/cddrg70pj1mo"
            },
            "sourceNotes": {
                "1": "leaked customer data in data breach and covered up severity",
                "2": "leaked customer data in data breach and covered up severity",
                "3": "deceptive pricing",
                "4": "stole designs from independent artists",
                "5": "stole designs from independent artists",
                "6": "used cotton sourced from forced Uyghur labour",
                "7": "used cotton sourced from forced Uyghur labour",
                "8": "caused freshwater and microplastic pollution",
                "9": "greenwashing",
                "10": "sold clothes containing dangerous chemicals",
                "11": "sold clothes containing dangerous chemicals",
                "12": "exploitative working conditions",
                "13": "overworked and exploited garment workers",
                "14": "child labour in supply chain",
                "15": "sold sex dolls resembling children"
            },
            "tags": [
                "clothing",
                "retail",
                "fast fashion",
                "data breach",
                "privacy violations",
                "deception",
                "forced uyghur labour",
                "unsustainable practices",
                "environmental violations",
                "greenwashing",
                "unsafe practices",
                "poor working conditions",
                "unsafe working conditions",
                "child labour"
            ],
            "score": 23,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/c5/Shein_Logo_2017.svg",
            "siteUrl": "https://shein.com/",
            "updatedAt": "2026-06-22T07:52:33.505Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Shein"
        },
        "siemens": {
            "key": "siemens",
            "names": [
                "Siemens",
                "Siemens AG",
                "SIE"
            ],
            "comment": "Siemens is a German Engineering company that has been repeatedly implicated in bribery and corruption scandals [1][2][3][4], has underpaid employees [5][6], and was involved in supplying Russian operations in Crimea despite sanctions [7]. The company also contaminated water supplies in Ohio [8] and is a BDS target for its role in constructing electricity infrastructure in Israel [9].",
            "sources": {
                "1": "https://www.theguardian.com/sustainable-business/recovering-business-trust-siemens",
                "2": "https://www.mcgrawcenter.org/stories/slammed-for-bribery-siemens-continued-to-ignore-red-flags/",
                "3": "https://www.sec.gov/news/press/2008/2008-294.htm",
                "4": "https://en.wikipedia.org/wiki/Siemens_Greek_bribery_scandal",
                "5": "https://web.archive.org/web/20200919092510/https://millerlawpc.com/medical-software-company-to-pay-14-4-million-to-end-suit-over-bonuses-law-com-february-14-2005/",
                "6": "https://web.archive.org/web/20161222152950/https://www.dol.gov/whd/media/press/whdpressVB2.asp?pressdoc=Western/archived/20040544.xml",
                "7": "https://www.reuters.com/world/europe/two-ex-siemens-execs-be-tried-germany-over-russia-sanctions-violations-2025-03-14/",
                "8": "https://violationtracker.goodjobsfirst.org/archive/enviro25.pdf",
                "9": "https://bdsmovement.net/siemens-and-chevron-stop-fueling-apartheid-and-climate-disaster"
            },
            "sourceNotes": {
                "1": "bribery and corruption",
                "2": "bribery and corruption",
                "3": "bribery and corruption",
                "4": "bribery and corruption",
                "5": "underpaid employees",
                "6": "underpaid employees",
                "7": "attempted to help supply russian operations in crimea, against sanctions",
                "8": "contaminated water supplies in Ohio",
                "9": "BDS target due to building electricity infrastructure in Israel"
            },
            "tags": [
                "tech",
                "corruption",
                "unfair pay",
                "connections to russia",
                "connections to israel",
                "environmental violations"
            ],
            "score": 25,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/3c/Siemens_AG_logo.svg",
            "siteUrl": "https://www.siemens.com/",
            "updatedAt": "2026-06-25T08:00:05.698Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Siemens"
        },
        "simple-skincare": {
            "key": "simple-skincare",
            "names": [
                "Simple Skincare",
                "Simple"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods"
            ],
            "score": 5,
            "ownedBy": [
                "unilever"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/8/88/Simple_Skincare_logo.png",
            "siteUrl": "http://www.simple.co.uk/",
            "updatedAt": "2026-06-26T10:18:06.871Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Simple_Skincare"
        },
        "sketchers": {
            "key": "sketchers",
            "names": [
                "Sketchers",
                "Sketchers",
                "Skechers U.S.A., Inc."
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing",
                "retail"
            ],
            "score": null,
            "ownedBy": [
                "3g-capital"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/b3/Skechers_wordmark.svg",
            "siteUrl": "https://www.skechers.com/",
            "updatedAt": "2026-06-26T10:18:06.871Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Skechers"
        },
        "sky": {
            "key": "sky",
            "names": [
                "Sky",
                "Sky Group",
                "Sky Group Limited",
                "British Sky Broadcasting plc",
                "British Sky Broadcasting",
                "Sky plc"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "telecommunications"
            ],
            "score": 12,
            "ownedBy": [
                "comcast"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/db/Sky_logo_2025.svg",
            "siteUrl": "https://www.skygroup.sky/",
            "updatedAt": "2026-06-28T06:06:04.736Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Sky_Group"
        },
        "skype": {
            "key": "skype",
            "names": [
                "Skype",
                "Skype Technologies"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech"
            ],
            "score": 35,
            "ownedBy": [
                "microsoft"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/60/Skype_logo_%282019%E2%80%93present%29.svg",
            "siteUrl": "https://web.archive.org/web/20250102150852/https://www.skype.com/en/",
            "updatedAt": "2026-07-03T23:08:46.446Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Skype"
        },
        "slack": {
            "key": "slack",
            "names": [
                "Slack"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech"
            ],
            "score": 40,
            "ownedBy": [
                "salesforce"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/b9/Slack_Technologies_Logo.svg",
            "siteUrl": "https://slack.com/",
            "updatedAt": "2026-07-03T23:08:46.446Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Slack_(software)"
        },
        "smeg": {
            "key": "smeg",
            "names": [
                "Smeg",
                "Smalterie Metallurgiche Emiliane Guastalla",
                "Smeg Group S.p.A.",
                "Smeg Group"
            ],
            "comment": "Smeg is an Italian applicance manufacturer.",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "appliances",
                ""
            ],
            "score": 50,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/06/Smeg_logo.svg",
            "siteUrl": "http://www.smeg.com/",
            "updatedAt": "2026-07-03T23:11:08.460Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Smeg_(appliances)"
        },
        "snapchat": {
            "key": "snapchat",
            "names": [
                "Snapchat",
                "Snapchat Inc.",
                "Snap Inc.",
                "Snap"
            ],
            "comment": "Snapchat is an American social media platform that has discriminated against female employees [1][2] and engaged in misleading advertising about its disappearing message feature [3]. The company has also knowingly built addictive features harmful to children, facilitated large‑scale child sexual abuse material and sextortion, ignored evidence of sexual exploitation of children, and contributed to abuse leading to suicides among minors [4][5][6][7][8][9].",
            "sources": {
                "1": "https://web.archive.org/web/20240619225424/https://apnews.com/article/california-snapchat-harassment-lawsuit-settlement-7fd5bf7539e95578b47bf6e85ffc2f9c",
                "2": "https://web.archive.org/web/20240620135021/https://www.theverge.com/2024/6/20/24182303/snap-gender-discrimination-settlement-california",
                "3": "https://web.archive.org/web/20210722183948/https://www.marylandattorneygeneral.gov/press/2014/061214.pdf",
                "4": "https://www.thebureauinvestigates.com/stories/2025-12-03/snapchat-ignored-staff-warnings-about-teens-mental-health",
                "5": "https://www.afterbabel.com/p/industrial-scale-snapchat",
                "6": "https://www.eryica.org/news/darkside-snapchat",
                "7": "https://www.npr.org/2024/10/04/nx-s1-5137218/snapchat-brushed-aside-warnings-of-child-harm-documents-show",
                "8": "https://fortune.com/2024/10/01/snapchat-lawsuit-new-mexico/",
                "9": "https://techcrunch.com/2022/03/17/following-suicides-and-lawsuits-snapchat-restricts-apps-building-on-its-platform-with-new-policies/"
            },
            "sourceNotes": {
                "1": "discriminated against female employees",
                "2": "discriminated against female employees",
                "3": "misleading advertising around disappearing message",
                "4": "knowingly built features addictive and harmful to children",
                "5": "significant, large scale harm to children, especially involving Child Sexual Abuse Material (CSAM) and sextortion",
                "6": "significant, large scale harm to children, especially involving Child Sexual Abuse Material (CSAM) and sextortion",
                "7": "ignored evidence of sexual exploitation of children",
                "8": "ignored evidence of sexual exploitation of children",
                "9": "facilited abuse of children leading to suicides"
            },
            "tags": [
                "tech",
                "gender discrimination",
                "deception",
                "unsafe practices"
            ],
            "score": 10,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/c/c4/Snapchat_logo.svg",
            "siteUrl": "https://www.snapchat.com/",
            "updatedAt": "2026-07-04T07:16:49.346Z",
            "error": "TypeError: Cannot read properties of undefined (reading 'url')"
        },
        "soundcloud": {
            "key": "soundcloud",
            "names": [
                "SoundCloud"
            ],
            "comment": "SoundCloud is a German music streaming platform that has allowed the use of its users' uploaded songs for training artificial intelligence models [1][2]. The company also suffered a significant data breach exposing personal details of approximately 30 million users [3].",
            "sources": {
                "1": "https://successquarterly.com/soundclouds-policy-shift-sparks-controversy-over-data-ownership-and-creator-rights/",
                "2": "https://musicminds.com/soundcloud-sparks-artist-concern-over-ai-rights",
                "3": "https://cybersecuritynews.com/soundcloud-breach-exposes-users-details/"
            },
            "sourceNotes": {
                "1": "allowing training AI on user-uploaded songs ",
                "2": "allowing training AI on user-uploaded songs ",
                "3": "allowed data breach of 30 million users' details"
            },
            "tags": [
                "tech",
                "music",
                "data breach",
                "privacy violations"
            ],
            "score": 44,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/78/Soundcloud_logo.svg",
            "siteUrl": "https://soundcloud.com/",
            "updatedAt": "2026-07-04T07:16:49.346Z",
            "error": "TypeError: Cannot read properties of undefined (reading 'url')",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/SoundCloud"
        },
        "spin-master": {
            "key": "spin-master",
            "names": [
                "Spin Master",
                "Spin Master Corp.",
                "Spin Master Toys",
                "TOY"
            ],
            "comment": "Spin Master is a Canadian toy company that has been accused of exploitative labour practices in factories [1] and selling unsafe toys [2].",
            "sources": {
                "1": "https://chinalaborwatch.org/barbie-mickey-mouse-optimus-prime-thomas-the-tank-engine-who-else-continues-to-exploit-toy-workers/",
                "2": "https://web.archive.org/web/20130420152612/http://www.cpsc.gov/en/Newsroom/News-Releases/2012/in-Master-Agrees-to-13-Million-Civil-Penalty-for-Failing-to-Report-Aqua-Dots-and-for-Selling-a-Banned-Hazardous-Substance/"
            },
            "sourceNotes": {
                "1": "exploitative labour practices in factories",
                "2": "sold unsafe toys"
            },
            "tags": [
                "toys",
                "forced labour",
                "poor working conditions",
                "unsafe practices"
            ],
            "score": 36,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/46/Spin_Master_logo.png",
            "siteUrl": "https://www.spinmaster.com/",
            "updatedAt": "2026-07-06T00:02:35.182Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Spin_Master"
        },
        "paw-patrol": {
            "key": "paw-patrol",
            "names": [
                "Paw Patrol"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys"
            ],
            "score": 36,
            "ownedBy": [
                "spin-master"
            ],
            "updatedAt": "2026-07-06T22:00:31.011Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Paw_Patrol",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/5/5f/PAW_Patrol_Logo.png"
        },
        "abby-hatcher": {
            "key": "abby-hatcher",
            "names": [
                "Abby Hatcher"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys"
            ],
            "score": 36,
            "ownedBy": [
                "spin-master"
            ],
            "updatedAt": "2026-07-06T22:00:32.091Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Abby_Hatcher",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/e/e0/Abby_Hatcher_logo.png"
        },
        "air-hogs": {
            "key": "air-hogs",
            "names": [
                "Air Hogs"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys"
            ],
            "score": 36,
            "ownedBy": [
                "spin-master"
            ],
            "updatedAt": "2026-07-06T22:00:32.522Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Air_Hogs"
        },
        "bakugan": {
            "key": "bakugan",
            "names": [
                "Bakugan"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys"
            ],
            "score": 36,
            "ownedBy": [
                "spin-master"
            ],
            "updatedAt": "2026-07-06T22:00:32.784Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Bakugan",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/f/f9/Bakugan_DVD_Volume_13_%28Japanese%29.jpg",
            "siteUrl": "http://www.bakugan.com/"
        },
        "hatchimals": {
            "key": "hatchimals",
            "names": [
                "Hatchimals"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys"
            ],
            "score": 36,
            "ownedBy": [
                "spin-master"
            ],
            "updatedAt": "2026-07-06T22:00:33.326Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Hatchimals",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/4/4f/Hatchimals_logo.png"
        },
        "meccano": {
            "key": "meccano",
            "names": [
                "Meccano"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys"
            ],
            "score": 36,
            "ownedBy": [
                "spin-master"
            ],
            "updatedAt": "2026-07-06T22:00:33.853Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Meccano",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/46/Meccano_logo.svg",
            "siteUrl": "https://meccano.com/en_us"
        },
        "mighty-express": {
            "key": "mighty-express",
            "names": [
                "Mighty Express"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys"
            ],
            "score": 36,
            "ownedBy": [
                "spin-master"
            ],
            "updatedAt": "2026-07-06T22:00:34.276Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Mighty_Express",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/9/91/Mighty_Express_Logo.png"
        },
        "rubik's-cube": {
            "key": "rubik's-cube",
            "names": [
                "Rubik's Cube"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys"
            ],
            "score": 36,
            "ownedBy": [
                "spin-master"
            ],
            "updatedAt": "2026-07-06T22:00:35.024Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Rubik's_Cube",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/61/Rubiks_cube_solved.jpg"
        },
        "toca-boca": {
            "key": "toca-boca",
            "names": [
                "Toca Boca"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys"
            ],
            "score": 36,
            "ownedBy": [
                "spin-master"
            ],
            "updatedAt": "2026-07-06T22:00:35.708Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Toca_Boca",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/a/a1/Toca_Boca_2024.svg",
            "siteUrl": "http://www.tocaboca.com/"
        },
        "vida-the-vet": {
            "key": "vida-the-vet",
            "names": [
                "Vida the Vet"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys"
            ],
            "score": 36,
            "ownedBy": [
                "spin-master"
            ],
            "updatedAt": "2026-07-06T22:00:36.095Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Vida_the_Vet"
        },
        "unicorn-academy": {
            "key": "unicorn-academy",
            "names": [
                "Unicorn Academy"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys"
            ],
            "score": 36,
            "ownedBy": [
                "spin-master"
            ],
            "updatedAt": "2026-07-06T22:00:36.557Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Unicorn_Academy"
        },
        "perplexus": {
            "key": "perplexus",
            "names": [
                "Perplexus"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys"
            ],
            "score": 36,
            "ownedBy": [
                "spin-master"
            ],
            "updatedAt": "2026-07-06T22:00:37.267Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Perplexus",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/b/ba/Superplexus-for-Wiki1.jpg"
        },
        "gund": {
            "key": "gund",
            "names": [
                "Gund"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "toys"
            ],
            "score": 36,
            "ownedBy": [
                "spin-master"
            ],
            "updatedAt": "2026-07-06T22:00:38.491Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Gund",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/7/7a/GUND_Logo_official.png",
            "siteUrl": "https://www.gund.com/"
        },
        "specsavers": {
            "key": "specsavers",
            "names": [
                "Specsavers",
                "Specsavers Optical Group Limited",
                "Visionplus Care Ltd.",
                "M.L. Bebbington Ltd."
            ],
            "comment": "Specsavers is a British optical retail chain that has been accused of defrauding government COVID pay assistance and engaging in tax avoidance [1][2]. The company also uses potentially harmful and exploitative sales targets [3].",
            "sources": {
                "1": "https://web.archive.org/web/20230907052556/https://www.abc.net.au/news/2021-09-15/jobkeeper-subsidies-specsavers-luxottica-sunglass-hut-retailers/100461772",
                "2": "https://web.archive.org/web/20230907053155/https://www.abc.net.au/news/2021-07-14/jobkeeper-repaid-comes-from-public-companies/100288376",
                "3": "https://michaelwest.com.au/nothing-to-see-here-optometrist-in-denial/"
            },
            "sourceNotes": {
                "1": "defrauded government covid pay assistance and engaged in tax avoidance",
                "2": "defrauded government covid pay assistance and engaged in tax avoidance",
                "3": "uses potentially harmful and exploitative sales targets"
            },
            "tags": [
                "healthcare",
                "tax avoidance",
                "deception"
            ],
            "score": 46,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/78/Specsavers_logo.svg",
            "siteUrl": "https://www.specsavers.com/",
            "updatedAt": "2026-07-07T18:54:45.667Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Specsavers"
        },
        "state-farm": {
            "key": "state-farm",
            "names": [
                "State Farm",
                "State Farm Insurance"
            ],
            "comment": "State Farm is a U.S. insurance company that failed to pay Hurricane Katrina victims' claims [1][2][3], rejected thousands of valid insurance claims [4][5][6], and violated customers' healthcare data privacy [7][8]. The company has engaged in bribery and corruption [9][10], promoted a net‑zero pledge while investing in fossil fuels [11][12], practiced sexist hiring practices [13][14], discriminated against disabled employees [15] and racially discriminated against both employees and customers in its claims process [16][17][18][19].",
            "sources": {
                "1": "https://apnews.com/article/lawsuits-mississippi-hurricanes-legal-proceedings-d8ca251ec9f6e6ead832c7b6577bd9a3",
                "2": "https://apnews.com/article/lawsuits-mississippi-hurricanes-legal-proceedings-d8ca251ec9f6e6ead832c7b6577bd9a3",
                "3": "https://web.archive.org/web/20070129011130/http://money.cnn.com/2007/01/26/news/companies/state_farm/index.htm",
                "4": "https://web.archive.org/web/20231021230512/https://casetext.com/case/state-farm-fire-cas-co-v-radcliff-1",
                "5": "http://www.cnn.com/2007/US/02/09/insurance.hardball/index.html",
                "6": "https://www.insurancebusinessmag.com/us/news/breaking-news/state-farm-files-motion-for-new-trial-against-shannen-doherty-316194.aspx",
                "7": "https://www.insurancebusinessmag.com/us/news/breaking-news/state-farm-accused-of-violating-privacy-laws-458699.aspx",
                "8": "https://cookcountyrecord.com/stories/647854063-class-action-accuses-state-farm-of-wrongly-sharing-people-s-health-information-with-company-building-risk-database",
                "9": "https://www.reuters.com/article/legal-us-otc-darkmoney-idUSKCN1LL2ZQ",
                "10": "https://www.nytimes.com/2008/06/28/business/28tort.html",
                "11": "https://www.prnewswire.com/news-releases/top-10-us-insurance-companies-invest-51-billion-in-fossil-fuels-8-out-of-10-have-not-altered-investments-to-address-climate-change-driving-catastrophic-fire-and-hurricane-losses-says-consumer-watchdog-300727520.html",
                "12": "https://www.insurancebusinessmag.com/us/news/environmental/insurance-industry-needs-to-dump-fossil-fuels-says-watchdog-group-113449.aspx",
                "13": "https://www.nytimes.com/1988/03/17/us/judge-backs-settlement-in-state-farm-bias-case.html",
                "14": "https://www.washingtonpost.com/archive/politics/1988/01/20/sex-bias-lawsuit-settled-by-state-farm-insurance/ab0c74c5-43b5-4de9-a726-0ec1df5ef09e/",
                "15": "https://www.insurancejournal.com/news/southeast/2023/07/19/731244.htm",
                "16": "https://www.propertyinsurancecoveragelaw.com/2014/02/articles/state-farm/hindin-v-state-farm-the-landmark-claims-practice-case-that-few-know-about-finally-ends/",
                "17": "https://www.insurancebusinessmag.com/us/news/breaking-news/state-farm-hit-by-class-action-lawsuit-claiming-racial-discrimination-430895.aspx",
                "18": "https://www.propertyinsurancecoveragelaw.com/2022/03/articles/state-farm/discrimination-concerns-at-state-farm/",
                "19": "https://web.archive.org/web/20231021230513/https://casetext.com/case/campbell-jackson-v-state-farm-ins"
            },
            "sourceNotes": {
                "1": "failed to pay claims of hurriance katrina victims",
                "2": "failed to pay claims of hurriance katrina victims",
                "3": "failed to pay claims of hurriance katrina victims",
                "4": "rejected thousands of valid insurance claims",
                "5": "rejecting valid insurance claims",
                "6": "rejected valid insurance claims",
                "7": "violated customers' healthcare data privacy",
                "8": "violated customers' healthcare data privacy",
                "9": "engaged in corruption",
                "10": "engaged in bribery",
                "11": "claims to support net zero while investing in fossil fuels",
                "12": "claims to support net zero while investing in fossil fuels",
                "13": "sexist hiring practices",
                "14": "sexist hiring practices",
                "15": "discriminating against disabled employee",
                "16": "racial discrimination in claims process",
                "17": "engaged in racial discrimination against employees and customers",
                "18": "engaged in racial discrimination against employees and customers",
                "19": "engaged in racial discrimination against employees and customers"
            },
            "tags": [
                "finance",
                "insurance",
                "corruption",
                "greenwashing",
                "fossil fuels",
                "gender discrimination",
                "racial discrimination",
                "privacy violations",
                "unfair pay"
            ],
            "score": 20,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/9a/State_Farm_logo.svg",
            "siteUrl": "https://www.statefarm.com/",
            "updatedAt": "2026-07-07T18:54:45.667Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/State_Farm"
        },
        "subaru": {
            "key": "subaru",
            "names": [
                "Subaru",
                "スバル",
                "Subaru Corporation",
                "Fuji Heavy Industries"
            ],
            "comment": "Subaru is a Japanese automotive company that has engaged in improper vehicle inspections leading to safety issues [1], manipulated emissions data [2], and underpaid manufacturing workers [3]. The company has also violated customers' data privacy [4], sold unsafe cars that accelerate randomly [5], and knowingly sold vehicles with defective safety systems [6] and defective airbags [7].",
            "sources": {
                "1": "https://www.reuters.com/article/business/automaker-subaru-sees-177-million-in-costs-linked-to-inspection-scandal-idUSKBN1DG19W/",
                "2": "https://www.motortrend.com/news/subaru-admits-manipulated-fuel-economy-emissions-data",
                "3": "https://www.reuters.com/article/2015/07/29/us-japan-subaru-specialreport-idUSKCN0Q21GS20150729/",
                "4": "https://www.torquenews.com/1084/subaru-now-involved-vehicle-data-collection-lawsuit-investigation",
                "5": "https://www.carcomplaints.com/news/2025/subaru-sudden-acceleration-lawsuit.shtml",
                "6": "https://www.motorbiscuit.com/lawsuit-subaru-suvs-faulty-safety-systems/",
                "7": "https://goldwaterlawfirm.com/insights/takata-airbag-lawsuit-settles-for-553-6-million/"
            },
            "sourceNotes": {
                "1": "conducted improper vehicle inspections leading to safety issues",
                "2": "manipulated emissions data",
                "3": "underpaid manufacturing workers",
                "4": "violating customers' data privacy",
                "5": "sold unsafe cars that accelerate randomly",
                "6": "knowingly sold cars with defective safety systems",
                "7": "knowingly sold cars with defective airbags"
            },
            "tags": [
                "cars",
                "deception",
                "unfair pay",
                "privacy violations",
                "unsafe practices",
                "environmental violations"
            ],
            "score": 24,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/ca/Subaru_logo_%28transparent%29.svg",
            "siteUrl": "https://www.subaru.co.jp/en/",
            "updatedAt": "2026-07-07T18:54:45.667Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Subaru"
        },
        "superdrug": {
            "key": "superdrug",
            "names": [
                "Superdrug"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "conumer goods",
                "retail"
            ],
            "score": null,
            "ownedBy": [
                "ck-hutchison"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/3/36/Superdrug_logo.svg",
            "siteUrl": "https://superdrug.com/",
            "updatedAt": "2026-07-11T07:13:56.030Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Superdrug"
        },
        "superdry": {
            "key": "superdry",
            "names": [
                "Superdry",
                "Superdry Limited",
                "SUPERDRY®︎冒険魂",
                "Superdry & Co",
                "SDRY"
            ],
            "comment": "Superdry is a British fashion retailer that has faced accusations of greenwashing in its advertising campaigns [1][2] and allegations of age discrimination against employees [3][4]. The brand has also been criticized for racial discrimination towards customers [5], the use of forced Uyghur labour in its supply chain [6], and the criminal conviction of a co‑founder for rape [7][8].",
            "sources": {
                "1": "https://www.bbc.co.uk/news/articles/ckgm79djr9yo",
                "2": "https://news.sky.com/story/nike-superdry-and-lacoste-ads-banned-over-misleading-sustainability-claims-13478650",
                "3": "https://www.brownejacobson.com/insights/hung-out-to-dry",
                "4": "https://assets.publishing.service.gov.uk/media/62fb9320d3bf7f06f7338bab/Ms_R_Sunderland_v_Superdry_PLC_-_1406389.2020_-_Reconsideration_Judgment.pdf",
                "5": "https://www.smh.com.au/national/nsw/this-can-t-just-keep-happening-the-family-taking-a-retail-giant-to-court-20260527-p601c6.html",
                "6": "https://www.shu.ac.uk/-/media/home/research/helena-kennedy-centre/projects/laundering-cotton-annexes/laundering-cotton.pdf",
                "7": "https://www.bbc.co.uk/news/articles/c936pdd0vyeo",
                "8": "https://www.theguardian.com/uk-news/2026/may/07/superdry-co-founder-james-holder-jailed-rape"
            },
            "sourceNotes": {
                "1": "greenwashing in adverts",
                "2": "greenwashing in adverts",
                "3": "age discrimination against employees",
                "4": "age discrimination against employees",
                "5": "racial discrimination against customers",
                "6": "forced Uyghur labour in supply chain",
                "7": "co founder guilty of rape",
                "8": "co founder guilty of rape"
            },
            "tags": [
                "clothing",
                "retail",
                "greenwashing",
                "racial discrimination",
                "forced uyghur labour",
                "sexual harassment"
            ],
            "score": 25,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/c/c9/Superdry_%26_Co_logo.jpg",
            "siteUrl": "http://superdry.com/",
            "updatedAt": "2026-07-12T07:03:52.537Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Superdry_%26_Co"
        },
        "swarovski": {
            "key": "swarovski",
            "names": [
                "Swarovski",
                "A. Kosmann, D. Swarovski & Co.",
                "D. Swarovski KG"
            ],
            "comment": "Swarovski is an Austrian jewllery company that has faced hazardous waste violations [1] and had historical involvement with the Nazi party [2][3]. ",
            "sources": {
                "1": "https://dem.ri.gov/programs/benviron/compinsp/enfact/mar2008.htm",
                "2": "https://www.jpost.com/opinion/article-708815",
                "3": "https://www.derstandard.de/consent/tcf/story/3000000280190/mitl228ufer-oder-aktive-nazis-swarovski-geschichte-entzweit-historiker"
            },
            "sourceNotes": {
                "1": "hazardous waste violation",
                "2": "historical inolvement with the Nazi party",
                "3": "historical inolvement with the Nazi party"
            },
            "tags": [
                "jewellery",
                "environmental violations",
                "unsustainable practices"
            ],
            "score": 44,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/06/Swarovski_new_logo.svg",
            "siteUrl": "https://www.swarovski.com/",
            "updatedAt": "2026-07-13T11:43:41.847Z",
            "error": "TypeError: Cannot read properties of undefined (reading 'url')",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Swarovski"
        },
        "swiffer": {
            "key": "swiffer",
            "names": [
                "Swiffer"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "child labour",
                "russia"
            ],
            "score": 35,
            "ownedBy": [
                "procter-and-gamble"
            ],
            "updatedAt": "2026-07-14T07:03:53.582Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Swiffer",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/e/ef/Swiffer_logo.svg",
            "siteUrl": "https://www.swiffer.com/"
        },
        "t-mobile": {
            "key": "t-mobile",
            "names": [
                "T-Mobile",
                "T Mobile",
                "T-Mobile US, Inc.",
                "VoiceStream Wireless",
                "TMUS"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "telecommunications"
            ],
            "score": 33,
            "ownedBy": [
                "deutsche-telekom-ag"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/8/88/T-Mobile_US_Logo_2022_RGB_Magenta_on_Transparent.svg",
            "siteUrl": "https://www.t-mobile.com/",
            "updatedAt": "2026-07-15T09:31:24.105Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/T-Mobile_US"
        },
        "tampax": {
            "key": "tampax",
            "names": [
                "Tampax"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer-goods"
            ],
            "score": 35,
            "ownedBy": [
                "procter-and-gamble"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/a5/Tampax.svg",
            "siteUrl": "http://www.tampax.com/",
            "updatedAt": "2026-07-16T07:18:21.219Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Tampax"
        },
        "target": {
            "key": "target",
            "names": [
                "Target",
                "Target Corporation",
                "Goodfellow Dry Goods",
                "Dayton's Dry Goods Company",
                "Dayton Company",
                "Dayton Corporation",
                "Dayton-Hudson Corporation",
                "TGT"
            ],
            "comment": "Target is an American retail company that has engaged in predatory pricing [1], rolled back DEI policies [2], enabled a massive data breach of millions of customers' data [3], underpaid employees [4][5][6], and exploited personal customer data [7][8]. It has also discriminated against job applicants on the basis of race [9] and disability [10], abused animals in its supply chain [11][12], and donated to anti-LGBTQ political causes [13].",
            "sources": {
                "1": "https://www.usnews.com/news/best-states/california/articles/2022-04-29/target-corp-pays-5-million-to-settle-pricing-lawsuit#:~:text=April%2029%2C%202022%2C%20at%203%3A54%20p.m.&text=MINNEAPOLIS%20(AP)%20%E2%80%94%20Target%20Corp,charged%20them%20more%20than%20advertised",
                "2": "https://www.forbes.com/sites/pamdanziger/2025/12/15/target-withstood-dei-boycotts-to-show-signs-of-reputation-recovery/",
                "3": "https://www.zdnet.com/article/anatomy-of-the-target-data-breach-missed-opportunities-and-lessons-learned/",
                "4": "https://news.bloomberglaw.com/daily-labor-report/target-workers-reach-nearly-2-million-deal-to-end-wage-lawsuit",
                "5": "https://news.bloomberglaw.com/daily-labor-report/target-workers-reach-nearly-2-million-deal-to-end-wage-lawsuit",
                "6": "https://www.thehrdigest.com/target-nj-employees-wage-dispute-lawsuit-settled-for-4-6-million/",
                "7": "https://www.businessinsider.com/the-incredible-story-of-how-target-exposed-a-teen-girls-pregnancy-2012-2",
                "8": "https://www.globalbusinessandhumanrights.com/2012/02/23/predictive-analytics-informed-consent-and-privacy-the-case-of-target/",
                "9": "https://www.washingtonpost.com/news/business/wp/2018/04/05/target-to-pay-3-74-million-to-settle-claims-that-it-discriminated-against-black-latino-job-applicants/",
                "10": "https://www.eeoc.gov/newsroom/target-corporation-pay-45000-settle-eeoc-disability-discrimination-lawsuit",
                "11": "https://web.archive.org/web/20120824064220/http://www.mcdonaldscruelty.com/",
                "12": "https://web.archive.org/web/20131213192832/http://www.startribune.com/business/134160418.html?refer=y",
                "13": "https://web.archive.org/web/20170818010627/http://www.rollingstone.com/music/news/lady-gaga-ends-deal-with-target-over-its-support-of-anti-gay-groups-20110309"
            },
            "sourceNotes": {
                "1": "predatory pricing",
                "2": "rolled back DEI policies",
                "3": "enabled data breach of millions of customers' data",
                "4": "underpaid employees",
                "5": "underpaid employees",
                "6": "underpaid employees",
                "7": "exploitatative use of personal customer data",
                "8": "exploitatative use of personal customer data",
                "9": "racially discriminated against job applicants",
                "10": "discriminated against disabled job applicants",
                "11": "animal abuse in supply chain",
                "12": "animal abuse in supply chain",
                "13": "donated to anti-LGBTQ political causes"
            },
            "tags": [
                "supermarket",
                "retail",
                "anticompetitive practices",
                "data breach",
                "privacy violations",
                "unfair pay",
                "racial discrimination",
                "animal abuse"
            ],
            "score": 31,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/2a/Target_2004_bullseye.svg",
            "siteUrl": "https://target.com/",
            "updatedAt": "2026-07-17T09:24:51.166Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Target_Corporation"
        },
        "tayto": {
            "key": "tayto",
            "names": [
                "Tayto"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": null,
            "ownedBy": [
                "pfeifer-and-langen"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/7/70/Mr_tayto.jpg",
            "siteUrl": "https://taytocrisps.ie/",
            "updatedAt": "2026-07-18T06:09:04.313Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Tayto_(Republic_of_Ireland)"
        },
        "tefal": {
            "key": "tefal",
            "names": [
                "Tefal",
                "Tefal S.A.S.",
                "T-fal"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "appliances"
            ],
            "score": 30,
            "ownedBy": [
                "groupe-seb"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/2/2f/Tefal_logo.svg",
            "siteUrl": "http://tefal.com/",
            "updatedAt": "2026-07-19T08:50:01.083Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Tefal"
        },
        "telefonica": {
            "key": "telefonica",
            "names": [
                "Telefonica",
                "Telefónica",
                "Telefónica, S.A.",
                "Compañía Telefónica Nacional de España",
                "TEF"
            ],
            "comment": "Telefonica is a Spanish telecommunications company that has been involved in bribery [1][2] and has faced allegations of disability discrimination against employees [3]. Employees have also suffered sexual harassment at the company [4][5].",
            "sources": {
                "1": "https://apnews.com/article/venezuela-bribery-scheme-phone-company-justice-department-fbb571ecd3cf1ce7c9d023a37fdec4b6",
                "2": "https://voz.us/en/world/241111/18041/telefonica-fired-its-ceo-in-venezuela-after-the-doj-fines-and-the-uncovering-of-the-bribery-scheme.html",
                "3": "https://equalityni.org/our-work/news/160-000-settlement-in-disability-discrimination-case",
                "4": "https://graziadaily.co.uk/life/real-life/belfast-woman-receives-35k-sexual-harassment-settlement-employer/",
                "5": "https://www.bbc.co.uk/news/uk-northern-ireland-42153642"
            },
            "sourceNotes": {
                "1": "involved in bribery",
                "2": "involved in bribery",
                "3": "disability discrimination against employees",
                "4": "employees suffered sexual harassment",
                "5": "employees suffered sexual harassment"
            },
            "tags": [
                "telecommunications",
                "corruption",
                "sexual harassment"
            ],
            "score": 34,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/79/Telef%C3%B3nica_2021_logo.svg",
            "siteUrl": "http://telefonica.com/",
            "updatedAt": "2026-07-20T12:29:29.607Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Telef%C3%B3nica"
        },
        "telxius": {
            "key": "telxius",
            "names": [
                "Telxius"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "telecommunications"
            ],
            "score": 34,
            "ownedBy": [
                "telefonica"
            ],
            "updatedAt": "2026-07-20T17:17:03.720Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Telxius",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/58/Telxius_logo.svg",
            "siteUrl": "https://telxius.com/"
        },
        "tgi-fridays": {
            "key": "tgi-fridays",
            "names": [
                "TGI Fridays",
                "TGI Fridays Franchisor, LLC"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurant"
            ],
            "score": null,
            "ownedBy": [
                "triartisan-capital-advisors"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/4/44/Tgi_fridays_logo13.svg",
            "siteUrl": "https://tgifridays.com/",
            "updatedAt": "2026-07-21T19:23:59.181Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/TGI_Fridays"
        },
        "the-body-shop": {
            "key": "the-body-shop",
            "names": [
                "The Body Shop"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "cosmetics",
                "retail"
            ],
            "score": null,
            "ownedBy": [
                "aurea-group"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/8/87/The_Body_Shop_logo_2020.svg",
            "siteUrl": "https://www.thebodyshop.com/",
            "updatedAt": "2026-07-21T19:23:59.181Z",
            "error": "Error [ERR_HTTP2_INVALID_SESSION]: The session has been destroyed"
        },
        "the-north-face": {
            "key": "the-north-face",
            "names": [
                "The North Face"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing"
            ],
            "score": 20,
            "ownedBy": [
                "vf-corporation"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/e/e1/The_North_Face.png",
            "siteUrl": "http://thenorthface.com/",
            "updatedAt": "2026-07-23T22:45:43.047Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/The_North_Face"
        },
        "columbia": {
            "key": "columbia",
            "names": [
                "Columbia",
                "Columbia Sportswear",
                "The Columbia Sportswear Company",
                "COLM"
            ],
            "comment": "Columbia Sportswear is an American apparel company that has faced environmental violations [1] and a range of labor abuses across its supply chain, including forced labour in cotton and garment production [2][3][4], underpayment and poor working conditions for garment workers [5], sexual abuse allegations [6], and the tragic death of an employee in unsafe factory conditions [7]. These incidents have also involved extreme exploitation leading to a garment worker’s suicide due to abuse within the supply chain [8] and highlight systemic failures in ensuring safe, fair, and ethical manufacturing practices.",
            "sources": {
                "1": "https://echo.epa.gov/enforcement-case-report?id=10-2012-0067",
                "2": "https://cleanclothes.org/file-repository/resources-publications-labour-without-liberty-2013-female-migrant-workers-in-bangalores-garment-industry-short-version",
                "3": "https://inews.co.uk/news/business/under-armour-columbia-forced-labour-investigation-us-3020631",
                "4": "https://www.lastradainternational.org/news/major-brands-linked-to-forced-labour-in-cotton-sector/",
                "5": "https://www.theguardian.com/global-development/2021/jul/09/top-fashion-brands-face-legal-challenge-over-garment-workers-rights-in-asia",
                "6": "https://inews.co.uk/news/under-armour-clothes-from-sweatshop-supplier-banned-4497529",
                "7": "https://www.osha.gov/ords/imis/establishment.inspection_detail?id=1613222.015",
                "8": "https://www.business-humanrights.org/en/latest-news/jordan-abuse-at-under-armour-columbia-and-american-eagle-supplier-factory-led-to-suicide-of-migrant-worker-incl-co-comments/"
            },
            "sourceNotes": {
                "1": "environmental violations",
                "2": "forced labour and abuse in supply chain",
                "3": "forced labour in supply chain",
                "4": "foced labour in cotton supply chain",
                "5": "underpayment and poor working conditions for garment workers",
                "6": "sexual abuse in supply chain",
                "7": "employee died in unsafe factory conditions",
                "8": "abuse of garment workers in supply chain leading to suicide"
            },
            "tags": [
                "clothing",
                "sportswear",
                "retail",
                "environmental violations",
                "forced labour",
                "poor working conditions",
                "sexual harassment",
                "unfair pay",
                "unsafe working conditions",
                "unsafe practices"
            ],
            "score": 17,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/c2/Columbia_Sportswear_Co_logo.svg",
            "siteUrl": "https://www.columbia.com/",
            "updatedAt": "2026-07-25T09:58:58.900Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Columbia_Sportswear"
        },
        "sorel": {
            "key": "sorel",
            "names": [
                "Sorel"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing",
                "sportswear",
                "retail"
            ],
            "score": 17,
            "ownedBy": [
                "columbia"
            ],
            "updatedAt": "2026-07-25T10:23:07.867Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Sorel_(brand)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/2/20/Sorel_logo.jpg",
            "siteUrl": "http://www.sorel.com/"
        },
        "mountain-hardwear": {
            "key": "mountain-hardwear",
            "names": [
                "Mountain Hardwear"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing",
                "sportswear",
                "retail"
            ],
            "score": 17,
            "ownedBy": [
                "columbia"
            ],
            "updatedAt": "2026-07-25T10:23:08.432Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Mountain_Hardwear",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/1/1a/Mountain_Hardwear.png",
            "siteUrl": "http://mountainhardwear.com/"
        },
        "prana": {
            "key": "prana",
            "names": [
                "Prana"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing",
                "sportswear",
                "retail"
            ],
            "score": 17,
            "ownedBy": [
                "columbia"
            ],
            "updatedAt": "2026-07-25T10:23:08.874Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Prana_(brand)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/3/35/PrAna_logo.png",
            "siteUrl": "https://prana.com/"
        },
        "three": {
            "key": "three",
            "names": [
                "Three",
                "Three UK",
                "Hutchison 3G UK Limited"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "telecommunications"
            ],
            "score": 38,
            "ownedBy": [
                "vodafone"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/7/73/Logo_of_Three_UK.svg",
            "siteUrl": "https://www.three.co.uk/",
            "updatedAt": "2026-07-26T07:13:59.070Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Three_UK"
        },
        "vodafone": {
            "key": "vodafone",
            "names": [
                "Vodafone",
                "Vodafone Group Public Limited Company",
                "Racal Strategic Radio Limited",
                "Racal Telecommunications Group Limited",
                "Racal Telecom Limited",
                "Racal Telecom Public Limited Company",
                "Vodafone AirTouch Public Limited Company",
                "VOD"
            ],
            "comment": "Vodafone is a British telecommunications company that has engaged in tax avoidance [1][2][3], overcharged customers [4] and violated consumer protection laws [5], while pursuing monopolistic anticompetitive practices [6] and exploitative marketing to consumers [7]. The firm has mistreated store staff [8], discriminated against disabled employees [9], suppressed internet access during the Arab Spring to silence protesters [10][11], and participated in state surveillance [12].",
            "sources": {
                "1": "https://web.archive.org/web/20101027221207/http://www.private-eye.co.uk/sections.php?section_link=in_the_back&issue=1273",
                "2": "https://www.theguardian.com/uk-news/2014/jun/14/uk-uncut-vodafone",
                "3": "https://web.archive.org/web/20160106161736/https://www.thebureauinvestigates.com/2012/03/06/vodafone-undercover-investigation-exposes-swiss-branches/",
                "4": "https://www.bbc.co.uk/news/business-37772118",
                "5": "https://www.bfdi.bund.de/SharedDocs/Pressemitteilungen/DE/2025/06_Geldbu%C3%9Fe-Vodafone.html?nn=251944",
                "6": "https://www.consiliulconcurentei.ro/wp-content/uploads/2011/02/amenzi_telefonie_feb_2011.pdf",
                "7": "https://en.agcm.it/en/media/press-releases/2019/12/PS11380-PS11381",
                "8": "https://www.theguardian.com/business/2025/apr/27/vodafone-whistleblowers-warned-executives-about-plight-of-high-street-store-staff",
                "9": "https://assets.publishing.service.gov.uk/media/64524287c33b460012f5e5c9/Mr_S_Pervaiz_v_Vodafone_Ltd_-_1305124_2021_-_Full.pdf",
                "10": "https://af.reuters.com/article/tunisiaNews/idAFLDE70Q2P220110127",
                "11": "https://web.archive.org/web/20220116201719/https://www.telegraph.co.uk/news/worldnews/africaandindianocean/egypt/8288163/How-Egypt-shut-down-the-internet.html",
                "12": "https://www.theguardian.com/business/2014/jun/06/vodafone-reveals-secret-wires-allowing-state-surveillance"
            },
            "sourceNotes": {
                "1": "tax avoidance",
                "2": "tax avoidance",
                "3": "tax avoidance",
                "4": "overcharging customers",
                "5": "consumer protection violations",
                "6": "monopolistic anticompetetive practices",
                "7": "exploitative marketing to customers",
                "8": "poor treatment of store staff",
                "9": "disability discrimination against employees",
                "10": "deactivated internet during arab spring to supress protesters",
                "11": "deactivated internet during arab spring to supress protesters",
                "12": "participation in state surveillance"
            },
            "tags": [
                "telecommunications",
                "anticompetitive practices",
                "tax avoidance",
                "deception",
                "privacy violations",
                "poor working conditions"
            ],
            "score": 38,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/c/cc/Vodafone_2017_logo.svg",
            "siteUrl": "https://vodafone.com/",
            "updatedAt": "2026-07-26T07:32:08.626Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Vodafone"
        },
        "tidal": {
            "key": "tidal",
            "names": [
                "Tidal",
                "TIDAL"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech",
                "music"
            ],
            "score": 37,
            "ownedBy": [
                "block"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/18/Tidal_%28service%29_logo.svg",
            "siteUrl": "https://en.wikipedia.org/wiki/Website",
            "updatedAt": "2026-07-26T07:59:09.268Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Tidal_(service)"
        },
        "tiktok": {
            "key": "tiktok",
            "names": [
                "TikTok"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech"
            ],
            "score": 20,
            "ownedBy": [
                "bytedance"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/a/a9/TikTok_logo.svg",
            "siteUrl": "https://tiktok.com/",
            "updatedAt": "2026-07-27T08:42:11.323Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/TikTok"
        },
        "timberland": {
            "key": "timberland",
            "names": [
                "Timberland"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing",
                "footwear"
            ],
            "score": 20,
            "ownedBy": [
                "vf-corporation"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/e/e8/Timberland-logo.png",
            "siteUrl": "https://www.timberland.com/",
            "updatedAt": "2026-07-28T07:26:26.414Z",
            "error": "TypeError: session.cookieJar.setCookies is not a function",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Timberland_(company)"
        },
        "tnt-express": {
            "key": "tnt-express",
            "names": [
                "TNT Express"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "logistics"
            ],
            "score": 45,
            "ownedBy": [
                "fedex"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/c9/TNT_Express_Logo.svg",
            "siteUrl": "http://tnt.com/",
            "updatedAt": "2026-07-29T10:22:34.763Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/TNT_Express"
        },
        "toolstation": {
            "key": "toolstation",
            "names": [
                "Toolstation",
                "Tool Station",
                "Toolstation Limited"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "construction",
                "retail"
            ],
            "score": 17,
            "ownedBy": [
                "travis-perkins"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/7c/Toolstation_logo.svg",
            "siteUrl": "http://toolstation.com/",
            "updatedAt": "2026-08-01T16:14:12.814Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Toolstation"
        },
        "trader-joe's": {
            "key": "trader-joe's",
            "names": [
                "Trader Joe's",
                "Trader Joe's Company"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "supermarket",
                "retail"
            ],
            "score": 60,
            "ownedBy": [
                "aldi"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/d/d1/Trader_Joes_Logo.svg",
            "siteUrl": "https://www.traderjoes.com/",
            "updatedAt": "2026-08-04T11:59:13.803Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Trader_Joe%27s"
        },
        "trek-bicycle-corporation": {
            "key": "trek-bicycle-corporation",
            "names": [
                "Trek Bicycle Corporation",
                "Trek"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "sportswear",
                "retail"
            ],
            "score": null,
            "ownedBy": [
                "intrepid-corporation"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/e/e0/2018_Trek_logo_word_mark_wiki_buffer.svg",
            "siteUrl": "https://www.trekbikes.com/us/en_US/",
            "updatedAt": "2026-08-05T07:31:40.081Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Trek_Bicycle_Corporation"
        },
        "tripadvisor": {
            "key": "tripadvisor",
            "names": [
                "Tripadvisor",
                "TRIP"
            ],
            "comment": "Tripadvisor is an American travel‑review platform that has been accused of predatory pricing practices [1] and of hosting misleading and fake AI‑generated reviews, including the use of AI to produce deceptive summaries of hotel feedback [2][3][4][5][6]. The company has also been implicated in supporting Israeli settlements [7][8][9] and in silencing sexual assault victims who reported abuse on its platform [10][11][12].",
            "sources": {
                "1": "https://web.archive.org/web/20200226212356/https://www.latimes.com/business/la-xpm-2012-jul-13-la-fi-mo-tripadvisor-fined-20120713-story.html",
                "2": "https://www.bbc.co.uk/news/business-49605457",
                "3": "https://hbr.org/2020/11/how-fake-customer-reviews-do-and-dont-work",
                "4": "https://web.archive.org/web/20201109032051/https://www.standard.co.uk/news/london/dulwich-shed-becomes-tripadvisors-number-one-ranked-restaurant-in-london-after-fake-reviews-a3712606.html",
                "5": "https://web.archive.org/web/20171129224653/http://www.bbc.co.uk/news/technology-16823012",
                "6": "https://www.theguardian.com/business/2026/jul/02/ai-summaries-tripadvisor-hotel-reviews-downplay-serious-complaints",
                "7": "https://web.archive.org/web/20210709093910/https://www.ohchr.org/EN/NewsEvents/Pages/DisplayNews.aspx?NewsID=25542",
                "8": "https://web.archive.org/web/20210709183439/https://reliefweb.int/report/occupied-palestinian-territory/database-all-business-enterprises-involved-certain-activities",
                "9": "https://www.independent.co.uk/voices/israel-palestine-illegal-settlements-west-bank-air-bnb-trip-advisor-booking-expedia-a8754001.html",
                "10": "https://web.archive.org/web/20171103220918/https://www.cbsnews.com/news/tripadvisor-accused-of-deleting-reviews-that-raised-red-flags",
                "11": "https://web.archive.org/web/20200210165945/https://www.jsonline.com/story/news/investigations/2017/11/01/tripadvisor-removed-warnings-rapes-and-injuries-mexico-resorts-tourists-say/817172001/",
                "12": "https://web.archive.org/web/20190906133638/https://www.nytimes.com/2017/11/14/travel/tripadvisor-warnings-criticism.html"
            },
            "sourceNotes": {
                "1": "predatory pricing",
                "2": "hosts misleading and fake AI generated reviews",
                "3": "hosts misleading and fake AI generated reviews",
                "4": "hosts misleading and fake AI generated reviews",
                "5": "hosts misleading and fake AI generated reviews",
                "6": "used AI to generate misleading summaries of hotel reviews",
                "7": "involvement in Israeli settlements",
                "8": "involvement in Israeli settlements",
                "9": "involvement in Israeli settlements",
                "10": "silenced sexual assault victims",
                "11": "silenced sexual assault victims",
                "12": "silenced sexual assault victims"
            },
            "tags": [
                "tech",
                "travel",
                "anticompetitive practices",
                "deception",
                "sexual harassment",
                "connections to israel"
            ],
            "score": 18,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/7/73/Tripadvisor_2025_Logo.svg",
            "siteUrl": "https://www.tripadvisor.com/",
            "updatedAt": "2026-08-07T10:34:59.882Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Tripadvisor",
            "error": "TypeError: Cannot read properties of undefined (reading '0')"
        },
        "cruise-critic": {
            "key": "cruise-critic",
            "names": [
                "Cruise Critic"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech",
                "travel"
            ],
            "score": 18,
            "ownedBy": [
                "tripadvisor"
            ],
            "updatedAt": "2026-08-07T11:03:04.518Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Cruise_Critic",
            "siteUrl": "https://www.cruisecritic.com/"
        },
        "flipkey": {
            "key": "flipkey",
            "names": [
                "FlipKey"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech",
                "travel"
            ],
            "score": 18,
            "ownedBy": [
                "tripadvisor"
            ],
            "updatedAt": "2026-08-07T11:03:04.607Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/FlipKey",
            "siteUrl": "https://www.flipkey.com/"
        },
        "thefork": {
            "key": "thefork",
            "names": [
                "TheFork"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech",
                "travel"
            ],
            "score": 18,
            "ownedBy": [
                "tripadvisor"
            ],
            "updatedAt": "2026-08-07T11:03:04.846Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/TheFork",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/c/c5/Thefork-logo-green.svg",
            "siteUrl": "https://www.thefork.com.au/"
        },
        "niumba": {
            "key": "niumba",
            "names": [
                "Niumba"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech",
                "travel"
            ],
            "score": 18,
            "ownedBy": [
                "tripadvisor"
            ],
            "updatedAt": "2026-08-07T11:03:04.913Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Niumba",
            "siteUrl": "https://www.niumba.com/"
        },
        "seatguru": {
            "key": "seatguru",
            "names": [
                "SeatGuru"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech",
                "travel"
            ],
            "score": 18,
            "ownedBy": [
                "tripadvisor"
            ],
            "updatedAt": "2026-08-07T11:03:05.287Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/SeatGuru",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/9/92/2020SGLogo.svg",
            "siteUrl": "https://www.seatguru.com/"
        },
        "tropicana": {
            "key": "tropicana",
            "names": [
                "Tropicana",
                "Tropicana Brands Group",
                "Tropicana Products, Inc."
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages"
            ],
            "score": 20,
            "ownedBy": [
                "pai-partners",
                "pepsico"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/b/b5/Tropicana_green_flat_logo.svg",
            "siteUrl": "https://www.tropicana.com/",
            "updatedAt": "2026-08-09T15:47:49.638Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Tropicana_Brands_Group"
        },
        "twinings": {
            "key": "twinings",
            "names": [
                "Twinings"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages"
            ],
            "score": 10,
            "ownedBy": [
                "associated-british-foods"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/5b/Twinings_Tea_logo.png",
            "siteUrl": "http://twinings.co.uk/",
            "updatedAt": "2026-08-10T19:14:32.194Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Twinings"
        },
        "tylenol": {
            "key": "tylenol",
            "names": [
                "Tylenol"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "pharmaceuticals"
            ],
            "score": null,
            "ownedBy": [
                "kenvue"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/Tylenol-red.svg",
            "siteUrl": "https://www.tylenol.com/",
            "updatedAt": "2026-08-11T20:10:49.017Z"
        },
        "kenvue": {
            "key": "kenvue",
            "names": [
                "Kenvue"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "pharmaceuticals"
            ],
            "score": 17,
            "ownedBy": [
                "kimberly-clark"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/35/Kenvue_Logo_Black_RGB.svg/250px-Kenvue_Logo_Black_RGB.svg.png",
            "siteUrl": "http://kenvue.com/",
            "updatedAt": "2026-08-13T19:18:44.090Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Kenvue"
        },
        "kimberly-clark": {
            "key": "kimberly-clark",
            "names": [
                "Kimberly-Clark",
                "Kimberly-Clark Corporation",
                "KMB"
            ],
            "comment": "Kimberly-Clark is an American consumer goods company that has engaged in price fixing [1], loaded employees' pensions with excessive fees [2], and engaged in greenwashing and deceptive advertising [3]. It has falsely advertised wipes as flushable [4], sold toxic nappies [5][6], used harmful ingredients in baby wipes [7], polluted a town with PFAS [8][9], caused an employee to lose fingers in an unsafe working environment [10], and has been implicated in abuse and trafficking in its supply chain [11].",
            "sources": {
                "1": "https://web.archive.org/web/20100214053711/http://www.ag.ny.gov/media_center/2000/jun/jun06a_00.html",
                "2": "https://www.law360.com/articles/2268547/kimberly-clark-strikes-2-25m-deal-to-end-401-k-fee-suit",
                "3": "https://lawstreetmedia.com/news/health/kimberly-clark-sued-for-greenwashed-baby-wipes/",
                "4": "https://www.law360.com/articles/1688217/costco-kimberly-clark-get-ok-for-20m-flushable-wipe-deal",
                "5": "https://www.courthousenews.com/pure-huggies-diapers-are-toxic-class-claims/",
                "6": "https://topclassactions.com/lawsuit-settlements/lawsuit-news/baby-food-class-action-lawsuit-and-settlement-news/huggies-class-action-claims-diapers-contain-skin-irritant-that-causes-rash/",
                "7": "https://topclassactions.com/lawsuit-settlements/lawsuit-news/huggies-baby-wipes-class-action-lawsuit-filed-over-allegedly-harmful-ingredients/",
                "8": "https://www.nbcnews.com/health/health-news/lawsuit-kleenex-maker-kimberly-clark-pfas-forever-chemicals-rcna141268",
                "9": "https://www.reuters.com/legal/litigation/kimberly-clark-factory-where-kleenex-made-pollutes-town-with-pfas-lawsuit-says-2024-02-29/",
                "10": "https://www.osha.gov/ords/imis/establishment.inspection_detail?id=1505143.015",
                "11": "https://eu.jsonline.com/story/money/business/2024/09/26/kimberly-clark-sued-over-alleged-abuse-of-suppliers-workers/75164931007/"
            },
            "sourceNotes": {
                "1": "engaged in price fixing",
                "2": "loaded employees' pensions with excessive fees",
                "3": "greenwashing and deceptive advertising",
                "4": "falsely advertised wipes as flushable",
                "5": "sold toxic nappies",
                "6": "sold toxic nappies",
                "7": "harmful ingredients in baby wipes",
                "8": "polluted town with PFAS",
                "9": "polluted town with PFAS",
                "10": "employee lost fingers in unsafe working environment",
                "11": "abuse and trafficking in supply chain"
            },
            "tags": [
                "consumer goods",
                "pharmaceuticals",
                "anticompetitive practices",
                "greenwashing",
                "deception",
                "environmental violations",
                "unsafe working conditions",
                "forced labour",
                "unfair pay"
            ],
            "score": 17,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/20/Kimberly-Clark_Logo.png/250px-Kimberly-Clark_Logo.png",
            "siteUrl": "https://www.kimberly-clark.com/en-us/",
            "updatedAt": "2026-08-13T19:18:44.090Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Kimberly-Clark"
        },
        "kleenex": {
            "key": "kleenex",
            "names": [
                "Kleenex"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "pharmaceuticals"
            ],
            "score": "17",
            "ownedBy": [
                "kimberly-clark"
            ],
            "updatedAt": "2026-08-14T19:38:27.596Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Kleenex",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/Kleenex_2024.svg/250px-Kleenex_2024.svg.png",
            "siteUrl": "https://www.kleenex.com/en-us"
        },
        "kotex": {
            "key": "kotex",
            "names": [
                "Kotex"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "pharmaceuticals"
            ],
            "score": "17",
            "ownedBy": [
                "kimberly-clark"
            ],
            "updatedAt": "2026-08-14T19:38:28.054Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Kotex",
            "logoUrl": "",
            "siteUrl": "http://www.kotex.com/"
        },
        "depend": {
            "key": "depend",
            "names": [
                "Depend"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "pharmaceuticals"
            ],
            "score": "17",
            "ownedBy": [
                "kimberly-clark"
            ],
            "updatedAt": "2026-08-14T19:38:28.324Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Depend_(undergarment)"
        },
        "scott": {
            "key": "scott",
            "names": [
                "Scott"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "pharmaceuticals"
            ],
            "score": "17",
            "ownedBy": [
                "kimberly-clark"
            ],
            "updatedAt": "2026-08-14T19:38:28.683Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Scott_Paper_Company",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/6/66/Logo_of_Scott_Paper_Company.jpg"
        },
        "cottonelle": {
            "key": "cottonelle",
            "names": [
                "Cottonelle"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "pharmaceuticals"
            ],
            "score": "17",
            "ownedBy": [
                "kimberly-clark"
            ],
            "updatedAt": "2026-08-14T19:38:28.857Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Cottonelle"
        },
        "andrex": {
            "key": "andrex",
            "names": [
                "Andrex"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "pharmaceuticals"
            ],
            "score": "17",
            "ownedBy": [
                "kimberly-clark"
            ],
            "updatedAt": "2026-08-14T19:38:28.904Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Andrex",
            "siteUrl": "http://andrex.co.uk/"
        },
        "huggies-pull-ups": {
            "key": "huggies-pull-ups",
            "names": [
                "Huggies Pull-Ups"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "pharmaceuticals"
            ],
            "score": "17",
            "ownedBy": [
                "kimberly-clark"
            ],
            "updatedAt": "2026-08-14T19:38:28.985Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Huggies_Pull-Ups",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/Huggies_Pull-Ups_Wetness_Indicator.png/250px-Huggies_Pull-Ups_Wetness_Indicator.png"
        },
        "goodnites": {
            "key": "goodnites",
            "names": [
                "GoodNites"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "pharmaceuticals"
            ],
            "score": "17",
            "ownedBy": [
                "kimberly-clark"
            ],
            "updatedAt": "2026-08-14T19:38:29.189Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/GoodNites",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/3/37/Current_2023_Goodnites_Logo.png",
            "siteUrl": "https://www.goodnites.com/en-us/"
        },
        "little-swimmers": {
            "key": "little-swimmers",
            "names": [
                "Little Swimmers"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "pharmaceuticals"
            ],
            "score": "17",
            "ownedBy": [
                "kimberly-clark"
            ],
            "updatedAt": "2026-08-14T19:38:29.825Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Little_Swimmers",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/20/Kimberly-Clark_Logo.png/250px-Kimberly-Clark_Logo.png",
            "siteUrl": "https://www.kimberly-clark.com/en-us/"
        },
        "softex": {
            "key": "softex",
            "names": [
                "Softex"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "pharmaceuticals"
            ],
            "score": "17",
            "ownedBy": [
                "kimberly-clark"
            ],
            "updatedAt": "2026-08-14T19:38:30.975Z",
            "wikipediaUrl": "https://id.wikipedia.org/wiki/Softex%20Indonesia"
        },
        "aveeno": {
            "key": "aveeno",
            "names": [
                "Aveeno"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "pharmaceuticals"
            ],
            "score": "17",
            "ownedBy": [
                "kimberly-clark"
            ],
            "updatedAt": "2026-08-14T19:38:31.115Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Aveeno",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/be/Aveeno_logo.svg/250px-Aveeno_logo.svg.png",
            "siteUrl": "http://www.aveeno.com/"
        },
        "band-aid": {
            "key": "band-aid",
            "names": [
                "Band-Aid"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "pharmaceuticals"
            ],
            "score": "17",
            "ownedBy": [
                "kimberly-clark"
            ],
            "updatedAt": "2026-08-14T19:38:31.190Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Band-Aid",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ce/Band-Aid_logo.svg/250px-Band-Aid_logo.svg.png",
            "siteUrl": "http://band-aid.com/"
        },
        "benadryl": {
            "key": "benadryl",
            "names": [
                "Benadryl"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "pharmaceuticals"
            ],
            "score": "17",
            "ownedBy": [
                "kimberly-clark"
            ],
            "updatedAt": "2026-08-14T19:38:31.393Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Benadryl",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bb/Benadryl_Itch_Stopping_Gel_%284600729217%29.jpg/250px-Benadryl_Itch_Stopping_Gel_%284600729217%29.jpg",
            "siteUrl": "https://www.benadryl.com/"
        },
        "benylin": {
            "key": "benylin",
            "names": [
                "Benylin"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "pharmaceuticals"
            ],
            "score": "17",
            "ownedBy": [
                "kimberly-clark"
            ],
            "updatedAt": "2026-08-14T19:38:31.485Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Benylin"
        },
        "calpol": {
            "key": "calpol",
            "names": [
                "Calpol"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "pharmaceuticals"
            ],
            "score": "17",
            "ownedBy": [
                "kimberly-clark"
            ],
            "updatedAt": "2026-08-14T19:38:31.666Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Calpol"
        },
        "carefree": {
            "key": "carefree",
            "names": [
                "Carefree"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "pharmaceuticals"
            ],
            "score": "17",
            "ownedBy": [
                "kimberly-clark"
            ],
            "updatedAt": "2026-08-14T19:38:32.566Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Carefree_(feminine_hygiene)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/60/Carefree_brand_logo.png/250px-Carefree_brand_logo.png",
            "siteUrl": "https://carefreelinersandpads.com/"
        },
        "clean-andamp-clear": {
            "key": "clean-andamp-clear",
            "names": [
                "Clean &amp; Clear"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "pharmaceuticals"
            ],
            "score": "17",
            "ownedBy": [
                "kimberly-clark"
            ],
            "updatedAt": "2026-08-14T19:38:32.767Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Clean_&amp;_Clear"
        },
        "combantrin": {
            "key": "combantrin",
            "names": [
                "Combantrin"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "pharmaceuticals"
            ],
            "score": "17",
            "ownedBy": [
                "kimberly-clark"
            ],
            "updatedAt": "2026-08-14T19:38:33.053Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Pyrantel",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f0/Pyrantel_skeletal_formula.svg/250px-Pyrantel_skeletal_formula.svg.png"
        },
        "imodium": {
            "key": "imodium",
            "names": [
                "Imodium"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "pharmaceuticals"
            ],
            "score": "17",
            "ownedBy": [
                "kimberly-clark"
            ],
            "updatedAt": "2026-08-14T19:38:33.297Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Loperamide",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/Loperamide.svg/250px-Loperamide.svg.png"
        },
        "listerine": {
            "key": "listerine",
            "names": [
                "Listerine"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "pharmaceuticals"
            ],
            "score": "17",
            "ownedBy": [
                "kimberly-clark"
            ],
            "updatedAt": "2026-08-14T19:38:33.517Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Listerine",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/56/Listerine_logo.svg/250px-Listerine_logo.svg.png",
            "siteUrl": "https://www.listerine.com/"
        },
        "motrin": {
            "key": "motrin",
            "names": [
                "Motrin"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "pharmaceuticals"
            ],
            "score": "17",
            "ownedBy": [
                "kimberly-clark"
            ],
            "updatedAt": "2026-08-14T19:38:33.646Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Ibuprofen",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/Ibuprofen.svg/250px-Ibuprofen.svg.png"
        },
        "mylanta": {
            "key": "mylanta",
            "names": [
                "Mylanta"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "pharmaceuticals"
            ],
            "score": "17",
            "ownedBy": [
                "kimberly-clark"
            ],
            "updatedAt": "2026-08-14T19:38:33.959Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Mylanta"
        },
        "johnson's-baby": {
            "key": "johnson's-baby",
            "names": [
                "Johnson's Baby"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "pharmaceuticals"
            ],
            "score": "17",
            "ownedBy": [
                "kimberly-clark"
            ],
            "updatedAt": "2026-08-14T19:38:34.519Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Johnson's_Baby",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/21/Johnson%27s_Baby_Product_Shelves_at_Kroger.JPG/500px-Johnson%27s_Baby_Product_Shelves_at_Kroger.JPG",
            "siteUrl": "http://johnsonsbaby.com/"
        },
        "sudafed": {
            "key": "sudafed",
            "names": [
                "Sudafed"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "pharmaceuticals"
            ],
            "score": "17",
            "ownedBy": [
                "kimberly-clark"
            ],
            "updatedAt": "2026-08-14T19:38:34.915Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Pseudoephedrine",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/66/Pseudoephedrine.svg/250px-Pseudoephedrine.svg.png"
        },
        "visine": {
            "key": "visine",
            "names": [
                "Visine"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "pharmaceuticals"
            ],
            "score": "17",
            "ownedBy": [
                "kimberly-clark"
            ],
            "updatedAt": "2026-08-14T19:38:35.406Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Visine",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/48/Visine_2020_logo.png/250px-Visine_2020_logo.png",
            "siteUrl": "http://www.visine.com/"
        },
        "zyrtec": {
            "key": "zyrtec",
            "names": [
                "Zyrtec"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "consumer goods",
                "pharmaceuticals"
            ],
            "score": "17",
            "ownedBy": [
                "kimberly-clark"
            ],
            "updatedAt": "2026-08-14T19:38:35.792Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Cetirizine",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Cetirizine_structure.svg/250px-Cetirizine_structure.svg.png"
        },
        "ubisoft": {
            "key": "ubisoft",
            "names": [
                "Ubisoft",
                "Ubisoft Entertainment SA",
                "Ubi Soft Entertainment SA",
                "UBI"
            ],
            "comment": "Ubisoft is a French video game company that has designed games to be addictive and financially draining [1][2] and has been accused of toxic and misogynist leadership [3]. The company has also faced allegations of psychological abuse of employees [4] and multiple reports of sexual assault against employees [5][6][7][8].",
            "sources": {
                "1": "https://timelinedaily.com/technology/eu-probes-seven-videogame-companies-for-unethical-gaming-practices",
                "2": "https://fortune.com/europe/2024/09/12/european-video-gaming-majors-supercell-ubisoft-in-game-purchases-complaint-eu/",
                "3": "https://techculture.biz/ubisoft-verdict-exposes-toxic-leadership-sparks-industry-wide-call-for-diversity-and-ethical-reform/",
                "4": "https://www.euronews.com/culture/2025/06/02/psychological-humiliation-and-sexual-harassment-three-former-ubisoft-execs-on-trial-in-fra",
                "5": "https://web.archive.org/web/20200712211317/https://www.eurogamer.net/articles/2020-06-24-assassins-creed-valhalla-creative-director-steps-down",
                "6": "https://web.archive.org/web/20210104005614/https://kotaku.com/assassin-s-creed-creative-director-fired-from-ubisoft-f-1844724819",
                "7": "https://web.archive.org/web/20200703070453/https://www.theverge.com/2020/7/2/21312022/ubisoft-internal-changes-allegations-employee-misconduct-ceo",
                "8": "https://web.archive.org/web/20200706153703/https://kotaku.com/ubisoft-employees-have-grave-concerns-over-toronto-stud-1844277486"
            },
            "sourceNotes": {
                "1": "designed games to be addictive and financially draining",
                "2": "designed games to be addictive and financially draining",
                "3": "toxic and misogynist leadership",
                "4": "psychological abuse of employees",
                "5": "sexual assault against employees",
                "6": "sexual assault against employees",
                "7": "sexual assault against employees",
                "8": "sexual assault against employees"
            },
            "tags": [
                "videogames",
                "tech",
                "entertainment",
                "sexual harassment",
                "gender discrimination",
                "deception"
            ],
            "score": 24,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Ubisoft_logo.svg/250px-Ubisoft_logo.svg.png",
            "siteUrl": "http://ubisoft.com/",
            "updatedAt": "2026-08-15T08:55:00.785Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Ubisoft"
        },
        "massive-entertainment": {
            "key": "massive-entertainment",
            "names": [
                "Massive Entertainment"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "videogames",
                "tech",
                "entertainment"
            ],
            "score": 24,
            "ownedBy": [
                "ubisoft"
            ],
            "updatedAt": "2026-08-15T09:56:27.170Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Massive_Entertainment",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4d/Massive_Entertainment_logo.svg/250px-Massive_Entertainment_logo.svg.png",
            "siteUrl": "https://www.massive.se/"
        },
        "red-storm-entertainment": {
            "key": "red-storm-entertainment",
            "names": [
                "Red Storm Entertainment"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "videogames",
                "tech",
                "entertainment"
            ],
            "score": 24,
            "ownedBy": [
                "ubisoft"
            ],
            "updatedAt": "2026-08-15T09:56:27.559Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Red_Storm_Entertainment",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/c/c9/Red_Storm_Entertainment_Logo.png",
            "siteUrl": "http://redstorm.com/"
        },
        "reflections-interactive": {
            "key": "reflections-interactive",
            "names": [
                "Reflections Interactive"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "videogames",
                "tech",
                "entertainment"
            ],
            "score": 24,
            "ownedBy": [
                "ubisoft"
            ],
            "updatedAt": "2026-08-15T09:56:27.790Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Reflections_Interactive",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/thumb/a/ac/Ubisoft_Reflections.svg/250px-Ubisoft_Reflections.svg.png",
            "siteUrl": "https://reflections.ubisoft.com/"
        },
        "freestylegames": {
            "key": "freestylegames",
            "names": [
                "FreeStyleGames"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "videogames",
                "tech",
                "entertainment"
            ],
            "score": 24,
            "ownedBy": [
                "ubisoft"
            ],
            "updatedAt": "2026-08-15T09:56:28.244Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/FreeStyleGames",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/thumb/f/fa/Ubisoft_Leamington.svg/250px-Ubisoft_Leamington.svg.png",
            "siteUrl": "https://leamington.ubisoft.com/"
        },
        "ketchapp": {
            "key": "ketchapp",
            "names": [
                "Ketchapp"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "videogames",
                "tech",
                "entertainment"
            ],
            "score": 24,
            "ownedBy": [
                "ubisoft"
            ],
            "updatedAt": "2026-08-15T09:56:28.456Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Ketchapp",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a3/Ketchapp_logo.svg/250px-Ketchapp_logo.svg.png",
            "siteUrl": "http://www.ketchappgames.com/"
        },
        "comcast": {
            "key": "comcast",
            "names": [
                "Comcast",
                "Comcast Corporation",
                "Comcast Holdings",
                "American Cable Systems",
                "CMCSA"
            ],
            "comment": "Comcast is an American telecommunications company that has engaged in false advertising [1], unlawful handling of hazardous waste [2], price fixing [3], underpaying employees [4], poor customer service [5][6], leaking private customer information [7], overcharging customers [8] and charging customers for damaged equipment after a hurricane [9]. Comcast has interfered with customers' internet access [10] and then manipulated FCC hearings on its conduct [11], hired family members of politicians to gain influence [12], and racially discriminated against employees [13], and has also donated to anti‑abortion funds [14] and subjected customers to rape and violence and the hands of its subcontractors [15].",
            "sources": {
                "1": "https://arstechnica.com/information-technology/2017/02/comcast-should-stop-claiming-it-has-fastest-internet-ad-board-rules/",
                "2": "https://www.oag.ca.gov/news/press-releases/attorney-general-kamala-d-harris-announces-2595-million-settlement-comcast-over",
                "3": "https://www.law360.com/articles/789414/comcast-asks-3rd-circ-to-ok-class-for-15-5m-deal",
                "4": "https://www.law360.com/articles/663278/nbcuniversal-gets-nod-for-6-4m-unpaid-intern-deal",
                "5": "http://www.dannfuria.com/comcast",
                "6": "http://www.businessinsider.com/comcast-customer-was-put-on-hold-until-comcast-closed-2014-8",
                "7": "https://docs.cpuc.ca.gov/PublishedDocs/Published/G000/M154/K457/154457136.PDF",
                "8": "https://www.mprnews.org/story/2018/12/21/minnesota-comcast-suit-overcharging-visa-card-promise",
                "9": "https://web.archive.org/web/20110629052940/http://abclocal.go.com/ktrk/story?section=news%2Flocal&id=6460278",
                "10": "https://web.archive.org/web/20150227151532/http://www.nbcnews.com/id/22560491/ns/technology_and_science-internet/t/fcc-probe-comcast-data-discrimination/",
                "11": "https://www.sfgate.com/business/article/Cable-giant-Comcast-hires-seat-warmers-to-pack-3226430.php",
                "12": "https://www.washingtonpost.com/wp-dyn/content/article/2006/03/06/AR2006030601594.html",
                "13": "https://web.archive.org/web/20181212135237/https://www.fiercetelecom.com/installer/comcast-pays-7-2m-to-settle-racial-discrimination-suit-by-chicago-techs",
                "14": "https://www.thebulwark.com/p/comcast-donation-to-desantis-anti-abortion-pac",
                "15": "https://stopthecap.com/2014/07/02/new-series-will-you-survive-a-comcast-service-call-answered-by-sketchy-subcontractors/"
            },
            "sourceNotes": {
                "1": "false advertising",
                "2": "unlawful handling of hazardous waste",
                "3": "engaged in price fixing",
                "4": "underpaid employees",
                "5": "poor customer service",
                "6": "poor customer service",
                "7": "leaked private customer information",
                "8": "overcharged customers",
                "9": "charged customers for damaged equipment after hurricane",
                "10": "interfered with customers' internet access",
                "11": "manipulated fcc hearings on its conduct",
                "12": "hires family members of politicians to gain influence",
                "13": "racial discrimination against employees",
                "14": "donated to anti-abortion fund",
                "15": "customers have suffered rape and violance by subcontractors"
            },
            "tags": [
                "entertainment",
                "anticompetitive practices",
                "deception",
                "unfair pay",
                "racial discrimination",
                "sexual harassment",
                "corruption",
                "privacy violations",
                "data breach",
                "environmental violations",
                "unsustainable practices"
            ],
            "score": 12,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Comcast.svg/250px-Comcast.svg.png",
            "siteUrl": "https://corporate.comcast.com/",
            "updatedAt": "2026-08-15T08:55:00.785Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Comcast"
        },
        "xfinity": {
            "key": "xfinity",
            "names": [
                "Xfinity"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "comcast"
            ],
            "updatedAt": "2026-08-16T13:23:39.423Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Xfinity",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Xfinity_2025.svg/250px-Xfinity_2025.svg.png",
            "siteUrl": "https://www.xfinity.com/"
        },
        "media-one": {
            "key": "media-one",
            "names": [
                "Media One"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "comcast"
            ],
            "updatedAt": "2026-08-16T13:23:39.853Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Media_One",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/b/bf/Media_one_logo.jpg"
        },
        "xumo": {
            "key": "xumo",
            "names": [
                "Xumo"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "comcast"
            ],
            "updatedAt": "2026-08-16T13:23:40.495Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Xumo",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/XUMO-logo-2022.svg/250px-XUMO-logo-2022.svg.png",
            "siteUrl": "http://www.xumo.com/"
        },
        "maine-mariners-(echl)": {
            "key": "maine-mariners-(echl)",
            "names": [
                "Maine Mariners (ECHL)"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "comcast"
            ],
            "updatedAt": "2026-08-16T13:23:40.869Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Maine_Mariners_(ECHL)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/thumb/d/dc/Maine_Mariners_%28ECHL%29_logo.svg/250px-Maine_Mariners_%28ECHL%29_logo.svg.png",
            "siteUrl": "https://www.marinersofmaine.com/"
        },
        "paciolan": {
            "key": "paciolan",
            "names": [
                "Paciolan"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "comcast"
            ],
            "updatedAt": "2026-08-16T13:23:41.124Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Paciolan",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Learfield_logo.png/250px-Learfield_logo.png",
            "siteUrl": "http://www.learfield.com/"
        },
        "philadelphia-flyers": {
            "key": "philadelphia-flyers",
            "names": [
                "Philadelphia Flyers"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "comcast"
            ],
            "updatedAt": "2026-08-16T13:23:41.686Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Philadelphia_Flyers",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/thumb/d/dc/Philadelphia_Flyers.svg/250px-Philadelphia_Flyers.svg.png"
        },
        "gritty": {
            "key": "gritty",
            "names": [
                "Gritty"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "comcast"
            ],
            "updatedAt": "2026-08-16T13:23:42.085Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Gritty",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/73/Gov._Wolf_Joins_Philadelphia_Flyers_Organization_to_Encourage_Pennsylvanians_to_%E2%80%98Take_Your_Shot%E2%80%99_%2851156977424%29_%28cropped%29.jpg/250px-Gov._Wolf_Joins_Philadelphia_Flyers_Organization_to_Encourage_Pennsylvanians_to_%E2%80%98Take_Your_Shot%E2%80%99_%2851156977424%29_%28cropped%29.jpg",
            "siteUrl": "https://www.nhl.com/flyers/fans/gritty"
        },
        "philadelphia-wings": {
            "key": "philadelphia-wings",
            "names": [
                "Philadelphia Wings"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "comcast"
            ],
            "updatedAt": "2026-08-16T13:23:42.314Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Philadelphia_Wings",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/thumb/8/8d/Philadelphia_Wings.svg/330px-Philadelphia_Wings.svg.png",
            "siteUrl": "https://wingslax.com/"
        },
        "philadelphia-fusion": {
            "key": "philadelphia-fusion",
            "names": [
                "Philadelphia Fusion"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "comcast"
            ],
            "updatedAt": "2026-08-16T13:23:43.079Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Philadelphia_Fusion",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/thumb/9/97/Philadelphia_Fusion_logo.svg/250px-Philadelphia_Fusion_logo.svg.png",
            "siteUrl": "https://fusion.overwatchleague.com/"
        },
        "nbcuniversal": {
            "key": "nbcuniversal",
            "names": [
                "NBCUniversal"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "comcast"
            ],
            "updatedAt": "2026-08-16T13:24:16.560Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/NBCUniversal",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/NBCUniversal_2026_Logo.svg/250px-NBCUniversal_2026_Logo.svg.png",
            "siteUrl": "https://nbcuniversal.com/"
        },
        "universal-pictures": {
            "key": "universal-pictures",
            "names": [
                "Universal Pictures"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "nbcuniversal"
            ],
            "updatedAt": "2026-08-16T13:30:29.106Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Universal_Pictures",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Universal_Pictures_logo.svg/250px-Universal_Pictures_logo.svg.png",
            "siteUrl": "https://universalpictures.com/"
        },
        "illumination": {
            "key": "illumination",
            "names": [
                "Illumination"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "nbcuniversal"
            ],
            "updatedAt": "2026-08-16T13:30:29.586Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Illumination_(company)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e3/Illumination_Entertainment_logo.svg/250px-Illumination_Entertainment_logo.svg.png",
            "siteUrl": "https://www.illumination.com/"
        },
        "focus-features": {
            "key": "focus-features",
            "names": [
                "Focus Features"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "nbcuniversal"
            ],
            "updatedAt": "2026-08-16T13:30:29.824Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Focus_Features",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/39/Focus_Features.svg/250px-Focus_Features.svg.png",
            "siteUrl": "http://focusfeatures.com/"
        },
        "dreamworks-animation": {
            "key": "dreamworks-animation",
            "names": [
                "DreamWorks Animation"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "nbcuniversal"
            ],
            "updatedAt": "2026-08-16T13:30:29.977Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/DreamWorks_Animation",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/thumb/f/ff/DreamWorks_Animation_SKG_logo_with_fishing_boy.svg/250px-DreamWorks_Animation_SKG_logo_with_fishing_boy.svg.png",
            "siteUrl": "http://dreamworks.com/"
        },
        "classic-media": {
            "key": "classic-media",
            "names": [
                "Classic Media"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "nbcuniversal"
            ],
            "updatedAt": "2026-08-16T13:30:30.446Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/DreamWorks_Classics",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1b/DreamWorks_Classics_logo.svg/250px-DreamWorks_Classics_logo.svg.png",
            "siteUrl": "https://www.dreamworks.com/classics"
        },
        "harvey-entertainment": {
            "key": "harvey-entertainment",
            "names": [
                "Harvey Entertainment"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "nbcuniversal"
            ],
            "updatedAt": "2026-08-16T13:30:31.158Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Harvey_Films",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/thumb/b/b8/Harvey_Entertainment_1994.svg/250px-Harvey_Entertainment_1994.svg.png",
            "siteUrl": "https://web.archive.org/web/20050403211432/http://www.classicmedia.tv/harvey/pageload/index.html"
        },
        "united-international-pictures": {
            "key": "united-international-pictures",
            "names": [
                "United International Pictures"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "nbcuniversal"
            ],
            "updatedAt": "2026-08-16T13:30:31.670Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/United_International_Pictures",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/United_International_Pictures_logo.svg/250px-United_International_Pictures_logo.svg.png",
            "siteUrl": "http://uip.com/"
        },
        "working-title-films": {
            "key": "working-title-films",
            "names": [
                "Working Title Films"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "nbcuniversal"
            ],
            "updatedAt": "2026-08-16T13:30:31.834Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Working_Title_Films",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/thumb/f/ff/Working_Title_Films_logo.png/250px-Working_Title_Films_logo.png",
            "siteUrl": "http://workingtitlefilms.com/"
        },
        "emka-ltd.": {
            "key": "emka-ltd.",
            "names": [
                "EMKA, Ltd."
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "nbcuniversal"
            ],
            "updatedAt": "2026-08-16T13:30:31.951Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/EMKA,_Ltd."
        },
        "snl-studios": {
            "key": "snl-studios",
            "names": [
                "SNL Studios"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "nbcuniversal"
            ],
            "updatedAt": "2026-08-16T13:30:32.122Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/SNL_Studios",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/thumb/1/17/Snlstudios.png/250px-Snlstudios.png"
        },
        "carnival-films": {
            "key": "carnival-films",
            "names": [
                "Carnival Films"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "nbcuniversal"
            ],
            "updatedAt": "2026-08-16T13:30:32.295Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Carnival_Films",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ad/Carnival_Films_logo.png/250px-Carnival_Films_logo.png",
            "siteUrl": "https://carnivalfilms.co.uk/"
        },
        "universal-studios-hollywood": {
            "key": "universal-studios-hollywood",
            "names": [
                "Universal Studios Hollywood"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "nbcuniversal"
            ],
            "updatedAt": "2026-08-16T13:30:32.788Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Universal_Studios_Hollywood",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/thumb/5/50/Universal_Studios_Hollywood_2023_logo.png/250px-Universal_Studios_Hollywood_2023_logo.png",
            "siteUrl": "https://www.universalstudioshollywood.com/"
        },
        "national-broadcasting-company": {
            "key": "national-broadcasting-company",
            "names": [
                "National Broadcasting Company"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "nbcuniversal"
            ],
            "updatedAt": "2026-08-16T13:30:32.956Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/NBC",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/NBC_logo_2022_%28vertical%29.svg/250px-NBC_logo_2022_%28vertical%29.svg.png",
            "siteUrl": "https://www.nbc.com/"
        },
        "nbc-studios": {
            "key": "nbc-studios",
            "names": [
                "NBC Studios"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "nbcuniversal"
            ],
            "updatedAt": "2026-08-16T13:30:33.246Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/NBC_Studios_(New_York_City)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/93/GE_Building_at_dusk.jpg/250px-GE_Building_at_dusk.jpg"
        },
        "bravo": {
            "key": "bravo",
            "names": [
                "Bravo"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "nbcuniversal"
            ],
            "updatedAt": "2026-08-16T13:30:33.525Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Bravo_(American_TV_network)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/22/Bravo_2024.svg/250px-Bravo_2024.svg.png",
            "siteUrl": "https://www.bravotv.com/"
        },
        "nbc-sports": {
            "key": "nbc-sports",
            "names": [
                "NBC Sports"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "nbcuniversal"
            ],
            "updatedAt": "2026-08-16T13:30:34.328Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/NBC_Sports",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/NBC_Sports_2023.svg/250px-NBC_Sports_2023.svg.png",
            "siteUrl": "https://www.nbcsports.com/"
        },
        "nbc-olympics-llc": {
            "key": "nbc-olympics-llc",
            "names": [
                "NBC Olympics, LLC"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "nbcuniversal"
            ],
            "updatedAt": "2026-08-16T13:30:34.572Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/NBC_Olympic_broadcasts",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5d/NBC_Olympics_2024.svg/250px-NBC_Olympics_2024.svg.png"
        },
        "nbcsn": {
            "key": "nbcsn",
            "names": [
                "NBCSN"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "nbcuniversal"
            ],
            "updatedAt": "2026-08-16T13:30:34.997Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/NBCSN",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/NBCSN_2025.svg/250px-NBCSN_2025.svg.png",
            "siteUrl": "https://www.nbcsports.com/"
        },
        "telemundo-deportes": {
            "key": "telemundo-deportes",
            "names": [
                "Telemundo Deportes"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "nbcuniversal"
            ],
            "updatedAt": "2026-08-16T13:30:35.202Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Telemundo_Deportes",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/73/Telemundo_Deportes_2022_vector_logo.svg/250px-Telemundo_Deportes_2022_vector_logo.svg.png"
        },
        "affiliate-relations": {
            "key": "affiliate-relations",
            "names": [
                "Affiliate Relations"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "nbcuniversal"
            ],
            "updatedAt": "2026-08-16T13:30:35.437Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/List_of_NBC_television_affiliates_(table)"
        },
        "lxtv": {
            "key": "lxtv",
            "names": [
                "LXTV"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "nbcuniversal"
            ],
            "updatedAt": "2026-08-16T13:30:35.934Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/LXTV",
            "siteUrl": "http://www.lxtv.com/"
        },
        "sky-group": {
            "key": "sky-group",
            "names": [
                "Sky Group"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "nbcuniversal"
            ],
            "updatedAt": "2026-08-16T13:30:36.124Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Sky_Group",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/thumb/d/db/Sky_logo_2025.svg/250px-Sky_logo_2025.svg.png",
            "siteUrl": "https://www.skygroup.sky/"
        },
        "love-productions": {
            "key": "love-productions",
            "names": [
                "Love Productions"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "nbcuniversal"
            ],
            "updatedAt": "2026-08-16T13:30:36.473Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Love_Productions",
            "siteUrl": "https://loveproductions.co.uk/"
        },
        "sky-q": {
            "key": "sky-q",
            "names": [
                "Sky Q"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "nbcuniversal"
            ],
            "updatedAt": "2026-08-16T13:30:36.650Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Sky_Q",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/thumb/7/72/Sky_q_logo.svg/250px-Sky_q_logo.svg.png"
        },
        "amstrad": {
            "key": "amstrad",
            "names": [
                "Amstrad"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "nbcuniversal"
            ],
            "updatedAt": "2026-08-16T13:30:36.723Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Amstrad",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/Amstrad_logo.svg/250px-Amstrad_logo.svg.png",
            "siteUrl": "https://web.archive.org/web/20190125111043/http://www.amstrad.com/"
        },
        "sky-studios": {
            "key": "sky-studios",
            "names": [
                "Sky Studios"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "nbcuniversal"
            ],
            "updatedAt": "2026-08-16T13:30:36.811Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Sky_Studios",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/thumb/f/f3/Sky_Studios_Logo_2020_%28production_company%29.png/250px-Sky_Studios_Logo_2020_%28production_company%29.png",
            "siteUrl": "https://www.skygroup.sky/skystudios"
        },
        "jupiter-entertainment": {
            "key": "jupiter-entertainment",
            "names": [
                "Jupiter Entertainment"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "nbcuniversal"
            ],
            "updatedAt": "2026-08-16T13:30:37.010Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Jupiter_Entertainment",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d8/Jupiter_Entertainmnet_Logo_designed_by_Tommy_Stokes_2012.jpg/250px-Jupiter_Entertainmnet_Logo_designed_by_Tommy_Stokes_2012.jpg",
            "siteUrl": "http://jupiterent.com/"
        },
        "now-(sky)": {
            "key": "now-(sky)",
            "names": [
                "Now (Sky)"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "nbcuniversal"
            ],
            "updatedAt": "2026-08-16T13:30:37.189Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Now_(Sky)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0d/Now_logo.svg/250px-Now_logo.svg.png",
            "siteUrl": "https://nowtv.com/"
        },
        "the-cloud": {
            "key": "the-cloud",
            "names": [
                "The Cloud"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "nbcuniversal"
            ],
            "updatedAt": "2026-08-16T13:30:37.443Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/The_Cloud_(company)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/4/46/The_Cloud_logo.png",
            "siteUrl": "https://thecloud.net/"
        },
        "challenge": {
            "key": "challenge",
            "names": [
                "Challenge"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "nbcuniversal"
            ],
            "updatedAt": "2026-08-16T13:30:37.490Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Challenge_(TV_channel)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/thumb/f/fb/Challenge_logo_2016.png/250px-Challenge_logo_2016.png",
            "siteUrl": "https://www.sky.com/watch/channel/challenge"
        },
        "nbc-news": {
            "key": "nbc-news",
            "names": [
                "NBC News"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "nbcuniversal"
            ],
            "updatedAt": "2026-08-16T13:30:37.613Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/NBC_News",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f0/NBC_News_%282023%29.svg/250px-NBC_News_%282023%29.svg.png",
            "siteUrl": "http://nbcnews.com/"
        },
        "hayu": {
            "key": "hayu",
            "names": [
                "Hayu"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "nbcuniversal"
            ],
            "updatedAt": "2026-08-16T13:30:37.873Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Hayu_(subscription_service)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/69/Hayu_Logo_Coral_svg.svg/250px-Hayu_Logo_Coral_svg.svg.png",
            "siteUrl": "https://www.hayu.com/"
        },
        "peacock": {
            "key": "peacock",
            "names": [
                "Peacock"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment"
            ],
            "score": 12,
            "ownedBy": [
                "nbcuniversal"
            ],
            "updatedAt": "2026-08-16T13:30:37.970Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Peacock_(streaming_service)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/20/NBCUniversal_Peacock_Logo_%282026%29.svg/250px-NBCUniversal_Peacock_Logo_%282026%29.svg.png",
            "siteUrl": "https://www.peacocktv.com/"
        },
        "ups": {
            "key": "ups",
            "names": [
                "UPS",
                "United Parcel Service, Inc.",
                "American Messenger Company",
                "Merchants Parcel Delivery"
            ],
            "comment": "UPS is a American logistics company that has leaked customer information in a data breach [1], overworked [2] and underpaid employees [3], diverted employee wages to undisclosed charities [4], discriminated against disabled employees [5], failed to provide adequate sick leave during COVID [6], discriminated against employees on the basis of religion [7], and engaged in racial discrimination against employees [8]. Employees have also suffered sexual harassment at UPS [9][10].",
            "sources": {
                "1": "https://www.techradar.com/pro/ups-discloses-data-breach-after-exposed-customer-info-used-in-sms-phishing",
                "2": "https://www.law360.com/articles/2260541/ups-hit-with-worker-suit-over-lack-of-bathrooms",
                "3": "https://www.cnbc.com/2025/12/15/new-york-lawsuit-ups-christmas-wage-steal-seasonal-workers.html",
                "4": "https://www.huffingtonpost.co.uk/entry/ups-to-pay-1-million-to-workers-over-charitable-paycheck-deductions_n_61b78e76e4b00aca716a614f",
                "5": "https://www.eeoc.gov/newsroom/ups-pay-2-million-resolve-nationwide-eeoc-disability-discrimination-claims",
                "6": "https://web.archive.org/web/20210218110714/https://www.nytimes.com/2020/03/21/business/coronavirus-ups-fedex-xpo-workers.html",
                "7": "https://www.eeoc.gov/newsroom/ups-pay-49-million-settle-eeoc-religious-discrimination-suit",
                "8": "https://www.lieffcabraser.com/employment/ups/",
                "9": "https://storage.courtlistener.com/recap/gov.uscourts.ncmd.97870/gov.uscourts.ncmd.97870.41.0.pdf",
                "10": "https://www.eeoc.gov/newsroom/united-parcel-service-settles-eeoc-sexual-harassment-charge"
            },
            "sourceNotes": {
                "1": "leaked customer information in data breach",
                "2": "overworking employees",
                "3": "underpaid employees",
                "4": "diverted employee wages to undisclosed charities",
                "5": "discriminated against disabled employees",
                "6": "failed to give employees adequate sick leave during covid",
                "7": "discriminated against employees on the basis of religion",
                "8": "racial discimination against employees",
                "9": "employees suffered sexual harassment",
                "10": "employees suffered sexual harassment"
            },
            "tags": [
                "logistics",
                "data breach",
                "privacy violations",
                "unfair pay",
                "poor working conditions",
                "racial discrimination",
                "sexual harassment"
            ],
            "score": 32,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/United_Parcel_Service_logo_2014.svg/250px-United_Parcel_Service_logo_2014.svg.png",
            "siteUrl": "https://www.ups.com/",
            "updatedAt": "2026-08-16T13:35:53.509Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/United_Parcel_Service"
        },
        "urban-decay": {
            "key": "urban-decay",
            "names": [
                "Urban Decay"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "cosmetics"
            ],
            "score": 15,
            "ownedBy": [
                "l'oreal"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/Urban_Decay_logo.svg/250px-Urban_Decay_logo.svg.png",
            "siteUrl": "https://www.urbandecay.com/",
            "updatedAt": "2026-08-16T13:35:53.509Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Urban_Decay_(cosmetics)"
        },
        "vans": {
            "key": "vans",
            "names": [
                "Vans",
                "Van Doren Rubber Company"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fotwear",
                "clothing"
            ],
            "score": 20,
            "ownedBy": [
                "vf-corporation"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/Vans_%28brand%29_logo.svg/250px-Vans_%28brand%29_logo.svg.png",
            "siteUrl": "https://www.vans.com/",
            "updatedAt": "2026-08-20T14:15:03.519Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Vans"
        },
        "virgin-media": {
            "key": "virgin-media",
            "names": [
                "Virgin Media",
                "Virgin Media Limited"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "telecommunications"
            ],
            "score": 34,
            "ownedBy": [
                "o2"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/32/Virgin_Media.svg/250px-Virgin_Media.svg.png",
            "siteUrl": "https://www.virginmedia.com/",
            "updatedAt": "2026-08-20T14:15:03.519Z",
            "error": "Error [ERR_HTTP2_INVALID_SESSION]: The session has been destroyed",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Virgin_Media"
        },
        "verizon": {
            "key": "verizon",
            "names": [
                "Verizon",
                "Verizon Communications",
                "Verizon Communications Inc.",
                "Bell Atlantic Corporation",
                "VZ"
            ],
            "comment": "Verizon is a US telecommunications company that has committed tax avoidance [1], overcharged customers [2], sold customer data without consent [3][4], illegally shared customers' location data [5], leaked customer data in a data breach [6], and committed environmental violations [7]. Verizon has collaborated with NSA to spy on phone calls of millions of people [8], and has several billion in US military contracts [9].",
            "sources": {
                "1": "https://web.archive.org/web/20050917015111/http://www.ago.state.ms.us/news/index.php?use=may9-2005",
                "2": "https://abc7.com/post/class-action-lawsuit-verizon-wireless-settlement/14279373/",
                "3": "https://topclassactions.com/lawsuit-settlements/lawsuit-news/verizon-class-action-alleges-wireless-carrier-sold-customer-data-without-consent/",
                "4": "https://arstechnica.com/tech-policy/2025/09/court-rejects-verizon-claim-that-selling-location-data-without-consent-is-legal/",
                "5": "https://www.reuters.com/legal/litigation/us-court-upholds-verizon-469-million-fine-over-location-data-2025-09-10/",
                "6": "https://mashable.com/article/verizon-data-breach",
                "7": "https://da.lacounty.gov/media/news/verizon-wireless-pay-77-million-settle-environmental-violations-following-statewide",
                "8": "https://www.theguardian.com/world/2013/jun/06/nsa-phone-records-verizon-court-order",
                "9": "https://www.washingtontechnology.com/rankings/top-100/2024/"
            },
            "sourceNotes": {
                "1": "tax avoidance",
                "2": "overcharged customers",
                "3": "sold customer data without consent",
                "4": "sold customer data without consent",
                "5": "illegally shared customers location data",
                "6": "leaked customer data in breach",
                "7": "environmental violations",
                "8": "collaborated with NSA to spy on phone calls",
                "9": "several billion in us military contracts"
            },
            "tags": [
                "telecommunications",
                "tech",
                "tax avoidance",
                "privacy violations",
                "data breach",
                "environmental violations",
                "deception"
            ],
            "score": 38,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/83/Verizon_2024.svg/250px-Verizon_2024.svg.png",
            "siteUrl": "https://verizon.com/",
            "updatedAt": "2026-08-20T15:22:43.592Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Verizon"
        },
        "victoria's-secret": {
            "key": "victoria's-secret",
            "names": [
                "Victoria's Secret",
                "Victoria's Secret & Co.",
                "VSXY"
            ],
            "comment": "",
            "sources": {
                "1": "https://www.law360.com/articles/953170/victoria-s-secret-gets-initial-ok-on-12m-clerk-wage-deal",
                "2": "https://www.nytimes.com/2020/02/03/business/victorias-secret-l-brands-leslie-wexner.html",
                "3": "https://www.nytimes.com/2020/02/01/business/victorias-secret-razek-harassment.html",
                "4": "https://www.latimes.com/archives/la-xpm-2002-aug-14-fi-rup14.4-story.html",
                "5": "https://wreg.com/news/woman-says-she-was-racially-profiled-at-victorias-secret-in-collierville/",
                "6": "https://www.hollywoodreporter.com/news/victorias-secret-backlash-ed-razeks-comments-trans-size-models-spark-outrage-1160446",
                "7": "https://www.aspi.org.au/report/uyghurs-for-sale",
                "8": "https://www.abc.net.au/news/2020-03-02/aspi-uyghur-china-forced-labour-report/12017650",
                "9": "https://houseandwhips.com/is-les-wexner-jewish/",
                "10": "https://web.archive.org/web/20130729114046/http://articles.chicagotribune.com/2003-03-05/news/0303050263_1_trademark-dilution-act-brand-famous-mark",
                "11": "https://www.nytimes.com/2019/07/25/business/jeffrey-epstein-wexner-victorias-secret.html"
            },
            "sourceNotes": {
                "1": "underpaid employees",
                "2": "verbal abuse of employees",
                "3": "racist and discriminatory practices",
                "4": "racist and discriminatory practices",
                "5": "racist and discriminatory practices",
                "6": "discriminated against trans and plus size models",
                "7": "complicity in Uyghur forced labour",
                "8": "complicity in Uyghur forced labour",
                "9": "connections to Israel",
                "10": "connection to Jeffrey Epstein",
                "11": "connection to Jeffrey Epstein"
            },
            "tags": [
                "clothing"
            ],
            "score": null,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/f/f1/Victoria%E2%80%99s_Secret_%28logo%2C_2021%29.svg/250px-Victoria%E2%80%99s_Secret_%28logo%2C_2021%29.svg.png?utm_source=en.wikipedia.org&utm_campaign=parser&utm_content=thumbnail",
            "siteUrl": "http://victoriassecret.com/",
            "updatedAt": "2026-08-20T15:22:43.592Z",
            "error": "TypeError: Cannot read properties of undefined (reading 'url')"
        },
        "visa": {
            "key": "visa",
            "names": [
                "Visa",
                "Visa Inc.",
                "V"
            ],
            "comment": "Visa is an American payment processing company that has repeatedly engaged in anticompetitive, monopolistic practices [1][2][3][4][5][6][7].",
            "sources": {
                "1": "https://www.prnewswire.com/news-releases/atm-operators-file-antitrust-lawsuit-against-visa-and-mastercard-131605078.html",
                "2": "https://web.archive.org/web/20240915125940/https://www.justice.gov/archive/atr/public/press_releases/1998/1974.htm",
                "3": "https://web.archive.org/web/20110727192417/http://marketplace.publicradio.org/display/web/2010/10/04/pm-visa-mastercard-settlement-means-more-flexibility-for-retailers/",
                "4": "https://web.archive.org/web/20201106182856/https://www.nbcnews.com/businessmain/judge-approves-credit-card-swipe-fee-settlement-2D11741836",
                "5": "https://web.archive.org/web/20240924184007/https://www.wsj.com/finance/regulation/justice-department-sues-visa-alleges-illegal-monopoly-in-debit-card-payments-a9ecd39c",
                "6": "https://web.archive.org/web/20181215224703/https://www.accc.gov.au/media-release/visa-ordered-to-pay-18-million-penalty-for-anti-competitive-conduct-following-accc-action",
                "7": "https://web.archive.org/web/20180704124002/https://www.reuters.com/article/us-eu-payments-cards-idUSKBN0JV2SV20141218"
            },
            "sourceNotes": {
                "1": "anticompetetive monopolistic practices",
                "2": "anticompetetive monopolistic practices",
                "3": "anticompetetive monopolistic practices",
                "4": "anticompetetive monopolistic practices",
                "5": "anticompetetive monopolistic practices",
                "6": "anticompetetive monopolistic practices",
                "7": "anticompetetive monopolistic practices"
            },
            "tags": [
                "finance",
                "anticompetitive practices"
            ],
            "score": 44,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/5/5c/Visa_Inc._logo_%282021%E2%80%93present%29.svg",
            "siteUrl": "https://visa.com/",
            "updatedAt": "2026-08-26T12:38:18.568Z",
            "error": "TypeError: Cannot read properties of undefined (reading 'url')"
        },
        "walgreens": {
            "key": "walgreens",
            "names": [
                "Walgreens",
                "Walgreen Drug Co.",
                "Walgreen Drug Stores",
                "Walgreen's"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "pharmacy",
                "consumer goods",
                "retail"
            ],
            "score": null,
            "ownedBy": [
                "sycamore-partners"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c7/Walgreens_2020_primary_logo.svg/250px-Walgreens_2020_primary_logo.svg.png",
            "siteUrl": "http://walgreens.com/",
            "updatedAt": "2026-08-28T05:03:14.760Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Walgreens"
        },
        "waterstones": {
            "key": "waterstones",
            "names": [
                "Waterstones",
                "Waterstones Booksellers Limited"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "books",
                "retail"
            ],
            "score": null,
            "ownedBy": [
                "elliott-management-corporation"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/thumb/2/2c/Waterstones_logo.png/250px-Waterstones_logo.png",
            "siteUrl": "https://www.waterstones.com/",
            "updatedAt": "2026-08-28T05:05:17.643Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Waterstones"
        },
        "wayfair": {
            "key": "wayfair",
            "names": [
                "Wayfair",
                "Wayfair Inc.",
                "CSN Stores",
                "W"
            ],
            "comment": "Wayfair is an American e-commerce company that has engaged in deceptive pricing practices [1] and violated air pollution regulations [2]. The company has also supplied goods to child migrant detention centers [3][4].",
            "sources": {
                "1": "https://www.gov.uk/cma-cases/wayfair-consumer-protection-enforcement-case",
                "2": "https://ww2.arb.ca.gov/wayfair-llc-settlement",
                "3": "https://www.cbsnews.com/news/wayfair-employees-plan-walkout-after-companys-sales-to-detention-centers/",
                "4": "https://gizmodo.com/wayfair-ceo-refuses-to-stop-furnishing-concentration-ca-1835850790"
            },
            "sourceNotes": {
                "1": "deceptive pricing",
                "2": "air pollution violation",
                "3": "provided goods to child migrant detention centres",
                "4": "provided goods to child migrant detention centres"
            },
            "tags": [
                "deception",
                "environmental violations",
                "child labour"
            ],
            "score": 40,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/3/34/Wayfair_2024_logo.svg/250px-Wayfair_2024_logo.svg.png?utm_source=en.wikipedia.org&utm_campaign=parser&utm_content=thumbnail",
            "siteUrl": "http://wayfair.com/",
            "updatedAt": "2026-08-28T05:07:01.867Z"
        },
        "waze": {
            "key": "waze",
            "names": [
                "Waze",
                "Waze Mobile Ltd",
                "FreeMap Israel"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech"
            ],
            "score": 20,
            "ownedBy": [
                "google"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/thumb/b/bc/Logo_for_waze.svg/250px-Logo_for_waze.svg.png",
            "siteUrl": "https://waze.com/",
            "updatedAt": "2026-08-28T05:21:56.695Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Waze"
        },
        "weetabix": {
            "key": "weetabix",
            "names": [
                "Weetabix"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 15,
            "ownedBy": [
                "post-holdings"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/thumb/a/ab/Weetabix_logo.png/250px-Weetabix_logo.png",
            "siteUrl": "https://weetabix.co.uk/",
            "updatedAt": "2026-08-28T05:25:03.308Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Weetabix"
        },
        "wells-fargo": {
            "key": "wells-fargo",
            "names": [
                "Wells Fargo",
                "Wells Fargo & Company",
                "WFC"
            ],
            "comment": "Wells Fargo is an American bank that has engaged in misleading fees [1][2], predatory sales practices [3][4], and invested in private for-profit prisons [5]. The company has also mismanaged loans and mortgages [6], fired whistleblowers [7][8], foreclosed homes due to software glitches [9][10], and perpetuated racism in employment [11][12] and mortgage approval processes [13][14][15] as well as sexism in employment practices [16][17].",
            "sources": {
                "1": "https://www.inquirer.com/philly/columnists/jeff_gelles/20100815_Consumer_10_0__How_Wells_Fargo_held_up_debit-card_customers.html",
                "2": "https://www.latimes.com/archives/la-xpm-2010-aug-10-la-fi-wells-20100810-story.html",
                "3": "https://www.scu.edu/ethics/focus-areas/business-ethics/resources/wells-fargo-banking-scandal/",
                "4": "https://www.reuters.com/article/business/wells-fargo-to-pay-3-billion-to-us-admits-pressuring-workers-in-fake-account-idUSKBN20F2KM/",
                "5": "https://www.salon.com/2012/04/11/wells_fargos_prison_cash_cow/",
                "6": "https://www.consumerfinance.gov/archive/newsroom/cfpb-orders-wells-fargo-to-pay-37-billion-for-widespread-mismanagement-of-auto-loans-mortgages-and-deposit-accounts/",
                "7": "https://natlawreview.com/article/osha-orders-wells-fargo-to-pay-22-million-to-wrongfully-discharged-whistleblower",
                "8": "https://www.usatoday.com/story/money/2022/09/02/wells-fargo-22-million-whistleblower-retaliation/7971488001/",
                "9": "https://ecweb.ecer.com/topic/en/detail-305329-wells_fargo_software_glitch_causes_wrongful_foreclosures_hundreds_displaced.html",
                "10": "https://www.cbsnews.com/video/wells-fargo-blames-calculation-error-after-hundreds-lose-homes-to-foreclosure/",
                "11": "https://www.dol.gov/newsroom/releases/ofccp/ofccp20200824",
                "12": "https://news.bloomberglaw.com/daily-labor-report/wells-fargo-to-pay-7-8-million-to-settle-hiring-bias-claims",
                "13": "https://www.baltimoresun.com/2012/07/12/wells-fargo-agrees-to-pay-175m-settlement-in-pricing-discrimination-suit/",
                "14": "https://www.reuters.com/article/hotStocksNews/idUSTRE56U6Q920090731",
                "15": "https://www.bloomberg.com/graphics/2022-wells-fargo-black-home-loan-refinancing/",
                "16": "https://www.wsj.com/articles/at-wells-fargo-discontent-simmers-among-female-executives-1535707801",
                "17": "https://www.cnbc.com/2018/08/31/wells-fargo-investigating-reports-of-gender-bias-in-wealth-division.html"
            },
            "sourceNotes": {
                "1": "misleading fees",
                "2": "misleading fees",
                "3": "predatory sales practices",
                "4": "predatory sales practices",
                "5": "invested in private for-profit prisons",
                "6": "predatory and mismanaged loans and mortgages",
                "7": "fired employee for whistleblowing on fraudulent practices",
                "8": "fired employee for whistleblowing on fraudulent practices",
                "9": "foreclosed hundreds of families' homes due to software glitch",
                "10": "foreclosed hundreds of families' homes due to software glitch",
                "11": "racism in employment practices",
                "12": "racism in employment practices",
                "13": "racism in mortgage approval processes",
                "14": "racism in mortgage approval processes",
                "15": "racism in mortgage approval processes",
                "16": "sexism in employment practices",
                "17": "sexism in employment practices"
            },
            "tags": [
                "finance",
                "bank",
                "deception",
                "racial discrimination",
                "gender discrimination"
            ],
            "score": 20,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/e/e2/Wells_Fargo_Logo_%282020%29.svg",
            "siteUrl": "http://wellsfargo.com/",
            "updatedAt": "2026-08-28T05:27:07.604Z"
        },
        "wendy's": {
            "key": "wendy's",
            "names": [
                "Wendy's",
                "The Wendy's Company",
                "Wendy's International, LLC",
                "WEN"
            ],
            "comment": "Wendy's is an American fast‑food chain that has refused to support agricultural workers via the Fair Food Program [1][2], engaged in disability and age discrimination [3], and has been accused of underpaying employees and refusing them breaks [4][5]. The company has also sold unsafe food, including E. coli‑contaminated products [6][7], violated child labour laws [8], and faced allegations of sexual harassment of employees [9].",
            "sources": {
                "1": "https://www.fastcompany.com/90736978/the-stakes-are-nothing-less-than-life-and-death-why-farmworkers-are-marching-against-wendys",
                "2": "https://www.business-humanrights.org/en/latest-news/coalition-of-immokalee-workers-calls-on-delivery-companies-to-drop-wendys-until-it-joins-the-fair-food-program",
                "3": "https://www.eeoc.gov/newsroom/eeoc-sues-wendys-disability-and-age-discrimination",
                "4": "https://www.law360.com/articles/2262247/wendy-s-to-pay-4m-to-settle-colo-wage-claims",
                "5": "https://www.law360.com/articles/220629/wendy-s-to-settle-calif-labor-suit-for-1-5m",
                "6": " https://finance.yahoo.com/healthcare/articles/woman-says-wendy-burger-led-090000534.html",
                "7": "https://nypost.com/2022/08/23/wendys-e-coli-outbreak-sickens-more-than-100-as-lawsuits-pile-up/",
                "8": "https://www.mass.gov/news/wendys-resolves-child-labor-law-violations-at-massachusetts-locations",
                "9": "https://www.qsrmagazine.com/story/wendys-franchisee-ordered-to-pay-7-1m-after-accusations-of-harassment-and-ppp-fraud/"
            },
            "sourceNotes": {
                "1": "refused to support agricultural workers via the Fair Food Program",
                "2": "refused to support agricultural workers via the Fair Food Program",
                "3": "disability and age discrimination",
                "4": "underpaid and refused breaks to employees",
                "5": "underpaid and refused breaks to employees",
                "6": "sold unsafe food",
                "7": "sold unsafe food containing E Coli bacteria",
                "8": "violation of child labour laws",
                "9": "sexual harassment of employees"
            },
            "tags": [
                "food",
                "fast food",
                "restaurant",
                "unfair pay",
                "poor working conditions",
                "unsafe practices",
                "child labour",
                "sexual harassment"
            ],
            "score": 34,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/3/32/Wendy%27s_full_logo_2012.svg/250px-Wendy%27s_full_logo_2012.svg.png?utm_source=en.wikipedia.org&utm_campaign=parser&utm_content=thumbnail",
            "siteUrl": "http://wendys.com/",
            "updatedAt": "2026-08-28T06:40:14.710Z",
            "error": "TypeError: Cannot read properties of undefined (reading 'url')"
        },
        "west-elm": {
            "key": "west-elm",
            "names": [
                "West Elm"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "home",
                "retail"
            ],
            "score": 42,
            "ownedBy": [
                "williams-sonoma"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/06/West_Elm_logo.svg",
            "siteUrl": "http://westelm.com/",
            "updatedAt": "2026-08-31T14:00:05.964Z"
        },
        "western-union": {
            "key": "western-union",
            "names": [
                "Western Union",
                "Western Union Company",
                "WU"
            ],
            "comment": "Western Union is an American money transfer company that has engaged in anticompetitive monopolistic practices [1][2]. It has also failed in anti‑money laundering practices [3][4][5] and defrauded customers [6].",
            "sources": {
                "1": "https://www.economist.com/news/business-and-finance/21650598-western-union-and-moneygrams-proposed-merger-good-news-shareholders-less-so",
                "2": "https://www.ifad.org/documents/36783902/4a5640d9-e944-4a8c-8007-a1bc461416e6",
                "3": "https://www.justice.gov/opa/pr/western-union-admits-anti-money-laundering-and-consumer-fraud-violations-forfeits-586-million",
                "4": "http://www.irishtimes.com/business/economy/central-bank-fines-western-union-1-75m-1.2218236",
                "5": "https://openclassactions.com/settlements/western-union-fraud-victims-remission-phase-3.php",
                "6": "https://www.yahoo.com/news/western-union-defrauded-customers-feds-172025261.html"
            },
            "sourceNotes": {
                "1": "anticompetetive monopolistic practices",
                "2": "anticompetetive monopolistic practices",
                "3": "failures in anti-money laundering practices",
                "4": "failures in anti-money laundering practices",
                "5": "failures in anti-money laundering practices",
                "6": "defrauded customers"
            },
            "tags": [
                "finance",
                "anticompetitive practices",
                "corruption",
                "deception"
            ],
            "score": 42,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1c/Western_Union_current_logo.svg/250px-Western_Union_current_logo.svg.png",
            "siteUrl": "http://westernunion.com/",
            "updatedAt": "2026-08-31T14:01:06.150Z",
            "error": "TypeError: Cannot read properties of undefined (reading 'key')",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Western_Union"
        },
        "wetzel's-pretzels": {
            "key": "wetzel's-pretzels",
            "names": [
                "Wetzel's Pretzels",
                "Wetzel's"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "fast food"
            ],
            "score": 47,
            "ownedBy": [
                "mty-food-group"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/thumb/d/d3/Wetzel%27s_Pretzels_logo.png/250px-Wetzel%27s_Pretzels_logo.png",
            "siteUrl": "https://www.wetzels.com/",
            "updatedAt": "2026-08-31T15:07:15.154Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Wetzel's_Pretzels"
        },
        "whataburger": {
            "key": "whataburger",
            "names": [
                "Whataburger"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food",
                "fast food"
            ],
            "score": null,
            "ownedBy": [
                "bdt-&-msd-partners"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/94/Whataburger_logo.svg/250px-Whataburger_logo.svg.png",
            "siteUrl": "http://whataburger.com/",
            "updatedAt": "2026-08-31T15:09:08.051Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Whataburger"
        },
        "whsmith": {
            "key": "whsmith",
            "names": [
                "WHSmith",
                "WH Smith plc",
                "Pollquote Limited",
                "New WH Smith plc",
                "SMWH"
            ],
            "comment": "WHSmith is a British retailer that has failed to pay minimum wage [1][2][3].",
            "sources": {
                "1": "https://www.bbc.co.uk/news/business-65968986",
                "2": "https://www.reuters.com/world/uk/uk-fines-wh-smith-ms-others-not-paying-minimum-wage-2023-06-20/",
                "3": "https://www.gov.uk/government/news/more-than-200-companies-named-for-not-paying-staff-minimum-wage"
            },
            "sourceNotes": {
                "1": "failed to pay minimum wage",
                "2": "failed to pay minimum wage",
                "3": "failed to pay minimum wage"
            },
            "tags": [
                "retail",
                "unfair pay"
            ],
            "score": 46,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WHSmith_logo.svg/250px-WHSmith_logo.svg.png",
            "siteUrl": "http://whsmithplc.co.uk/",
            "updatedAt": "2026-08-31T15:10:20.941Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/WHSmith"
        },
        "wickes": {
            "key": "wickes",
            "names": [
                "Wickes",
                "Wickes Group plc",
                "WIX"
            ],
            "comment": "Wickes is a British home improvement retailer that has been reported to provide unacceptably poor quality kitchen fittings [1][2]. The company has also failed to pay minimum wage to its workers [3].",
            "sources": {
                "1": "https://www.theguardian.com/money/2023/nov/08/wickes-wont-pay-up-for-causing-my-kitchen-chaos",
                "2": "https://www.theguardian.com/money/2026/feb/22/wickes-kitchen-fitting-complaint",
                "3": "https://www.gov.uk/government/news/over-500-companies-named-for-not-paying-minimum-wage"
            },
            "sourceNotes": {
                "1": "provides unnaceptably poor quality kitchen fittings",
                "2": "provides unnaceptably poor quality kitchen fittings",
                "3": "failed to pay minimum wage"
            },
            "tags": [
                "retail",
                "home",
                "unfair pay",
                "poor working conditions"
            ],
            "score": 45,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/Wickes_logo.svg/250px-Wickes_logo.svg.png",
            "siteUrl": "https://www.wickes.co.uk/",
            "updatedAt": "2026-08-31T15:27:32.833Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Wickes"
        },
        "wilko": {
            "key": "wilko",
            "names": [
                "Wilko",
                "Wilko.com",
                "Wilko.com Limited"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 44,
            "ownedBy": [
                "the-range"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/thumb/d/d3/Wilko.svg/250px-Wilko.svg.png",
            "siteUrl": "https://www.wilko.com/",
            "updatedAt": "2026-08-31T15:34:51.353Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Wilko"
        },
        "williams-sonoma": {
            "key": "williams-sonoma",
            "names": [
                "Williams-Sonoma",
                "Williams Sonoma",
                "Williams-Sonoma, Inc."
            ],
            "comment": "Williams-Sonoma is an American company that has been accused of false advertising [1][2] and misleading advertising [3], and has sold unsafe products [4][5]. The company has also faced allegations of race and sex discrimination [6] and has underpaid workers [7].",
            "sources": {
                "1": "https://web.archive.org/web/20200404085519/https://www.consumer.ftc.gov/blog/2020/04/williams-sonoma-made-usa",
                "2": "https://web.archive.org/web/20240426202303/https://apnews.com/article/williams-sonoma-fine-ftc-made-usa-10313984e90fa206d219ed0546a2b9a2",
                "3": "https://retailboss.co/judge-denies-williams-sonomas-request-in-class-action-over-allegedly-misleading-bedding-claims/",
                "4": "https://www.cpsc.gov/Newsroom/News-Releases/2013/Williams-Sonoma-Agrees-to-987500-Civil-Penalty-Significant-Internal-Compliance-Improvements-for-Failure-to-Report-Defective-Pottery-Barn-Wooden-Hammock-Stands",
                "5": "https://www.cpsc.gov/Newsroom/News-Releases/2015/Williams-Sonoma-Agrees-to-Pay-700000-Civil-Penalty-for-Failure-to-Report-Defective-Pottery-Barn-Kids-Roman-Shades",
                "6": "https://aflegal.org/press-release/america-first-legal-slams-williams-sonoma-inc-for-illegal-race-and-sex-discrimination-files-federal-civil-rights-complaint/",
                "7": "https://www.law360.com/articles/841937/williams-sonoma-s-1-2m-security-check-suit-deal-gets-nod"
            },
            "sourceNotes": {
                "1": "false advertising",
                "2": "false advertising",
                "3": "misleading advertising",
                "4": "sold unsafe products",
                "5": "sold unsafe products",
                "6": "race and sex discrimination",
                "7": "underpaid workers"
            },
            "tags": [
                "retail",
                "home",
                "deception",
                "unsafe practices",
                "unfair pay",
                "racial discrimination",
                "gender discrimination"
            ],
            "score": 42,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/30/Williams_Sonoma_logo.svg/250px-Williams_Sonoma_logo.svg.png",
            "siteUrl": "https://www.williams-sonoma.com/",
            "updatedAt": "2026-08-31T15:35:39.790Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Williams_Sonoma"
        },
        "rejuvenation": {
            "key": "rejuvenation",
            "names": [
                "Rejuvenation"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "home"
            ],
            "score": 42,
            "ownedBy": [
                "williams-sonoma"
            ],
            "updatedAt": "2026-08-31T16:00:41.122Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Rejuvenation_(company)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f9/Rejuvenation_%28lighting_and_hardware%29_logo.png/250px-Rejuvenation_%28lighting_and_hardware%29_logo.png",
            "siteUrl": "http://www.rejuvenation.com/"
        },
        "xiaomi": {
            "key": "xiaomi",
            "names": [
                "Xiaomi",
                "Xiaomi Corporation",
                "小米",
                "小米集团"
            ],
            "comment": "Xiaomi is a Chinese technology company that has been accused of engaging in corruption [1], unfair repair practices [2], environmental violations in its supply chain [3], and selling phones with secret censorship software [4]. The company has also been reported to track customers' phone usage without consent [5][6][7][8] and to participate in Uyghur forced labour [9].",
            "sources": {
                "1": "https://www.gizmochina.com/2024/06/15/xiaomi-fires-regional-managers-western-europe-latin-america/",
                "2": "https://en.agcm.it/en/media/press-releases/2022/7/PS12268",
                "3": "https://www.ft.com/content/7dfeb4d6-5fef-11e8-9334-2218e7146b04",
                "4": "https://www.telegraph.co.uk/technology/2021/09/22/stop-using-chinese-smartphones-hidden-censorship-software-consumers/",
                "5": "https://www.cnet.com/tech/mobile/xiaomi-defends-data-practices-after-being-accused-of-tracking-private-phone-use/",
                "6": "https://in.mashable.com/tech/13725/xiaomi-accused-of-harvesting-private-data-heres-everything-we-know-so-far",
                "7": "https://www.androidcentral.com/xiaomi-has-been-accused-collecting-private-data-smartphone-users",
                "8": "https://www.bitdefender.com/en-us/blog/hotforsecurity/xiaomi-accused-collecting-browser-data-without-consent",
                "9": "https://www.aspi.org.au/report/uyghurs-sale"
            },
            "sourceNotes": {
                "1": "engaging in corruption",
                "2": "unfair repair practices",
                "3": "environmental violations in supply chain",
                "4": "sold phones with secret censorship software",
                "5": "tracking customers' phone usage without consent",
                "6": "tracking customers' phone usage without consent",
                "7": "tracking customers' phone usage without consent",
                "8": "tracking customers' phone usage without consent",
                "9": "participation in Uyghur forced labour"
            },
            "tags": [
                "tech",
                "electronics",
                "cars",
                "corruption",
                "deception",
                "privacy violations",
                "forced Uyghur labour",
                "environmental violations"
            ],
            "score": 34,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/a/ae/Xiaomi_logo_%282021-%29.svg?utm_source=en.wikipedia.org&utm_campaign=index&utm_content=original",
            "siteUrl": "https://mi.com",
            "updatedAt": "2026-08-31T16:27:11.800Z"
        },
        "poco": {
            "key": "poco",
            "names": [
                "POCO"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech",
                "electronics",
                "cars"
            ],
            "score": 34,
            "ownedBy": [
                "xiaomi"
            ],
            "updatedAt": "2026-08-31T21:07:21.793Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Poco_(company)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0d/Poco_Logo_Transparent.png/250px-Poco_Logo_Transparent.png",
            "siteUrl": "https://www.po.co/global/"
        },
        "redmi": {
            "key": "redmi",
            "names": [
                "Redmi"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech",
                "electronics",
                "cars"
            ],
            "score": 34,
            "ownedBy": [
                "xiaomi"
            ],
            "updatedAt": "2026-08-31T21:07:22.505Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Redmi",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/76/REDMI_logo_%28red%29.svg/250px-REDMI_logo_%28red%29.svg.png",
            "siteUrl": "https://www.mi.com/"
        },
        "take-two": {
            "key": "take-two",
            "names": [
                "Take Two",
                "Take-Two Interactive",
                "Take-Two Interactive Software, Inc.",
                "Take 2",
                "Take 2 Interactive",
                "Take-Two",
                "\tParagon Software",
                "TTWO"
            ],
            "comment": "Take Two is an American video game publisher that has engaged in anti‑union practices [1], stolen music from an independent artist [2], and operated predatory gambling games [3]. The company has also underpaid employees and denied them breaks [4][5][6][7].",
            "sources": {
                "1": "https://www.bbc.co.uk/news/articles/c9v10rr1meeo",
                "2": "https://www.svg.com/378328/why-this-musician-is-suing-rockstar-games/",
                "3": "https://www.law360.com/articles/1554238/game-maker-zynga-pays-12m-to-end-gambling-app-suit",
                "4": "https://www.law360.com/articles/416208/gaming-co-settles-meal-break-allegations-with-testers",
                "5": "https://www.engadget.com/2010-01-15-rockstar-quietly-settled-class-action-lawsuit-with-over-100-ex.html",
                "6": "https://gamerant.com/rockstar-games-underpaid-workers/",
                "7": "https://www.business-humanrights.org/en/latest-news/uk-rockstar-games-improves-working-conditions-following-investigation-highlighting-excessive-overtime-temporary-contracts/"
            },
            "sourceNotes": {
                "1": "anti-union practices",
                "2": "stole music from independent artist",
                "3": "operated predatory gambling games",
                "4": "underpaid and denied breaks to employees",
                "5": "underpaid and denied breaks to employees",
                "6": "underpaid and denied breaks to employees",
                "7": "underpaid and denied breaks to employees"
            },
            "tags": [
                "videogames",
                "entertainment",
                "tech",
                "anti-union practices",
                "unfair pay",
                "poor working conditions",
                "unsafe practices"
            ],
            "score": 43,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/d/d6/Take-Two_Interactive_Logo.svg",
            "siteUrl": "https://www.take2games.com/",
            "updatedAt": "2026-09-07T22:19:50.910Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Take_Two"
        },
        "zynga": {
            "key": "zynga",
            "names": [
                "Zynga"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "videogames",
                "entertainment",
                "tech"
            ],
            "score": 43,
            "ownedBy": [
                "take-two"
            ],
            "updatedAt": "2026-09-08T00:02:16.943Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Zynga",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/thumb/7/7b/Zynga.svg/250px-Zynga.svg.png",
            "siteUrl": "https://www.zynga.com/"
        },
        "2k": {
            "key": "2k",
            "names": [
                "2K"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "videogames",
                "entertainment",
                "tech"
            ],
            "score": 43,
            "ownedBy": [
                "take-two"
            ],
            "updatedAt": "2026-09-08T00:02:17.500Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/2K_(company)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1f/2K_2021_Logo.svg/250px-2K_2021_Logo.svg.png",
            "siteUrl": "https://2k.com/"
        },
        "ghost-story-games": {
            "key": "ghost-story-games",
            "names": [
                "Ghost Story Games"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "videogames",
                "entertainment",
                "tech"
            ],
            "score": 43,
            "ownedBy": [
                "take-two"
            ],
            "updatedAt": "2026-09-08T00:02:17.634Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Ghost_Story_Games",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/thumb/3/3e/Ghost_story_logo.png/250px-Ghost_story_logo.png",
            "siteUrl": "https://www.ghoststorygames.com/"
        },
        "general-mills": {
            "key": "general-mills",
            "names": [
                "General Mills",
                "General Mills, Inc.",
                "Minneapolis Milling Company",
                "Washburn-Crosby Company",
                "GIS"
            ],
            "comment": "General Mills is an American food company that has discouraged the public from eating healthy [1], committed environmental violations [2][3][4], sold food containing dangerous herbicides [5][6] and pesticides [7], and sells food containing plasticisers [8]. The company has also engaged in racial discrimination against employees [9][10][11], retaliated against employees who reported racism [12][13], purchased palm oil from illegal plantations in wildlife reserves [14], operates in illegal Israeli settlements [15][16], and uses child labour in its supply chain [17].",
            "sources": {
                "1": "https://www.washingtonpost.com/wellness/2024/04/03/diet-culture-nutrition-influencers-general-mills-processed-food/",
                "2": "https://echo.epa.gov/enforcement-case-report?id=05-2019-7523",
                "3": "https://web.archive.org/web/20210815073911/http://edocpub.epa.ohio.gov/publicportal/ViewDocument.aspx?docid=362275",
                "4": "https://echo.epa.gov/enforcement-case-report?id=05-2022-7573",
                "5": "https://people.com/food/general-mills-cheerios-weed-killer-chemical-glyphosate-quaker-oats-response/",
                "6": "https://www.ecowatch.com/general-mills-glyphosate-lawsuit-2598400768.html",
                "7": "https://topclassactions.com/lawsuit-settlements/consumer-products/food/cheerios-class-action-alleges-products-contain-dangerous-pesticide-levels/",
                "8": "https://www.cbsnews.com/news/general-mills-plastic-chemicals-consumer-reports/",
                "9": "https://www.businesswire.com/news/home/20250924512794/en/Federal-Court-Sends-General-Mills-Racial-Discrimination-Claim-to-Jury-Trial-Ahead-of-Larger-Class-Action-Challenge",
                "10": "https://www.theroot.com/black-employees-sue-general-mills-alleging-shocking-ra-1851521651",
                "11": "https://www.thestreet.com/employment/general-mills-faces-lawsuit-alleging-egregious-incidents-of-racism",
                "12": "https://www.fox9.com/news/general-mills-worker-retaliation-lawsuit-offensive-black-history-month-fun-facts-july-2025",
                "13": "https://kstp.com/kstp-news/local-news/lawsuit-alleges-general-mills-fired-employee-after-he-reported-racially-offensive-material/",
                "14": "https://www.ran.org/leuser-watch/the-last-of-the-leuser-lowlands/",
                "15": "https://reliefweb.int/report/occupied-palestinian-territory/database-all-business-enterprises-involved-certain-activities",
                "16": "https://web.archive.org/web/20211103173922/https://www.ohchr.org/EN/NewsEvents/Pages/DisplayNews.aspx?NewsID=25542",
                "17": "https://www.business-humanrights.org/en/latest-news/usa-investigation-finds-migrant-children-working-in-food-processing-factories-and-making-auto-parts-in-violation-of-child-labour-laws-incl-co-responses/"
            },
            "sourceNotes": {
                "1": "discouraged the public from eating healthy",
                "2": "committed environmental violations",
                "3": "committed environmental violations",
                "4": "committed environmental violations",
                "5": "sold food containing dangerous herbicides",
                "6": "sold food containing dangerous herbicides",
                "7": "sold food containing dangerous pesticides",
                "8": "sells food containing plasticisers",
                "9": "racial discrimination against employees",
                "10": "racial discrimination against employees",
                "11": "racial discrimination against employees",
                "12": "retaliated against employee who reported racism",
                "13": "retaliated against employee who reported racism",
                "14": "purchased palm oil from illegal plantations in wildlife reserves",
                "15": "operating in illegal Israeli settlements",
                "16": "operating in illegal Israeli settlements",
                "17": "child labour in supply chain"
            },
            "tags": [
                "food",
                "environmental violations",
                "unsustainable practices",
                "deforestation",
                "racial discrimination",
                "child labour",
                "connections to israel"
            ],
            "score": 26,
            "ownedBy": [],
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/0/00/General_Mills_logo.svg/250px-General_Mills_logo.svg.png",
            "siteUrl": "http://generalmills.com/",
            "updatedAt": "2026-09-08T00:01:39.493Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/General_Mills"
        },
        "boo-berry": {
            "key": "boo-berry",
            "names": [
                "Boo-Berry"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 26,
            "ownedBy": [
                "general-mills"
            ],
            "updatedAt": "2026-09-08T11:47:25.463Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Monster_Cereals",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/3/33/Count-Chocula-Box-Small.jpg"
        },
        "chex": {
            "key": "chex",
            "names": [
                "Chex"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 26,
            "ownedBy": [
                "general-mills"
            ],
            "updatedAt": "2026-09-08T11:47:26.184Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Chex",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/6/62/Chex_cereal.png",
            "siteUrl": "https://www.chex.com/"
        },
        "cinnamon-toast-crunch": {
            "key": "cinnamon-toast-crunch",
            "names": [
                "Cinnamon Toast Crunch"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 26,
            "ownedBy": [
                "general-mills"
            ],
            "updatedAt": "2026-09-08T11:47:26.281Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Cinnamon_Toast_Crunch",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1d/Cinnamon_toastcrunch_logo.png/250px-Cinnamon_toastcrunch_logo.png",
            "siteUrl": "https://www.cinnamontoastcrunch.com/"
        },
        "fiber-one-fibre-one": {
            "key": "fiber-one-fibre-one",
            "names": [
                "Fiber One / Fibre One"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 26,
            "ownedBy": [
                "general-mills"
            ],
            "updatedAt": "2026-09-08T11:47:26.817Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Fiber_One",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/91/FiberOneLogoredcircle.png/120px-FiberOneLogoredcircle.png",
            "siteUrl": "https://www.fiberone.com/"
        },
        "french-toast-crunch": {
            "key": "french-toast-crunch",
            "names": [
                "French Toast Crunch"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 26,
            "ownedBy": [
                "general-mills"
            ],
            "updatedAt": "2026-09-08T11:47:28.232Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/French_Toast_Crunch",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/2/2f/French-Toast-Crunch-Box.jpg/250px-French-Toast-Crunch-Box.jpg",
            "siteUrl": "http://www.blog.generalmills.com/2014/12/weve-got-big-news-about-french-toast-crunch/"
        },
        "kix": {
            "key": "kix",
            "names": [
                "Kix"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 26,
            "ownedBy": [
                "general-mills"
            ],
            "updatedAt": "2026-09-08T11:47:28.354Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Kix_(cereal)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/7/7e/Kix_cereal.png",
            "siteUrl": "http://www.kixcereal.com/"
        },
        "lucky-charms": {
            "key": "lucky-charms",
            "names": [
                "Lucky Charms"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 26,
            "ownedBy": [
                "general-mills"
            ],
            "updatedAt": "2026-09-08T11:47:28.673Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Lucky_Charms",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/69/Lucky_charms_brand_logo.png",
            "siteUrl": "https://www.luckycharms.com/"
        },
        "oatmeal-crisp": {
            "key": "oatmeal-crisp",
            "names": [
                "Oatmeal Crisp"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 26,
            "ownedBy": [
                "general-mills"
            ],
            "updatedAt": "2026-09-08T11:47:28.925Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Oatmeal_Crisp",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/e/e0/Oatmeal_Crisp.png",
            "siteUrl": "https://www.oatmealcrisp.ca/"
        },
        "trix": {
            "key": "trix",
            "names": [
                "Trix"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 26,
            "ownedBy": [
                "general-mills"
            ],
            "updatedAt": "2026-09-08T11:47:29.457Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Trix_(cereal)",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/6/6b/Trix_brand_logo.png/250px-Trix_brand_logo.png",
            "siteUrl": "https://www.generalmills.com/Brands/Cereals/Trix.aspx"
        },
        "wheaties": {
            "key": "wheaties",
            "names": [
                "Wheaties"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 26,
            "ownedBy": [
                "general-mills"
            ],
            "updatedAt": "2026-09-08T11:47:30.129Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Wheaties",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/thumb/5/51/Wheaties_logo.png/250px-Wheaties_logo.png",
            "siteUrl": "http://wheaties.com/"
        },
        "bugles": {
            "key": "bugles",
            "names": [
                "Bugles"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 26,
            "ownedBy": [
                "general-mills"
            ],
            "updatedAt": "2026-09-08T11:47:30.210Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Bugles_(snack)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Bugles_brand_snack_food.jpg/250px-Bugles_brand_snack_food.jpg"
        },
        "chex-mix": {
            "key": "chex-mix",
            "names": [
                "Chex Mix"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 26,
            "ownedBy": [
                "general-mills"
            ],
            "updatedAt": "2026-09-08T11:47:30.605Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Chex_Mix",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/thumb/9/98/Traditional_Chex_Mix.png/250px-Traditional_Chex_Mix.png",
            "siteUrl": "https://www.chexmix.com/"
        },
        "gardetto's": {
            "key": "gardetto's",
            "names": [
                "Gardetto's"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 26,
            "ownedBy": [
                "general-mills"
            ],
            "updatedAt": "2026-09-08T11:47:30.792Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Gardetto's"
        },
        "nature-valley": {
            "key": "nature-valley",
            "names": [
                "Nature Valley"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 26,
            "ownedBy": [
                "general-mills"
            ],
            "updatedAt": "2026-09-08T11:47:30.999Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Nature_Valley",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/16/Nature-valley-logo.png/250px-Nature-valley-logo.png",
            "siteUrl": "https://www.naturevalley.com/"
        },
        "betty-crocker": {
            "key": "betty-crocker",
            "names": [
                "Betty Crocker"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 26,
            "ownedBy": [
                "general-mills"
            ],
            "updatedAt": "2026-09-08T11:47:31.177Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Betty_Crocker",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/thumb/2/2c/Betty_Crocker_New_Logo.svg/250px-Betty_Crocker_New_Logo.svg.png",
            "siteUrl": "https://www.bettycrocker.com/"
        },
        "bisquick": {
            "key": "bisquick",
            "names": [
                "Bisquick"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 26,
            "ownedBy": [
                "general-mills"
            ],
            "updatedAt": "2026-09-08T11:47:31.255Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Bisquick",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Bisquick_Logo.jpg/330px-Bisquick_Logo.jpg",
            "siteUrl": "http://bisquick.com/"
        },
        "jus-rol": {
            "key": "jus-rol",
            "names": [
                "Jus-Rol"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 26,
            "ownedBy": [
                "general-mills"
            ],
            "updatedAt": "2026-09-08T11:47:31.746Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Jus-Rol",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/thumb/2/28/Logo_for_Jus-Rol%2C_Oct_2014.jpg/250px-Logo_for_Jus-Rol%2C_Oct_2014.jpg",
            "siteUrl": "http://jusrol.co.uk/"
        },
        "pillsbury": {
            "key": "pillsbury",
            "names": [
                "Pillsbury"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 26,
            "ownedBy": [
                "general-mills"
            ],
            "updatedAt": "2026-09-08T11:47:32.382Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Pillsbury_Company",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b1/Pillsbury_company_logo.svg/250px-Pillsbury_company_logo.svg.png",
            "siteUrl": "https://www.pillsbury.com/"
        },
        "diablitos-underwood": {
            "key": "diablitos-underwood",
            "names": [
                "Diablitos Underwood"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 26,
            "ownedBy": [
                "general-mills"
            ],
            "updatedAt": "2026-09-08T11:47:32.490Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/William_Underwood_Company",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/de/Underwood_Meat_Spreads_logo.png",
            "siteUrl": "http://underwoodspreads.com/"
        },
        "old-el-paso": {
            "key": "old-el-paso",
            "names": [
                "Old El Paso"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 26,
            "ownedBy": [
                "general-mills"
            ],
            "updatedAt": "2026-09-08T11:47:32.677Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Old_El_Paso",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/thumb/2/27/Logo_for_Old_El_Paso%2C_Oct_2014.png/250px-Logo_for_Old_El_Paso%2C_Oct_2014.png",
            "siteUrl": "https://www.oldelpaso.com/"
        },
        "wanchai-ferry": {
            "key": "wanchai-ferry",
            "names": [
                "Wanchai Ferry"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 26,
            "ownedBy": [
                "general-mills"
            ],
            "updatedAt": "2026-09-08T11:47:32.728Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Wanchai_Ferry_(brand)"
        },
        "cascadian-farm": {
            "key": "cascadian-farm",
            "names": [
                "Cascadian Farm"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 26,
            "ownedBy": [
                "general-mills"
            ],
            "updatedAt": "2026-09-08T11:47:33.239Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Cascadian_Farm",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/0/00/General_Mills_logo.svg/250px-General_Mills_logo.svg.png",
            "siteUrl": "http://generalmills.com/"
        },
        "annie's-homegrown": {
            "key": "annie's-homegrown",
            "names": [
                "Annie's Homegrown"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 26,
            "ownedBy": [
                "general-mills"
            ],
            "updatedAt": "2026-09-08T11:47:34.025Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Annie's_Homegrown",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/cd/Annies_logo.png",
            "siteUrl": "http://www.annies.com/"
        },
        "totino's": {
            "key": "totino's",
            "names": [
                "Totino's"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 26,
            "ownedBy": [
                "general-mills"
            ],
            "updatedAt": "2026-09-08T11:47:34.566Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Totino's",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/60/Totinos.svg/250px-Totinos.svg.png",
            "siteUrl": "http://www.totinos.com/"
        },
        "progresso": {
            "key": "progresso",
            "names": [
                "Progresso"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 26,
            "ownedBy": [
                "general-mills"
            ],
            "updatedAt": "2026-09-08T11:47:35.017Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Progresso",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/thumb/8/80/New_progresso_logo.svg/250px-New_progresso_logo.svg.png"
        },
        "colombo": {
            "key": "colombo",
            "names": [
                "Colombo"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 26,
            "ownedBy": [
                "general-mills"
            ],
            "updatedAt": "2026-09-08T11:47:35.201Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Colombo_Yogurt"
        },
        "larabar": {
            "key": "larabar",
            "names": [
                "Lärabar"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 26,
            "ownedBy": [
                "general-mills"
            ],
            "updatedAt": "2026-09-08T11:47:35.457Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Lärabar",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/7/78/Larabar_logo.png/250px-Larabar_logo.png",
            "siteUrl": "https://www.larabar.com/"
        },
        "a.g.-barr": {
            "key": "a.g.-barr",
            "names": [
                "A.G. Barr",
                "Barr's",
                "A.G. Barr p.l.c.",
                "BAG"
            ],
            "comment": "",
            "sources": {
                "1": "https://www.heraldscotland.com/news/23746060.irn-bru-manufacturer-accused-union-busting-tactics/"
            },
            "sourceNotes": {
                "1": "anti union practices"
            },
            "tags": [
                "beverages"
            ],
            "score": 49,
            "ownedBy": [],
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/2/24/A.G._Barr_logo.svg/250px-A.G._Barr_logo.svg.png",
            "siteUrl": "https://agbarr.co.uk/",
            "updatedAt": "2026-09-09T20:13:12.311Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/A.G._Barr"
        },
        "barr-cola": {
            "key": "barr-cola",
            "names": [
                "Barr Cola"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages"
            ],
            "score": 49,
            "ownedBy": [
                "a.g.-barr"
            ],
            "updatedAt": "2026-09-09T20:25:20.189Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Barr_Cola",
            "siteUrl": "https://www.agbarr.co.uk/our-brands/barr-soft-drinks/barr-flavours"
        },
        "red-kola": {
            "key": "red-kola",
            "names": [
                "Red Kola"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages"
            ],
            "score": 49,
            "ownedBy": [
                "a.g.-barr"
            ],
            "updatedAt": "2026-09-09T20:25:20.468Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Red_Kola",
            "siteUrl": "http://dunnsfoodanddrinks.co.uk/our-range/own-brands/curries-red-kola-3"
        },
        "boost-drinks": {
            "key": "boost-drinks",
            "names": [
                "Boost Drinks"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages"
            ],
            "score": 49,
            "ownedBy": [
                "a.g.-barr"
            ],
            "updatedAt": "2026-09-09T20:25:20.895Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Boost_Drinks",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/5/5b/Boost_Drinks_logo.png/250px-Boost_Drinks_logo.png",
            "siteUrl": "https://boostdrinks.com/"
        },
        "bundaberg": {
            "key": "bundaberg",
            "names": [
                "Bundaberg"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages"
            ],
            "score": 49,
            "ownedBy": [
                "a.g.-barr"
            ],
            "updatedAt": "2026-09-09T20:25:20.994Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Bundaberg_Brewed_Drinks",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/3/3e/Bundaberg_Brewed_Drinks_Logo.png/250px-Bundaberg_Brewed_Drinks_Logo.png",
            "siteUrl": "http://bundaberg.com/"
        },
        "rio": {
            "key": "rio",
            "names": [
                "Rio"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages"
            ],
            "score": 49,
            "ownedBy": [
                "a.g.-barr"
            ],
            "updatedAt": "2026-09-09T20:25:21.630Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Rio_(British_drink)",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/e/e5/Rio_British_drink_logo.png",
            "siteUrl": "https://drinkrio.com/"
        },
        "rubicon": {
            "key": "rubicon",
            "names": [
                "Rubicon"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages"
            ],
            "score": 49,
            "ownedBy": [
                "a.g.-barr"
            ],
            "updatedAt": "2026-09-09T20:25:22.152Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Rubicon_Drinks",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/thumb/1/12/Rubicon_Drinks.png/250px-Rubicon_Drinks.png",
            "siteUrl": "http://rubicondrinks.com/"
        },
        "tizer": {
            "key": "tizer",
            "names": [
                "Tizer"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages"
            ],
            "score": 49,
            "ownedBy": [
                "a.g.-barr"
            ],
            "updatedAt": "2026-09-09T20:25:22.227Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Tizer",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/63/Tizer.jpg/250px-Tizer.jpg"
        },
        "fentimans": {
            "key": "fentimans",
            "names": [
                "Fentimans"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages"
            ],
            "score": 49,
            "ownedBy": [
                "a.g.-barr"
            ],
            "updatedAt": "2026-09-09T20:25:22.324Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Fentimans",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/7/7f/Fentimans.png",
            "siteUrl": "http://www.fentimans.com/"
        },
        "schwarz-group": {
            "key": "schwarz-group",
            "names": [
                "Schwarz Group",
                "Schwarz Gruppe"
            ],
            "comment": "Schwarz Group is a German retail conglomerate that has been accused of price fixing [1][2], misleading advertising [3], underpaying employees [4], maintaining poor working conditions in its supply chain [5], spying on staff [6], and discriminating against employees on the basis of sex [7][8]. The company has also sold cheese contaminated with listeria [9] and has been implicated in animal abuse within its supply chain [10][11][12].",
            "sources": {
                "1": "https://www.concorrencia.pt/en/articles/adc-imposed-fines-six-large-retail-food-chains",
                "2": "https://www.concorrencia.pt/en/articles/adc-sanctions-auchan-lidl-modelo-continente-pingo-doce-supplier-soft-drinks-and-two",
                "3": "https://archive.ph/Ilj0k",
                "4": "https://www.gov.uk/government/news/over-74-million-put-back-in-working-peoples-pockets-by-employers",
                "5": "https://news.stv.tv/north/seasonal-workers-at-castleton-farm-in-aberdeenshire-given-cramped-and-undignified-accommodation",
                "6": "https://www.theguardian.com/world/2008/mar/27/germany.supermarkets",
                "7": "https://redmans.co.uk/insights/et-awards-22000-to-lidl-employee-in-a-sex-discrimination-and-victimisation-case/",
                "8": "https://www.gbnews.com/news/lidl-worker-sexual-harassment-employment-tribunal-reading",
                "9": "https://www.err.ee/340057/saksa-odavpoodide-ketti-lidl-trahviti-1-5-miljoni-euroga",
                "10": "https://thehumaneleague.org.uk/article/whistleblower-exposes-lidls-animal-cruelty",
                "11": "https://pressat.co.uk/releases/new-photos-suggest-lidl-lied-about-animal-cruelty-scandal-48a2fea28a7ec62f5b9f7b3213274ff8/",
                "12": "https://thehumaneleague.org.uk/article/lidl-german-investigation"
            },
            "sourceNotes": {
                "1": "price fixing",
                "2": "price fixing",
                "3": "misleading advertising",
                "4": "underpaid employees",
                "5": "poor working conditions in supply chain",
                "6": "spying on staff",
                "7": "sex discrimination against employees",
                "8": "sex discrimination against employees",
                "9": "sold cheese contaminated with listeria",
                "10": "animal abuse in supply chain",
                "11": "animal abuse in supply chain",
                "12": "animal abuse in supply chain"
            },
            "tags": [
                "retail",
                "anticompetitive practices",
                "deception",
                "unfair pay",
                "poor working conditions",
                "privacy violations",
                "gender discrimination",
                "unsafe products",
                "animal abuse"
            ],
            "score": 25,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Logo_of_Schwarz_Group%2C_2023.svg/250px-Logo_of_Schwarz_Group%2C_2023.svg.png",
            "siteUrl": "https://gruppe.schwarz/en",
            "updatedAt": "2026-09-09T20:27:19.074Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Schwarz_Group"
        },
        "kaufland": {
            "key": "kaufland",
            "names": [
                "Kaufland"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 25,
            "ownedBy": [
                "schwarz-group"
            ],
            "updatedAt": "2026-09-11T15:03:59.180Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Kaufland",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/6/65/Kaufland_Deutschland.png/250px-Kaufland_Deutschland.png",
            "siteUrl": "http://www.kaufland.com/"
        },
        "prezero": {
            "key": "prezero",
            "names": [
                "Prezero"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail"
            ],
            "score": 25,
            "ownedBy": [
                "schwarz-group"
            ],
            "updatedAt": "2026-09-11T15:03:59.294Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Prezero",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/f/f7/PreZero.png/250px-PreZero.png",
            "siteUrl": "http://prezero-international.com/"
        },
        "geely": {
            "key": "geely",
            "names": [
                "Geely",
                "Geely Commercial Vehicles",
                "ZGH",
                "浙江吉利控股集团有限公司",
                "浙江吉利控股集團有限公司",
                "Zhèjiāng Jílì Kònggǔ Jítuán Yǒuxiàn Gōngsī"
            ],
            "comment": "Geely is a Chinese automotive company that has committed fuel economy violations [1], environmental violations [2][3], colluded to avoid paying dismantlers for end‑of‑life vehicle recycling [4][5], and has inadequate human rights due diligence in its battery supply chain [6]. It has paid sub‑minimum wages and discriminated against workers [7], used coerced labour in its supply chain [8], and sponsored aggression by expanding sales in Russia [9].",
            "sources": {
                "1": "//violationtrackerglobal.goodjobsfirst.org/violation-tracker-global/united-states-volvo-2",
                "2": "//violationtrackerglobal.goodjobsfirst.org/violation-tracker-global/china-shandong-tangjun-ouling-automobile",
                "3": "//violationtracker.goodjobsfirst.org/violation-tracker/ca-volvo-cars-of-north-america",
                "4": "https://ec.europa.eu/commission/presscorner/detail/en/ip_25_881",
                "5": "//violationtrackerglobal.goodjobsfirst.org/violation-tracker-global/european-commission-volvo",
                "6": "https://www.amnesty.org/en/latest/news/2024/10/human-rights-ranking-electric-vehicle-industry/",
                "7": "https://www.theguardian.com/global-development/2021/nov/08/cobalt-drc-miners-toil-for-30p-an-hour-to-fuel-electric-cars",
                "8": "https://www.thebureauinvestigates.com/stories/2025-05-31/did-coerced-labour-build-your-car",
                "9": "https://www.business-humanrights.org/en/latest-news/ukraine-chinese-car-manufacturer-geely-is-designated-as-intl-sponsor-of-war-by-govt-over-trade-increase-in-russia/"
            },
            "sourceNotes": {
                "1": "committed fuel economy violations",
                "2": "committed environmental violations",
                "3": "committed environmental violations",
                "4": "colluded to avoid paying dismantlers for end‑of‑life vehicle recycling",
                "5": "participated in a cartel for end‑of‑life vehicle recycling",
                "6": "inadequate human rights due diligence in battery supply chain",
                "7": "paid sub‑minimum wages and discriminated against workers",
                "8": "used coerced labour in supply chain",
                "9": "sponsored aggression by expanding sales in Russia"
            },
            "tags": [
                "cars",
                "manufacturing",
                "corruption",
                "forced labour",
                "unfair pay",
                "connections to russia",
                "environmental violations",
                "unsustainable practices",
                "poor working conditions"
            ],
            "score": 26,
            "ownedBy": [],
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/2/2c/Geely_Logo_2022.svg/250px-Geely_Logo_2022.svg.png",
            "siteUrl": "http://zgh.com/",
            "updatedAt": "2026-09-16T09:27:51.647Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Geely"
        },
        "lynk-and-co": {
            "key": "lynk-and-co",
            "names": [
                "Lynk & Co"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "cars",
                "manufacturing"
            ],
            "score": 26,
            "ownedBy": [
                "geely"
            ],
            "updatedAt": "2026-09-16T11:12:17.300Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Lynk_&amp;_Co"
        },
        "zeekr": {
            "key": "zeekr",
            "names": [
                "Zeekr"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "cars",
                "manufacturing"
            ],
            "score": 26,
            "ownedBy": [
                "geely"
            ],
            "updatedAt": "2026-09-16T11:12:18.029Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Zeekr",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/1/1e/Zeekr_logo.svg/250px-Zeekr_logo.svg.png",
            "siteUrl": "https://www.zeekrgroup.com/en"
        },
        "proton": {
            "key": "proton",
            "names": [
                "Proton"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "cars",
                "manufacturing"
            ],
            "score": 26,
            "ownedBy": [
                "geely"
            ],
            "updatedAt": "2026-09-16T11:12:18.772Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Proton_Holdings",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/c/c2/PROTON_Holdings_logo_%282019%E2%80%93present%29.svg/250px-PROTON_Holdings_logo_%282019%E2%80%93present%29.svg.png",
            "siteUrl": "http://proton.com/"
        },
        "smart": {
            "key": "smart",
            "names": [
                "Smart"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "cars",
                "manufacturing"
            ],
            "score": 26,
            "ownedBy": [
                "geely"
            ],
            "updatedAt": "2026-09-16T11:12:19.151Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Smart_(marque)",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/7/79/Smart_2022.svg/120px-Smart_2022.svg.png",
            "siteUrl": "http://smart.com/"
        },
        "lotus": {
            "key": "lotus",
            "names": [
                "Lotus"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "cars",
                "manufacturing"
            ],
            "score": 26,
            "ownedBy": [
                "geely"
            ],
            "updatedAt": "2026-09-16T11:12:19.985Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Lotus_Cars",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/2/2f/Lotus_Cars_logo.svg/250px-Lotus_Cars_logo.svg.png",
            "siteUrl": "https://www.lotuscars.com/en"
        },
        "london-ev-company": {
            "key": "london-ev-company",
            "names": [
                "London EV Company"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "cars",
                "manufacturing"
            ],
            "score": 26,
            "ownedBy": [
                "geely"
            ],
            "updatedAt": "2026-09-16T11:12:20.337Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/London_EV_Company",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/8/81/London_EV_Company_logo.svg/250px-London_EV_Company_logo.svg.png",
            "siteUrl": "http://levc.com/"
        },
        "radar-auto": {
            "key": "radar-auto",
            "names": [
                "Radar Auto"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "cars",
                "manufacturing"
            ],
            "score": 26,
            "ownedBy": [
                "geely"
            ],
            "updatedAt": "2026-09-16T11:12:20.449Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Radar_Auto",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/1/12/Radar_Auto_logo.png/250px-Radar_Auto_logo.png",
            "siteUrl": "https://www.radar-ev.com/"
        },
        "farizon": {
            "key": "farizon",
            "names": [
                "Farizon"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "cars",
                "manufacturing"
            ],
            "score": 26,
            "ownedBy": [
                "geely"
            ],
            "updatedAt": "2026-09-16T11:12:21.053Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Farizon_Auto",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/e/e2/Farizon_Auto_Logo.png/250px-Farizon_Auto_Logo.png",
            "siteUrl": "https://geelycv.com/"
        },
        "tata": {
            "key": "tata",
            "names": [
                "Tata",
                "Tata Group",
                "Tata Sons"
            ],
            "comment": "Tata is an Indian conglomerate that has engaged in bribery in recruitment [1], accepted bribes from staffing firms for job placements [2], failed to pay minimum wage [3], sold cars with defective vehicle suspensions [4], colluded to avoid paying for car recycling [5], blocked spare parts sales to stifle competition [6], committed environmental violations [7][8], released pollution into the environment [9], exploited indigenous communities for industrial expansion [10], and engaged in illegal mining [11]. Its workplace culture has been marred by sexual harassment and coercion of employees [12][13], forced religious conversion [14], inhumane working conditions on tea estates [15], denial of wages and food rations during a 3‑month lockout of workers [16], and an employee death in unsafe working conditions [17].",
            "sources": {
                "1": "https://store.hbr.org/product/tata-consultancy-services-tackling-scandal-in-india/W36159?srsltid=AU7gw4Wlt2sbWge8Mi_4HSg0Seqhzhth6mcXsV2W1Rp7reb7Q4t7Bkv6",
                "2": "https://www.staffingindustry.com/news/global-daily-news/tcs-whistleblower-alleges-bribery-scandal-involving-staffing-firms-media",
                "3": "https://www.law360.com/articles/417770/tata-to-pay-30m-over-workers-tax-refund-theft-claims",
                "4": "//https://www.law360.com/articles/1029727/judge-rejects-6-2m-land-rover-deal-as-unfair-to-drivers",
                "5": "https://www.gov.uk/government/news/car-industry-settles-competition-law-case",
                "6": "https://www.cci.gov.in/antitrust/orders/details/750/0",
                "7": "https://www.dutchnews.nl/2026/07/tata-steel-to-face-criminal-charges-for-pollution/",
                "8": "https://violationtracker.goodjobsfirst.org/violation-tracker/wy-tata-chemicals-soda-ash-partners-1",
                "9": "https://www.nu.nl/economie/6392914/tata-steel-krijgt-opnieuw-boete-van-85-miljoen-euro-wegens-schadelijke-uitstoot.html?referrer=https%3A%2F%2Fwww.google.com%2F&referrer=https%3A%2F%2Fgmk.center%2F&referrer=https%3A%2F%2Fviolationtrackerglobal.goodjobsfirst.org%2F",
                "10": "https://www.indiancurrents.org/article-the-dark-side-of-an-iconic-brand-aakash-2323.php",
                "11": "https://economictimes.indiatimes.com/industry/indl-goods/svs/steel/rs-6000-cr-fine-on-tata-steel-for-illegal-mining-sources/articleshow/17105624.cms",
                "12": "https://www.independent.co.uk/asia/india/workplace-sexual-misconduct-tcs-nashik-india-b2957109.html",
                "13": "https://www.facebook.com/Timesnow/posts/a-major-controversy-has-erupted-at-tata-consultancy-services-nashik-facility-aft/1451880916983166/",
                "14": "https://openthemagazine.com/business/tata-groups-reputation-tested-by-relentless-troubles",
                "15": "http://www.bbc.com/news/world-asia-india-34173532",
                "16": "http://cms.iuf.org/?q=node/711",
                "17": "https://www.bbc.co.uk/news/articles/clyn5lq1egeo"
            },
            "sourceNotes": {
                "1": "committed bribery in recruitment",
                "2": "accepted bribes from staffing firms for job placements",
                "3": "failed to pay minimum wage",
                "4": "sold cars with defective vehicle suspensions",
                "5": "colluded to avoid paying for car recycling",
                "6": "blocked spare parts sales to stifle competition",
                "7": "committed environmental violations",
                "8": "committed environmental violations",
                "9": "released pollution into the environment",
                "10": "exploited indigenous communities for industrial expansion",
                "11": "engaged in illegal mining",
                "12": "sexual harassment and coercion at workplace",
                "13": "sexual harassment and coercion of employees",
                "14": "sexual harassment and forced religious conversion",
                "15": "maintained inhumane working conditions on tea estates",
                "16": "denied wages and food rations during a 3‑month lockout of workers",
                "17": "employee died in unsafe working conditions"
            },
            "tags": [
                "conglomerate",
                "cars",
                "manufacturing",
                "corruption",
                "unfair pay",
                "anticompetitive practices",
                "sexual harassment",
                "unsafe working conditions",
                "poor working conditions",
                "environmental violations",
                "unsustainable practices"
            ],
            "score": 6,
            "ownedBy": [],
            "logoUrl": "https://thumb.wikimedia.org/wikipedia/commons/thumb/7/74/TATA_logo.png/250px-TATA_logo.png",
            "siteUrl": "http://www.tata.com/",
            "updatedAt": "2026-09-18T07:57:13.852Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Tata_Group",
            "error": "TypeError: Cannot read properties of undefined (reading '0')"
        },
        "air-india": {
            "key": "air-india",
            "names": [
                "Air India"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "airline"
            ],
            "score": 6,
            "ownedBy": [
                "tata"
            ],
            "updatedAt": "2026-09-19T09:45:49.318Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Air_India",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/b/bf/Air_India_2023.svg/330px-Air_India_2023.svg.png",
            "siteUrl": "https://www.airindia.com/"
        },
        "tajair": {
            "key": "tajair",
            "names": [
                "TajAir"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "airline"
            ],
            "score": 6,
            "ownedBy": [
                "tata"
            ],
            "updatedAt": "2026-09-19T09:45:50.634Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/TajAir",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/5/53/TajAir_Logo.svg/250px-TajAir_Logo.svg.png",
            "siteUrl": "https://www.tajair-tata.aero/"
        },
        "indian-hotels-company-limited": {
            "key": "indian-hotels-company-limited",
            "names": [
                "Indian Hotels Company Limited"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "hospitality"
            ],
            "score": 6,
            "ownedBy": [
                "tata"
            ],
            "updatedAt": "2026-09-19T09:45:51.074Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Indian_Hotels_Company_Limited",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/9/92/Indian_Hotels_Company_Limited_logo.svg/250px-Indian_Hotels_Company_Limited_logo.svg.png",
            "siteUrl": "https://www.ihcltata.com/"
        },
        "taj-hotels": {
            "key": "taj-hotels",
            "names": [
                "Taj Hotels"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "hospitality"
            ],
            "score": 6,
            "ownedBy": [
                "tata"
            ],
            "updatedAt": "2026-09-19T09:45:51.804Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Taj_Hotels",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/c/cd/Taj_Hotels_logo.svg/120px-Taj_Hotels_logo.svg.png",
            "siteUrl": "https://www.tajhotels.com/"
        },
        "vivanta": {
            "key": "vivanta",
            "names": [
                "Vivanta"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "hospitality"
            ],
            "score": 6,
            "ownedBy": [
                "tata"
            ],
            "updatedAt": "2026-09-19T09:45:52.364Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Vivanta",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/9/9a/Vivanta_logo.svg/250px-Vivanta_logo.svg.png",
            "siteUrl": "https://vivantahotels.com/"
        },
        "ginger-hotels": {
            "key": "ginger-hotels",
            "names": [
                "Ginger Hotels"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "hospitality"
            ],
            "score": 6,
            "ownedBy": [
                "tata"
            ],
            "updatedAt": "2026-09-19T09:45:53.097Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Ginger_Hotels",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/f/fb/Ginger_Hotels.svg/250px-Ginger_Hotels.svg.png",
            "siteUrl": "https://www.gingerhotels.com/"
        },
        "tetley": {
            "key": "tetley",
            "names": [
                "Tetley"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "beverages"
            ],
            "score": 6,
            "ownedBy": [
                "tata"
            ],
            "updatedAt": "2026-09-19T09:45:53.577Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Tetley",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/3/38/Tetley_logo.png",
            "siteUrl": "http://tetley.com/"
        },
        "golden-casket": {
            "key": "golden-casket",
            "names": [
                "Golden Casket"
            ],
            "comment": "Golden Casket is a Scottish family-owned confectionery company.",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "confectionery",
                ""
            ],
            "score": 50,
            "ownedBy": [],
            "logoUrl": "https://goldencasket.co.uk/wp-content/uploads/2025/05/logo-1.png",
            "siteUrl": "https://goldencasket.co.uk/",
            "updatedAt": "2026-09-20T16:24:57.481Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Golden_Casket"
        },
        "bestseller": {
            "key": "bestseller",
            "names": [
                "Bestseller",
                "Bestseller A/S"
            ],
            "comment": "jack & jones is a Danish clothing brand that has released sexist ads [1], and has faced criticism for unsafe working conditions in its supply chain [2] and for using forced Uyghur labour [3].",
            "sources": {
                "1": "https://www.indiatvnews.com/entertainment/bollywood-jack-jones-apologises-for-controversial-ad-featuring-ranveer-withdraws-immediately-358064",
                "2": "https://www.business-humanrights.org/en/big-issues/labour-rights/myanmar-garment-worker-allegations-tracker/",
                "3": "https://www.aspi.org.au/report/uyghurs-sale"
            },
            "sourceNotes": {
                "1": "released sexist ad",
                "2": "unsafe working conditions in supply chain",
                "3": "used forced Uyghur labour in supply chain"
            },
            "tags": [
                "clothing",
                "retail",
                "gender discrimination",
                "unsafe working conditions",
                "forced uyghur labour"
            ],
            "score": 34,
            "ownedBy": [],
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/5/52/Bestseller_%28Unternehmen%29_logo.svg/250px-Bestseller_%28Unternehmen%29_logo.svg.png",
            "siteUrl": "https://www.bestseller.com/",
            "updatedAt": "2026-09-20T17:29:25.946Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Bestseller_(company)"
        },
        "jack-and-jones": {
            "key": "jack-and-jones",
            "names": [
                "Jack & Jones"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing",
                "retail"
            ],
            "score": 34,
            "ownedBy": [
                "bestseller"
            ],
            "logoUrl": "https://logowik.com/content/uploads/images/jack-jones1312.logowik.com.webp",
            "siteUrl": "https://www.jackjones.com/en-gb",
            "updatedAt": "2026-09-21T11:11:38.931Z"
        },
        "lvmh": {
            "key": "lvmh",
            "names": [
                "LVMH",
                "LVMH Moet Hennessy Louis Vuitton SE",
                "LVMH Moët Hennessy Louis Vuitton SA",
                "MC"
            ],
            "comment": "LVMH is a French luxury goods conglomerate that has failed to disclose sale of personal data [1], failed to pay minimum wage [2][3], misclassified models and staff as independent contractors to avoid proper wages [4], and failed to pay overtime and meal/rest breaks to employees [5]. The company has also failed to pay overtime and reimburse expenses to employees [6], faced allegations of sweatshop conditions and worker exploitation in its supply chain [7][8][9][10][11][12], committed environmental violations and continued use of microplastics in cosmetics [13][14], bribed public officials [15], and engaged in gender discrimination and unfair dismissal in its drinks division [16] as well as racial discrimination against customers and employees [17][18].",
            "sources": {
                "1": "https://www.oag.ca.gov/news/press-releases/attorney-general-bonta-announces-settlement-sephora-part-ongoing-enforcement",
                "2": "https://www.facebook.com/caspercapitaltv/posts/italian-prosecutors-say-dior-spends-only-57-to-produce-handbags-that-retail-for-/1044986815155121/",
                "3": "https://www.forbes.com/sites/pamdanziger/2025/07/16/loro-piana-joins-growing-list-of-luxury-brands-tied-to-worker-abuse/",
                "4": "https://www.law360.com/articles/984955/moet-s-joint-1-95m-wage-deal-with-models-gets-initial-ok",
                "5": "https://www.law360.com/articles/258690/louis-vuitton-managers-bag-1-5m-payout-in-ot-action",
                "6": "https://www.law360.com/articles/444120/sephora-to-pay-4m-to-settle-worker-compensation-suit",
                "7": "https://www.reuters.com/business/retail-consumer/some-investors-demand-change-lvmh-after-probe-into-dior-contractors-2024-07-23/",
                "8": "https://www.forbes.com/sites/pamdanziger/2024/06/24/italian-court-reveals-diors-unethical-supply-chain-and-puts-other-luxury-brands-on-notice/",
                "9": "https://www.linkedin.com/posts/glenn-mcmahon-127a00128_completely-mystified-how-loro-piana-did-not-activity-7350931604703260674-KlmH",
                "10": "https://www.fashioncapital.co.uk/insights/lvmh-labour-scandal-highlights-urgent-need-for-supply-chain-transparency/",
                "11": "https://www.worldfootwear.com/news/loro-piana-placed-under-court-administration-in-italy-over-worker-exploitation/10791.html",
                "12": "https://www.lemonde.fr/en/europe/article/2024/07/17/dior-and-armani-under-investigation-for-exploiting-workers-at-chinese-factories-in-italy_6687795_143.html?srsltid=AU7gw4X4oEgBrETZFSqM2DvC-S6IKZCXR5GbhwBXbQbvs4Ku3G9kE9_E",
                "13": "https://www.sacda.org/2025/09/da-thien-ho-announces-settlement-with-sephora-relating-to-environmental-laws-and-unfair-business-practices/",
                "14": "https://www.beatthemicrobead.org/product-lists/",
                "15": "https://web.archive.org/web/20101109014908/http://www.ag.ny.gov/media_center/2008/nov/nov19a_08.html",
                "16": "https://www.linkedin.com/posts/financial-times_the-accusations-in-the-lawsuit-that-also-activity-7348978072345337858-5fHS",
                "17": "https://www.law360.com/classaction/articles/928491",
                "18": "https://www.leagle.com/decision/infdco20170621c78"
            },
            "sourceNotes": {
                "1": "failed to disclose sale of personal data",
                "2": "failed to pay minimum wage",
                "3": "failed to pay minimum wage",
                "4": "misclassified models and staff as independent contractors to avoid proper wages",
                "5": "failed to pay overtime and meal/rest breaks to employees",
                "6": "failed to pay overtime and reimburse expenses to employees",
                "7": "alleged sweatshop conditions in supply chain",
                "8": "exploited workers in supply chain",
                "9": "exploited workers in supply chain",
                "10": "exploited workers in supply chain",
                "11": "failed to monitor suppliers, leading to worker exploitation",
                "12": "exploited undocumented workers in supply chain",
                "13": "committed environmental violations",
                "14": "continued use of microplastics in cosmetics",
                "15": "bribed public officials",
                "16": "gender discrimination and unfair dismissal in drinks division",
                "17": "racial discrimination against customers",
                "18": "racial discrimination against employees"
            },
            "tags": [
                "fashion",
                "clothing",
                "privacy violations",
                "unfair pay",
                "poor working conditions",
                "environmental violations",
                "corruption",
                "gender discrimination",
                "racial discrimination",
                "unsustainable practices",
                "unsafe working conditions"
            ],
            "score": 35,
            "ownedBy": [],
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/7/76/LVMH_wordmark.svg/250px-LVMH_wordmark.svg.png",
            "siteUrl": "https://lvmh.com/",
            "updatedAt": "2026-09-22T15:47:23.737Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/LVMH"
        },
        "ao-yun": {
            "key": "ao-yun",
            "names": [
                "Ao Yun"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:30:54.782Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Ao_Yun",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/b/b9/%E6%A2%85%E9%87%8C%E9%9B%AA%E5%B1%B1.jpg/250px-%E6%A2%85%E9%87%8C%E9%9B%AA%E5%B1%B1.jpg",
            "siteUrl": "https://www.aoyun-wine.com/"
        },
        "ardbeg": {
            "key": "ardbeg",
            "names": [
                "Ardbeg"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:30:55.541Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Ardbeg_distillery",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/f/f2/Ardbeg_Distillery%2C_Islay_-_geograph.org.uk_-_4150964.jpg/330px-Ardbeg_Distillery%2C_Islay_-_geograph.org.uk_-_4150964.jpg",
            "siteUrl": "https://www.ardbeg.com/"
        },
        "belvedere": {
            "key": "belvedere",
            "names": [
                "Belvedere"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:30:56.210Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Belvedere_Vodka",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/d/d8/Belvedere_Vodka_%28wordmark_logo%29.svg/250px-Belvedere_Vodka_%28wordmark_logo%29.svg.png",
            "siteUrl": "https://www.belvederevodka.com/"
        },
        "chandon": {
            "key": "chandon",
            "names": [
                "Chandon"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:30:56.306Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Domaine_Chandon_California",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/e/ee/Chandon_California_Brut_sparkling_wine.JPG/250px-Chandon_California_Brut_sparkling_wine.JPG",
            "siteUrl": "http://www.chandon.com/"
        },
        "chateau-d'esclans": {
            "key": "chateau-d'esclans",
            "names": [
                "Château d'Esclans"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:30:56.862Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Château_d'Esclans"
        },
        "chateau-cheval-blanc": {
            "key": "chateau-cheval-blanc",
            "names": [
                "Château Cheval Blanc"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:30:58.058Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Château_Cheval_Blanc"
        },
        "chateau-d'yquem": {
            "key": "chateau-d'yquem",
            "names": [
                "Château d'Yquem"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:30:58.484Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Château_d'Yquem",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/1/1e/Chateau_d_yquem_logo.jpg/250px-Chateau_d_yquem_logo.jpg",
            "siteUrl": "http://yquem.fr/"
        },
        "chateau-galoupet": {
            "key": "chateau-galoupet",
            "names": [
                "Château Galoupet"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:30:58.595Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Château_Galoupet"
        },
        "chateau-minuty": {
            "key": "chateau-minuty",
            "names": [
                "Château Minuty"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:30:59.050Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Château_Minuty"
        },
        "cheval-des-andes": {
            "key": "cheval-des-andes",
            "names": [
                "Cheval des Andes"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:30:59.242Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Terrazas_de_los_Andes",
            "siteUrl": "http://www.terrazasdelosandes.com/"
        },
        "clos-des-lambrays": {
            "key": "clos-des-lambrays",
            "names": [
                "Clos des Lambrays"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:30:59.940Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Clos_des_Lambrays"
        },
        "cloudy-bay": {
            "key": "cloudy-bay",
            "names": [
                "Cloudy Bay"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:00.112Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Cloudy_Bay_Vineyards",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/3/31/Cloudy_Bay_-_Marlborough.jpg/250px-Cloudy_Bay_-_Marlborough.jpg",
            "siteUrl": "https://www.cloudybay.com/"
        },
        "colgin-cellars": {
            "key": "colgin-cellars",
            "names": [
                "Colgin Cellars"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:00.645Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Colgin_Cellars",
            "siteUrl": "http://www.colgincellars.com/"
        },
        "dom-perignon": {
            "key": "dom-perignon",
            "names": [
                "Dom Pérignon"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:01.197Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Dom_Pérignon",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/1/17/Logo_-_Dom_P%C3%A9rignon.svg/250px-Logo_-_Dom_P%C3%A9rignon.svg.png",
            "siteUrl": "http://domperignon.com/"
        },
        "glenmorangie": {
            "key": "glenmorangie",
            "names": [
                "Glenmorangie"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:01.317Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Glenmorangie_distillery",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/f/f8/Glenmorangie_Distillery_-_panoramio.jpg/330px-Glenmorangie_Distillery_-_panoramio.jpg"
        },
        "hennessy": {
            "key": "hennessy",
            "names": [
                "Hennessy"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:01.483Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Hennessy",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/b/bd/Logo_hennessy.svg/250px-Logo_hennessy.svg.png",
            "siteUrl": "http://www.hennessy.com/"
        },
        "krug": {
            "key": "krug",
            "names": [
                "Krug"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:01.605Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Champagne_Krug",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/2/26/Logo_for_Champagne_Krug.jpg/250px-Logo_for_Champagne_Krug.jpg",
            "siteUrl": "http://krug.com/"
        },
        "mercier": {
            "key": "mercier",
            "names": [
                "Mercier"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:01.699Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Champagne_Mercier"
        },
        "moet-and-chandon": {
            "key": "moet-and-chandon",
            "names": [
                "Moët & Chandon"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:01.746Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Moët_&amp;_Chandon"
        },
        "newton-vineyard": {
            "key": "newton-vineyard",
            "names": [
                "Newton Vineyard"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:02.488Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Newton_Vineyard",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/d/d6/Newton_Vineyard_logo.png",
            "siteUrl": "http://newtonvineyard.com/"
        },
        "ruinart": {
            "key": "ruinart",
            "names": [
                "Ruinart"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:02.700Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Ruinart_(Champagne)"
        },
        "veuve-clicquot": {
            "key": "veuve-clicquot",
            "names": [
                "Veuve Clicquot"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:02.997Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Veuve_Clicquot",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/c/cc/Logo_Veuve_Clicquot.png/250px-Logo_Veuve_Clicquot.png",
            "siteUrl": "http://www.veuve-clicquot.com/"
        },
        "berluti": {
            "key": "berluti",
            "names": [
                "Berluti"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:03.190Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Berluti",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/4/40/Berluti_logo_%282018%29.svg/250px-Berluti_logo_%282018%29.svg.png",
            "siteUrl": "http://www.berluti.com/"
        },
        "celine": {
            "key": "celine",
            "names": [
                "Celine"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:03.810Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Celine_(brand)",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/8/81/Celine_logo.svg/250px-Celine_logo.svg.png",
            "siteUrl": "http://www.celine.com/"
        },
        "christian-dior-couture": {
            "key": "christian-dior-couture",
            "names": [
                "Christian Dior Couture"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:03.911Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Dior",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/5/56/Dior_Logo_2022.svg/330px-Dior_Logo_2022.svg.png",
            "siteUrl": "https://www.dior.com/"
        },
        "emilio-pucci": {
            "key": "emilio-pucci",
            "names": [
                "Emilio Pucci"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:04.918Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Emilio_Pucci",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/4/44/Pucci_logo.svg/250px-Pucci_logo.svg.png",
            "siteUrl": "http://www.pucci.com/"
        },
        "armani": {
            "key": "armani",
            "names": [
                "Armani"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:05.008Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Armani",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/7/7a/Giorgio_Armani.svg/330px-Giorgio_Armani.svg.png",
            "siteUrl": "https://www.armani.com/"
        },
        "fendi": {
            "key": "fendi",
            "names": [
                "Fendi"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:05.173Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Fendi",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/a/a1/Fendi_logo.svg/250px-Fendi_logo.svg.png",
            "siteUrl": "https://www.fendi.com/"
        },
        "givenchy": {
            "key": "givenchy",
            "names": [
                "Givenchy"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:05.320Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Givenchy",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/d/df/Givenchy_-_wordmark_%28France%2C_2003%29.svg/330px-Givenchy_-_wordmark_%28France%2C_2003%29.svg.png",
            "siteUrl": "https://www.givenchy.com/"
        },
        "jw-anderson": {
            "key": "jw-anderson",
            "names": [
                "JW Anderson"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:05.431Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/JW_Anderson",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/4/4a/JW_Anderson_logo.svg/250px-JW_Anderson_logo.svg.png",
            "siteUrl": "http://jwanderson.com/"
        },
        "kapital": {
            "key": "kapital",
            "names": [
                "Kapital"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:05.539Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Kapital_(fashion_brand)",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/b/b9/Kapital_logo.png/250px-Kapital_logo.png",
            "siteUrl": "https://www.kapital.jp/"
        },
        "kenzo": {
            "key": "kenzo",
            "names": [
                "Kenzo"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:06.157Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Kenzo_(brand)",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/5/5a/Kenzo_logo_%282022%E2%80%93present%29.svg/250px-Kenzo_logo_%282022%E2%80%93present%29.svg.png",
            "siteUrl": "http://www.kenzo.com/"
        },
        "loewe": {
            "key": "loewe",
            "names": [
                "Loewe"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:06.266Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Loewe_(fashion_brand)",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/8/8e/Loewe_logo.svg/250px-Loewe_logo.svg.png",
            "siteUrl": "http://loewe.com/"
        },
        "loro-piana": {
            "key": "loro-piana",
            "names": [
                "Loro Piana"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:06.500Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Loro_Piana",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/8/8d/Loro_Piana_logo.svg/250px-Loro_Piana_logo.svg.png",
            "siteUrl": "http://loropiana.com/"
        },
        "louis-vuitton": {
            "key": "louis-vuitton",
            "names": [
                "Louis Vuitton"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:06.625Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Louis_Vuitton",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/4/43/LV_Monogram.svg/40px-LV_Monogram.svg.png",
            "siteUrl": "https://www.louisvuitton.com/"
        },
        "moynat": {
            "key": "moynat",
            "names": [
                "Moynat"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:06.836Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Moynat",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/9/96/Moynat_logo.png",
            "siteUrl": "http://moynat.com/"
        },
        "patou": {
            "key": "patou",
            "names": [
                "Patou"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:07.498Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Patou",
            "siteUrl": "https://www.patou.com/"
        },
        "phoebe-philo": {
            "key": "phoebe-philo",
            "names": [
                "Phoebe Philo"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:07.737Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Phoebe_Philo",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/c/c4/Phoebe_Philo_2.jpg"
        },
        "rimowa": {
            "key": "rimowa",
            "names": [
                "Rimowa"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:08.261Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Rimowa",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/3/35/RIMOWA_Monogram.svg/60px-RIMOWA_Monogram.svg.png",
            "siteUrl": "http://rimowa.com/"
        },
        "vuarnet": {
            "key": "vuarnet",
            "names": [
                "Vuarnet"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:09.169Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Vuarnet",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/4/4d/LOGO_VUARNET_TRICOLORE.jpg/250px-LOGO_VUARNET_TRICOLORE.jpg",
            "siteUrl": "https://www.vuarnet.com/"
        },
        "acqua-di-parma": {
            "key": "acqua-di-parma",
            "names": [
                "Acqua di Parma"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:09.739Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Acqua_di_Parma",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/f/fb/Acqua_di_Parma_logo.svg/250px-Acqua_di_Parma_logo.svg.png",
            "siteUrl": "https://www.acquadiparma.com/"
        },
        "benefit-cosmetics": {
            "key": "benefit-cosmetics",
            "names": [
                "Benefit Cosmetics"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:09.795Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Benefit_Cosmetics",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/8/8c/Benefit_Cosmetics_logo.svg/250px-Benefit_Cosmetics_logo.svg.png",
            "siteUrl": "https://benefitcosmetics.com/"
        },
        "bite-beauty": {
            "key": "bite-beauty",
            "names": [
                "BITE Beauty"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:09.856Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/BITE_Beauty",
            "siteUrl": "http://www.bitebeauty.com/"
        },
        "fenty-beauty": {
            "key": "fenty-beauty",
            "names": [
                "Fenty Beauty"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:10.029Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Fenty_Beauty",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/5/5b/Fenty_beauty_logo.png/250px-Fenty_beauty_logo.png",
            "siteUrl": "http://fentybeauty.com/"
        },
        "rihanna": {
            "key": "rihanna",
            "names": [
                "Rihanna"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:10.183Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Rihanna",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/c/c2/Rihanna_Fenty_2018.png/250px-Rihanna_Fenty_2018.png",
            "siteUrl": "http://rihanna.com/"
        },
        "parfums-givenchy": {
            "key": "parfums-givenchy",
            "names": [
                "Parfums Givenchy"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:10.820Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Parfums_Givenchy",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/c/c1/Parfums_Givenchy_Logo.png/250px-Parfums_Givenchy_Logo.png",
            "siteUrl": "https://givenchybeauty.com/"
        },
        "guerlain": {
            "key": "guerlain",
            "names": [
                "Guerlain"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:11.384Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Guerlain",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/6/6d/Guerlain_-_logo_%28France%2C_2022-%29.svg/250px-Guerlain_-_logo_%28France%2C_2022-%29.svg.png",
            "siteUrl": "https://www.guerlain.com/"
        },
        "maison-francis-kurkdjian": {
            "key": "maison-francis-kurkdjian",
            "names": [
                "Maison Francis Kurkdjian"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:12.990Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Francis_Kurkdjian",
            "siteUrl": "https://www.franciskurkdjian.com/"
        },
        "make-up-for-ever": {
            "key": "make-up-for-ever",
            "names": [
                "Make Up For Ever"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:13.551Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Make_Up_For_Ever",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/1/1f/Make_Up_Forever_Logo_2022_updated_version.png/250px-Make_Up_Forever_Logo_2022_updated_version.png",
            "siteUrl": "http://www.makeupforever.com/"
        },
        "officine-universelle-buly": {
            "key": "officine-universelle-buly",
            "names": [
                "Officine Universelle Buly"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:13.943Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Officine_Universelle_Buly",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/1/1c/Paris_75006_Rue_Bonaparte_no_6_shop_windows.jpg/250px-Paris_75006_Rue_Bonaparte_no_6_shop_windows.jpg",
            "siteUrl": "https://www.buly1803.com/"
        },
        "ole-henriksen": {
            "key": "ole-henriksen",
            "names": [
                "Ole Henriksen"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:14.186Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Ole_Henriksen",
            "siteUrl": "http://www.olehenriksen.com/"
        },
        "parfums-christian-dior": {
            "key": "parfums-christian-dior",
            "names": [
                "Parfums Christian Dior"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:14.791Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Parfums_Christian_Dior"
        },
        "bulgari": {
            "key": "bulgari",
            "names": [
                "Bulgari"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:15.316Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Bulgari",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/3/32/Bulgari_logo.svg/250px-Bulgari_logo.svg.png",
            "siteUrl": "http://www.bulgari.com/"
        },
        "chaumet": {
            "key": "chaumet",
            "names": [
                "Chaumet"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:15.563Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Chaumet",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/f/f4/Chaumet_Logo.svg/250px-Chaumet_Logo.svg.png",
            "siteUrl": "https://www.chaumet.com/en"
        },
        "daniel-roth": {
            "key": "daniel-roth",
            "names": [
                "Daniel Roth"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:16.437Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Daniel_Roth_(watchmakers)",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/2/25/Danielrothlogo.png/250px-Danielrothlogo.png",
            "siteUrl": "http://danielroth.com/"
        },
        "fred": {
            "key": "fred",
            "names": [
                "Fred"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:16.601Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Fred_Joaillier",
            "siteUrl": "https://www.fred.com/"
        },
        "gerald-genta": {
            "key": "gerald-genta",
            "names": [
                "Gerald Genta"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:17.340Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Gerald_Genta",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/0/04/Gerald_Genta.jpg/250px-Gerald_Genta.jpg"
        },
        "hublot": {
            "key": "hublot",
            "names": [
                "Hublot"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:17.883Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Hublot",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/7/79/Hublot-logo.svg/250px-Hublot-logo.svg.png",
            "siteUrl": "http://www.hublot.com/"
        },
        "repossi": {
            "key": "repossi",
            "names": [
                "Repossi"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:18.625Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Repossi",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/0/01/Repossi-logo.png/250px-Repossi-logo.png",
            "siteUrl": "http://repossi.com/"
        },
        "tag-heuer": {
            "key": "tag-heuer",
            "names": [
                "TAG Heuer"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:19.122Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/TAG_Heuer",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/d/de/TAG_Heuer_Logo.svg/250px-TAG_Heuer_Logo.svg.png",
            "siteUrl": "http://tagheuer.com/"
        },
        "tiffany-and-co.": {
            "key": "tiffany-and-co.",
            "names": [
                "Tiffany & Co."
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:19.309Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Tiffany_&amp;_Co."
        },
        "zenith": {
            "key": "zenith",
            "names": [
                "Zenith"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:19.507Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Zenith_(watchmaker)",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/a/a5/Zenith_logo.svg/250px-Zenith_logo.svg.png",
            "siteUrl": "http://www.zenith-watches.com/"
        },
        "la-grande-epicerie": {
            "key": "la-grande-epicerie",
            "names": [
                "La Grande Epicerie"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:20.140Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Le_Bon_Marché",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/0/05/Le-bon-marche-logo-vector.svg/250px-Le-bon-marche-logo-vector.svg.png",
            "siteUrl": "https://www.lebonmarche.com/"
        },
        "la-samaritaine": {
            "key": "la-samaritaine",
            "names": [
                "La Samaritaine"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:20.225Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/La_Samaritaine",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/e/e3/La_Samaritaine_rue_de_la_Monnaie_2.jpg/330px-La_Samaritaine_rue_de_la_Monnaie_2.jpg"
        },
        "24s": {
            "key": "24s",
            "names": [
                "24S"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:20.301Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/24S",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/0/0f/24S_Logo.png/250px-24S_Logo.png",
            "siteUrl": "https://en.wikipedia.org/wiki/Online_shopping"
        },
        "belmond": {
            "key": "belmond",
            "names": [
                "Belmond"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:20.704Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Belmond_Limited",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/1/1c/Belmond_Logo.png/250px-Belmond_Logo.png",
            "siteUrl": "https://www.belmond.com/"
        },
        "bulgari-hotel-and-resorts": {
            "key": "bulgari-hotel-and-resorts",
            "names": [
                "Bulgari Hotel and Resorts"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:20.860Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Bulgari#Bulgari_hotels_and_resorts",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/3/32/Bulgari_logo.svg/250px-Bulgari_logo.svg.png",
            "siteUrl": "http://www.bulgari.com/"
        },
        "chez-l'ami-louis": {
            "key": "chez-l'ami-louis",
            "names": [
                "Chez l'Ami Louis"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:21.061Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Chez_l'Ami_Louis"
        },
        "connaissance-des-arts": {
            "key": "connaissance-des-arts",
            "names": [
                "Connaissance des Arts"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:21.782Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Connaissance_des_Arts"
        },
        "cova": {
            "key": "cova",
            "names": [
                "Cova"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:22.073Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Caffè-Pasticceria_Cova",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/9/95/Pasticceria_Cova_logo.png",
            "siteUrl": "http://www.pasticceriacova.com/"
        },
        "investir": {
            "key": "investir",
            "names": [
                "Investir"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:23.949Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Investir"
        },
        "jardin-d'acclimatation": {
            "key": "jardin-d'acclimatation",
            "names": [
                "Jardin d'Acclimatation"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:24.242Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Jardin_d'Acclimatation",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/c/c0/Jardin_d%27acclimatation_-_Fondation_Louis_Vuitton.jpg/250px-Jardin_d%27acclimatation_-_Fondation_Louis_Vuitton.jpg",
            "siteUrl": "https://www.jardindacclimatation.fr/"
        },
        "le-parisien": {
            "key": "le-parisien",
            "names": [
                "Le Parisien"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:24.960Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Le_Parisien",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/2/27/Le_Parisien_logo.svg/250px-Le_Parisien_logo.svg.png",
            "siteUrl": "http://leparisien.fr/"
        },
        "les-echos": {
            "key": "les-echos",
            "names": [
                "Les Echos"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:25.468Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Les_Echos_(France)",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/1/15/Logo_Les_%C3%89chos.svg/250px-Logo_Les_%C3%89chos.svg.png",
            "siteUrl": "http://lesechos.fr/"
        },
        "paris-match": {
            "key": "paris-match",
            "names": [
                "Paris Match"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:25.901Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Paris_Match",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/e/ee/Paris_Match_1981_logo.svg/250px-Paris_Match_1981_logo.svg.png",
            "siteUrl": "https://www.parismatch.com/"
        },
        "radio-classique": {
            "key": "radio-classique",
            "names": [
                "Radio Classique"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:26.091Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Radio_Classique",
            "siteUrl": "http://radioclassique.fr/"
        },
        "royal-van-lent": {
            "key": "royal-van-lent",
            "names": [
                "Royal Van Lent"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "fashion",
                "clothing"
            ],
            "score": 35,
            "ownedBy": [
                "lvmh"
            ],
            "updatedAt": "2026-09-23T07:31:26.329Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Feadship",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/2/29/Feadship_logo.jpg/250px-Feadship_logo.jpg",
            "siteUrl": "https://www.feadship.nl/"
        },
        "berkshire-hathaway": {
            "key": "berkshire-hathaway",
            "names": [
                "Berkshire Hathaway",
                "Berkshire Hathaway Inc.",
                "Berkshire",
                "BRK",
                "BRK.A",
                "BRK.B"
            ],
            "comment": "Berkshire Hathaway is an American conglomerate that has ignored climate risk in insurance underwriting [1], financed unsustainable coal power generation [2], polluted its local environment and rivers [3][4], and negligently caused wildfires through faulty electrical lines and failing to shut off power [5][6][7][8]. It has also compromised consumer data security [9], used prison labor [10], engaged in racial discrimination in mortgage lending and redlining [11][12], failed to report safety defects and launch recalls [13], and exposed employees to unsafe working conditions leading to injury [14].",
            "sources": {
                "1": "https://global.insure-our-future.com/scorecard/",
                "2": "https://www.brkenergy.com/energy/coal.aspx",
                "3": "https://www.justice.gov/opa/pr/epa-requires-global-titanium-manufacturer-investigate-and-clean-pcb-contamination-nevada",
                "4": "https://nj.gov/oag/newsreleases14/pr20141217a.html",
                "5": "https://www.justice.gov/usao-or/pr/pacificorp-agrees-pay-575-million-settle-claims-damage-caused-six-wildfires-oregon-and",
                "6": "https://www.sec.gov/ixviewer/ix.html?doc=/Archives/edgar/data/75594/000007559423000015/pacificorp-20231205.htm",
                "7": "https://www.sec.gov/ixviewer/ix.html?doc=/Archives/edgar/data/75594/000007559423000020/pacificorp-20231215.htm",
                "8": "https://justthenews.com/nation/states/center-square/pacific-power-reaches-178-million-settlement-role-2020-labor-day",
                "9": "https://ag.ny.gov/press-release/2024/attorney-general-james-and-dfs-superintendent-harris-secure-113-million-auto",
                "10": "https://investigate.afsc.org/company/berkshire-hathaway",
                "11": "https://www.consumerfinance.gov/about-us/newsroom/cfpb-doj-order-trident-mortgage-company-to-pay-more-than-22-million-for-deliberate-discrimination-against-minority-families/",
                "12": "https://www.justice.gov/opa/pr/justice-department-and-consumer-financial-protection-bureau-secure-agreement-trident-mortgage",
                "13": "https://web.archive.org/web/20180423205634/https://www.nhtsa.gov/press-releases/us-dot-fines-spartan-motors-inc-and-forest-river-inc-failure-announce-recalls-and",
                "14": "https://web.archive.org/web/20230325083008/https://press.hse.gov.uk/2023/03/16/firm-receives-190k-fine-after-worker-seriously-injured/"
            },
            "sourceNotes": {
                "1": "ignored climate risk in insurance underwriting",
                "2": "finances unsustainable coal power generation",
                "3": "pollution of local environment",
                "4": "polluted local rivers",
                "5": "negligently caused wildfires through faulty electrical lines",
                "6": "negligently caused wildfires through faulty electrical lines",
                "7": "negligently caused wildfires through faulty electrical lines",
                "8": "worsened wildfires by failing to shut off power",
                "9": "poor information security leading to consumer data breach",
                "10": "used prison labor",
                "11": "racial discrimination in mortgage lending",
                "12": "racial discrimination through redlining",
                "13": "failed to report safety defects and launch recalls",
                "14": "employee injured in unsafe working conditions"
            },
            "tags": [
                "finance",
                "unsustainable practices",
                "fossil fuels",
                "environmental violations",
                "privacy violations",
                "data breach",
                "forced labour",
                "racial discrimination",
                "unsafe working conditions",
                "unsafe practices",
                "greenwashing"
            ],
            "score": 17,
            "ownedBy": [],
            "logoUrl": "https://thumb.wikimedia.org/wikipedia/commons/thumb/2/23/Berkshire_Hathaway.svg/250px-Berkshire_Hathaway.svg.png",
            "siteUrl": "https://www.berkshirehathaway.com/",
            "updatedAt": "2026-09-24T22:33:33.062Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Berkshire_Hathaway"
        },
        "berkshire-hathaway-assurance": {
            "key": "berkshire-hathaway-assurance",
            "names": [
                "Berkshire Hathaway Assurance"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "finance"
            ],
            "score": 17,
            "ownedBy": [
                "berkshire-hathaway"
            ],
            "updatedAt": "2026-09-26T01:53:11.578Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Berkshire_Hathaway_Assurance"
        },
        "central-states-indemnity": {
            "key": "central-states-indemnity",
            "names": [
                "Central States Indemnity"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "finance"
            ],
            "score": 17,
            "ownedBy": [
                "berkshire-hathaway"
            ],
            "updatedAt": "2026-09-26T01:53:12.847Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Central_States_Indemnity"
        },
        "gen-re": {
            "key": "gen-re",
            "names": [
                "Gen Re"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "finance"
            ],
            "score": 17,
            "ownedBy": [
                "berkshire-hathaway"
            ],
            "updatedAt": "2026-09-26T01:53:13.480Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Gen_Re",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/c/c2/Gen_Re_logo.svg/250px-Gen_Re_logo.svg.png",
            "siteUrl": "http://genre.com/"
        },
        "usli": {
            "key": "usli",
            "names": [
                "USLI"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "finance"
            ],
            "score": 17,
            "ownedBy": [
                "berkshire-hathaway"
            ],
            "updatedAt": "2026-09-26T01:53:13.563Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/USLI",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/2/23/Berkshire_Hathaway.svg/250px-Berkshire_Hathaway.svg.png",
            "siteUrl": "https://www.berkshirehathaway.com/"
        },
        "bnsf-railway": {
            "key": "bnsf-railway",
            "names": [
                "BNSF Railway"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "finance"
            ],
            "score": 17,
            "ownedBy": [
                "berkshire-hathaway"
            ],
            "updatedAt": "2026-09-26T01:53:14.323Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/BNSF_Railway",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/2/2d/BNSF_Railway_Company_logo.svg/250px-BNSF_Railway_Company_logo.svg.png",
            "siteUrl": "https://bnsf.com/"
        },
        "berkshire-hathaway-energy": {
            "key": "berkshire-hathaway-energy",
            "names": [
                "Berkshire Hathaway Energy"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "finance"
            ],
            "score": 17,
            "ownedBy": [
                "berkshire-hathaway"
            ],
            "updatedAt": "2026-09-26T01:53:14.700Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Berkshire_Hathaway_Energy",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/0/03/Berkshire_Hathaway_Energy_Logo.svg/250px-Berkshire_Hathaway_Energy_Logo.svg.png",
            "siteUrl": "https://brkenergy.com/"
        },
        "pilot-flying-j": {
            "key": "pilot-flying-j",
            "names": [
                "Pilot Flying J"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "finance"
            ],
            "score": 17,
            "ownedBy": [
                "berkshire-hathaway"
            ],
            "updatedAt": "2026-09-26T01:53:14.915Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Pilot_Flying_J",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/8/88/Pilot_Flying_J_logo.svg/250px-Pilot_Flying_J_logo.svg.png",
            "siteUrl": "http://pilotflyingj.com/"
        },
        "benjamin-moore-and-co.": {
            "key": "benjamin-moore-and-co.",
            "names": [
                "Benjamin Moore & Co."
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "finance"
            ],
            "score": 17,
            "ownedBy": [
                "berkshire-hathaway"
            ],
            "updatedAt": "2026-09-26T01:53:15.016Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Benjamin_Moore_&amp;_Co."
        },
        "clayton-homes": {
            "key": "clayton-homes",
            "names": [
                "Clayton Homes"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "finance"
            ],
            "score": 17,
            "ownedBy": [
                "berkshire-hathaway"
            ],
            "updatedAt": "2026-09-26T01:53:15.248Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Clayton_Homes",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/3/32/Clayton_Homes_logo.png",
            "siteUrl": "http://www.claytonhomes.com/"
        },
        "ctb-international": {
            "key": "ctb-international",
            "names": [
                "CTB International"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "finance"
            ],
            "score": 17,
            "ownedBy": [
                "berkshire-hathaway"
            ],
            "updatedAt": "2026-09-26T01:53:15.382Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/CTB_International",
            "siteUrl": "https://www.ctbinc.com/"
        },
        "fruit-of-the-loom": {
            "key": "fruit-of-the-loom",
            "names": [
                "Fruit of the Loom"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "finance"
            ],
            "score": 17,
            "ownedBy": [
                "berkshire-hathaway"
            ],
            "updatedAt": "2026-09-26T01:53:16.044Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Fruit_of_the_Loom",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/0/0d/Fruit_logo.svg/250px-Fruit_logo.svg.png",
            "siteUrl": "https://www.fruit.com/"
        },
        "johns-manville": {
            "key": "johns-manville",
            "names": [
                "Johns Manville"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "finance"
            ],
            "score": 17,
            "ownedBy": [
                "berkshire-hathaway"
            ],
            "updatedAt": "2026-09-26T01:53:16.164Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Johns_Manville",
            "siteUrl": "http://www.jm.com/"
        },
        "lubrizol": {
            "key": "lubrizol",
            "names": [
                "Lubrizol"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "finance"
            ],
            "score": 17,
            "ownedBy": [
                "berkshire-hathaway"
            ],
            "updatedAt": "2026-09-26T01:53:16.904Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Lubrizol",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/8/88/Lubrizol_Logo_2017.png/250px-Lubrizol_Logo_2017.png",
            "siteUrl": "http://www.lubrizol.com/"
        },
        "precision-castparts-corp": {
            "key": "precision-castparts-corp",
            "names": [
                "Precision Castparts Corp"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "finance"
            ],
            "score": 17,
            "ownedBy": [
                "berkshire-hathaway"
            ],
            "updatedAt": "2026-09-26T01:53:17.110Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Precision_Castparts_Corp",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/9/96/Precision_Castparts_logo.svg/250px-Precision_Castparts_logo.svg.png",
            "siteUrl": "http://www.precast.com/"
        },
        "scott-fetzer-company": {
            "key": "scott-fetzer-company",
            "names": [
                "Scott Fetzer Company"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "finance"
            ],
            "score": 17,
            "ownedBy": [
                "berkshire-hathaway"
            ],
            "updatedAt": "2026-09-26T01:53:17.604Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Scott_Fetzer_Company",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/4/48/ScottFetzerLogo.png/250px-ScottFetzerLogo.png",
            "siteUrl": "https://scottfetzer.com/"
        },
        "ben-bridge-jeweler": {
            "key": "ben-bridge-jeweler",
            "names": [
                "Ben Bridge Jeweler"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "finance"
            ],
            "score": 17,
            "ownedBy": [
                "berkshire-hathaway"
            ],
            "updatedAt": "2026-09-26T01:53:18.011Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Ben_Bridge_Jeweler",
            "siteUrl": "http://www.benbridge.com/"
        },
        "business-wire": {
            "key": "business-wire",
            "names": [
                "Business Wire"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "finance"
            ],
            "score": 17,
            "ownedBy": [
                "berkshire-hathaway"
            ],
            "updatedAt": "2026-09-26T01:53:18.516Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Business_Wire",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/a/a6/BusinessWire_Logo.svg/250px-BusinessWire_Logo.svg.png",
            "siteUrl": "http://businesswire.com/"
        },
        "dairy-queen": {
            "key": "dairy-queen",
            "names": [
                "Dairy Queen"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "finance"
            ],
            "score": 17,
            "ownedBy": [
                "berkshire-hathaway"
            ],
            "updatedAt": "2026-09-26T01:53:18.583Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Dairy_Queen",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/a/ae/Dairy_Queen_logo.svg/250px-Dairy_Queen_logo.svg.png",
            "siteUrl": "http://dairyqueen.com/"
        },
        "homeservices-of-america": {
            "key": "homeservices-of-america",
            "names": [
                "HomeServices of America"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "finance"
            ],
            "score": 17,
            "ownedBy": [
                "berkshire-hathaway"
            ],
            "updatedAt": "2026-09-26T01:53:18.889Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/HomeServices_of_America",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/9/95/Logo_of_HomeServices_of_America.png/250px-Logo_of_HomeServices_of_America.png",
            "siteUrl": "https://www.homeservices.com/"
        },
        "mclane-company": {
            "key": "mclane-company",
            "names": [
                "McLane Company"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "finance"
            ],
            "score": 17,
            "ownedBy": [
                "berkshire-hathaway"
            ],
            "updatedAt": "2026-09-26T01:53:19.319Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/McLane_Company",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/2/2b/McLane_logo.gif",
            "siteUrl": "http://www.mclaneco.com/"
        },
        "netjets": {
            "key": "netjets",
            "names": [
                "NetJets"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "finance"
            ],
            "score": 17,
            "ownedBy": [
                "berkshire-hathaway"
            ],
            "updatedAt": "2026-09-26T01:53:19.636Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/NetJets",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/9/9d/NetJets_logo.svg/250px-NetJets_logo.svg.png",
            "siteUrl": "https://www.netjets.com/"
        },
        "oriental-trading-company": {
            "key": "oriental-trading-company",
            "names": [
                "Oriental Trading Company"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "finance"
            ],
            "score": 17,
            "ownedBy": [
                "berkshire-hathaway"
            ],
            "updatedAt": "2026-09-26T01:53:19.796Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Oriental_Trading_Company",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/2/2a/Otc75Logo.gif",
            "siteUrl": "http://orientaltrading.com/"
        },
        "pampered-chef": {
            "key": "pampered-chef",
            "names": [
                "Pampered Chef"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "finance"
            ],
            "score": 17,
            "ownedBy": [
                "berkshire-hathaway"
            ],
            "updatedAt": "2026-09-26T01:53:19.989Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Pampered_Chef",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/3/3d/Pamperedchief.png",
            "siteUrl": "http://www.pamperedchef.com/"
        },
        "see's-candies": {
            "key": "see's-candies",
            "names": [
                "See's Candies"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "finance"
            ],
            "score": 17,
            "ownedBy": [
                "berkshire-hathaway"
            ],
            "updatedAt": "2026-09-26T01:53:20.179Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/See's_Candies",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/4/41/See%27s_Candies_logo.svg/250px-See%27s_Candies_logo.svg.png",
            "siteUrl": "http://sees.com/"
        },
        "star-furniture": {
            "key": "star-furniture",
            "names": [
                "Star Furniture"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "finance"
            ],
            "score": 17,
            "ownedBy": [
                "berkshire-hathaway"
            ],
            "updatedAt": "2026-09-26T01:53:20.905Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Star_Furniture",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/7/72/Star_furniture_texas_logo.png/250px-Star_furniture_texas_logo.png",
            "siteUrl": "http://www.starfurniture.com/"
        },
        "wplg": {
            "key": "wplg",
            "names": [
                "WPLG"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "finance"
            ],
            "score": 17,
            "ownedBy": [
                "berkshire-hathaway"
            ],
            "updatedAt": "2026-09-26T01:53:21.472Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/WPLG",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/d/dd/WPLG_Local_10_%282014%2C_without_ABC_logo%29.svg/250px-WPLG_Local_10_%282014%2C_without_ABC_logo%29.svg.png",
            "siteUrl": "https://www.local10.com/"
        },
        "pacificorp": {
            "key": "pacificorp",
            "names": [
                "PacifiCorp"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "finance"
            ],
            "score": 17,
            "ownedBy": [
                "berkshire-hathaway"
            ],
            "updatedAt": "2026-09-26T01:53:21.776Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/PacifiCorp",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/b/b1/PacifCorp_logo.svg/250px-PacifCorp_logo.svg.png",
            "siteUrl": "https://www.pacificorp.com/"
        },
        "dick's-sporting-goods": {
            "key": "dick's-sporting-goods",
            "names": [
                "Dick's Sporting Goods",
                "Dick's Sporting Goods, Inc.",
                "DICK'S Sporting Goods",
                "DKS"
            ],
            "comment": "Dick's Sporting Goods is an American sporting goods retailer that has been accused of withholding commissions from golf sales associates [1] and failing to pay overtime wages [2][3], while also underpaying employees [4].",
            "sources": {
                "1": "https://www.reddit.com/r/golf/comments/1czrjp3/dicks_sporting_goods_sued_for_hiding_golf/",
                "2": "https://www.law360.com/articles/222904/dick-s-to-pay-up-to-15-5m-to-settle-ot-actions",
                "3": "https://www.law360.com/articles/735906",
                "4": "https://www.bigclassaction.com/settlement/7-1m-settlement-final-in-foot-locker-wage-hour.php"
            },
            "sourceNotes": {
                "1": "withheld commissions from golf sales associates",
                "2": "failed to pay overtime wages",
                "3": "failed to pay overtime wages",
                "4": "underpaid employees"
            },
            "tags": [
                "sportswear",
                "retail",
                "unfair pay"
            ],
            "score": 43,
            "ownedBy": [],
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/3/33/New_Dick%27s_Sporting_Goods_logo.svg/250px-New_Dick%27s_Sporting_Goods_logo.svg.png",
            "siteUrl": "https://www.dickssportinggoods.com/",
            "updatedAt": "2026-09-26T08:33:23.924Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Dick%27s_Sporting_Goods"
        },
        "gamechanger": {
            "key": "gamechanger",
            "names": [
                "GameChanger"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "sportswear",
                "retail"
            ],
            "score": 43,
            "ownedBy": [
                "dick's-sporting-goods"
            ],
            "updatedAt": "2026-09-26T08:44:37.752Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/GameChanger",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/c/c1/GameChanger_Logo.jpg/250px-GameChanger_Logo.jpg",
            "siteUrl": "https://en.wikipedia.org/wiki/Mobile_application"
        },
        "wonder-group": {
            "key": "grubhub",
            "names": [
                "Wonder Group"
            ],
            "comment": "Wonder Group is an American food delivery company that has engaged in unlawful conduct towards drivers, customers, and restaurants [1], falsely advertised restaurant partnerships [2], and misled customers and drivers about costs and earnings [3]. It has also employed deceptive pricing and subscription practices [4], failed to pay minimum wage [5], and circumvented minimum wage law via subcontracting deliveries [6][7].",
            "sources": {
                "1": "https://www.ftc.gov/news-events/news/press-releases/2026/08/ftc-sends-more-238-million-drivers-diners-harmed-grubhubs-deceptive-advertising-claims-other",
                "2": "https://www.reuters.com/legal/government/grubhub-agrees-pay-restaurants-7-million-false-advertising-case-2025-08-27/",
                "3": "https://www.nbcnews.com/business/business-news/grubhub-settlement-25-million-charges-allegedly-misled-diners-drivers-rcna184582",
                "4": "https://www.regulatoryoversight.com/2025/01/ftc-and-illinois-ag-settle-matter-against-grubhub-for-140m/",
                "5": "https://nypost.com/2026/04/01/lifestyle/grubhub-exploited-legal-loophole-to-avoid-paying-minimum-wage/",
                "6": "https://nyc.streetsblog.org/2026/03/31/maximum-rage-grubhub-outsourced-delivery-work-to-skirt-city-minimum-wage-docs-show",
                "7": "https://www.law360.com/articles/2449460/grubhub-s-24-8m-deal-to-end-driver-fight-nears-initial-ok"
            },
            "sourceNotes": {
                "1": "unlawful conduct towards drivers, customers, and restaurants",
                "2": "falsely advertised restaurant partnerships",
                "3": "misled customers and drivers about costs and earnings",
                "4": "engaged in deceptive pricing and subscription practices",
                "5": "failed to pay minimum wage",
                "6": "circumvented minimum wage law via subcontracting deliveries",
                "7": "circumvented minimum wage law via subcontracting deliveries"
            },
            "tags": [
                "fast food",
                "deception",
                "unfair pay"
            ],
            "score": 43,
            "ownedBy": [],
            "logoUrl": "https://s21.q4cdn.com/947563309/files/design/slider/wonder-logo-snap-pea.png",
            "siteUrl": "https://about.wonder.com/overview/default.aspx",
            "updatedAt": "2026-09-27T21:56:26.607Z"
        },
        "lindt": {
            "key": "lindt",
            "names": [
                "Lindt",
                "Chocoladefabriken Lindt & Sprüngli AG",
                "LISN",
                "LISP"
            ],
            "comment": "Lindt is a Swiss chocolate company that has been accused of committing environmental violations [1][2] and of using child labor in its cocoa supply chain [3][4]. The company has also misled consumers about child labor practices [5] and sold chocolate with lead and cadmium contamination [6][7][8].",
            "sources": {
                "1": "https://archive.epa.gov/epapages/newsroom_archive/newsreleases/593c4dbcbfac739785257a2400729d93.html",
                "2": "https://archive.epa.gov/epapages/newsroom_archive/newsreleases/119f7457e0cf5c6085257911004b0b2f.html",
                "3": "https://www.sustainalytics.com/esg-research/resource/investors-esg-blog/child-labor-in-cocoa-supply-chains--unveiling-the-layers-of-human-rights-challenges",
                "4": "https://www.confectionerynews.com/Article/2024/01/17/Lindt-Spruengli-hit-with-child-labor-allegations-in-cocoa-supply-chain/",
                "5": "https://www.reuters.com/sustainability/land-use-biodiversity/swiss-chocolate-maker-lindt-misleads-consumers-about-child-labor-us-lawsuit-2026-07-23/",
                "6": "https://m.economictimes.com/news/international/global-trends/heavy-metals-found-in-expertly-crafted-lindt-chocolates-how-safe-is-your-favorite-treat/articleshow/115523807.cms",
                "7": "https://fortune.com/europe/2024/11/12/lindt-us-lawsuit/",
                "8": "https://thepalladiumgroup.com/news/Lindt-Lawsuit-is-a-Symptom-the-Chocolate-Industry-Real-Problem-is-Structural"
            },
            "sourceNotes": {
                "1": "committed environmental violations",
                "2": "committed environmental violations",
                "3": "child labor in cocoa supply chain",
                "4": "child labor in cocoa supply chain",
                "5": "misleading consumers about child labor in cocoa supply chain",
                "6": "sold chocolate with lead and cadmium contamination",
                "7": "sold chocolate with lead and cadmium contamination",
                "8": "sold chocolate with lead and cadmium contamination"
            },
            "tags": [
                "confectionery",
                "child labour",
                "deception",
                "environmental violations",
                "unsustainable practices"
            ],
            "score": 29,
            "ownedBy": [],
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/8/8e/Lindt_%26_Spr%C3%BCngli.svg/250px-Lindt_%26_Spr%C3%BCngli.svg.png",
            "siteUrl": "https://www.lindt-spruengli.com/",
            "updatedAt": "2026-09-29T09:53:55.057Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Lindt"
        },
        "russell-stover": {
            "key": "russell-stover",
            "names": [
                "Russell Stover"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "confectionery"
            ],
            "score": 29,
            "ownedBy": [
                "lindt"
            ],
            "updatedAt": "2026-09-29T15:21:34.851Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Russell_Stover_Candies",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/3/35/Russell_Stover_Candies_logo.svg/250px-Russell_Stover_Candies_logo.svg.png",
            "siteUrl": "http://www.russellstover.com/"
        },
        "caffarel": {
            "key": "caffarel",
            "names": [
                "Caffarel"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "confectionery"
            ],
            "score": 29,
            "ownedBy": [
                "lindt"
            ],
            "updatedAt": "2026-09-29T15:21:35.382Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Caffarel"
        },
        "itausa": {
            "key": "itausa",
            "names": [
                "Itaúsa",
                "Itausa",
                "Itaúsa Investimentos Itaú S.A.",
                "ITSA3",
                "ITSA4"
            ],
            "comment": "Itaúsa is a Brazilian conglomerate involved in corruption [1] which has also faced anti-money laundering failures [2][3].",
            "sources": {
                "1": "https://www.sbs.com.au/news/article/havaianas-the-new-symbol-of-corruption-in-brazil/jkpsekrxn",
                "2": "https://insightcrime.org/news/paraguay-money-laundering-impunity/",
                "3": "https://www.moneylaunderingbulletin.com/legalandregulatory/cases/banco-itau-fined-us9.64m-in-paraguay-for-reporting-failures--1.htm"
            },
            "sourceNotes": {
                "1": "involved in corruption",
                "2": "anti-money laundering failure",
                "3": "anti-money laundering failure"
            },
            "tags": [
                "finance",
                "corruption"
            ],
            "score": 44,
            "ownedBy": [],
            "logoUrl": "https://thumb.wikimedia.org/wikipedia/commons/thumb/2/25/Logotipo_da_Ita%C3%BAsa_%282025%29.svg/250px-Logotipo_da_Ita%C3%BAsa_%282025%29.svg.png",
            "siteUrl": "http://www.itausa.com.br/",
            "updatedAt": "2026-09-30T07:05:45.274Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Itaúsa"
        },
        "duratex": {
            "key": "duratex",
            "names": [
                "Duratex"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "finance"
            ],
            "score": 44,
            "ownedBy": [
                "itausa"
            ],
            "updatedAt": "2026-09-30T13:14:26.635Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Duratex_S.A.",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/c/c4/Logotipo_da_Dexco.svg/250px-Logotipo_da_Dexco.svg.png",
            "siteUrl": "http://www.dex.co/"
        },
        "alpargatas-s.a.": {
            "key": "alpargatas-s.a.",
            "names": [
                "Alpargatas S.A."
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "finance"
            ],
            "score": 44,
            "ownedBy": [
                "itausa"
            ],
            "updatedAt": "2026-09-30T13:14:26.694Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Alpargatas_S.A.",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/8/80/Alpargatas-logo.svg/250px-Alpargatas-logo.svg.png",
            "siteUrl": "https://alpargatas.com.br/"
        },
        "itau-unibanco": {
            "key": "itau-unibanco",
            "names": [
                "Itaú Unibanco"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "finance"
            ],
            "score": 44,
            "ownedBy": [
                "itausa"
            ],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/1/19/Ita%C3%BA_Unibanco_logo_2023.svg?utm_source=commons.wikimedia.org&utm_campaign=index&utm_content=original",
            "siteUrl": "http://www.itau.com.br/",
            "updatedAt": "2026-09-30T13:13:03.958Z"
        },
        "paramount": {
            "key": "paramount",
            "names": [
                "Paramount",
                "Paramount Skydance",
                "Paramount Global",
                "ViacomCBS",
                "PARA",
                "PSKY"
            ],
            "comment": "Paramount is an American media company that has engaged in monopolistic price fixing [1], failed to pay overtime [2], and has a record of sex [3] and age [4] discrimination against employees. The company has also been linked to unsafe working conditions that injured employees [5], executed a merger violating antitrust law [6], made illegal promises to secure regulatory approval [7], paid bribes to Trump for merger approval [8], and enabled the abuse of child actors [9][10][11].",
            "sources": {
                "1": "https://www.law360.com/articles/1732040/ad-buyers-want-final-ok-for-48m-deal-with-cbs-fox-cox",
                "2": "https://www.law360.com/articles/1126032/cbs-gets-10m-ot-deal-with-parking-spot-guards-approved",
                "3": "https://www.eeoc.gov/eeoc/newsroom/release/archive/10-25-00.html",
                "4": "https://www.eeoc.gov/newsroom/cbs-broadcast-affiliate-texas-pay-215000-settle-eeoc-age-suit-female-reporter",
                "5": "https://www.osha.gov/ords/imis/establishment.inspection_detail?id=126061597",
                "6": "https://www.theguardian.com/media/2026/jul/17/paramount-warner-bros-merger",
                "7": "https://www.latimes.com/entertainment-arts/business/story/2026-07-15/paramount-shareholder-lawsuit-accuses-ellisons-of-corruption",
                "8": "https://variety.com/2025/tv/news/warren-paramount-skydance-trump-side-deal-investigation-1236476697/",
                "9": "https://www.nytimes.com/2021/06/30/arts/dan-schneider-nickelodeon.html",
                "10": "https://www.washingtonpost.com/arts-entertainment/2022/08/05/jennette-mccurdy-memoir-interview/",
                "11": "https://variety.com/2022/tv/news/jennette-mccurdy-icarly-nickelodeon-hush-money-1235334535/"
            },
            "sourceNotes": {
                "1": "engaged in monopolistic price fixing",
                "2": "failed to pay overtime",
                "3": "sex discrimination against employees",
                "4": "age discrimination against employees",
                "5": "employees injured in unsafe working conditions",
                "6": "executed merger violating antitrust law",
                "7": "made illegal promises to secure regulatory approval",
                "8": "paid bribes to Trump for merger approval",
                "9": "enabled abuse of child actors",
                "10": "enabled abuse of child actors",
                "11": "enabled abuse of child actors"
            },
            "tags": [
                "entertainment",
                "media",
                "anticompetitive practices",
                "unfair pay",
                "gender discrimination",
                "unsafe working conditions",
                "deception",
                "corruption",
                "child labour"
            ],
            "score": 36,
            "ownedBy": [],
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/1/1e/Paramount_Global.svg/250px-Paramount_Global.svg.png",
            "siteUrl": "https://www.paramount.com/",
            "updatedAt": "2026-10-01T21:20:02.364Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Paramount_Global"
        },
        "bet": {
            "key": "bet",
            "names": [
                "BET"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 36,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-10-01T22:15:07.123Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/BET",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/b/bd/BET-2021Logo.svg/250px-BET-2021Logo.svg.png",
            "siteUrl": "https://www.bet.com/"
        },
        "cbs": {
            "key": "cbs",
            "names": [
                "CBS"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 36,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-10-01T22:15:07.243Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/CBS",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/e/ee/CBS_logo_%282020%29.svg/250px-CBS_logo_%282020%29.svg.png",
            "siteUrl": "https://www.cbs.com/"
        },
        "comedy-central": {
            "key": "comedy-central",
            "names": [
                "Comedy Central"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 36,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-10-01T22:15:08.786Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Comedy_Central",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/a/aa/Comedy_Central_2018.svg/250px-Comedy_Central_2018.svg.png",
            "siteUrl": "https://cc.com/"
        },
        "mtv": {
            "key": "mtv",
            "names": [
                "MTV"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 36,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-10-01T22:15:08.934Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/MTV",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/6/68/MTV_2021_%28brand_version%29.svg/250px-MTV_2021_%28brand_version%29.svg.png",
            "siteUrl": "https://www.mtv.com/"
        },
        "network-10": {
            "key": "network-10",
            "names": [
                "Network 10"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 36,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-10-01T22:15:09.202Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Network_10",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/9/91/Network_10_logo_2025.svg/250px-Network_10_logo_2025.svg.png",
            "siteUrl": "http://10.com.au/"
        },
        "nickelodeon": {
            "key": "nickelodeon",
            "names": [
                "Nickelodeon"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 36,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-10-01T22:15:09.546Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Nickelodeon",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/e/e5/Nickelodeon_2023_logo_%28outline%29.svg/250px-Nickelodeon_2023_logo_%28outline%29.svg.png",
            "siteUrl": "http://nick.com/"
        },
        "nick-jr.": {
            "key": "nick-jr.",
            "names": [
                "Nick Jr."
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 36,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-10-01T22:15:09.802Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Nick_Jr._Channel",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/e/e0/Nick_Jr._logo_2023.svg/250px-Nick_Jr._logo_2023.svg.png",
            "siteUrl": "https://web.archive.org/web/20240729053942/http://www.nickjr.com/"
        },
        "paramount+": {
            "key": "paramount+",
            "names": [
                "Paramount+"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 36,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-10-01T22:15:10.360Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Paramount+",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/a/a5/Paramount_Plus.svg/250px-Paramount_Plus.svg.png",
            "siteUrl": "https://en.wikipedia.org/wiki/File:Paramount+_Website.png"
        },
        "paramount-network": {
            "key": "paramount-network",
            "names": [
                "Paramount Network"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 36,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-10-01T22:15:10.741Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Paramount_Network",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/5/57/Paramount_Network_2024.svg/250px-Paramount_Network_2024.svg.png",
            "siteUrl": "https://www.paramountnetwork.com/"
        },
        "paramount-pictures": {
            "key": "paramount-pictures",
            "names": [
                "Paramount Pictures"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 36,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-10-01T22:15:10.935Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Paramount_Pictures",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/2/2a/Paramount_Pictures_with_Skydance_byline.svg/250px-Paramount_Pictures_with_Skydance_byline.svg.png",
            "siteUrl": "https://www.paramountpictures.com/"
        },
        "paramount-animation": {
            "key": "paramount-animation",
            "names": [
                "Paramount Animation"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 36,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-10-01T22:15:11.279Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Paramount_Animation",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/8/8f/Paramount_Animation_2025.svg/250px-Paramount_Animation_2025.svg.png",
            "siteUrl": "http://www.paramountanimation.com/"
        },
        "pluto-tv": {
            "key": "pluto-tv",
            "names": [
                "Pluto TV"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 36,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-10-01T22:15:11.568Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Pluto_TV",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/5/5b/Pluto_TV_logo_2024_black.svg/250px-Pluto_TV_logo_2024_black.svg.png",
            "siteUrl": "https://en.wikipedia.org/wiki/Entertainment"
        },
        "pop": {
            "key": "pop",
            "names": [
                "Pop"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 36,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-10-01T22:15:11.752Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Pop_(American_TV_channel)",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/a/a5/Pop_Network_Logo.svg/250px-Pop_Network_Logo.svg.png",
            "siteUrl": "https://www.poptv.com/"
        },
        "showtime": {
            "key": "showtime",
            "names": [
                "Showtime"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 36,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-10-01T22:15:12.363Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Showtime_(TV_network)",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/2/22/Showtime.svg/250px-Showtime.svg.png"
        },
        "skydance-animation": {
            "key": "skydance-animation",
            "names": [
                "Skydance Animation"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 36,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-10-01T22:15:12.699Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Skydance_Animation",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/9/97/Skydance_Animation_Logo_2020.svg/250px-Skydance_Animation_Logo_2020.svg.png",
            "siteUrl": "https://skydance.com/animation/"
        },
        "skydance-sports": {
            "key": "skydance-sports",
            "names": [
                "Skydance Sports"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 36,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-10-01T22:15:13.557Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Skydance_Sports",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/0/0f/Skydance_Media_2020.svg/250px-Skydance_Media_2020.svg.png",
            "siteUrl": "https://skydance.com/sports"
        },
        "smithsonian-channel": {
            "key": "smithsonian-channel",
            "names": [
                "Smithsonian Channel"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 36,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-10-01T22:15:14.192Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Smithsonian_Channel",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/b/b6/Smithsonian_Channel_current_logo.png/330px-Smithsonian_Channel_current_logo.png",
            "siteUrl": "https://www.smithsonianchannel.com/"
        },
        "tv-land": {
            "key": "tv-land",
            "names": [
                "TV Land"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "entertainment",
                "media"
            ],
            "score": 36,
            "ownedBy": [
                "paramount"
            ],
            "updatedAt": "2026-10-01T22:15:14.687Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/TV_Land",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/8/87/TV_Land_2015_logo.svg/250px-TV_Land_2015_logo.svg.png",
            "siteUrl": "https://www.tvland.com/"
        },
        "groupe-seb": {
            "key": "groupe-seb",
            "names": [
                "Groupe SEB",
                "SEB S.A.",
                "SEB",
                "SK"
            ],
            "comment": "Groupe SEB is a French company that has engaged in tax avoidance [1], price fixing of household appliances [2][3], monopolistic restriction of competition [4], and suppression of competitors through legal action [5]. It has sold unsafe products and cookware [6][7][8], released toxic and forever chemicals into products [9][10], polluted local water supplies [11], illegally avoided recycling waste [12], and continued business in Russia after pledging to exit [13].",
            "sources": {
                "1": "https://www.nytimes.com/2019/09/24/nyregion/nj-tax-break.html",
                "2": "https://www.reuters.com/business/retail-consumer/france-fines-12-household-appliance-firms-635-million-price-fixing-2024-12-19/",
                "3": "https://www.autoritedelaconcurrence.fr/en/press-release/autorite-imposes-fines-eu611-million-10-manufacturers-and-2-distributors-household",
                "4": "https://uohs.gov.cz/cs/informacni-centrum/tiskove-zpravy/hospodarska-soutez/3849-urad-ulozil-pokutu-72-milionu-korun-distributorovi-vyrobku-moulinex-rowenta-krups-ci-tefal.html",
                "5": "https://www.inc.com/amaya-nichole/caraway-was-just-sued-by-its-competitors-here-is-how-its-ceo-responded/91350828",
                "6": "https://web.archive.org/web/20161221021543/https://www.cpsc.gov/PageFiles/94304/seb.pdf",
                "7": "https://www.classaction.org/media/mears-v-all-clad-metalcrafters-llc-et-al.pdf",
                "8": "https://www.petersandpeters.com/case/seb-group-and-its-subsidiary-tefal-faced-with-complaint-for-misleading-commercial-practices/",
                "9": "https://oag.ca.gov/system/files/prop65/settlements/2020-00526S8903.pdf",
                "10": "https://www.novethic.fr/economie-et-social/business-model-en-transition/scandale-pfas-seb-tefal-risque-reputationnel",
                "11": "https://www.lemonde.fr/en/les-decodeurs/article/2023/02/24/rumilly-france-the-world-capital-of-the-frying-pan-and-a-forever-chemical-hotspot_6017093_8.html?srsltid=AU7gw4WaXj9uqfRhH-p_1-CVPD2_BZpGFqoOXLPzSCkEQaaVkxBseH_2",
                "12": "https://web.archive.org/web/20210608153410/https://www.360environmental.co.uk/documents/Enforcement%20Undertakings%20accepted%20by%20the%20Environment%20Agency%20160620%20-%20GOV.UK.pdf",
                "13": "https://leave-russia.org/groupe-seb"
            },
            "sourceNotes": {
                "1": "engaged in tax avoidance",
                "2": "price fixing of household appliances",
                "3": "practiced vertical price fixing to keep appliance prices high",
                "4": "monopolistic restriction of competition",
                "5": "supressed competitors through legal action",
                "6": "sold unsafe products",
                "7": "sold unsafe cookware",
                "8": "sold unsafe cookware",
                "9": "sold products containing toxic chemicals",
                "10": "sold products containing forever checmicals",
                "11": "polluted local water supplies",
                "12": "illegally avoided recycling waste",
                "13": "continued business in Russia after pledging to exit"
            },
            "tags": [
                "appliances",
                "home",
                "tax avoidance",
                "anticompetitive practices",
                "unsafe practices",
                "environmental violations",
                "unsustainable practices",
                "connections to russia"
            ],
            "score": 30,
            "ownedBy": [],
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/4/41/Groupe_SEB_logo.svg/120px-Groupe_SEB_logo.svg.png",
            "siteUrl": "http://www.groupeseb.com/en",
            "updatedAt": "2026-10-02T07:44:11.625Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Groupe_SEB"
        },
        "all-clad": {
            "key": "all-clad",
            "names": [
                "All-Clad"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "appliances",
                "home"
            ],
            "score": 30,
            "ownedBy": [
                "groupe-seb"
            ],
            "updatedAt": "2026-10-02T08:28:15.356Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/All-Clad",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/9/99/All-Clad_logo.jpg/250px-All-Clad_logo.jpg",
            "siteUrl": "http://www.all-clad.com/"
        },
        "emsa": {
            "key": "emsa",
            "names": [
                "Emsa"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "appliances",
                "home"
            ],
            "score": 30,
            "ownedBy": [
                "groupe-seb"
            ],
            "updatedAt": "2026-10-02T08:28:16.070Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Emsa_(company)",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/7/70/EMSA-logo.svg/250px-EMSA-logo.svg.png",
            "siteUrl": "https://www.emsa.com/"
        },
        "krampouz": {
            "key": "krampouz",
            "names": [
                "Krampouz"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "appliances",
                "home"
            ],
            "score": 30,
            "ownedBy": [
                "groupe-seb"
            ],
            "updatedAt": "2026-10-02T08:28:16.328Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Krampouz",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/c/cb/Logo_Krampouz.jpg/250px-Logo_Krampouz.jpg"
        },
        "lagostina": {
            "key": "lagostina",
            "names": [
                "Lagostina"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "appliances",
                "home"
            ],
            "score": 30,
            "ownedBy": [
                "groupe-seb"
            ],
            "updatedAt": "2026-10-02T08:28:16.994Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Lagostina",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/9/94/Lagostina_19561971.png/250px-Lagostina_19561971.png",
            "siteUrl": "http://www.lagostina.com/"
        },
        "mirro": {
            "key": "mirro",
            "names": [
                "Mirro"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "appliances",
                "home"
            ],
            "score": 30,
            "ownedBy": [
                "groupe-seb"
            ],
            "updatedAt": "2026-10-02T08:28:17.048Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Mirro_Aluminum_Company",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/f/fc/Mirro_Brand_Logo.png/250px-Mirro_Brand_Logo.png"
        },
        "moulinex": {
            "key": "moulinex",
            "names": [
                "Moulinex"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "appliances",
                "home"
            ],
            "score": 30,
            "ownedBy": [
                "groupe-seb"
            ],
            "updatedAt": "2026-10-02T08:28:17.882Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Moulinex",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/7/74/Moulinex_Logo.svg/250px-Moulinex_Logo.svg.png",
            "siteUrl": "https://www.moulinex.com/"
        },
        "obh-nordica": {
            "key": "obh-nordica",
            "names": [
                "OBH Nordica"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "appliances",
                "home"
            ],
            "score": 30,
            "ownedBy": [
                "groupe-seb"
            ],
            "updatedAt": "2026-10-02T08:28:18.382Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/OBH_Nordica",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/6/6c/OBH_Nordica_Logo.png"
        },
        "rowenta": {
            "key": "rowenta",
            "names": [
                "Rowenta"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "appliances",
                "home"
            ],
            "score": 30,
            "ownedBy": [
                "groupe-seb"
            ],
            "updatedAt": "2026-10-02T08:28:18.823Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Rowenta",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/6/6a/Logo_Rowenta_%2B_techline.svg/250px-Logo_Rowenta_%2B_techline.svg.png",
            "siteUrl": "http://rowenta.com/"
        },
        "schaerer": {
            "key": "schaerer",
            "names": [
                "Schaerer"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "appliances",
                "home"
            ],
            "score": 30,
            "ownedBy": [
                "groupe-seb"
            ],
            "updatedAt": "2026-10-02T08:28:18.889Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Schaerer_Ltd",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/3/39/Schaerer_logo.svg/250px-Schaerer_logo.svg.png",
            "siteUrl": "https://schaerer.com/"
        },
        "supor": {
            "key": "supor",
            "names": [
                "Supor"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "appliances",
                "home"
            ],
            "score": 30,
            "ownedBy": [
                "groupe-seb"
            ],
            "updatedAt": "2026-10-02T08:28:19.237Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Supor",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/2/27/Supor_logo_2.png/250px-Supor_logo_2.png",
            "siteUrl": "https://www.supor.com/"
        },
        "wearever": {
            "key": "wearever",
            "names": [
                "WearEver"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "appliances",
                "home"
            ],
            "score": 30,
            "ownedBy": [
                "groupe-seb"
            ],
            "updatedAt": "2026-10-02T08:28:19.905Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/WearEver_Cookware"
        },
        "wmf-group": {
            "key": "wmf-group",
            "names": [
                "WMF Group"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "appliances",
                "home"
            ],
            "score": 30,
            "ownedBy": [
                "groupe-seb"
            ],
            "updatedAt": "2026-10-02T08:28:20.431Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/WMF_Group",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/6/69/WMF-Logo.svg/250px-WMF-Logo.svg.png",
            "siteUrl": "https://www.wmf.com/"
        },
        "jingdong-group": {
            "key": "jingdong-group",
            "names": [
                "Jingdong Group",
                "JD.com, Inc.",
                "京东集团",
                "Jīngdōng Jítuán",
                "360buy",
                "京东",
                "360Buy",
                "JD"
            ],
            "comment": "Jingdong Group is a Chinese e-commerce company that failed to prevent a breach of sensitive customer data [1], engaged in corruption [2], and continues operations in Russia [3]. The founder has been accused of raping a young woman, a claim cited in two separate reports [4][5].",
            "sources": {
                "1": "https://dailysecurityreview.com/security-spotlight/jd-com-data-breach-babuk-ransomware-cartel-claims-massive-data-theft/",
                "2": "https://english.visitbeijing.com.cn/article/47ONg3z2TcF",
                "3": "https://leave-russia.org/jd-com",
                "4": "https://www.cnbc.com/2022/10/02/jdcom-founder-and-billionaire-liu-settles-us-rape-civil-suit.html",
                "5": "https://www.bbc.co.uk/news/world-asia-china-63070735"
            },
            "sourceNotes": {
                "1": "failed to prevent breach of sensitive customer data",
                "2": "engaged in corruption",
                "3": "continuing operations in russia",
                "4": "founder raped a young woman",
                "5": "founder raped a young woman"
            },
            "tags": [
                "technology",
                "electronics",
                "data breach",
                "privacy violations",
                "corruption",
                "connections to russia",
                "sexual harassment"
            ],
            "score": 24,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/c/c4/JD.com_logo.png",
            "siteUrl": "https://corporate.jd.com/",
            "updatedAt": "2026-10-03T13:41:19.118Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/JD.com"
        },
        "darden-restaurants": {
            "key": "darden-restaurants",
            "names": [
                "Darden Restaurants",
                "Darden Restaurants, Inc.",
                "Darden",
                "DRI"
            ],
            "comment": "Darden Restaurants is an American restaurant conglomerate that has faced multiple ethical concerns. The company has been accused of underpaying staff [1][2], firing an employee who received a large tip and refusing to pay her [3], discriminating against employees on the basis of race [4][5][6] and age in hiring [7], and maintaining unsafe restaurant decor that has caused customer injuries [8].",
            "sources": {
                "1": "https://www.sec.gov/Archives/edgar/data/940944/000119312507068488/d10q.htm#tx46295_12",
                "2": "https://ecf.nysd.uscourts.gov/cgi-bin/DktRpt.pl?387941",
                "3": "https://creators.yahoo.com/lifestyle/story/an-olive-garden-server-was-fired-after-a-700-tiphere-is-what-the-restaurant-got-wrong-103802074.html",
                "4": "https://www.eandblaw.com/one-fair-wage-says-darden-restaurants-tips-policy-caused-racial-and-gender-discrimination/",
                "5": "https://www.cnbc.com/2021/04/15/lawsuit-alleges-dardens-tipping-policy-causes-discrimination-harassment.html",
                "6": "https://www.eeoc.gov/eeoc/newsroom/release/12-14-09a.cfm",
                "7": "https://www.eeoc.gov/eeoc/newsroom/release/5-3-18a.cfm",
                "8": "https://www.independent.co.uk/news/world/americas/longhorn-steakhouse-taxidermy-antlers-severe-injuries-b2926070.html"
            },
            "sourceNotes": {
                "1": "underpaid staff",
                "2": "underpaid staff",
                "3": "fired employee who received a large tip, refusing to pay her",
                "4": "racial discrimination against employees",
                "5": "racial discrimination against employees",
                "6": "racial discrimination against employees",
                "7": "age discrimination in hiring",
                "8": "unsafe restarant decor safety causing injuries to customers"
            },
            "tags": [
                "restaurant",
                "unfair pay",
                "racial discrimination",
                "unsafe practices"
            ],
            "score": 32,
            "ownedBy": [],
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/4/4c/Darden_logo.svg/250px-Darden_logo.svg.png",
            "siteUrl": "http://darden.com/",
            "updatedAt": "2026-10-04T07:13:54.676Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Darden_Restaurants"
        },
        "longhorn-steakhouse": {
            "key": "longhorn-steakhouse",
            "names": [
                "LongHorn Steakhouse"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurant",
                "food"
            ],
            "score": "32",
            "ownedBy": [
                "darden-restaurants"
            ],
            "updatedAt": "2026-10-04T08:15:10.357Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/LongHorn_Steakhouse",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/7/7f/LongHornSteakhouseLogo.PNG/250px-LongHornSteakhouseLogo.PNG",
            "siteUrl": "https://www.longhornsteakhouse.com/"
        },
        "cheddar's-scratch-kitchen": {
            "key": "cheddar's-scratch-kitchen",
            "names": [
                "Cheddar's Scratch Kitchen"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurant",
                "food"
            ],
            "score": "32",
            "ownedBy": [
                "darden-restaurants"
            ],
            "updatedAt": "2026-10-04T08:15:10.429Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Cheddar's_Scratch_Kitchen",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/2/21/Cheddar%27s_Scratch_Kitchen_logo.png/250px-Cheddar%27s_Scratch_Kitchen_logo.png",
            "siteUrl": "https://cheddars.com/"
        },
        "yard-house": {
            "key": "yard-house",
            "names": [
                "Yard House"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurant",
                "food"
            ],
            "score": "32",
            "ownedBy": [
                "darden-restaurants"
            ],
            "updatedAt": "2026-10-04T08:15:10.598Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Yard_House",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/1/1b/Yard_House_logo.svg/250px-Yard_House_logo.svg.png",
            "siteUrl": "https://www.yardhouse.com/"
        },
        "the-capital-grille": {
            "key": "the-capital-grille",
            "names": [
                "The Capital Grille"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurant",
                "food"
            ],
            "score": "32",
            "ownedBy": [
                "darden-restaurants"
            ],
            "updatedAt": "2026-10-04T08:15:10.979Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/The_Capital_Grille",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/0/0d/Capital_Grille.svg/250px-Capital_Grille.svg.png",
            "siteUrl": "http://www.thecapitalgrille.com/"
        },
        "seasons-52": {
            "key": "seasons-52",
            "names": [
                "Seasons 52"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurant",
                "food"
            ],
            "score": "32",
            "ownedBy": [
                "darden-restaurants"
            ],
            "updatedAt": "2026-10-04T08:15:11.036Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Seasons_52"
        },
        "bahama-breeze": {
            "key": "bahama-breeze",
            "names": [
                "Bahama Breeze"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurant",
                "food"
            ],
            "score": "32",
            "ownedBy": [
                "darden-restaurants"
            ],
            "updatedAt": "2026-10-04T08:15:11.514Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Bahama_Breeze",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/9/90/Bahama_Breeze.svg/250px-Bahama_Breeze.svg.png",
            "siteUrl": "http://www.bahamabreeze.com/"
        },
        "eddie-v's": {
            "key": "eddie-v's",
            "names": [
                "Eddie V's"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurant",
                "food"
            ],
            "score": "32",
            "ownedBy": [
                "darden-restaurants"
            ],
            "updatedAt": "2026-10-04T08:15:11.572Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Eddie_V's",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/5/5a/Eddie_v_logo.jpg/330px-Eddie_v_logo.jpg",
            "siteUrl": "http://www.eddiev.com/"
        },
        "ruth's-chris-steak-house": {
            "key": "ruth's-chris-steak-house",
            "names": [
                "Ruth's Chris Steak House"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurant",
                "food"
            ],
            "score": "32",
            "ownedBy": [
                "darden-restaurants"
            ],
            "updatedAt": "2026-10-04T08:15:11.893Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Ruth's_Chris_Steak_House",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/2/2a/Ruths_Chris_Logo.svg/250px-Ruths_Chris_Logo.svg.png",
            "siteUrl": "http://www.ruthschris.com/"
        },
        "chuy's": {
            "key": "chuy's",
            "names": [
                "Chuy's"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurant",
                "food"
            ],
            "score": "32",
            "ownedBy": [
                "darden-restaurants"
            ],
            "updatedAt": "2026-10-04T08:15:12.423Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Chuy's",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/2/2d/Chuy%27s.png/250px-Chuy%27s.png",
            "siteUrl": "http://chuys.com/"
        },
        "oppo": {
            "key": "oppo",
            "names": [
                "Oppo",
                "OPPO广东移动通信有限公司",
                "OPPO廣東移動通信有限公司",
                "OPPO Guangdong Mobile Telecommunications Corp., Ltd.",
                "OPPO Guǎngdōng Yídòng Tōngxìn Yǒuxiàn Gōngsī"
            ],
            "comment": "Oppo is a Chinese smartphone manufacturer that has been implicated in evading customs duties [1][2] and unlawfully pre‑installing loan apps that collect personal data without consent [3][4]. The company has also been linked to forced labor and wage theft in its electronics factories [6], complicit in forced Uyghur labour in its supply chain [5], and continues operations in Russia [7].",
            "sources": {
                "1": "https://web.archive.org/web/20220714030554/https://www.caixinglobal.com/2022-07-14/india-accuses-chinas-oppo-of-evading-551-million-of-taxes-101912684.html",
                "2": "https://www.reuters.com/world/india/india-accuses-chinas-oppo-551-mln-tax-evasion-2022-07-13/",
                "3": "https://www.bangkokpost.com/business/general/2938775/oppo-realme-phone-brands-in-hot-seat-for-data-breach",
                "4": "https://developingtelecoms.com/telecom-technology/financial-services/17868-oppo-apologises-to-thai-users-over-pre-installed-loan-apps.html",
                "5": "https://www.aspi.org.au/report/uyghurs-sale",
                "6": "https://chinalaborwatch.org/labor-conditions-in-chinas-consumer-electronics-sector/",
                "7": "https://leave-russia.org/oppo"
            },
            "sourceNotes": {
                "1": "evaded customs duties",
                "2": "evaded customs duty on imported goods",
                "3": "unlawfully pre‑installed loan app collecting personal data without consent",
                "4": "pre-installed unauthorized loan apps on phones",
                "5": "complicit in forced Uyghur labour in supply chain",
                "6": "forced labor and wage theft in electronics factories",
                "7": "continuing operations in russia"
            },
            "tags": [
                "electronics",
                "tech",
                "tax avoidance",
                "privacy violations",
                "forced labour",
                "forced uyghur labour",
                "connections to russia",
                "unfair pay"
            ],
            "score": 29,
            "ownedBy": [],
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/0/0a/OPPO_LOGO_2019.svg/250px-OPPO_LOGO_2019.svg.png",
            "siteUrl": "https://www.oppo.com/en/",
            "updatedAt": "2026-10-05T08:40:12.860Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Oppo"
        },
        "bloomin'-brands": {
            "key": "bloomin'-brands",
            "names": [
                "Bloomin' Brands",
                "Bloomin' Brands, Inc.",
                "BLMN"
            ],
            "comment": "Bloomin' Brands is a U.S. restaurant chain that has been accused of unlawful tip pooling of servers' gratuities [1], failing to pay minimum wage [2] and to pay employees for pre‑shift work [3], and engaging in gender-based pay discrimination and retaliation against a female employee [4]. The company has also faced allegations of sex discrimination against women [5], sexual harassment of female employees [6], using a racist marketing term [7], causing a norovirus outbreak through food safety violations [8], negligent slip and fall hazard leading to customer injury [9], negligent restroom maintenance causing injury to customer [10], and unsafe working conditions resulting in employee injury [11].",
            "sources": {
                "1": "https://www.bigclassaction.com/settlement/1-25m-settlement-approved-outback-steakhouse.php",
                "2": "https://finance.yahoo.com/news/class-action-filed-against-outback-043504610.html",
                "3": "https://www.law360.com/articles/786690/outback-workers-get-nod-for-3m-wage-deal",
                "4": "https://www.eeoc.gov/eeoc/newsroom/release/archive/9-19-01.html",
                "5": "https://www.eeoc.gov/eeoc/newsroom/release/12-29-09a.cfm",
                "6": "https://www.eeoc.gov/newsroom/carrabbas-pay-690000-settle-eeoc-lawsuit-sexual-harassment",
                "7": "https://www.news.com.au/lifestyle/food/restaurants-bars/australianthemed-food-chain-outback-steakhouse-taken-to-task-over-aussie-slur/news-story/3a99fb57295f13d1c2c4ab1640057c1e",
                "8": "https://marlerclark.com/news_events/carrabbas-has-history-of-violations",
                "9": "https://www.thetakeout.com/2187584/why-outback-steakhouse-mashed-potatoes-million-dollar-lawsuit/",
                "10": "https://www.thesun.co.uk/news/37756641/diner-loses-bodily-function-toilet-seat-shatters/",
                "11": "https://www.osha.gov/ords/imis/establishment.inspection_detail?id=1350749.015"
            },
            "sourceNotes": {
                "1": "unlawful tip pooling of servers' gratuities",
                "2": "failed to pay minimum wage",
                "3": "failed to pay employees for pre‑shift work",
                "4": "gender-based pay discrimination and retaliation against a female employee",
                "5": "sex discrimination against women",
                "6": "sexual harassment of female employees",
                "7": "used a racist marketing term",
                "8": "caused norovirus outbreak through food safety violations",
                "9": "negligent slip and fall hazard leading to customer injury",
                "10": "negligent restroom maintenance causing injury to customer",
                "11": "employee injured in unsafe working conditions"
            },
            "tags": [
                "unfair pay",
                "gender discrimination",
                "sexual harassment",
                "racial discrimination",
                "unsafe working conditions",
                "unsafe practices"
            ],
            "score": 22,
            "ownedBy": [],
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/6/68/Bloomin%27_Brands_logo.svg/250px-Bloomin%27_Brands_logo.svg.png",
            "siteUrl": "http://www.bloominbrands.com/",
            "updatedAt": "2026-10-06T10:04:55.823Z",
            "error": "Error [ERR_HTTP2_INVALID_SESSION]: The session has been destroyed",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Bloomin%27_Brands"
        },
        "carrabba's-italian-grill": {
            "key": "carrabba's-italian-grill",
            "names": [
                "Carrabba's Italian Grill"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [],
            "score": 22,
            "ownedBy": [
                "bloomin'-brands"
            ],
            "updatedAt": "2026-10-06T10:59:35.606Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Carrabba's_Italian_Grill",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/6/67/Carrabba%27s_Italian_Grill_logo.svg/250px-Carrabba%27s_Italian_Grill_logo.svg.png",
            "siteUrl": "https://www.carrabbas.com/"
        },
        "bonefish-grill": {
            "key": "bonefish-grill",
            "names": [
                "Bonefish Grill"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [],
            "score": 22,
            "ownedBy": [
                "bloomin'-brands"
            ],
            "updatedAt": "2026-10-06T10:59:35.671Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Bonefish_Grill",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/b/b9/Bonefish_Grill_logo.svg/250px-Bonefish_Grill_logo.svg.png",
            "siteUrl": "http://www.bonefishgrill.com/"
        },
        "fleming's-prime-steakhouse-andamp-wine-bar": {
            "key": "fleming's-prime-steakhouse-andamp-wine-bar",
            "names": [
                "Fleming's Prime Steakhouse &amp; Wine Bar"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [],
            "score": 22,
            "ownedBy": [
                "bloomin'-brands"
            ],
            "updatedAt": "2026-10-06T10:59:35.735Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Fleming's_Prime_Steakhouse_&amp;_Wine_Bar"
        },
        "racetrac": {
            "key": "racetrac",
            "names": [
                "Racetrac",
                "RaceTrac, Inc.",
                "Carl Bolch Trackside Stations"
            ],
            "comment": "Racetrac is an American convenience store chain that has repeatedly failed to pay minimum wage [1][2][3] and committed multiple environmental violations [4][5][6][7], including discharging fill material into wetlands [8].",
            "sources": {
                "1": "https://violationtracker.goodjobsfirst.org/violation-tracker/mn-potbelly-sandwich-shop",
                "2": "https://violationtracker.goodjobsfirst.org/violation-tracker/mn-potbelly-sandwich-shop-0",
                "3": "https://violationtrackerglobal.goodjobsfirst.org/violation-tracker-global/united-states-potbelly-sandwich-shop-0",
                "4": "https://violationtracker.goodjobsfirst.org/violation-tracker/tx-racetrac-petroleum-inc-7",
                "5": "https://wayback.archive-it.org/414/20210527112017/https://www.tceq.texas.gov/assets/public/compliance/enforcement/enf_reports/AER/FY16/enfrptfy16.pdf",
                "6": "https://wayback.archive-it.org/414/20210527112017/https://www.tceq.texas.gov/assets/public/compliance/enforcement/enf_reports/AER/FY13/enfrptfy13.pdf",
                "7": "https://wayback.archive-it.org/414/20150906000656/https://www.tceq.texas.gov/assets/public/compliance/enforcement/enf_reports/AER/historical/Annual-Enforcement-Report-FY2007.pdf",
                "8": "https://echo.epa.gov/enforcement-case-report?id=04-2010-5500"
            },
            "sourceNotes": {
                "1": "failed to pay minimum wage",
                "2": "failed to pay minimum wage",
                "3": "failed to pay minimum wage",
                "4": "committed environmental violations",
                "5": "committed environmental violations",
                "6": "committed environmental violations",
                "7": "committed environmental violations",
                "8": "discharged fill material into wetlands without permit"
            },
            "tags": [
                "petroleum",
                "retail",
                "unfair pay",
                "environmental violations"
            ],
            "score": 37,
            "ownedBy": [],
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/c/ce/RaceTrac_logo.svg/250px-RaceTrac_logo.svg.png",
            "siteUrl": "https://racetrac.com/",
            "updatedAt": "2026-10-06T19:42:02.599Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/RaceTrac"
        },
        "gulf-oil": {
            "key": "gulf-oil",
            "names": [
                "Gulf Oil"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "petroleum",
                "retail"
            ],
            "score": 37,
            "ownedBy": [
                "racetrac"
            ],
            "updatedAt": "2026-10-07T08:34:06.496Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Gulf_Oil_LP",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/7/72/Gulf_Oil_logo.svg/250px-Gulf_Oil_logo.svg.png",
            "siteUrl": "https://www.gulfoilltd.com/"
        },
        "coty": {
            "key": "coty",
            "names": [
                "COTY",
                "Coty Inc.",
                "Coty"
            ],
            "comment": "COTY is an American cosmetics company that has used microplastics in its products [1], engaged in anticompetitive practices [2], and tested products on animals [3]. The company has sold asbestos-tainted talc products [4] and sourced mica mined with child labour  [5][6].",
            "sources": {
                "1": "https://www.beatthemicrobead.org/product-lists/",
                "2": "https://legalblogs.wolterskluwer.com/competition-blog/french-competition-authority-revisits-platform-ban-in-a-post-coty-world/",
                "3": "https://crueltyfree.peta.org/wp-content/uploads/companies-do-test.pdf",
                "4": "https://www.mesothelioma.com/asbestos-exposure/companies/coty/",
                "5": "https://www.telegraph.co.uk/beauty/make-up/dark-truth-really-inside-make-up/",
                "6": "https://www.theaustralian.com.au/the-oz/news/crushed-skulls-broken-ribs-the-human-cost-of-shimmery-makeup/news-story/6f2a2540b8d5d372c003f51a10328881?eafs_enabled=false"
            },
            "sourceNotes": {
                "1": "used microplastics in cosmetic products",
                "2": "anticompetetive practices",
                "3": "tests products on animals",
                "4": "sold asbestos-tainted talc products",
                "5": "used mica mined with child labor",
                "6": "child labor in mica mining supply chain"
            },
            "tags": [
                "cosmetics",
                "anticompetitive practices",
                "animal abuse",
                "child labour",
                "unsustainable practices",
                "environmental violations"
            ],
            "score": 19,
            "ownedBy": [],
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/8/8f/Coty_logo.svg/250px-Coty_logo.svg.png",
            "siteUrl": "https://www.coty.com/",
            "updatedAt": "2026-10-07T15:49:08.104Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Coty"
        },
        "bourjois": {
            "key": "bourjois",
            "names": [
                "Bourjois"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "cosmetics"
            ],
            "score": 19,
            "ownedBy": [
                "coty"
            ],
            "updatedAt": "2026-10-07T15:58:38.059Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Bourjois",
            "siteUrl": "http://www.bourjois.fr/"
        },
        "covergirl": {
            "key": "covergirl",
            "names": [
                "CoverGirl"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "cosmetics"
            ],
            "score": 19,
            "ownedBy": [
                "coty"
            ],
            "updatedAt": "2026-10-07T15:58:38.408Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/CoverGirl",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/f/f4/COVERGIRL_logo_2017.svg/250px-COVERGIRL_logo_2017.svg.png",
            "siteUrl": "http://www.covergirl.com/"
        },
        "ghd": {
            "key": "ghd",
            "names": [
                "ghd"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "cosmetics"
            ],
            "score": 19,
            "ownedBy": [
                "coty"
            ],
            "updatedAt": "2026-10-07T15:58:39.124Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Good_Hair_Day",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/a/a9/Good_Hair_Day_%28logo%29.png",
            "siteUrl": "http://ghdhair.com/"
        },
        "kylie-cosmetics": {
            "key": "kylie-cosmetics",
            "names": [
                "Kylie Cosmetics"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "cosmetics"
            ],
            "score": 19,
            "ownedBy": [
                "coty"
            ],
            "updatedAt": "2026-10-07T15:58:39.320Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Kylie_Cosmetics",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/f/fe/Kylie_Cosmetics_Logo.svg/250px-Kylie_Cosmetics_Logo.svg.png",
            "siteUrl": "http://kyliecosmetics.com/"
        },
        "max-factor": {
            "key": "max-factor",
            "names": [
                "Max Factor"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "cosmetics"
            ],
            "score": 19,
            "ownedBy": [
                "coty"
            ],
            "updatedAt": "2026-10-07T15:58:39.423Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Max_Factor",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/a/ab/MaxFactor_New_Logo_Wht.jpg/250px-MaxFactor_New_Logo_Wht.jpg",
            "siteUrl": "https://maxfactor.com/"
        },
        "sally-hansen": {
            "key": "sally-hansen",
            "names": [
                "Sally Hansen"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "cosmetics"
            ],
            "score": 19,
            "ownedBy": [
                "coty"
            ],
            "updatedAt": "2026-10-07T15:58:40.259Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Sally_Hansen#Sally_Hansen,_Inc.",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/5/57/Sally_Hansen_mirror.jpg/250px-Sally_Hansen_mirror.jpg"
        },
        "wella": {
            "key": "wella",
            "names": [
                "Wella"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "cosmetics"
            ],
            "score": 19,
            "ownedBy": [
                "coty"
            ],
            "updatedAt": "2026-10-07T15:58:40.443Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Wella",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/8/8d/Wella-Company-logo.jpg/250px-Wella-Company-logo.jpg",
            "siteUrl": "http://www.wellacompany.com/"
        },
        "kmd-brands": {
            "key": "kmd-brands",
            "names": [
                "KMD Brands",
                "Kathmandu Holdings",
                "KMD"
            ],
            "comment": "KMD Brands is an Australian clothing company that has faced accusations of misleading sale advertising [1] and has also been linked to the use of slave‑like labor in North Korea [2][3][4].",
            "sources": {
                "1": "https://web.archive.org/web/20180203162406/http://www.comcom.govt.nz/the-commission/media-centre/media-releases/2006/kathmandufindsoutthetruecostofsale",
                "2": "https://blogs.soas.ac.uk/ssai-notes/2016/05/23/a-survey-of-delhi-garment-workers-suggests-poverty-comes-in-many-sizes/",
                "3": "https://www.smh.com.au/business/surf-clothing-label-rip-curl-using-slave-labour-to-manufacture-clothes-in-north-korea-20160220-gmz375.html",
                "4": "https://www.theguardian.com/australia-news/2016/feb/22/rip-curls-use-of-north-korean-factories-leads-to-calls-for-industry-transparency"
            },
            "sourceNotes": {
                "1": "misleading sale advertising",
                "2": "used slave‑like labor in North Korea",
                "3": "exploited slave labour in North Korea",
                "4": "manufactured garments in North Korea"
            },
            "tags": [
                "clothing",
                "sportswear",
                "retail",
                "deception",
                "forced labour"
            ],
            "score": 34,
            "ownedBy": [],
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/4/48/KMD_Brands_Masterbrand_Logo_Black_%28RGB%29_HR_%281%29.png/250px-KMD_Brands_Masterbrand_Logo_Black_%28RGB%29_HR_%281%29.png",
            "siteUrl": "https://www.kmdbrands.com/",
            "updatedAt": "2026-10-08T12:01:57.916Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/KMD_Brands"
        },
        "kathmandu": {
            "key": "kathmandu",
            "names": [
                "Kathmandu"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing"
            ],
            "score": 34,
            "ownedBy": [
                "kmd-brands"
            ],
            "logoUrl": "https://www.kathmandu.co.uk/cdn/shop/files/full-light.svg?height=20&v=1750127941",
            "siteUrl": "https://www.kathmandu.co.uk/",
            "updatedAt": "2026-10-08T12:13:37.087Z"
        },
        "oboz": {
            "key": "oboz",
            "names": [
                "Oboz"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing"
            ],
            "score": 34,
            "ownedBy": [
                "kmd-brands"
            ],
            "logoUrl": "https://obozfootwear.com/cdn/shop/files/Oboz_Wordmark_Bison.svg?height=24&v=1789082395",
            "siteUrl": "https://obozfootwear.com/",
            "updatedAt": "2026-10-08T12:13:37.087Z"
        },
        "deutsche-telecom": {
            "key": "deutsche-telecom",
            "names": [
                "Deutsche Telecom",
                "Deutsche Telekom AG",
                "Deutsche Telekom",
                "Telekom",
                "Deutsche Bundespost",
                "DTE"
            ],
            "comment": "Deutsche Telecom is a German telecommunications company that has abused its monopoly position [1] and exploited monopoly power to squeeze margins [2], while being linked to corruption in South Africa [3] and engaging in bribery and falsifying records to secure contracts [4][5]. The company has also committed data breaches and illegal processing of customer call records [6], illegally accessed employee call records [7], spied on journalists, customers, executives, shareholders, and engaged in illegal wiretapping and coverups [8][9][10].",
            "sources": {
                "1": "https://www.antimon.gov.sk/6812-sk/ns-sr-potvrdil-rozhodnutie-rady-pmu-sr-v-spojeni-s-rozhodnutim-pmu-sr-vo-veci-zneuzitia-dominantneho-postavenia-spolocnostou-slovak-telekom-a-s/?csrt=16762170205131931356",
                "2": "https://www.antimon.gov.sk/6812-sk/ns-sr-potvrdil-rozhodnutie-rady-pmu-sr-v-spojeni-s-rozhodnutim-pmu-sr-vo-veci-zneuzitia-dominantneho-postavenia-spolocnostou-slovak-telekom-a-s/?csrt=16762170205131931356",
                "3": "https://www.telcotitans.com/deutsche-telekomwatch/t-systems-probed-over-south-african-state-capture-links/5359.article",
                "4": "https://www.justice.gov/opa/pr/magyar-telekom-and-deutsche-telekom-resolve-foreign-corrupt-practices-act-investigation-and",
                "5": "https://web.archive.org/web/20150908022916/https://www.sec.gov/news/press/2011/2011-279.htm",
                "6": "https://www.dpa.gr/el/enimerwtiko/prakseisArxis/epiboli-prostimoy-gia-peristatiko-parabiasis-prosopikon-dedomenon-kai-mi",
                "7": "https://www.lightreading.com/services/spying-scandal-rocks-deutsche-telekom",
                "8": "https://www.sciencedirect.com/science/article/abs/pii/S0363811116301497",
                "9": "https://digitalcommons.emerson.edu/cgi/viewcontent.cgi?article=2400&context=arc",
                "10": "https://www.dw.com/en/macedonian-prosecutors-say-telecom-company-holds-key-to-surveillance-scandal/a-36602198"
            },
            "sourceNotes": {
                "1": "abuse of monopoly position",
                "2": "exploited monopoly power to squeeze margins",
                "3": "linked to corruption in South Africa",
                "4": "committed bribery and falsified records",
                "5": "bribed officials to secure telecom contracts",
                "6": "data breach and illegal processing of customer call records",
                "7": "illegally accessed employee call records",
                "8": "spied on journalists and customers' data",
                "9": "spied on executives, shareholders, and journalists",
                "10": "illegal wiretapping and coverup"
            },
            "tags": [
                "telecommunications",
                "anticompetitive practices",
                "corruption",
                "data breach",
                "privacy violations",
                "deception"
            ],
            "score": 33,
            "ownedBy": [],
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/d/dd/Deutsche_Telekom_2022.svg/120px-Deutsche_Telekom_2022.svg.png",
            "siteUrl": "https://www.telekom.com/",
            "updatedAt": "2026-10-08T12:16:18.467Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Deutsche_Telekom"
        },
        "magyar-telekom": {
            "key": "magyar-telekom",
            "names": [
                "Magyar Telekom"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "telecommunications"
            ],
            "score": 33,
            "ownedBy": [
                "deutsche-telecom"
            ],
            "updatedAt": "2026-10-09T15:09:52.934Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Magyar_Telekom",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/d/dd/Deutsche_Telekom_2022.svg/250px-Deutsche_Telekom_2022.svg.png",
            "siteUrl": "http://www.telekom.hu/"
        },
        "makedonski-telekom": {
            "key": "makedonski-telekom",
            "names": [
                "Makedonski Telekom"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "telecommunications"
            ],
            "score": 33,
            "ownedBy": [
                "deutsche-telecom"
            ],
            "updatedAt": "2026-10-09T15:09:53.102Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Makedonski_Telekom",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/d/dd/Deutsche_Telekom_2022.svg/250px-Deutsche_Telekom_2022.svg.png",
            "siteUrl": "https://www.telekom.mk/"
        },
        "magenta-telekom": {
            "key": "magenta-telekom",
            "names": [
                "Magenta Telekom"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "telecommunications"
            ],
            "score": 33,
            "ownedBy": [
                "deutsche-telecom"
            ],
            "updatedAt": "2026-10-09T15:09:53.179Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Magenta_Telekom",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/5/55/Magenta_Telekom_Logo.svg/250px-Magenta_Telekom_Logo.svg.png",
            "siteUrl": "http://magenta.at/"
        },
        "slovak-telekom-a.s.": {
            "key": "slovak-telekom-a.s.",
            "names": [
                "Slovak Telekom, a.s."
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "telecommunications"
            ],
            "score": 33,
            "ownedBy": [
                "deutsche-telecom"
            ],
            "updatedAt": "2026-10-09T15:09:53.263Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Slovak_Telekom",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/d/dd/Deutsche_Telekom_2022.svg/250px-Deutsche_Telekom_2022.svg.png",
            "siteUrl": "https://www.telekom.sk/"
        },
        "pfiefer-and-langen": {
            "key": "pfiefer-and-langen",
            "names": [
                "Pfiefer & Langen",
                "Pfeifer & Langen GmbH & Co. KG"
            ],
            "comment": "Pfiefer & Langen is an Austrian company that has been involved in a monopolistic cartel to divide the industrial sugar market [1].",
            "sources": {
                "1": "https://www.bwb.gv.at/en/news/news-2022/detail-1-1/cartel-court-imposes-a-fine-of-eur-42-million-on-suedzucker-ag-at-afcas-request-the-decision-is-final"
            },
            "sourceNotes": {
                "1": "monopolistic cartel to divide the Austrian industrial sugar market"
            },
            "tags": [
                "food",
                "anticompetitive practices"
            ],
            "score": 45,
            "ownedBy": [],
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/e/e2/Pfeifer_%26_Langen_logo.png",
            "siteUrl": "http://www.pfeifer-langen.com/",
            "updatedAt": "2026-10-10T09:04:17.046Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Pfeifer_%26_Langen"
        },
        "vf-corporation": {
            "key": "vf-corporation",
            "names": [
                "VF Corporation",
                "VF Corporation",
                "Vanity Fair Mills",
                "VFC",
                "Reading Glove and Mitten Manufacturing Company"
            ],
            "comment": "VF Corporation is an American apparel company that failed to protect personal data of 35.5 million customers in a ransomware attack [1][2][3], and has failed to pay wages to workers [4][5]. VF Corporation has also been linked to migrant worker abuse [6], used sweatshop labour ad forced labour [7][8], bypassed forced labour laws in its supply chain [9], violated workers' rights in sportswear factories [10], exploited workers in Haiti [11] and Cambodian factories [12], sourced cotton from forced labour in Xinjiang [13], and employed child labour in its supply chain [14].",
            "sources": {
                "1": "https://www.securityweek.com/vf-corp-says-data-breach-resulting-from-ransomware-attack-impacts-35-million/",
                "2": "https://www.bleepingcomputer.com/news/security/vans-and-north-face-owner-vf-corp-hit-by-ransomware-attack/",
                "3": "https://www.reuters.com/business/retail-consumer/vf-corps-cyber-incident-causes-data-breach-355-million-consumers-2024-01-18/",
                "4": "https://www.publiceye.ch/en/topics/fashion/fashion-brands-fail-to-address-pandemic-era-wage-theft-in-cambodia-garment-workers-deprived-of-109-million",
                "5": "https://asia.floorwage.org/big-fashion-and-wall-street-cash-in-on-wage-theft/",
                "6": "https://www.hcamag.com/us/specialization/employment-law/nearly-600-companies-linked-to-global-migrant-worker-abuse-in-2025/567742",
                "7": "https://www.stuff.co.nz/business/industries/103624255/icebreaker-buyer-vf-corp-investigated-over-sweatshop-labour",
                "8": "https://committees.parliament.uk/publications/5095/documents/52855/default/",
                "9": "https://www.business-humanrights.org/en/latest-news/us-and-eu-brands-accused-of-bypassing-forced-labour-laws-through-chinese-and-vietnamese-supply-routes/",
                "10": "https://www.ituc-csi.org/itglwf-report-an-overview-of",
                "11": "https://web.archive.org/web/20170228170228/https://www.workersrights.org/freports/WRC%20Haiti%20Minimum%20Wage%20Report%2010%2015%2013.pdf",
                "12": "https://www.theguardian.com/business/2017/jun/25/female-cambodian-garment-workers-mass-fainting",
                "13": "https://web.archive.org/web/20220301105102/https://www.shu.ac.uk/helena-kennedy-centre-international-justice/research-and-projects/all-projects/laundered-cotton",
                "14": "https://www.somo.nl/branded-childhood/"
            },
            "sourceNotes": {
                "1": "failed to protect personal data of 35.5 million customers in ransomware attack",
                "2": "suffered a ransomware attack",
                "3": "failed to protect personal data of 35.5 million customers in ransomware attack",
                "4": "failed to pay wages during pandemic lockdown",
                "5": "failed to pay minimum wage",
                "6": "linked to migrant worker abuse",
                "7": "used sweatshop labour",
                "8": "used forced labour in supply chain",
                "9": "bypassing forced labour laws in supply chain",
                "10": "violated workers' rights in sportswear factories",
                "11": "exploited workers in Haiti",
                "12": "exploited workers in Cambodian factories",
                "13": "sourced cotton from forced labor in Xinjiang",
                "14": "child labour in supply chain"
            },
            "tags": [
                "clothing",
                "data breach",
                "privacy violations",
                "unfair pay",
                "forced labour",
                "child labour",
                "forced Uyghur labour"
            ],
            "score": 20,
            "ownedBy": [],
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/8/8c/VF_Corporation_logo.svg/250px-VF_Corporation_logo.svg.png",
            "siteUrl": "https://vfc.com/",
            "updatedAt": "2026-10-10T09:22:50.335Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/VF_Corporation"
        },
        "altra-running": {
            "key": "altra-running",
            "names": [
                "Altra Running"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing"
            ],
            "score": 20,
            "ownedBy": [
                "vf-corporation"
            ],
            "updatedAt": "2026-10-10T11:11:59.485Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Altra_Running",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/5/5b/Altra_running_logo.png/250px-Altra_running_logo.png",
            "siteUrl": "http://altrarunning.com/"
        },
        "eastpak": {
            "key": "eastpak",
            "names": [
                "Eastpak"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing"
            ],
            "score": 20,
            "ownedBy": [
                "vf-corporation"
            ],
            "updatedAt": "2026-10-10T11:11:59.919Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Eastpak",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/a/ac/Eastpak_logo.svg/250px-Eastpak_logo.svg.png",
            "siteUrl": "http://www.eastpak.com/"
        },
        "jansport": {
            "key": "jansport",
            "names": [
                "JanSport"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing"
            ],
            "score": 20,
            "ownedBy": [
                "vf-corporation"
            ],
            "updatedAt": "2026-10-10T11:12:00.126Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/JanSport",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/5/5e/Jansportlogo.jpg/250px-Jansportlogo.jpg",
            "siteUrl": "https://www.jansport.com/"
        },
        "icebreaker": {
            "key": "icebreaker",
            "names": [
                "Icebreaker"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing"
            ],
            "score": 20,
            "ownedBy": [
                "vf-corporation"
            ],
            "updatedAt": "2026-10-10T11:12:00.216Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Icebreaker_(clothing)",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/3/36/Icebreaker_logo.png/250px-Icebreaker_logo.png",
            "siteUrl": "https://www.icebreaker.com/"
        },
        "kipling": {
            "key": "kipling",
            "names": [
                "Kipling"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing"
            ],
            "score": 20,
            "ownedBy": [
                "vf-corporation"
            ],
            "updatedAt": "2026-10-10T11:12:00.439Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Kipling_(brand)",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/b/b9/Kipling_wordmark.svg/250px-Kipling_wordmark.svg.png",
            "siteUrl": "https://www.kipling.com/"
        },
        "napapijri": {
            "key": "napapijri",
            "names": [
                "Napapijri"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing"
            ],
            "score": 20,
            "ownedBy": [
                "vf-corporation"
            ],
            "updatedAt": "2026-10-10T11:12:00.872Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Napapijri",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/0/06/Napapijri_logo.svg/250px-Napapijri_logo.svg.png",
            "siteUrl": "http://www.napapijri.com/"
        },
        "smartwool": {
            "key": "smartwool",
            "names": [
                "SmartWool"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "clothing"
            ],
            "score": 20,
            "ownedBy": [
                "vf-corporation"
            ],
            "updatedAt": "2026-10-10T11:12:01.191Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/SmartWool",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/2/25/Smartwool_logo.svg/250px-Smartwool_logo.svg.png",
            "siteUrl": "http://www.smartwool.com/"
        },
        "block": {
            "key": "block",
            "names": [
                "Block",
                "Square, Inc.",
                "Block, Inc.",
                "XYZ",
                "SQ"
            ],
            "comment": "Block is a US company that has violated anti‑money laundering regulations [1] and failed to prevent data breaches exposing personal data [2][3]. It has also failed to investigate and prevent fraud [4][5][6][7][8][9] and has withheld payments from small businesses [10].",
            "sources": {
                "1": "https://www.scag.gov/about-the-office/news/attorney-general-alan-wilson-joins-80-million-enforcement-action-against-block-inc-and-cash-app-for-bsa-aml-violations/",
                "2": "https://www.law360.com/articles/1809699/cash-app-block-reach-15m-deal-to-end-data-breach-suit",
                "3": "https://topclassactions.com/lawsuit-settlements/open-lawsuit-settlements/15m-cash-app-data-breach-class-action-settlement/",
                "4": "https://www.consumerfinance.gov/about-us/newsroom/cfpb-orders-operator-of-cash-app-to-pay-175-million-and-fix-its-failures-on-fraud/",
                "5": "https://hindenburgresearch.com/block/",
                "6": "https://topclassactions.com/lawsuit-settlements/lawsuit-news/cash-app-parent-block-to-pay-45m-to-settle-states-fraud-protection-claims/",
                "7": "https://techcrunch.com/2018/06/11/squares-caviar-agrees-to-pay-2-2-million-to-settle-class-action-lawsuit-over-gratuity/",
                "8": "https://www.consumerfinance.gov/enforcement/actions/block-inc/",
                "9": "https://www.paymentsdive.com/news/block-payments-cfpb-state-regulators-fine-penalty-cash-app-tool/737530/",
                "10": "https://www.nytimes.com/2020/06/23/technology/square-jack-dorsey-pandemic-withholding.html"
            },
            "sourceNotes": {
                "1": "violated anti‑money laundering regulations",
                "2": "failed to prevent data breach exposing personal data",
                "3": "failed to prevent data breach exposing personal data",
                "4": "failed to investigate and prevent fraud",
                "5": "failed to investigate and prevent fraud",
                "6": "failed to investigate and prevent fraud",
                "7": "failed to investigate and prevent fraud",
                "8": "failed to investigate and prevent fraud",
                "9": "failed to investigate and prevent fraud",
                "10": "withholding payments from small businesses"
            },
            "tags": [
                "tech",
                "corruption",
                "deception",
                "privacy violations",
                "unfair pay",
                "data breach"
            ],
            "score": 37,
            "ownedBy": [],
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/d/d3/Block-lockup_black.svg/250px-Block-lockup_black.svg.png",
            "siteUrl": "https://block.xyz/",
            "updatedAt": "2026-10-11T20:58:26.157Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Block,_Inc."
        },
        "square": {
            "key": "square",
            "names": [
                "Square"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech"
            ],
            "score": 37,
            "ownedBy": [
                "block"
            ],
            "updatedAt": "2026-10-11T21:29:07.098Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Square_(payment_system)",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/8/81/Square_%28Block%2C_Inc.%29_Logo_08.2022.svg/250px-Square_%28Block%2C_Inc.%29_Logo_08.2022.svg.png"
        },
        "cash-app": {
            "key": "cash-app",
            "names": [
                "Cash App"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech"
            ],
            "score": 37,
            "ownedBy": [
                "block"
            ],
            "updatedAt": "2026-10-11T21:29:07.844Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Cash_App",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/c/c5/Square_Cash_app_logo.svg/120px-Square_Cash_app_logo.svg.png",
            "siteUrl": "https://cash.app/"
        },
        "afterpay": {
            "key": "afterpay",
            "names": [
                "Afterpay"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech"
            ],
            "score": 37,
            "ownedBy": [
                "block"
            ],
            "updatedAt": "2026-10-11T21:29:07.977Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Afterpay",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/c/c3/Afterpay_logo.svg/250px-Afterpay_logo.svg.png",
            "siteUrl": "https://afterpay.com/"
        },
        "bitkey": {
            "key": "bitkey",
            "names": [
                "Bitkey"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech"
            ],
            "score": 37,
            "ownedBy": [
                "block"
            ],
            "updatedAt": "2026-10-11T21:29:08.111Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Bitkey",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/1/16/Bitkey_logo.svg/250px-Bitkey_logo.svg.png",
            "siteUrl": "https://bitkey.world/"
        },
        "weebly": {
            "key": "weebly",
            "names": [
                "Weebly"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech"
            ],
            "score": 37,
            "ownedBy": [
                "block"
            ],
            "updatedAt": "2026-10-11T21:29:09.890Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Weebly",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/e/e6/Weebly_Logo.svg/250px-Weebly_Logo.svg.png",
            "siteUrl": "https://en.wikipedia.org/wiki/Web_hosting_service"
        },
        "buzz": {
            "key": "buzz",
            "names": [
                "Buzz"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech"
            ],
            "score": 37,
            "ownedBy": [
                "block"
            ],
            "updatedAt": "2026-10-11T21:29:09.956Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Block_Buzz"
        },
        "bytedance": {
            "key": "bytedance",
            "names": [
                "ByteDance",
                "ByteDance Ltd",
                "字节跳动有限公司",
                "Beijing ByteDance Technology Co., Ltd.",
                "Douyin Group (HK) Ltd.",
                "字节跳动",
                "Zìjié Tiàodòng",
                "ㄗˋ ㄐㄧㄝˊ ㄊㄧㄠˋ ㄉㄨㄥˋ",
                "Tzu4-chieh2 T'iao4-tung4",
                "Zìh-jié Tiào-dòng"
            ],
            "comment": "ByteDance is a Chinese company that has been accused of having a toxic work culture and dismissal of maternity leave [1], building addictive features against regulations [2], misleading users about data storage and location tracking [3], and violating children's privacy by collecting data on minors [4][5][6][7]. ByteDance has also been implicated in illegally spying on journalists investigating the company [8][9][10][11], sharing user data with the Chinese Communist Party [12], and collaborating with Chinese authorities to spread propaganda on Xinjiang [13].",
            "sources": {
                "1": "https://www.ft.com/content/174ed2e2-f88e-4759-9a7f-133629aab94a?syn-25a6b1a6=1",
                "2": "https://www.reuters.com/business/media-telecom/tiktok-hit-with-charges-breaching-eu-online-content-rules-app-may-have-change-2026-02-06/",
                "3": "https://techworkerscoalition.org/blog/2023/03/22/issue-3/",
                "4": "https://www.ftc.gov/news-events/news/press-releases/2024/08/ftc-investigation-leads-lawsuit-against-tiktok-bytedance-flagrantly-violating-childrens-privacy-law",
                "5": "https://www.bbc.com/news/articles/cwyr0l45xjro",
                "6": "https://www.reuters.com/legal/government/brazil-fines-tiktok-owner-bytedance-unlawful-processing-teenagers-data-2026-08-25/",
                "7": "https://www.justice.gov/archives/opa/pr/justice-department-sues-tiktok-and-parent-company-bytedance-widespread-violations-childrens",
                "8": "https://english.elpais.com/science-tech/2022-12-23/tiktok-spied-on-forbes-journalists-investigating-the-social-network-in-the-us.html",
                "9": "https://www.politico.eu/article/tiktoks-parent-company-admits-accessing-journalists-data/",
                "10": "https://edition.cnn.com/2023/06/08/tech/tiktok-data-china/index.html",
                "11": "https://www.theguardian.com/technology/2022/dec/22/tiktok-bytedance-workers-fired-data-access-journalists",
                "12": "https://www.courthousenews.com/tiktok-whistleblower-asks-ninth-circuit-to-vacate-sanction-order/",
                "13": "https://www.businessinsider.com/tiktok-parent-company-bytedance-spreads-chinese-propaganda-report-2019-11"
            },
            "sourceNotes": {
                "1": "toxic work culture and dismissal of maternity leave",
                "2": "built addictive features against regulations",
                "3": "misled users about data storage and location tracking",
                "4": "violated children's privacy by collecting data on minors",
                "5": "violated children's privacy by collecting data on minors",
                "6": "violated children's privacy by collecting data on minors",
                "7": "violated children's privacy by collecting data on minors",
                "8": "illegally spied on journalists investigating the company",
                "9": "illegally spied on journalists investigating the company",
                "10": "illegally spied on journalists investigating the company",
                "11": "illegally spied on journalists investigating the company",
                "12": "shared user data with the Chinese Communist Party",
                "13": "collaborated with Chinese authorities to spread propaganda on Xinjiang"
            },
            "tags": [
                "tech",
                "deception",
                "privacy violations",
                "gender discrimination",
                "unsafe working conditions",
                "poor working conditions"
            ],
            "score": 20,
            "ownedBy": [],
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/0/07/ByteDance_logo_English.svg/250px-ByteDance_logo_English.svg.png",
            "siteUrl": "https://bytedance.com/",
            "updatedAt": "2026-10-12T08:57:48.800Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/ByteDance"
        },
        "doubao": {
            "key": "doubao",
            "names": [
                "Doubao"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech"
            ],
            "score": 20,
            "ownedBy": [
                "bytedance"
            ],
            "updatedAt": "2026-10-12T11:51:54.231Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Doubao",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/f/ff/Doubao_logo.jpg/250px-Doubao_logo.jpg",
            "siteUrl": "https://www.doubao.com/"
        },
        "seedance": {
            "key": "seedance",
            "names": [
                "Seedance"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech"
            ],
            "score": 20,
            "ownedBy": [
                "bytedance"
            ],
            "updatedAt": "2026-10-12T11:51:54.297Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Seedance_2.0",
            "siteUrl": "https://seed.bytedance.com/en/seedance2_5"
        },
        "capcut": {
            "key": "capcut",
            "names": [
                "CapCut"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech"
            ],
            "score": 20,
            "ownedBy": [
                "bytedance"
            ],
            "updatedAt": "2026-10-12T11:51:54.388Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/CapCut",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/a/a0/Capcut-logo.svg/330px-Capcut-logo.svg.png",
            "siteUrl": "https://www.capcut.com/"
        },
        "toutiao": {
            "key": "toutiao",
            "names": [
                "Toutiao"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech"
            ],
            "score": 20,
            "ownedBy": [
                "bytedance"
            ],
            "updatedAt": "2026-10-12T11:51:54.580Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Toutiao",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/7/7b/Toutiao_logo.svg/250px-Toutiao_logo.svg.png",
            "siteUrl": "https://en.wikipedia.org/wiki/File:Toutiao_logo.svg"
        },
        "whee": {
            "key": "whee",
            "names": [
                "Whee"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech"
            ],
            "score": 20,
            "ownedBy": [
                "bytedance"
            ],
            "updatedAt": "2026-10-12T11:51:54.659Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Whee_(social_network)",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/0/07/ByteDance_logo_English.svg/250px-ByteDance_logo_English.svg.png",
            "siteUrl": "https://bytedance.com/"
        },
        "lark": {
            "key": "lark",
            "names": [
                "Lark"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech"
            ],
            "score": 20,
            "ownedBy": [
                "bytedance"
            ],
            "updatedAt": "2026-10-12T11:51:55.323Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Lark_(software)",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/4/42/Lark_Suite_logo_2022.png/250px-Lark_Suite_logo_2022.png",
            "siteUrl": "https://larksuite.com/"
        },
        "pico": {
            "key": "pico",
            "names": [
                "PICO"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech"
            ],
            "score": 20,
            "ownedBy": [
                "bytedance"
            ],
            "updatedAt": "2026-10-12T11:51:55.389Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/PICO_4",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/a/a4/Pico_website_logo.svg/250px-Pico_website_logo.svg.png",
            "siteUrl": "https://www.picoxr.com/global/products/pico4"
        },
        "lemon8": {
            "key": "lemon8",
            "names": [
                "Lemon8"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech"
            ],
            "score": 20,
            "ownedBy": [
                "bytedance"
            ],
            "updatedAt": "2026-10-12T11:51:55.450Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Lemon8",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/3/35/Lemon8_icon.png/250px-Lemon8_icon.png",
            "siteUrl": "https://lemon8-app.com/"
        },
        "soundon": {
            "key": "soundon",
            "names": [
                "SoundOn"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech"
            ],
            "score": 20,
            "ownedBy": [
                "bytedance"
            ],
            "updatedAt": "2026-10-12T11:51:55.929Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/SoundOn",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/5/5a/Soundon.jpg/250px-Soundon.jpg"
        },
        "baike.com": {
            "key": "baike.com",
            "names": [
                "Baike.com"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "tech"
            ],
            "score": 20,
            "ownedBy": [
                "bytedance"
            ],
            "updatedAt": "2026-10-12T11:51:55.985Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Baike.com",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/4/42/Douyin_Baike_logo.svg/250px-Douyin_Baike_logo.svg.png",
            "siteUrl": "https://en.wikipedia.org/wiki/Wiki"
        },
        "travis-perkins": {
            "key": "travis-perkins",
            "names": [
                "Travis Perkins",
                "Travis Perkins plc",
                "TPK"
            ],
            "comment": "Travis Perkins is a UK-based building materials supplier that has engaged in age discrimination and unfair dismissal [1][2], as well as disability discrimination and harassment [3]. The company has sold timber linked to deforestation and human rights abuses [4], engaged in unsafe loading practices that caused a fatal accident [5], and was involved in a fatal road traffic incident [6].",
            "sources": {
                "1": "https://assets.publishing.service.gov.uk/media/5d0107ebed915d097e54a0fb/Mr_P_Hodgkiss_v_Travis_Perkins_Trading_Company_Limited_2411659_2018_-_Judgment.pdf",
                "2": "https://www.gov.uk/employment-tribunal-decisions/mr-a-wise-v-travis-perkins-trading-company-ltd-6021417-slash-2024",
                "3": "https://assets.publishing.service.gov.uk/media/6596d332c23a10000d8d0ba0/Mr_D._Cooper_v_Travis_Perkins_Trading_Company_Ltd_3300006.2022_-_judgment_on_remedy.pdf",
                "4": "https://www.earthsight.org.uk/news/malaysian-timber-uk",
                "5": "https://www.lewes-eastbourne.gov.uk/article/3087/Court-fines-Travis-Perkins-2million-for-health-and-safety-breaches-after-man-s-death",
                "6": "https://www.dailyecho.co.uk/news/18174676.woman-dies-hit-lorry-new-milton-crash/"
            },
            "sourceNotes": {
                "1": "age discrimination and unfair dismissal of employee",
                "2": "unfair dismissal of employee",
                "3": "disability discrimination and harassment of employee",
                "4": "sold timber linked to deforestation and human rights abuses",
                "5": "unsafe loading practices causing fatal accident",
                "6": "caused fatal road traffic accident"
            },
            "tags": [
                "deforestation",
                "unsafe practices"
            ],
            "score": 17,
            "ownedBy": [],
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/5/55/Travis_Perkins_logo.svg/250px-Travis_Perkins_logo.svg.png",
            "siteUrl": "http://www.travisperkinsplc.co.uk/",
            "updatedAt": "2026-10-13T10:00:57.404Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Travis_Perkins"
        },
        "bss": {
            "key": "bss",
            "names": [
                "BSS"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [],
            "score": 17,
            "ownedBy": [
                "travis-perkins"
            ],
            "updatedAt": "2026-10-13T10:37:20.967Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/BSS_Group",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/4/4e/BSS_Industrial_logo.svg/250px-BSS_Industrial_logo.svg.png",
            "siteUrl": "http://www.bssindustrial.co.uk/"
        },
        "associated-british-foods": {
            "key": "associated-british-foods",
            "names": [
                "Associated British Foods",
                "Associated British Foods plc",
                "ABF",
                "George Weston Holdings plc"
            ],
            "comment": "Associated British Foods is a British company that has been criticized for lack of transparency in its supply chain [1], failing to pay minimum wage [2], discriminating against a transgender employee [3], and violating environmental regulations by failing to report nitrate compounds [4] and polluting a creek with untreated wastewater [5]. The company has also breached occupational health and safety standards [6], resulting in an employee losing a finger in a workplace accident [7], another being injured in a fire due to unsafe conditions [8], and it has diverted floodwater into a village, causing multiple deaths [9][10].",
            "sources": {
                "1": "https://www.theguardian.com/sustainable-business/associated-british-foods-transparent-nestle-coca-cola",
                "2": "https://www.gov.uk/government/news/17m-back-pay-identified-for-a-record-16000-workers-as-260-employers-are-named-and-shamed-for-underpaying-minimum-wage-rates",
                "3": "https://assets.publishing.service.gov.uk/media/5a7aed66ed915d670dd7f91e/Miss_A_de_Souza_E_Souza_v_Primark_Strores_Ltd_-_2206063-2017_-_Final.pdf",
                "4": "https://echo.epa.gov/enforcement-case-report?id=HQ-2001-3070",
                "5": "https://web.archive.org/web/20220328092459/https://www.epa.vic.gov.au/about-epa/news-media-and-updates/media-releases-and-news/court-orders-100000-to-environmental-program",
                "6": "https://www.worksafe.vic.gov.au/prosecution-result-summaries-enforceable-undertakings",
                "7": "https://www.osha.gov/pls/imis/establishment.inspection_detail?id=125709774",
                "8": "https://www.osha.gov/pls/imis/establishment.inspection_detail?id=300877677",
                "9": "https://www.doughtystreet.co.uk/news/margherita-cornaglia-represents-malawian-villagers-legal-action-against-primark-owner",
                "10": "https://www.leighday.co.uk/news/press-releases/2025-news/malawian-villagers-take-legal-action-against-primark-owner-associated-british-foods-after-flooding-destroyed-their-village-and-left-seven-people-dead/"
            },
            "sourceNotes": {
                "1": "lack of transparency in supply chain",
                "2": "failed to pay minimum wage",
                "3": "discrimination against transgender employee",
                "4": "environmental violation failing to report nitrate compounds",
                "5": "polluted a creek with untreated wastewater",
                "6": "violated occupational health and safety regulations",
                "7": "employee lost finger in workplace accident",
                "8": "employee injured in fire in unsafe working conditions",
                "9": "diverted floodwater into village causing multiple deaths",
                "10": "diverted floodwater into village causing multiple deaths"
            },
            "tags": [
                "food",
                "deception",
                "unfair pay",
                "gender discrimination",
                "environmental violations",
                "unsafe working conditions",
                "unsafe practices",
                "poor working conditions",
                "unsustainable practices"
            ],
            "score": 10,
            "ownedBy": [],
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/1/16/Associated_British_Foods_Logo.svg/250px-Associated_British_Foods_Logo.svg.png",
            "siteUrl": "https://abf.co.uk/",
            "updatedAt": "2026-10-13T23:51:01.668Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Associated_British_Foods"
        },
        "ab-mauri": {
            "key": "ab-mauri",
            "names": [
                "AB Mauri"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 10,
            "ownedBy": [
                "associated-british-foods"
            ],
            "updatedAt": "2026-10-14T09:37:03.882Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/AB_Mauri"
        },
        "british-sugar": {
            "key": "british-sugar",
            "names": [
                "British Sugar"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 10,
            "ownedBy": [
                "associated-british-foods"
            ],
            "updatedAt": "2026-10-14T09:37:04.158Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/British_Sugar",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/3/32/BritishSugar.png/250px-BritishSugar.png",
            "siteUrl": "http://britishsugar.co.uk/"
        },
        "dorset-cereals": {
            "key": "dorset-cereals",
            "names": [
                "Dorset Cereals"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 10,
            "ownedBy": [
                "associated-british-foods"
            ],
            "updatedAt": "2026-10-14T09:37:04.274Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Dorset_Cereals",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/1/1c/Dorset_Cereals_logo.jpg",
            "siteUrl": "http://dorsetcereals.co.uk/"
        },
        "illovo-sugar": {
            "key": "illovo-sugar",
            "names": [
                "Illovo Sugar"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 10,
            "ownedBy": [
                "associated-british-foods"
            ],
            "updatedAt": "2026-10-14T09:37:04.635Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Illovo_Sugar",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/2/27/ILLOVO_SUGAR_AFRICA_logo.png/250px-ILLOVO_SUGAR_AFRICA_logo.png",
            "siteUrl": "https://illovosugarsa.co.za/"
        },
        "wander-ag": {
            "key": "wander-ag",
            "names": [
                "Wander AG"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 10,
            "ownedBy": [
                "associated-british-foods"
            ],
            "updatedAt": "2026-10-14T09:37:05.377Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Wander_AG",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/9/92/Wander_AG_Logo.svg/250px-Wander_AG_Logo.svg.png",
            "siteUrl": "http://www.wander.ch/"
        },
        "post-holdings": {
            "key": "post-holdings",
            "names": [
                "Post Holdings",
                "Post Holdings, Inc.",
                "POST"
            ],
            "comment": "Post Holdings is an American company that has been accused of monopolistic price‑fixing [1], underpaying employees [2], and engaging in discriminatory employment practices [3]. The company has also faced environmental violations, including air pollution violations [4] and illegal ammonia releases [5][6], and has been linked to unsafe working conditions that resulted in an employee death [7].",
            "sources": {
                "1": "https://www.law360.com/articles/870885",
                "2": "https://www.law360.com/articles/1068232/bob-evans-strikes-deal-to-end-servers-tip-credit-suit",
                "3": "https://web.archive.org/web/20090813022716/http://eeoc.gov/litigation/settlements/settlement01-05.html",
                "4": "https://archive.epa.gov/epapages/newsroom_archive/newsreleases/74157cc43982ed4f85257be5006495f0.html",
                "5": "https://echo.epa.gov/enforcement-case-report?id=05-2022-7579",
                "6": "https://echo.epa.gov/enforcement-case-report?id=05-2024-7825",
                "7": "https://www.osha.gov/pls/imis/establishment.inspection_detail?id=1266349.015"
            },
            "sourceNotes": {
                "1": "monopolistic price‑fixing",
                "2": "underpaid employees",
                "3": "engaged in discriminatory employment practices",
                "4": "air pollution violations",
                "5": "illiegally released ammonia into the environment",
                "6": "illiegally released ammonia into the environment",
                "7": "employee died in unsafe working conditions"
            },
            "tags": [
                "food",
                "anticompetitive practices",
                "unfair pay",
                "racial discrimination",
                "gender discrimination",
                "environmental violations",
                "unsafe working conditions",
                "unsustainable practices"
            ],
            "score": 15,
            "ownedBy": [],
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/3/32/Post_Holdings_logo.svg/250px-Post_Holdings_logo.svg.png",
            "siteUrl": "https://www.postholdings.com/",
            "updatedAt": "2026-10-13T23:51:01.668Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Post_Holdings"
        },
        "post-consumer-brands": {
            "key": "post-consumer-brands",
            "names": [
                "Post Consumer Brands"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 15,
            "ownedBy": [
                "post-holdings"
            ],
            "updatedAt": "2026-10-15T08:37:23.448Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Post_Consumer_Brands",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/3/30/Postconsumerbrands_logo.png/250px-Postconsumerbrands_logo.png",
            "siteUrl": "https://www.postconsumerbrands.com/"
        },
        "michael-foods": {
            "key": "michael-foods",
            "names": [
                "Michael Foods"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 15,
            "ownedBy": [
                "post-holdings"
            ],
            "updatedAt": "2026-10-15T08:37:23.564Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Michael_Foods",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/3/30/Postconsumerbrands_logo.png/250px-Postconsumerbrands_logo.png",
            "siteUrl": "https://www.postconsumerbrands.com/"
        },
        "bob-evans-farms": {
            "key": "bob-evans-farms",
            "names": [
                "Bob Evans Farms"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 15,
            "ownedBy": [
                "post-holdings"
            ],
            "updatedAt": "2026-10-15T08:37:23.670Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Bob_Evans_Farms",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/7/73/Bob_Evans_logo.png/250px-Bob_Evans_logo.png",
            "siteUrl": "https://www.bobevans.com/"
        },
        "weetabix-limited": {
            "key": "weetabix-limited",
            "names": [
                "Weetabix Limited"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 15,
            "ownedBy": [
                "post-holdings"
            ],
            "updatedAt": "2026-10-15T08:37:23.738Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Weetabix_Limited",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/e/e3/Weetabix_Food_Company_logo.png",
            "siteUrl": "https://weetabixfoodcompany.co.uk/"
        },
        "8th-avenue": {
            "key": "8th-avenue",
            "names": [
                "8th Avenue"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 15,
            "ownedBy": [
                "post-holdings"
            ],
            "updatedAt": "2026-10-15T08:37:23.809Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Attune_Foods"
        },
        "mom-brands": {
            "key": "mom-brands",
            "names": [
                "MOM Brands"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 15,
            "ownedBy": [
                "post-holdings"
            ],
            "updatedAt": "2026-10-15T08:37:23.844Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/MOM_Brands",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/e/e3/MOM_Brands_Logo.png/250px-MOM_Brands_Logo.png",
            "siteUrl": "http://www.postconsumerbrands.com/"
        },
        "9lives": {
            "key": "9lives",
            "names": [
                "9Lives"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 15,
            "ownedBy": [
                "post-holdings"
            ],
            "updatedAt": "2026-10-15T08:37:23.898Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/9Lives",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/0/0e/9lives_brand_logo.png",
            "siteUrl": "https://www.9lives.com/"
        },
        "grape-nuts": {
            "key": "grape-nuts",
            "names": [
                "Grape-Nuts"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 15,
            "ownedBy": [
                "post-holdings"
            ],
            "updatedAt": "2026-10-15T08:37:24.509Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Grape-Nuts",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/f/fc/Grape_nuts_logo.png/250px-Grape_nuts_logo.png",
            "siteUrl": "https://www.grapenuts.com/"
        },
        "gravy-train": {
            "key": "gravy-train",
            "names": [
                "Gravy Train"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 15,
            "ownedBy": [
                "post-holdings"
            ],
            "updatedAt": "2026-10-15T08:37:24.563Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Gravy_Train_(dog_food)",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/3/33/Gravy_train_food_logo.png/250px-Gravy_train_food_logo.png",
            "siteUrl": "https://www.gravytraindog.com/"
        },
        "honey-bunches-of-oats": {
            "key": "honey-bunches-of-oats",
            "names": [
                "Honey Bunches of Oats"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 15,
            "ownedBy": [
                "post-holdings"
            ],
            "updatedAt": "2026-10-15T08:37:24.729Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Honey_Bunches_of_Oats",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/0/08/Honey_bunches_oat_logo.png/250px-Honey_bunches_oat_logo.png",
            "siteUrl": "https://www.honeybunchesofoats.com/"
        },
        "honeycomb": {
            "key": "honeycomb",
            "names": [
                "Honeycomb"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 15,
            "ownedBy": [
                "post-holdings"
            ],
            "updatedAt": "2026-10-15T08:37:24.931Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Honeycomb_(cereal)",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/a/a4/Honeycomb_brand_logo.png/250px-Honeycomb_brand_logo.png",
            "siteUrl": "https://www.postconsumerbrands.com/honeycomb/"
        },
        "kibbles-'n-bits": {
            "key": "kibbles-'n-bits",
            "names": [
                "Kibbles 'n Bits"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 15,
            "ownedBy": [
                "post-holdings"
            ],
            "updatedAt": "2026-10-15T08:37:25.323Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Kibbles_'n_Bits",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/a/ad/Kibbles_bits_logo.png/250px-Kibbles_bits_logo.png",
            "siteUrl": "https://www.kibblesnbits.com/"
        },
        "pebbles": {
            "key": "pebbles",
            "names": [
                "Pebbles"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 15,
            "ownedBy": [
                "post-holdings"
            ],
            "updatedAt": "2026-10-15T08:37:25.936Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Pebbles_(cereal)",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/6/62/Pebbles_cereal_brand_logo.png/250px-Pebbles_cereal_brand_logo.png",
            "siteUrl": "https://www.pebblescereal.com/"
        },
        "peter-pan-peanut-butter": {
            "key": "peter-pan-peanut-butter",
            "names": [
                "Peter Pan peanut butter"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 15,
            "ownedBy": [
                "post-holdings"
            ],
            "updatedAt": "2026-10-15T08:37:26.030Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Peter_Pan_(peanut_butter)",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/3/31/Peter_Pan_%28peanut_butter%29_logo.png/250px-Peter_Pan_%28peanut_butter%29_logo.png",
            "siteUrl": "https://www.peterpanpb.com/"
        },
        "raisin-bran": {
            "key": "raisin-bran",
            "names": [
                "Raisin Bran"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 15,
            "ownedBy": [
                "post-holdings"
            ],
            "updatedAt": "2026-10-15T08:37:26.245Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Raisin_Bran",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/5/5d/Raisin-Bran-Bowl.jpg/250px-Raisin-Bran-Bowl.jpg"
        },
        "shredded-wheat": {
            "key": "shredded-wheat",
            "names": [
                "Shredded Wheat"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 15,
            "ownedBy": [
                "post-holdings"
            ],
            "updatedAt": "2026-10-15T08:37:26.612Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Shredded_wheat",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/8/8b/Shredded_wheat_brand_logo.png/250px-Shredded_wheat_brand_logo.png",
            "siteUrl": "https://www.postconsumerbrands.com/shredded-wheat/"
        },
        "ready-brek": {
            "key": "ready-brek",
            "names": [
                "Ready Brek"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 15,
            "ownedBy": [
                "post-holdings"
            ],
            "updatedAt": "2026-10-15T08:37:26.840Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Ready_Brek",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/7/7a/Ready_Brek_logo.jpg/250px-Ready_Brek_logo.jpg"
        },
        "weetos": {
            "key": "weetos",
            "names": [
                "Weetos"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 15,
            "ownedBy": [
                "post-holdings"
            ],
            "updatedAt": "2026-10-15T08:37:26.942Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Weetos",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/a/a2/Weetos_logo.jpg/250px-Weetos_logo.jpg",
            "siteUrl": "https://www.weetabixfoodcompany.co.uk/our-brands/weetos"
        },
        "airly-foods": {
            "key": "airly-foods",
            "names": [
                "Airly Foods"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 15,
            "ownedBy": [
                "post-holdings"
            ],
            "updatedAt": "2026-10-15T08:37:27.129Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Airly_Foods",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/0/01/Airly_Foods_Logo.png/250px-Airly_Foods_Logo.png",
            "siteUrl": "https://airlyfoods.com/"
        },
        "dakota-growers-pasta-company": {
            "key": "dakota-growers-pasta-company",
            "names": [
                "Dakota Growers Pasta Company"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "food"
            ],
            "score": 15,
            "ownedBy": [
                "post-holdings"
            ],
            "updatedAt": "2026-10-15T08:37:27.603Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Dakota_Growers",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/4/44/Dakota_growers_co_logo.png",
            "siteUrl": "https://www.8avepasta.com/"
        },
        "mty-food-group": {
            "key": "mty-food-group",
            "names": [
                "MTY Food Group",
                "MTY Food Group Inc.",
                "Golden Sky Resources",
                "Golden Sky Ventures International",
                "iNsu Innovations Group",
                "Le Paradis du Pacifique",
                "MTY"
            ],
            "comment": "MTY Food Group is a Canadian restaurant company that has made misleading statements about cage‑free egg usage [1].",
            "sources": {
                "1": "https://sustainablefoodbusiness.com/mty-food-group-false-statements-sustainability-filing/"
            },
            "sourceNotes": {
                "1": "misleading statements about cage‑free egg usage"
            },
            "tags": [
                "restaurants",
                "deception"
            ],
            "score": 47,
            "ownedBy": [],
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/d/d3/MTY_Food_Group_logo_%282016%29.svg/250px-MTY_Food_Group_logo_%282016%29.svg.png",
            "siteUrl": "http://www.mtygroup.com/",
            "updatedAt": "2026-10-16T08:03:49.698Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/MTY_Food_Group"
        },
        "thai-express": {
            "key": "thai-express",
            "names": [
                "Thaï Express"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurants"
            ],
            "score": 47,
            "ownedBy": [
                "mty-food-group"
            ],
            "updatedAt": "2026-10-16T09:00:45.206Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Thaï_Express",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/3/34/Thai_Express_%28Canada%29_logo.svg/250px-Thai_Express_%28Canada%29_logo.svg.png",
            "siteUrl": "http://www.thaiexpress.ca/"
        },
        "country-style": {
            "key": "country-style",
            "names": [
                "Country Style"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurants"
            ],
            "score": 47,
            "ownedBy": [
                "mty-food-group"
            ],
            "updatedAt": "2026-10-16T09:00:45.358Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Country_Style",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/67/Country_Style_Logo.png",
            "siteUrl": "https://countrystyle.com/"
        },
        "groupe-valentine": {
            "key": "groupe-valentine",
            "names": [
                "Groupe Valentine"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurants"
            ],
            "score": 47,
            "ownedBy": [
                "mty-food-group"
            ],
            "updatedAt": "2026-10-16T09:00:45.576Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Groupe_Valentine_Inc.",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/4/4d/Valentine_%28restaurant%29_logo.svg/250px-Valentine_%28restaurant%29_logo.svg.png",
            "siteUrl": "http://valentine.ca/"
        },
        "vanelli's": {
            "key": "vanelli's",
            "names": [
                "Vanelli's"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurants"
            ],
            "score": 47,
            "ownedBy": [
                "mty-food-group"
            ],
            "updatedAt": "2026-10-16T09:00:45.631Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/List_of_Canadian_restaurant_chains"
        },
        "extreme-pita": {
            "key": "extreme-pita",
            "names": [
                "Extreme Pita"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurants"
            ],
            "score": 47,
            "ownedBy": [
                "mty-food-group"
            ],
            "updatedAt": "2026-10-16T09:00:46.582Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Extreme_Pita",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/8/87/Extreme_Pita_logo.svg/250px-Extreme_Pita_logo.svg.png",
            "siteUrl": "http://extremepita.com/"
        },
        "taco-time": {
            "key": "taco-time",
            "names": [
                "Taco Time"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurants"
            ],
            "score": 47,
            "ownedBy": [
                "mty-food-group"
            ],
            "updatedAt": "2026-10-16T09:00:47.149Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Taco_Time",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/a/aa/TacoTime_logo.svg/250px-TacoTime_logo.svg.png",
            "siteUrl": "http://www.tacotime.com/"
        },
        "yogen-fruz": {
            "key": "yogen-fruz",
            "names": [
                "Yogen Früz"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurants"
            ],
            "score": 47,
            "ownedBy": [
                "mty-food-group"
            ],
            "updatedAt": "2026-10-16T09:00:47.458Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Yogen_Früz",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/2/2d/Yogen_Fruz_Logo.svg/330px-Yogen_Fruz_Logo.svg.png",
            "siteUrl": "http://www.yogenfruz.com/"
        },
        "kahala-brands": {
            "key": "kahala-brands",
            "names": [
                "Kahala Brands"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurants"
            ],
            "score": 47,
            "ownedBy": [
                "mty-food-group"
            ],
            "updatedAt": "2026-10-16T09:00:47.648Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Kahala_Brands",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/2/29/Kahala_Brands_logo.svg/250px-Kahala_Brands_logo.svg.png",
            "siteUrl": "http://kahalamgmt.com/"
        },
        "baja-fresh": {
            "key": "baja-fresh",
            "names": [
                "Baja Fresh"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurants"
            ],
            "score": 47,
            "ownedBy": [
                "mty-food-group"
            ],
            "updatedAt": "2026-10-16T09:00:47.718Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Baja_Fresh",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/8/8c/Logo_of_Baja_Fresh_%28Current%29.png/250px-Logo_of_Baja_Fresh_%28Current%29.png",
            "siteUrl": "https://www.bajafresh.com/"
        },
        "cold-stone-creamery": {
            "key": "cold-stone-creamery",
            "names": [
                "Cold Stone Creamery"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurants"
            ],
            "score": 47,
            "ownedBy": [
                "mty-food-group"
            ],
            "updatedAt": "2026-10-16T09:00:47.804Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Cold_Stone_Creamery",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/e/eb/Cold_Stone_Creamery_logo.svg/250px-Cold_Stone_Creamery_logo.svg.png",
            "siteUrl": "http://coldstonecreamery.com/"
        },
        "famous-dave's": {
            "key": "famous-dave's",
            "names": [
                "Famous Dave's"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurants"
            ],
            "score": 47,
            "ownedBy": [
                "mty-food-group"
            ],
            "updatedAt": "2026-10-16T09:00:48.029Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Famous_Dave's",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/d/df/Famous_Dave%27s_logo.png/250px-Famous_Dave%27s_logo.png",
            "siteUrl": "http://famousdaves.com/home"
        },
        "papa-murphy's": {
            "key": "papa-murphy's",
            "names": [
                "Papa Murphy's"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurants"
            ],
            "score": 47,
            "ownedBy": [
                "mty-food-group"
            ],
            "updatedAt": "2026-10-16T09:00:48.335Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Papa_Murphy's",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/6/60/Papa_Murphy%27s_2021.png/250px-Papa_Murphy%27s_2021.png",
            "siteUrl": "http://papamurphys.com/"
        },
        "pinkberry": {
            "key": "pinkberry",
            "names": [
                "Pinkberry"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurants"
            ],
            "score": 47,
            "ownedBy": [
                "mty-food-group"
            ],
            "updatedAt": "2026-10-16T09:00:48.400Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Pinkberry",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/d/dc/Pinkberry_logo.svg/250px-Pinkberry_logo.svg.png",
            "siteUrl": "http://pinkberry.com/"
        },
        "planet-smoothie": {
            "key": "planet-smoothie",
            "names": [
                "Planet Smoothie"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurants"
            ],
            "score": 47,
            "ownedBy": [
                "mty-food-group"
            ],
            "updatedAt": "2026-10-16T09:00:48.602Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Planet_Smoothie",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/6/6c/Planet_Smoothie_logo.svg/250px-Planet_Smoothie_logo.svg.png",
            "siteUrl": "http://planetsmoothie.com/"
        },
        "sweet-frog": {
            "key": "sweet-frog",
            "names": [
                "Sweet Frog"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurants"
            ],
            "score": 47,
            "ownedBy": [
                "mty-food-group"
            ],
            "updatedAt": "2026-10-16T09:00:49.148Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Sweet_Frog",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/9/96/Sweet_Frog_-_Premium_Frozen_Yogurt_logo_%28frogs_right%29.jpg/250px-Sweet_Frog_-_Premium_Frozen_Yogurt_logo_%28frogs_right%29.jpg",
            "siteUrl": "http://www.sweetfrog.com/"
        },
        "manchu-wok": {
            "key": "manchu-wok",
            "names": [
                "Manchu Wok"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurants"
            ],
            "score": 47,
            "ownedBy": [
                "mty-food-group"
            ],
            "updatedAt": "2026-10-16T09:00:50.137Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Manchu_Wok",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/0/0c/Manchu_Wok_logo.svg/250px-Manchu_Wok_logo.svg.png",
            "siteUrl": "https://www.manchuwok.com/"
        },
        "jugo-juice": {
            "key": "jugo-juice",
            "names": [
                "Jugo Juice"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurants"
            ],
            "score": 47,
            "ownedBy": [
                "mty-food-group"
            ],
            "updatedAt": "2026-10-16T09:00:50.210Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Jugo_Juice",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/d/d3/MTY_Food_Group_logo_%282016%29.svg/250px-MTY_Food_Group_logo_%282016%29.svg.png",
            "siteUrl": "http://www.mtygroup.com/"
        },
        "mr.-sub": {
            "key": "mr.-sub",
            "names": [
                "Mr. Sub"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurants"
            ],
            "score": 47,
            "ownedBy": [
                "mty-food-group"
            ],
            "updatedAt": "2026-10-16T09:00:50.912Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Mr._Sub",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/7/76/Mr._Sub_logo.svg/250px-Mr._Sub_logo.svg.png",
            "siteUrl": "http://www.mrsub.ca/"
        },
        "imvescor-restaurant-group": {
            "key": "imvescor-restaurant-group",
            "names": [
                "Imvescor Restaurant Group"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurants"
            ],
            "score": 47,
            "ownedBy": [
                "mty-food-group"
            ],
            "updatedAt": "2026-10-16T09:00:51.450Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Imvescor_Restaurant_Group",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/d/d3/MTY_Food_Group_logo_%282016%29.svg/250px-MTY_Food_Group_logo_%282016%29.svg.png",
            "siteUrl": "http://www.mtygroup.com/"
        },
        "toujours-mikes": {
            "key": "toujours-mikes",
            "names": [
                "Toujours Mikes"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurants"
            ],
            "score": 47,
            "ownedBy": [
                "mty-food-group"
            ],
            "updatedAt": "2026-10-16T09:00:52.050Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Toujours_Mikes",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/6/68/IMV1602005-MikesLogo-Outlines_EN.jpg/250px-IMV1602005-MikesLogo-Outlines_EN.jpg",
            "siteUrl": "http://www.mikes.ca/"
        },
        "pizza-delight": {
            "key": "pizza-delight",
            "names": [
                "Pizza Delight"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurants"
            ],
            "score": 47,
            "ownedBy": [
                "mty-food-group"
            ],
            "updatedAt": "2026-10-16T09:00:52.460Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Pizza_Delight",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/6/67/Pizza_Delight_logo.jpg",
            "siteUrl": "http://www.pizzadelight.com/"
        },
        "scores-rotisserie": {
            "key": "scores-rotisserie",
            "names": [
                "Scores Rotisserie"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurants"
            ],
            "score": 47,
            "ownedBy": [
                "mty-food-group"
            ],
            "updatedAt": "2026-10-16T09:00:52.856Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Scores_Rotisserie",
            "siteUrl": "http://www.scores.ca/"
        },
        "baton-rouge": {
            "key": "baton-rouge",
            "names": [
                "Bâton Rouge"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurants"
            ],
            "score": 47,
            "ownedBy": [
                "mty-food-group"
            ],
            "updatedAt": "2026-10-16T09:00:53.178Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Baton_Rouge_(restaurant)",
            "siteUrl": "http://www.batonrouge.ca/en/"
        },
        "ben-and-florentine": {
            "key": "ben-and-florentine",
            "names": [
                "Ben & Florentine"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurants"
            ],
            "score": 47,
            "ownedBy": [
                "mty-food-group"
            ],
            "updatedAt": "2026-10-16T09:00:53.566Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Ben_&amp;_Florentine",
            "logoUrl": "https://benetflorentine.com/wp-content/uploads/2020/02/cropped-benflorentine_logo.png"
        },
        "van-houtte": {
            "key": "van-houtte",
            "names": [
                "Van Houtte"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurants"
            ],
            "score": 47,
            "ownedBy": [
                "mty-food-group"
            ],
            "updatedAt": "2026-10-16T09:00:53.854Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Van_Houtte",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/e/e5/Van_Houtte_Logo.svg/250px-Van_Houtte_Logo.svg.png",
            "siteUrl": "https://www.vanhoutte.com/"
        },
        "la-salsa": {
            "key": "la-salsa",
            "names": [
                "La Salsa"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurants"
            ],
            "score": 47,
            "ownedBy": [
                "mty-food-group"
            ],
            "updatedAt": "2026-10-16T09:00:54.410Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/La_Salsa",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/d/d5/La_Salsa_logo.svg/250px-La_Salsa_logo.svg.png",
            "siteUrl": "https://www.lasalsa.com/"
        },
        "timothy's-world-coffee": {
            "key": "timothy's-world-coffee",
            "names": [
                "Timothy's World Coffee"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurants"
            ],
            "score": 47,
            "ownedBy": [
                "mty-food-group"
            ],
            "updatedAt": "2026-10-16T09:00:54.644Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Timothy's_World_Coffee",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/en/3/33/Timothy%27s_World_Coffee_logo.png",
            "siteUrl": "http://timothyscafes.com/"
        },
        "mmmuffins": {
            "key": "mmmuffins",
            "names": [
                "Mmmuffins"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurants"
            ],
            "score": 47,
            "ownedBy": [
                "mty-food-group"
            ],
            "updatedAt": "2026-10-16T09:00:55.059Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Mmmuffins",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/b/bc/Mmmuffins.jpg/250px-Mmmuffins.jpg"
        },
        "bakers-square": {
            "key": "bakers-square",
            "names": [
                "Bakers Square"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurants"
            ],
            "score": 47,
            "ownedBy": [
                "mty-food-group"
            ],
            "updatedAt": "2026-10-16T09:00:55.433Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Bakers_Square",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/6/61/Bakers_Square.svg/250px-Bakers_Square.svg.png",
            "siteUrl": "http://www.bakerssquare.com/"
        },
        "village-inn": {
            "key": "village-inn",
            "names": [
                "Village Inn"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurants"
            ],
            "score": 47,
            "ownedBy": [
                "mty-food-group"
            ],
            "updatedAt": "2026-10-16T09:00:55.824Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Village_Inn",
            "logoUrl": "https://upload.wikimedia.org/wikipedia/commons/d/d3/Village_Inn_logo.png",
            "siteUrl": "https://www.villageinn.com/"
        },
        "tahoe-joe's": {
            "key": "tahoe-joe's",
            "names": [
                "Tahoe Joe's"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "restaurants"
            ],
            "score": 47,
            "ownedBy": [
                "mty-food-group"
            ],
            "updatedAt": "2026-10-16T09:00:56.255Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Tahoe_Joe's",
            "logoUrl": "https://www.tahoejoes.com/wp-content/uploads/2020/06/TahoeJoes_Logo_web@2x.png",
            "siteUrl": "https://tahoejoes.com/"
        },
        "the-range": {
            "key": "the-range",
            "names": [
                "The Range",
                "CDS (Superstores International) Limited",
                "Chris Dawson Superstores"
            ],
            "comment": "The Range is a UK-based retailer that failed to properly consult employees before redundancies [1] and engaged in unauthorized wage deductions [2][3].",
            "sources": {
                "1": "https://vinciworks.com/blog/wilkos-costly-collapse-the-employment-rights-bill-and-collective-consultation/",
                "2": "https://assets.publishing.service.gov.uk/media/62a1f2dfd3bf7f037097be72/Mrs_T_Norton_V_The_Range_-_1404276.2021_-_Judgment.pdf",
                "3": "https://assets.publishing.service.gov.uk/media/623b26538fa8f540f127aad2/Mr_D_Bessant___Others_-v-_Wilko_Retail_Ltd_1601269.2020___Others_-_Judgment.pdf"
            },
            "sourceNotes": {
                "1": "failed to properly consult employees before redundancies",
                "2": "unauthorized wage deductions",
                "3": "unauthorized wage deductions"
            },
            "tags": [
                "retail",
                "home",
                "unfair pay"
            ],
            "score": 44,
            "ownedBy": [],
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/6/60/The_Range_logo_22.png/250px-The_Range_logo_22.png",
            "siteUrl": "https://www.therange.co.uk/",
            "updatedAt": "2026-10-17T07:51:39.867Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/The_Range_(retailer)"
        },
        "homebase": {
            "key": "homebase",
            "names": [
                "Homebase"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "home"
            ],
            "score": 44,
            "ownedBy": [
                "the-range"
            ],
            "updatedAt": "2026-10-17T08:16:23.036Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Homebase_(brand)",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/6/60/The_Range_logo_22.png/250px-The_Range_logo_22.png",
            "siteUrl": "https://www.therange.co.uk/"
        },
        "bathstore": {
            "key": "bathstore",
            "names": [
                "Bathstore"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "home"
            ],
            "score": 44,
            "ownedBy": [
                "the-range"
            ],
            "updatedAt": "2026-10-17T08:16:23.426Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Bathstore",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/5/56/Bathstore-Logo.png/250px-Bathstore-Logo.png",
            "siteUrl": "http://www.bathstore.com/"
        },
        "texas-homecare": {
            "key": "texas-homecare",
            "names": [
                "Texas Homecare"
            ],
            "comment": "",
            "sources": {},
            "sourceNotes": {},
            "tags": [
                "retail",
                "home"
            ],
            "score": 44,
            "ownedBy": [
                "the-range"
            ],
            "updatedAt": "2026-10-17T08:16:23.594Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Texas_Homecare",
            "logoUrl": "//thumb.wikimedia.org/wikipedia/en/thumb/0/08/Texas_Homecare_DIY_Logo.png/250px-Texas_Homecare_DIY_Logo.png"
        },
        "eli-lilly": {
            "key": "eli-lilly",
            "names": [
                "Eli Lilly",
                "Eli Lilly and Company",
                "Lilly",
                "LLY"
            ],
            "comment": "Eli Lilly is a U.S. pharmaceutical company that has inflated insulin prices through collusion [1][2][3], blocked whistleblowers and falsified manufacturing records [4], manipulated documents to cover up quality control issues [5], failed to disclose state lobbying spending [6], committed bribery to secure contracts in foreign markets [7], offered illegal kickbacks to doctors to boost prescriptions [8][9][10], and illegally promoted drugs for unapproved uses [11][12][13][14][15]. The company has also engaged in sex discrimination and harassment of female employees [16].",
            "sources": {
                "1": "https://www.drugwatch.com/manufacturers/eli-lilly/",
                "2": "https://web.archive.org/web/20190131230558/https://www.reuters.com/article/us-usa-healthcare-insulin/u-s-lawmakers-request-info-from-insulin-makers-on-rising-prices-idUSKCN1PO2LQ",
                "3": "https://www.wfyi.org/health/2026-01-05/indiana-attorney-general-sues-eli-lilly-insulin-prices-rokita",
                "4": "https://www.foxbusiness.com/healthcare/insider-alleges-eli-lilly-blocked-her-efforts-to-sound-alarms-about-u-s-drug-factory",
                "5": "https://www.reuters.com/business/healthcare-pharmaceuticals/exclusive-lilly-hit-by-staff-accusations-fda-scrutiny-covid-drug-factories-2021-05-05/",
                "6": "https://www.citizen.org/news/despite-company-claims-eli-lilly-fails-to-disclose-its-state-lobbying-spending-for-half-the-country/",
                "7": "https://www.anti-corruption.com/2572416/pharma-giant-eli-lilly-agrees-to-and36294-million-consent-judgment-to-settle-sec-charges-of-fcpa-violations-arising-out-of-its-operations-in-russia-china-brazil-and-poland.thtml",
                "8": "https://www.fiercepharma.com/pharma/eli-lilly-pledges-vigorous-defense-texas-ag-and-return-relator-sue-over-alleged-kickback",
                "9": "https://www.mckoolsmith.com/newsroom-pressreleases-383",
                "10": "https://texasscorecard.com/state/texas-ag-sues-big-pharma-company-eli-lilly-for-bribery/",
                "11": "https://www.justice.gov/archive/opa/pr/2009/January/09-civ-038.html",
                "12": "https://www.bmj.com/content/338/bmj.b217",
                "13": "https://www.justice.gov/archive/opa/pr/2005/December/05_civ_685.html",
                "14": "https://pmc.ncbi.nlm.nih.gov/articles/PMC1781986/",
                "15": "https://www.sec.gov/Archives/edgar/data/59478/000129993305004762/htm_7115.htm",
                "16": "https://www.fiercepharma.com/pharma/biopharma-lobbying-powerhouse-sues-lilly-over-sex-discrimination-hostile-workplace"
            },
            "sourceNotes": {
                "1": "inflated insulin prices through collusion",
                "2": "inflated insulin prices through collusion",
                "3": "inflated insulin prices through collusion",
                "4": "blocked whistleblower and falsified manufacturing records",
                "5": "manipulated documents to cover up quality control issues",
                "6": "failed to disclose state lobbying spending",
                "7": "committed bribery to secure contracts in foreign markets",
                "8": "offered illegal kickbacks to doctors to boost drug prescriptions",
                "9": "offered illegal kickbacks to doctors to boost drug prescriptions",
                "10": "offered illegal kickbacks to doctors to boost drug prescriptions",
                "11": "illegally promoted drug for unapproved uses",
                "12": "illegally promoted drug for unapproved uses",
                "13": "illegally promoted drug for unapproved uses",
                "14": "illegally promoted drug for unapproved uses",
                "15": "illegally promoted drug for unapproved uses",
                "16": "sex discrimination and harassment of female employees"
            },
            "tags": [
                "healthcare",
                "anticompetitive practices",
                "deception",
                "corruption",
                "gender discrimination",
                "sexual harassment"
            ],
            "score": 18,
            "ownedBy": [],
            "logoUrl": "//thumb.wikimedia.org/wikipedia/commons/thumb/2/2b/Eli_Lilly_and_Company.svg/250px-Eli_Lilly_and_Company.svg.png",
            "siteUrl": "https://www.lilly.com/",
            "updatedAt": "2026-10-18T20:45:47.814Z",
            "wikipediaUrl": "https://en.wikipedia.org/wiki/Eli_Lilly_and_Company"
        }
    }
}